{
  "level": "mt02d",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02d",
    "objects": "AREAS.E3:mt02d.e3",
    "mesh": "TREES.E3:mt02d.e3"
  },
  "spawn_point": {
    "position": [
      -1550.5207989245334,
      -3827.1718629237944,
      959.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1550.5207989245334,
      -3727.1718629237944,
      959.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -1707.9254150390625,
      -4003.042236328125,
      935.0
    ],
    "bbox_max": [
      -1423.1636962890625,
      -3605.0,
      1435.0999755859375
    ],
    "vertex_count": 4852,
    "vertices": [
      [
        -1544.0,
        -3624.0,
        956.0
      ],
      [
        -1518.5,
        -3628.5,
        956.0
      ],
      [
        -1569.5,
        -3628.5,
        956.0
      ],
      [
        -1544.0,
        -3624.0,
        956.0
      ],
      [
        -1544.0,
        -3660.0,
        956.0
      ],
      [
        -1567.227294921875,
        -3655.901123046875,
        956.0
      ],
      [
        -1569.5,
        -3655.5,
        956.0
      ],
      [
        -1567.227294921875,
        -3655.901123046875,
        956.0
      ],
      [
        -1522.3182373046875,
        -3656.173828125,
        956.0
      ],
      [
        -1544.0,
        -3660.0,
        956.0
      ],
      [
        -1518.5,
        -3655.5,
        956.0
      ],
      [
        -1522.3182373046875,
        -3656.173828125,
        956.0
      ],
      [
        -1544.4615478515625,
        -3628.58544921875,
        953.5
      ],
      [
        -1544.4610595703125,
        -3655.41455078125,
        953.5
      ],
      [
        -1570.6939697265625,
        -3651.942626953125,
        953.92431640625
      ],
      [
        -1571.400634765625,
        -3652.78662109375,
        954.235595703125
      ],
      [
        -1571.5010986328125,
        -3652.906494140625,
        954.2798461914062
      ],
      [
        -1571.400634765625,
        -3652.78662109375,
        954.235595703125
      ],
      [
        -1570.814208984375,
        -3651.26171875,
        953.7122192382812
      ],
      [
        -1570.6939697265625,
        -3651.942626953125,
        953.92431640625
      ],
      [
        -1573.2015380859375,
        -3650.840576171875,
        953.7122192382812
      ],
      [
        -1573.5460205078125,
        -3651.064453125,
        953.8038330078125
      ],
      [
        -1518.5,
        -3655.5,
        956.0
      ],
      [
        -1510.0,
        -3642.0,
        956.0
      ],
      [
        -1518.5,
        -3628.5,
        956.0
      ],
      [
        -1510.0,
        -3642.0,
        956.0
      ],
      [
        -1570.009033203125,
        -3629.308349609375,
        956.0
      ],
      [
        -1569.8363037109375,
        -3629.0341796875,
        956.0
      ],
      [
        -1578.0,
        -3642.0,
        956.0
      ],
      [
        -1570.009033203125,
        -3629.308349609375,
        956.0
      ],
      [
        -1569.5,
        -3628.5,
        956.0
      ],
      [
        -1569.8363037109375,
        -3629.0341796875,
        956.0
      ],
      [
        -1569.8758544921875,
        -3654.903076171875,
        956.0
      ],
      [
        -1570.0556640625,
        -3654.617431640625,
        956.0
      ],
      [
        -1570.0556640625,
        -3654.617431640625,
        956.0
      ],
      [
        -1578.0,
        -3642.0,
        956.0
      ],
      [
        -1569.5,
        -3655.5,
        956.0
      ],
      [
        -1569.8758544921875,
        -3654.903076171875,
        956.0
      ],
      [
        -1572.6700439453125,
        -3650.465087890625,
        953.7122192382812
      ],
      [
        -1572.8797607421875,
        -3650.1318359375,
        956.0
      ],
      [
        -1574.0137939453125,
        -3650.932861328125,
        956.0
      ],
      [
        -1571.290771484375,
        -3652.655517578125,
        954.1871948242188
      ],
      [
        -1571.221923828125,
        -3652.764892578125,
        954.9178466796875
      ],
      [
        -1571.39013671875,
        -3653.21923828125,
        956.0
      ],
      [
        -1571.1201171875,
        -3652.9267578125,
        956.0
      ],
      [
        -1571.22216796875,
        -3652.764892578125,
        954.9171752929688
      ],
      [
        -1560.10693359375,
        -3635.850341796875,
        956.0
      ],
      [
        -1560.68017578125,
        -3634.857421875,
        956.0
      ],
      [
        -1560.10693359375,
        -3633.86474609375,
        956.0
      ],
      [
        -1558.9603271484375,
        -3633.86474609375,
        956.0
      ],
      [
        -1560.68017578125,
        -3634.857421875,
        956.0
      ],
      [
        -1560.10693359375,
        -3633.86474609375,
        956.0
      ],
      [
        -1558.9603271484375,
        -3633.86474609375,
        956.0
      ],
      [
        -1558.386962890625,
        -3634.857421875,
        956.0
      ],
      [
        -1558.386962890625,
        -3634.857421875,
        956.0
      ],
      [
        -1558.9603271484375,
        -3635.850341796875,
        956.0
      ],
      [
        -1558.9603271484375,
        -3635.850341796875,
        956.0
      ],
      [
        -1560.10693359375,
        -3635.850341796875,
        956.0
      ],
      [
        -1572.337890625,
        -3649.98291015625,
        954.8878173828125
      ],
      [
        -1571.0804443359375,
        -3650.399658203125,
        954.712158203125
      ],
      [
        -1570.7454833984375,
        -3650.510498046875,
        954.6654052734375
      ],
      [
        -1571.0804443359375,
        -3650.399658203125,
        954.712158203125
      ],
      [
        -1570.5400390625,
        -3651.994873046875,
        954.7940063476562
      ],
      [
        -1571.201416015625,
        -3652.762451171875,
        954.9960327148438
      ],
      [
        -1571.2015380859375,
        -3652.762451171875,
        954.99609375
      ],
      [
        -1571.21435546875,
        -3652.77734375,
        955.0
      ],
      [
        -1570.5400390625,
        -3651.994873046875,
        954.7940673828125
      ],
      [
        -1570.7454833984375,
        -3650.510498046875,
        954.6654052734375
      ],
      [
        -1572.337890625,
        -3649.98291015625,
        954.8878173828125
      ],
      [
        -1572.7880859375,
        -3650.277587890625,
        954.9999389648438
      ],
      [
        -1570.32666015625,
        -3652.067138671875,
        956.0
      ],
      [
        -1570.539306640625,
        -3650.347900390625,
        956.0
      ],
      [
        -1572.3829345703125,
        -3649.78076171875,
        956.0
      ],
      [
        -1571.322021484375,
        -3650.107177734375,
        956.0
      ],
      [
        -1570.539306640625,
        -3650.347900390625,
        956.0
      ],
      [
        -1571.322021484375,
        -3650.107177734375,
        956.0
      ],
      [
        -1570.32666015625,
        -3652.067138671875,
        956.0
      ],
      [
        -1570.9385986328125,
        -3652.730224609375,
        956.0
      ],
      [
        -1570.9385986328125,
        -3652.730224609375,
        956.0
      ],
      [
        -1572.3829345703125,
        -3649.78076171875,
        956.0
      ],
      [
        -1624.414306640625,
        -3605.0,
        1015.0
      ],
      [
        -1622.0,
        -3607.4140625,
        1015.0
      ],
      [
        -1520.8572998046875,
        -3628.083984375,
        1000.1109619140625
      ],
      [
        -1527.4869384765625,
        -3626.9140625,
        999.7144775390625
      ],
      [
        -1527.4869384765625,
        -3626.9140625,
        1009.7603149414062
      ],
      [
        -1520.8572998046875,
        -3628.083984375,
        1009.7175903320312
      ],
      [
        -1518.1544189453125,
        -3628.56103515625,
        1007.2808227539062
      ],
      [
        -1520.8572998046875,
        -3628.083984375,
        1000.1109619140625
      ],
      [
        -1527.4869384765625,
        -3626.9140625,
        999.7144775390625
      ],
      [
        -1530.7159423828125,
        -3626.34423828125,
        1007.5694580078125
      ],
      [
        -1520.8572998046875,
        -3628.083984375,
        1009.7175903320312
      ],
      [
        -1518.1544189453125,
        -3628.56103515625,
        1008.383056640625
      ],
      [
        -1517.817626953125,
        -3628.62060546875,
        1008.174560546875
      ],
      [
        -1518.1544189453125,
        -3628.56103515625,
        1008.383056640625
      ],
      [
        -1530.7159423828125,
        -3626.34423828125,
        1008.2686157226562
      ],
      [
        -1527.4869384765625,
        -3626.9140625,
        1009.7603149414062
      ],
      [
        -1530.7159423828125,
        -3626.34423828125,
        1008.2686157226562
      ],
      [
        -1530.948486328125,
        -3626.30322265625,
        1008.1349487304688
      ],
      [
        -1531.00634765625,
        -3626.29296875,
        1008.1016845703125
      ],
      [
        -1530.7159423828125,
        -3626.34423828125,
        1007.5694580078125
      ],
      [
        -1531.00634765625,
        -3626.29296875,
        1008.1016845703125
      ],
      [
        -1517.7314453125,
        -3628.6357421875,
        1008.1211547851562
      ],
      [
        -1518.1544189453125,
        -3628.56103515625,
        1007.2808227539062
      ],
      [
        -1517.7314453125,
        -3628.6357421875,
        1008.1211547851562
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        983.35693359375
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        983.1091918945312
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        989.3487548828125
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        989.3025512695312
      ],
      [
        -1536.4239501953125,
        -3625.337158203125,
        986.3760375976562
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.208740234375
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.208740234375
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        983.35693359375
      ],
      [
        -1536.4239501953125,
        -3625.337158203125,
        986.3760375976562
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.5383911132812
      ],
      [
        -1539.7125244140625,
        -3624.756591796875,
        989.3025512695312
      ],
      [
        -1536.6015625,
        -3625.3056640625,
        986.5383911132812
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.2349243164062
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        989.3487548828125
      ],
      [
        -1550.6424560546875,
        -3622.827880859375,
        986.1759033203125
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.2349243164062
      ],
      [
        -1550.6424560546875,
        -3622.827880859375,
        986.1759033203125
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.1188354492188
      ],
      [
        -1546.873779296875,
        -3623.492919921875,
        983.1091918945312
      ],
      [
        -1550.57421875,
        -3622.83984375,
        986.1188354492188
      ],
      [
        -1628.585693359375,
        -3605.0,
        1015.0
      ],
      [
        -1624.414306640625,
        -3605.0,
        1015.0
      ],
      [
        -1631.0,
        -3607.4140625,
        1015.0
      ],
      [
        -1628.585693359375,
        -3605.0,
        1015.0
      ],
      [
        -1622.0,
        -3610.2353515625,
        973.7354736328125
      ],
      [
        -1622.0,
        -3610.2353515625,
        978.5
      ],
      [
        -1622.0,
        -3610.2353515625,
        972.8877563476562
      ],
      [
        -1622.0,
        -3610.2353515625,
        973.7354736328125
      ],
      [
        -1622.0,
        -3607.4140625,
        1015.0
      ],
      [
        -1622.0,
        -3610.2353515625,
        1015.0
      ],
      [
        -1622.0,
        -3610.2353515625,
        978.5
      ],
      [
        -1631.0,
        -3608.647216796875,
        975.52294921875
      ],
      [
        -1631.0,
        -3608.647216796875,
        978.5
      ],
      [
        -1631.0,
        -3608.647216796875,
        1015.0
      ],
      [
        -1631.0,
        -3607.4140625,
        1015.0
      ],
      [
        -1631.0,
        -3608.647216796875,
        978.5
      ],
      [
        -1629.880859375,
        -3608.8447265625,
        972.3447265625
      ],
      [
        -1631.0,
        -3608.647216796875,
        975.52294921875
      ],
      [
        -1624.414306640625,
        -3609.809326171875,
        970.6500244140625
      ],
      [
        -1628.585693359375,
        -3609.072998046875,
        970.9550170898438
      ],
      [
        -1622.0,
        -3610.2353515625,
        972.8877563476562
      ],
      [
        -1624.414306640625,
        -3609.809326171875,
        970.6500244140625
      ],
      [
        -1628.585693359375,
        -3609.072998046875,
        970.9550170898438
      ],
      [
        -1629.880859375,
        -3608.8447265625,
        972.3447265625
      ],
      [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      [
        -1622.0,
        -3610.585693359375,
        1015.0
      ],
      [
        -1565.908203125,
        -3627.8662109375,
        1001.0
      ],
      [
        -1560.5831298828125,
        -3626.926513671875,
        985.0
      ],
      [
        -1554.4989013671875,
        -3625.852783203125,
        1001.0
      ],
      [
        -1556.2061767578125,
        -3626.154296875,
        989.2205810546875
      ],
      [
        -1565.908203125,
        -3627.8662109375,
        1001.0
      ],
      [
        -1554.4989013671875,
        -3625.852783203125,
        1001.0
      ],
      [
        -1556.2061767578125,
        -3626.154296875,
        989.2205810546875
      ],
      [
        -1558.06591796875,
        -3626.482177734375,
        985.0
      ],
      [
        -1560.5831298828125,
        -3626.926513671875,
        985.0
      ],
      [
        -1558.06591796875,
        -3626.482177734375,
        985.0
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.5060424804688
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        989.3125
      ],
      [
        -1550.0721435546875,
        -3625.07177734375,
        986.3548583984375
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.5060424804688
      ],
      [
        -1550.0721435546875,
        -3625.07177734375,
        986.3548583984375
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.1990966796875
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        983.303955078125
      ],
      [
        -1549.9072265625,
        -3625.042724609375,
        986.1990966796875
      ],
      [
        -1544.0001220703125,
        -3624.0,
        983.2086181640625
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        983.303955078125
      ],
      [
        -1546.756103515625,
        -3624.486328125,
        989.3125
      ],
      [
        -1544.0001220703125,
        -3624.0,
        989.3302001953125
      ],
      [
        -1617.66650390625,
        -3637.0,
        974.0858154296875
      ],
      [
        -1617.66650390625,
        -3637.0,
        970.9141845703125
      ],
      [
        -1622.0,
        -3637.0,
        974.9142456054688
      ],
      [
        -1622.0,
        -3637.0,
        974.9142456054688
      ],
      [
        -1620.0,
        -3637.0,
        972.9144287109375
      ],
      [
        -1621.17138671875,
        -3637.0,
        970.4290161132812
      ],
      [
        -1622.0,
        -3637.0,
        970.0857543945312
      ],
      [
        -1622.0,
        -3637.0,
        970.0857543945312
      ],
      [
        -1622.0,
        -3637.764892578125,
        975.678955078125
      ],
      [
        -1620.0,
        -3637.411865234375,
        974.4976196289062
      ],
      [
        -1617.66650390625,
        -3637.0,
        974.0858154296875
      ],
      [
        -1620.0,
        -3637.411865234375,
        974.4976196289062
      ],
      [
        -1620.0,
        -3637.411865234375,
        970.5023803710938
      ],
      [
        -1622.0,
        -3637.764892578125,
        969.321044921875
      ],
      [
        -1617.66650390625,
        -3637.0,
        970.9141845703125
      ],
      [
        -1620.0,
        -3637.411865234375,
        970.5023803710938
      ],
      [
        -1624.414306640625,
        -3613.0,
        1015.0
      ],
      [
        -1628.585693359375,
        -3613.0,
        1015.0
      ],
      [
        -1623.1826171875,
        -3637.973388671875,
        968.5
      ],
      [
        -1627.0699462890625,
        -3638.659423828125,
        968.5
      ],
      [
        -1622.9287109375,
        -3637.9287109375,
        968.7724609375
      ],
      [
        -1623.1826171875,
        -3637.973388671875,
        968.5
      ],
      [
        -1622.9287109375,
        -3637.9287109375,
        968.7724609375
      ],
      [
        -1627.0699462890625,
        -3638.659423828125,
        976.5
      ],
      [
        -1623.1826171875,
        -3637.973388671875,
        976.5
      ],
      [
        -1629.4140625,
        -3613.0,
        976.5001220703125
      ],
      [
        -1629.4140625,
        -3613.0,
        976.5001220703125
      ],
      [
        -1627.4141845703125,
        -3613.0,
        978.5
      ],
      [
        -1623.9290771484375,
        -3613.0,
        977.3285522460938
      ],
      [
        -1623.5859375,
        -3613.0,
        976.5001220703125
      ],
      [
        -1623.5859375,
        -3613.0,
        976.5001220703125
      ],
      [
        -1623.1826171875,
        -3637.973388671875,
        976.5
      ],
      [
        -1622.9287109375,
        -3637.9287109375,
        976.2275390625
      ],
      [
        -1622.0,
        -3613.0,
        974.9142456054688
      ],
      [
        -1622.9287109375,
        -3637.9287109375,
        976.2275390625
      ],
      [
        -1631.0,
        -3613.0,
        974.9142456054688
      ],
      [
        -1629.3197021484375,
        -3639.056640625,
        970.9141845703125
      ],
      [
        -1629.3197021484375,
        -3639.056640625,
        974.0858154296875
      ],
      [
        -1627.0699462890625,
        -3638.659423828125,
        968.5
      ],
      [
        -1629.3197021484375,
        -3639.056640625,
        970.9141845703125
      ],
      [
        -1629.3197021484375,
        -3639.056640625,
        974.0858154296875
      ],
      [
        -1627.0699462890625,
        -3638.659423828125,
        976.5
      ],
      [
        -1624.414306640625,
        -3613.0,
        969.3284301757812
      ],
      [
        -1628.585693359375,
        -3613.0,
        969.3284301757812
      ],
      [
        -1628.585693359375,
        -3613.0,
        969.3284301757812
      ],
      [
        -1631.0,
        -3613.0,
        971.7426147460938
      ],
      [
        -1622.0,
        -3613.0,
        971.7426147460938
      ],
      [
        -1624.414306640625,
        -3613.0,
        969.3284301757812
      ],
      [
        -1622.0,
        -3610.585693359375,
        1015.0
      ],
      [
        -1624.414306640625,
        -3613.0,
        1015.0
      ],
      [
        -1622.0,
        -3610.585693359375,
        972.7426147460938
      ],
      [
        -1628.585693359375,
        -3613.0,
        1015.0
      ],
      [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      [
        -1631.0,
        -3610.58544921875,
        972.7427368164062
      ],
      [
        -1517.906494140625,
        -3629.442626953125,
        1008.1278686523438
      ],
      [
        -1518.251220703125,
        -3628.895751953125,
        1007.2372436523438
      ],
      [
        -1517.906494140625,
        -3629.442626953125,
        1008.1278686523438
      ],
      [
        -1518.251220703125,
        -3628.895751953125,
        1008.4003295898438
      ],
      [
        -1518.5003662109375,
        -3628.5,
        1008.5538940429688
      ],
      [
        -1518.251220703125,
        -3628.895751953125,
        1008.4003295898438
      ],
      [
        -1518.251220703125,
        -3628.895751953125,
        1007.2372436523438
      ],
      [
        -1518.5003662109375,
        -3628.5,
        1006.363037109375
      ],
      [
        -1518.6370849609375,
        -3655.718017578125,
        1008.1559448242188
      ],
      [
        -1516.7227783203125,
        -3665.800048828125,
        1008.0824584960938
      ],
      [
        -1516.83056640625,
        -3665.800048828125,
        1008.1469116210938
      ],
      [
        -1519.1697998046875,
        -3656.56396484375,
        1008.5642700195312
      ],
      [
        -1521.0078125,
        -3659.483154296875,
        1000.5958251953125
      ],
      [
        -1520.426513671875,
        -3665.800048828125,
        998.7225952148438
      ],
      [
        -1516.83056640625,
        -3665.800048828125,
        1007.8763427734375
      ],
      [
        -1519.1697998046875,
        -3656.56396484375,
        1006.823974609375
      ],
      [
        -1519.1697998046875,
        -3656.56396484375,
        1008.5642700195312
      ],
      [
        -1516.83056640625,
        -3665.800048828125,
        1008.1469116210938
      ],
      [
        -1520.426513671875,
        -3665.800048828125,
        1009.8671875
      ],
      [
        -1521.0078125,
        -3659.483154296875,
        1009.6653442382812
      ],
      [
        -1524.985107421875,
        -3665.800048828125,
        998.7225952148438
      ],
      [
        -1520.426513671875,
        -3665.800048828125,
        998.7225952148438
      ],
      [
        -1521.0078125,
        -3659.483154296875,
        1000.5958251953125
      ],
      [
        -1521.0078125,
        -3659.483154296875,
        1009.6653442382812
      ],
      [
        -1520.426513671875,
        -3665.800048828125,
        1009.8671875
      ],
      [
        -1524.985107421875,
        -3665.800048828125,
        1009.8671875
      ],
      [
        -1516.7227783203125,
        -3665.800048828125,
        1008.0824584960938
      ],
      [
        -1518.6370849609375,
        -3655.718017578125,
        1008.1559448242188
      ],
      [
        -1519.1697998046875,
        -3656.56396484375,
        1006.823974609375
      ],
      [
        -1516.83056640625,
        -3665.800048828125,
        1007.8763427734375
      ],
      [
        -1574.8519287109375,
        -3637.0,
        974.0858154296875
      ],
      [
        -1574.8519287109375,
        -3637.0,
        970.9141845703125
      ],
      [
        -1574.2222900390625,
        -3636.0,
        974.5
      ],
      [
        -1574.2222900390625,
        -3636.0,
        970.5
      ],
      [
        -1574.8519287109375,
        -3637.0,
        969.5
      ],
      [
        -1574.2222900390625,
        -3636.0,
        970.5
      ],
      [
        -1591.0,
        -3637.0,
        969.5
      ],
      [
        -1591.0,
        -3637.0,
        975.5
      ],
      [
        -1574.2222900390625,
        -3636.0,
        974.5
      ],
      [
        -1574.8519287109375,
        -3637.0,
        975.5
      ],
      [
        -1576.3719482421875,
        -3639.414306640625,
        968.5
      ],
      [
        -1578.9984130859375,
        -3643.585693359375,
        968.5
      ],
      [
        -1576.1112060546875,
        -3639.0,
        967.5
      ],
      [
        -1575.4815673828125,
        -3638.0,
        968.5
      ],
      [
        -1591.0,
        -3638.0,
        968.5
      ],
      [
        -1576.1112060546875,
        -3639.0,
        967.5
      ],
      [
        -1579.2593994140625,
        -3644.0,
        967.5
      ],
      [
        -1579.2593994140625,
        -3644.0,
        967.5
      ],
      [
        -1591.0,
        -3645.0,
        968.5
      ],
      [
        -1579.8890380859375,
        -3645.0,
        968.5
      ],
      [
        -1574.8519287109375,
        -3637.0,
        970.9141845703125
      ],
      [
        -1576.3719482421875,
        -3639.414306640625,
        968.5
      ],
      [
        -1623.171630859375,
        -3638.0,
        968.5
      ],
      [
        -1623.1529541015625,
        -3637.96826171875,
        968.5317993164062
      ],
      [
        -1626.75732421875,
        -3639.414306640625,
        968.5
      ],
      [
        -1627.6739501953125,
        -3638.76611328125,
        969.148193359375
      ],
      [
        -1578.9984130859375,
        -3643.585693359375,
        976.5
      ],
      [
        -1576.3719482421875,
        -3639.414306640625,
        976.5
      ],
      [
        -1576.1112060546875,
        -3639.0,
        977.5
      ],
      [
        -1591.0,
        -3638.0,
        976.5
      ],
      [
        -1575.4815673828125,
        -3638.0,
        976.5
      ],
      [
        -1579.2593994140625,
        -3644.0,
        977.5
      ],
      [
        -1576.1112060546875,
        -3639.0,
        977.5
      ],
      [
        -1579.2593994140625,
        -3644.0,
        977.5
      ],
      [
        -1579.8890380859375,
        -3645.0,
        976.5
      ],
      [
        -1591.0,
        -3645.0,
        976.5
      ],
      [
        -1576.3719482421875,
        -3639.414306640625,
        976.5
      ],
      [
        -1574.8519287109375,
        -3637.0,
        974.0858154296875
      ],
      [
        -1623.1715087890625,
        -3638.0,
        976.5
      ],
      [
        -1623.15283203125,
        -3637.96826171875,
        976.468017578125
      ],
      [
        -1626.75732421875,
        -3639.414306640625,
        976.5
      ],
      [
        -1627.6739501953125,
        -3638.76611328125,
        975.8518676757812
      ],
      [
        -1580.5184326171875,
        -3646.0,
        974.0858154296875
      ],
      [
        -1578.9984130859375,
        -3643.585693359375,
        976.5
      ],
      [
        -1581.148193359375,
        -3647.0,
        974.5
      ],
      [
        -1591.0,
        -3647.0,
        973.0858764648438
      ],
      [
        -1581.148193359375,
        -3647.0,
        974.5
      ],
      [
        -1581.148193359375,
        -3647.0,
        973.0858764648438
      ],
      [
        -1578.9984130859375,
        -3643.585693359375,
        968.5
      ],
      [
        -1580.5184326171875,
        -3646.0,
        970.9141845703125
      ],
      [
        -1581.148193359375,
        -3647.0,
        970.5
      ],
      [
        -1581.148193359375,
        -3647.0,
        970.5
      ],
      [
        -1591.0,
        -3647.0,
        971.914306640625
      ],
      [
        -1581.148193359375,
        -3647.0,
        971.914306640625
      ],
      [
        -1580.5184326171875,
        -3646.0,
        970.9141845703125
      ],
      [
        -1580.5184326171875,
        -3646.0,
        974.0858154296875
      ],
      [
        -1573.54150390625,
        -3649.0810546875,
        963.2122192382812
      ],
      [
        -1572.8800048828125,
        -3650.1318359375,
        956.0
      ],
      [
        -1570.4405517578125,
        -3654.006103515625,
        963.2122192382812
      ],
      [
        -1571.1201171875,
        -3652.9267578125,
        956.0
      ],
      [
        -1570.4405517578125,
        -3654.006103515625,
        963.2122192382812
      ],
      [
        -1573.54150390625,
        -3649.0810546875,
        963.2122192382812
      ],
      [
        -1574.851806640625,
        -3647.0,
        970.5
      ],
      [
        -1574.851806640625,
        -3647.0,
        974.5
      ],
      [
        -1576.740478515625,
        -3644.0,
        967.5
      ],
      [
        -1574.851806640625,
        -3647.0,
        970.5
      ],
      [
        -1576.740478515625,
        -3644.0,
        977.5
      ],
      [
        -1574.851806640625,
        -3647.0,
        974.5
      ],
      [
        -1575.4814453125,
        -3646.0,
        970.9141845703125
      ],
      [
        -1575.4814453125,
        -3646.0,
        974.0858154296875
      ],
      [
        -1578.0,
        -3641.999755859375,
        967.5
      ],
      [
        -1576.740478515625,
        -3644.0,
        967.5
      ],
      [
        -1577.0015869140625,
        -3643.585693359375,
        968.5
      ],
      [
        -1575.4814453125,
        -3646.0,
        970.9141845703125
      ],
      [
        -1576.740478515625,
        -3644.0,
        977.5
      ],
      [
        -1578.0,
        -3641.999755859375,
        977.5
      ],
      [
        -1575.4814453125,
        -3646.0,
        974.0858154296875
      ],
      [
        -1577.0015869140625,
        -3643.585693359375,
        976.5
      ],
      [
        -1577.0015869140625,
        -3643.585693359375,
        968.5
      ],
      [
        -1578.0,
        -3642.0,
        968.5
      ],
      [
        -1577.0015869140625,
        -3643.585693359375,
        976.5
      ],
      [
        -1578.0,
        -3642.0,
        976.5
      ],
      [
        -1539.5595703125,
        -3660.783203125,
        989.3556518554688
      ],
      [
        -1546.73876953125,
        -3659.516357421875,
        989.30712890625
      ],
      [
        -1546.73876953125,
        -3659.516357421875,
        983.3326416015625
      ],
      [
        -1539.5595703125,
        -3660.783203125,
        983.0718994140625
      ],
      [
        -1550.02880859375,
        -3658.935791015625,
        986.3685302734375
      ],
      [
        -1549.8564453125,
        -3658.96630859375,
        986.2052612304688
      ],
      [
        -1549.8564453125,
        -3658.96630859375,
        986.2052612304688
      ],
      [
        -1546.73876953125,
        -3659.516357421875,
        983.3326416015625
      ],
      [
        -1546.73876953125,
        -3659.516357421875,
        989.30712890625
      ],
      [
        -1549.8564453125,
        -3658.96630859375,
        986.5266723632812
      ],
      [
        -1550.02880859375,
        -3658.935791015625,
        986.3685302734375
      ],
      [
        -1549.8564453125,
        -3658.96630859375,
        986.5266723632812
      ],
      [
        -1535.7647705078125,
        -3661.452880859375,
        986.15771484375
      ],
      [
        -1535.8212890625,
        -3661.44287109375,
        986.2066040039062
      ],
      [
        -1535.8212890625,
        -3661.44287109375,
        986.2066040039062
      ],
      [
        -1539.5595703125,
        -3660.783203125,
        989.3556518554688
      ],
      [
        -1535.7647705078125,
        -3661.452880859375,
        986.15771484375
      ],
      [
        -1535.8212890625,
        -3661.44287109375,
        986.1104736328125
      ],
      [
        -1539.5595703125,
        -3660.783203125,
        983.0718994140625
      ],
      [
        -1535.8212890625,
        -3661.44287109375,
        986.1104736328125
      ],
      [
        -1530.52294921875,
        -3662.3779296875,
        1007.4864501953125
      ],
      [
        -1531.4295654296875,
        -3665.800048828125,
        1007.8763427734375
      ],
      [
        -1527.833740234375,
        -3665.800048828125,
        998.7225952148438
      ],
      [
        -1527.5335693359375,
        -3662.905517578125,
        999.5809326171875
      ],
      [
        -1527.5335693359375,
        -3662.905517578125,
        1009.774658203125
      ],
      [
        -1527.833740234375,
        -3665.800048828125,
        1009.8671875
      ],
      [
        -1531.4295654296875,
        -3665.800048828125,
        1008.1469116210938
      ],
      [
        -1530.52294921875,
        -3662.3779296875,
        1008.301513671875
      ],
      [
        -1527.5335693359375,
        -3662.905517578125,
        999.5809326171875
      ],
      [
        -1527.833740234375,
        -3665.800048828125,
        998.7225952148438
      ],
      [
        -1523.599609375,
        -3663.599609375,
        999.3751220703125
      ],
      [
        -1523.599609375,
        -3663.599609375,
        1009.796875
      ],
      [
        -1527.833740234375,
        -3665.800048828125,
        1009.8671875
      ],
      [
        -1527.5335693359375,
        -3662.905517578125,
        1009.774658203125
      ],
      [
        -1530.772705078125,
        -3662.333740234375,
        1008.147216796875
      ],
      [
        -1530.52294921875,
        -3662.3779296875,
        1008.301513671875
      ],
      [
        -1531.4295654296875,
        -3665.800048828125,
        1008.1469116210938
      ],
      [
        -1531.515625,
        -3665.800048828125,
        1008.095458984375
      ],
      [
        -1530.8365478515625,
        -3662.322509765625,
        1008.1077880859375
      ],
      [
        -1531.537353515625,
        -3665.800048828125,
        1008.0824584960938
      ],
      [
        -1531.4295654296875,
        -3665.800048828125,
        1007.8763427734375
      ],
      [
        -1530.52294921875,
        -3662.3779296875,
        1007.4864501953125
      ],
      [
        -1531.537353515625,
        -3665.800048828125,
        1008.0824584960938
      ],
      [
        -1530.8365478515625,
        -3662.322509765625,
        1008.1077880859375
      ],
      [
        -1555.796142578125,
        -3665.800048828125,
        967.99365234375
      ],
      [
        -1553.983642578125,
        -3665.800048828125,
        963.49365234375
      ],
      [
        -1553.983642578125,
        -3665.800048828125,
        972.49365234375
      ],
      [
        -1555.796142578125,
        -3665.800048828125,
        967.99365234375
      ],
      [
        -1553.983642578125,
        -3665.800048828125,
        963.49365234375
      ],
      [
        -1548.546142578125,
        -3665.800048828125,
        961.99365234375
      ],
      [
        -1548.546142578125,
        -3665.800048828125,
        961.99365234375
      ],
      [
        -1548.5345458984375,
        -3665.800048828125,
        961.996826171875
      ],
      [
        -1543.108642578125,
        -3660.156982421875,
        972.5
      ],
      [
        -1543.108642578125,
        -3660.156982421875,
        963.5
      ],
      [
        -1543.108642578125,
        -3665.800048828125,
        963.49365234375
      ],
      [
        -1543.108642578125,
        -3665.800048828125,
        963.49365234375
      ],
      [
        -1543.105712890625,
        -3665.800048828125,
        963.5007934570312
      ],
      [
        -1541.296142578125,
        -3660.476806640625,
        968.0
      ],
      [
        -1543.108642578125,
        -3660.156982421875,
        972.5
      ],
      [
        -1541.296142578125,
        -3665.800048828125,
        967.99365234375
      ],
      [
        -1543.108642578125,
        -3665.800048828125,
        972.49365234375
      ],
      [
        -1543.108642578125,
        -3660.156982421875,
        963.5
      ],
      [
        -1541.296142578125,
        -3660.476806640625,
        968.0
      ],
      [
        -1541.296142578125,
        -3665.800048828125,
        967.99365234375
      ],
      [
        -1543.108642578125,
        -3665.800048828125,
        972.49365234375
      ],
      [
        -1548.546142578125,
        -3665.800048828125,
        973.99365234375
      ],
      [
        -1548.546142578125,
        -3665.800048828125,
        973.99365234375
      ],
      [
        -1553.983642578125,
        -3665.800048828125,
        972.49365234375
      ],
      [
        -1526.9197998046875,
        -3656.986083984375,
        1001.3363037109375
      ],
      [
        -1521.328369140625,
        -3655.999267578125,
        1001.62890625
      ],
      [
        -1521.328369140625,
        -3655.999267578125,
        1009.5540161132812
      ],
      [
        -1526.9197998046875,
        -3656.986083984375,
        1009.5855102539062
      ],
      [
        -1526.9197998046875,
        -3656.986083984375,
        1009.5855102539062
      ],
      [
        -1529.2010498046875,
        -3657.388427734375,
        1008.5269775390625
      ],
      [
        -1529.2010498046875,
        -3657.388427734375,
        1006.9179077148438
      ],
      [
        -1526.9197998046875,
        -3656.986083984375,
        1001.3363037109375
      ],
      [
        -1529.73291015625,
        -3657.482421875,
        1008.2196044921875
      ],
      [
        -1529.2010498046875,
        -3657.388427734375,
        1008.5269775390625
      ],
      [
        -1530.772705078125,
        -3662.333740234375,
        1008.147216796875
      ],
      [
        -1519.3990478515625,
        -3655.65869140625,
        1008.6051635742188
      ],
      [
        -1521.328369140625,
        -3655.999267578125,
        1009.5540161132812
      ],
      [
        -1518.672607421875,
        -3655.53076171875,
        1008.1572875976562
      ],
      [
        -1519.3990478515625,
        -3655.65869140625,
        1006.7208251953125
      ],
      [
        -1518.672607421875,
        -3655.53076171875,
        1008.1572875976562
      ],
      [
        -1519.3990478515625,
        -3655.65869140625,
        1008.6051635742188
      ],
      [
        -1521.328369140625,
        -3655.999267578125,
        1001.62890625
      ],
      [
        -1519.3990478515625,
        -3655.65869140625,
        1006.7208251953125
      ],
      [
        -1529.86572265625,
        -3657.505859375,
        1008.1428833007812
      ],
      [
        -1529.2010498046875,
        -3657.388427734375,
        1006.9179077148438
      ],
      [
        -1529.86572265625,
        -3657.505859375,
        1008.1428833007812
      ],
      [
        -1536.4681396484375,
        -3658.6708984375,
        986.3906860351562
      ],
      [
        -1536.65380859375,
        -3658.703857421875,
        986.21533203125
      ],
      [
        -1539.729248046875,
        -3659.246337890625,
        983.3882446289062
      ],
      [
        -1536.65380859375,
        -3658.703857421875,
        986.21533203125
      ],
      [
        -1536.4681396484375,
        -3658.6708984375,
        986.3906860351562
      ],
      [
        -1536.65380859375,
        -3658.703857421875,
        986.560546875
      ],
      [
        -1536.65380859375,
        -3658.703857421875,
        986.560546875
      ],
      [
        -1539.729248046875,
        -3659.246337890625,
        989.2967529296875
      ],
      [
        -1543.9991455078125,
        -3659.999755859375,
        983.233154296875
      ],
      [
        -1539.729248046875,
        -3659.246337890625,
        983.3882446289062
      ],
      [
        -1539.729248046875,
        -3659.246337890625,
        989.2967529296875
      ],
      [
        -1543.9991455078125,
        -3659.999755859375,
        989.3256225585938
      ],
      [
        -1560.8380126953125,
        -3637.161865234375,
        980.7122192382812
      ],
      [
        -1562.1817626953125,
        -3634.834228515625,
        980.7122192382812
      ],
      [
        -1560.8380126953125,
        -3632.507080078125,
        980.7122192382812
      ],
      [
        -1558.1510009765625,
        -3632.507080078125,
        980.7122192382812
      ],
      [
        -1556.8072509765625,
        -3634.83447265625,
        980.7122192382812
      ],
      [
        -1558.15087890625,
        -3637.161865234375,
        980.7122192382812
      ],
      [
        -1560.124755859375,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1558.8641357421875,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1558.8641357421875,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1560.124755859375,
        -3638.397216796875,
        980.7122192382812
      ],
      [
        -1559.5325927734375,
        -3635.644775390625,
        956.7099609375
      ],
      [
        -1562.6448974609375,
        -3633.8076171875,
        979.2841186523438
      ],
      [
        -1562.849365234375,
        -3632.507080078125,
        980.7122192382812
      ],
      [
        -1563.1873779296875,
        -3633.092529296875,
        980.7122192382812
      ],
      [
        -1562.6448974609375,
        -3633.8076171875,
        979.2841186523438
      ],
      [
        -1563.1873779296875,
        -3633.092529296875,
        980.7122192382812
      ],
      [
        -1562.849365234375,
        -3632.507080078125,
        980.7122192382812
      ],
      [
        -1560.1844482421875,
        -3634.530029296875,
        956.8013916015625
      ],
      [
        -1560.5303955078125,
        -3634.597900390625,
        956.0
      ],
      [
        -1559.7181396484375,
        -3635.850341796875,
        956.0
      ],
      [
        -1559.250244140625,
        -3630.602783203125,
        980.7122192382812
      ],
      [
        -1559.25048828125,
        -3630.602783203125,
        980.7122192382812
      ],
      [
        -1559.777587890625,
        -3633.86474609375,
        956.0
      ],
      [
        -1556.3497314453125,
        -3633.810546875,
        979.289794921875
      ],
      [
        -1556.3497314453125,
        -3633.810546875,
        979.289794921875
      ],
      [
        -1555.8070068359375,
        -3633.10205078125,
        980.7122192382812
      ],
      [
        -1555.8070068359375,
        -3633.10205078125,
        980.7122192382812
      ],
      [
        -1558.765869140625,
        -3634.201416015625,
        956.0
      ],
      [
        -1545.8505859375,
        -3644.615478515625,
        987.2501220703125
      ],
      [
        -1546.2708740234375,
        -3650.322265625,
        988.3689575195312
      ],
      [
        -1546.3994140625,
        -3648.0927734375,
        987.9318237304688
      ],
      [
        -1546.5103759765625,
        -3645.750732421875,
        987.4727172851562
      ],
      [
        -1546.3994140625,
        -3648.0927734375,
        987.9318237304688
      ],
      [
        -1546.5103759765625,
        -3645.750732421875,
        987.4727172851562
      ],
      [
        -1548.871337890625,
        -3659.14013671875,
        985.2975463867188
      ],
      [
        -1545.4725341796875,
        -3649.3408203125,
        985.42724609375
      ],
      [
        -1548.156982421875,
        -3659.26611328125,
        988.0423583984375
      ],
      [
        -1545.4725341796875,
        -3649.3408203125,
        985.42724609375
      ],
      [
        -1548.839111328125,
        -3659.145751953125,
        985.267822265625
      ],
      [
        -1545.4874267578125,
        -3649.4599609375,
        985.4027099609375
      ],
      [
        -1545.4874267578125,
        -3649.4599609375,
        985.4027099609375
      ],
      [
        -1538.9649658203125,
        -3659.111572265625,
        984.0908813476562
      ],
      [
        -1540.0718994140625,
        -3647.457275390625,
        986.645751953125
      ],
      [
        -1540.0718994140625,
        -3647.457275390625,
        986.645751953125
      ],
      [
        -1538.330322265625,
        -3658.99951171875,
        988.0521240234375
      ],
      [
        -1520.4014892578125,
        -3649.099609375,
        1007.2332153320312
      ],
      [
        -1519.960205078125,
        -3653.443359375,
        1008.7052612304688
      ],
      [
        -1520.0863037109375,
        -3653.673095703125,
        1008.7830810546875
      ],
      [
        -1519.3612060546875,
        -3651.904296875,
        1008.1837158203125
      ],
      [
        -1519.960205078125,
        -3653.443359375,
        1008.7052612304688
      ],
      [
        -1519.3612060546875,
        -3651.904296875,
        1008.1837158203125
      ],
      [
        -1521.4644775390625,
        -3654.52001953125,
        1002.0675659179688
      ],
      [
        -1519.610595703125,
        -3655.696044921875,
        1008.709228515625
      ],
      [
        -1521.4644775390625,
        -3654.52001953125,
        1002.0675659179688
      ],
      [
        -1521.132080078125,
        -3655.964599609375,
        1002.1468505859375
      ],
      [
        -1528.04052734375,
        -3653.008056640625,
        1006.4188232421875
      ],
      [
        -1528.62744140625,
        -3657.287353515625,
        1005.514404296875
      ],
      [
        -1528.04052734375,
        -3653.008056640625,
        1006.4188232421875
      ],
      [
        -1528.9378662109375,
        -3657.342041015625,
        1008.6491088867188
      ],
      [
        -1543.108642578125,
        -3673.800048828125,
        970.8812255859375
      ],
      [
        -1548.546142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      [
        -1531.515625,
        -3665.800048828125,
        1008.095458984375
      ],
      [
        -1516.744384765625,
        -3665.800048828125,
        1008.0953979492188
      ],
      [
        -1548.546142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      [
        -1553.983642578125,
        -3673.800048828125,
        970.8812255859375
      ],
      [
        -1553.983642578125,
        -3673.800048828125,
        961.8812255859375
      ],
      [
        -1548.546142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      [
        -1548.546142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      [
        -1543.108642578125,
        -3673.800048828125,
        961.8812255859375
      ],
      [
        -1553.983642578125,
        -3673.800048828125,
        970.8812255859375
      ],
      [
        -1555.796142578125,
        -3673.800048828125,
        966.3812255859375
      ],
      [
        -1555.796142578125,
        -3673.800048828125,
        966.3812255859375
      ],
      [
        -1553.983642578125,
        -3673.800048828125,
        961.8812255859375
      ],
      [
        -1543.108642578125,
        -3673.800048828125,
        961.8812255859375
      ],
      [
        -1541.296142578125,
        -3673.800048828125,
        966.3812255859375
      ],
      [
        -1541.296142578125,
        -3673.800048828125,
        966.3812255859375
      ],
      [
        -1543.108642578125,
        -3673.800048828125,
        970.8812255859375
      ],
      [
        -1548.53564453125,
        -3673.800048828125,
        960.3841552734375
      ],
      [
        -1553.986328125,
        -3673.800048828125,
        961.8877563476562
      ],
      [
        -1543.1060791015625,
        -3673.800048828125,
        961.8876342773438
      ],
      [
        -1556.3553466796875,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1542.6947021484375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1542.6947021484375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.7158203125,
        -3697.7685546875,
        951.8101196289062
      ],
      [
        -1540.7369384765625,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1541.7158203125,
        -3697.7685546875,
        951.8101196289062
      ],
      [
        -1556.3553466796875,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1540.7369384765625,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1556.39404296875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1556.39404296875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1541.065673828125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1540.6982421875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1540.6982421875,
        -3697.7685546875,
        961.5885620117188
      ],
      [
        -1541.065673828125,
        -3697.7685546875,
        962.5009765625
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      [
        -1548.5999755859375,
        -3720.14990234375,
        948.4600830078125
      ],
      [
        -1539.9739990234375,
        -3728.5185546875,
        948.0535888671875
      ],
      [
        -1539.2103271484375,
        -3728.5185546875,
        949.39453125
      ],
      [
        -1521.0767822265625,
        -3712.97314453125,
        957.947998046875
      ],
      [
        -1548.54052734375,
        -3717.528564453125,
        961.5820922851562
      ],
      [
        -1548.5419921875,
        -3717.856689453125,
        961.4942626953125
      ],
      [
        -1518.9776611328125,
        -3712.677734375,
        957.6713256835938
      ],
      [
        -1521.0767822265625,
        -3712.97314453125,
        957.947998046875
      ],
      [
        -1548.5999755859375,
        -3717.551025390625,
        961.5653076171875
      ],
      [
        -1548.5999755859375,
        -3717.759765625,
        961.5095825195312
      ],
      [
        -1548.5419921875,
        -3717.856689453125,
        961.4942626953125
      ],
      [
        -1548.54052734375,
        -3717.528564453125,
        961.5820922851562
      ],
      [
        -1540.805908203125,
        -3697.7685546875,
        961.8560180664062
      ],
      [
        -1548.5999755859375,
        -3708.402099609375,
        963.9703369140625
      ],
      [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      [
        -1548.5999755859375,
        -3697.7685546875,
        963.8651123046875
      ],
      [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      [
        -1548.5999755859375,
        -3708.402099609375,
        963.9703369140625
      ],
      [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      [
        -1548.5999755859375,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      [
        -1548.5999755859375,
        -3718.8369140625,
        961.209716796875
      ],
      [
        -1548.5999755859375,
        -3718.751708984375,
        961.2447509765625
      ],
      [
        -1548.5999755859375,
        -3718.8369140625,
        961.209716796875
      ],
      [
        -1539.1971435546875,
        -3721.56494140625,
        950.0297241210938
      ],
      [
        -1539.1971435546875,
        -3721.56494140625,
        950.0297241210938
      ],
      [
        -1539.557861328125,
        -3722.03955078125,
        949.3544311523438
      ],
      [
        -1548.5999755859375,
        -3718.751708984375,
        961.2447509765625
      ],
      [
        -1548.5999755859375,
        -3700.238525390625,
        951.0
      ],
      [
        -1548.5999755859375,
        -3697.7685546875,
        952.0801391601562
      ],
      [
        -1548.5999755859375,
        -3720.10546875,
        948.4705200195312
      ],
      [
        -1557.1182861328125,
        -3728.5185546875,
        948.0535888671875
      ],
      [
        -1557.8819580078125,
        -3728.5185546875,
        949.39453125
      ],
      [
        -1576.01513671875,
        -3712.97314453125,
        957.9479370117188
      ],
      [
        -1548.5999755859375,
        -3717.83935546875,
        961.4883422851562
      ],
      [
        -1548.5999755859375,
        -3717.522216796875,
        961.572998046875
      ],
      [
        -1578.1146240234375,
        -3712.677734375,
        957.6712036132812
      ],
      [
        -1576.01513671875,
        -3712.97314453125,
        957.9479370117188
      ],
      [
        -1556.286376953125,
        -3697.7685546875,
        961.8560180664062
      ],
      [
        -1557.8951416015625,
        -3721.565185546875,
        950.02978515625
      ],
      [
        -1557.534423828125,
        -3722.039794921875,
        949.3544311523438
      ],
      [
        -1557.8951416015625,
        -3721.565185546875,
        950.02978515625
      ],
      [
        -1531.9283447265625,
        -3740.70263671875,
        942.53466796875
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        941.5712890625
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        941.5729370117188
      ],
      [
        -1531.43115234375,
        -3750.979248046875,
        941.5712890625
      ],
      [
        -1531.3936767578125,
        -3751.753173828125,
        941.5729370117188
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      [
        -1548.5999755859375,
        -3740.238525390625,
        942.5399780273438
      ],
      [
        -1548.5999755859375,
        -3740.238525390625,
        942.5399780273438
      ],
      [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      [
        -1537.7735595703125,
        -3760.5185546875,
        940.634521484375
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      [
        -1548.5999755859375,
        -3752.690185546875,
        952.1936645507812
      ],
      [
        -1534.3707275390625,
        -3752.3779296875,
        950.4219970703125
      ],
      [
        -1536.09033203125,
        -3754.908203125,
        950.271728515625
      ],
      [
        -1548.5999755859375,
        -3752.56201171875,
        952.2296752929688
      ],
      [
        -1548.5999755859375,
        -3752.51708984375,
        952.2457275390625
      ],
      [
        -1548.5999755859375,
        -3752.56201171875,
        952.2296752929688
      ],
      [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      [
        -1548.5999755859375,
        -3739.20458984375,
        954.0750732421875
      ],
      [
        -1548.5999755859375,
        -3739.385986328125,
        954.025634765625
      ],
      [
        -1548.5999755859375,
        -3746.493896484375,
        952.9970703125
      ],
      [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      [
        -1548.5999755859375,
        -3739.44140625,
        954.010498046875
      ],
      [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      [
        -1548.5999755859375,
        -3739.44140625,
        954.010498046875
      ],
      [
        -1548.5999755859375,
        -3753.242431640625,
        941.1710205078125
      ],
      [
        -1559.2916259765625,
        -3760.5185546875,
        940.5975952148438
      ],
      [
        -1559.8170166015625,
        -3760.5185546875,
        941.3113403320312
      ],
      [
        -1560.529541015625,
        -3756.31884765625,
        949.8262329101562
      ],
      [
        -1548.5999755859375,
        -3758.17578125,
        950.6508178710938
      ],
      [
        -1554.349853515625,
        -3757.190673828125,
        950.0599365234375
      ],
      [
        -1560.529541015625,
        -3756.31884765625,
        949.8262329101562
      ],
      [
        -1554.349853515625,
        -3757.190673828125,
        950.0599365234375
      ],
      [
        -1561.2381591796875,
        -3754.8642578125,
        950.2855834960938
      ],
      [
        -1563.066650390625,
        -3752.378173828125,
        950.4214477539062
      ],
      [
        -1563.8194580078125,
        -3752.702392578125,
        949.361572265625
      ],
      [
        -1561.836181640625,
        -3755.740966796875,
        948.9309692382812
      ],
      [
        -1548.5999755859375,
        -3765.25,
        1006.5
      ],
      [
        -1430.000732421875,
        -3791.635498046875,
        1006.5
      ],
      [
        -1548.5999755859375,
        -3782.512451171875,
        1006.5
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        935.0035400390625
      ],
      [
        -1548.5999755859375,
        -3781.218017578125,
        935.00537109375
      ],
      [
        -1548.5999755859375,
        -3781.218017578125,
        935.00537109375
      ],
      [
        -1548.5999755859375,
        -3773.15576171875,
        935.903564453125
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        935.7178344726562
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        935.0
      ],
      [
        -1537.785888671875,
        -3783.343994140625,
        935.7640380859375
      ],
      [
        -1538.14208984375,
        -3783.316650390625,
        935.7178344726562
      ],
      [
        -1548.5501708984375,
        -3782.516357421875,
        935.0
      ],
      [
        -1548.5999755859375,
        -3782.512451171875,
        935.0075073242188
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        935.0076904296875
      ],
      [
        -1548.5999755859375,
        -3781.261474609375,
        935.0035400390625
      ],
      [
        -1548.5999755859375,
        -3781.299560546875,
        935.0076904296875
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        935.99609375
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        935.99609375
      ],
      [
        -1438.42724609375,
        -3784.442626953125,
        1006.5
      ],
      [
        -1423.42724609375,
        -3784.442626953125,
        1006.5
      ],
      [
        -1441.2779541015625,
        -3790.76806640625,
        996.9375
      ],
      [
        -1438.42724609375,
        -3784.442626953125,
        1006.5
      ],
      [
        -1442.1644287109375,
        -3790.69970703125,
        1006.5
      ],
      [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      [
        -1533.484619140625,
        -3782.828857421875,
        942.4762573242188
      ],
      [
        -1535.9979248046875,
        -3783.481689453125,
        945.6007690429688
      ],
      [
        -1533.527099609375,
        -3783.671875,
        942.2769775390625
      ],
      [
        -1532.622314453125,
        -3783.5107421875,
        941.1296997070312
      ],
      [
        -1532.6265869140625,
        -3783.7412109375,
        941.0655517578125
      ],
      [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      [
        -1548.5999755859375,
        -3768.47509765625,
        947.7540893554688
      ],
      [
        -1548.5999755859375,
        -3768.52001953125,
        947.7431640625
      ],
      [
        -1548.5999755859375,
        -3768.47509765625,
        947.7540893554688
      ],
      [
        -1498.4254150390625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1495.25341796875,
        -3764.542724609375,
        1015.0
      ],
      [
        -1495.25341796875,
        -3764.542724609375,
        1015.0
      ],
      [
        -1495.0,
        -3764.542724609375,
        1015.0
      ],
      [
        -1548.5999755859375,
        -3764.6259765625,
        1014.0
      ],
      [
        -1548.5999755859375,
        -3764.542724609375,
        1015.0
      ],
      [
        -1498.4254150390625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1451.1397705078125,
        -3764.542724609375,
        1015.0
      ],
      [
        -1495.0,
        -3764.542724609375,
        1015.0
      ],
      [
        -1548.5999755859375,
        -3765.25,
        1006.5
      ],
      [
        -1548.5999755859375,
        -3764.6259765625,
        1014.0
      ],
      [
        -1430.000732421875,
        -3791.635498046875,
        1006.5
      ],
      [
        -1449.4796142578125,
        -3767.80615234375,
        1015.0
      ],
      [
        -1430.0672607421875,
        -3791.63037109375,
        1015.0
      ],
      [
        -1435.861572265625,
        -3784.442626953125,
        1006.5
      ],
      [
        -1424.25146484375,
        -3784.442626953125,
        1015.0
      ],
      [
        -1435.9239501953125,
        -3784.442626953125,
        1015.0
      ],
      [
        -1451.1397705078125,
        -3764.542724609375,
        1015.0
      ],
      [
        -1449.4796142578125,
        -3767.80615234375,
        1015.0
      ],
      [
        -1439.25146484375,
        -3784.442626953125,
        1015.0
      ],
      [
        -1442.9525146484375,
        -3790.63916015625,
        1015.0
      ],
      [
        -1439.25146484375,
        -3784.442626953125,
        1015.0
      ],
      [
        -1625.731201171875,
        -3776.579345703125,
        1006.5
      ],
      [
        -1548.5999755859375,
        -3771.328369140625,
        936.1071166992188
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        935.25830078125
      ],
      [
        -1557.4801025390625,
        -3781.829345703125,
        935.7698364257812
      ],
      [
        -1550.2620849609375,
        -3782.384521484375,
        935.25830078125
      ],
      [
        -1617.4271240234375,
        -3777.218017578125,
        1001.0
      ],
      [
        -1604.1737060546875,
        -3778.237548828125,
        1002.3384399414062
      ],
      [
        -1561.645751953125,
        -3781.509033203125,
        944.5693969726562
      ],
      [
        -1604.1737060546875,
        -3778.237548828125,
        1002.3384399414062
      ],
      [
        -1602.9718017578125,
        -3778.329833984375,
        1001.0
      ],
      [
        -1561.645751953125,
        -3781.509033203125,
        944.5693969726562
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        945.5963134765625
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        936.018310546875
      ],
      [
        -1560.986328125,
        -3781.5595703125,
        936.018310546875
      ],
      [
        -1590.7313232421875,
        -3764.542724609375,
        1015.0
      ],
      [
        -1587.484619140625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1591.0,
        -3764.542724609375,
        1015.0
      ],
      [
        -1590.7313232421875,
        -3764.542724609375,
        1015.0
      ],
      [
        -1587.484619140625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1591.0,
        -3764.542724609375,
        1015.0
      ],
      [
        -1616.40869140625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1625.731201171875,
        -3776.579345703125,
        1006.5
      ],
      [
        -1624.8275146484375,
        -3776.648681640625,
        1015.0
      ],
      [
        -1617.6224365234375,
        -3767.80615234375,
        1015.0
      ],
      [
        -1616.40869140625,
        -3764.542724609375,
        1015.0
      ],
      [
        -1617.6224365234375,
        -3767.80615234375,
        1015.0
      ],
      [
        -1448.6239013671875,
        -3829.22021484375,
        1006.5
      ],
      [
        -1578.4940185546875,
        -3780.212890625,
        1006.5
      ],
      [
        -1423.42724609375,
        -3809.557373046875,
        1006.5
      ],
      [
        -1438.42724609375,
        -3809.557373046875,
        1006.5
      ],
      [
        -1438.42724609375,
        -3809.557373046875,
        1006.5
      ],
      [
        -1445.92724609375,
        -3797.0,
        1006.5
      ],
      [
        -1445.92724609375,
        -3797.0,
        1006.5
      ],
      [
        -1442.1644287109375,
        -3790.69970703125,
        1006.5
      ],
      [
        -1448.6239013671875,
        -3829.22021484375,
        1006.5
      ],
      [
        -1426.301025390625,
        -3801.92724609375,
        1015.0
      ],
      [
        -1448.5596923828125,
        -3829.24462890625,
        1015.0
      ],
      [
        -1424.25146484375,
        -3809.557373046875,
        1015.0
      ],
      [
        -1432.6024169921875,
        -3809.557373046875,
        1006.5
      ],
      [
        -1432.51806640625,
        -3809.557373046875,
        1015.0
      ],
      [
        -1439.25146484375,
        -3809.557373046875,
        1015.0
      ],
      [
        -1446.75146484375,
        -3797.0,
        1015.0
      ],
      [
        -1424.2244873046875,
        -3798.801025390625,
        1015.0
      ],
      [
        -1446.75146484375,
        -3797.0,
        1015.0
      ],
      [
        -1439.25146484375,
        -3809.557373046875,
        1015.0
      ],
      [
        -1424.2244873046875,
        -3798.801025390625,
        1015.0
      ],
      [
        -1426.301025390625,
        -3801.92724609375,
        1015.0
      ],
      [
        -1587.039306640625,
        -3816.10888671875,
        1006.5
      ],
      [
        -1606.0196533203125,
        -3850.810546875,
        1006.5
      ],
      [
        -1662.960693359375,
        -3816.10888671875,
        1006.5
      ],
      [
        -1643.9803466796875,
        -3781.407470703125,
        1006.5
      ],
      [
        -1606.0196533203125,
        -3781.407470703125,
        1006.5
      ],
      [
        -1587.039306640625,
        -3816.10888671875,
        1006.5
      ],
      [
        -1583.04052734375,
        -3821.401123046875,
        935.6671142578125
      ],
      [
        -1574.5142822265625,
        -3818.942138671875,
        935.751220703125
      ],
      [
        -1643.9803466796875,
        -3781.407470703125,
        1006.5
      ],
      [
        -1606.0196533203125,
        -3781.407470703125,
        1006.5
      ],
      [
        -1577.7279052734375,
        -3825.248291015625,
        936.83740234375
      ],
      [
        -1548.2073974609375,
        -3797.843505859375,
        935.3236694335938
      ],
      [
        -1548.2073974609375,
        -3797.843505859375,
        935.3236694335938
      ],
      [
        -1542.16259765625,
        -3793.9228515625,
        935.96533203125
      ],
      [
        -1538.4215087890625,
        -3795.334716796875,
        936.7704467773438
      ],
      [
        -1537.7236328125,
        -3803.261962890625,
        941.0
      ],
      [
        -1537.7236328125,
        -3803.261962890625,
        941.0
      ],
      [
        -1539.515869140625,
        -3803.320068359375,
        943.1204223632812
      ],
      [
        -1533.551025390625,
        -3844.2958984375,
        1015.0
      ],
      [
        -1457.7857666015625,
        -3833.96435546875,
        1015.0
      ],
      [
        -1615.5458984375,
        -3832.922119140625,
        1015.0
      ],
      [
        -1539.7806396484375,
        -3843.25390625,
        1015.0
      ],
      [
        -1597.5543212890625,
        -3835.33349609375,
        1006.5
      ],
      [
        -1609.7900390625,
        -3843.498291015625,
        1015.0
      ],
      [
        -1604.806396484375,
        -3834.38671875,
        1015.0
      ],
      [
        -1533.551025390625,
        -3844.2958984375,
        1015.0
      ],
      [
        -1539.7806396484375,
        -3843.25390625,
        1015.0
      ],
      [
        -1615.5458984375,
        -3832.922119140625,
        1015.0
      ],
      [
        -1640.801025390625,
        -3801.92724609375,
        1015.0
      ],
      [
        -1655.419921875,
        -3815.68994140625,
        1015.0
      ],
      [
        -1649.7457275390625,
        -3791.9482421875,
        1006.5
      ],
      [
        -1645.0439453125,
        -3796.7197265625,
        1015.0
      ],
      [
        -1609.7900390625,
        -3787.8818359375,
        1015.0
      ],
      [
        -1594.580078125,
        -3815.68994140625,
        1015.0
      ],
      [
        -1640.2099609375,
        -3787.8818359375,
        1015.0
      ],
      [
        -1609.7900390625,
        -3787.8818359375,
        1015.0
      ],
      [
        -1594.580078125,
        -3815.68994140625,
        1015.0
      ],
      [
        -1629.665283203125,
        -3781.407470703125,
        1006.5
      ],
      [
        -1642.8775634765625,
        -3798.801025390625,
        1015.0
      ],
      [
        -1633.9803466796875,
        -3787.881591796875,
        1015.0
      ],
      [
        -1640.2099609375,
        -3787.8818359375,
        1015.0
      ],
      [
        -1640.801025390625,
        -3801.92724609375,
        1015.0
      ],
      [
        -1642.8775634765625,
        -3798.801025390625,
        1015.0
      ],
      [
        -1451.55615234375,
        -3832.922119140625,
        1015.0
      ],
      [
        -1457.7857666015625,
        -3833.96435546875,
        1015.0
      ],
      [
        -1451.55615234375,
        -3832.922119140625,
        1015.0
      ],
      [
        -1460.340087890625,
        -3860.61328125,
        1110.625
      ],
      [
        -1467.840087890625,
        -3848.055908203125,
        1110.625
      ],
      [
        -1467.840087890625,
        -3848.055908203125,
        1110.625
      ],
      [
        -1459.96875,
        -3836.0927734375,
        1107.0552978515625
      ],
      [
        -1460.8209228515625,
        -3836.3037109375,
        1110.625
      ],
      [
        -1459.96875,
        -3836.0927734375,
        1107.0552978515625
      ],
      [
        -1445.340087890625,
        -3835.49853515625,
        1110.625
      ],
      [
        -1456.008056640625,
        -3835.49853515625,
        1110.625
      ],
      [
        -1529.1107177734375,
        -3848.2197265625,
        1110.625
      ],
      [
        -1514.1107177734375,
        -3848.2197265625,
        1110.625
      ],
      [
        -1536.6107177734375,
        -3860.777099609375,
        1110.625
      ],
      [
        -1529.1107177734375,
        -3848.2197265625,
        1110.625
      ],
      [
        -1514.1107177734375,
        -3848.2197265625,
        1110.625
      ],
      [
        -1506.6107177734375,
        -3860.777099609375,
        1110.625
      ],
      [
        -1506.6107177734375,
        -3860.777099609375,
        1110.625
      ],
      [
        -1508.6947021484375,
        -3864.266357421875,
        1110.625
      ],
      [
        -1484.6522216796875,
        -3839.463623046875,
        1067.475830078125
      ],
      [
        -1477.8182373046875,
        -3838.322021484375,
        1067.5540771484375
      ],
      [
        -1477.814208984375,
        -3838.4306640625,
        1073.2672119140625
      ],
      [
        -1484.6568603515625,
        -3839.575439453125,
        1073.2818603515625
      ],
      [
        -1474.567626953125,
        -3837.833251953125,
        1070.4237060546875
      ],
      [
        -1474.780029296875,
        -3837.864990234375,
        1070.231201171875
      ],
      [
        -1477.8182373046875,
        -3838.322021484375,
        1067.5540771484375
      ],
      [
        -1474.780029296875,
        -3837.864990234375,
        1070.231201171875
      ],
      [
        -1474.567626953125,
        -3837.833251953125,
        1070.4237060546875
      ],
      [
        -1474.779296875,
        -3837.872314453125,
        1070.614013671875
      ],
      [
        -1474.779296875,
        -3837.872314453125,
        1070.614013671875
      ],
      [
        -1477.814208984375,
        -3838.4306640625,
        1073.2672119140625
      ],
      [
        -1488.0538330078125,
        -3840.087890625,
        1070.3607177734375
      ],
      [
        -1487.873046875,
        -3840.0546875,
        1070.203369140625
      ],
      [
        -1487.873046875,
        -3840.0546875,
        1070.203369140625
      ],
      [
        -1484.6522216796875,
        -3839.463623046875,
        1067.475830078125
      ],
      [
        -1484.6568603515625,
        -3839.575439453125,
        1073.2818603515625
      ],
      [
        -1487.8736572265625,
        -3840.060791015625,
        1070.519775390625
      ],
      [
        -1488.0538330078125,
        -3840.087890625,
        1070.3607177734375
      ],
      [
        -1487.8736572265625,
        -3840.060791015625,
        1070.519775390625
      ],
      [
        -1604.806396484375,
        -3834.38671875,
        1015.0
      ],
      [
        -1615.18701171875,
        -3833.03125,
        1027.1671142578125
      ],
      [
        -1615.206787109375,
        -3832.978271484375,
        1017.0
      ],
      [
        -1617.383544921875,
        -3832.725830078125,
        1025.9732666015625
      ],
      [
        -1626.8170166015625,
        -3831.45458984375,
        1029.0
      ],
      [
        -1634.578857421875,
        -3830.396240234375,
        1029.0
      ],
      [
        -1604.4544677734375,
        -3834.696044921875,
        1067.8028564453125
      ],
      [
        -1597.9189453125,
        -3835.5869140625,
        1067.7418212890625
      ],
      [
        -1597.91796875,
        -3835.6142578125,
        1073.231201171875
      ],
      [
        -1604.45556640625,
        -3834.722900390625,
        1073.2198486328125
      ],
      [
        -1607.2657470703125,
        -3834.324951171875,
        1070.2763671875
      ],
      [
        -1604.4544677734375,
        -3834.696044921875,
        1067.8028564453125
      ],
      [
        -1604.45556640625,
        -3834.722900390625,
        1073.2198486328125
      ],
      [
        -1607.2659912109375,
        -3834.3271484375,
        1070.7667236328125
      ],
      [
        -1607.5379638671875,
        -3834.2890625,
        1070.5225830078125
      ],
      [
        -1607.2659912109375,
        -3834.3271484375,
        1070.7667236328125
      ],
      [
        -1607.5379638671875,
        -3834.2890625,
        1070.5225830078125
      ],
      [
        -1607.2657470703125,
        -3834.324951171875,
        1070.2763671875
      ],
      [
        -1594.718994140625,
        -3836.036865234375,
        1070.4737548828125
      ],
      [
        -1594.9688720703125,
        -3836.001708984375,
        1070.2550048828125
      ],
      [
        -1597.9189453125,
        -3835.5869140625,
        1067.7418212890625
      ],
      [
        -1594.9688720703125,
        -3836.001708984375,
        1070.2550048828125
      ],
      [
        -1594.718994140625,
        -3836.036865234375,
        1070.4737548828125
      ],
      [
        -1594.9686279296875,
        -3836.00390625,
        1070.6944580078125
      ],
      [
        -1594.9686279296875,
        -3836.00390625,
        1070.6944580078125
      ],
      [
        -1597.91796875,
        -3835.6142578125,
        1073.231201171875
      ],
      [
        -1433.5242919921875,
        -3809.557373046875,
        1110.625
      ],
      [
        -1431.3690185546875,
        -3809.557373046875,
        1015.0
      ],
      [
        -1435.3814697265625,
        -3809.557373046875,
        1110.625
      ],
      [
        -1619.1221923828125,
        -3831.45458984375,
        1029.0
      ],
      [
        -1637.1524658203125,
        -3804.30908203125,
        1029.0
      ],
      [
        -1637.1524658203125,
        -3804.30908203125,
        1029.0
      ],
      [
        -1644.6898193359375,
        -3796.072265625,
        1015.0
      ],
      [
        -1635.5228271484375,
        -3807.20947265625,
        1029.0
      ],
      [
        -1632.022705078125,
        -3813.70458984375,
        1029.0
      ],
      [
        -1632.022705078125,
        -3813.70458984375,
        1029.0
      ],
      [
        -1635.522705078125,
        -3820.19970703125,
        1029.0
      ],
      [
        -1640.757568359375,
        -3807.7548828125,
        1027.0
      ],
      [
        -1635.5228271484375,
        -3807.20947265625,
        1029.0
      ],
      [
        -1638.73876953125,
        -3807.20947265625,
        1029.0
      ],
      [
        -1642.522705078125,
        -3807.20947265625,
        1029.0
      ],
      [
        -1627.8104248046875,
        -3813.929443359375,
        1049.0
      ],
      [
        -1631.0057373046875,
        -3812.941650390625,
        1031.796875
      ],
      [
        -1635.84228515625,
        -3802.19921875,
        1047.37109375
      ],
      [
        -1635.2513427734375,
        -3807.005859375,
        1029.7464599609375
      ],
      [
        -1627.8104248046875,
        -3813.929443359375,
        1049.0
      ],
      [
        -1635.539794921875,
        -3802.292724609375,
        1049.0
      ],
      [
        -1635.2513427734375,
        -3807.005859375,
        1029.7464599609375
      ],
      [
        -1631.0057373046875,
        -3812.941650390625,
        1031.796875
      ],
      [
        -1618.976318359375,
        -3829.451171875,
        1039.0
      ],
      [
        -1626.7056884765625,
        -3817.814453125,
        1039.0
      ],
      [
        -1618.976318359375,
        -3829.451171875,
        1039.0
      ],
      [
        -1618.938720703125,
        -3829.61767578125,
        1038.5059814453125
      ],
      [
        -1620.3529052734375,
        -3822.95361328125,
        1058.917724609375
      ],
      [
        -1622.9757080078125,
        -3819.07080078125,
        1058.619384765625
      ],
      [
        -1622.779541015625,
        -3820.169921875,
        1055.0
      ],
      [
        -1619.1162109375,
        -3825.685791015625,
        1055.0
      ],
      [
        -1618.5328369140625,
        -3826.16943359375,
        1056.773681640625
      ],
      [
        -1620.3529052734375,
        -3822.95361328125,
        1058.917724609375
      ],
      [
        -1622.9757080078125,
        -3819.07080078125,
        1058.619384765625
      ],
      [
        -1623.778564453125,
        -3818.404296875,
        1056.1771240234375
      ],
      [
        -1619.1162109375,
        -3825.685791015625,
        1055.0
      ],
      [
        -1618.5328369140625,
        -3826.16943359375,
        1056.773681640625
      ],
      [
        -1623.778564453125,
        -3818.404296875,
        1056.1771240234375
      ],
      [
        -1622.779541015625,
        -3820.169921875,
        1055.0
      ],
      [
        -1432.51806640625,
        -3809.557373046875,
        1015.0
      ],
      [
        -1432.2987060546875,
        -3809.557373046875,
        1037.1551513671875
      ],
      [
        -1435.9239501953125,
        -3784.442626953125,
        1015.0
      ],
      [
        -1433.199462890625,
        -3784.442626953125,
        1107.2757568359375
      ],
      [
        -1436.329833984375,
        -3784.442626953125,
        1070.3173828125
      ],
      [
        -1434.3182373046875,
        -3769.7392578125,
        1110.625
      ],
      [
        -1444.6331787109375,
        -3765.8349609375,
        1084.05224609375
      ],
      [
        -1440.39599609375,
        -3769.7392578125,
        1110.625
      ],
      [
        -1444.6331787109375,
        -3765.8349609375,
        1084.05224609375
      ],
      [
        -1439.7012939453125,
        -3761.22021484375,
        1054.9375
      ],
      [
        -1448.2874755859375,
        -3758.943359375,
        1082.303466796875
      ],
      [
        -1440.1929931640625,
        -3784.442626953125,
        1024.7088623046875
      ],
      [
        -1440.2041015625,
        -3786.03759765625,
        1015.0
      ],
      [
        -1440.193115234375,
        -3784.442626953125,
        1024.710205078125
      ],
      [
        -1615.7593994140625,
        -3831.0146484375,
        1029.0
      ],
      [
        -1635.5340576171875,
        -3806.74560546875,
        1029.0
      ],
      [
        -1616.651611328125,
        -3829.919921875,
        1029.0
      ],
      [
        -1615.2850341796875,
        -3832.96923828125,
        1017.3223876953125
      ],
      [
        -1617.7591552734375,
        -3831.97509765625,
        1029.0
      ],
      [
        -1615.7593994140625,
        -3831.0146484375,
        1029.0
      ],
      [
        -1614.2972412109375,
        -3833.1474609375,
        1026.124267578125
      ],
      [
        -1627.792724609375,
        -3813.896484375,
        1049.0
      ],
      [
        -1630.421142578125,
        -3812.503173828125,
        1033.4044189453125
      ],
      [
        -1630.421142578125,
        -3812.503173828125,
        1033.4044189453125
      ],
      [
        -1627.792724609375,
        -3813.896484375,
        1049.0
      ],
      [
        -1628.0068359375,
        -3813.6337890625,
        1049.0
      ],
      [
        -1617.82177734375,
        -3827.30859375,
        1039.0
      ],
      [
        -1626.2486572265625,
        -3816.96630859375,
        1039.0
      ],
      [
        -1617.82177734375,
        -3827.30859375,
        1039.0
      ],
      [
        -1622.10693359375,
        -3820.169921875,
        1055.0
      ],
      [
        -1618.5306396484375,
        -3824.558837890625,
        1055.0
      ],
      [
        -1621.47119140625,
        -3820.47998046875,
        1059.0
      ],
      [
        -1622.8076171875,
        -3818.869140625,
        1058.75390625
      ],
      [
        -1619.55615234375,
        -3822.830078125,
        1059.0
      ],
      [
        -1617.751953125,
        -3825.232421875,
        1057.3983154296875
      ],
      [
        -1619.5565185546875,
        -3822.830078125,
        1059.0
      ],
      [
        -1621.470947265625,
        -3820.48046875,
        1059.0
      ],
      [
        -1622.8076171875,
        -3818.869140625,
        1058.75390625
      ],
      [
        -1623.5966796875,
        -3818.18603515625,
        1056.3226318359375
      ],
      [
        -1618.5306396484375,
        -3824.558837890625,
        1055.0
      ],
      [
        -1617.751953125,
        -3825.232421875,
        1057.3983154296875
      ],
      [
        -1623.5966796875,
        -3818.18603515625,
        1056.3226318359375
      ],
      [
        -1622.10693359375,
        -3820.169921875,
        1055.0
      ],
      [
        -1642.28857421875,
        -3798.6962890625,
        1019.4600219726562
      ],
      [
        -1637.30517578125,
        -3792.869873046875,
        1021.5487670898438
      ],
      [
        -1637.30517578125,
        -3792.869873046875,
        1021.5487060546875
      ],
      [
        -1633.980712890625,
        -3787.8818359375,
        1015.0
      ],
      [
        -1610.6334228515625,
        -3758.506103515625,
        1110.625
      ],
      [
        -1610.633544921875,
        -3758.506103515625,
        1110.625
      ],
      [
        -1610.251220703125,
        -3756.587158203125,
        1110.625
      ],
      [
        -1606.560546875,
        -3762.002197265625,
        1071.053466796875
      ],
      [
        -1606.8526611328125,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1604.478759765625,
        -3759.71728515625,
        1073.0013427734375
      ],
      [
        -1605.215087890625,
        -3760.05615234375,
        1068.9305419921875
      ],
      [
        -1606.845703125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1606.572021484375,
        -3761.919921875,
        1070.3599853515625
      ],
      [
        -1606.905517578125,
        -3762.379638671875,
        1070.7210693359375
      ],
      [
        -1607.1915283203125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1606.8526611328125,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1606.560546875,
        -3762.002197265625,
        1071.053466796875
      ],
      [
        -1607.1915283203125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1606.905517578125,
        -3762.379638671875,
        1070.7210693359375
      ],
      [
        -1606.572021484375,
        -3761.919921875,
        1070.3599853515625
      ],
      [
        -1606.845703125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1448.5242919921875,
        -3809.557373046875,
        1110.625
      ],
      [
        -1456.0242919921875,
        -3797.0,
        1110.625
      ],
      [
        -1456.0242919921875,
        -3797.0,
        1110.625
      ],
      [
        -1448.5242919921875,
        -3784.442626953125,
        1110.625
      ],
      [
        -1448.5242919921875,
        -3809.557373046875,
        1110.625
      ],
      [
        -1448.5242919921875,
        -3784.442626953125,
        1110.625
      ],
      [
        -1433.5242919921875,
        -3784.442626953125,
        1110.625
      ],
      [
        -1433.162353515625,
        -3784.442626953125,
        1110.625
      ],
      [
        -1432.960205078125,
        -3784.442626953125,
        1110.1031494140625
      ],
      [
        -1440.3782958984375,
        -3770.8037109375,
        1110.625
      ],
      [
        -1440.0968017578125,
        -3770.5146484375,
        1109.5035400390625
      ],
      [
        -1449.3182373046875,
        -3769.7392578125,
        1110.625
      ],
      [
        -1456.362548828125,
        -3756.802001953125,
        1108.040283203125
      ],
      [
        -1456.8182373046875,
        -3757.181884765625,
        1110.625
      ],
      [
        -1449.3182373046875,
        -3769.7392578125,
        1110.625
      ],
      [
        -1446.884521484375,
        -3758.506103515625,
        1110.625
      ],
      [
        -1440.9415283203125,
        -3769.7392578125,
        1110.625
      ],
      [
        -1440.5816650390625,
        -3769.568359375,
        1109.4627685546875
      ],
      [
        -1447.266845703125,
        -3756.587158203125,
        1110.625
      ],
      [
        -1446.884521484375,
        -3758.506103515625,
        1110.625
      ],
      [
        -1456.8182373046875,
        -3757.181884765625,
        1110.625
      ],
      [
        -1456.362548828125,
        -3756.802001953125,
        1108.040283203125
      ],
      [
        -1456.4630126953125,
        -3756.587158203125,
        1110.625
      ],
      [
        -1536.5213623046875,
        -3757.489990234375,
        1099.7703857421875
      ],
      [
        -1592.896484375,
        -3758.739013671875,
        1084.7596435546875
      ],
      [
        -1478.277587890625,
        -3784.79150390625,
        1071.2271728515625
      ],
      [
        -1477.745361328125,
        -3768.151611328125,
        1072.368896484375
      ],
      [
        -1477.6524658203125,
        -3775.924072265625,
        1071.8355712890625
      ],
      [
        -1477.60498046875,
        -3781.84033203125,
        1071.4296875
      ],
      [
        -1477.6524658203125,
        -3775.924072265625,
        1071.8355712890625
      ],
      [
        -1477.60498046875,
        -3781.84033203125,
        1071.4296875
      ],
      [
        -1475.194580078125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1475.540283203125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1475.540283203125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1476.95654296875,
        -3760.040771484375,
        1069.1136474609375
      ],
      [
        -1478.748779296875,
        -3773.21533203125,
        1069.2884521484375
      ],
      [
        -1475.194580078125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1475.5335693359375,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1478.748779296875,
        -3773.21533203125,
        1069.2884521484375
      ],
      [
        -1477.05859375,
        -3759.77880859375,
        1072.2618408203125
      ],
      [
        -1475.5335693359375,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1480.270751953125,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1478.0999755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1478.0999755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1478.7332763671875,
        -3772.893310546875,
        1069.2596435546875
      ],
      [
        -1476.9906005859375,
        -3760.043212890625,
        1069.08447265625
      ],
      [
        -1478.7332763671875,
        -3772.893310546875,
        1069.2596435546875
      ],
      [
        -1478.1201171875,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1484.2647705078125,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1484.2647705078125,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1485.13134765625,
        -3760.06201171875,
        1068.85888671875
      ],
      [
        -1484.215576171875,
        -3778.966552734375,
        1070.6435546875
      ],
      [
        -1478.1201171875,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1484.215576171875,
        -3778.966552734375,
        1070.6435546875
      ],
      [
        -1603.918212890625,
        -3784.957763671875,
        1071.2158203125
      ],
      [
        -1604.63623046875,
        -3775.923583984375,
        1071.8355712890625
      ],
      [
        -1604.59033203125,
        -3768.153076171875,
        1072.368896484375
      ],
      [
        -1604.647705078125,
        -3781.84033203125,
        1071.4296875
      ],
      [
        -1604.63623046875,
        -3775.923583984375,
        1071.8355712890625
      ],
      [
        -1604.647705078125,
        -3781.84033203125,
        1071.4296875
      ],
      [
        -1603.6370849609375,
        -3771.72607421875,
        1069.1552734375
      ],
      [
        -1605.22509765625,
        -3760.070068359375,
        1068.941162109375
      ],
      [
        -1603.6370849609375,
        -3771.72607421875,
        1069.1552734375
      ],
      [
        -1605.25830078125,
        -3760.57275390625,
        1072.27197265625
      ],
      [
        -1635.5067138671875,
        -3804.9287109375,
        1037.3629150390625
      ],
      [
        -1630.970703125,
        -3803.79541015625,
        1041.51806640625
      ],
      [
        -1630.970703125,
        -3803.79541015625,
        1041.51806640625
      ],
      [
        -1626.0977783203125,
        -3809.2607421875,
        1045.2935791015625
      ],
      [
        -1626.0977783203125,
        -3809.2607421875,
        1045.2935791015625
      ],
      [
        -1628.909423828125,
        -3813.304443359375,
        1042.3740234375
      ],
      [
        -1617.7591552734375,
        -3814.37939453125,
        1029.0
      ],
      [
        -1613.0181884765625,
        -3823.17724609375,
        1029.0
      ],
      [
        -1627.2408447265625,
        -3814.37939453125,
        1029.0
      ],
      [
        -1617.7591552734375,
        -3814.37939453125,
        1029.0
      ],
      [
        -1613.0181884765625,
        -3823.17724609375,
        1029.0
      ],
      [
        -1616.651611328125,
        -3829.919921875,
        1029.0
      ],
      [
        -1598.1201171875,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1604.2647705078125,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1597.9559326171875,
        -3778.220458984375,
        1070.631103515625
      ],
      [
        -1597.08740234375,
        -3760.05029296875,
        1069.0015869140625
      ],
      [
        -1598.1201171875,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1597.9559326171875,
        -3778.220458984375,
        1070.631103515625
      ],
      [
        -1604.2647705078125,
        -3760.123779296875,
        1068.1168212890625
      ],
      [
        -1604.2874755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1601.785400390625,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1604.2874755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1484.2874755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1598.0999755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1486.8526611328125,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1484.2874755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1487.1915283203125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1486.8526611328125,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1487.1915283203125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1486.845703125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1486.845703125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1598.0999755859375,
        -3759.703369140625,
        1073.16796875
      ],
      [
        -1595.5335693359375,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1595.194580078125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1595.5335693359375,
        -3759.88916015625,
        1070.9346923828125
      ],
      [
        -1595.194580078125,
        -3759.91455078125,
        1070.63134765625
      ],
      [
        -1595.540283203125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1595.540283203125,
        -3759.93994140625,
        1070.3270263671875
      ],
      [
        -1544.1060791015625,
        -3758.775634765625,
        1084.3175048828125
      ],
      [
        -1554.3839111328125,
        -3759.145263671875,
        1079.877197265625
      ],
      [
        -1554.3839111328125,
        -3759.145263671875,
        1079.877197265625
      ],
      [
        -1577.906982421875,
        -3759.398193359375,
        1076.835693359375
      ],
      [
        -1592.896484375,
        -3758.739013671875,
        1084.7596435546875
      ],
      [
        -1577.906982421875,
        -3759.398193359375,
        1076.835693359375
      ],
      [
        -1544.1060791015625,
        -3758.775634765625,
        1084.3175048828125
      ],
      [
        -1536.5213623046875,
        -3757.489990234375,
        1099.7703857421875
      ],
      [
        -1460.340087890625,
        -3835.49853515625,
        1110.625
      ],
      [
        -1460.340087890625,
        -3835.49853515625,
        1110.625
      ],
      [
        -1581.5548095703125,
        -3752.29248046875,
        1110.625
      ],
      [
        -1479.7960205078125,
        -3752.29248046875,
        1110.625
      ],
      [
        -1449.3182373046875,
        -3744.62451171875,
        1110.625
      ],
      [
        -1453.8978271484375,
        -3752.292236328125,
        1110.625
      ],
      [
        -1456.3963623046875,
        -3756.729736328125,
        1108.909912109375
      ],
      [
        -1604.29931640625,
        -3759.485107421875,
        1073.171630859375
      ],
      [
        -1598.0562744140625,
        -3758.7939453125,
        1073.18310546875
      ],
      [
        -1607.1190185546875,
        -3757.96240234375,
        1070.826416015625
      ],
      [
        -1604.29931640625,
        -3759.485107421875,
        1073.171630859375
      ],
      [
        -1594.7999267578125,
        -3756.324951171875,
        1070.5006103515625
      ],
      [
        -1595.092529296875,
        -3756.55126953125,
        1070.7471923828125
      ],
      [
        -1598.0562744140625,
        -3758.7939453125,
        1073.18310546875
      ],
      [
        -1595.092529296875,
        -3756.55126953125,
        1070.7471923828125
      ],
      [
        -1607.438720703125,
        -3757.784423828125,
        1070.5538330078125
      ],
      [
        -1607.1190185546875,
        -3757.96240234375,
        1070.826416015625
      ],
      [
        -1607.438720703125,
        -3757.784423828125,
        1070.5538330078125
      ],
      [
        -1607.1766357421875,
        -3757.5458984375,
        1070.2872314453125
      ],
      [
        -1604.531005859375,
        -3755.20166015625,
        1067.67626953125
      ],
      [
        -1607.1766357421875,
        -3757.5458984375,
        1070.2872314453125
      ],
      [
        -1597.8450927734375,
        -3754.395263671875,
        1067.6041259765625
      ],
      [
        -1604.531005859375,
        -3755.20166015625,
        1067.67626953125
      ],
      [
        -1594.7999267578125,
        -3756.324951171875,
        1070.5006103515625
      ],
      [
        -1595.041748046875,
        -3756.166748046875,
        1070.2642822265625
      ],
      [
        -1595.041748046875,
        -3756.166748046875,
        1070.2642822265625
      ],
      [
        -1597.8450927734375,
        -3754.395263671875,
        1067.6041259765625
      ],
      [
        -1546.929443359375,
        -3707.0,
        1045.543212890625
      ],
      [
        -1447.804931640625,
        -3753.885498046875,
        1110.625
      ],
      [
        -1479.7960205078125,
        -3752.29248046875,
        1110.625
      ],
      [
        -1454.64599609375,
        -3753.544921875,
        1110.625
      ],
      [
        -1455.7398681640625,
        -3755.56396484375,
        1109.3604736328125
      ],
      [
        -1581.5548095703125,
        -3752.29248046875,
        1110.625
      ],
      [
        -1609.713134765625,
        -3753.885498046875,
        1110.625
      ],
      [
        -1609.713134765625,
        -3753.885498046875,
        1110.625
      ],
      [
        -1447.804931640625,
        -3753.885498046875,
        1110.625
      ],
      [
        -1543.538818359375,
        -3628.58544921875,
        1056.9000244140625
      ],
      [
        -1565.1087646484375,
        -3656.235107421875,
        1017.518310546875
      ],
      [
        -1565.3463134765625,
        -3656.23291015625,
        1015.0
      ],
      [
        -1565.1087646484375,
        -3656.235107421875,
        1017.518310546875
      ],
      [
        -1563.512939453125,
        -3656.249755859375,
        1034.434814453125
      ],
      [
        -1562.04296875,
        -3656.262939453125,
        1050.0169677734375
      ],
      [
        -1563.512939453125,
        -3656.249755859375,
        1034.434814453125
      ],
      [
        -1562.0634765625,
        -3656.2626953125,
        1056.9000244140625
      ],
      [
        -1562.04296875,
        -3656.262939453125,
        1050.0169677734375
      ],
      [
        -1526.4534912109375,
        -3656.586181640625,
        1051.3134765625
      ],
      [
        -1524.7435302734375,
        -3656.601806640625,
        1018.1234130859375
      ],
      [
        -1524.7430419921875,
        -3656.601806640625,
        1015.0
      ],
      [
        -1524.7435302734375,
        -3656.601806640625,
        1018.1234130859375
      ],
      [
        -1527.4554443359375,
        -3656.576904296875,
        1056.9000244140625
      ],
      [
        -1526.4534912109375,
        -3656.586181640625,
        1051.3134765625
      ],
      [
        -1564.83154296875,
        -3656.237548828125,
        1020.4552612304688
      ],
      [
        -1543.7548828125,
        -3659.956787109375,
        1020.4677124023438
      ],
      [
        -1524.7435302734375,
        -3656.601806640625,
        1020.4564208984375
      ],
      [
        -1562.4635009765625,
        -3656.25927734375,
        1045.5595703125
      ],
      [
        -1536.4945068359375,
        -3658.675537109375,
        1051.0069580078125
      ],
      [
        -1526.78662109375,
        -3656.5830078125,
        1053.1710205078125
      ],
      [
        -1536.4945068359375,
        -3658.675537109375,
        1051.0069580078125
      ],
      [
        -1525.9190673828125,
        -3656.591064453125,
        1045.52392578125
      ],
      [
        -1547.21142578125,
        -3666.491943359375,
        1048.3834228515625
      ],
      [
        -1620.99072265625,
        -3810.502685546875,
        1110.625
      ],
      [
        -1533.9212646484375,
        -3856.473876953125,
        1133.25
      ],
      [
        -1533.9639892578125,
        -3856.542236328125,
        1132.890380859375
      ],
      [
        -1533.15771484375,
        -3855.1953125,
        1133.25
      ],
      [
        -1453.8978271484375,
        -3752.292236328125,
        1110.625
      ],
      [
        -1449.8126220703125,
        -3745.03662109375,
        1113.42919921875
      ],
      [
        -1463.529296875,
        -3712.333740234375,
        1133.25
      ],
      [
        -1454.6458740234375,
        -3753.544677734375,
        1110.625
      ],
      [
        -1450.2200927734375,
        -3745.376220703125,
        1115.740478515625
      ],
      [
        -1462.6937255859375,
        -3856.847412109375,
        1133.25
      ],
      [
        -1469.384033203125,
        -3845.585693359375,
        1125.4664306640625
      ],
      [
        -1468.2391357421875,
        -3847.53369140625,
        1129.5120849609375
      ],
      [
        -1465.2796630859375,
        -3852.517578125,
        1133.25
      ],
      [
        -1469.384033203125,
        -3845.585693359375,
        1125.4664306640625
      ],
      [
        -1460.821044921875,
        -3836.3037109375,
        1110.625
      ],
      [
        -1456.0076904296875,
        -3835.49853515625,
        1110.625
      ],
      [
        -1445.6005859375,
        -3835.081787109375,
        1113.1287841796875
      ],
      [
        -1513.6004638671875,
        -3847.4033203125,
        1114.9178466796875
      ],
      [
        -1505.02294921875,
        -3858.236572265625,
        1123.9818115234375
      ],
      [
        -1513.3775634765625,
        -3847.6025390625,
        1115.3648681640625
      ],
      [
        -1505.02294921875,
        -3858.236572265625,
        1123.9818115234375
      ],
      [
        -1509.6629638671875,
        -3866.031494140625,
        1126.9151611328125
      ],
      [
        -1536.070556640625,
        -3859.912841796875,
        1115.1688232421875
      ],
      [
        -1529.0948486328125,
        -3848.1943359375,
        1110.7586669921875
      ],
      [
        -1529.0948486328125,
        -3848.1943359375,
        1110.7586669921875
      ],
      [
        -1513.6004638671875,
        -3847.4033203125,
        1114.9178466796875
      ],
      [
        -1518.26708984375,
        -3847.60986328125,
        1113.832275390625
      ],
      [
        -1516.606201171875,
        -3857.6015625,
        1133.25
      ],
      [
        -1534.60546875,
        -3857.568603515625,
        1127.494384765625
      ],
      [
        -1529.0269775390625,
        -3848.085693359375,
        1111.329345703125
      ],
      [
        -1507.1015625,
        -3861.728515625,
        1125.2958984375
      ],
      [
        -1510.0394287109375,
        -3866.7177734375,
        1133.25
      ],
      [
        -1507.5965576171875,
        -3862.627685546875,
        1133.25
      ],
      [
        -1529.0269775390625,
        -3848.085693359375,
        1111.329345703125
      ],
      [
        -1527.74658203125,
        -3848.12158203125,
        1111.141357421875
      ],
      [
        -1528.0047607421875,
        -3848.04052734375,
        1111.567138671875
      ],
      [
        -1503.9212646484375,
        -3856.473876953125,
        1133.25
      ],
      [
        -1504.4610595703125,
        -3855.570068359375,
        1133.25
      ],
      [
        -1503.9212646484375,
        -3856.473876953125,
        1133.25
      ],
      [
        -1467.1812744140625,
        -3849.333740234375,
        1133.25
      ],
      [
        -1528.835693359375,
        -3847.779541015625,
        1112.938720703125
      ],
      [
        -1530.0994873046875,
        -3850.074951171875,
        1133.25
      ],
      [
        -1528.835693359375,
        -3847.779541015625,
        1112.938720703125
      ],
      [
        -1528.0048828125,
        -3848.04052734375,
        1111.567138671875
      ],
      [
        -1528.78076171875,
        -3847.691650390625,
        1113.4010009765625
      ],
      [
        -1529.1265869140625,
        -3848.446044921875,
        1133.25
      ],
      [
        -1509.1146240234375,
        -3851.411865234375,
        1123.915771484375
      ],
      [
        -1506.450439453125,
        -3852.2392578125,
        1133.25
      ],
      [
        -1528.78076171875,
        -3847.691650390625,
        1113.4010009765625
      ],
      [
        -1526.674560546875,
        -3847.981689453125,
        1111.8765869140625
      ],
      [
        -1446.8209228515625,
        -3809.557373046875,
        1131.0
      ],
      [
        -1441.818359375,
        -3784.442626953125,
        1131.0
      ],
      [
        -1446.8209228515625,
        -3809.557373046875,
        1131.0
      ],
      [
        -1434.0576171875,
        -3809.557373046875,
        1116.125
      ],
      [
        -1441.818359375,
        -3784.442626953125,
        1131.0
      ],
      [
        -1434.6949462890625,
        -3784.442626953125,
        1122.697998046875
      ],
      [
        -1430.3297119140625,
        -3761.226318359375,
        1123.0
      ],
      [
        -1429.66455078125,
        -3757.88720703125,
        1123.0
      ],
      [
        -1446.9036865234375,
        -3832.996826171875,
        1125.6549072265625
      ],
      [
        -1447.459716796875,
        -3832.107177734375,
        1131.0
      ],
      [
        -1451.312744140625,
        -3832.107177734375,
        1131.0
      ],
      [
        -1447.6937255859375,
        -3831.732666015625,
        1133.25
      ],
      [
        -1453.168701171875,
        -3831.732666015625,
        1133.25
      ],
      [
        -1444.7720947265625,
        -3771.557373046875,
        1123.0
      ],
      [
        -1444.8966064453125,
        -3771.322021484375,
        1123.0
      ],
      [
        -1449.8524169921875,
        -3746.442626953125,
        1123.0
      ],
      [
        -1444.7720947265625,
        -3771.557373046875,
        1123.0
      ],
      [
        -1440.941162109375,
        -3769.7392578125,
        1110.625
      ],
      [
        -1433.6451416015625,
        -3784.442626953125,
        1111.8719482421875
      ],
      [
        -1434.9541015625,
        -3784.442626953125,
        1123.0
      ],
      [
        -1437.954833984375,
        -3784.442626953125,
        1123.0
      ],
      [
        -1440.4237060546875,
        -3784.442626953125,
        1129.3746337890625
      ],
      [
        -1442.648193359375,
        -3784.442626953125,
        1131.0
      ],
      [
        -1441.71826171875,
        -3784.442626953125,
        1110.625
      ],
      [
        -1436.4078369140625,
        -3811.1025390625,
        1110.625
      ],
      [
        -1436.344970703125,
        -3813.100341796875,
        1117.9683837890625
      ],
      [
        -1434.28955078125,
        -3809.557373046875,
        1116.3953857421875
      ],
      [
        -1435.381591796875,
        -3809.557373046875,
        1110.625
      ],
      [
        -1437.130126953125,
        -3809.557373046875,
        1119.705810546875
      ],
      [
        -1436.715576171875,
        -3809.557373046875,
        1110.625
      ],
      [
        -1442.648193359375,
        -3784.442626953125,
        1131.0
      ],
      [
        -1442.2332763671875,
        -3786.525634765625,
        1131.0
      ],
      [
        -1444.8497314453125,
        -3771.557373046875,
        1123.0
      ],
      [
        -1444.64697265625,
        -3769.7392578125,
        1110.625
      ],
      [
        -1444.8497314453125,
        -3771.557373046875,
        1123.0
      ],
      [
        -1452.3480224609375,
        -3835.35205078125,
        1111.5054931640625
      ],
      [
        -1447.7857666015625,
        -3832.81884765625,
        1126.7242431640625
      ],
      [
        -1470.1937255859375,
        -3844.2900390625,
        1133.25
      ],
      [
        -1462.6937255859375,
        -3831.732666015625,
        1133.25
      ],
      [
        -1462.6937255859375,
        -3831.732666015625,
        1133.25
      ],
      [
        -1470.1937255859375,
        -3844.2900390625,
        1133.25
      ],
      [
        -1526.4212646484375,
        -3843.91650390625,
        1133.25
      ],
      [
        -1511.4212646484375,
        -3843.91650390625,
        1133.25
      ],
      [
        -1526.4212646484375,
        -3843.91650390625,
        1133.25
      ],
      [
        -1511.4212646484375,
        -3843.91650390625,
        1133.25
      ],
      [
        -1546.5,
        -3835.8642578125,
        1147.4215087890625
      ],
      [
        -1545.8729248046875,
        -3832.9169921875,
        1147.5645751953125
      ],
      [
        -1545.8729248046875,
        -3832.9169921875,
        1147.5645751953125
      ],
      [
        -1546.5,
        -3831.80029296875,
        1146.477783203125
      ],
      [
        -1457.25634765625,
        -3855.557373046875,
        1141.0
      ],
      [
        -1452.8363037109375,
        -3830.442626953125,
        1141.0
      ],
      [
        -1452.8363037109375,
        -3830.442626953125,
        1141.0
      ],
      [
        -1453.1728515625,
        -3831.064208984375,
        1137.26611328125
      ],
      [
        -1453.1688232421875,
        -3831.732666015625,
        1133.25
      ],
      [
        -1453.5347900390625,
        -3831.732666015625,
        1133.25
      ],
      [
        -1527.4764404296875,
        -3839.905517578125,
        1146.6607666015625
      ],
      [
        -1527.1346435546875,
        -3842.470458984375,
        1149.0
      ],
      [
        -1525.638671875,
        -3841.873779296875,
        1149.0
      ],
      [
        -1528.851806640625,
        -3833.647216796875,
        1146.2310791015625
      ],
      [
        -1527.4764404296875,
        -3839.905517578125,
        1146.6607666015625
      ],
      [
        -1527.6142578125,
        -3831.090576171875,
        1148.8779296875
      ],
      [
        -1528.851806640625,
        -3833.647216796875,
        1146.2310791015625
      ],
      [
        -1528.2584228515625,
        -3842.90966796875,
        1149.0
      ],
      [
        -1527.1346435546875,
        -3842.470458984375,
        1149.0
      ],
      [
        -1528.2584228515625,
        -3830.69873046875,
        1149.0
      ],
      [
        -1527.6142578125,
        -3831.090576171875,
        1148.8779296875
      ],
      [
        -1527.5565185546875,
        -3830.976318359375,
        1149.0
      ],
      [
        -1528.2584228515625,
        -3830.69873046875,
        1149.0
      ],
      [
        -1529.2587890625,
        -3830.91015625,
        1149.0
      ],
      [
        -1528.2584228515625,
        -3842.90966796875,
        1149.0
      ],
      [
        -1529.2587890625,
        -3842.693115234375,
        1149.0
      ],
      [
        -1529.2587890625,
        -3842.693115234375,
        1149.0
      ],
      [
        -1539.58154296875,
        -3840.36669921875,
        1149.0
      ],
      [
        -1539.58154296875,
        -3833.18701171875,
        1149.0
      ],
      [
        -1529.2587890625,
        -3830.91015625,
        1149.0
      ],
      [
        -1539.58154296875,
        -3840.36669921875,
        1149.0
      ],
      [
        -1539.58154296875,
        -3833.18701171875,
        1149.0
      ],
      [
        -1529.4696044921875,
        -3849.0888671875,
        1141.0
      ],
      [
        -1526.5196533203125,
        -3865.85009765625,
        1141.0
      ],
      [
        -1533.2952880859375,
        -3855.426025390625,
        1133.25
      ],
      [
        -1529.4696044921875,
        -3849.0888671875,
        1141.0
      ],
      [
        -1528.889892578125,
        -3848.118408203125,
        1141.0
      ],
      [
        -1525.017822265625,
        -3867.557373046875,
        1141.0
      ],
      [
        -1533.1578369140625,
        -3855.19580078125,
        1133.25
      ],
      [
        -1528.889892578125,
        -3848.118408203125,
        1141.0
      ],
      [
        -1529.0362548828125,
        -3848.361083984375,
        1140.734130859375
      ],
      [
        -1528.8355712890625,
        -3848.39111328125,
        1141.0
      ],
      [
        -1528.99853515625,
        -3848.30029296875,
        1141.0
      ],
      [
        -1529.674560546875,
        -3847.923095703125,
        1141.0
      ],
      [
        -1523.2906494140625,
        -3849.220703125,
        1148.34326171875
      ],
      [
        -1522.7664794921875,
        -3849.438232421875,
        1149.0
      ],
      [
        -1523.2908935546875,
        -3849.220703125,
        1148.3433837890625
      ],
      [
        -1527.6563720703125,
        -3833.698486328125,
        1146.6044921875
      ],
      [
        -1526.067138671875,
        -3839.851806640625,
        1147.1009521484375
      ],
      [
        -1527.1346435546875,
        -3831.14306640625,
        1149.0
      ],
      [
        -1527.1346435546875,
        -3831.14306640625,
        1149.0
      ],
      [
        -1527.6563720703125,
        -3833.698486328125,
        1146.6044921875
      ],
      [
        -1526.3472900390625,
        -3831.4609375,
        1149.0
      ],
      [
        -1526.067138671875,
        -3839.851806640625,
        1147.1009521484375
      ],
      [
        -1524.3736572265625,
        -3841.369384765625,
        1149.0
      ],
      [
        -1464.465087890625,
        -3853.94140625,
        1141.0
      ],
      [
        -1456.15625,
        -3849.306640625,
        1141.0
      ],
      [
        -1464.465087890625,
        -3853.94140625,
        1141.0
      ],
      [
        -1465.27978515625,
        -3852.517578125,
        1133.25
      ],
      [
        -1487.86669921875,
        -3697.221923828125,
        1149.0
      ],
      [
        -1488.1524658203125,
        -3696.99853515625,
        1148.13623046875
      ],
      [
        -1464.733642578125,
        -3853.49169921875,
        1141.0
      ],
      [
        -1455.9127197265625,
        -3847.9228515625,
        1141.0
      ],
      [
        -1464.733642578125,
        -3853.49169921875,
        1141.0
      ],
      [
        -1464.859619140625,
        -3853.251953125,
        1137.2469482421875
      ],
      [
        -1506.5999755859375,
        -3861.027587890625,
        1141.0
      ],
      [
        -1528.835693359375,
        -3848.390625,
        1141.0
      ],
      [
        -1509.7730712890625,
        -3859.024169921875,
        1141.0
      ],
      [
        -1530.0994873046875,
        -3850.0751953125,
        1133.25
      ],
      [
        -1529.0360107421875,
        -3848.36083984375,
        1140.734619140625
      ],
      [
        -1506.5999755859375,
        -3861.027587890625,
        1141.0
      ],
      [
        -1506.7301025390625,
        -3861.230712890625,
        1139.348388671875
      ],
      [
        -1507.596435546875,
        -3862.62744140625,
        1133.25
      ],
      [
        -1506.4954833984375,
        -3860.8525390625,
        1141.0
      ],
      [
        -1506.4954833984375,
        -3860.8525390625,
        1141.0
      ],
      [
        -1519.9874267578125,
        -3834.027587890625,
        1149.0
      ],
      [
        -1519.9874267578125,
        -3839.620361328125,
        1149.0
      ],
      [
        -1519.9874267578125,
        -3834.027587890625,
        1149.0
      ],
      [
        -1519.9874267578125,
        -3839.620361328125,
        1149.0
      ],
      [
        -1534.019775390625,
        -3770.5986328125,
        1162.36669921875
      ],
      [
        -1541.5374755859375,
        -3787.66259765625,
        1165.875
      ],
      [
        -1534.019775390625,
        -3770.5986328125,
        1162.36669921875
      ],
      [
        -1445.980224609375,
        -3770.5986328125,
        1162.36669921875
      ],
      [
        -1438.4625244140625,
        -3787.66259765625,
        1165.875
      ],
      [
        -1445.980224609375,
        -3770.5986328125,
        1162.36669921875
      ],
      [
        -1440.54248046875,
        -3840.1865234375,
        1163.5377197265625
      ],
      [
        -1439.2154541015625,
        -3833.33447265625,
        1163.6678466796875
      ],
      [
        -1438.8203125,
        -3842.75390625,
        1165.875
      ],
      [
        -1428.5,
        -3841.96533203125,
        1165.875
      ],
      [
        -1440.54248046875,
        -3840.1865234375,
        1163.5377197265625
      ],
      [
        -1439.2154541015625,
        -3833.33447265625,
        1163.6678466796875
      ],
      [
        -1428.5,
        -3831.554443359375,
        1165.875
      ],
      [
        -1436.7451171875,
        -3830.963134765625,
        1165.875
      ],
      [
        -1437.5704345703125,
        -3818.08203125,
        1165.875
      ],
      [
        -1438.0919189453125,
        -3815.4951171875,
        1161.50048828125
      ],
      [
        -1541.907958984375,
        -3815.495361328125,
        1161.50048828125
      ],
      [
        -1542.4295654296875,
        -3818.082275390625,
        1165.875
      ],
      [
        -1541.907958984375,
        -3815.495361328125,
        1161.50048828125
      ],
      [
        -1528.3603515625,
        -3839.939453125,
        1151.5601806640625
      ],
      [
        -1529.276611328125,
        -3833.629150390625,
        1151.3511962890625
      ],
      [
        -1526.328125,
        -3842.385986328125,
        1149.8380126953125
      ],
      [
        -1528.3603515625,
        -3839.939453125,
        1151.5601806640625
      ],
      [
        -1529.276611328125,
        -3833.629150390625,
        1151.3511962890625
      ],
      [
        -1527.9027099609375,
        -3831.058837890625,
        1149.3876953125
      ],
      [
        -1526.04638671875,
        -3842.716796875,
        1149.5977783203125
      ],
      [
        -1526.328125,
        -3842.385986328125,
        1149.8380126953125
      ],
      [
        -1526.04638671875,
        -3842.716796875,
        1149.5977783203125
      ],
      [
        -1525.859375,
        -3842.3369140625,
        1149.32470703125
      ],
      [
        -1525.6387939453125,
        -3841.8740234375,
        1149.0
      ],
      [
        -1525.8592529296875,
        -3842.3369140625,
        1149.32470703125
      ],
      [
        -1527.7298583984375,
        -3830.747314453125,
        1149.142822265625
      ],
      [
        -1527.9027099609375,
        -3831.058837890625,
        1149.3876953125
      ],
      [
        -1527.7298583984375,
        -3830.747314453125,
        1149.142822265625
      ],
      [
        -1527.5567626953125,
        -3830.97607421875,
        1149.0
      ],
      [
        -1476.74609375,
        -3861.75732421875,
        1149.0
      ],
      [
        -1442.761962890625,
        -3830.531494140625,
        1165.875
      ],
      [
        -1442.761962890625,
        -3843.05517578125,
        1165.875
      ],
      [
        -1444.3201904296875,
        -3830.42724609375,
        1165.875
      ],
      [
        -1442.761962890625,
        -3830.531494140625,
        1165.875
      ],
      [
        -1444.3201904296875,
        -3830.42724609375,
        1165.875
      ],
      [
        -1446.2606201171875,
        -3830.90234375,
        1165.875
      ],
      [
        -1444.3201904296875,
        -3843.166748046875,
        1165.875
      ],
      [
        -1442.761962890625,
        -3843.05517578125,
        1165.875
      ],
      [
        -1444.3201904296875,
        -3843.166748046875,
        1165.875
      ],
      [
        -1446.2606201171875,
        -3842.70068359375,
        1165.875
      ],
      [
        -1446.2606201171875,
        -3830.90234375,
        1165.875
      ],
      [
        -1459.408447265625,
        -3834.171875,
        1165.875
      ],
      [
        -1459.408447265625,
        -3839.4921875,
        1165.875
      ],
      [
        -1446.2606201171875,
        -3842.70068359375,
        1165.875
      ],
      [
        -1459.408447265625,
        -3834.171875,
        1165.875
      ],
      [
        -1459.408447265625,
        -3839.4921875,
        1165.875
      ],
      [
        -1498.6732177734375,
        -3838.585693359375,
        1158.3336181640625
      ],
      [
        -1502.481689453125,
        -3837.882568359375,
        1157.464599609375
      ],
      [
        -1502.4818115234375,
        -3835.98388671875,
        1157.4644775390625
      ],
      [
        -1498.669677734375,
        -3835.261962890625,
        1158.334228515625
      ],
      [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      [
        -1447.4122314453125,
        -3841.435546875,
        1164.16455078125
      ],
      [
        -1447.274658203125,
        -3839.93896484375,
        1162.8775634765625
      ],
      [
        -1444.6610107421875,
        -3833.56005859375,
        1163.1339111328125
      ],
      [
        -1447.4122314453125,
        -3841.435546875,
        1164.16455078125
      ],
      [
        -1450.282958984375,
        -3841.71875,
        1165.875
      ],
      [
        -1451.309814453125,
        -3842.201416015625,
        1165.240234375
      ],
      [
        -1451.9815673828125,
        -3842.52099609375,
        1164.8121337890625
      ],
      [
        -1450.765869140625,
        -3842.23388671875,
        1164.634033203125
      ],
      [
        -1450.3138427734375,
        -3841.7275390625,
        1165.875
      ],
      [
        -1497.6715087890625,
        -3838.770751953125,
        1158.5621337890625
      ],
      [
        -1459.239013671875,
        -3844.234375,
        1165.875
      ],
      [
        -1494.2645263671875,
        -3839.025390625,
        1159.0062255859375
      ],
      [
        -1497.6717529296875,
        -3838.7705078125,
        1158.56201171875
      ],
      [
        -1494.2645263671875,
        -3839.025390625,
        1159.0062255859375
      ],
      [
        -1459.62890625,
        -3844.343994140625,
        1165.875
      ],
      [
        -1488.5885009765625,
        -3839.450927734375,
        1159.7210693359375
      ],
      [
        -1494.35888671875,
        -3839.035400390625,
        1158.979248046875
      ],
      [
        -1497.8306884765625,
        -3838.77685546875,
        1158.5257568359375
      ],
      [
        -1502.481689453125,
        -3837.90673828125,
        1157.464599609375
      ],
      [
        -1494.35888671875,
        -3839.035400390625,
        1158.979248046875
      ],
      [
        -1497.8302001953125,
        -3838.776611328125,
        1158.52587890625
      ],
      [
        -1488.5885009765625,
        -3839.450927734375,
        1159.7210693359375
      ],
      [
        -1530.4853515625,
        -3843.231201171875,
        1160.2225341796875
      ],
      [
        -1540.0792236328125,
        -3824.02392578125,
        1165.875
      ],
      [
        -1531.0284423828125,
        -3837.039794921875,
        1154.82470703125
      ],
      [
        -1497.2933349609375,
        -3835.00146484375,
        1158.6483154296875
      ],
      [
        -1497.2933349609375,
        -3835.00146484375,
        1158.6483154296875
      ],
      [
        -1494.11376953125,
        -3834.76318359375,
        1159.04931640625
      ],
      [
        -1494.11376953125,
        -3834.76318359375,
        1159.04931640625
      ],
      [
        -1540.27197265625,
        -3823.53662109375,
        1165.875
      ],
      [
        -1531.031982421875,
        -3836.999267578125,
        1154.7894287109375
      ],
      [
        -1488.5865478515625,
        -3834.34912109375,
        1159.7215576171875
      ],
      [
        -1494.207763671875,
        -3834.7529296875,
        1159.0224609375
      ],
      [
        -1502.4818115234375,
        -3835.95849609375,
        1157.4644775390625
      ],
      [
        -1497.453125,
        -3834.99462890625,
        1158.61181640625
      ],
      [
        -1497.453125,
        -3834.99462890625,
        1158.61181640625
      ],
      [
        -1494.207763671875,
        -3834.7529296875,
        1159.0224609375
      ],
      [
        -1488.5865478515625,
        -3834.34912109375,
        1159.7215576171875
      ],
      [
        -1448.14404296875,
        -3842.060546875,
        1162.7923583984375
      ],
      [
        -1477.7608642578125,
        -3851.267578125,
        1159.888427734375
      ],
      [
        -1484.7591552734375,
        -3856.38720703125,
        1159.2022705078125
      ],
      [
        -1477.7608642578125,
        -3851.267578125,
        1159.888427734375
      ],
      [
        -1527.6959228515625,
        -3845.614013671875,
        1154.9923095703125
      ],
      [
        -1530.936279296875,
        -3837.138671875,
        1154.674560546875
      ],
      [
        -1493.7813720703125,
        -3839.903564453125,
        1158.317626953125
      ],
      [
        -1498.1817626953125,
        -3839.43603515625,
        1157.8861083984375
      ],
      [
        -1498.1817626953125,
        -3839.43603515625,
        1157.8861083984375
      ],
      [
        -1502.4815673828125,
        -3838.953857421875,
        1157.464599609375
      ],
      [
        -1493.7813720703125,
        -3839.903564453125,
        1158.317626953125
      ],
      [
        -1502.4815673828125,
        -3838.953857421875,
        1157.464599609375
      ],
      [
        -1448.14404296875,
        -3842.060546875,
        1162.7923583984375
      ],
      [
        -1532.2261962890625,
        -3833.7646484375,
        1154.548095703125
      ],
      [
        -1437.8172607421875,
        -3816.85791015625,
        1163.804931640625
      ],
      [
        -1493.7813720703125,
        -3833.87109375,
        1158.317626953125
      ],
      [
        -1498.181640625,
        -3834.317138671875,
        1157.88623046875
      ],
      [
        -1502.4818115234375,
        -3834.77880859375,
        1157.4644775390625
      ],
      [
        -1498.181640625,
        -3834.317138671875,
        1157.88623046875
      ],
      [
        -1493.7813720703125,
        -3833.87109375,
        1158.317626953125
      ],
      [
        -1502.48193359375,
        -3834.77880859375,
        1157.4644775390625
      ],
      [
        -1530.7938232421875,
        -3836.467529296875,
        1153.51953125
      ],
      [
        -1529.8492431640625,
        -3838.25,
        1152.8411865234375
      ],
      [
        -1530.7589111328125,
        -3836.88134765625,
        1153.88427734375
      ],
      [
        -1530.8150634765625,
        -3836.796875,
        1153.94873046875
      ],
      [
        -1530.847900390625,
        -3836.365478515625,
        1153.558349609375
      ],
      [
        -1526.5599365234375,
        -3846.584228515625,
        1152.8623046875
      ],
      [
        -1530.75244140625,
        -3837.619140625,
        1154.692626953125
      ],
      [
        -1526.738037109375,
        -3844.12060546875,
        1150.6070556640625
      ],
      [
        -1456.2547607421875,
        -3844.58203125,
        1161.9970703125
      ],
      [
        -1465.8450927734375,
        -3849.702392578125,
        1154.06005859375
      ],
      [
        -1466.3419189453125,
        -3855.188720703125,
        1149.0
      ],
      [
        -1465.84521484375,
        -3849.70263671875,
        1154.0601806640625
      ],
      [
        -1540.041259765625,
        -3779.426025390625,
        1209.0
      ],
      [
        -1565.0,
        -3805.62060546875,
        1209.0
      ],
      [
        -1565.0,
        -3823.37939453125,
        1209.0
      ],
      [
        -1561.0430908203125,
        -3830.406494140625,
        1209.0
      ],
      [
        -1561.0865478515625,
        -3830.329345703125,
        1210.5
      ],
      [
        -1565.0,
        -3823.37939453125,
        1210.5
      ],
      [
        -1565.0,
        -3805.62060546875,
        1210.5
      ],
      [
        -1540.1165771484375,
        -3779.426025390625,
        1210.5
      ],
      [
        -1540.1165771484375,
        -3779.426025390625,
        1210.5
      ],
      [
        -1540.041259765625,
        -3779.426025390625,
        1209.0
      ],
      [
        -1550.283447265625,
        -3806.913330078125,
        1187.4580078125
      ],
      [
        -1550.2218017578125,
        -3806.76513671875,
        1187.4453125
      ],
      [
        -1550.2218017578125,
        -3806.76513671875,
        1187.4453125
      ],
      [
        -1544.0133056640625,
        -3791.816650390625,
        1186.4454345703125
      ],
      [
        -1550.3851318359375,
        -3806.914306640625,
        1189.4749755859375
      ],
      [
        -1550.31689453125,
        -3806.75048828125,
        1189.4608154296875
      ],
      [
        -1550.31689453125,
        -3806.75048828125,
        1189.4608154296875
      ],
      [
        -1543.6331787109375,
        -3790.6572265625,
        1188.384033203125
      ],
      [
        -1550.283447265625,
        -3806.913330078125,
        1187.4580078125
      ],
      [
        -1550.3851318359375,
        -3806.914306640625,
        1189.4749755859375
      ],
      [
        -1540.0250244140625,
        -3779.426025390625,
        1209.0
      ],
      [
        -1560.542724609375,
        -3831.294921875,
        1209.0
      ],
      [
        -1560.5784912109375,
        -3831.231689453125,
        1210.5
      ],
      [
        -1540.0858154296875,
        -3779.426025390625,
        1210.5
      ],
      [
        -1554.5128173828125,
        -3814.372314453125,
        1210.5
      ],
      [
        -1554.2939453125,
        -3814.023681640625,
        1209.0
      ],
      [
        -1554.00244140625,
        -3814.7607421875,
        1209.0
      ],
      [
        -1554.211181640625,
        -3815.135009765625,
        1210.5
      ],
      [
        -1540.0858154296875,
        -3779.426025390625,
        1210.5
      ],
      [
        -1540.0250244140625,
        -3779.426025390625,
        1209.0
      ],
      [
        -1554.301513671875,
        -3815.296875,
        1211.1488037109375
      ],
      [
        -1554.4310302734375,
        -3815.5244140625,
        1212.125
      ],
      [
        -1554.301513671875,
        -3815.296875,
        1211.1488037109375
      ],
      [
        -1549.3243408203125,
        -3805.154541015625,
        1187.3099365234375
      ],
      [
        -1549.363037109375,
        -3805.047119140625,
        1189.317138671875
      ],
      [
        -1550.061767578125,
        -3807.002685546875,
        1187.469482421875
      ],
      [
        -1550.1446533203125,
        -3807.010009765625,
        1189.4443359375
      ],
      [
        -1550.061767578125,
        -3807.002685546875,
        1187.469482421875
      ],
      [
        -1549.3243408203125,
        -3805.154541015625,
        1187.3099365234375
      ],
      [
        -1550.146484375,
        -3807.01025390625,
        1189.4873046875
      ],
      [
        -1549.363037109375,
        -3805.047119140625,
        1189.317138671875
      ],
      [
        -1550.146484375,
        -3807.01025390625,
        1189.4873046875
      ],
      [
        -1559.1199951171875,
        -3840.385498046875,
        1190.0
      ],
      [
        -1490.9088134765625,
        -3859.54541015625,
        1190.0
      ],
      [
        -1491.1182861328125,
        -3859.917236328125,
        1191.5
      ],
      [
        -1559.329345703125,
        -3840.75732421875,
        1191.5
      ],
      [
        -1536.564697265625,
        -3847.443359375,
        1191.5
      ],
      [
        -1536.38525390625,
        -3847.046142578125,
        1190.0
      ],
      [
        -1511.7874755859375,
        -3853.680419921875,
        1190.0
      ],
      [
        -1510.4375,
        -3854.490234375,
        1191.5
      ],
      [
        -1491.1182861328125,
        -3859.917236328125,
        1191.5
      ],
      [
        -1490.9088134765625,
        -3859.54541015625,
        1190.0
      ],
      [
        -1559.596435546875,
        -3841.231689453125,
        1191.5
      ],
      [
        -1559.3785400390625,
        -3840.844482421875,
        1190.0
      ],
      [
        -1559.329345703125,
        -3840.75732421875,
        1191.5
      ],
      [
        -1559.1199951171875,
        -3840.385498046875,
        1190.0
      ],
      [
        -1536.38525390625,
        -3847.046142578125,
        1190.0
      ],
      [
        -1536.564697265625,
        -3847.443359375,
        1191.5
      ],
      [
        -1536.7005615234375,
        -3847.11328125,
        1191.5
      ],
      [
        -1536.51318359375,
        -3846.7353515625,
        1190.0
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1550.6630859375,
        -3848.84033203125,
        1209.0
      ],
      [
        -1547.942626953125,
        -3849.573974609375,
        1209.0
      ],
      [
        -1549.5955810546875,
        -3849.573974609375,
        1210.5
      ],
      [
        -1547.942626953125,
        -3849.573974609375,
        1209.0
      ],
      [
        -1549.595703125,
        -3849.573974609375,
        1210.5
      ],
      [
        -1550.3670654296875,
        -3849.365966796875,
        1210.5
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1539.276611328125,
        -3852.310546875,
        1212.125
      ],
      [
        -1551.0811767578125,
        -3848.097900390625,
        1209.0
      ],
      [
        -1545.8262939453125,
        -3849.573974609375,
        1209.0
      ],
      [
        -1547.358642578125,
        -3849.573974609375,
        1210.5
      ],
      [
        -1550.793212890625,
        -3848.609130859375,
        1210.5
      ],
      [
        -1547.3594970703125,
        -3849.573974609375,
        1210.5
      ],
      [
        -1545.8262939453125,
        -3849.573974609375,
        1209.0
      ],
      [
        -1481.070068359375,
        -3858.573974609375,
        1196.5
      ],
      [
        -1434.708984375,
        -3846.06982421875,
        1196.5
      ],
      [
        -1434.9725341796875,
        -3846.5380859375,
        1198.0
      ],
      [
        -1479.59814453125,
        -3858.573974609375,
        1198.0
      ],
      [
        -1479.59814453125,
        -3858.573974609375,
        1198.0
      ],
      [
        -1481.070068359375,
        -3858.573974609375,
        1196.5
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1212.125
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1212.125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1212.125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1212.125
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1212.125
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1212.125
      ],
      [
        -1439.5968017578125,
        -3840.221435546875,
        1169.43017578125
      ],
      [
        -1449.419921875,
        -3841.9296875,
        1165.875
      ],
      [
        -1428.5,
        -3837.755615234375,
        1171.4215087890625
      ],
      [
        -1439.5968017578125,
        -3840.221435546875,
        1169.43017578125
      ],
      [
        -1490.88330078125,
        -3859.500244140625,
        1190.0
      ],
      [
        -1491.0072021484375,
        -3859.719970703125,
        1190.7044677734375
      ],
      [
        -1490.978515625,
        -3859.52587890625,
        1190.0
      ],
      [
        -1490.88330078125,
        -3859.500244140625,
        1190.0
      ],
      [
        -1522.4468994140625,
        -3754.103515625,
        1204.5
      ],
      [
        -1468.3348388671875,
        -3768.6982421875,
        1204.5
      ],
      [
        -1468.5341796875,
        -3768.34423828125,
        1203.0
      ],
      [
        -1522.3001708984375,
        -3753.8427734375,
        1203.0
      ],
      [
        -1468.3348388671875,
        -3768.6982421875,
        1204.5
      ],
      [
        -1468.5341796875,
        -3768.34423828125,
        1203.0
      ],
      [
        -1522.4468994140625,
        -3754.103515625,
        1204.5
      ],
      [
        -1522.3001708984375,
        -3753.8427734375,
        1203.0
      ],
      [
        -1536.51318359375,
        -3846.7353515625,
        1190.0
      ],
      [
        -1536.7005615234375,
        -3847.11328125,
        1191.5
      ],
      [
        -1545.273681640625,
        -3826.302734375,
        1191.5
      ],
      [
        -1544.58447265625,
        -3827.142822265625,
        1190.0
      ],
      [
        -1544.58447265625,
        -3827.142822265625,
        1190.0
      ],
      [
        -1545.273681640625,
        -3826.302734375,
        1191.5
      ],
      [
        -1547.7149658203125,
        -3820.131103515625,
        1191.5
      ],
      [
        -1547.50537109375,
        -3819.759033203125,
        1190.0
      ],
      [
        -1551.553955078125,
        -3810.426025390625,
        1191.5
      ],
      [
        -1551.197265625,
        -3810.426025390625,
        1190.0
      ],
      [
        -1536.3851318359375,
        -3772.168701171875,
        1190.0
      ],
      [
        -1536.5645751953125,
        -3772.46875,
        1191.5
      ],
      [
        -1525.76416015625,
        -3769.5556640625,
        1191.5
      ],
      [
        -1525.8870849609375,
        -3769.337158203125,
        1190.0
      ],
      [
        -1551.566650390625,
        -3810.39404296875,
        1191.5
      ],
      [
        -1551.35791015625,
        -3810.019775390625,
        1190.0
      ],
      [
        -1430.337890625,
        -3809.9560546875,
        1191.5
      ],
      [
        -1430.4351806640625,
        -3809.607421875,
        1190.0
      ],
      [
        -1438.6343994140625,
        -3789.704345703125,
        1190.0
      ],
      [
        -1439.046875,
        -3788.8154296875,
        1191.5
      ],
      [
        -1439.046875,
        -3788.8154296875,
        1191.5
      ],
      [
        -1438.6343994140625,
        -3789.704345703125,
        1190.0
      ],
      [
        -1445.57080078125,
        -3772.168701171875,
        1190.0
      ],
      [
        -1445.5130615234375,
        -3772.46875,
        1191.5
      ],
      [
        -1445.5130615234375,
        -3847.443359375,
        1191.5
      ],
      [
        -1445.57080078125,
        -3847.046142578125,
        1190.0
      ],
      [
        -1437.3717041015625,
        -3827.142822265625,
        1190.0
      ],
      [
        -1436.8040771484375,
        -3826.302734375,
        1191.5
      ],
      [
        -1491.038818359375,
        -3759.972900390625,
        1191.5
      ],
      [
        -1490.97802734375,
        -3759.689208984375,
        1190.0
      ],
      [
        -1511.7874755859375,
        -3765.534423828125,
        1190.0
      ],
      [
        -1510.4375,
        -3765.421875,
        1191.5
      ],
      [
        -1510.4375,
        -3765.421875,
        1191.5
      ],
      [
        -1511.7874755859375,
        -3765.534423828125,
        1190.0
      ],
      [
        -1464.9117431640625,
        -3852.892333984375,
        1191.5
      ],
      [
        -1466.38037109375,
        -3852.891357421875,
        1190.0
      ],
      [
        -1445.57080078125,
        -3847.046142578125,
        1190.0
      ],
      [
        -1445.5130615234375,
        -3847.443359375,
        1191.5
      ],
      [
        -1436.8040771484375,
        -3826.302734375,
        1191.5
      ],
      [
        -1437.37158203125,
        -3827.142822265625,
        1190.0
      ],
      [
        -1430.4351806640625,
        -3809.607421875,
        1190.0
      ],
      [
        -1430.337890625,
        -3809.9560546875,
        1191.5
      ],
      [
        -1428.5,
        -3837.12939453125,
        1171.4215087890625
      ],
      [
        -1441.5511474609375,
        -3840.1494140625,
        1169.0794677734375
      ],
      [
        -1441.5511474609375,
        -3840.1494140625,
        1169.0794677734375
      ],
      [
        -1450.283203125,
        -3841.718994140625,
        1165.875
      ],
      [
        -1490.563720703125,
        -3757.755859375,
        1179.781494140625
      ],
      [
        -1490.4820556640625,
        -3757.375,
        1177.7681884765625
      ],
      [
        -1518.1678466796875,
        -3766.06591796875,
        1182.9107666015625
      ],
      [
        -1517.109130859375,
        -3765.977783203125,
        1184.087158203125
      ],
      [
        -1535.93701171875,
        -3771.419189453125,
        1186.2525634765625
      ],
      [
        -1536.0440673828125,
        -3771.598388671875,
        1187.1480712890625
      ],
      [
        -1517.109130859375,
        -3765.977783203125,
        1184.087158203125
      ],
      [
        -1518.1678466796875,
        -3766.06591796875,
        1182.9107666015625
      ],
      [
        -1536.154296875,
        -3771.874755859375,
        1187.166015625
      ],
      [
        -1535.87255859375,
        -3771.789306640625,
        1187.1304931640625
      ],
      [
        -1538.1480712890625,
        -3776.882080078125,
        1187.49072265625
      ],
      [
        -1490.446533203125,
        -3762.3017578125,
        1176.8587646484375
      ],
      [
        -1490.4466552734375,
        -3762.30224609375,
        1176.8607177734375
      ],
      [
        -1490.4466552734375,
        -3762.30224609375,
        1176.8607177734375
      ],
      [
        -1482.8443603515625,
        -3760.507568359375,
        1178.315185546875
      ],
      [
        -1481.2139892578125,
        -3760.062255859375,
        1178.26708984375
      ],
      [
        -1482.8443603515625,
        -3760.507568359375,
        1178.315185546875
      ],
      [
        -1444.30810546875,
        -3773.2216796875,
        1169.159912109375
      ],
      [
        -1446.3173828125,
        -3768.291748046875,
        1170.61474609375
      ],
      [
        -1446.253662109375,
        -3768.622802734375,
        1172.2701416015625
      ],
      [
        -1444.2244873046875,
        -3773.6318359375,
        1171.097412109375
      ],
      [
        -1444.254638671875,
        -3773.46044921875,
        1170.2806396484375
      ],
      [
        -1449.6343994140625,
        -3771.953369140625,
        1170.01025390625
      ],
      [
        -1446.2408447265625,
        -3768.689208984375,
        1172.6021728515625
      ],
      [
        -1444.22265625,
        -3773.640869140625,
        1171.14013671875
      ],
      [
        -1444.1644287109375,
        -3773.88232421875,
        1172.26611328125
      ],
      [
        -1444.174072265625,
        -3773.879150390625,
        1172.265625
      ],
      [
        -1446.2010498046875,
        -3768.89599609375,
        1173.6365966796875
      ],
      [
        -1444.1187744140625,
        -3774.15087890625,
        1173.5479736328125
      ],
      [
        -1444.298095703125,
        -3773.24609375,
        1169.1527099609375
      ],
      [
        -1444.212890625,
        -3773.68896484375,
        1171.3662109375
      ],
      [
        -1444.2496337890625,
        -3773.472900390625,
        1170.27978515625
      ],
      [
        -1538.82763671875,
        -3778.793212890625,
        1185.6011962890625
      ],
      [
        -1548.7811279296875,
        -3816.53369140625,
        1190.0
      ],
      [
        -1550.3409423828125,
        -3812.590576171875,
        1190.0
      ],
      [
        -1551.322021484375,
        -3809.95556640625,
        1189.7425537109375
      ],
      [
        -1551.034912109375,
        -3809.44091796875,
        1187.6798095703125
      ],
      [
        -1548.5418701171875,
        -3816.1357421875,
        1188.33203125
      ],
      [
        -1550.3831787109375,
        -3808.2724609375,
        1182.9971923828125
      ],
      [
        -1547.54736328125,
        -3814.354248046875,
        1181.1893310546875
      ],
      [
        -1548.476806640625,
        -3816.027587890625,
        1187.878662109375
      ],
      [
        -1548.771484375,
        -3816.55810546875,
        1190.0
      ],
      [
        -1433.2503662109375,
        -3801.3056640625,
        1170.421875
      ],
      [
        -1432.6947021484375,
        -3802.503173828125,
        1168.401123046875
      ],
      [
        -1444.2547607421875,
        -3773.471435546875,
        1170.279541015625
      ],
      [
        -1444.199462890625,
        -3773.754638671875,
        1171.6761474609375
      ],
      [
        -1431.71630859375,
        -3805.016845703125,
        1170.2496337890625
      ],
      [
        -1431.8446044921875,
        -3804.556884765625,
        1168.270751953125
      ],
      [
        -1432.6947021484375,
        -3802.503173828125,
        1168.401123046875
      ],
      [
        -1433.2503662109375,
        -3801.3056640625,
        1170.421875
      ],
      [
        -1431.8446044921875,
        -3804.556884765625,
        1168.270751953125
      ],
      [
        -1431.71630859375,
        -3805.016845703125,
        1170.2496337890625
      ],
      [
        -1431.7457275390625,
        -3805.091064453125,
        1170.2493896484375
      ],
      [
        -1431.8607177734375,
        -3804.59765625,
        1168.2706298828125
      ],
      [
        -1431.860595703125,
        -3804.598388671875,
        1168.273193359375
      ],
      [
        -1431.876953125,
        -3804.556884765625,
        1168.2723388671875
      ],
      [
        -1434.2213134765625,
        -3811.341064453125,
        1170.2281494140625
      ],
      [
        -1434.349609375,
        -3810.88134765625,
        1168.25
      ],
      [
        -1434.32763671875,
        -3810.965576171875,
        1168.6728515625
      ],
      [
        -1432.6846923828125,
        -3802.524658203125,
        1168.36474609375
      ],
      [
        -1444.2774658203125,
        -3773.353271484375,
        1169.68896484375
      ],
      [
        -1432.6846923828125,
        -3802.524658203125,
        1168.36474609375
      ],
      [
        -1438.7030029296875,
        -3787.0546875,
        1165.875
      ],
      [
        -1443.995361328125,
        -3773.9892578125,
        1168.933349609375
      ],
      [
        -1431.8607177734375,
        -3804.59765625,
        1168.2706298828125
      ],
      [
        -1434.4901123046875,
        -3810.294921875,
        1165.875
      ],
      [
        -1434.375,
        -3810.79052734375,
        1167.8590087890625
      ],
      [
        -1434.503662109375,
        -3810.329345703125,
        1165.875
      ],
      [
        -1433.2686767578125,
        -3801.26611328125,
        1170.488525390625
      ],
      [
        -1444.174072265625,
        -3773.87939453125,
        1172.265625
      ],
      [
        -1433.2686767578125,
        -3801.26611328125,
        1170.488525390625
      ],
      [
        -1433.9915771484375,
        -3799.70849609375,
        1173.1171875
      ],
      [
        -1431.5377197265625,
        -3805.65673828125,
        1173.00244140625
      ],
      [
        -1433.9915771484375,
        -3799.70849609375,
        1173.1171875
      ],
      [
        -1431.5377197265625,
        -3805.65673828125,
        1173.00244140625
      ],
      [
        -1431.5850830078125,
        -3805.78125,
        1173.0147705078125
      ],
      [
        -1431.7457275390625,
        -3805.091064453125,
        1170.2493896484375
      ],
      [
        -1431.775390625,
        -3805.016845703125,
        1170.2529296875
      ],
      [
        -1431.74560546875,
        -3805.092529296875,
        1170.2545166015625
      ],
      [
        -1433.999755859375,
        -3812.134765625,
        1173.6431884765625
      ],
      [
        -1434.201416015625,
        -3811.419677734375,
        1170.65234375
      ],
      [
        -1445.5596923828125,
        -3839.26416015625,
        1168.360107421875
      ],
      [
        -1442.5020751953125,
        -3830.549560546875,
        1165.875
      ],
      [
        -1442.33935546875,
        -3830.248291015625,
        1166.1529541015625
      ],
      [
        -1443.2137451171875,
        -3833.50048828125,
        1168.7811279296875
      ],
      [
        -1446.44580078125,
        -3841.029296875,
        1167.2833251953125
      ],
      [
        -1445.5596923828125,
        -3839.26416015625,
        1168.360107421875
      ],
      [
        -1445.8671875,
        -3839.990966796875,
        1168.304931640625
      ],
      [
        -1442.2469482421875,
        -3829.904541015625,
        1165.875
      ],
      [
        -1446.41015625,
        -3841.27392578125,
        1168.2073974609375
      ],
      [
        -1446.080322265625,
        -3843.542236328125,
        1176.77099609375
      ],
      [
        -1444.23681640625,
        -3837.3056640625,
        1171.8563232421875
      ],
      [
        -1446.0279541015625,
        -3843.41015625,
        1176.757568359375
      ],
      [
        -1444.23681640625,
        -3837.3056640625,
        1171.8563232421875
      ],
      [
        -1442.70361328125,
        -3835.0361328125,
        1175.908203125
      ],
      [
        -1436.8616943359375,
        -3804.68603515625,
        1168.541748046875
      ],
      [
        -1436.8253173828125,
        -3804.595947265625,
        1168.5360107421875
      ],
      [
        -1444.046142578125,
        -3837.0234375,
        1172.3603515625
      ],
      [
        -1444.452392578125,
        -3838.040283203125,
        1172.4461669921875
      ],
      [
        -1442.7037353515625,
        -3835.0361328125,
        1175.908203125
      ],
      [
        -1535.875,
        -3845.44775390625,
        1184.8900146484375
      ],
      [
        -1542.5594482421875,
        -3829.611572265625,
        1185.5926513671875
      ],
      [
        -1542.5594482421875,
        -3829.611572265625,
        1185.5926513671875
      ],
      [
        -1548.240478515625,
        -3815.60205078125,
        1186.1778564453125
      ],
      [
        -1537.6319580078125,
        -3835.618896484375,
        1174.8680419921875
      ],
      [
        -1534.3681640625,
        -3842.40771484375,
        1172.8260498046875
      ],
      [
        -1537.6319580078125,
        -3835.618896484375,
        1174.8680419921875
      ],
      [
        -1439.7718505859375,
        -3784.3525390625,
        1165.875
      ],
      [
        -1518.6802978515625,
        -3766.108642578125,
        1182.34130859375
      ],
      [
        -1535.8001708984375,
        -3771.1904296875,
        1185.1083984375
      ],
      [
        -1518.6802978515625,
        -3766.108642578125,
        1182.34130859375
      ],
      [
        -1540.31591796875,
        -3823.42529296875,
        1165.875
      ],
      [
        -1548.7569580078125,
        -3805.357177734375,
        1171.313720703125
      ],
      [
        -1522.05029296875,
        -3766.3896484375,
        1178.596923828125
      ],
      [
        -1535.066650390625,
        -3769.9638671875,
        1178.97509765625
      ],
      [
        -1522.05029296875,
        -3766.3896484375,
        1178.596923828125
      ],
      [
        -1535.6448974609375,
        -3771.36328125,
        1185.092529296875
      ],
      [
        -1535.9000244140625,
        -3771.440673828125,
        1185.1246337890625
      ],
      [
        -1431.5850830078125,
        -3805.78125,
        1173.0147705078125
      ],
      [
        -1430.5982666015625,
        -3810.01953125,
        1190.0
      ],
      [
        -1537.93994140625,
        -3774.768798828125,
        1203.0
      ],
      [
        -1538.119384765625,
        -3775.06884765625,
        1204.5
      ],
      [
        -1498.737548828125,
        -3764.44677734375,
        1204.5
      ],
      [
        -1500.0875244140625,
        -3764.559326171875,
        1203.0
      ],
      [
        -1533.5599365234375,
        -3773.839111328125,
        1204.5
      ],
      [
        -1533.3929443359375,
        -3773.54248046875,
        1203.0
      ],
      [
        -1491.56591796875,
        -3762.432373046875,
        1204.5
      ],
      [
        -1491.505126953125,
        -3762.148681640625,
        1203.0
      ],
      [
        -1500.0875244140625,
        -3764.559326171875,
        1203.0
      ],
      [
        -1498.737548828125,
        -3764.44677734375,
        1204.5
      ],
      [
        -1538.1368408203125,
        -3850.01123046875,
        1203.0
      ],
      [
        -1538.32421875,
        -3850.38916015625,
        1204.5
      ],
      [
        -1551.24658203125,
        -3819.02099609375,
        1204.5
      ],
      [
        -1550.557373046875,
        -3819.861328125,
        1203.0
      ],
      [
        -1550.557373046875,
        -3819.861328125,
        1203.0
      ],
      [
        -1551.24658203125,
        -3819.02099609375,
        1204.5
      ],
      [
        -1553.3760986328125,
        -3813.637939453125,
        1204.5
      ],
      [
        -1553.1673583984375,
        -3813.263671875,
        1203.0
      ],
      [
        -1429.49462890625,
        -3812.977783203125,
        1204.5
      ],
      [
        -1429.5919189453125,
        -3812.629150390625,
        1203.0
      ],
      [
        -1442.2093505859375,
        -3782.0009765625,
        1203.0
      ],
      [
        -1442.621826171875,
        -3781.112060546875,
        1204.5
      ],
      [
        -1442.621826171875,
        -3781.112060546875,
        1204.5
      ],
      [
        -1442.2093505859375,
        -3782.0009765625,
        1203.0
      ],
      [
        -1445.0701904296875,
        -3774.768798828125,
        1203.0
      ],
      [
        -1445.012451171875,
        -3775.06884765625,
        1204.5
      ],
      [
        -1445.012451171875,
        -3850.886474609375,
        1204.5
      ],
      [
        -1445.0701904296875,
        -3850.4892578125,
        1203.0
      ],
      [
        -1432.4527587890625,
        -3819.861083984375,
        1203.0
      ],
      [
        -1431.8851318359375,
        -3819.02099609375,
        1204.5
      ],
      [
        -1452.18408203125,
        -3852.901123046875,
        1204.5
      ],
      [
        -1453.6527099609375,
        -3852.900146484375,
        1203.0
      ],
      [
        -1445.0701904296875,
        -3850.4892578125,
        1203.0
      ],
      [
        -1445.012451171875,
        -3850.886474609375,
        1204.5
      ],
      [
        -1431.8851318359375,
        -3819.02099609375,
        1204.5
      ],
      [
        -1432.4527587890625,
        -3819.861083984375,
        1203.0
      ],
      [
        -1429.5919189453125,
        -3812.629150390625,
        1203.0
      ],
      [
        -1429.49462890625,
        -3812.977783203125,
        1204.5
      ],
      [
        -1445.2628173828125,
        -3849.164794921875,
        1198.0
      ],
      [
        -1445.320556640625,
        -3848.767578125,
        1196.5
      ],
      [
        -1434.9122314453125,
        -3823.501953125,
        1196.5
      ],
      [
        -1434.3446044921875,
        -3822.661865234375,
        1198.0
      ],
      [
        -1429.916259765625,
        -3811.466796875,
        1198.0
      ],
      [
        -1430.0135498046875,
        -3811.1181640625,
        1196.5
      ],
      [
        -1439.3616943359375,
        -3788.426025390625,
        1196.5
      ],
      [
        -1439.407958984375,
        -3788.426025390625,
        1198.0
      ],
      [
        -1458.5479736328125,
        -3852.896728515625,
        1198.0
      ],
      [
        -1460.0164794921875,
        -3852.895751953125,
        1196.5
      ],
      [
        -1445.320556640625,
        -3848.767578125,
        1196.5
      ],
      [
        -1445.2628173828125,
        -3849.164794921875,
        1198.0
      ],
      [
        -1434.3446044921875,
        -3822.661865234375,
        1198.0
      ],
      [
        -1434.9122314453125,
        -3823.501953125,
        1196.5
      ],
      [
        -1430.0135498046875,
        -3811.1181640625,
        1196.5
      ],
      [
        -1429.916259765625,
        -3811.466796875,
        1198.0
      ],
      [
        -1440.8343505859375,
        -3784.963623046875,
        1198.0
      ],
      [
        -1440.421875,
        -3785.8525390625,
        1196.5
      ],
      [
        -1445.320556640625,
        -3773.46875,
        1196.5
      ],
      [
        -1445.2628173828125,
        -3773.768798828125,
        1198.0
      ],
      [
        -1440.421875,
        -3785.8525390625,
        1196.5
      ],
      [
        -1440.8343505859375,
        -3784.963623046875,
        1198.0
      ],
      [
        -1537.16259765625,
        -3773.46875,
        1196.5
      ],
      [
        -1537.342041015625,
        -3773.768798828125,
        1198.0
      ],
      [
        -1504.5875244140625,
        -3764.934326171875,
        1198.0
      ],
      [
        -1505.9375,
        -3765.046875,
        1196.5
      ],
      [
        -1491.3023681640625,
        -3761.20263671875,
        1198.0
      ],
      [
        -1491.2415771484375,
        -3760.9189453125,
        1196.5
      ],
      [
        -1505.9375,
        -3765.046875,
        1196.5
      ],
      [
        -1504.5875244140625,
        -3764.934326171875,
        1198.0
      ],
      [
        -1537.3250732421875,
        -3848.373291015625,
        1196.5
      ],
      [
        -1537.512451171875,
        -3848.751220703125,
        1198.0
      ],
      [
        -1548.2601318359375,
        -3822.662109375,
        1198.0
      ],
      [
        -1547.5709228515625,
        -3823.502197265625,
        1196.5
      ],
      [
        -1547.5709228515625,
        -3823.502197265625,
        1196.5
      ],
      [
        -1548.2601318359375,
        -3822.662109375,
        1198.0
      ],
      [
        -1552.4713134765625,
        -3812.015869140625,
        1198.0
      ],
      [
        -1552.2625732421875,
        -3811.6416015625,
        1196.5
      ],
      [
        -1538.657470703125,
        -3775.96875,
        1209.0
      ],
      [
        -1538.8369140625,
        -3776.268798828125,
        1210.5
      ],
      [
        -1493.3375244140625,
        -3763.996826171875,
        1210.5
      ],
      [
        -1494.6875,
        -3764.109375,
        1209.0
      ],
      [
        -1491.80908203125,
        -3763.567626953125,
        1210.5
      ],
      [
        -1491.748291015625,
        -3763.28369140625,
        1209.0
      ],
      [
        -1494.6875,
        -3764.109375,
        1209.0
      ],
      [
        -1493.3375244140625,
        -3763.996826171875,
        1210.5
      ],
      [
        -1538.88623046875,
        -3851.523193359375,
        1209.0
      ],
      [
        -1539.0736083984375,
        -3851.901123046875,
        1210.5
      ],
      [
        -1554.00341796875,
        -3815.660400390625,
        1210.5
      ],
      [
        -1553.314208984375,
        -3816.50048828125,
        1209.0
      ],
      [
        -1540.032470703125,
        -3849.573974609375,
        1210.5
      ],
      [
        -1539.689453125,
        -3849.573974609375,
        1209.0
      ],
      [
        -1553.314208984375,
        -3816.50048828125,
        1209.0
      ],
      [
        -1554.00341796875,
        -3815.660400390625,
        1210.5
      ],
      [
        -1554.211181640625,
        -3815.135009765625,
        1210.5
      ],
      [
        -1554.00244140625,
        -3814.7607421875,
        1209.0
      ],
      [
        -1429.10546875,
        -3814.372314453125,
        1210.5
      ],
      [
        -1429.2027587890625,
        -3814.023681640625,
        1209.0
      ],
      [
        -1443.859375,
        -3778.445556640625,
        1209.0
      ],
      [
        -1444.2718505859375,
        -3777.556640625,
        1210.5
      ],
      [
        -1444.2718505859375,
        -3777.556640625,
        1210.5
      ],
      [
        -1443.859375,
        -3778.445556640625,
        1209.0
      ],
      [
        -1444.839111328125,
        -3775.96875,
        1209.0
      ],
      [
        -1444.7813720703125,
        -3776.268798828125,
        1210.5
      ],
      [
        -1444.7813720703125,
        -3852.475830078125,
        1210.5
      ],
      [
        -1444.839111328125,
        -3852.07861328125,
        1209.0
      ],
      [
        -1430.182373046875,
        -3816.50048828125,
        1209.0
      ],
      [
        -1429.6148681640625,
        -3815.66015625,
        1210.5
      ],
      [
        -1446.3096923828125,
        -3852.9052734375,
        1210.5
      ],
      [
        -1447.7783203125,
        -3852.904296875,
        1209.0
      ],
      [
        -1444.839111328125,
        -3852.07861328125,
        1209.0
      ],
      [
        -1444.7813720703125,
        -3852.475830078125,
        1210.5
      ],
      [
        -1429.6148681640625,
        -3815.66015625,
        1210.5
      ],
      [
        -1430.182373046875,
        -3816.50048828125,
        1209.0
      ],
      [
        -1429.2027587890625,
        -3814.023681640625,
        1209.0
      ],
      [
        -1429.10546875,
        -3814.372314453125,
        1210.5
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1241.875
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1241.875
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1241.875
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1241.875
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1241.875
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1241.875
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1241.875
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1241.875
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1241.875
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1241.875
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1241.875
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1241.875
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1241.875
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1241.875
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1241.875
      ],
      [
        -1493.1160888671875,
        -3955.164306640625,
        1241.875
      ],
      [
        -1502.6197509765625,
        -3955.164306640625,
        1240.538818359375
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1241.875
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1241.875
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1241.875
      ],
      [
        -1493.90966796875,
        -3955.498291015625,
        1241.875
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1241.7362060546875
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1241.2490234375
      ],
      [
        -1498.995849609375,
        -3957.63818359375,
        1241.875
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1241.875
      ],
      [
        -1502.6197509765625,
        -3955.164306640625,
        1240.538818359375
      ],
      [
        -1513.1339111328125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1241.875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1498.2999267578125,
        -3919.165771484375,
        1229.115234375
      ],
      [
        -1547.6639404296875,
        -3919.165771484375,
        1235.388671875
      ],
      [
        -1558.7713623046875,
        -3919.165771484375,
        1236.40478515625
      ],
      [
        -1547.6639404296875,
        -3919.165771484375,
        1235.388671875
      ],
      [
        -1558.7713623046875,
        -3919.165771484375,
        1236.40478515625
      ],
      [
        -1559.524658203125,
        -3919.165771484375,
        1236.89599609375
      ],
      [
        -1498.2999267578125,
        -3919.165771484375,
        1229.115234375
      ],
      [
        -1453.6805419921875,
        -3919.165771484375,
        1235.388671875
      ],
      [
        -1443.341552734375,
        -3919.165771484375,
        1236.40478515625
      ],
      [
        -1453.680419921875,
        -3919.165771484375,
        1235.388671875
      ],
      [
        -1443.341552734375,
        -3919.165771484375,
        1236.40478515625
      ],
      [
        -1442.9595947265625,
        -3919.165771484375,
        1236.89599609375
      ],
      [
        -1539.588623046875,
        -3940.5712890625,
        1241.875
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1233.2723388671875
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1233.2813720703125
      ],
      [
        -1509.4117431640625,
        -3940.39697265625,
        1241.875
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1233.2813720703125
      ],
      [
        -1509.4117431640625,
        -3940.39697265625,
        1241.875
      ],
      [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1509.4117431640625,
        -3940.39697265625,
        1241.875
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1233.2813720703125
      ],
      [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1565.0,
        -3927.349365234375,
        1241.875
      ],
      [
        -1565.0,
        -3919.165771484375,
        1240.4658203125
      ],
      [
        -1439.088623046875,
        -3919.165771484375,
        1241.875
      ],
      [
        -1497.5797119140625,
        -3913.164306640625,
        1227.2108154296875
      ],
      [
        -1541.410400390625,
        -3913.164306640625,
        1232.781005859375
      ],
      [
        -1565.0,
        -3917.256103515625,
        1222.0
      ],
      [
        -1565.0,
        -3917.256103515625,
        1237.014892578125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1236.605224609375
      ],
      [
        -1565.0,
        -3915.073974609375,
        1222.0
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1236.605224609375
      ],
      [
        -1565.0,
        -3915.073974609375,
        1236.3558349609375
      ],
      [
        -1556.9833984375,
        -3913.164306640625,
        1234.2056884765625
      ],
      [
        -1541.4105224609375,
        -3913.164306640625,
        1232.781005859375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1232.4024658203125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1233.0888671875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1232.6484375
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1231.521728515625
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1231.521728515625
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1230.8355712890625
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1231.27587890625
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1232.4024658203125
      ],
      [
        -1528.5084228515625,
        -3915.100341796875,
        1231.7261962890625
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1231.1463623046875
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1231.146484375
      ],
      [
        -1529.2408447265625,
        -3913.164306640625,
        1231.234375
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1231.1463623046875
      ],
      [
        -1528.508544921875,
        -3915.100341796875,
        1231.7261962890625
      ],
      [
        -1529.240966796875,
        -3913.164306640625,
        1231.234375
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1231.146484375
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1231.136962890625
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1231.136962890625
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1226.0482177734375
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1226.734619140625
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1226.2943115234375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1225.1676025390625
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1224.9217529296875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1226.04833984375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1225.1676025390625
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1224.4813232421875
      ],
      [
        -1556.9833984375,
        -3913.164306640625,
        1234.2056884765625
      ],
      [
        -1559.524658203125,
        -3919.165771484375,
        1236.89599609375
      ],
      [
        -1558.03955078125,
        -3913.164306640625,
        1234.894287109375
      ],
      [
        -1497.5797119140625,
        -3913.164306640625,
        1227.2108154296875
      ],
      [
        -1457.9617919921875,
        -3913.164306640625,
        1232.781005859375
      ],
      [
        -1443.46630859375,
        -3913.164306640625,
        1234.2056884765625
      ],
      [
        -1457.961669921875,
        -3913.164306640625,
        1232.781005859375
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1232.236083984375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1231.4769287109375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1231.4769287109375
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1230.2303466796875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1230.5025634765625
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1231.7490234375
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1229.7431640625
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1230.5025634765625
      ],
      [
        -1442.9595947265625,
        -3919.165771484375,
        1236.8961181640625
      ],
      [
        -1443.46630859375,
        -3913.164306640625,
        1234.2056884765625
      ],
      [
        -1442.930908203125,
        -3913.164306640625,
        1234.894287109375
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1232.0
      ],
      [
        -1504.488037109375,
        -3916.0,
        1241.875
      ],
      [
        -1502.88525390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1504.488037109375,
        -3916.0,
        1241.875
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1232.0
      ],
      [
        -1502.88525390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1233.563720703125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1232.123779296875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1233.5484619140625
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1233.563720703125
      ],
      [
        -1526.7447509765625,
        -3919.165771484375,
        1233.2786865234375
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1232.0
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1232.0
      ],
      [
        -1565.0,
        -3913.164306640625,
        1239.432373046875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1239.5384521484375
      ],
      [
        -1565.0,
        -3915.073974609375,
        1239.7613525390625
      ],
      [
        -1565.0,
        -3917.256103515625,
        1240.136962890625
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1239.5384521484375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1565.0,
        -3915.073974609375,
        1241.875
      ],
      [
        -1565.0,
        -3917.256103515625,
        1241.875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1504.488037109375,
        -3916.0,
        1241.875
      ],
      [
        -1504.488037109375,
        -3916.0,
        1241.875
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1233.5384521484375
      ],
      [
        -1524.4654541015625,
        -3915.999755859375,
        1233.484375
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1233.065185546875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1233.5384521484375
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1233.2801513671875
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1233.125732421875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1545.0670166015625,
        -3873.165771484375,
        1219.5487060546875
      ],
      [
        -1499.732421875,
        -3873.165771484375,
        1215.4014892578125
      ],
      [
        -1492.7799072265625,
        -3873.165771484375,
        1214.5179443359375
      ],
      [
        -1499.7322998046875,
        -3873.165771484375,
        1215.4014892578125
      ],
      [
        -1529.240966796875,
        -3913.164306640625,
        1231.234375
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1218.9635009765625
      ],
      [
        -1548.7764892578125,
        -3873.165771484375,
        1219.8880615234375
      ],
      [
        -1532.4820556640625,
        -3904.595458984375,
        1229.057861328125
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1218.9635009765625
      ],
      [
        -1529.240966796875,
        -3913.164306640625,
        1231.234375
      ],
      [
        -1532.4822998046875,
        -3904.594970703125,
        1229.0577392578125
      ],
      [
        -1548.7764892578125,
        -3873.165771484375,
        1219.8880615234375
      ],
      [
        -1492.7799072265625,
        -3873.165771484375,
        1214.5179443359375
      ],
      [
        -1491.7138671875,
        -3873.165771484375,
        1214.6678466796875
      ],
      [
        -1490.8555908203125,
        -3913.164306640625,
        1228.15625
      ],
      [
        -1528.03955078125,
        -3913.164306640625,
        1231.557861328125
      ],
      [
        -1528.03955078125,
        -3913.164306640625,
        1231.557861328125
      ],
      [
        -1444.297607421875,
        -3873.165771484375,
        1219.5487060546875
      ],
      [
        -1486.49560546875,
        -3873.165771484375,
        1215.4014892578125
      ],
      [
        -1486.49560546875,
        -3873.165771484375,
        1215.4014892578125
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1232.0
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1232.0
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1232.0
      ],
      [
        -1500.3482666015625,
        -3873.165771484375,
        1233.4451904296875
      ],
      [
        -1490.7142333984375,
        -3891.630859375,
        1241.875
      ],
      [
        -1490.7142333984375,
        -3891.630859375,
        1241.875
      ],
      [
        -1500.3482666015625,
        -3873.165771484375,
        1233.4451904296875
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1232.0
      ],
      [
        -1546.420654296875,
        -3877.709228515625,
        1221.213623046875
      ],
      [
        -1565.0,
        -3873.165771484375,
        1232.5447998046875
      ],
      [
        -1546.5194091796875,
        -3873.165771484375,
        1220.49560546875
      ],
      [
        -1426.939453125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1444.297607421875,
        -3873.165771484375,
        1219.5487060546875
      ],
      [
        -1545.0670166015625,
        -3873.165771484375,
        1219.5487060546875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1217.1463623046875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1217.1365966796875
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1217.1365966796875
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1218.0596923828125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1219.0023193359375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1218.0792236328125
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1218.9925537109375
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1219.0023193359375
      ],
      [
        -1552.1024169921875,
        -3873.165771484375,
        1224.1357421875
      ],
      [
        -1555.5672607421875,
        -3873.165771484375,
        1226.394775390625
      ],
      [
        -1557.2998046875,
        -3870.164794921875,
        1227.007568359375
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1225.3614501953125
      ],
      [
        -1552.102294921875,
        -3867.164306640625,
        1223.1021728515625
      ],
      [
        -1550.369873046875,
        -3870.1650390625,
        1222.4893798828125
      ],
      [
        -1548.6373291015625,
        -3873.165771484375,
        1221.87646484375
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1231.1463623046875
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1231.1365966796875
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1233.00244140625
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1232.0792236328125
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1232.9925537109375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1233.00244140625
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1231.1365966796875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1232.0596923828125
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1232.0
      ],
      [
        -1503.5677490234375,
        -3873.165771484375,
        1232.093017578125
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1232.0
      ],
      [
        -1503.5677490234375,
        -3873.165771484375,
        1232.093017578125
      ],
      [
        -1546.5194091796875,
        -3873.165771484375,
        1220.49560546875
      ],
      [
        -1546.6497802734375,
        -3867.164306640625,
        1219.5472412109375
      ],
      [
        -1559.032470703125,
        -3873.165771484375,
        1228.654052734375
      ],
      [
        -1565.0,
        -3867.164306640625,
        1231.5113525390625
      ],
      [
        -1543.279052734375,
        -3867.164306640625,
        1217.349609375
      ],
      [
        -1493.47900390625,
        -3867.164306640625,
        1212.7938232421875
      ],
      [
        -1492.0596923828125,
        -3867.164306640625,
        1212.613525390625
      ],
      [
        -1493.4788818359375,
        -3867.164306640625,
        1212.7938232421875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1214.89306640625
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1215.7523193359375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1215.435302734375
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1214.2591552734375
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1213.7166748046875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1214.89306640625
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1214.2591552734375
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1213.3997802734375
      ],
      [
        -1492.0596923828125,
        -3867.164306640625,
        1212.613525390625
      ],
      [
        -1491.8426513671875,
        -3867.164306640625,
        1212.64404296875
      ],
      [
        -1491.7137451171875,
        -3873.165771484375,
        1214.6678466796875
      ],
      [
        -1444.42236328125,
        -3867.164306640625,
        1217.349609375
      ],
      [
        -1490.77685546875,
        -3867.164306640625,
        1212.7938232421875
      ],
      [
        -1490.77685546875,
        -3867.164306640625,
        1212.7938232421875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1219.5679931640625
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1218.6448974609375
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1217.9637451171875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1219.2275390625
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1218.6448974609375
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1217.3809814453125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1217.04052734375
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1217.9637451171875
      ],
      [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      [
        -1444.42236328125,
        -3867.164306640625,
        1217.349609375
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1221.0087890625
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1217.7611083984375
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1219.7998046875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1221.0087890625
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1241.875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1241.875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1241.875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1241.875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      [
        -1543.279052734375,
        -3867.164306640625,
        1217.349609375
      ],
      [
        -1491.842529296875,
        -3867.164306640625,
        1212.64404296875
      ],
      [
        -1565.0,
        -3856.04443359375,
        1229.5965576171875
      ],
      [
        -1441.1708984375,
        -3785.205810546875,
        1212.125
      ],
      [
        -1565.0,
        -3830.394775390625,
        1222.8245849609375
      ],
      [
        -1565.0,
        -3789.150634765625,
        1241.875
      ],
      [
        -1565.0,
        -3830.394775390625,
        1222.8245849609375
      ],
      [
        -1565.0,
        -3856.04443359375,
        1229.5965576171875
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1241.875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1567.1614990234375,
        -3919.165771484375,
        1241.875
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1241.1845703125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1240.151123046875
      ],
      [
        -1568.74658203125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1241.875
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1241.1845703125
      ],
      [
        -1565.0,
        -3917.256103515625,
        1240.136962890625
      ],
      [
        -1565.0,
        -3915.073974609375,
        1239.76123046875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1240.151123046875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1241.875
      ],
      [
        -1565.0,
        -3806.10302734375,
        1201.1512451171875
      ],
      [
        -1585.6302490234375,
        -3789.407958984375,
        1201.85546875
      ],
      [
        -1586.4012451171875,
        -3790.42822265625,
        1196.939208984375
      ],
      [
        -1588.7423095703125,
        -3797.073974609375,
        1197.001708984375
      ],
      [
        -1588.7445068359375,
        -3798.167724609375,
        1201.595703125
      ],
      [
        -1588.7349853515625,
        -3796.99560546875,
        1196.7579345703125
      ],
      [
        -1588.7423095703125,
        -3797.073974609375,
        1197.001708984375
      ],
      [
        -1587.968994140625,
        -3797.13720703125,
        1206.52197265625
      ],
      [
        -1588.7138671875,
        -3798.11962890625,
        1201.75927734375
      ],
      [
        -1588.7445068359375,
        -3798.167724609375,
        1201.595703125
      ],
      [
        -1588.7138671875,
        -3798.11962890625,
        1201.75927734375
      ],
      [
        -1587.7021484375,
        -3793.692626953125,
        1195.1622314453125
      ],
      [
        -1588.660400390625,
        -3796.764404296875,
        1196.6744384765625
      ],
      [
        -1588.7349853515625,
        -3796.99560546875,
        1196.7579345703125
      ],
      [
        -1588.660400390625,
        -3796.764404296875,
        1196.6744384765625
      ],
      [
        -1586.4532470703125,
        -3790.544677734375,
        1196.8095703125
      ],
      [
        -1586.4193115234375,
        -3790.45654296875,
        1196.8426513671875
      ],
      [
        -1587.7021484375,
        -3793.692626953125,
        1195.1622314453125
      ],
      [
        -1586.4532470703125,
        -3790.544677734375,
        1196.8095703125
      ],
      [
        -1586.4193115234375,
        -3790.45654296875,
        1196.8426513671875
      ],
      [
        -1586.4012451171875,
        -3790.42822265625,
        1196.939208984375
      ],
      [
        -1585.6309814453125,
        -3789.417236328125,
        1201.8857421875
      ],
      [
        -1585.6309814453125,
        -3789.417236328125,
        1201.8857421875
      ],
      [
        -1585.6302490234375,
        -3789.407958984375,
        1201.85546875
      ],
      [
        -1587.2991943359375,
        -3795.45654296875,
        1207.4381103515625
      ],
      [
        -1587.968994140625,
        -3797.13720703125,
        1206.52197265625
      ],
      [
        -1587.9515380859375,
        -3797.091796875,
        1206.539794921875
      ],
      [
        -1587.9515380859375,
        -3797.091796875,
        1206.539794921875
      ],
      [
        -1664.0411376953125,
        -3736.897705078125,
        1200.0
      ],
      [
        -1638.6136474609375,
        -3725.8486328125,
        1200.0
      ],
      [
        -1637.429443359375,
        -3725.340087890625,
        1200.0
      ],
      [
        -1612.5445556640625,
        -3728.857177734375,
        1200.0
      ],
      [
        -1612.5445556640625,
        -3728.857177734375,
        1200.0
      ],
      [
        -1611.478759765625,
        -3728.99072265625,
        1200.0
      ],
      [
        -1611.478759765625,
        -3728.99072265625,
        1200.0
      ],
      [
        -1611.4798583984375,
        -3729.008056640625,
        1200.0
      ],
      [
        -1640.261474609375,
        -3747.219482421875,
        1195.72119140625
      ],
      [
        -1666.306640625,
        -3745.5380859375,
        1197.273193359375
      ],
      [
        -1640.690673828125,
        -3738.762939453125,
        1197.2864990234375
      ],
      [
        -1639.1612548828125,
        -3738.748291015625,
        1197.199951171875
      ],
      [
        -1641.0491943359375,
        -3739.353271484375,
        1197.199951171875
      ],
      [
        -1640.690673828125,
        -3738.762939453125,
        1197.28662109375
      ],
      [
        -1666.306640625,
        -3745.5380859375,
        1197.273193359375
      ],
      [
        -1667.2191162109375,
        -3745.263916015625,
        1197.64990234375
      ],
      [
        -1666.3499755859375,
        -3745.6962890625,
        1197.2418212890625
      ],
      [
        -1660.44580078125,
        -3747.852783203125,
        1194.825439453125
      ],
      [
        -1666.3499755859375,
        -3745.6962890625,
        1197.2418212890625
      ],
      [
        -1667.250732421875,
        -3745.343994140625,
        1197.63720703125
      ],
      [
        -1669.72021484375,
        -3751.597900390625,
        1196.64208984375
      ],
      [
        -1669.72021484375,
        -3751.597900390625,
        1196.64208984375
      ],
      [
        -1669.6697998046875,
        -3751.642333984375,
        1196.631103515625
      ],
      [
        -1666.069580078125,
        -3755.57177734375,
        1195.705322265625
      ],
      [
        -1667.77783203125,
        -3753.30908203125,
        1196.217041015625
      ],
      [
        -1666.069580078125,
        -3755.57177734375,
        1195.705322265625
      ],
      [
        -1667.77783203125,
        -3753.30908203125,
        1196.217041015625
      ],
      [
        -1640.261474609375,
        -3747.219482421875,
        1195.72119140625
      ],
      [
        -1639.7864990234375,
        -3747.655029296875,
        1195.614013671875
      ],
      [
        -1677.8883056640625,
        -3749.19189453125,
        1200.0
      ],
      [
        -1677.4967041015625,
        -3748.748291015625,
        1200.0
      ],
      [
        -1664.0411376953125,
        -3736.897705078125,
        1200.0
      ],
      [
        -1677.4967041015625,
        -3748.748291015625,
        1200.0
      ],
      [
        -1629.9791259765625,
        -3737.490478515625,
        1198.36279296875
      ],
      [
        -1631.2828369140625,
        -3734.512451171875,
        1198.6580810546875
      ],
      [
        -1625.9376220703125,
        -3734.5146484375,
        1198.7376708984375
      ],
      [
        -1627.2261962890625,
        -3737.479736328125,
        1198.405029296875
      ],
      [
        -1627.303955078125,
        -3731.71630859375,
        1199.0128173828125
      ],
      [
        -1625.9376220703125,
        -3734.5146484375,
        1198.7376708984375
      ],
      [
        -1631.2828369140625,
        -3734.512451171875,
        1198.6580810546875
      ],
      [
        -1629.90087890625,
        -3731.705078125,
        1198.9752197265625
      ],
      [
        -1629.90087890625,
        -3731.705078125,
        1198.9752197265625
      ],
      [
        -1627.303955078125,
        -3731.71630859375,
        1199.0128173828125
      ],
      [
        -1627.2261962890625,
        -3737.479736328125,
        1198.405029296875
      ],
      [
        -1629.9791259765625,
        -3737.490478515625,
        1198.36279296875
      ],
      [
        -1638.196044921875,
        -3738.89990234375,
        1198.0911865234375
      ],
      [
        -1636.9486083984375,
        -3740.988525390625,
        1197.88916015625
      ],
      [
        -1636.9486083984375,
        -3740.988525390625,
        1197.88916015625
      ],
      [
        -1638.1475830078125,
        -3743.161865234375,
        1197.6416015625
      ],
      [
        -1640.656494140625,
        -3743.169677734375,
        1197.6033935546875
      ],
      [
        -1641.8673095703125,
        -3740.98974609375,
        1197.8155517578125
      ],
      [
        -1638.1475830078125,
        -3743.161865234375,
        1197.6416015625
      ],
      [
        -1640.656494140625,
        -3743.169677734375,
        1197.6033935546875
      ],
      [
        -1641.8673095703125,
        -3740.98974609375,
        1197.8155517578125
      ],
      [
        -1640.6077880859375,
        -3738.893798828125,
        1198.0557861328125
      ],
      [
        -1640.6077880859375,
        -3738.893798828125,
        1198.055908203125
      ],
      [
        -1638.196044921875,
        -3738.89990234375,
        1198.0911865234375
      ],
      [
        -1611.954833984375,
        -3733.67822265625,
        1199.5247802734375
      ],
      [
        -1634.909423828125,
        -3745.205810546875,
        1197.7364501953125
      ],
      [
        -1634.909423828125,
        -3745.205810546875,
        1197.7364501953125
      ],
      [
        -1635.6566162109375,
        -3745.5810546875,
        1197.6343994140625
      ],
      [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ],
      [
        -1641.8642578125,
        -3740.989501953125,
        1197.8297119140625
      ],
      [
        -1641.8642578125,
        -3740.989501953125,
        1197.8297119140625
      ],
      [
        -1640.60693359375,
        -3738.895263671875,
        1198.0640869140625
      ],
      [
        -1640.60693359375,
        -3738.895263671875,
        1198.064208984375
      ],
      [
        -1639.571533203125,
        -3743.166259765625,
        1197.619873046875
      ],
      [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ],
      [
        -1611.954833984375,
        -3733.67822265625,
        1199.5247802734375
      ],
      [
        -1611.5120849609375,
        -3729.536376953125,
        1200.0
      ],
      [
        -1611.8721923828125,
        -3733.63671875,
        1200.0
      ],
      [
        -1629.769775390625,
        -3737.081787109375,
        1200.0
      ],
      [
        -1630.939453125,
        -3734.54931640625,
        1200.0
      ],
      [
        -1626.2606201171875,
        -3734.54931640625,
        1200.0
      ],
      [
        -1627.4302978515625,
        -3737.081787109375,
        1200.0
      ],
      [
        -1630.939453125,
        -3734.54931640625,
        1200.0
      ],
      [
        -1629.769775390625,
        -3732.016845703125,
        1200.0
      ],
      [
        -1627.4302978515625,
        -3732.016845703125,
        1200.0
      ],
      [
        -1626.2606201171875,
        -3734.54931640625,
        1200.0
      ],
      [
        -1627.4302978515625,
        -3737.081787109375,
        1200.0
      ],
      [
        -1629.769775390625,
        -3737.081787109375,
        1200.0
      ],
      [
        -1629.769775390625,
        -3732.016845703125,
        1200.0
      ],
      [
        -1627.4302978515625,
        -3732.016845703125,
        1200.0
      ],
      [
        -1611.5120849609375,
        -3729.536376953125,
        1200.0
      ],
      [
        -1640.398193359375,
        -3742.6826171875,
        1200.0
      ],
      [
        -1641.3966064453125,
        -3740.95361328125,
        1200.0
      ],
      [
        -1641.3966064453125,
        -3740.95361328125,
        1200.0
      ],
      [
        -1640.398193359375,
        -3739.224365234375,
        1200.0
      ],
      [
        -1637.4034423828125,
        -3740.95361328125,
        1200.0
      ],
      [
        -1638.4017333984375,
        -3742.6826171875,
        1200.0
      ],
      [
        -1638.4017333984375,
        -3742.6826171875,
        1200.0
      ],
      [
        -1640.398193359375,
        -3742.6826171875,
        1200.0
      ],
      [
        -1638.4017333984375,
        -3739.224365234375,
        1200.0
      ],
      [
        -1637.4034423828125,
        -3740.95361328125,
        1200.0
      ],
      [
        -1640.398193359375,
        -3739.224365234375,
        1200.0
      ],
      [
        -1638.4017333984375,
        -3739.224365234375,
        1200.0
      ],
      [
        -1638.6136474609375,
        -3725.8486328125,
        1200.0
      ],
      [
        -1637.429443359375,
        -3725.340087890625,
        1200.0
      ],
      [
        -1665.87939453125,
        -3760.758544921875,
        1197.6895751953125
      ],
      [
        -1670.476318359375,
        -3763.067138671875,
        1200.0
      ],
      [
        -1677.7872314453125,
        -3749.348388671875,
        1200.0
      ],
      [
        -1665.87939453125,
        -3760.758544921875,
        1197.6895751953125
      ],
      [
        -1665.842041015625,
        -3760.73974609375,
        1197.6732177734375
      ],
      [
        -1677.8883056640625,
        -3749.19189453125,
        1200.0
      ],
      [
        -1677.7872314453125,
        -3749.348388671875,
        1200.0
      ],
      [
        -1665.842041015625,
        -3760.73974609375,
        1197.6732177734375
      ],
      [
        -1638.3426513671875,
        -3746.929931640625,
        1197.2674560546875
      ],
      [
        -1638.3426513671875,
        -3746.929931640625,
        1197.2674560546875
      ],
      [
        -1627.2987060546875,
        -3746.639892578125,
        1198.0030517578125
      ],
      [
        -1624.50537109375,
        -3746.68017578125,
        1198.1722412109375
      ],
      [
        -1624.50537109375,
        -3746.68017578125,
        1198.1722412109375
      ],
      [
        -1623.0528564453125,
        -3749.0,
        1197.9222412109375
      ],
      [
        -1624.4124755859375,
        -3751.486328125,
        1197.4713134765625
      ],
      [
        -1627.408203125,
        -3751.532470703125,
        1197.2767333984375
      ],
      [
        -1628.83642578125,
        -3749.0,
        1197.5594482421875
      ],
      [
        -1627.2987060546875,
        -3746.639892578125,
        1198.0030517578125
      ],
      [
        -1623.0528564453125,
        -3749.0,
        1197.9222412109375
      ],
      [
        -1624.4124755859375,
        -3751.486328125,
        1197.4713134765625
      ],
      [
        -1627.408203125,
        -3751.532470703125,
        1197.2767333984375
      ],
      [
        -1628.83642578125,
        -3749.0,
        1197.5594482421875
      ],
      [
        -1612.38037109375,
        -3739.4228515625,
        1200.0
      ],
      [
        -1611.75732421875,
        -3746.440185546875,
        1199.1270751953125
      ],
      [
        -1621.394287109375,
        -3759.279541015625,
        1196.531982421875
      ],
      [
        -1610.3599853515625,
        -3744.578369140625,
        1199.566650390625
      ],
      [
        -1611.75732421875,
        -3746.440185546875,
        1199.1270751953125
      ],
      [
        -1624.74755859375,
        -3750.885986328125,
        1200.0
      ],
      [
        -1626.9976806640625,
        -3750.885986328125,
        1200.0
      ],
      [
        -1623.6224365234375,
        -3749.0,
        1200.0
      ],
      [
        -1624.74755859375,
        -3750.885986328125,
        1200.0
      ],
      [
        -1626.9976806640625,
        -3750.885986328125,
        1200.0
      ],
      [
        -1628.122802734375,
        -3749.0,
        1200.0
      ],
      [
        -1628.122802734375,
        -3749.0,
        1200.0
      ],
      [
        -1626.9976806640625,
        -3747.114013671875,
        1200.0
      ],
      [
        -1626.9976806640625,
        -3747.114013671875,
        1200.0
      ],
      [
        -1624.74755859375,
        -3747.114013671875,
        1200.0
      ],
      [
        -1624.74755859375,
        -3747.114013671875,
        1200.0
      ],
      [
        -1623.6224365234375,
        -3749.0,
        1200.0
      ],
      [
        -1610.3599853515625,
        -3744.578369140625,
        1199.566650390625
      ],
      [
        -1612.643798828125,
        -3742.421630859375,
        1200.0
      ],
      [
        -1610.29443359375,
        -3744.49072265625,
        1200.0
      ],
      [
        -1612.643798828125,
        -3742.421630859375,
        1200.0
      ],
      [
        -1621.4437255859375,
        -3759.345458984375,
        1196.4898681640625
      ],
      [
        -1621.4437255859375,
        -3759.345458984375,
        1196.4898681640625
      ],
      [
        -1621.4010009765625,
        -3759.28857421875,
        1196.5301513671875
      ],
      [
        -1621.4010009765625,
        -3759.28857421875,
        1196.5301513671875
      ],
      [
        -1652.3973388671875,
        -3772.315185546875,
        1200.0
      ],
      [
        -1653.5213623046875,
        -3771.298095703125,
        1200.0
      ],
      [
        -1670.0543212890625,
        -3763.85888671875,
        1200.0
      ],
      [
        -1654.9678955078125,
        -3770.3154296875,
        1200.0
      ],
      [
        -1654.9678955078125,
        -3770.3154296875,
        1200.0
      ],
      [
        -1653.5213623046875,
        -3771.298095703125,
        1200.0
      ],
      [
        -1670.0543212890625,
        -3763.85888671875,
        1200.0
      ],
      [
        -1639.8321533203125,
        -3776.222412109375,
        1200.0
      ],
      [
        -1635.2554931640625,
        -3777.748046875,
        1200.0
      ],
      [
        -1652.3973388671875,
        -3772.315185546875,
        1200.0
      ],
      [
        -1639.8321533203125,
        -3776.222412109375,
        1200.0
      ],
      [
        -1593.5579833984375,
        -3759.230712890625,
        1200.0
      ],
      [
        -1588.806396484375,
        -3772.5693359375,
        1200.0
      ],
      [
        -1588.3463134765625,
        -3772.860107421875,
        1200.0
      ],
      [
        -1594.0347900390625,
        -3778.013427734375,
        1196.9403076171875
      ],
      [
        -1594.9217529296875,
        -3778.93701171875,
        1196.4212646484375
      ],
      [
        -1592.9449462890625,
        -3776.878662109375,
        1197.578125
      ],
      [
        -1591.51513671875,
        -3764.210693359375,
        1200.0
      ],
      [
        -1589.5361328125,
        -3772.050537109375,
        1200.0
      ],
      [
        -1589.5361328125,
        -3772.050537109375,
        1200.0
      ],
      [
        -1588.806396484375,
        -3772.5693359375,
        1200.0
      ],
      [
        -1591.51513671875,
        -3764.210693359375,
        1200.0
      ],
      [
        -1593.3369140625,
        -3759.440185546875,
        1200.0
      ],
      [
        -1593.5579833984375,
        -3759.230712890625,
        1200.0
      ],
      [
        -1593.3369140625,
        -3759.440185546875,
        1200.0
      ],
      [
        -1585.9404296875,
        -3788.86767578125,
        1200.0
      ],
      [
        -1588.3463134765625,
        -3772.860107421875,
        1200.0
      ],
      [
        -1621.2244873046875,
        -3784.2978515625,
        1200.0
      ],
      [
        -1634.3919677734375,
        -3778.035888671875,
        1200.0
      ],
      [
        -1621.2244873046875,
        -3784.2978515625,
        1200.0
      ],
      [
        -1617.052734375,
        -3787.87939453125,
        1200.0
      ],
      [
        -1634.3919677734375,
        -3778.035888671875,
        1200.0
      ],
      [
        -1616.8406982421875,
        -3787.9794921875,
        1200.0
      ],
      [
        -1617.052734375,
        -3787.87939453125,
        1200.0
      ],
      [
        -1603.412353515625,
        -3789.3388671875,
        1195.099365234375
      ],
      [
        -1608.4490966796875,
        -3783.412353515625,
        1194.825439453125
      ],
      [
        -1606.4169921875,
        -3797.84130859375,
        1200.0
      ],
      [
        -1615.8834228515625,
        -3788.431884765625,
        1200.0
      ],
      [
        -1604.0960693359375,
        -3800.1484375,
        1200.0
      ],
      [
        -1604.766845703125,
        -3799.945556640625,
        1200.0
      ],
      [
        -1604.766845703125,
        -3799.945556640625,
        1200.0
      ],
      [
        -1606.4169921875,
        -3797.84130859375,
        1200.0
      ],
      [
        -1615.8834228515625,
        -3788.431884765625,
        1200.0
      ],
      [
        -1594.4664306640625,
        -3803.062744140625,
        1200.0
      ],
      [
        -1594.4664306640625,
        -3803.062744140625,
        1200.0
      ],
      [
        -1594.4090576171875,
        -3803.01318359375,
        1200.0
      ],
      [
        -1594.3414306640625,
        -3802.954833984375,
        1200.0
      ],
      [
        -1585.9404296875,
        -3788.86767578125,
        1200.0
      ],
      [
        -1585.92041015625,
        -3789.232421875,
        1200.0
      ],
      [
        -1594.1458740234375,
        -3802.785888671875,
        1200.0
      ],
      [
        -1588.451904296875,
        -3796.095947265625,
        1196.3453369140625
      ],
      [
        -1587.1092529296875,
        -3792.1982421875,
        1195.9442138671875
      ],
      [
        -1585.92041015625,
        -3789.232421875,
        1200.0
      ],
      [
        -1586.05908203125,
        -3789.759765625,
        1200.0
      ],
      [
        -1586.05908203125,
        -3789.759765625,
        1200.0
      ],
      [
        -1585.9212646484375,
        -3789.79296875,
        1200.0
      ],
      [
        -1587.3597412109375,
        -3792.503173828125,
        1195.781982421875
      ],
      [
        -1588.7437744140625,
        -3797.787841796875,
        1200.0
      ],
      [
        -1589.0931396484375,
        -3797.580322265625,
        1200.0
      ],
      [
        -1589.7430419921875,
        -3798.532470703125,
        1200.0
      ],
      [
        -1594.1458740234375,
        -3802.785888671875,
        1200.0
      ],
      [
        -1589.198974609375,
        -3797.517578125,
        1200.0
      ],
      [
        -1589.4637451171875,
        -3798.044921875,
        1200.0
      ],
      [
        -1589.198974609375,
        -3797.517578125,
        1200.0
      ],
      [
        -1589.7430419921875,
        -3798.532470703125,
        1200.0
      ],
      [
        -1589.4637451171875,
        -3798.044921875,
        1200.0
      ],
      [
        -1636.68408203125,
        -3777.755859375,
        1201.3995361328125
      ],
      [
        -1636.68408203125,
        -3777.755859375,
        1201.3995361328125
      ],
      [
        -1634.7816162109375,
        -3777.906005859375,
        1200.0
      ],
      [
        -1634.5936279296875,
        -3778.49609375,
        1201.525146484375
      ],
      [
        -1655.8948974609375,
        -3769.918701171875,
        1200.0
      ],
      [
        -1677.8773193359375,
        -3749.179443359375,
        1200.0
      ],
      [
        -1680.383056640625,
        -3757.672607421875,
        1203.943115234375
      ],
      [
        -1680.383056640625,
        -3757.672607421875,
        1203.943115234375
      ],
      [
        -1677.9835205078125,
        -3748.4619140625,
        1201.8526611328125
      ],
      [
        -1672.5625,
        -3744.402587890625,
        1200.0
      ],
      [
        -1676.3385009765625,
        -3747.43408203125,
        1201.325439453125
      ],
      [
        -1677.9835205078125,
        -3748.4619140625,
        1201.8526611328125
      ],
      [
        -1676.3385009765625,
        -3747.43408203125,
        1201.325439453125
      ],
      [
        -1683.457275390625,
        -3773.551513671875,
        1207.8809814453125
      ],
      [
        -1683.457275390625,
        -3773.551513671875,
        1207.8809814453125
      ],
      [
        -1681.41357421875,
        -3761.3203125,
        1205.6177978515625
      ],
      [
        -1681.41357421875,
        -3761.3203125,
        1205.6177978515625
      ],
      [
        -1677.9857177734375,
        -3748.06298828125,
        1202.8829345703125
      ],
      [
        -1669.5517578125,
        -3741.7509765625,
        1200.0
      ],
      [
        -1675.4141845703125,
        -3746.458984375,
        1202.05078125
      ],
      [
        -1677.9857177734375,
        -3748.06298828125,
        1202.8829345703125
      ],
      [
        -1675.4141845703125,
        -3746.458984375,
        1202.05078125
      ],
      [
        -1627.3739013671875,
        -3802.41064453125,
        1209.498779296875
      ],
      [
        -1627.3739013671875,
        -3802.41064453125,
        1209.498779296875
      ],
      [
        -1626.7637939453125,
        -3803.0693359375,
        1209.7003173828125
      ],
      [
        -1666.7996826171875,
        -3755.70556640625,
        1211.0
      ],
      [
        -1684.5625,
        -3772.360595703125,
        1211.0
      ],
      [
        -1666.7996826171875,
        -3755.70556640625,
        1211.0
      ],
      [
        -1666.3585205078125,
        -3754.2666015625,
        1211.0
      ],
      [
        -1666.3585205078125,
        -3754.2666015625,
        1211.0
      ],
      [
        -1660.74560546875,
        -3737.3095703125,
        1211.0
      ],
      [
        -1665.7152099609375,
        -3736.228515625,
        1209.662841796875
      ],
      [
        -1664.5145263671875,
        -3735.169921875,
        1209.667724609375
      ],
      [
        -1665.7152099609375,
        -3736.228515625,
        1209.662841796875
      ],
      [
        -1664.5145263671875,
        -3735.169921875,
        1209.667724609375
      ],
      [
        -1664.0279541015625,
        -3734.955078125,
        1209.6851806640625
      ],
      [
        -1662.518798828125,
        -3734.288330078125,
        1209.7393798828125
      ],
      [
        -1654.1575927734375,
        -3730.46142578125,
        1211.0
      ],
      [
        -1650.4117431640625,
        -3728.852783203125,
        1211.0
      ],
      [
        -1650.36865234375,
        -3728.98779296875,
        1210.1806640625
      ],
      [
        -1660.74560546875,
        -3737.3095703125,
        1211.0
      ],
      [
        -1654.1575927734375,
        -3730.46142578125,
        1211.0
      ],
      [
        -1662.518798828125,
        -3734.288330078125,
        1209.7393798828125
      ],
      [
        -1684.725830078125,
        -3773.0439453125,
        1211.0
      ],
      [
        -1684.5625,
        -3772.360595703125,
        1211.0
      ],
      [
        -1680.3271484375,
        -3794.300048828125,
        1211.0
      ],
      [
        -1684.5859375,
        -3773.611083984375,
        1211.0
      ],
      [
        -1684.7347412109375,
        -3773.144287109375,
        1211.0
      ],
      [
        -1684.5859375,
        -3773.611083984375,
        1211.0
      ],
      [
        -1684.7347412109375,
        -3773.144287109375,
        1211.0
      ],
      [
        -1684.725830078125,
        -3773.0439453125,
        1211.0
      ],
      [
        -1677.9871826171875,
        -3747.809326171875,
        1203.5379638671875
      ],
      [
        -1676.194091796875,
        -3746.945556640625,
        1202.30322265625
      ],
      [
        -1680.3271484375,
        -3794.300048828125,
        1211.0
      ],
      [
        -1675.0325927734375,
        -3803.220703125,
        1211.0
      ],
      [
        -1650.0792236328125,
        -3729.896484375,
        1204.6712646484375
      ],
      [
        -1649.8177490234375,
        -3730.71728515625,
        1200.0
      ],
      [
        -1650.0792236328125,
        -3729.896484375,
        1204.6712646484375
      ],
      [
        -1653.7186279296875,
        -3812.849853515625,
        1211.0
      ],
      [
        -1663.6644287109375,
        -3811.8486328125,
        1211.0
      ],
      [
        -1642.2025146484375,
        -3805.84228515625,
        1211.0
      ],
      [
        -1648.5311279296875,
        -3809.647705078125,
        1211.0
      ],
      [
        -1648.5311279296875,
        -3809.647705078125,
        1211.0
      ],
      [
        -1653.7186279296875,
        -3812.849853515625,
        1211.0
      ],
      [
        -1625.9351806640625,
        -3805.670166015625,
        1210.833740234375
      ],
      [
        -1626.090087890625,
        -3805.183837890625,
        1210.666259765625
      ],
      [
        -1626.090087890625,
        -3805.183837890625,
        1210.666259765625
      ],
      [
        -1625.9351806640625,
        -3805.670166015625,
        1210.833740234375
      ],
      [
        -1625.9947509765625,
        -3805.4833984375,
        1211.0025634765625
      ],
      [
        -1642.2025146484375,
        -3805.84228515625,
        1211.0
      ],
      [
        -1669.3817138671875,
        -3811.141357421875,
        1211.0
      ],
      [
        -1675.0325927734375,
        -3803.220703125,
        1211.0
      ],
      [
        -1663.6644287109375,
        -3811.8486328125,
        1211.0
      ],
      [
        -1669.3817138671875,
        -3811.141357421875,
        1211.0
      ],
      [
        -1635.510498046875,
        -3723.313720703125,
        1211.0
      ],
      [
        -1609.7747802734375,
        -3726.5390625,
        1211.0
      ],
      [
        -1637.017333984375,
        -3723.100830078125,
        1211.0
      ],
      [
        -1635.510498046875,
        -3723.313720703125,
        1211.0
      ],
      [
        -1637.0606689453125,
        -3723.119384765625,
        1211.0
      ],
      [
        -1637.017333984375,
        -3723.100830078125,
        1211.0
      ],
      [
        -1638.14794921875,
        -3725.648681640625,
        1200.0
      ],
      [
        -1610.6473388671875,
        -3740.4931640625,
        1211.0
      ],
      [
        -1609.49169921875,
        -3741.510986328125,
        1211.0
      ],
      [
        -1609.7747802734375,
        -3726.5390625,
        1211.0
      ],
      [
        -1610.578857421875,
        -3739.712890625,
        1211.0
      ],
      [
        -1610.6473388671875,
        -3740.4931640625,
        1211.0
      ],
      [
        -1610.578857421875,
        -3739.712890625,
        1211.0
      ],
      [
        -1609.49169921875,
        -3741.510986328125,
        1211.0
      ],
      [
        -1597.4881591796875,
        -3752.8916015625,
        1211.0
      ],
      [
        -1605.7183837890625,
        -3814.93408203125,
        1211.0
      ],
      [
        -1591.3734130859375,
        -3799.46533203125,
        1211.0
      ],
      [
        -1589.6260986328125,
        -3798.249755859375,
        1211.0
      ],
      [
        -1591.3734130859375,
        -3799.46533203125,
        1211.0
      ],
      [
        -1589.6260986328125,
        -3798.249755859375,
        1211.0
      ],
      [
        -1588.9945068359375,
        -3796.899658203125,
        1211.0
      ],
      [
        -1605.336669921875,
        -3812.940185546875,
        1206.024658203125
      ],
      [
        -1607.7423095703125,
        -3799.133544921875,
        1201.3094482421875
      ],
      [
        -1607.7423095703125,
        -3799.133544921875,
        1201.3094482421875
      ],
      [
        -1612.551025390625,
        -3791.744140625,
        1200.0
      ],
      [
        -1605.336669921875,
        -3812.940185546875,
        1206.024658203125
      ],
      [
        -1602.0355224609375,
        -3800.772216796875,
        1200.0
      ],
      [
        -1585.1666259765625,
        -3788.946044921875,
        1206.9085693359375
      ],
      [
        -1587.5155029296875,
        -3778.387939453125,
        1200.0
      ],
      [
        -1585.651611328125,
        -3789.408203125,
        1201.8824462890625
      ],
      [
        -1585.65478515625,
        -3789.400390625,
        1201.8616943359375
      ],
      [
        -1585.6304931640625,
        -3789.447509765625,
        1202.01953125
      ],
      [
        -1585.651611328125,
        -3789.408203125,
        1201.8824462890625
      ],
      [
        -1585.655029296875,
        -3789.400390625,
        1201.86181640625
      ],
      [
        -1585.6793212890625,
        -3789.472900390625,
        1201.54248046875
      ],
      [
        -1588.9434814453125,
        -3798.062255859375,
        1201.6485595703125
      ],
      [
        -1588.8851318359375,
        -3797.703857421875,
        1200.0
      ],
      [
        -1588.91064453125,
        -3798.045654296875,
        1201.730712890625
      ],
      [
        -1588.5440673828125,
        -3797.895751953125,
        1202.8450927734375
      ],
      [
        -1588.9434814453125,
        -3798.062255859375,
        1201.6485595703125
      ],
      [
        -1588.9107666015625,
        -3798.04541015625,
        1201.730712890625
      ],
      [
        -1589.17138671875,
        -3797.533935546875,
        1200.0
      ],
      [
        -1588.1126708984375,
        -3797.326904296875,
        1205.60302734375
      ],
      [
        -1585.4832763671875,
        -3790.30224609375,
        1207.393798828125
      ],
      [
        -1585.1417236328125,
        -3789.152587890625,
        1207.0299072265625
      ],
      [
        -1586.006103515625,
        -3789.7724609375,
        1200.0
      ],
      [
        -1585.1666259765625,
        -3788.946044921875,
        1206.9085693359375
      ],
      [
        -1585.1417236328125,
        -3789.152587890625,
        1207.0299072265625
      ],
      [
        -1587.1683349609375,
        -3795.128662109375,
        1207.6181640625
      ],
      [
        -1587.3577880859375,
        -3772.0517578125,
        1211.0
      ],
      [
        -1585.2186279296875,
        -3785.74609375,
        1211.0
      ],
      [
        -1622.019287109375,
        -3807.022705078125,
        1210.4683837890625
      ],
      [
        -1622.019287109375,
        -3807.022705078125,
        1210.4683837890625
      ],
      [
        -1616.4854736328125,
        -3808.81591796875,
        1210.0684814453125
      ],
      [
        -1613.645263671875,
        -3810.899169921875,
        1209.780517578125
      ],
      [
        -1613.645263671875,
        -3810.899169921875,
        1209.780517578125
      ],
      [
        -1615.38134765625,
        -3809.308837890625,
        1210.0543212890625
      ],
      [
        -1615.8408203125,
        -3809.02490234375,
        1210.0218505859375
      ],
      [
        -1615.8408203125,
        -3809.02490234375,
        1210.0218505859375
      ],
      [
        -1604.482421875,
        -3817.52685546875,
        1208.9130859375
      ],
      [
        -1606.911865234375,
        -3816.139892578125,
        1209.4288330078125
      ],
      [
        -1606.911865234375,
        -3816.139892578125,
        1209.4288330078125
      ],
      [
        -1614.72265625,
        -3809.715576171875,
        1210.1009521484375
      ],
      [
        -1605.520751953125,
        -3815.39892578125,
        1210.7515869140625
      ],
      [
        -1590.381103515625,
        -3761.502685546875,
        1211.0
      ],
      [
        -1587.3577880859375,
        -3772.0517578125,
        1211.0
      ],
      [
        -1605.7183837890625,
        -3814.93408203125,
        1211.0
      ],
      [
        -1615.2242431640625,
        -3808.184326171875,
        1211.0
      ],
      [
        -1615.2242431640625,
        -3808.184326171875,
        1211.0
      ],
      [
        -1585.420654296875,
        -3789.2587890625,
        1211.0
      ],
      [
        -1593.4554443359375,
        -3760.44580078125,
        1211.0
      ],
      [
        -1597.4881591796875,
        -3752.8916015625,
        1211.0
      ],
      [
        -1590.381103515625,
        -3761.502685546875,
        1211.0
      ],
      [
        -1593.4554443359375,
        -3760.44580078125,
        1211.0
      ],
      [
        -1585.2186279296875,
        -3785.74609375,
        1211.0
      ],
      [
        -1585.420654296875,
        -3789.2587890625,
        1211.0
      ],
      [
        -1629.5634765625,
        -3748.94140625,
        1211.0
      ],
      [
        -1627.712158203125,
        -3752.044677734375,
        1211.0
      ],
      [
        -1626.194091796875,
        -3750.22119140625,
        1202.800048828125
      ],
      [
        -1624.9072265625,
        -3750.885986328125,
        1200.0
      ],
      [
        -1627.11328125,
        -3748.680419921875,
        1202.800048828125
      ],
      [
        -1627.07763671875,
        -3747.248046875,
        1200.0
      ],
      [
        -1626.19384765625,
        -3750.22119140625,
        1202.800048828125
      ],
      [
        -1627.11328125,
        -3748.680419921875,
        1202.800048828125
      ],
      [
        -1624.009521484375,
        -3745.838134765625,
        1211.0
      ],
      [
        -1627.712158203125,
        -3745.838134765625,
        1211.0
      ],
      [
        -1627.712158203125,
        -3745.838134765625,
        1211.0
      ],
      [
        -1629.5634765625,
        -3748.94140625,
        1211.0
      ],
      [
        -1622.158203125,
        -3748.94140625,
        1211.0
      ],
      [
        -1624.009521484375,
        -3745.838134765625,
        1211.0
      ],
      [
        -1627.712158203125,
        -3752.044677734375,
        1211.0
      ],
      [
        -1624.009521484375,
        -3752.044677734375,
        1211.0
      ],
      [
        -1624.009521484375,
        -3752.044677734375,
        1211.0
      ],
      [
        -1622.158203125,
        -3748.94140625,
        1211.0
      ],
      [
        -1629.9488525390625,
        -3731.5908203125,
        1211.0
      ],
      [
        -1631.2977294921875,
        -3734.510986328125,
        1211.0
      ],
      [
        -1625.90234375,
        -3734.510986328125,
        1211.0
      ],
      [
        -1627.2510986328125,
        -3731.5908203125,
        1211.0
      ],
      [
        -1631.2977294921875,
        -3734.510986328125,
        1211.0
      ],
      [
        -1629.9488525390625,
        -3737.43115234375,
        1211.0
      ],
      [
        -1627.2510986328125,
        -3737.43115234375,
        1211.0
      ],
      [
        -1625.90234375,
        -3734.510986328125,
        1211.0
      ],
      [
        -1627.2510986328125,
        -3731.5908203125,
        1211.0
      ],
      [
        -1629.9488525390625,
        -3731.5908203125,
        1211.0
      ],
      [
        -1629.9488525390625,
        -3737.43115234375,
        1211.0
      ],
      [
        -1627.2510986328125,
        -3737.43115234375,
        1211.0
      ],
      [
        -1640.3336181640625,
        -3742.560791015625,
        1211.0
      ],
      [
        -1638.46630859375,
        -3742.560791015625,
        1211.0
      ],
      [
        -1641.2672119140625,
        -3740.943603515625,
        1211.0
      ],
      [
        -1640.3336181640625,
        -3742.560791015625,
        1211.0
      ],
      [
        -1638.46630859375,
        -3742.560791015625,
        1211.0
      ],
      [
        -1637.5328369140625,
        -3740.943603515625,
        1211.0
      ],
      [
        -1640.3336181640625,
        -3739.326416015625,
        1211.0
      ],
      [
        -1641.2672119140625,
        -3740.943603515625,
        1211.0
      ],
      [
        -1637.5328369140625,
        -3740.943603515625,
        1211.0
      ],
      [
        -1638.46630859375,
        -3739.326416015625,
        1211.0
      ],
      [
        -1638.46630859375,
        -3739.326416015625,
        1211.0
      ],
      [
        -1640.3336181640625,
        -3739.326416015625,
        1211.0
      ],
      [
        -1654.794189453125,
        -3740.90087890625,
        1211.67041015625
      ],
      [
        -1654.794189453125,
        -3740.90087890625,
        1211.67041015625
      ],
      [
        -1645.3634033203125,
        -3726.616943359375,
        1211.3631591796875
      ],
      [
        -1645.3634033203125,
        -3726.616943359375,
        1211.3631591796875
      ],
      [
        -1646.39697265625,
        -3727.128662109375,
        1211.0
      ],
      [
        -1673.784423828125,
        -3781.09033203125,
        1216.5938720703125
      ],
      [
        -1683.813232421875,
        -3782.228759765625,
        1211.6273193359375
      ],
      [
        -1683.3043212890625,
        -3779.8369140625,
        1211.0
      ],
      [
        -1684.7132568359375,
        -3772.991455078125,
        1211.0
      ],
      [
        -1673.6153564453125,
        -3781.212890625,
        1216.679443359375
      ],
      [
        -1637.0606689453125,
        -3723.119384765625,
        1211.0
      ],
      [
        -1649.1009521484375,
        -3781.38525390625,
        1225.8541259765625
      ],
      [
        -1647.3358154296875,
        -3779.991943359375,
        1226.5369873046875
      ],
      [
        -1649.1009521484375,
        -3781.38525390625,
        1225.8541259765625
      ],
      [
        -1647.3358154296875,
        -3779.991943359375,
        1226.5369873046875
      ],
      [
        -1646.680419921875,
        -3780.24462890625,
        1226.5474853515625
      ],
      [
        -1639.54248046875,
        -3782.9970703125,
        1226.662353515625
      ],
      [
        -1670.50634765625,
        -3813.593017578125,
        1212.7427978515625
      ],
      [
        -1670.50634765625,
        -3813.593017578125,
        1212.7427978515625
      ],
      [
        -1674.625732421875,
        -3809.49560546875,
        1213.4681396484375
      ],
      [
        -1622.708984375,
        -3742.960205078125,
        1212.7227783203125
      ],
      [
        -1630.8885498046875,
        -3745.588623046875,
        1212.9261474609375
      ],
      [
        -1638.2923583984375,
        -3739.052001953125,
        1212.614013671875
      ],
      [
        -1640.5091552734375,
        -3739.04931640625,
        1212.6292724609375
      ],
      [
        -1637.1636962890625,
        -3740.971923828125,
        1212.7130126953125
      ],
      [
        -1638.2923583984375,
        -3739.052001953125,
        1212.614013671875
      ],
      [
        -1640.5091552734375,
        -3739.04931640625,
        1212.6292724609375
      ],
      [
        -1641.6431884765625,
        -3740.97265625,
        1212.7442626953125
      ],
      [
        -1638.2691650390625,
        -3742.9326171875,
        1212.829833984375
      ],
      [
        -1637.1636962890625,
        -3740.971923828125,
        1212.7130126953125
      ],
      [
        -1641.6431884765625,
        -3740.97265625,
        1212.7442626953125
      ],
      [
        -1640.532470703125,
        -3742.935791015625,
        1212.8458251953125
      ],
      [
        -1640.532470703125,
        -3742.935791015625,
        1212.8458251953125
      ],
      [
        -1638.2691650390625,
        -3742.9326171875,
        1212.829833984375
      ],
      [
        -1630.8885498046875,
        -3745.588623046875,
        1212.9261474609375
      ],
      [
        -1640.531494140625,
        -3742.93408203125,
        1212.8370361328125
      ],
      [
        -1638.2698974609375,
        -3742.93115234375,
        1212.8231201171875
      ],
      [
        -1641.64111328125,
        -3740.972412109375,
        1212.73486328125
      ],
      [
        -1640.531494140625,
        -3742.93408203125,
        1212.8370361328125
      ],
      [
        -1638.2698974609375,
        -3742.93115234375,
        1212.8231201171875
      ],
      [
        -1640.50830078125,
        -3739.050537109375,
        1212.6217041015625
      ],
      [
        -1641.64111328125,
        -3740.972412109375,
        1212.73486328125
      ],
      [
        -1638.29296875,
        -3739.052978515625,
        1212.6085205078125
      ],
      [
        -1638.29296875,
        -3739.052978515625,
        1212.6085205078125
      ],
      [
        -1640.50830078125,
        -3739.050537109375,
        1212.6217041015625
      ],
      [
        -1641.615234375,
        -3740.970458984375,
        1212.614501953125
      ],
      [
        -1640.5303955078125,
        -3742.931884765625,
        1212.826416015625
      ],
      [
        -1640.501953125,
        -3739.060546875,
        1212.56298828125
      ],
      [
        -1641.615234375,
        -3740.970458984375,
        1212.614501953125
      ],
      [
        -1639.73388671875,
        -3739.05126953125,
        1212.6170654296875
      ],
      [
        -1640.501953125,
        -3739.060546875,
        1212.56298828125
      ],
      [
        -1640.5303955078125,
        -3742.931884765625,
        1212.826416015625
      ],
      [
        -1640.3951416015625,
        -3742.933837890625,
        1212.836181640625
      ],
      [
        -1610.4190673828125,
        -3738.73681640625,
        1211.708984375
      ],
      [
        -1622.708984375,
        -3742.960205078125,
        1212.7227783203125
      ],
      [
        -1610.4190673828125,
        -3738.73681640625,
        1211.708984375
      ],
      [
        -1610.504150390625,
        -3738.48828125,
        1211.0
      ],
      [
        -1616.2645263671875,
        -3743.73046875,
        1212.17578125
      ],
      [
        -1588.250244140625,
        -3768.5888671875,
        1211.97802734375
      ],
      [
        -1617.3963623046875,
        -3741.134521484375,
        1212.2845458984375
      ],
      [
        -1616.2645263671875,
        -3743.73046875,
        1212.17578125
      ],
      [
        -1610.4296875,
        -3738.705810546875,
        1211.62060546875
      ],
      [
        -1588.250244140625,
        -3768.5888671875,
        1211.97802734375
      ],
      [
        -1588.06787109375,
        -3769.21728515625,
        1212.0001220703125
      ],
      [
        -1610.4322509765625,
        -3738.698486328125,
        1211.599609375
      ],
      [
        -1589.95166015625,
        -3763.001220703125,
        1211.0
      ],
      [
        -1610.6409912109375,
        -3740.42138671875,
        1211.0
      ],
      [
        -1592.487548828125,
        -3799.635009765625,
        1211.3779296875
      ],
      [
        -1592.0889892578125,
        -3800.237060546875,
        1211.0
      ],
      [
        -1592.487548828125,
        -3799.635009765625,
        1211.3779296875
      ],
      [
        -1628.5582275390625,
        -3744.83984375,
        1212.8681640625
      ],
      [
        -1635.0692138671875,
        -3746.930419921875,
        1213.025634765625
      ],
      [
        -1627.5595703125,
        -3752.46142578125,
        1212.60009765625
      ],
      [
        -1628.3133544921875,
        -3751.88916015625,
        1212.60009765625
      ],
      [
        -1627.5595703125,
        -3752.46142578125,
        1212.60009765625
      ],
      [
        -1627.26416015625,
        -3752.044677734375,
        1211.0
      ],
      [
        -1628.3133544921875,
        -3751.88916015625,
        1212.60009765625
      ],
      [
        -1628.0830078125,
        -3751.423095703125,
        1211.0
      ],
      [
        -1616.2896728515625,
        -3773.779052734375,
        1226.800048828125
      ],
      [
        -1614.630126953125,
        -3779.378173828125,
        1226.0162353515625
      ],
      [
        -1625.0068359375,
        -3774.749755859375,
        1226.800048828125
      ],
      [
        -1614.630126953125,
        -3779.378173828125,
        1226.0162353515625
      ],
      [
        -1616.078125,
        -3781.5283203125,
        1226.800048828125
      ],
      [
        -1681.75146484375,
        -3795.91259765625,
        1212.100341796875
      ],
      [
        -1682.0120849609375,
        -3786.11474609375,
        1211.0
      ],
      [
        -1681.0618896484375,
        -3798.698486328125,
        1212.6998291015625
      ],
      [
        -1681.4827880859375,
        -3797.34228515625,
        1212.3682861328125
      ],
      [
        -1681.75146484375,
        -3795.91259765625,
        1212.100341796875
      ],
      [
        -1681.4827880859375,
        -3797.34228515625,
        1212.3682861328125
      ],
      [
        -1620.2213134765625,
        -3784.216064453125,
        1226.5712890625
      ],
      [
        -1616.1395263671875,
        -3782.910400390625,
        1226.4425048828125
      ],
      [
        -1620.2213134765625,
        -3784.216064453125,
        1226.5712890625
      ],
      [
        -1615.0721435546875,
        -3780.03466796875,
        1226.2554931640625
      ],
      [
        -1616.1395263671875,
        -3782.910400390625,
        1226.4425048828125
      ],
      [
        -1602.6033935546875,
        -3792.776123046875,
        1217.886474609375
      ],
      [
        -1602.6033935546875,
        -3792.776123046875,
        1217.886474609375
      ],
      [
        -1599.745361328125,
        -3788.6708984375,
        1218.2613525390625
      ],
      [
        -1620.799560546875,
        -3803.968505859375,
        1213.7716064453125
      ],
      [
        -1617.091064453125,
        -3807.716064453125,
        1211.00048828125
      ],
      [
        -1620.799560546875,
        -3803.968505859375,
        1213.7716064453125
      ],
      [
        -1602.5006103515625,
        -3792.62841796875,
        1217.89990234375
      ],
      [
        -1637.416259765625,
        -3805.57763671875,
        1211.0009765625
      ],
      [
        -1626.8829345703125,
        -3783.38818359375,
        1241.875
      ],
      [
        -1626.006591796875,
        -3786.255859375,
        1241.875
      ],
      [
        -1626.560791015625,
        -3781.650146484375,
        1241.875
      ],
      [
        -1625.6844482421875,
        -3778.7822265625,
        1241.875
      ],
      [
        -1615.826171875,
        -3786.40283203125,
        1241.875
      ],
      [
        -1614.9498291015625,
        -3783.534912109375,
        1241.875
      ],
      [
        -1616.421875,
        -3780.78515625,
        1241.875
      ],
      [
        -1617.2982177734375,
        -3777.91748046875,
        1241.875
      ],
      [
        -1614.9498291015625,
        -3783.534912109375,
        1241.875
      ],
      [
        -1616.421875,
        -3780.78515625,
        1241.875
      ],
      [
        -1619.282958984375,
        -3789.466796875,
        1241.875
      ],
      [
        -1616.654052734375,
        -3788.5107421875,
        1241.875
      ],
      [
        -1623.9801025390625,
        -3788.56201171875,
        1241.875
      ],
      [
        -1621.351318359375,
        -3789.51806640625,
        1241.875
      ],
      [
        -1624.455078125,
        -3778.075439453125,
        1241.875
      ],
      [
        -1621.8262939453125,
        -3777.11962890625,
        1241.875
      ],
      [
        -1617.2982177734375,
        -3777.91748046875,
        1241.875
      ],
      [
        -1619.9271240234375,
        -3776.96142578125,
        1241.875
      ],
      [
        -1626.006591796875,
        -3786.255859375,
        1241.875
      ],
      [
        -1623.9801025390625,
        -3788.56201171875,
        1241.875
      ],
      [
        -1616.654052734375,
        -3788.5107421875,
        1241.875
      ],
      [
        -1615.826171875,
        -3786.40283203125,
        1241.875
      ],
      [
        -1621.351318359375,
        -3789.51806640625,
        1241.875
      ],
      [
        -1619.282958984375,
        -3789.466796875,
        1241.875
      ],
      [
        -1626.8829345703125,
        -3783.38818359375,
        1241.875
      ],
      [
        -1626.560791015625,
        -3781.650146484375,
        1241.875
      ],
      [
        -1621.8262939453125,
        -3777.11962890625,
        1241.875
      ],
      [
        -1619.9271240234375,
        -3776.96142578125,
        1241.875
      ],
      [
        -1625.6844482421875,
        -3778.7822265625,
        1241.875
      ],
      [
        -1624.455078125,
        -3778.075439453125,
        1241.875
      ],
      [
        -1657.414794921875,
        -3830.28759765625,
        1335.75
      ],
      [
        -1658.8380126953125,
        -3827.779052734375,
        1335.75
      ],
      [
        -1658.8380126953125,
        -3827.779052734375,
        1335.75
      ],
      [
        -1661.2489013671875,
        -3827.779052734375,
        1335.75
      ],
      [
        -1646.408935546875,
        -3848.9287109375,
        1331.699951171875
      ],
      [
        -1644.9840087890625,
        -3844.869873046875,
        1296.6361083984375
      ],
      [
        -1669.0986328125,
        -3819.56494140625,
        1246.5
      ],
      [
        -1670.34228515625,
        -3824.205322265625,
        1296.9205322265625
      ],
      [
        -1665.1578369140625,
        -3855.753173828125,
        1335.75
      ],
      [
        -1646.408935546875,
        -3848.9287109375,
        1331.699951171875
      ],
      [
        -1646.7333984375,
        -3849.11572265625,
        1335.75
      ],
      [
        -1672.9705810546875,
        -3813.359375,
        1335.75
      ],
      [
        -1669.8072509765625,
        -3817.158447265625,
        1335.75
      ],
      [
        -1669.8072509765625,
        -3817.158447265625,
        1335.75
      ],
      [
        -1670.73193359375,
        -3823.7373046875,
        1335.75
      ],
      [
        -1674.972900390625,
        -3810.85595703125,
        1331.699951171875
      ],
      [
        -1695.416748046875,
        -3820.774169921875,
        1335.75
      ],
      [
        -1675.1318359375,
        -3810.76416015625,
        1335.75
      ],
      [
        -1697.6888427734375,
        -3821.686767578125,
        1335.75
      ],
      [
        -1695.416748046875,
        -3820.774169921875,
        1335.75
      ],
      [
        -1697.5771484375,
        -3821.83984375,
        1335.75
      ],
      [
        -1697.6888427734375,
        -3821.686767578125,
        1335.75
      ],
      [
        -1696.4490966796875,
        -3823.38525390625,
        1335.75
      ],
      [
        -1658.724609375,
        -3811.271728515625,
        1246.58984375
      ],
      [
        -1659.9678955078125,
        -3812.98974609375,
        1267.4542236328125
      ],
      [
        -1669.531494140625,
        -3808.170654296875,
        1331.699951171875
      ],
      [
        -1669.9432373046875,
        -3808.20361328125,
        1335.75
      ],
      [
        -1631.8065185546875,
        -3748.870361328125,
        1335.75
      ],
      [
        -1630.3421630859375,
        -3746.288818359375,
        1335.75
      ],
      [
        -1653.564208984375,
        -3800.56494140625,
        1246.58984375
      ],
      [
        -1659.9410400390625,
        -3812.80810546875,
        1270.5013427734375
      ],
      [
        -1658.1707763671875,
        -3809.007568359375,
        1273.595458984375
      ],
      [
        -1651.2203369140625,
        -3771.595703125,
        1246.58984375
      ],
      [
        -1654.0970458984375,
        -3770.618408203125,
        1266.9345703125
      ],
      [
        -1667.01904296875,
        -3806.760498046875,
        1335.75
      ],
      [
        -1645.8331298828125,
        -3734.7705078125,
        1335.75
      ],
      [
        -1645.653076171875,
        -3733.87255859375,
        1335.75
      ],
      [
        -1645.653076171875,
        -3733.87255859375,
        1335.75
      ],
      [
        -1645.07177734375,
        -3733.549560546875,
        1335.75
      ],
      [
        -1643.04541015625,
        -3731.993408203125,
        1335.75
      ],
      [
        -1628.9984130859375,
        -3719.9736328125,
        1335.75
      ],
      [
        -1644.6708984375,
        -3733.326904296875,
        1335.75
      ],
      [
        -1643.04541015625,
        -3731.993408203125,
        1335.75
      ],
      [
        -1644.6708984375,
        -3733.326904296875,
        1335.75
      ],
      [
        -1650.542236328125,
        -3779.121337890625,
        1335.75
      ],
      [
        -1654.7216796875,
        -3775.40625,
        1335.75
      ],
      [
        -1651.75927734375,
        -3795.2421875,
        1284.8017578125
      ],
      [
        -1651.01953125,
        -3782.736328125,
        1335.75
      ],
      [
        -1650.542236328125,
        -3779.121337890625,
        1335.75
      ],
      [
        -1663.2548828125,
        -3767.5068359375,
        1331.699951171875
      ],
      [
        -1666.506103515625,
        -3806.50732421875,
        1335.75
      ],
      [
        -1663.367919921875,
        -3767.720703125,
        1335.75
      ],
      [
        -1666.506103515625,
        -3806.50732421875,
        1335.75
      ],
      [
        -1651.75927734375,
        -3795.2421875,
        1284.8017578125
      ],
      [
        -1611.5035400390625,
        -3731.69384765625,
        1251.0999755859375
      ],
      [
        -1628.9984130859375,
        -3719.9736328125,
        1335.75
      ],
      [
        -1622.408203125,
        -3720.6796875,
        1335.75
      ],
      [
        -1613.2510986328125,
        -3727.836181640625,
        1282.656005859375
      ],
      [
        -1613.2510986328125,
        -3727.836181640625,
        1282.656005859375
      ],
      [
        -1622.408203125,
        -3720.6796875,
        1335.75
      ],
      [
        -1616.8040771484375,
        -3722.42529296875,
        1335.75
      ],
      [
        -1663.1656494140625,
        -3763.134033203125,
        1335.75
      ],
      [
        -1646.0003662109375,
        -3735.605224609375,
        1335.75
      ],
      [
        -1646.0003662109375,
        -3735.605224609375,
        1335.75
      ],
      [
        -1663.214599609375,
        -3765.825439453125,
        1335.75
      ],
      [
        -1663.1656494140625,
        -3763.134033203125,
        1335.75
      ],
      [
        -1663.214599609375,
        -3765.825439453125,
        1335.75
      ],
      [
        -1608.5672607421875,
        -3743.496337890625,
        1335.75
      ],
      [
        -1612.8905029296875,
        -3741.500244140625,
        1335.75
      ],
      [
        -1602.677001953125,
        -3740.99609375,
        1335.75
      ],
      [
        -1608.5672607421875,
        -3743.496337890625,
        1335.75
      ],
      [
        -1601.1094970703125,
        -3736.499755859375,
        1335.75
      ],
      [
        -1602.677001953125,
        -3740.99609375,
        1335.75
      ],
      [
        -1605.1812744140625,
        -3726.04541015625,
        1335.75
      ],
      [
        -1605.1812744140625,
        -3726.04541015625,
        1335.75
      ],
      [
        -1600.3179931640625,
        -3734.22998046875,
        1335.75
      ],
      [
        -1600.9962158203125,
        -3738.53564453125,
        1291.6932373046875
      ],
      [
        -1597.5826416015625,
        -3738.833251953125,
        1335.75
      ],
      [
        -1599.36474609375,
        -3740.079345703125,
        1301.4146728515625
      ],
      [
        -1593.6024169921875,
        -3745.53173828125,
        1335.75
      ],
      [
        -1645.1859130859375,
        -3845.44482421875,
        1301.603271484375
      ],
      [
        -1628.944580078125,
        -3843.723388671875,
        1335.75
      ],
      [
        -1631.2747802734375,
        -3843.885986328125,
        1335.75
      ],
      [
        -1628.263427734375,
        -3842.801025390625,
        1335.75
      ],
      [
        -1628.944580078125,
        -3843.723388671875,
        1335.75
      ],
      [
        -1609.77099609375,
        -3821.700439453125,
        1335.75
      ],
      [
        -1626.7802734375,
        -3840.792724609375,
        1335.75
      ],
      [
        -1626.7802734375,
        -3840.792724609375,
        1335.75
      ],
      [
        -1632.4429931640625,
        -3843.967529296875,
        1335.75
      ],
      [
        -1632.4429931640625,
        -3843.967529296875,
        1335.75
      ],
      [
        -1608.8824462890625,
        -3785.633544921875,
        1335.75
      ],
      [
        -1612.697265625,
        -3780.571044921875,
        1335.75
      ],
      [
        -1612.697265625,
        -3780.571044921875,
        1335.75
      ],
      [
        -1611.8148193359375,
        -3775.9375,
        1335.75
      ],
      [
        -1604.23193359375,
        -3792.931640625,
        1285.4871826171875
      ],
      [
        -1608.8125,
        -3787.233642578125,
        1268.5235595703125
      ],
      [
        -1597.8125,
        -3800.916748046875,
        1309.2608642578125
      ],
      [
        -1599.1326904296875,
        -3799.37646484375,
        1299.8212890625
      ],
      [
        -1586.5400390625,
        -3796.46533203125,
        1335.75
      ],
      [
        -1579.98876953125,
        -3771.735595703125,
        1335.75
      ],
      [
        -1594.674072265625,
        -3804.577880859375,
        1331.699951171875
      ],
      [
        -1594.674072265625,
        -3804.577880859375,
        1331.699951171875
      ],
      [
        -1586.5400390625,
        -3796.46533203125,
        1335.75
      ],
      [
        -1594.30908203125,
        -3804.9716796875,
        1335.75
      ],
      [
        -1579.98876953125,
        -3771.735595703125,
        1335.75
      ],
      [
        -1579.4644775390625,
        -3769.1318359375,
        1335.75
      ],
      [
        -1579.4644775390625,
        -3769.1318359375,
        1335.75
      ],
      [
        -1580.3922119140625,
        -3767.095458984375,
        1335.75
      ],
      [
        -1659.3653564453125,
        -3808.919189453125,
        1335.75
      ],
      [
        -1652.632080078125,
        -3794.948974609375,
        1335.75
      ],
      [
        -1652.632080078125,
        -3794.948974609375,
        1335.75
      ],
      [
        -1616.60888671875,
        -3780.5185546875,
        1242.5655517578125
      ],
      [
        -1616.60888671875,
        -3780.5185546875,
        1242.5655517578125
      ],
      [
        -1616.6710205078125,
        -3779.969970703125,
        1241.875
      ],
      [
        -1620.4119873046875,
        -3789.494873046875,
        1241.875
      ],
      [
        -1606.439697265625,
        -3818.253662109375,
        1335.75
      ],
      [
        -1608.5616455078125,
        -3820.343017578125,
        1335.75
      ],
      [
        -1606.439697265625,
        -3818.253662109375,
        1335.75
      ],
      [
        -1608.5616455078125,
        -3820.343017578125,
        1335.75
      ],
      [
        -1423.2099609375,
        -3857.77978515625,
        1242.3587646484375
      ],
      [
        -1423.1636962890625,
        -3857.63037109375,
        1241.875
      ],
      [
        -1423.2099609375,
        -3857.77978515625,
        1242.3587646484375
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1301.125
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1301.125
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1301.125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1301.125
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1301.125
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1301.125
      ],
      [
        -1469.0931396484375,
        -3961.165771484375,
        1301.125
      ],
      [
        -1503.587890625,
        -3961.165771484375,
        1247.6492919921875
      ],
      [
        -1503.587890625,
        -3961.165771484375,
        1247.6492919921875
      ],
      [
        -1528.8990478515625,
        -3961.165771484375,
        1278.616943359375
      ],
      [
        -1528.8990478515625,
        -3961.165771484375,
        1278.616943359375
      ],
      [
        -1546.6568603515625,
        -3961.165771484375,
        1301.125
      ],
      [
        -1470.02880859375,
        -3955.164306640625,
        1277.917724609375
      ],
      [
        -1455.058837890625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1493.1160888671875,
        -3955.164306640625,
        1241.875
      ],
      [
        -1470.02880859375,
        -3955.164306640625,
        1277.917724609375
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1262.353271484375
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1254.161376953125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1243.3575439453125
      ],
      [
        -1498.9228515625,
        -3958.818359375,
        1246.370361328125
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1256.981689453125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1254.161376953125
      ],
      [
        -1493.9097900390625,
        -3955.498291015625,
        1241.875
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1243.357421875
      ],
      [
        -1498.99560546875,
        -3957.6376953125,
        1241.875
      ],
      [
        -1493.939208984375,
        -3955.447265625,
        1241.875
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1243.417236328125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1243.418212890625
      ],
      [
        -1498.9737548828125,
        -3957.599853515625,
        1241.875
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1301.125
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1301.125
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1301.125
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1301.125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1301.125
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1301.125
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1301.125
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1300.42236328125
      ],
      [
        -1550.5213623046875,
        -3959.51318359375,
        1301.125
      ],
      [
        -1551.2999267578125,
        -3958.164794921875,
        1298.1153564453125
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1287.0257568359375
      ],
      [
        -1546.102783203125,
        -3955.164306640625,
        1282.6341552734375
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1289.33203125
      ],
      [
        -1546.4710693359375,
        -3955.164306640625,
        1267.332763671875
      ],
      [
        -1544.4361572265625,
        -3958.27978515625,
        1267.0531005859375
      ],
      [
        -1544.369873046875,
        -3958.1650390625,
        1267.025390625
      ],
      [
        -1546.1026611328125,
        -3955.164306640625,
        1267.233642578125
      ],
      [
        -1544.4361572265625,
        -3958.27978515625,
        1267.0531005859375
      ],
      [
        -1546.4710693359375,
        -3955.164306640625,
        1267.332763671875
      ],
      [
        -1546.1026611328125,
        -3955.164306640625,
        1267.233642578125
      ],
      [
        -1544.369873046875,
        -3958.1650390625,
        1267.025390625
      ],
      [
        -1546.4710693359375,
        -3955.164306640625,
        1247.73974609375
      ],
      [
        -1546.1026611328125,
        -3955.164306640625,
        1247.7406005859375
      ],
      [
        -1544.369873046875,
        -3958.1650390625,
        1248.953857421875
      ],
      [
        -1544.4361572265625,
        -3958.27978515625,
        1249.0
      ],
      [
        -1549.436279296875,
        -3955.164306640625,
        1268.0740966796875
      ],
      [
        -1546.4710693359375,
        -3955.164306640625,
        1267.332763671875
      ],
      [
        -1546.4710693359375,
        -3955.164306640625,
        1267.332763671875
      ],
      [
        -1549.436279296875,
        -3955.164306640625,
        1268.0740966796875
      ],
      [
        -1542.637451171875,
        -3955.164306640625,
        1278.2418212890625
      ],
      [
        -1542.6373291015625,
        -3955.164306640625,
        1266.301513671875
      ],
      [
        -1542.6373291015625,
        -3955.164306640625,
        1266.301513671875
      ],
      [
        -1542.6373291015625,
        -3955.164306640625,
        1247.7486572265625
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1301.125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1301.125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1301.125
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1301.125
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1301.125
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1301.125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1301.125
      ],
      [
        -1499.2154541015625,
        -3958.0185546875,
        1295.5570068359375
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1293.91748046875
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1293.91748046875
      ],
      [
        -1499.2154541015625,
        -3958.0185546875,
        1295.5570068359375
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1293.91748046875
      ],
      [
        -1494.78466796875,
        -3955.164306640625,
        1294.25732421875
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1293.81201171875
      ],
      [
        -1494.78466796875,
        -3955.164306640625,
        1294.25732421875
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1293.91748046875
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1293.81201171875
      ],
      [
        -1494.78466796875,
        -3955.164306640625,
        1249.27001953125
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1248.1011962890625
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1248.0313720703125
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1248.0313720703125
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1248.1011962890625
      ],
      [
        -1494.78466796875,
        -3955.164306640625,
        1249.27001953125
      ],
      [
        -1499.2154541015625,
        -3958.0185546875,
        1254.8665771484375
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1254.2847900390625
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1254.2847900390625
      ],
      [
        -1499.2154541015625,
        -3958.0185546875,
        1254.8665771484375
      ],
      [
        -1497.8231201171875,
        -3955.607177734375,
        1248.0313720703125
      ],
      [
        -1499.2154541015625,
        -3958.0185546875,
        1249.0
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1254.3375244140625
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1254.3375244140625
      ],
      [
        -1541.765869140625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1531.3548583984375,
        -3958.2041015625,
        1301.125
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1293.7171630859375
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1293.7171630859375
      ],
      [
        -1531.3548583984375,
        -3958.2041015625,
        1301.125
      ],
      [
        -1541.765869140625,
        -3955.164306640625,
        1301.125
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1293.7171630859375
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1293.7171630859375
      ],
      [
        -1536.5072021484375,
        -3955.164306640625,
        1270.4718017578125
      ],
      [
        -1512.664794921875,
        -3961.165771484375,
        1258.754638671875
      ],
      [
        -1536.5072021484375,
        -3955.164306640625,
        1270.4718017578125
      ],
      [
        -1530.4105224609375,
        -3955.164306640625,
        1263.0125732421875
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1247.8521728515625
      ],
      [
        -1513.1339111328125,
        -3955.164306640625,
        1241.875
      ],
      [
        -1505.7161865234375,
        -3961.165771484375,
        1250.253173828125
      ],
      [
        -1517.9815673828125,
        -3955.164306640625,
        1247.8060302734375
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1247.8521728515625
      ],
      [
        -1498.1605224609375,
        -3955.164306640625,
        1247.8521728515625
      ],
      [
        -1551.7701416015625,
        -3958.979248046875,
        1301.125
      ],
      [
        -1560.691162109375,
        -3955.164306640625,
        1301.125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1575.680419921875,
        -3919.165771484375,
        1301.125
      ],
      [
        -1569.3245849609375,
        -3919.165771484375,
        1257.2489013671875
      ],
      [
        -1567.161376953125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1569.3245849609375,
        -3919.165771484375,
        1257.2489013671875
      ],
      [
        -1541.1932373046875,
        -3943.9736328125,
        1243.2423095703125
      ],
      [
        -1518.6234130859375,
        -3955.164306640625,
        1247.8045654296875
      ],
      [
        -1544.2503662109375,
        -3950.455810546875,
        1266.3309326171875
      ],
      [
        -1530.6783447265625,
        -3955.164306640625,
        1263.0845947265625
      ],
      [
        -1530.678955078125,
        -3955.164306640625,
        1263.0848388671875
      ],
      [
        -1544.25048828125,
        -3950.4560546875,
        1266.3310546875
      ],
      [
        -1544.2503662109375,
        -3950.455810546875,
        1266.3309326171875
      ],
      [
        -1553.166748046875,
        -3947.2939453125,
        1268.2601318359375
      ],
      [
        -1553.166748046875,
        -3947.2939453125,
        1268.2601318359375
      ],
      [
        -1544.2503662109375,
        -3950.455810546875,
        1266.3309326171875
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1277.43212890625
      ],
      [
        -1545.9014892578125,
        -3953.956787109375,
        1301.125
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1278.0955810546875
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1278.0955810546875
      ],
      [
        -1545.9014892578125,
        -3953.956787109375,
        1301.125
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1277.43212890625
      ],
      [
        -1541.12939453125,
        -3943.838134765625,
        1243.1878662109375
      ],
      [
        -1517.9813232421875,
        -3955.164306640625,
        1247.8060302734375
      ],
      [
        -1530.41064453125,
        -3955.164306640625,
        1263.0126953125
      ],
      [
        -1541.0958251953125,
        -3951.550537109375,
        1265.5765380859375
      ],
      [
        -1541.062744140625,
        -3951.561767578125,
        1265.5684814453125
      ],
      [
        -1530.4107666015625,
        -3955.164306640625,
        1263.0125732421875
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1258.6231689453125
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1259.673583984375
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1259.673583984375
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1258.6231689453125
      ],
      [
        -1566.4993896484375,
        -3919.165771484375,
        1268.9251708984375
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1259.673583984375
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1259.673583984375
      ],
      [
        -1566.4993896484375,
        -3919.165771484375,
        1268.9251708984375
      ],
      [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1488.8072509765625,
        -3919.165771484375,
        1248.729248046875
      ],
      [
        -1488.7708740234375,
        -3941.132080078125,
        1250.6064453125
      ],
      [
        -1488.77099609375,
        -3941.13232421875,
        1250.6064453125
      ],
      [
        -1488.807373046875,
        -3919.165771484375,
        1248.729248046875
      ],
      [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      [
        -1479.3568115234375,
        -3919.165771484375,
        1252.698486328125
      ],
      [
        -1479.3568115234375,
        -3919.165771484375,
        1252.698486328125
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1277.43212890625
      ],
      [
        -1479.3568115234375,
        -3919.165771484375,
        1284.8291015625
      ],
      [
        -1479.3568115234375,
        -3919.165771484375,
        1284.8291015625
      ],
      [
        -1525.5880126953125,
        -3919.165771484375,
        1277.43212890625
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1278.0955810546875
      ],
      [
        -1545.9014892578125,
        -3953.956787109375,
        1301.125
      ],
      [
        -1557.4075927734375,
        -3919.165771484375,
        1301.125
      ],
      [
        -1545.9014892578125,
        -3953.956787109375,
        1301.125
      ],
      [
        -1529.4930419921875,
        -3919.165771484375,
        1278.0955810546875
      ],
      [
        -1557.4075927734375,
        -3919.165771484375,
        1301.125
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1301.125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1568.7464599609375,
        -3913.164306640625,
        1241.875
      ],
      [
        -1570.8621826171875,
        -3915.40673828125,
        1261.120361328125
      ],
      [
        -1569.5673828125,
        -3913.164306640625,
        1247.70947265625
      ],
      [
        -1570.8621826171875,
        -3915.40673828125,
        1261.120361328125
      ],
      [
        -1569.567626953125,
        -3919.165771484375,
        1258.9263916015625
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1265.5040283203125
      ],
      [
        -1564.46533203125,
        -3916.0,
        1268.1163330078125
      ],
      [
        -1566.1024169921875,
        -3919.165771484375,
        1268.825927734375
      ],
      [
        -1564.3699951171875,
        -3916.165283203125,
        1268.108154296875
      ],
      [
        -1566.1024169921875,
        -3919.165771484375,
        1268.825927734375
      ],
      [
        -1564.46533203125,
        -3916.0,
        1268.1163330078125
      ],
      [
        -1564.3699951171875,
        -3916.165283203125,
        1268.108154296875
      ],
      [
        -1566.1029052734375,
        -3913.164306640625,
        1268.9263916015625
      ],
      [
        -1567.136962890625,
        -3913.164306640625,
        1269.1849365234375
      ],
      [
        -1564.46533203125,
        -3916.0,
        1268.1163330078125
      ],
      [
        -1564.46533203125,
        -3916.0,
        1268.1163330078125
      ],
      [
        -1567.136962890625,
        -3913.164306640625,
        1269.1849365234375
      ],
      [
        -1566.1029052734375,
        -3913.164306640625,
        1268.9263916015625
      ],
      [
        -1562.6376953125,
        -3919.165771484375,
        1267.959716796875
      ],
      [
        -1562.6376953125,
        -3919.165771484375,
        1267.959716796875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1301.125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1301.125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1531.204833984375,
        -3916.0,
        1278.6439208984375
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1278.156982421875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1278.767578125
      ],
      [
        -1531.204833984375,
        -3916.0,
        1278.6439208984375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1278.767578125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1278.156982421875
      ],
      [
        -1531.204833984375,
        -3916.0,
        1259.80126953125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1259.8406982421875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1259.692138671875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1259.692138671875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1259.8406982421875
      ],
      [
        -1531.204833984375,
        -3916.0,
        1259.80126953125
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1259.7926025390625
      ],
      [
        -1531.204833984375,
        -3916.0,
        1259.80126953125
      ],
      [
        -1531.204833984375,
        -3916.0,
        1259.80126953125
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1259.7926025390625
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1259.5548095703125
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1259.7987060546875
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1259.7926025390625
      ],
      [
        -1529.5853271484375,
        -3913.1953125,
        1259.7926025390625
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1259.7987060546875
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1259.5548095703125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1258.7615966796875
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1258.6689453125
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1258.6689453125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1258.7615966796875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1277.51953125
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1277.25830078125
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1277.25830078125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1277.51953125
      ],
      [
        -1524.465087890625,
        -3916.0,
        1276.5655517578125
      ],
      [
        -1524.369873046875,
        -3916.164794921875,
        1276.63525390625
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1277.25830078125
      ],
      [
        -1525.8807373046875,
        -3918.781494140625,
        1277.25830078125
      ],
      [
        -1524.369873046875,
        -3916.164794921875,
        1276.63525390625
      ],
      [
        -1524.465087890625,
        -3916.0,
        1276.5655517578125
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1275.75341796875
      ],
      [
        -1526.1026611328125,
        -3913.164306640625,
        1275.800537109375
      ],
      [
        -1524.465087890625,
        -3916.0,
        1276.5655517578125
      ],
      [
        -1524.465087890625,
        -3916.0,
        1276.5655517578125
      ],
      [
        -1526.1026611328125,
        -3913.164306640625,
        1275.800537109375
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1275.75341796875
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1259.8013916015625
      ],
      [
        -1533.0325927734375,
        -3913.164306640625,
        1260.6588134765625
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1259.848876953125
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1259.848876953125
      ],
      [
        -1533.0325927734375,
        -3913.164306640625,
        1260.6588134765625
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1259.8013916015625
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1278.8011474609375
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1278.8011474609375
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1259.848876953125
      ],
      [
        -1531.3953857421875,
        -3916.0,
        1259.848876953125
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1259.8013916015625
      ],
      [
        -1529.602783203125,
        -3913.164306640625,
        1259.8013916015625
      ],
      [
        -1558.45458984375,
        -3916.0,
        1301.125
      ],
      [
        -1558.45458984375,
        -3916.0,
        1301.125
      ],
      [
        -1522.63720703125,
        -3919.165771484375,
        1277.904296875
      ],
      [
        -1522.63720703125,
        -3919.165771484375,
        1277.904296875
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1301.125
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      [
        -1481.204833984375,
        -3916.0,
        1251.6539306640625
      ],
      [
        -1481.3001708984375,
        -3916.1650390625,
        1251.6279296875
      ],
      [
        -1479.567626953125,
        -3919.165771484375,
        1252.60986328125
      ],
      [
        -1481.204833984375,
        -3916.0,
        1251.6539306640625
      ],
      [
        -1479.567626953125,
        -3919.165771484375,
        1252.60986328125
      ],
      [
        -1481.3001708984375,
        -3916.1650390625,
        1251.6279296875
      ],
      [
        -1479.567626953125,
        -3919.165771484375,
        1284.79541015625
      ],
      [
        -1481.2047119140625,
        -3916.0,
        1283.4871826171875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1283.5264892578125
      ],
      [
        -1481.2047119140625,
        -3916.0,
        1283.4871826171875
      ],
      [
        -1479.567626953125,
        -3919.165771484375,
        1284.79541015625
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1283.5264892578125
      ],
      [
        -1481.2047119140625,
        -3916.0,
        1283.4871826171875
      ],
      [
        -1479.4794921875,
        -3913.164306640625,
        1283.26025390625
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1283.2462158203125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1283.2462158203125
      ],
      [
        -1479.4794921875,
        -3913.164306640625,
        1283.26025390625
      ],
      [
        -1481.2047119140625,
        -3916.0,
        1283.4871826171875
      ],
      [
        -1479.4794921875,
        -3913.164306640625,
        1251.7054443359375
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1251.66845703125
      ],
      [
        -1481.204833984375,
        -3916.0,
        1251.6539306640625
      ],
      [
        -1481.204833984375,
        -3916.0,
        1251.6539306640625
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1251.66845703125
      ],
      [
        -1479.4794921875,
        -3913.164306640625,
        1251.7054443359375
      ],
      [
        -1483.032470703125,
        -3919.165771484375,
        1251.1546630859375
      ],
      [
        -1483.032470703125,
        -3919.165771484375,
        1251.1546630859375
      ],
      [
        -1483.032470703125,
        -3919.165771484375,
        1284.240966796875
      ],
      [
        -1483.032470703125,
        -3919.165771484375,
        1284.240966796875
      ],
      [
        -1502.88525390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1502.88525390625,
        -3913.164306640625,
        1241.875
      ],
      [
        -1571.779296875,
        -3913.164306640625,
        1263.4296875
      ],
      [
        -1573.0325927734375,
        -3913.164306640625,
        1272.0819091796875
      ],
      [
        -1571.779296875,
        -3913.164306640625,
        1263.4296875
      ],
      [
        -1577.23974609375,
        -3913.164306640625,
        1301.125
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1586.100830078125,
        -3873.165771484375,
        1290.1348876953125
      ],
      [
        -1579.310546875,
        -3873.165771484375,
        1241.875
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1267.380615234375
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1271.1053466796875
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1271.1053466796875
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1267.380615234375
      ],
      [
        -1500.3482666015625,
        -3873.165771484375,
        1272.8258056640625
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1272.2752685546875
      ],
      [
        -1503.789306640625,
        -3873.165771484375,
        1272.2752685546875
      ],
      [
        -1500.3482666015625,
        -3873.165771484375,
        1272.8258056640625
      ],
      [
        -1545.4566650390625,
        -3885.115234375,
        1267.728271484375
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1271.1053466796875
      ],
      [
        -1554.9635009765625,
        -3873.165771484375,
        1271.7935791015625
      ],
      [
        -1567.0582275390625,
        -3912.90576171875,
        1269.2017822265625
      ],
      [
        -1567.0582275390625,
        -3912.90576171875,
        1269.2017822265625
      ],
      [
        -1554.9635009765625,
        -3873.165771484375,
        1271.7935791015625
      ],
      [
        -1552.210693359375,
        -3873.165771484375,
        1271.1053466796875
      ],
      [
        -1545.4566650390625,
        -3885.115234375,
        1267.728271484375
      ],
      [
        -1429.882568359375,
        -3873.165771484375,
        1301.125
      ],
      [
        -1427.952880859375,
        -3873.165771484375,
        1290.49755859375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1550.4652099609375,
        -3870.0,
        1271.72802734375
      ],
      [
        -1552.1024169921875,
        -3873.165771484375,
        1271.0970458984375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1271.6812744140625
      ],
      [
        -1550.4652099609375,
        -3870.0,
        1271.72802734375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1271.6812744140625
      ],
      [
        -1552.1024169921875,
        -3873.165771484375,
        1271.0970458984375
      ],
      [
        -1550.274658203125,
        -3870.0,
        1271.71337890625
      ],
      [
        -1550.274658203125,
        -3870.0,
        1271.71337890625
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1272.2584228515625
      ],
      [
        -1503.5677490234375,
        -3873.165771484375,
        1272.3106689453125
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1272.2584228515625
      ],
      [
        -1503.5677490234375,
        -3873.165771484375,
        1272.3106689453125
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1267.4185791015625
      ],
      [
        -1505.204833984375,
        -3870.0,
        1268.2464599609375
      ],
      [
        -1505.3001708984375,
        -3870.1650390625,
        1268.21435546875
      ],
      [
        -1505.204833984375,
        -3870.0,
        1268.2464599609375
      ],
      [
        -1503.6796875,
        -3872.971923828125,
        1267.4185791015625
      ],
      [
        -1505.3001708984375,
        -3870.1650390625,
        1268.21435546875
      ],
      [
        -1507.0325927734375,
        -3873.165771484375,
        1267.630126953125
      ],
      [
        -1507.0325927734375,
        -3873.165771484375,
        1267.630126953125
      ],
      [
        -1584.9537353515625,
        -3867.164306640625,
        1270.7171630859375
      ],
      [
        -1580.8956298828125,
        -3867.164306640625,
        1241.875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1301.125
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1301.125
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1301.125
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      [
        -1431.44189453125,
        -3867.164306640625,
        1301.125
      ],
      [
        -1426.1029052734375,
        -3867.164306640625,
        1271.720458984375
      ],
      [
        -1487.1475830078125,
        -3906.009765625,
        1335.75
      ],
      [
        -1525.3603515625,
        -3894.0986328125,
        1335.75
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1322.179443359375
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1322.127197265625
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1326.4039306640625
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1326.7423095703125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1323.0230712890625
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1322.9708251953125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1322.127197265625
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1323.086181640625
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1323.1904296875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1322.179443359375
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1323.086181640625
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1324.097412109375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1324.1495361328125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1323.1904296875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1324.097412109375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1324.1495361328125
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1322.9708251953125
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1323.9296875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1324.0341796875
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1323.0230712890625
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1323.9296875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1324.94091796875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1324.9932861328125
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1324.0341796875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1324.94091796875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1324.9932861328125
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1326.9200439453125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1326.4039306640625
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1326.7423095703125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1327.5968017578125
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1327.7744140625
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1326.9200439453125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1327.5968017578125
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1328.11279296875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1328.11279296875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1327.7744140625
      ],
      [
        -1561.6781005859375,
        -3903.998291015625,
        1335.75
      ],
      [
        -1532.3333740234375,
        -3895.583251953125,
        1335.75
      ],
      [
        -1532.3333740234375,
        -3895.583251953125,
        1335.75
      ],
      [
        -1525.3603515625,
        -3894.0986328125,
        1335.75
      ],
      [
        -1487.1475830078125,
        -3906.009765625,
        1335.75
      ],
      [
        -1486.3338623046875,
        -3907.87060546875,
        1335.75
      ],
      [
        -1469.6663818359375,
        -3897.468994140625,
        1325.274169921875
      ],
      [
        -1471.08984375,
        -3942.72021484375,
        1335.7464599609375
      ],
      [
        -1469.6663818359375,
        -3897.468994140625,
        1325.274169921875
      ],
      [
        -1471.08984375,
        -3942.72021484375,
        1335.7464599609375
      ],
      [
        -1471.087646484375,
        -3942.737060546875,
        1335.75
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1317.566650390625
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1317.228271484375
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1317.228271484375
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1316.3739013671875
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1316.3739013671875
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1315.8577880859375
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1317.050537109375
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1317.566650390625
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1315.8577880859375
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1316.1961669921875
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1316.1961669921875
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1317.050537109375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1331.5872802734375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1331.7747802734375
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1333.072509765625
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1331.5872802734375
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1331.7747802734375
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1333.447021484375
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1334.744873046875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1333.072509765625
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1333.447021484375
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1334.93212890625
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1334.93212890625
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1334.744873046875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1333.414306640625
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1331.59912109375
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1331.59912109375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1330.282958984375
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1330.7823486328125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1332.597412109375
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1332.597412109375
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1333.9134521484375
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1333.9134521484375
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1333.414306640625
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1330.282958984375
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1330.7823486328125
      ],
      [
        -1521.003662109375,
        -3916.0,
        1334.5186767578125
      ],
      [
        -1521.1932373046875,
        -3916.0,
        1335.75
      ],
      [
        -1524.5965576171875,
        -3910.105224609375,
        1335.75
      ],
      [
        -1524.41845703125,
        -3909.796630859375,
        1333.4356689453125
      ],
      [
        -1524.41845703125,
        -3909.796630859375,
        1333.4356689453125
      ],
      [
        -1524.5965576171875,
        -3910.105224609375,
        1335.75
      ],
      [
        -1531.4034423828125,
        -3910.105224609375,
        1335.75
      ],
      [
        -1531.5264892578125,
        -3909.89208984375,
        1334.151611328125
      ],
      [
        -1531.5264892578125,
        -3909.89208984375,
        1334.151611328125
      ],
      [
        -1531.4034423828125,
        -3910.105224609375,
        1335.75
      ],
      [
        -1534.5703125,
        -3915.590576171875,
        1335.75
      ],
      [
        -1523.6522216796875,
        -3920.25927734375,
        1335.75
      ],
      [
        -1521.1932373046875,
        -3916.0,
        1335.75
      ],
      [
        -1521.003662109375,
        -3916.0,
        1334.518798828125
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1334.369140625
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1334.70751953125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1334.88525390625
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1334.369140625
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1334.70751953125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1335.56201171875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1335.739501953125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1334.88525390625
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1335.56201171875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1530.6685791015625,
        -3917.2587890625,
        1335.75
      ],
      [
        -1526.20947265625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1335.739501953125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1329.8250732421875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1330.679443359375
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1330.679443359375
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1331.1954345703125
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1329.4866943359375
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1329.8250732421875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1331.1954345703125
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1330.8570556640625
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1330.8570556640625
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1330.0028076171875
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1330.0028076171875
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1329.4866943359375
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1322.6966552734375
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1321.84228515625
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1321.84228515625
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1321.326171875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1323.0350341796875
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1322.6966552734375
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1322.51904296875
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1323.0350341796875
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1321.66455078125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1322.51904296875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1321.326171875
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1321.66455078125
      ],
      [
        -1568.6912841796875,
        -3906.009521484375,
        1335.75
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1322.36474609375
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1323.3623046875
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1323.3623046875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1324.2996826171875
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1322.3046875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1322.36474609375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1323.2421875
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1322.3046875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1324.23974609375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1323.2421875
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1324.2996826171875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1324.23974609375
      ],
      [
        -1569.889892578125,
        -3906.009765625,
        1335.75
      ],
      [
        -1568.6912841796875,
        -3906.009521484375,
        1335.75
      ],
      [
        -1569.9837646484375,
        -3906.380126953125,
        1335.75
      ],
      [
        -1569.889892578125,
        -3906.009765625,
        1335.75
      ],
      [
        -1570.365234375,
        -3907.885009765625,
        1335.75
      ],
      [
        -1574.4149169921875,
        -3898.30029296875,
        1326.2344970703125
      ],
      [
        -1577.218994140625,
        -3934.794189453125,
        1335.615478515625
      ],
      [
        -1574.4149169921875,
        -3898.30029296875,
        1326.2344970703125
      ],
      [
        -1577.32568359375,
        -3935.345947265625,
        1335.75
      ],
      [
        -1577.218994140625,
        -3934.794189453125,
        1335.615478515625
      ],
      [
        -1531.798583984375,
        -3910.401611328125,
        1334.2945556640625
      ],
      [
        -1534.8067626953125,
        -3916.0,
        1335.75
      ],
      [
        -1534.855224609375,
        -3916.0,
        1335.4351806640625
      ],
      [
        -1534.855224609375,
        -3916.0,
        1335.4351806640625
      ],
      [
        -1534.8067626953125,
        -3916.0,
        1335.75
      ],
      [
        -1534.26806640625,
        -3916.93310546875,
        1335.75
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1330.7362060546875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1331.3369140625
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1331.3369140625
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1335.75
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1332.331298828125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1332.72509765625
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1332.12451171875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1332.331298828125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1335.75
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1332.72509765625
      ],
      [
        -1564.85009765625,
        -3905.650390625,
        1329.275146484375
      ],
      [
        -1564.9462890625,
        -3916.0,
        1332.01513671875
      ],
      [
        -1564.9462890625,
        -3916.0,
        1332.01513671875
      ],
      [
        -1564.85009765625,
        -3905.650390625,
        1329.275146484375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1332.12451171875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1332.0330810546875
      ],
      [
        -1564.938720703125,
        -3915.179931640625,
        1331.798095703125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1332.032958984375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1335.75
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1334.28515625
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1331.1300048828125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1330.7362060546875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1331.1300048828125
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1320.70166015625
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1321.6961669921875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1320.1009521484375
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1320.70166015625
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1321.6961669921875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1322.090087890625
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1322.090087890625
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1321.4893798828125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1320.494873046875
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1320.1009521484375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1321.4893798828125
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1320.494873046875
      ],
      [
        -1467.702880859375,
        -3944.345703125,
        1330.626220703125
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1308.5743408203125
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1307.2581787109375
      ],
      [
        -1442.3699951171875,
        -3870.1650390625,
        1307.2581787109375
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1307.7574462890625
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1310.389404296875
      ],
      [
        -1444.1025390625,
        -3873.165771484375,
        1308.5743408203125
      ],
      [
        -1444.1025390625,
        -3867.164306640625,
        1307.7574462890625
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1309.572509765625
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1310.888671875
      ],
      [
        -1447.5675048828125,
        -3873.165771484375,
        1310.389404296875
      ],
      [
        -1447.5675048828125,
        -3867.164306640625,
        1309.572509765625
      ],
      [
        -1449.300048828125,
        -3870.1650390625,
        1310.888671875
      ],
      [
        -1467.702880859375,
        -3944.345703125,
        1330.626220703125
      ],
      [
        -1474.9388427734375,
        -3954.139892578125,
        1335.75
      ],
      [
        -1579.23388671875,
        -3942.949951171875,
        1335.704345703125
      ],
      [
        -1579.2200927734375,
        -3943.022705078125,
        1335.75
      ],
      [
        -1579.23388671875,
        -3942.949951171875,
        1335.704345703125
      ],
      [
        -1519.7418212890625,
        -3994.3720703125,
        1332.5885009765625
      ],
      [
        -1524.750244140625,
        -3992.504150390625,
        1332.9854736328125
      ],
      [
        -1517.5982666015625,
        -3997.232421875,
        1335.4068603515625
      ],
      [
        -1519.7418212890625,
        -3994.3720703125,
        1332.5885009765625
      ],
      [
        -1524.750244140625,
        -3992.504150390625,
        1332.9854736328125
      ],
      [
        -1526.329345703125,
        -3993.05126953125,
        1334.758056640625
      ],
      [
        -1527.30517578125,
        -3993.560791015625,
        1335.75
      ],
      [
        -1528.23681640625,
        -3995.618408203125,
        1335.75
      ],
      [
        -1520.4866943359375,
        -4003.042236328125,
        1335.75
      ],
      [
        -1517.9039306640625,
        -3997.33837890625,
        1335.75
      ],
      [
        -1517.5982666015625,
        -3997.232421875,
        1335.4068603515625
      ],
      [
        -1528.23681640625,
        -3995.618408203125,
        1335.75
      ],
      [
        -1528.77685546875,
        -4000.612060546875,
        1335.75
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1302.9295654296875
      ],
      [
        -1546.656982421875,
        -3961.165771484375,
        1301.125
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1302.9295654296875
      ],
      [
        -1550.521484375,
        -3959.513427734375,
        1301.125
      ],
      [
        -1567.59375,
        -3976.08935546875,
        1335.75
      ],
      [
        -1527.2130126953125,
        -3993.357421875,
        1335.75
      ],
      [
        -1517.125,
        -3995.6181640625,
        1335.75
      ],
      [
        -1517.095703125,
        -3995.347412109375,
        1335.75
      ],
      [
        -1519.0499267578125,
        -3995.29541015625,
        1333.4981689453125
      ],
      [
        -1517.125,
        -3995.6181640625,
        1335.75
      ],
      [
        -1518.8905029296875,
        -3991.46826171875,
        1333.2056884765625
      ],
      [
        -1523.7069091796875,
        -3992.893310546875,
        1332.90283203125
      ],
      [
        -1516.688720703125,
        -3991.583984375,
        1335.75
      ],
      [
        -1518.8905029296875,
        -3991.46826171875,
        1333.2056884765625
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1310.1876220703125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1309.8377685546875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1309.8377685546875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.909423828125
      ],
      [
        -1527.4398193359375,
        -3919.165771484375,
        1308.4547119140625
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1324.7313232421875
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1325.909423828125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.909423828125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1309.248046875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1308.408447265625
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1308.308349609375
      ],
      [
        -1526.397216796875,
        -3913.164306640625,
        1308.3082275390625
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1308.308349609375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1310.1876220703125
      ],
      [
        -1529.5855712890625,
        -3913.195556640625,
        1308.304931640625
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1309.248046875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1308.408447265625
      ],
      [
        -1524.4652099609375,
        -3916.0,
        1309.514892578125
      ],
      [
        -1524.7103271484375,
        -3916.0,
        1309.1185302734375
      ],
      [
        -1526.4720458984375,
        -3918.646484375,
        1308.740478515625
      ],
      [
        -1526.1722412109375,
        -3919.165771484375,
        1309.7098388671875
      ],
      [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      [
        -1524.369873046875,
        -3916.164794921875,
        1309.82275390625
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1309.514404296875
      ],
      [
        -1526.36279296875,
        -3913.164306640625,
        1309.09375
      ],
      [
        -1526.617431640625,
        -3913.60546875,
        1308.270263671875
      ],
      [
        -1524.7103271484375,
        -3916.0,
        1309.1185302734375
      ],
      [
        -1524.4652099609375,
        -3916.0,
        1309.514892578125
      ],
      [
        -1529.602294921875,
        -3913.224609375,
        1308.98095703125
      ],
      [
        -1529.385498046875,
        -3913.600341796875,
        1308.27978515625
      ],
      [
        -1529.3502197265625,
        -3913.611083984375,
        1308.2596435546875
      ],
      [
        -1526.64990234375,
        -3913.611083984375,
        1308.2596435546875
      ],
      [
        -1526.617431640625,
        -3913.60546875,
        1308.270263671875
      ],
      [
        -1526.36279296875,
        -3913.164306640625,
        1309.09375
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1309.09375
      ],
      [
        -1526.1722412109375,
        -3919.165771484375,
        1309.7098388671875
      ],
      [
        -1526.4720458984375,
        -3918.646484375,
        1308.740478515625
      ],
      [
        -1527.5687255859375,
        -3918.437255859375,
        1308.35009765625
      ],
      [
        -1529.3709716796875,
        -3919.165771484375,
        1309.7099609375
      ],
      [
        -1529.385498046875,
        -3913.600341796875,
        1308.27978515625
      ],
      [
        -1529.602294921875,
        -3913.224853515625,
        1308.98095703125
      ],
      [
        -1530.201171875,
        -3914.26171875,
        1308.9810791015625
      ],
      [
        -1523.946533203125,
        -3913.164306640625,
        1313.0
      ],
      [
        -1523.2919921875,
        -3914.298095703125,
        1313.0
      ],
      [
        -1522.637451171875,
        -3913.164306640625,
        1321.50341796875
      ],
      [
        -1523.2919921875,
        -3914.298095703125,
        1313.0
      ],
      [
        -1523.946533203125,
        -3913.164306640625,
        1313.0
      ],
      [
        -1524.2747802734375,
        -3916.0,
        1309.82275390625
      ],
      [
        -1524.2747802734375,
        -3916.0,
        1309.82275390625
      ],
      [
        -1532.54296875,
        -3914.01220703125,
        1313.0
      ],
      [
        -1532.053466796875,
        -3913.164306640625,
        1313.0
      ],
      [
        -1533.0325927734375,
        -3913.164306640625,
        1319.3599853515625
      ],
      [
        -1529.63720703125,
        -3913.164306640625,
        1309.09375
      ],
      [
        -1532.053466796875,
        -3913.164306640625,
        1313.0
      ],
      [
        -1532.54296875,
        -3914.01220703125,
        1313.0
      ],
      [
        -1531.6981201171875,
        -3915.475830078125,
        1310.26806640625
      ],
      [
        -1529.63720703125,
        -3913.164306640625,
        1309.09375
      ],
      [
        -1522.1373291015625,
        -3912.298095703125,
        1328.0
      ],
      [
        -1533.69775390625,
        -3912.012451171875,
        1328.0
      ],
      [
        -1533.69775390625,
        -3912.012451171875,
        1328.0
      ],
      [
        -1533.1737060546875,
        -3912.920166015625,
        1334.8077392578125
      ],
      [
        -1522.1373291015625,
        -3912.298095703125,
        1328.0
      ],
      [
        -1522.6002197265625,
        -3913.099853515625,
        1334.0123291015625
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1312.9820556640625
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1312.7313232421875
      ],
      [
        -1503.6795654296875,
        -3872.9716796875,
        1312.677001953125
      ],
      [
        -1503.5675048828125,
        -3873.165771484375,
        1312.7313232421875
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1313.909423828125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1312.9820556640625
      ],
      [
        -1500.1025390625,
        -3873.165771484375,
        1313.909423828125
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1314.248046875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1313.408447265625
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1500.3968505859375,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1498.3699951171875,
        -3870.1650390625,
        1314.248046875
      ],
      [
        -1500.1025390625,
        -3867.164306640625,
        1313.408447265625
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1312.656005859375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1312.982177734375
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1314.8377685546875
      ],
      [
        -1552.1025390625,
        -3873.165771484375,
        1312.656005859375
      ],
      [
        -1552.2110595703125,
        -3873.165771484375,
        1312.656005859375
      ],
      [
        -1550.3699951171875,
        -3870.1650390625,
        1312.982177734375
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1552.1025390625,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1555.5675048828125,
        -3867.164306640625,
        1313.308349609375
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1315.187744140625
      ],
      [
        -1555.5855712890625,
        -3867.195556640625,
        1313.304931640625
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1315.187744140625
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1314.8377685546875
      ],
      [
        -1524.1370849609375,
        -3919.165771484375,
        1313.0
      ],
      [
        -1521.8277587890625,
        -3919.165771484375,
        1328.0
      ],
      [
        -1521.8277587890625,
        -3919.165771484375,
        1328.0
      ],
      [
        -1522.9722900390625,
        -3919.165771484375,
        1335.4339599609375
      ],
      [
        -1524.1370849609375,
        -3919.165771484375,
        1313.0
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1323.8917236328125
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1324.7313232421875
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1324.2303466796875
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1323.8917236328125
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1325.4083251953125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1324.2303466796875
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1325.909423828125
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1326.2479248046875
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1326.2479248046875
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1325.4083251953125
      ],
      [
        -1528.550048828125,
        -3920.92822265625,
        1313.0
      ],
      [
        -1527.395263671875,
        -3922.92822265625,
        1328.0
      ],
      [
        -1527.395263671875,
        -3922.92822265625,
        1328.0
      ],
      [
        -1527.991943359375,
        -3921.894775390625,
        1335.75
      ],
      [
        -1524.5965576171875,
        -3921.894775390625,
        1335.75
      ],
      [
        -1524.5965576171875,
        -3921.894775390625,
        1335.75
      ],
      [
        -1529.5303955078125,
        -3919.230224609375,
        1309.830322265625
      ],
      [
        -1528.550048828125,
        -3920.92822265625,
        1313.0
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1321.616455078125
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1335.75
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1335.75
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1321.27783203125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1321.27783203125
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1335.75
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1335.75
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1322.1173095703125
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1322.7945556640625
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1335.75
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1335.75
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1321.616455078125
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1322.1173095703125
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1335.75
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1335.75
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1323.29541015625
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1323.634033203125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1335.75
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1335.75
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1322.7945556640625
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1323.29541015625
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1335.75
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1335.75
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1323.634033203125
      ],
      [
        -1531.4034423828125,
        -3921.894775390625,
        1335.75
      ],
      [
        -1531.4034423828125,
        -3921.894775390625,
        1335.75
      ],
      [
        -1532.3446044921875,
        -3916.0,
        1310.8238525390625
      ],
      [
        -1529.9669189453125,
        -3919.40673828125,
        1310.1597900390625
      ],
      [
        -1529.9669189453125,
        -3919.40673828125,
        1310.1597900390625
      ],
      [
        -1532.3446044921875,
        -3916.0,
        1310.8238525390625
      ],
      [
        -1520.9375,
        -3979.498046875,
        1335.75
      ],
      [
        -1515.381591796875,
        -3979.498291015625,
        1335.75
      ],
      [
        -1520.9375,
        -3979.498046875,
        1335.75
      ],
      [
        -1515.381591796875,
        -3979.498291015625,
        1335.75
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1329.54833984375
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1335.75
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1335.75
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1329.8980712890625
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1331.4508056640625
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1335.75
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1335.75
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1329.54833984375
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1329.8980712890625
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1335.75
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1335.75
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1332.150390625
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1333.7030029296875
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1335.75
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1335.75
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1331.4508056640625
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1332.150390625
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1335.75
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1335.75
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1334.052734375
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1334.052734375
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1335.75
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1335.75
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1333.7030029296875
      ],
      [
        -1564.9573974609375,
        -3917.182373046875,
        1332.328125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1331.68310546875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1331.6832275390625
      ],
      [
        -1564.938720703125,
        -3915.179931640625,
        1331.7979736328125
      ],
      [
        -1567.0753173828125,
        -3954.30419921875,
        1303.836669921875
      ],
      [
        -1568.0908203125,
        -3951.6279296875,
        1304.12744140625
      ],
      [
        -1530.421875,
        -3958.19873046875,
        1310.69921875
      ],
      [
        -1530.421875,
        -3958.19873046875,
        1310.69921875
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1307.4727783203125
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1307.958984375
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1307.958984375
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1308.493896484375
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1307.5218505859375
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1307.4727783203125
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1308.056884765625
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1307.5218505859375
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1308.493896484375
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1308.5430908203125
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1308.5430908203125
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1308.056884765625
      ],
      [
        -1528.782958984375,
        -3919.165771484375,
        1309.3277587890625
      ],
      [
        -1528.1820068359375,
        -3919.165771484375,
        1308.202392578125
      ],
      [
        -1528.782958984375,
        -3919.165771484375,
        1308.109619140625
      ],
      [
        -1528.1337890625,
        -3918.32958984375,
        1308.1490478515625
      ],
      [
        -1528.292236328125,
        -3918.31591796875,
        1308.12353515625
      ],
      [
        -1528.6038818359375,
        -3918.855712890625,
        1309.1312255859375
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1307.982177734375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1307.656005859375
      ],
      [
        -1566.787841796875,
        -3916.0,
        1308.0
      ],
      [
        -1555.83642578125,
        -3939.68017578125,
        1305.4261474609375
      ],
      [
        -1555.125732421875,
        -3943.1611328125,
        1305.7894287109375
      ],
      [
        -1555.125732421875,
        -3943.1611328125,
        1305.7894287109375
      ],
      [
        -1555.8365478515625,
        -3939.68017578125,
        1305.4261474609375
      ],
      [
        -1566.7879638671875,
        -3916.0,
        1308.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1308.3082275390625
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1309.51953125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1311.767578125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1307.982177734375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1307.656005859375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1311.1568603515625
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1308.29833984375
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1307.656005859375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1309.51953125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1308.3082275390625
      ],
      [
        -1568.099365234375,
        -3913.164306640625,
        1308.3082275390625
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1307.656005859375
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1308.29833984375
      ],
      [
        -1565.6702880859375,
        -3918.4169921875,
        1307.7374267578125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1307.982177734375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1307.982177734375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1308.308349609375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1308.308349609375
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1312.982177734375
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      [
        -1555.5675048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      [
        -1557.300048828125,
        -3870.1650390625,
        1312.982177734375
      ],
      [
        -1529.3792724609375,
        -3913.611083984375,
        1308.2596435546875
      ],
      [
        -1529.3792724609375,
        -3913.611083984375,
        1308.2596435546875
      ],
      [
        -1530.597900390625,
        -3916.0,
        1308.0
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1308.9810791015625
      ],
      [
        -1530.2012939453125,
        -3914.261962890625,
        1308.9810791015625
      ],
      [
        -1530.597900390625,
        -3916.0,
        1308.0
      ],
      [
        -1531.204833984375,
        -3916.0,
        1308.981201171875
      ],
      [
        -1531.7208251953125,
        -3916.893798828125,
        1310.649658203125
      ],
      [
        -1529.2877197265625,
        -3918.230224609375,
        1307.963623046875
      ],
      [
        -1529.677978515625,
        -3917.42724609375,
        1307.8448486328125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1309.289794921875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1309.2891845703125
      ],
      [
        -1529.2877197265625,
        -3918.230224609375,
        1307.963623046875
      ],
      [
        -1529.69775390625,
        -3918.9404296875,
        1309.289306640625
      ],
      [
        -1529.5303955078125,
        -3919.230224609375,
        1309.8304443359375
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1309.7095947265625
      ],
      [
        -1529.3701171875,
        -3919.165771484375,
        1309.70947265625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1309.2891845703125
      ],
      [
        -1528.8326416015625,
        -3919.165771484375,
        1308.1019287109375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1308.9810791015625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.9884033203125
      ],
      [
        -1530.27685546875,
        -3917.937255859375,
        1307.78955078125
      ],
      [
        -1530.9720458984375,
        -3916.733154296875,
        1307.9202880859375
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.9884033203125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1307.9820556640625
      ],
      [
        -1529.825439453125,
        -3913.611083984375,
        1308.259765625
      ],
      [
        -1529.7542724609375,
        -3913.487548828125,
        1308.4901123046875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1307.9820556640625
      ],
      [
        -1548.9273681640625,
        -3956.238037109375,
        1304.2437744140625
      ],
      [
        -1549.3330078125,
        -3953.742431640625,
        1303.8975830078125
      ],
      [
        -1549.3330078125,
        -3953.742431640625,
        1303.8975830078125
      ],
      [
        -1548.9273681640625,
        -3956.238037109375,
        1304.2437744140625
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1305.114501953125
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1304.4788818359375
      ],
      [
        -1549.1019287109375,
        -3955.164306640625,
        1304.0947265625
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1305.9541015625
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1305.114501953125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1305.615478515625
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1305.9541015625
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1304.478759765625
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1306.7269287109375
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1306.1163330078125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1305.615478515625
      ],
      [
        -1548.1263427734375,
        -3961.165771484375,
        1304.9273681640625
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1306.7269287109375
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1306.1163330078125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.7313232421875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.7313232421875
      ],
      [
        -1529.679443359375,
        -3918.971923828125,
        1307.6771240234375
      ],
      [
        -1529.2017822265625,
        -3918.1259765625,
        1307.7689208984375
      ],
      [
        -1529.2275390625,
        -3918.1259765625,
        1307.7689208984375
      ],
      [
        -1529.2275390625,
        -3918.1259765625,
        1307.7689208984375
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1303.9365234375
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1303.597900390625
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1303.597900390625
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1304.4373779296875
      ],
      [
        -1549.5675048828125,
        -3961.165771484375,
        1304.4373779296875
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1303.9365234375
      ],
      [
        -1552.5811767578125,
        -3933.759521484375,
        1301.125
      ],
      [
        -1552.5811767578125,
        -3933.759521484375,
        1301.125
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1312.2303466796875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1306.05029296875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1306.6610107421875
      ],
      [
        -1565.6702880859375,
        -3918.4169921875,
        1307.7374267578125
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1306.05029296875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1306.6610107421875
      ],
      [
        -1568.099365234375,
        -3913.164306640625,
        1308.3082275390625
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1307.2303466796875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1306.891845703125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1306.891845703125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1307.2303466796875
      ],
      [
        -1529.129638671875,
        -3914.04345703125,
        1307.45263671875
      ],
      [
        -1529.129638671875,
        -3914.04345703125,
        1307.45263671875
      ],
      [
        -1530.146484375,
        -3916.0,
        1307.270263671875
      ],
      [
        -1530.146484375,
        -3916.0,
        1307.270263671875
      ],
      [
        -1529.2249755859375,
        -3918.12158203125,
        1307.7607421875
      ],
      [
        -1529.2249755859375,
        -3918.12158203125,
        1307.7607421875
      ],
      [
        -1503.5675048828125,
        -3867.164306640625,
        1312.2303466796875
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1311.8917236328125
      ],
      [
        -1505.300048828125,
        -3870.1650390625,
        1311.8917236328125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1317.222900390625
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1316.839599609375
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1315.988525390625
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1316.5235595703125
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1316.5235595703125
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1317.222900390625
      ],
      [
        -1493.8809814453125,
        -3960.781982421875,
        1316.52978515625
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1316.839599609375
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1315.6614990234375
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1315.50244140625
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1315.988525390625
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1315.6614990234375
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1315.50244140625
      ],
      [
        -1497.8232421875,
        -3955.607177734375,
        1315.544189453125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.5235595703125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1309.2230224609375
      ],
      [
        -1525.8804931640625,
        -3918.78125,
        1308.5299072265625
      ],
      [
        -1528.1820068359375,
        -3919.165771484375,
        1308.202392578125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.5235595703125
      ],
      [
        -1526.3797607421875,
        -3918.127197265625,
        1308.4051513671875
      ],
      [
        -1526.57763671875,
        -3918.463623046875,
        1308.3990478515625
      ],
      [
        -1526.57763671875,
        -3918.463623046875,
        1308.3990478515625
      ],
      [
        -1528.1343994140625,
        -3918.32958984375,
        1308.14892578125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1309.2230224609375
      ],
      [
        -1524.4652099609375,
        -3916.000244140625,
        1309.201904296875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1324.25
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1325.4281005859375
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1323.86669921875
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1324.25
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1325.4281005859375
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1326.222900390625
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1326.222900390625
      ],
      [
        -1474.4652099609375,
        -3916.000244140625,
        1326.2017822265625
      ],
      [
        -1481.204833984375,
        -3916.000244140625,
        1323.9102783203125
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1323.86669921875
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.6204833984375
      ],
      [
        -1549.1019287109375,
        -3955.164306640625,
        1304.0948486328125
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1303.2578125
      ],
      [
        -1544.458740234375,
        -3958.31884765625,
        1301.125
      ],
      [
        -1548.126220703125,
        -3961.165771484375,
        1304.9273681640625
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1303.2578125
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.620361328125
      ],
      [
        -1544.6968994140625,
        -3957.5986328125,
        1301.125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1306.8668212890625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.2498779296875
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1314.86669921875
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1315.25
      ],
      [
        -1497.5675048828125,
        -3961.165771484375,
        1315.25
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1316.42822265625
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1314.86669921875
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1316.42822265625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1307.2498779296875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.427978515625
      ],
      [
        -1526.6055908203125,
        -3918.4150390625,
        1308.30859375
      ],
      [
        -1529.1375732421875,
        -3917.97021484375,
        1307.4781494140625
      ],
      [
        -1529.1375732421875,
        -3917.97021484375,
        1307.4781494140625
      ],
      [
        -1526.6055908203125,
        -3918.4150390625,
        1308.30859375
      ],
      [
        -1531.2044677734375,
        -3915.99951171875,
        1306.9105224609375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1306.86669921875
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1308.427978515625
      ],
      [
        -1536.8848876953125,
        -3958.236083984375,
        1302.0830078125
      ],
      [
        -1540.2315673828125,
        -3955.6123046875,
        1301.125
      ],
      [
        -1536.8848876953125,
        -3958.236083984375,
        1302.0830078125
      ],
      [
        -1540.2315673828125,
        -3955.6123046875,
        1301.125
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1303.3134765625
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.8616943359375
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1305.353515625
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1303.3134765625
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1301.8616943359375
      ],
      [
        -1546.4708251953125,
        -3955.164306640625,
        1301.92431640625
      ],
      [
        -1550.288330078125,
        -3864.799072265625,
        1381.199951171875
      ],
      [
        -1550.9344482421875,
        -3865.0810546875,
        1381.492919921875
      ],
      [
        -1544.5814208984375,
        -3887.300048828125,
        1382.5819091796875
      ],
      [
        -1544.5400390625,
        -3887.300048828125,
        1382.4739990234375
      ],
      [
        -1544.5400390625,
        -3887.300048828125,
        1382.4739990234375
      ],
      [
        -1544.5452880859375,
        -3887.300048828125,
        1382.46044921875
      ],
      [
        -1550.608154296875,
        -3864.943359375,
        1380.9305419921875
      ],
      [
        -1550.288330078125,
        -3864.799072265625,
        1381.199951171875
      ],
      [
        -1550.6846923828125,
        -3864.9814453125,
        1380.5592041015625
      ],
      [
        -1550.608154296875,
        -3864.943359375,
        1380.9305419921875
      ],
      [
        -1551.5911865234375,
        -3865.431396484375,
        1376.1639404296875
      ],
      [
        -1544.5721435546875,
        -3887.300048828125,
        1382.390380859375
      ],
      [
        -1551.5911865234375,
        -3865.431396484375,
        1376.1639404296875
      ],
      [
        -1552.1619873046875,
        -3865.68408203125,
        1376.1024169921875
      ],
      [
        -1546.686767578125,
        -3887.300048828125,
        1388.0772705078125
      ],
      [
        -1546.70947265625,
        -3887.300048828125,
        1388.136474609375
      ],
      [
        -1546.686767578125,
        -3887.300048828125,
        1388.0772705078125
      ],
      [
        -1546.7210693359375,
        -3887.300048828125,
        1388.1397705078125
      ],
      [
        -1546.70947265625,
        -3887.300048828125,
        1388.136474609375
      ],
      [
        -1546.686767578125,
        -3887.300048828125,
        1376.870849609375
      ],
      [
        -1546.686767578125,
        -3887.300048828125,
        1376.870849609375
      ],
      [
        -1546.70947265625,
        -3887.300048828125,
        1376.8115234375
      ],
      [
        -1546.70947265625,
        -3887.300048828125,
        1376.8115234375
      ],
      [
        -1546.7191162109375,
        -3887.300048828125,
        1376.8087158203125
      ],
      [
        -1546.77783203125,
        -3887.300048828125,
        1376.791748046875
      ],
      [
        -1553.218017578125,
        -3887.300048828125,
        1374.9239501953125
      ],
      [
        -1546.77783203125,
        -3887.300048828125,
        1376.791748046875
      ],
      [
        -1552.6932373046875,
        -3865.919189453125,
        1376.045166015625
      ],
      [
        -1553.218017578125,
        -3887.300048828125,
        1374.9239501953125
      ],
      [
        -1553.238037109375,
        -3887.300048828125,
        1374.9296875
      ],
      [
        -1557.28955078125,
        -3867.953857421875,
        1375.5501708984375
      ],
      [
        -1557.28955078125,
        -3867.953857421875,
        1375.5501708984375
      ],
      [
        -1557.64501953125,
        -3868.10986328125,
        1375.62255859375
      ],
      [
        -1553.218017578125,
        -3887.300048828125,
        1390.0240478515625
      ],
      [
        -1546.77783203125,
        -3887.300048828125,
        1388.15625
      ],
      [
        -1546.77783203125,
        -3887.300048828125,
        1388.15625
      ],
      [
        -1552.4556884765625,
        -3865.69482421875,
        1386.589599609375
      ],
      [
        -1553.3258056640625,
        -3866.0771484375,
        1386.7486572265625
      ],
      [
        -1552.4556884765625,
        -3865.69482421875,
        1386.589599609375
      ],
      [
        -1552.410888671875,
        -3865.677001953125,
        1386.4212646484375
      ],
      [
        -1553.2464599609375,
        -3887.300048828125,
        1390.0157470703125
      ],
      [
        -1553.218017578125,
        -3887.300048828125,
        1390.0240478515625
      ],
      [
        -1558.322265625,
        -3868.272705078125,
        1387.6617431640625
      ],
      [
        -1552.395751953125,
        -3865.6708984375,
        1386.3642578125
      ],
      [
        -1558.322265625,
        -3868.272705078125,
        1387.6617431640625
      ],
      [
        -1558.396240234375,
        -3868.305908203125,
        1387.625732421875
      ],
      [
        -1559.658203125,
        -3887.300048828125,
        1388.15625
      ],
      [
        -1559.7265625,
        -3887.300048828125,
        1388.136474609375
      ],
      [
        -1559.658203125,
        -3887.300048828125,
        1388.15625
      ],
      [
        -1558.5712890625,
        -3868.38427734375,
        1387.5406494140625
      ],
      [
        -1559.73583984375,
        -3887.300048828125,
        1388.1123046875
      ],
      [
        -1559.7265625,
        -3887.300048828125,
        1388.136474609375
      ],
      [
        -1559.658203125,
        -3887.300048828125,
        1376.791748046875
      ],
      [
        -1559.658203125,
        -3887.300048828125,
        1376.791748046875
      ],
      [
        -1559.7265625,
        -3887.300048828125,
        1376.8115234375
      ],
      [
        -1562.3272705078125,
        -3870.16650390625,
        1376.5472412109375
      ],
      [
        -1562.078369140625,
        -3870.058349609375,
        1376.396728515625
      ],
      [
        -1562.078369140625,
        -3870.058349609375,
        1376.396728515625
      ],
      [
        -1561.6783447265625,
        -3869.881591796875,
        1376.4056396484375
      ],
      [
        -1559.7265625,
        -3887.300048828125,
        1376.8115234375
      ],
      [
        -1559.732421875,
        -3887.300048828125,
        1376.826904296875
      ],
      [
        -1564.1116943359375,
        -3870.90185546875,
        1381.199951171875
      ],
      [
        -1565.124267578125,
        -3871.543701171875,
        1378.377685546875
      ],
      [
        -1561.89599609375,
        -3887.300048828125,
        1382.4739990234375
      ],
      [
        -1559.749267578125,
        -3887.300048828125,
        1388.0772705078125
      ],
      [
        -1559.749267578125,
        -3887.300048828125,
        1388.0772705078125
      ],
      [
        -1561.8818359375,
        -3887.300048828125,
        1382.43701171875
      ],
      [
        -1561.89599609375,
        -3887.300048828125,
        1382.4739990234375
      ],
      [
        -1565.179443359375,
        -3871.40625,
        1378.2723388671875
      ],
      [
        -1565.124267578125,
        -3871.543701171875,
        1378.377685546875
      ],
      [
        -1559.749267578125,
        -3887.300048828125,
        1376.870849609375
      ],
      [
        -1559.749267578125,
        -3887.300048828125,
        1376.870849609375
      ],
      [
        -1561.930419921875,
        -3885.719970703125,
        1382.7518310546875
      ],
      [
        -1551.121826171875,
        -3865.162841796875,
        1381.577880859375
      ],
      [
        -1551.121826171875,
        -3865.162841796875,
        1381.577880859375
      ],
      [
        -1561.5091552734375,
        -3869.806884765625,
        1376.409423828125
      ],
      [
        -1561.5091552734375,
        -3869.806884765625,
        1376.409423828125
      ],
      [
        -1653.9222412109375,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1647.8101806640625,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1672.2469482421875,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1647.8101806640625,
        -3830.189208984375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3819.41552734375,
        1435.0999755859375
      ],
      [
        -1653.9222412109375,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1666.135009765625,
        -3840.962646484375,
        1435.0999755859375
      ],
      [
        -1621.1893310546875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3735.930419921875,
        1435.0999755859375
      ],
      [
        -1621.1893310546875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1644.865966796875,
        -3746.368896484375,
        1435.0999755859375
      ],
      [
        -1627.1114501953125,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1638.944091796875,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1645.150390625,
        -3731.426025390625,
        1353.76318359375
      ],
      [
        -1639.518798828125,
        -3722.626220703125,
        1386.5806884765625
      ],
      [
        -1640.349365234375,
        -3728.865234375,
        1342.944580078125
      ],
      [
        -1643.0291748046875,
        -3731.974609375,
        1335.7933349609375
      ],
      [
        -1650.43603515625,
        -3729.4130859375,
        1394.9000244140625
      ],
      [
        -1645.150390625,
        -3731.426025390625,
        1353.76318359375
      ],
      [
        -1643.0291748046875,
        -3731.974609375,
        1335.7933349609375
      ],
      [
        -1640.349365234375,
        -3728.865234375,
        1342.944580078125
      ],
      [
        -1640.5208740234375,
        -3729.833251953125,
        1335.75
      ],
      [
        -1643.0244140625,
        -3731.975341796875,
        1335.75
      ],
      [
        -1650.43603515625,
        -3729.4130859375,
        1394.9000244140625
      ],
      [
        -1650.2764892578125,
        -3730.100341796875,
        1397.1866455078125
      ],
      [
        -1626.990234375,
        -3736.14453125,
        1435.0999755859375
      ],
      [
        -1628.4610595703125,
        -3734.566650390625,
        1429.3531494140625
      ],
      [
        -1628.4610595703125,
        -3734.566650390625,
        1429.3531494140625
      ],
      [
        -1639.518798828125,
        -3722.626220703125,
        1386.5806884765625
      ],
      [
        -1648.125,
        -3739.365234375,
        1428.010498046875
      ],
      [
        -1629.959716796875,
        -3741.872802734375,
        1373.0
      ],
      [
        -1630.673828125,
        -3742.275634765625,
        1363.5902099609375
      ],
      [
        -1629.959716796875,
        -3741.872802734375,
        1373.0
      ],
      [
        -1636.4681396484375,
        -3730.40087890625,
        1373.0
      ],
      [
        -1633.2000732421875,
        -3747.31787109375,
        1373.0
      ],
      [
        -1635.5985107421875,
        -3750.48193359375,
        1366.2606201171875
      ],
      [
        -1635.76171875,
        -3751.38232421875,
        1372.9522705078125
      ],
      [
        -1635.761474609375,
        -3751.386474609375,
        1373.0
      ],
      [
        -1635.5986328125,
        -3750.482177734375,
        1366.2608642578125
      ],
      [
        -1636.7183837890625,
        -3748.274658203125,
        1364.9459228515625
      ],
      [
        -1631.48974609375,
        -3741.101806640625,
        1362.095458984375
      ],
      [
        -1631.531982421875,
        -3743.51953125,
        1361.0
      ],
      [
        -1631.1722412109375,
        -3743.050048828125,
        1362.064453125
      ],
      [
        -1630.673828125,
        -3742.275634765625,
        1363.5902099609375
      ],
      [
        -1636.7183837890625,
        -3748.274658203125,
        1364.9459228515625
      ],
      [
        -1637.4873046875,
        -3746.91455078125,
        1364.9202880859375
      ],
      [
        -1647.0684814453125,
        -3742.486572265625,
        1435.0999755859375
      ],
      [
        -1648.125,
        -3739.365234375,
        1428.010498046875
      ],
      [
        -1635.7513427734375,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1635.861572265625,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1638.8819580078125,
        -3746.22802734375,
        1374.9000244140625
      ],
      [
        -1635.7513427734375,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1658.02783203125,
        -3751.093505859375,
        1369.64306640625
      ],
      [
        -1665.119140625,
        -3753.29833984375,
        1394.9000244140625
      ],
      [
        -1658.02783203125,
        -3751.093505859375,
        1369.64306640625
      ],
      [
        -1653.81298828125,
        -3748.134765625,
        1335.75
      ],
      [
        -1673.0755615234375,
        -3753.29833984375,
        1394.9000244140625
      ],
      [
        -1668.5169677734375,
        -3754.354736328125,
        1407.0020751953125
      ],
      [
        -1662.5538330078125,
        -3755.736572265625,
        1422.8326416015625
      ],
      [
        -1659.6474609375,
        -3756.524169921875,
        1431.855224609375
      ],
      [
        -1662.5538330078125,
        -3755.736572265625,
        1422.8326416015625
      ],
      [
        -1659.6474609375,
        -3756.524169921875,
        1431.855224609375
      ],
      [
        -1658.2171630859375,
        -3756.741455078125,
        1434.345458984375
      ],
      [
        -1647.8345947265625,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1641.5374755859375,
        -3751.115966796875,
        1369.900634765625
      ],
      [
        -1647.8345947265625,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1635.79541015625,
        -3750.83349609375,
        1366.66552734375
      ],
      [
        -1641.5374755859375,
        -3751.115966796875,
        1369.900634765625
      ],
      [
        -1635.79541015625,
        -3750.83349609375,
        1366.66552734375
      ],
      [
        -1657.7838134765625,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1617.841064453125,
        -3740.466796875,
        1435.0999755859375
      ],
      [
        -1616.823486328125,
        -3734.973388671875,
        1414.3336181640625
      ],
      [
        -1616.823486328125,
        -3734.973388671875,
        1414.3336181640625
      ],
      [
        -1612.8072509765625,
        -3720.612548828125,
        1373.4637451171875
      ],
      [
        -1612.8072509765625,
        -3720.612548828125,
        1373.4637451171875
      ],
      [
        -1614.253662109375,
        -3721.100341796875,
        1361.890625
      ],
      [
        -1628.463134765625,
        -3720.031005859375,
        1335.75
      ],
      [
        -1617.5206298828125,
        -3722.201904296875,
        1335.75
      ],
      [
        -1587.3287353515625,
        -3751.427001953125,
        1373.4637451171875
      ],
      [
        -1587.4544677734375,
        -3751.468505859375,
        1373.9412841796875
      ],
      [
        -1587.4544677734375,
        -3751.468505859375,
        1373.9412841796875
      ],
      [
        -1603.15869140625,
        -3756.807373046875,
        1435.0999755859375
      ],
      [
        -1587.3287353515625,
        -3751.427001953125,
        1373.4637451171875
      ],
      [
        -1587.4927978515625,
        -3751.3125,
        1372.1544189453125
      ],
      [
        -1631.38916015625,
        -3748.134765625,
        1335.75
      ],
      [
        -1657.7388916015625,
        -3820.20654296875,
        1426.4166259765625
      ],
      [
        -1666.414794921875,
        -3823.90966796875,
        1413.4552001953125
      ],
      [
        -1668.718505859375,
        -3830.830322265625,
        1397.9833984375
      ],
      [
        -1653.6697998046875,
        -3821.47021484375,
        1426.416015625
      ],
      [
        -1654.242431640625,
        -3819.960693359375,
        1429.1142578125
      ],
      [
        -1660.445068359375,
        -3837.360595703125,
        1394.5888671875
      ],
      [
        -1668.718505859375,
        -3830.830322265625,
        1397.9833984375
      ],
      [
        -1671.6361083984375,
        -3836.5166015625,
        1395.0447998046875
      ],
      [
        -1671.2332763671875,
        -3837.362060546875,
        1394.6064453125
      ],
      [
        -1660.445068359375,
        -3837.360595703125,
        1394.5888671875
      ],
      [
        -1656.084228515625,
        -3837.37109375,
        1394.7066650390625
      ],
      [
        -1655.987060546875,
        -3837.21484375,
        1394.7890625
      ],
      [
        -1655.987060546875,
        -3837.21484375,
        1394.7890625
      ],
      [
        -1655.6619873046875,
        -3836.669189453125,
        1394.93896484375
      ],
      [
        -1655.5018310546875,
        -3836.400390625,
        1395.0128173828125
      ],
      [
        -1671.2332763671875,
        -3837.362060546875,
        1394.6064453125
      ],
      [
        -1671.6361083984375,
        -3836.5166015625,
        1395.0447998046875
      ],
      [
        -1672.06396484375,
        -3837.358642578125,
        1394.568359375
      ],
      [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      [
        -1650.5738525390625,
        -3830.217529296875,
        1408.6728515625
      ],
      [
        -1653.6697998046875,
        -3821.47021484375,
        1426.416015625
      ],
      [
        -1655.1014404296875,
        -3835.728515625,
        1395.1973876953125
      ],
      [
        -1666.414794921875,
        -3823.90966796875,
        1413.455322265625
      ],
      [
        -1657.7388916015625,
        -3820.20654296875,
        1426.4166259765625
      ],
      [
        -1665.2738037109375,
        -3820.889404296875,
        1418.914794921875
      ],
      [
        -1652.8970947265625,
        -3833.04541015625,
        1401.7576904296875
      ],
      [
        -1654.4971923828125,
        -3834.714599609375,
        1395.4759521484375
      ],
      [
        -1654.4971923828125,
        -3834.714599609375,
        1395.4759521484375
      ],
      [
        -1656.1591796875,
        -3825.224853515625,
        1382.5
      ],
      [
        -1663.87841796875,
        -3825.16064453125,
        1382.5
      ],
      [
        -1663.3365478515625,
        -3824.20556640625,
        1382.5
      ],
      [
        -1656.7374267578125,
        -3824.20556640625,
        1382.5
      ],
      [
        -1656.1591796875,
        -3825.224853515625,
        1382.5
      ],
      [
        -1656.375244140625,
        -3825.1064453125,
        1381.0843505859375
      ],
      [
        -1663.669677734375,
        -3825.0458984375,
        1381.1304931640625
      ],
      [
        -1661.1710205078125,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1663.272216796875,
        -3824.315673828125,
        1381.291259765625
      ],
      [
        -1658.8289794921875,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1656.375244140625,
        -3825.1064453125,
        1381.0843505859375
      ],
      [
        -1656.803955078125,
        -3824.318603515625,
        1381.2578125
      ],
      [
        -1661.1710205078125,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1658.8289794921875,
        -3824.39990234375,
        1380.366455078125
      ],
      [
        -1654.6494140625,
        -3818.8876953125,
        1431.0322265625
      ],
      [
        -1656.3336181640625,
        -3815.164794921875,
        1435.0999755859375
      ],
      [
        -1661.891357421875,
        -3811.935302734375,
        1435.0999755859375
      ],
      [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1658.8763427734375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1658.8763427734375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      [
        -1661.7669677734375,
        -3821.5498046875,
        1381.9002685546875
      ],
      [
        -1658.2545166015625,
        -3821.65283203125,
        1381.8448486328125
      ],
      [
        -1661.7669677734375,
        -3821.5498046875,
        1381.9002685546875
      ],
      [
        -1658.2545166015625,
        -3821.65283203125,
        1381.8448486328125
      ],
      [
        -1660.46142578125,
        -3827.779052734375,
        1335.75
      ],
      [
        -1659.6275634765625,
        -3827.779052734375,
        1335.75
      ],
      [
        -1654.6494140625,
        -3818.8876953125,
        1431.0322265625
      ],
      [
        -1647.086181640625,
        -3825.972412109375,
        1419.053466796875
      ],
      [
        -1641.3128662109375,
        -3818.736572265625,
        1435.0999755859375
      ],
      [
        -1647.086181640625,
        -3825.972412109375,
        1419.053466796875
      ],
      [
        -1657.80517578125,
        -3829.599609375,
        1335.75
      ],
      [
        -1697.409912109375,
        -3795.158203125,
        1408.7164306640625
      ],
      [
        -1692.5484619140625,
        -3790.89306640625,
        1405.559326171875
      ],
      [
        -1691.9532470703125,
        -3790.370849609375,
        1405.1727294921875
      ],
      [
        -1698.8807373046875,
        -3778.877197265625,
        1408.791015625
      ],
      [
        -1691.9532470703125,
        -3790.370849609375,
        1405.1727294921875
      ],
      [
        -1693.662109375,
        -3770.754150390625,
        1405.224365234375
      ],
      [
        -1691.426513671875,
        -3773.0859375,
        1403.9876708984375
      ],
      [
        -1680.485107421875,
        -3780.255126953125,
        1397.722412109375
      ],
      [
        -1684.6956787109375,
        -3783.66552734375,
        1399.2032470703125
      ],
      [
        -1684.63916015625,
        -3780.165283203125,
        1400.2330322265625
      ],
      [
        -1684.848876953125,
        -3783.78955078125,
        1399.257080078125
      ],
      [
        -1684.848876953125,
        -3783.78955078125,
        1399.257080078125
      ],
      [
        -1684.8671875,
        -3783.367919921875,
        1400.5316162109375
      ],
      [
        -1684.8070068359375,
        -3783.834228515625,
        1399.2392578125
      ],
      [
        -1684.8070068359375,
        -3783.834228515625,
        1399.2392578125
      ],
      [
        -1680.453857421875,
        -3780.332275390625,
        1397.7073974609375
      ],
      [
        -1707.9254150390625,
        -3799.530517578125,
        1397.1622314453125
      ],
      [
        -1703.0078125,
        -3795.861572265625,
        1397.9945068359375
      ],
      [
        -1669.7471923828125,
        -3775.42626953125,
        1433.8359375
      ],
      [
        -1669.7750244140625,
        -3776.171875,
        1434.0556640625
      ],
      [
        -1681.5185546875,
        -3807.337890625,
        1428.16357421875
      ],
      [
        -1689.34228515625,
        -3810.99609375,
        1422.1007080078125
      ],
      [
        -1685.261962890625,
        -3801.03759765625,
        1423.52294921875
      ],
      [
        -1681.5185546875,
        -3807.337890625,
        1428.16357421875
      ],
      [
        -1681.4110107421875,
        -3807.293701171875,
        1428.1751708984375
      ],
      [
        -1680.2659912109375,
        -3797.8515625,
        1423.4505615234375
      ],
      [
        -1679.1861572265625,
        -3806.37939453125,
        1428.4156494140625
      ],
      [
        -1692.6441650390625,
        -3771.060546875,
        1404.886474609375
      ],
      [
        -1693.08203125,
        -3771.359130859375,
        1404.9034423828125
      ],
      [
        -1668.8682861328125,
        -3763.339599609375,
        1423.6673583984375
      ],
      [
        -1668.0400390625,
        -3757.336669921875,
        1412.57421875
      ],
      [
        -1668.0400390625,
        -3757.336669921875,
        1412.57421875
      ],
      [
        -1667.7584228515625,
        -3754.530517578125,
        1409.0157470703125
      ],
      [
        -1669.7374267578125,
        -3779.218994140625,
        1432.62109375
      ],
      [
        -1669.7750244140625,
        -3776.171875,
        1434.0556640625
      ],
      [
        -1669.7374267578125,
        -3779.21923828125,
        1432.62109375
      ],
      [
        -1669.5841064453125,
        -3793.731201171875,
        1426.1861572265625
      ],
      [
        -1669.7552490234375,
        -3798.766357421875,
        1427.4149169921875
      ],
      [
        -1669.9542236328125,
        -3802.586181640625,
        1429.4134521484375
      ],
      [
        -1669.5841064453125,
        -3793.731201171875,
        1426.1861572265625
      ],
      [
        -1669.7552490234375,
        -3798.766357421875,
        1427.4149169921875
      ],
      [
        -1669.7471923828125,
        -3775.42626953125,
        1433.8359375
      ],
      [
        -1668.8682861328125,
        -3763.339599609375,
        1423.6673583984375
      ],
      [
        -1689.8741455078125,
        -3834.87646484375,
        1366.6529541015625
      ],
      [
        -1689.7711181640625,
        -3836.350341796875,
        1383.227783203125
      ],
      [
        -1689.7711181640625,
        -3836.350341796875,
        1383.227783203125
      ],
      [
        -1684.05712890625,
        -3837.2822265625,
        1393.7108154296875
      ],
      [
        -1671.1749267578125,
        -3820.300048828125,
        1414.705322265625
      ],
      [
        -1670.9088134765625,
        -3817.908203125,
        1420.6773681640625
      ],
      [
        -1672.7684326171875,
        -3815.851318359375,
        1427.9232177734375
      ],
      [
        -1671.9005126953125,
        -3826.251220703125,
        1405.259765625
      ],
      [
        -1671.1749267578125,
        -3820.300048828125,
        1414.705322265625
      ],
      [
        -1672.8739013671875,
        -3833.918212890625,
        1396.3919677734375
      ],
      [
        -1683.834716796875,
        -3837.310546875,
        1394.02783203125
      ],
      [
        -1673.3348388671875,
        -3837.353515625,
        1394.510009765625
      ],
      [
        -1672.8739013671875,
        -3833.918212890625,
        1396.3919677734375
      ],
      [
        -1672.458984375,
        -3830.831787109375,
        1397.989013671875
      ],
      [
        -1683.834716796875,
        -3837.310546875,
        1394.02783203125
      ],
      [
        -1683.9503173828125,
        -3837.2958984375,
        1393.8631591796875
      ],
      [
        -1671.9005126953125,
        -3826.251220703125,
        1405.259765625
      ],
      [
        -1672.2596435546875,
        -3829.349609375,
        1398.7559814453125
      ],
      [
        -1672.2596435546875,
        -3829.349609375,
        1398.7559814453125
      ],
      [
        -1672.7684326171875,
        -3815.851318359375,
        1427.9232177734375
      ],
      [
        -1675.5382080078125,
        -3812.534912109375,
        1428.345458984375
      ],
      [
        -1679.6114501953125,
        -3807.658203125,
        1428.96630859375
      ],
      [
        -1679.6114501953125,
        -3807.658203125,
        1428.96630859375
      ],
      [
        -1680.2862548828125,
        -3806.83154296875,
        1428.2967529296875
      ],
      [
        -1684.05712890625,
        -3837.2822265625,
        1393.7108154296875
      ],
      [
        -1669.7501220703125,
        -3825.33349609375,
        1408.4722900390625
      ],
      [
        -1669.9124755859375,
        -3830.3310546875,
        1398.243896484375
      ],
      [
        -1669.9124755859375,
        -3830.3310546875,
        1398.243896484375
      ],
      [
        -1670.136474609375,
        -3833.59375,
        1396.5552978515625
      ],
      [
        -1669.7501220703125,
        -3825.33349609375,
        1408.472412109375
      ],
      [
        -1669.489501953125,
        -3819.530517578125,
        1417.298095703125
      ],
      [
        -1670.2042236328125,
        -3818.6875,
        1417.9317626953125
      ],
      [
        -1670.2042236328125,
        -3818.6875,
        1417.9317626953125
      ],
      [
        -1670.2999267578125,
        -3809.22265625,
        1432.8856201171875
      ],
      [
        -1670.2177734375,
        -3813.95556640625,
        1430.29150390625
      ],
      [
        -1670.2999267578125,
        -3809.22265625,
        1432.8856201171875
      ],
      [
        -1669.6123046875,
        -3817.7041015625,
        1419.8992919921875
      ],
      [
        -1670.2177734375,
        -3813.95556640625,
        1430.29150390625
      ],
      [
        -1669.4849853515625,
        -3819.430419921875,
        1417.4501953125
      ],
      [
        -1669.6123046875,
        -3817.7041015625,
        1419.8992919921875
      ],
      [
        -1669.07080078125,
        -3825.04345703125,
        1409.4871826171875
      ],
      [
        -1668.5098876953125,
        -3830.20361328125,
        1399.3843994140625
      ],
      [
        -1669.07080078125,
        -3825.04345703125,
        1409.4873046875
      ],
      [
        -1664.7547607421875,
        -3756.37841796875,
        1418.71728515625
      ],
      [
        -1668.7396240234375,
        -3762.407470703125,
        1421.944580078125
      ],
      [
        -1664.7547607421875,
        -3756.37841796875,
        1418.71728515625
      ],
      [
        -1664.1239013671875,
        -3755.372802734375,
        1418.664306640625
      ],
      [
        -1668.5052490234375,
        -3824.802001953125,
        1410.332275390625
      ],
      [
        -1662.5987548828125,
        -3811.524169921875,
        1435.0999755859375
      ],
      [
        -1670.2742919921875,
        -3808.731201171875,
        1432.62841796875
      ],
      [
        -1669.770751953125,
        -3776.058837890625,
        1434.0223388671875
      ],
      [
        -1667.0150146484375,
        -3772.193115234375,
        1435.0999755859375
      ],
      [
        -1669.3280029296875,
        -3769.662353515625,
        1428.9866943359375
      ],
      [
        -1668.5052490234375,
        -3824.802001953125,
        1410.3321533203125
      ],
      [
        -1668.97900390625,
        -3825.88818359375,
        1407.8333740234375
      ],
      [
        -1647.644775390625,
        -3751.873779296875,
        1374.9000244140625
      ],
      [
        -1647.5968017578125,
        -3751.535888671875,
        1374.711181640625
      ],
      [
        -1647.644775390625,
        -3751.873779296875,
        1374.9000244140625
      ],
      [
        -1647.602294921875,
        -3751.55224609375,
        1374.9000244140625
      ],
      [
        -1664.9873046875,
        -3851.680419921875,
        1387.15478515625
      ],
      [
        -1665.1240234375,
        -3851.81005859375,
        1386.5465087890625
      ],
      [
        -1667.885986328125,
        -3854.443115234375,
        1374.34912109375
      ],
      [
        -1665.1240234375,
        -3851.81005859375,
        1386.5465087890625
      ],
      [
        -1664.660400390625,
        -3851.15869140625,
        1387.4530029296875
      ],
      [
        -1664.9873046875,
        -3851.680419921875,
        1387.15478515625
      ],
      [
        -1663.232666015625,
        -3848.85986328125,
        1388.640625
      ],
      [
        -1664.660400390625,
        -3851.15869140625,
        1387.4530029296875
      ],
      [
        -1663.232666015625,
        -3848.85986328125,
        1388.640625
      ],
      [
        -1589.939208984375,
        -3773.55615234375,
        1426.4005126953125
      ],
      [
        -1576.4552001953125,
        -3771.714111328125,
        1379.4097900390625
      ],
      [
        -1570.1778564453125,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1566.948974609375,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1565.2955322265625,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1571.83154296875,
        -3803.326416015625,
        1375.0999755859375
      ],
      [
        -1570.1778564453125,
        -3806.1083984375,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1564.2955322265625,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1570.83154296875,
        -3814.826416015625,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1569.1778564453125,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1565.948974609375,
        -3817.6083984375,
        1375.0999755859375
      ],
      [
        -1582.34375,
        -3780.625244140625,
        1335.75
      ],
      [
        -1581.306640625,
        -3783.39404296875,
        1351.6605224609375
      ],
      [
        -1581.306640625,
        -3783.39404296875,
        1351.6605224609375
      ],
      [
        -1580.92333984375,
        -3789.022705078125,
        1375.0999755859375
      ],
      [
        -1584.2962646484375,
        -3757.077392578125,
        1375.0999755859375
      ],
      [
        -1660.9869384765625,
        -3856.211669921875,
        1375.0999755859375
      ],
      [
        -1660.9869384765625,
        -3856.211669921875,
        1375.0999755859375
      ],
      [
        -1665.10302734375,
        -3855.93798828125,
        1375.0999755859375
      ],
      [
        -1665.10302734375,
        -3855.93798828125,
        1375.0999755859375
      ],
      [
        -1667.7159423828125,
        -3854.281005859375,
        1375.0999755859375
      ],
      [
        -1621.1650390625,
        -3837.75244140625,
        1392.0999755859375
      ],
      [
        -1591.0390625,
        -3772.21826171875,
        1427.2364501953125
      ],
      [
        -1566.14013671875,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1570.9749755859375,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1563.65283203125,
        -3803.38818359375,
        1392.0999755859375
      ],
      [
        -1566.14013671875,
        -3807.573486328125,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1572.462646484375,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1562.65283203125,
        -3814.88818359375,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1565.14013671875,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1569.9749755859375,
        -3819.073486328125,
        1392.0999755859375
      ],
      [
        -1565.2379150390625,
        -3803.328369140625,
        1387.48095703125
      ],
      [
        -1566.723876953125,
        -3806.51611328125,
        1388.645263671875
      ],
      [
        -1566.723876953125,
        -3806.51611328125,
        1388.645263671875
      ],
      [
        -1570.7747802734375,
        -3807.20556640625,
        1390.8974609375
      ],
      [
        -1564.0089111328125,
        -3814.837158203125,
        1388.1480712890625
      ],
      [
        -1565.5975341796875,
        -3818.244873046875,
        1389.392822265625
      ],
      [
        -1565.5975341796875,
        -3818.244873046875,
        1389.392822265625
      ],
      [
        -1569.9248046875,
        -3818.981201171875,
        1391.798828125
      ],
      [
        -1569.9248046875,
        -3818.981201171875,
        1391.798828125
      ],
      [
        -1570.744873046875,
        -3817.778076171875,
        1392.0999755859375
      ],
      [
        -1574.7027587890625,
        -3797.11572265625,
        1390.6368408203125
      ],
      [
        -1565.4625244140625,
        -3803.31982421875,
        1386.826416015625
      ],
      [
        -1566.0643310546875,
        -3804.6083984375,
        1387.293701171875
      ],
      [
        -1566.739013671875,
        -3806.48876953125,
        1388.5555419921875
      ],
      [
        -1566.739013671875,
        -3806.48876953125,
        1388.5555419921875
      ],
      [
        -1567.0799560546875,
        -3806.57666015625,
        1388.84326171875
      ],
      [
        -1565.6800537109375,
        -3818.095458984375,
        1388.904541015625
      ],
      [
        -1569.798583984375,
        -3818.74951171875,
        1391.041259765625
      ],
      [
        -1566.7867431640625,
        -3806.40234375,
        1388.2728271484375
      ],
      [
        -1570.6734619140625,
        -3807.01953125,
        1390.2894287109375
      ],
      [
        -1566.7867431640625,
        -3806.40234375,
        1388.2728271484375
      ],
      [
        -1566.4642333984375,
        -3805.72314453125,
        1388.041748046875
      ],
      [
        -1569.798583984375,
        -3818.74951171875,
        1391.041259765625
      ],
      [
        -1572.4166259765625,
        -3814.886474609375,
        1391.96484375
      ],
      [
        -1564.13037109375,
        -3814.83251953125,
        1387.794189453125
      ],
      [
        -1565.6800537109375,
        -3818.095458984375,
        1388.904541015625
      ],
      [
        -1569.7884521484375,
        -3818.730712890625,
        1390.980224609375
      ],
      [
        -1572.3466796875,
        -3814.8837890625,
        1391.7596435546875
      ],
      [
        -1565.6893310546875,
        -3818.07861328125,
        1388.849365234375
      ],
      [
        -1569.7884521484375,
        -3818.730712890625,
        1390.980224609375
      ],
      [
        -1566.8492431640625,
        -3806.2890625,
        1387.903076171875
      ],
      [
        -1570.600830078125,
        -3806.885986328125,
        1389.8531494140625
      ],
      [
        -1577.745849609375,
        -3796.682861328125,
        1392.0999755859375
      ],
      [
        -1574.7027587890625,
        -3797.11572265625,
        1390.6368408203125
      ],
      [
        -1566.8492431640625,
        -3806.2890625,
        1387.903076171875
      ],
      [
        -1564.17236328125,
        -3814.8310546875,
        1387.671875
      ],
      [
        -1565.6893310546875,
        -3818.07861328125,
        1388.849365234375
      ],
      [
        -1565.60009765625,
        -3803.314697265625,
        1386.4254150390625
      ],
      [
        -1566.0643310546875,
        -3804.6083984375,
        1387.293701171875
      ],
      [
        -1569.11962890625,
        -3783.68896484375,
        1375.0999755859375
      ],
      [
        -1570.987548828125,
        -3782.3896484375,
        1378.6053466796875
      ],
      [
        -1570.987548828125,
        -3782.3896484375,
        1378.6053466796875
      ],
      [
        -1571.2906494140625,
        -3782.51513671875,
        1378.87353515625
      ],
      [
        -1551.4945068359375,
        -3865.38330078125,
        1376.6326904296875
      ],
      [
        -1561.3228759765625,
        -3869.614013671875,
        1386.2039794921875
      ],
      [
        -1629.5155029296875,
        -3856.526611328125,
        1385.80029296875
      ],
      [
        -1629.075439453125,
        -3854.339599609375,
        1387.2027587890625
      ],
      [
        -1568.397705078125,
        -3872.783447265625,
        1382.1558837890625
      ],
      [
        -1624.914306640625,
        -3860.91455078125,
        1378.1693115234375
      ],
      [
        -1629.5155029296875,
        -3856.526611328125,
        1385.80029296875
      ],
      [
        -1626.7030029296875,
        -3858.954833984375,
        1380.099853515625
      ],
      [
        -1570.126220703125,
        -3873.2294921875,
        1380.9832763671875
      ],
      [
        -1628.288818359375,
        -3852.690185546875,
        1387.689697265625
      ],
      [
        -1629.075439453125,
        -3854.339599609375,
        1387.2027587890625
      ],
      [
        -1620.8028564453125,
        -3853.108154296875,
        1389.716552734375
      ],
      [
        -1570.126220703125,
        -3873.2294921875,
        1380.9832763671875
      ],
      [
        -1569.65966796875,
        -3873.353759765625,
        1380.982177734375
      ],
      [
        -1625.5313720703125,
        -3859.96630859375,
        1377.7252197265625
      ],
      [
        -1626.624755859375,
        -3859.04052734375,
        1380.015380859375
      ],
      [
        -1626.646240234375,
        -3859.00390625,
        1379.98486328125
      ],
      [
        -1621.1650390625,
        -3837.75244140625,
        1392.0999755859375
      ],
      [
        -1566.26513671875,
        -3803.28955078125,
        1384.487548828125
      ],
      [
        -1565.3050537109375,
        -3814.788330078125,
        1378.09814453125
      ],
      [
        -1566.420166015625,
        -3816.7548828125,
        1377.9420166015625
      ],
      [
        -1565.435791015625,
        -3816.7451171875,
        1375.0999755859375
      ],
      [
        -1566.420166015625,
        -3816.7548828125,
        1377.9420166015625
      ],
      [
        -1625.9490966796875,
        -3834.8466796875,
        1394.86767578125
      ],
      [
        -1625.78564453125,
        -3836.3583984375,
        1392.1646728515625
      ],
      [
        -1625.92919921875,
        -3836.5947265625,
        1392.0999755859375
      ],
      [
        -1625.9490966796875,
        -3834.8466796875,
        1394.86767578125
      ],
      [
        -1625.26513671875,
        -3835.501220703125,
        1392.399169921875
      ],
      [
        -1625.26513671875,
        -3835.501220703125,
        1392.399169921875
      ],
      [
        -1574.7020263671875,
        -3776.952880859375,
        1376.6451416015625
      ],
      [
        -1582.851806640625,
        -3782.396484375,
        1385.410400390625
      ],
      [
        -1635.1466064453125,
        -3851.773193359375,
        1387.94677734375
      ],
      [
        -1636.3670654296875,
        -3854.26953125,
        1386.63818359375
      ],
      [
        -1635.146728515625,
        -3851.773193359375,
        1387.94677734375
      ],
      [
        -1636.366943359375,
        -3854.26953125,
        1386.63818359375
      ],
      [
        -1636.0306396484375,
        -3854.740234375,
        1385.192138671875
      ],
      [
        -1635.9232177734375,
        -3854.890625,
        1384.73046875
      ],
      [
        -1631.0654296875,
        -3854.471435546875,
        1375.0999755859375
      ],
      [
        -1635.9232177734375,
        -3854.890625,
        1384.73046875
      ],
      [
        -1574.142333984375,
        -3777.18408203125,
        1375.0999755859375
      ],
      [
        -1574.7020263671875,
        -3776.952880859375,
        1376.6451416015625
      ],
      [
        -1593.689697265625,
        -3768.994140625,
        1429.2508544921875
      ],
      [
        -1598.079833984375,
        -3771.20361328125,
        1435.0999755859375
      ],
      [
        -1638.4990234375,
        -3835.14501953125,
        1393.7921142578125
      ],
      [
        -1575.016357421875,
        -3777.162841796875,
        1376.9832763671875
      ],
      [
        -1487.178955078125,
        -3906.0,
        1335.75
      ],
      [
        -1562.59423828125,
        -3899.0791015625,
        1373.2047119140625
      ],
      [
        -1536.0750732421875,
        -3905.97021484375,
        1370.099365234375
      ],
      [
        -1493.83544921875,
        -3906.0,
        1351.37255859375
      ],
      [
        -1499.391357421875,
        -3906.0,
        1351.37255859375
      ],
      [
        -1499.391357421875,
        -3906.0,
        1351.37255859375
      ],
      [
        -1501.965087890625,
        -3906.0,
        1354.7989501953125
      ],
      [
        -1501.965087890625,
        -3906.0,
        1354.7989501953125
      ],
      [
        -1498.98291015625,
        -3906.0,
        1358.2252197265625
      ],
      [
        -1493.427001953125,
        -3906.0,
        1358.225341796875
      ],
      [
        -1498.98291015625,
        -3906.0,
        1358.2252197265625
      ],
      [
        -1490.853271484375,
        -3906.0,
        1354.7989501953125
      ],
      [
        -1493.83544921875,
        -3906.0,
        1351.37255859375
      ],
      [
        -1493.427001953125,
        -3906.0,
        1358.225341796875
      ],
      [
        -1490.853271484375,
        -3906.0,
        1354.7989501953125
      ],
      [
        -1536.0648193359375,
        -3905.977783203125,
        1370.1092529296875
      ],
      [
        -1536.03515625,
        -3906.0,
        1370.138671875
      ],
      [
        -1536.0750732421875,
        -3905.97021484375,
        1370.099365234375
      ],
      [
        -1536.0648193359375,
        -3905.977783203125,
        1370.1092529296875
      ],
      [
        -1565.323974609375,
        -3906.0,
        1390.7552490234375
      ],
      [
        -1566.673583984375,
        -3902.834716796875,
        1384.55712890625
      ],
      [
        -1567.10107421875,
        -3901.890625,
        1382.7264404296875
      ],
      [
        -1566.673583984375,
        -3902.834716796875,
        1384.55712890625
      ],
      [
        -1567.10107421875,
        -3901.890625,
        1382.7264404296875
      ],
      [
        -1564.4510498046875,
        -3893.5,
        1382.9974365234375
      ],
      [
        -1567.0810546875,
        -3901.87841796875,
        1382.684814453125
      ],
      [
        -1565.709716796875,
        -3901.041259765625,
        1379.8287353515625
      ],
      [
        -1562.59423828125,
        -3899.0791015625,
        1373.2047119140625
      ],
      [
        -1565.709716796875,
        -3901.041259765625,
        1379.8287353515625
      ],
      [
        -1568.6580810546875,
        -3906.0,
        1335.75
      ],
      [
        -1575.208740234375,
        -3899.814453125,
        1372.8731689453125
      ],
      [
        -1562.0701904296875,
        -3906.0,
        1368.9881591796875
      ],
      [
        -1563.3594970703125,
        -3906.0,
        1370.0858154296875
      ],
      [
        -1562.0701904296875,
        -3906.0,
        1368.9881591796875
      ],
      [
        -1567.9063720703125,
        -3906.0,
        1366.5819091796875
      ],
      [
        -1578.7286376953125,
        -3906.0,
        1368.419921875
      ],
      [
        -1567.9063720703125,
        -3906.0,
        1366.5819091796875
      ],
      [
        -1578.7286376953125,
        -3906.0,
        1368.419921875
      ],
      [
        -1579.436767578125,
        -3906.0,
        1369.022705078125
      ],
      [
        -1567.055419921875,
        -3906.0,
        1373.232421875
      ],
      [
        -1567.055419921875,
        -3906.0,
        1373.232421875
      ],
      [
        -1577.87744140625,
        -3906.0,
        1375.0704345703125
      ],
      [
        -1563.7257080078125,
        -3905.808837890625,
        1370.172119140625
      ],
      [
        -1563.9417724609375,
        -3906.0,
        1370.581787109375
      ],
      [
        -1578.05224609375,
        -3906.0,
        1374.998291015625
      ],
      [
        -1577.87744140625,
        -3906.0,
        1375.0704345703125
      ],
      [
        -1567.091552734375,
        -3901.91162109375,
        1382.76708984375
      ],
      [
        -1482.2191162109375,
        -3954.0,
        1357.6602783203125
      ],
      [
        -1493.041259765625,
        -3954.0,
        1359.498291015625
      ],
      [
        -1482.218994140625,
        -3954.0,
        1357.6602783203125
      ],
      [
        -1477.23388671875,
        -3954.0,
        1353.416015625
      ],
      [
        -1493.892333984375,
        -3954.0,
        1352.8477783203125
      ],
      [
        -1483.0703125,
        -3954.0,
        1351.009765625
      ],
      [
        -1477.23388671875,
        -3954.0,
        1353.416015625
      ],
      [
        -1483.0703125,
        -3954.0,
        1351.009765625
      ],
      [
        -1493.892333984375,
        -3954.0,
        1352.8477783203125
      ],
      [
        -1498.877685546875,
        -3954.0,
        1357.0921630859375
      ],
      [
        -1498.877685546875,
        -3954.0,
        1357.0921630859375
      ],
      [
        -1493.041259765625,
        -3954.0,
        1359.498291015625
      ],
      [
        -1571.2015380859375,
        -3906.0,
        1373.9365234375
      ],
      [
        -1568.633056640625,
        -3906.0,
        1366.705322265625
      ],
      [
        -1569.3792724609375,
        -3911.289794921875,
        1366.703857421875
      ],
      [
        -1570.9371337890625,
        -3913.22900390625,
        1370.3192138671875
      ],
      [
        -1571.6949462890625,
        -3909.498291015625,
        1373.935546875
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1366.1263427734375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1372.3809814453125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1370.952392578125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1369.076904296875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1368.193359375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1369.9351806640625
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1372.3809814453125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1366.1263427734375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1369.076904296875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1370.952392578125
      ],
      [
        -1569.9329833984375,
        -3913.79736328125,
        1370.1351318359375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1369.9351806640625
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1368.193359375
      ],
      [
        -1564.7093505859375,
        -3916.7529296875,
        1369.1761474609375
      ],
      [
        -1572.4947509765625,
        -3915.167724609375,
        1373.9339599609375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1372.5299072265625
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1372.89697265625
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1373.4853515625
      ],
      [
        -1571.1605224609375,
        -3915.92333984375,
        1373.689208984375
      ],
      [
        -1565.936767578125,
        -3918.878662109375,
        1372.730224609375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1372.5299072265625
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1372.89697265625
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1373.4853515625
      ],
      [
        -1572.6378173828125,
        -3934.3896484375,
        1366.697265625
      ],
      [
        -1577.943603515625,
        -3953.793701171875,
        1373.9232177734375
      ],
      [
        -1578.2216796875,
        -3952.03857421875,
        1367.2178955078125
      ],
      [
        -1578.0023193359375,
        -3953.9794921875,
        1373.9287109375
      ],
      [
        -1577.943603515625,
        -3953.793701171875,
        1373.9232177734375
      ],
      [
        -1572.6378173828125,
        -3934.3896484375,
        1366.697265625
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1370.173828125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1366.911865234375
      ],
      [
        -1569.66845703125,
        -3913.339111328125,
        1366.7032470703125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1366.911865234375
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1370.173828125
      ],
      [
        -1570.3092041015625,
        -3917.88134765625,
        1366.701904296875
      ],
      [
        -1578.0023193359375,
        -3953.9794921875,
        1373.9287109375
      ],
      [
        -1578.2216796875,
        -3952.03857421875,
        1367.2178955078125
      ],
      [
        -1577.5205078125,
        -3954.0,
        1367.0511474609375
      ],
      [
        -1577.9949951171875,
        -3954.0,
        1373.9268798828125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1366.5447998046875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1373.3399658203125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1372.75146484375
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1365.956298828125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1365.956298828125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1372.75146484375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1365.7347412109375
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1373.70703125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1373.3399658203125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1366.5447998046875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1366.6903076171875
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1373.70703125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1366.101806640625
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1366.6903076171875
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1365.7347412109375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1366.101806640625
      ],
      [
        -1475.40087890625,
        -3952.216064453125,
        1349.7503662109375
      ],
      [
        -1476.2586669921875,
        -3954.0,
        1352.5863037109375
      ],
      [
        -1476.0333251953125,
        -3954.0,
        1349.8145751953125
      ],
      [
        -1572.2376708984375,
        -3916.0,
        1336.5
      ],
      [
        -1581.7359619140625,
        -3950.997314453125,
        1336.5
      ],
      [
        -1578.7208251953125,
        -3941.577392578125,
        1336.5
      ],
      [
        -1581.59423828125,
        -3951.532958984375,
        1339.0
      ],
      [
        -1571.6226806640625,
        -3916.0,
        1339.0
      ],
      [
        -1576.957275390625,
        -3937.046142578125,
        1339.0
      ],
      [
        -1572.2376708984375,
        -3916.0,
        1336.5
      ],
      [
        -1571.6226806640625,
        -3916.0,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1344.432373046875
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1366.4886474609375
      ],
      [
        -1569.66845703125,
        -3913.339111328125,
        1366.7032470703125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1340.481201171875
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1340.481201171875
      ],
      [
        -1570.3092041015625,
        -3917.88134765625,
        1366.701904296875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1364.103271484375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1352.306884765625
      ],
      [
        -1569.8253173828125,
        -3918.71923828125,
        1349.1077880859375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1366.4886474609375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1344.432373046875
      ],
      [
        -1567.663330078125,
        -3913.164306640625,
        1352.17236328125
      ],
      [
        -1566.8341064453125,
        -3913.164306640625,
        1358.79296875
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1352.306884765625
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1364.103271484375
      ],
      [
        -1568.47509765625,
        -3919.165771484375,
        1361.0279541015625
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1364.63330078125
      ],
      [
        -1567.8212890625,
        -3919.165771484375,
        1366.2481689453125
      ],
      [
        -1565.9862060546875,
        -3913.36572265625,
        1366.0771484375
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1364.63330078125
      ],
      [
        -1570.5338134765625,
        -3916.0,
        1336.5
      ],
      [
        -1569.705322265625,
        -3906.009521484375,
        1336.5
      ],
      [
        -1567.3360595703125,
        -3906.009033203125,
        1336.5
      ],
      [
        -1570.220703125,
        -3916.0,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1336.97021484375
      ],
      [
        -1569.313232421875,
        -3913.164306640625,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1336.97021484375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1339.0
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1339.0
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1336.5
      ],
      [
        -1569.6995849609375,
        -3913.393310546875,
        1336.5
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1336.5
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1339.0
      ],
      [
        -1570.6397705078125,
        -3917.308837890625,
        1339.0
      ],
      [
        -1570.8411865234375,
        -3916.9599609375,
        1336.5
      ],
      [
        -1571.2047119140625,
        -3916.0,
        1336.5
      ],
      [
        -1570.5338134765625,
        -3916.0,
        1336.5
      ],
      [
        -1570.220703125,
        -3916.0,
        1339.0
      ],
      [
        -1571.2047119140625,
        -3916.0,
        1339.0
      ],
      [
        -1569.910400390625,
        -3913.75830078125,
        1335.75
      ],
      [
        -1570.901611328125,
        -3916.855224609375,
        1335.75
      ],
      [
        -1567.354248046875,
        -3906.009033203125,
        1336.354736328125
      ],
      [
        -1567.354248046875,
        -3906.009033203125,
        1336.354736328125
      ],
      [
        -1567.35302734375,
        -3906.0,
        1336.3409423828125
      ],
      [
        -1575.3603515625,
        -3954.0,
        1335.75
      ],
      [
        -1579.2257080078125,
        -3943.15478515625,
        1336.5
      ],
      [
        -1580.941162109375,
        -3954.0,
        1336.5
      ],
      [
        -1575.412353515625,
        -3954.0,
        1336.5
      ],
      [
        -1580.941162109375,
        -3954.0,
        1339.0
      ],
      [
        -1579.1439208984375,
        -3943.877685546875,
        1339.0
      ],
      [
        -1575.584716796875,
        -3954.0,
        1339.0
      ],
      [
        -1549.31005859375,
        -3954.0,
        1339.0
      ],
      [
        -1549.31005859375,
        -3954.0,
        1336.5
      ],
      [
        -1549.31005859375,
        -3954.0,
        1339.0
      ],
      [
        -1549.31005859375,
        -3954.0,
        1336.5
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1336.5
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1339.0
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1339.0
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1336.5
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1336.5
      ],
      [
        -1570.8411865234375,
        -3916.9599609375,
        1336.5
      ],
      [
        -1570.6397705078125,
        -3917.308837890625,
        1339.0
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1336.5
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1339.0
      ],
      [
        -1565.92578125,
        -3918.859619140625,
        1339.0
      ],
      [
        -1565.92578125,
        -3918.859619140625,
        1336.5
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1336.5
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1339.0
      ],
      [
        -1569.313232421875,
        -3913.164306640625,
        1339.0
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1336.5
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1339.0
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1336.5
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1336.5
      ],
      [
        -1569.6995849609375,
        -3913.393310546875,
        1336.5
      ],
      [
        -1513.462646484375,
        -3954.0,
        1341.1697998046875
      ],
      [
        -1505.7716064453125,
        -3927.764404296875,
        1346.746337890625
      ],
      [
        -1508.5657958984375,
        -3928.5166015625,
        1350.012939453125
      ],
      [
        -1516.036376953125,
        -3954.0,
        1344.59619140625
      ],
      [
        -1507.90673828125,
        -3954.0,
        1341.1697998046875
      ],
      [
        -1501.0599365234375,
        -3930.644287109375,
        1346.1341552734375
      ],
      [
        -1505.7716064453125,
        -3927.764404296875,
        1346.746337890625
      ],
      [
        -1513.462646484375,
        -3954.0,
        1341.1697998046875
      ],
      [
        -1516.036376953125,
        -3954.0,
        1344.59619140625
      ],
      [
        -1508.5657958984375,
        -3928.5166015625,
        1350.012939453125
      ],
      [
        -1506.6483154296875,
        -3932.1484375,
        1352.667236328125
      ],
      [
        -1513.0540771484375,
        -3954.0,
        1348.0224609375
      ],
      [
        -1504.924560546875,
        -3954.0,
        1344.59619140625
      ],
      [
        -1499.1424560546875,
        -3934.276123046875,
        1348.78857421875
      ],
      [
        -1501.0599365234375,
        -3930.644287109375,
        1346.1341552734375
      ],
      [
        -1507.90673828125,
        -3954.0,
        1341.1697998046875
      ],
      [
        -1501.9366455078125,
        -3935.0283203125,
        1352.05517578125
      ],
      [
        -1507.4981689453125,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1513.0540771484375,
        -3954.0,
        1348.0224609375
      ],
      [
        -1506.6483154296875,
        -3932.1484375,
        1352.667236328125
      ],
      [
        -1507.4981689453125,
        -3954.0,
        1348.0225830078125
      ],
      [
        -1501.9366455078125,
        -3935.0283203125,
        1352.05517578125
      ],
      [
        -1499.1424560546875,
        -3934.276123046875,
        1348.78857421875
      ],
      [
        -1504.924560546875,
        -3954.0,
        1344.59619140625
      ],
      [
        -1473.212646484375,
        -3947.66552734375,
        1342.5164794921875
      ],
      [
        -1475.3304443359375,
        -3954.0,
        1341.170166015625
      ],
      [
        -1474.8896484375,
        -3954.0,
        1335.75
      ],
      [
        -1471.1658935546875,
        -3943.4091796875,
        1335.75
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1354.7896728515625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1356.8564453125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1356.8564453125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1353.906494140625
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1353.906494140625
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1348.8897705078125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1349.7725830078125
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1354.7896728515625
      ],
      [
        -1523.2919921875,
        -3914.298095703125,
        1343.0
      ],
      [
        -1522.73388671875,
        -3913.33154296875,
        1335.75
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1346.8226318359375
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1349.7725830078125
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1348.8897705078125
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1346.8226318359375
      ],
      [
        -1526.1024169921875,
        -3919.165771484375,
        1345.69384765625
      ],
      [
        -1526.1722412109375,
        -3919.165771484375,
        1345.7894287109375
      ],
      [
        -1524.4649658203125,
        -3916.0,
        1345.95458984375
      ],
      [
        -1524.3697509765625,
        -3916.164794921875,
        1345.6937255859375
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1345.7894287109375
      ],
      [
        -1529.6976318359375,
        -3918.9404296875,
        1346.1461181640625
      ],
      [
        -1526.1722412109375,
        -3919.165771484375,
        1345.7894287109375
      ],
      [
        -1524.4649658203125,
        -3916.0,
        1345.95458984375
      ],
      [
        -1526.36279296875,
        -3913.164306640625,
        1346.3118896484375
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1345.9552001953125
      ],
      [
        -1529.6976318359375,
        -3918.9404296875,
        1346.1461181640625
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1346.1461181640625
      ],
      [
        -1531.204833984375,
        -3916.0,
        1346.4071044921875
      ],
      [
        -1526.36279296875,
        -3913.164306640625,
        1346.3118896484375
      ],
      [
        -1529.602294921875,
        -3913.224609375,
        1346.407470703125
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1346.31201171875
      ],
      [
        -1531.204833984375,
        -3916.0,
        1346.4071044921875
      ],
      [
        -1529.602294921875,
        -3913.224609375,
        1346.407470703125
      ],
      [
        -1524.274658203125,
        -3916.0,
        1345.6937255859375
      ],
      [
        -1523.946533203125,
        -3913.164306640625,
        1343.0
      ],
      [
        -1523.2919921875,
        -3914.298095703125,
        1343.0
      ],
      [
        -1524.274658203125,
        -3916.0,
        1345.6937255859375
      ],
      [
        -1528.3592529296875,
        -3911.07177734375,
        1343.0
      ],
      [
        -1527.80126953125,
        -3910.105224609375,
        1335.75
      ],
      [
        -1528.3592529296875,
        -3911.07177734375,
        1343.0
      ],
      [
        -1532.54296875,
        -3914.01220703125,
        1343.0
      ],
      [
        -1533.10107421875,
        -3913.045654296875,
        1335.75
      ],
      [
        -1531.395263671875,
        -3916.0,
        1346.1461181640625
      ],
      [
        -1532.54296875,
        -3914.01220703125,
        1343.0
      ],
      [
        -1531.395263671875,
        -3916.0,
        1346.1461181640625
      ],
      [
        -1524.1370849609375,
        -3919.165771484375,
        1343.0
      ],
      [
        -1523.02099609375,
        -3919.165771484375,
        1335.75
      ],
      [
        -1524.1370849609375,
        -3919.165771484375,
        1343.0
      ],
      [
        -1528.550048828125,
        -3920.92822265625,
        1343.0
      ],
      [
        -1527.991943359375,
        -3921.894775390625,
        1335.75
      ],
      [
        -1528.550048828125,
        -3920.92822265625,
        1343.0
      ],
      [
        -1474.8016357421875,
        -3948.9453125,
        1356.5230712890625
      ],
      [
        -1503.487060546875,
        -3921.911376953125,
        1362.05029296875
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1358.19970703125
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1358.4212646484375
      ],
      [
        -1481.300048828125,
        -3916.1650390625,
        1358.4212646484375
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1358.0543212890625
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1357.611328125
      ],
      [
        -1479.5675048828125,
        -3913.164306640625,
        1358.19970703125
      ],
      [
        -1479.5675048828125,
        -3919.165771484375,
        1358.0543212890625
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1357.4658203125
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1357.244384765625
      ],
      [
        -1476.1025390625,
        -3913.164306640625,
        1357.611328125
      ],
      [
        -1476.1025390625,
        -3919.165771484375,
        1357.4658203125
      ],
      [
        -1474.3699951171875,
        -3916.1650390625,
        1357.244384765625
      ],
      [
        -1513.2918701171875,
        -3906.0,
        1364.101318359375
      ],
      [
        -1503.487060546875,
        -3921.911376953125,
        1362.05029296875
      ],
      [
        -1498.53662109375,
        -3923.43017578125,
        1354.5205078125
      ],
      [
        -1496.1763916015625,
        -3924.158203125,
        1350.939208984375
      ],
      [
        -1496.1763916015625,
        -3924.158203125,
        1350.939208984375
      ],
      [
        -1498.172607421875,
        -3920.795166015625,
        1348.2276611328125
      ],
      [
        -1498.53662109375,
        -3923.43017578125,
        1354.5205078125
      ],
      [
        -1502.89306640625,
        -3919.338623046875,
        1355.3900146484375
      ],
      [
        -1498.172607421875,
        -3920.795166015625,
        1348.2276611328125
      ],
      [
        -1502.22314453125,
        -3915.659912109375,
        1349.3193359375
      ],
      [
        -1499.0001220703125,
        -3920.01806640625,
        1348.392822265625
      ],
      [
        -1504.889404296875,
        -3915.975830078125,
        1352.6785888671875
      ],
      [
        -1502.89306640625,
        -3919.338623046875,
        1355.3900146484375
      ],
      [
        -1502.22314453125,
        -3915.659912109375,
        1349.3193359375
      ],
      [
        -1504.889404296875,
        -3915.975830078125,
        1352.6785888671875
      ],
      [
        -1503.3631591796875,
        -3916.446533203125,
        1350.36279296875
      ],
      [
        -1502.5291748046875,
        -3916.70361328125,
        1349.097412109375
      ],
      [
        -1502.5291748046875,
        -3916.70361328125,
        1349.097412109375
      ],
      [
        -1474.8016357421875,
        -3948.9453125,
        1356.5230712890625
      ],
      [
        -1476.5936279296875,
        -3954.0,
        1356.704833984375
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1365.7362060546875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1366.1033935546875
      ],
      [
        -1526.1025390625,
        -3913.164306640625,
        1366.1033935546875
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1366.6917724609375
      ],
      [
        -1529.5675048828125,
        -3913.164306640625,
        1366.6917724609375
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1366.913330078125
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1365.957763671875
      ],
      [
        -1524.3699951171875,
        -3916.1650390625,
        1365.7362060546875
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1366.5462646484375
      ],
      [
        -1526.1025390625,
        -3919.165771484375,
        1365.957763671875
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1366.913330078125
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1366.5462646484375
      ],
      [
        -1508.09228515625,
        -3906.0,
        1378.740234375
      ],
      [
        -1475.1368408203125,
        -3948.62939453125,
        1356.587646484375
      ],
      [
        -1474.8492431640625,
        -3949.07958984375,
        1356.5279541015625
      ],
      [
        -1531.300048828125,
        -3916.1650390625,
        1410.0972900390625
      ],
      [
        -1529.5675048828125,
        -3919.165771484375,
        1410.5811767578125
      ],
      [
        -1526.1024169921875,
        -3919.165771484375,
        1409.4971923828125
      ],
      [
        -1524.369873046875,
        -3916.1650390625,
        1407.9293212890625
      ],
      [
        -1526.1024169921875,
        -3913.164306640625,
        1407.4454345703125
      ],
      [
        -1529.5673828125,
        -3913.164306640625,
        1408.5294189453125
      ],
      [
        -1533.03271484375,
        -3913.164306640625,
        1409.6134033203125
      ],
      [
        -1530.2388916015625,
        -3906.0,
        1406.2900390625
      ],
      [
        -1537.1693115234375,
        -3906.0,
        1408.4580078125
      ],
      [
        -1527.8349609375,
        -3922.16650390625,
        1411.0650634765625
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1390.018798828125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1385.7081298828125
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1385.7081298828125
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1391.1534423828125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1399.8206787109375
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1390.018798828125
      ],
      [
        -1566.8260498046875,
        -3913.164306640625,
        1397.7369384765625
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1391.1534423828125
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1401.0615234375
      ],
      [
        -1568.470947265625,
        -3919.165771484375,
        1394.2406005859375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1405.430908203125
      ],
      [
        -1566.1025390625,
        -3913.164306640625,
        1399.8206787109375
      ],
      [
        -1566.1025390625,
        -3919.165771484375,
        1401.0615234375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1405.430908203125
      ],
      [
        -1572.9078369140625,
        -3906.0,
        1378.7403564453125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1389.841552734375
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1385.4720458984375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1391.08251953125
      ],
      [
        -1569.5675048828125,
        -3913.164306640625,
        1389.841552734375
      ],
      [
        -1571.300048828125,
        -3916.1650390625,
        1385.4720458984375
      ],
      [
        -1569.5675048828125,
        -3919.165771484375,
        1391.08251953125
      ],
      [
        -1546.21484375,
        -3954.0,
        1416.1712646484375
      ],
      [
        -1533.661865234375,
        -3932.258544921875,
        1416.338134765625
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1403.7950439453125
      ],
      [
        -1564.9931640625,
        -3915.085693359375,
        1403.4130859375
      ],
      [
        -1565.0218505859375,
        -3917.294189453125,
        1403.786865234375
      ],
      [
        -1564.3699951171875,
        -3916.1650390625,
        1403.7950439453125
      ],
      [
        -1533.661865234375,
        -3932.258544921875,
        1416.338134765625
      ],
      [
        -1533.5013427734375,
        -3931.98046875,
        1416.19287109375
      ],
      [
        -1518.5008544921875,
        -3906.0,
        1402.6181640625
      ],
      [
        -1497.5675048828125,
        -3955.164306640625,
        1411.6551513671875
      ],
      [
        -1499.300048828125,
        -3958.1650390625,
        1410.6463623046875
      ],
      [
        -1497.567626953125,
        -3961.165771484375,
        1408.52880859375
      ],
      [
        -1494.1025390625,
        -3961.165771484375,
        1407.419921875
      ],
      [
        -1492.3699951171875,
        -3958.1650390625,
        1408.4287109375
      ],
      [
        -1494.1024169921875,
        -3955.164306640625,
        1410.5462646484375
      ],
      [
        -1496.81982421875,
        -3955.164306640625,
        1356.7144775390625
      ],
      [
        -1492.7840576171875,
        -3957.44775390625,
        1355.9736328125
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1354.40087890625
      ],
      [
        -1492.7840576171875,
        -3957.44775390625,
        1355.9736328125
      ],
      [
        -1496.81982421875,
        -3955.164306640625,
        1356.7144775390625
      ],
      [
        -1494.1025390625,
        -3955.164306640625,
        1357.834716796875
      ],
      [
        -1494.7747802734375,
        -3954.0,
        1353.5989990234375
      ],
      [
        -1496.895263671875,
        -3954.0,
        1355.4044189453125
      ],
      [
        -1497.3834228515625,
        -3954.845458984375,
        1356.81787109375
      ],
      [
        -1494.774658203125,
        -3954.0,
        1411.367919921875
      ],
      [
        -1496.895263671875,
        -3954.0,
        1412.0465087890625
      ],
      [
        -1497.3834228515625,
        -3954.845458984375,
        1356.81787109375
      ],
      [
        -1496.895263671875,
        -3954.0,
        1357.909423828125
      ],
      [
        -1494.7747802734375,
        -3954.0,
        1358.78369140625
      ],
      [
        -1491.77734375,
        -3957.138671875,
        1408.773681640625
      ],
      [
        -1492.1597900390625,
        -3957.801025390625,
        1355.8590087890625
      ],
      [
        -1490.72265625,
        -3955.311767578125,
        1359.0726318359375
      ],
      [
        -1490.93212890625,
        -3955.6748046875,
        1352.304443359375
      ],
      [
        -1492.1597900390625,
        -3957.801025390625,
        1355.8590087890625
      ],
      [
        -1490.93212890625,
        -3955.6748046875,
        1352.304443359375
      ],
      [
        -1489.9652099609375,
        -3954.0,
        1352.1807861328125
      ],
      [
        -1490.72265625,
        -3955.311767578125,
        1359.0726318359375
      ],
      [
        -1489.9652099609375,
        -3954.0,
        1358.975830078125
      ],
      [
        -1489.9652099609375,
        -3954.0,
        1408.4598388671875
      ],
      [
        -1491.77734375,
        -3957.138671875,
        1408.773681640625
      ],
      [
        -1495.8350830078125,
        -3964.16650390625,
        1406.4111328125
      ],
      [
        -1477.5335693359375,
        -3956.651123046875,
        1356.8001708984375
      ],
      [
        -1479.3416748046875,
        -3961.751220703125,
        1356.983642578125
      ],
      [
        -1477.5335693359375,
        -3956.651123046875,
        1356.8001708984375
      ],
      [
        -1476.46728515625,
        -3954.433837890625,
        1353.2752685546875
      ],
      [
        -1476.46728515625,
        -3954.433837890625,
        1353.2752685546875
      ],
      [
        -1477.2091064453125,
        -3957.316162109375,
        1349.9339599609375
      ],
      [
        -1480.08349609375,
        -3964.6337890625,
        1353.642333984375
      ],
      [
        -1479.3416748046875,
        -3961.751220703125,
        1356.983642578125
      ],
      [
        -1479.0172119140625,
        -3962.416259765625,
        1350.117431640625
      ],
      [
        -1477.2091064453125,
        -3957.316162109375,
        1349.9339599609375
      ],
      [
        -1479.0172119140625,
        -3962.416259765625,
        1350.117431640625
      ],
      [
        -1480.08349609375,
        -3964.6337890625,
        1353.642333984375
      ],
      [
        -1487.521484375,
        -3978.5654296875,
        1374.0
      ],
      [
        -1485.4451904296875,
        -3982.1611328125,
        1341.60693359375
      ],
      [
        -1492.6265869140625,
        -3969.7236328125,
        1391.5518798828125
      ],
      [
        -1495.1326904296875,
        -3965.383056640625,
        1405.5526123046875
      ],
      [
        -1487.521484375,
        -3978.5654296875,
        1374.0
      ],
      [
        -1492.6265869140625,
        -3969.7236328125,
        1391.5518798828125
      ],
      [
        -1495.1326904296875,
        -3965.383056640625,
        1405.5526123046875
      ],
      [
        -1485.6651611328125,
        -3981.7802734375,
        1335.75
      ],
      [
        -1485.4451904296875,
        -3982.1611328125,
        1341.60693359375
      ],
      [
        -1501.704833984375,
        -3954.0,
        1413.5855712890625
      ],
      [
        -1546.1025390625,
        -3961.165771484375,
        1412.4742431640625
      ],
      [
        -1544.3699951171875,
        -3958.1650390625,
        1414.591796875
      ],
      [
        -1546.1025390625,
        -3955.164306640625,
        1415.6005859375
      ],
      [
        -1549.5675048828125,
        -3955.164306640625,
        1414.4918212890625
      ],
      [
        -1551.2999267578125,
        -3958.1650390625,
        1412.374267578125
      ],
      [
        -1549.5673828125,
        -3961.165771484375,
        1411.365478515625
      ],
      [
        -1550.1214599609375,
        -3960.206298828125,
        1336.5
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1336.5
      ],
      [
        -1549.5673828125,
        -3955.164306640625,
        1336.5
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1336.5
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1339.0
      ],
      [
        -1550.1214599609375,
        -3960.206298828125,
        1339.0
      ],
      [
        -1551.300048828125,
        -3958.1650390625,
        1339.0
      ],
      [
        -1549.5673828125,
        -3955.164306640625,
        1339.0
      ],
      [
        -1550.1214599609375,
        -3960.206298828125,
        1336.5
      ],
      [
        -1550.1214599609375,
        -3960.206298828125,
        1339.0
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1339.0
      ],
      [
        -1548.9287109375,
        -3955.164306640625,
        1336.5
      ],
      [
        -1546.7747802734375,
        -3954.0,
        1415.9920654296875
      ],
      [
        -1548.895263671875,
        -3954.0,
        1415.3134765625
      ],
      [
        -1549.159912109375,
        -3954.45849609375,
        1339.0
      ],
      [
        -1549.159912109375,
        -3954.45849609375,
        1336.5
      ],
      [
        -1549.159912109375,
        -3954.45849609375,
        1336.5
      ],
      [
        -1549.159912109375,
        -3954.45849609375,
        1339.0
      ],
      [
        -1553.7047119140625,
        -3954.0,
        1413.7744140625
      ],
      [
        -1553.704833984375,
        -3954.0,
        1336.5
      ],
      [
        -1553.704833984375,
        -3954.0,
        1339.0
      ],
      [
        -1547.8349609375,
        -3964.166259765625,
        1410.3568115234375
      ],
      [
        -1576.4879150390625,
        -3954.0,
        1339.0
      ],
      [
        -1567.198486328125,
        -3977.966552734375,
        1339.0
      ],
      [
        -1567.12158203125,
        -3977.886474609375,
        1336.5
      ],
      [
        -1576.3798828125,
        -3954.0,
        1336.5
      ],
      [
        -1567.12158203125,
        -3977.886474609375,
        1336.5
      ],
      [
        -1567.198486328125,
        -3977.966552734375,
        1339.0
      ],
      [
        -1575.5848388671875,
        -3954.0,
        1339.0
      ],
      [
        -1567.1688232421875,
        -3977.935791015625,
        1339.0
      ],
      [
        -1567.0426025390625,
        -3977.80419921875,
        1336.5
      ],
      [
        -1575.4122314453125,
        -3954.0,
        1336.5
      ],
      [
        -1567.0426025390625,
        -3977.80419921875,
        1336.5
      ],
      [
        -1567.1688232421875,
        -3977.935791015625,
        1339.0
      ],
      [
        -1561.2833251953125,
        -3987.458740234375,
        1374.0
      ],
      [
        -1555.8154296875,
        -3977.988525390625,
        1400.402587890625
      ],
      [
        -1561.0931396484375,
        -3987.129150390625,
        1370.9176025390625
      ],
      [
        -1561.2833251953125,
        -3987.458740234375,
        1374.0
      ],
      [
        -1565.5697021484375,
        -3984.710693359375,
        1361.8050537109375
      ],
      [
        -1559.322998046875,
        -3984.0634765625,
        1342.23583984375
      ],
      [
        -1559.02001953125,
        -3983.538818359375,
        1335.75
      ],
      [
        -1559.322998046875,
        -3984.0634765625,
        1342.23583984375
      ],
      [
        -1555.7608642578125,
        -3977.89404296875,
        1400.67236328125
      ],
      [
        -1555.7384033203125,
        -3977.85498046875,
        1400.6968994140625
      ],
      [
        -1555.7384033203125,
        -3977.85498046875,
        1400.6968994140625
      ],
      [
        -1555.7635498046875,
        -3977.898681640625,
        1400.6529541015625
      ],
      [
        -1555.7608642578125,
        -3977.89404296875,
        1400.67236328125
      ],
      [
        -1555.7635498046875,
        -3977.898681640625,
        1400.6529541015625
      ],
      [
        -1541.965087890625,
        -3954.0,
        1417.5311279296875
      ],
      [
        -1518.828369140625,
        -3992.6494140625,
        1339.807373046875
      ],
      [
        -1524.8880615234375,
        -3994.3681640625,
        1339.4420166015625
      ],
      [
        -1518.828369140625,
        -3992.6494140625,
        1339.807373046875
      ],
      [
        -1515.966796875,
        -3991.667236328125,
        1336.58984375
      ],
      [
        -1528.086181640625,
        -3995.1044921875,
        1335.8592529296875
      ],
      [
        -1524.8880615234375,
        -3994.3681640625,
        1339.4420166015625
      ],
      [
        -1515.966796875,
        -3991.667236328125,
        1336.58984375
      ],
      [
        -1516.71630859375,
        -3991.83984375,
        1335.75
      ],
      [
        -1528.086181640625,
        -3995.1044921875,
        1335.8592529296875
      ],
      [
        -1527.989013671875,
        -3995.071044921875,
        1335.75
      ],
      [
        -1518.803955078125,
        -3992.56591796875,
        1339.8250732421875
      ],
      [
        -1515.8885498046875,
        -3991.400146484375,
        1336.6466064453125
      ],
      [
        -1518.803955078125,
        -3992.56591796875,
        1339.8250732421875
      ],
      [
        -1521.6080322265625,
        -3993.437744140625,
        1339.6397705078125
      ],
      [
        -1515.8885498046875,
        -3991.400146484375,
        1336.6466064453125
      ],
      [
        -1516.6885986328125,
        -3991.584228515625,
        1335.75
      ],
      [
        -1527.617431640625,
        -3993.50537109375,
        1336.1990966796875
      ],
      [
        -1525.3619384765625,
        -3994.477294921875,
        1338.9111328125
      ],
      [
        -1527.617431640625,
        -3993.50537109375,
        1336.1990966796875
      ],
      [
        -1527.30517578125,
        -3993.56103515625,
        1335.75
      ],
      [
        -1560.894287109375,
        -3986.784912109375,
        1375.878662109375
      ],
      [
        -1528.0,
        -3981.157958984375,
        1411.894775390625
      ],
      [
        -1533.9056396484375,
        -3984.472412109375,
        1408.0157470703125
      ],
      [
        -1528.0,
        -3981.157958984375,
        1411.894775390625
      ],
      [
        -1485.5106201171875,
        -3982.214111328125,
        1342.0260009765625
      ],
      [
        -1485.473388671875,
        -3982.1123046875,
        1342.047607421875
      ],
      [
        -1491.4862060546875,
        -3985.40185546875,
        1376.7049560546875
      ],
      [
        -1488.8564453125,
        -3976.25341796875,
        1378.5897216796875
      ],
      [
        -1494.5736083984375,
        -3966.3515625,
        1402.428955078125
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.677920401096344,
        0.7326462268829346,
        0.06044388189911842
      ],
      "plane_d": 1765.05712890625,
      "bbox_min": [
        -2014.1455078125,
        -4330.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1744.305419921875,
        -3985.0,
        1554.3597412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5439438223838806,
        0.824375569820404,
        0.156621053814888
      ],
      "plane_d": 2299.808837890625,
      "bbox_min": [
        -2014.1455078125,
        -4330.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1859.8328857421875,
        -3985.0,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2014.1455078125,
        -4300.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1859.8328857421875,
        -3985.0,
        1090.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32590940594673157,
        0.7248631119728088,
        0.6069238781929016
      ],
      "plane_d": 1811.6932373046875,
      "bbox_min": [
        -1980.5394287109375,
        -4300.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -1859.8328857421875,
        -4216.904296875,
        1090.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -956.0,
      "bbox_min": [
        -1631.0,
        -3665.800048828125,
        953.5
      ],
      "bbox_max": [
        -1508.5,
        -3605.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -953.5,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3837.180419921875,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3300.53125,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        0.9847835898399353,
        -0.0
      ],
      "plane_d": 3872.632568359375,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17380055785179138,
        0.9847808480262756,
        -7.279147394001484e-05
      ],
      "plane_d": 3336.02001953125,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0539231039583683,
        -0.3055642545223236,
        0.9506434202194214
      ],
      "plane_d": -2098.486572265625,
      "bbox_min": [
        -1578.0,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058494724333286285,
        -0.31568625569343567,
        0.9470588564872742
      ],
      "plane_d": -2138.80419921875,
      "bbox_min": [
        -1544.4615478515625,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1525.111083984375,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        -0.31568628549575806,
        0.9470588564872742
      ],
      "plane_d": -1958.1724853515625,
      "bbox_min": [
        -1544.4615478515625,
        -3628.58544921875,
        953.5
      ],
      "bbox_max": [
        -1544.0,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        -0.31568628549575806,
        0.9470588564872742
      ],
      "plane_d": -1958.1724853515625,
      "bbox_min": [
        -1562.888916015625,
        -3632.0,
        953.5
      ],
      "bbox_max": [
        -1544.0,
        -3624.0,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        0.31568625569343567,
        0.9470588564872742
      ],
      "plane_d": 341.2863464355469,
      "bbox_min": [
        -1544.4610595703125,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1544.0,
        -3655.41455078125,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.058494724333286285,
        0.31568625569343567,
        0.9470588564872742
      ],
      "plane_d": 341.2863464355469,
      "bbox_min": [
        -1573.5460205078125,
        -3660.0,
        953.5
      ],
      "bbox_max": [
        -1544.0,
        -3650.840576171875,
        955.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7243033647537231,
        -0.6686188578605652,
        -0.1683250516653061
      ],
      "plane_d": -1143.529296875,
      "bbox_min": [
        -1573.5460205078125,
        -3652.906494140625,
        953.7122192382812
      ],
      "bbox_max": [
        -1570.6939697265625,
        -3650.840576171875,
        954.2798461914062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9786690473556519,
        0.12109607458114624,
        -0.1659596860408783
      ],
      "plane_d": 2137.738525390625,
      "bbox_min": [
        -1573.5460205078125,
        -3651.942626953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1570.6939697265625,
        -3650.840576171875,
        953.92431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5686390399932861,
        0.8049494028091431,
        -0.1694285124540329
      ],
      "plane_d": 2205.744140625,
      "bbox_min": [
        -1573.5460205078125,
        -3651.070068359375,
        953.7122192382812
      ],
      "bbox_max": [
        -1573.2015380859375,
        -3650.840576171875,
        953.8038330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17275424301624298,
        0.1087711974978447,
        0.9789407253265381
      ],
      "plane_d": -799.6026000976562,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17275424301624298,
        -0.1087711974978447,
        0.9789407253265381
      ],
      "plane_d": -1591.89208984375,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17275424301624298,
        -0.1087711974978447,
        0.9789407253265381
      ],
      "plane_d": -1058.4268798828125,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8462328910827637,
        0.532813310623169,
        0.0
      ],
      "plane_d": 662.6944580078125,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8462328910827637,
        -0.532813310623169,
        0.0
      ],
      "plane_d": -3218.31787109375,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462328910827637,
        -0.532813310623169,
        0.0
      ],
      "plane_d": -605.150634765625,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        956.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.16475722193717957,
        0.10892237722873688,
        0.9803014993667603
      ],
      "plane_d": -788.2060546875,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16475722193717957,
        -0.10892237722873688,
        0.9803014993667603
      ],
      "plane_d": -1072.826416015625,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16475722193717957,
        -0.10892237722873688,
        0.9803014993667603
      ],
      "plane_d": -1581.5966796875,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462295532226562,
        0.5328184366226196,
        -7.234164058900205e-06
      ],
      "plane_d": 3275.8818359375,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1557.553955078125,
        -3633.07861328125,
        956.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5686390399932861,
        0.8049494028091431,
        -0.1694285124540329
      ],
      "plane_d": 2205.744140625,
      "bbox_min": [
        -1574.0137939453125,
        -3653.21923828125,
        953.7122192382812
      ],
      "bbox_max": [
        -1571.1201171875,
        -3650.1318359375,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9457221031188965,
        0.32497653365135193
      ],
      "plane_d": 3125.94873046875,
      "bbox_min": [
        -1561.520263671875,
        -3636.5126953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1557.553955078125,
        -3633.07861328125,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8219942450523376,
        0.47467273473739624,
        0.3146604895591736
      ],
      "plane_d": 141.68212890625,
      "bbox_min": [
        -1561.520263671875,
        -3636.5126953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1557.553955078125,
        -3633.07861328125,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8226437568664551,
        0.4750477969646454,
        0.312389075756073
      ],
      "plane_d": 2710.08447265625,
      "bbox_min": [
        -1560.5286865234375,
        -3636.5126953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1557.553955078125,
        -3633.07861328125,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8290457129478455,
        -0.4787446856498718,
        0.28894057869911194
      ],
      "plane_d": -724.4217529296875,
      "bbox_min": [
        -1560.5286865234375,
        -3636.5126953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1557.553955078125,
        -3634.795654296875,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9605445265769958,
        0.27812641859054565
      ],
      "plane_d": -3758.284912109375,
      "bbox_min": [
        -1560.5286865234375,
        -3636.5126953125,
        953.7122192382812
      ],
      "bbox_max": [
        -1558.5455322265625,
        -3635.850341796875,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17275424301624298,
        0.1087711974978447,
        0.9789407253265381
      ],
      "plane_d": -266.1374816894531,
      "bbox_min": [
        -1578.0,
        -3655.5,
        953.5
      ],
      "bbox_max": [
        -1562.888916015625,
        -3642.0,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29027000069618225,
        0.9435012340545654,
        -0.1598399430513382
      ],
      "plane_d": 4052.795166015625,
      "bbox_min": [
        -1572.7880859375,
        -3652.77734375,
        953.7122192382812
      ],
      "bbox_max": [
        -1570.5400390625,
        -3649.98291015625,
        955.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7243033647537231,
        -0.6686188578605652,
        -0.1683250516653061
      ],
      "plane_d": -1143.529296875,
      "bbox_min": [
        -1572.7880859375,
        -3652.77734375,
        953.7122192382812
      ],
      "bbox_max": [
        -1570.5400390625,
        -3649.98291015625,
        955.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9786690473556519,
        0.12109607458114624,
        -0.1659596860408783
      ],
      "plane_d": 2137.738525390625,
      "bbox_min": [
        -1572.8797607421875,
        -3652.9267578125,
        954.6654052734375
      ],
      "bbox_max": [
        -1570.32666015625,
        -3649.78076171875,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29027000069618225,
        0.9435012340545654,
        -0.1598399430513382
      ],
      "plane_d": 4052.795166015625,
      "bbox_min": [
        -1572.8797607421875,
        -3652.9267578125,
        954.6654052734375
      ],
      "bbox_max": [
        -1570.32666015625,
        -3649.78076171875,
        956.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7243033647537231,
        -0.6686188578605652,
        -0.1683250516653061
      ],
      "plane_d": -1143.529296875,
      "bbox_min": [
        -1572.8797607421875,
        -3652.9267578125,
        954.7940063476562
      ],
      "bbox_max": [
        -1570.32666015625,
        -3649.78076171875,
        956.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5686390399932861,
        0.8049494028091431,
        -0.1694285124540329
      ],
      "plane_d": 2205.744140625,
      "bbox_min": [
        -1572.8797607421875,
        -3650.277587890625,
        954.8878173828125
      ],
      "bbox_max": [
        -1572.337890625,
        -3649.78076171875,
        956.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3837.180419921875,
      "bbox_min": [
        -1631.0,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1510.0,
        -3605.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70707106590271,
        -0.7071425318717957,
        -0.0
      ],
      "plane_d": -3697.8251953125,
      "bbox_min": [
        -1631.0,
        -3628.6357421875,
        970.6500244140625
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3605.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.32097047567367554,
        -0.9470891952514648
      ],
      "plane_d": -217.3135986328125,
      "bbox_min": [
        -1550.97998046875,
        -3628.6357421875,
        982.718505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3621.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.03649793565273285,
        0.9993336796760559
      ],
      "plane_d": -1141.46240234375,
      "bbox_min": [
        -1531.8800048828125,
        -3628.6357421875,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9086763858795166,
        -0.21654069423675537,
        -0.356955885887146
      ],
      "plane_d": 953.3348388671875,
      "bbox_min": [
        -1531.8800048828125,
        -3628.6357421875,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9062353372573853,
        -0.2280433624982834,
        -0.3559969663619995
      ],
      "plane_d": -1855.4609375,
      "bbox_min": [
        -1531.8800048828125,
        -3628.62060546875,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4302462041378021,
        -0.078095443546772,
        0.8993271589279175
      ],
      "plane_d": -537.0601806640625,
      "bbox_min": [
        -1531.8800048828125,
        -3628.62060546875,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5103150010108948,
        -0.10362716019153595,
        0.8537212014198303
      ],
      "plane_d": -462.158447265625,
      "bbox_min": [
        -1531.8800048828125,
        -3628.62060546875,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430046409368515,
        -0.0837937518954277,
        0.8989096283912659
      ],
      "plane_d": -1868.486328125,
      "bbox_min": [
        -1531.8800048828125,
        -3626.9140625,
        1008.070068359375
      ],
      "bbox_max": [
        -1527.4869384765625,
        -3622.5,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5099438428878784,
        -0.11035174131393433,
        0.8531002402305603
      ],
      "plane_d": -2040.90673828125,
      "bbox_min": [
        -1531.8800048828125,
        -3626.34423828125,
        1008.070068359375
      ],
      "bbox_max": [
        -1530.7159423828125,
        -3622.5,
        1008.2686157226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8675738573074341,
        -0.20361202955245972,
        -0.4537154734134674
      ],
      "plane_d": -1609.2266845703125,
      "bbox_min": [
        -1531.8800048828125,
        -3626.34423828125,
        1007.5694580078125
      ],
      "bbox_max": [
        -1530.7159423828125,
        -3622.5,
        1008.1349487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5099438428878784,
        -0.11035174131393433,
        0.8531002402305603
      ],
      "plane_d": -2040.90673828125,
      "bbox_min": [
        -1531.8800048828125,
        -3626.30322265625,
        1008.070068359375
      ],
      "bbox_max": [
        -1530.948486328125,
        -3622.5,
        1008.1349487304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8695663213729858,
        -0.19248422980308533,
        -0.4547574520111084
      ],
      "plane_d": 1079.763671875,
      "bbox_min": [
        -1518.1544189453125,
        -3628.6357421875,
        1007.2808227539062
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1008.174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5103150010108948,
        -0.10362716019153595,
        0.8537212014198303
      ],
      "plane_d": -462.158447265625,
      "bbox_min": [
        -1517.817626953125,
        -3628.6357421875,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3622.5,
        1008.174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.1923827975988388,
        -0.9813199043273926
      ],
      "plane_d": 267.64691162109375,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        989.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.036495037376880646,
        0.9993337988853455
      ],
      "plane_d": -1120.92919921875,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        989.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6397563219070435,
        -0.21210886538028717,
        -0.7387297749519348
      ],
      "plane_d": 942.6328125,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6516278982162476,
        -0.09601175785064697,
        0.7524380087852478
      ],
      "plane_d": -89.0885009765625,
      "bbox_min": [
        -1550.97998046875,
        -3625.337158203125,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3621.5,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6510604023933411,
        -0.10460984706878662,
        0.7517826557159424
      ],
      "plane_d": -2129.9365234375,
      "bbox_min": [
        -1550.97998046875,
        -3623.492919921875,
        982.718505859375
      ],
      "bbox_max": [
        -1546.873779296875,
        -3621.5,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1550.97998046875,
        -3623.492919921875,
        982.718505859375
      ],
      "bbox_max": [
        -1546.873779296875,
        -3621.5,
        986.1759033203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3605.0,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70707106590271,
        -0.7071425318717957,
        0.0
      ],
      "plane_d": -1397.722900390625,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1622.0,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1631.0,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.67857426404953,
        -0.6786142587661743,
        0.2811041474342346
      ],
      "plane_d": -3823.75048828125,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678572416305542,
        -0.678619384765625,
        0.2810964286327362
      ],
      "plane_d": -1616.3623046875,
      "bbox_min": [
        -1631.0,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826870620250702,
        0.9238780736923218
      ],
      "plane_d": -2278.189697265625,
      "bbox_min": [
        -1629.880859375,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3607.928955078125,
        973.1360473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785794496536255,
        -0.281093031167984,
        0.6786137819290161
      ],
      "plane_d": -2775.68310546875,
      "bbox_min": [
        -1629.880859375,
        -3610.2353515625,
        970.6500244140625
      ],
      "bbox_max": [
        -1622.0,
        -3607.928955078125,
        973.1360473632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785792708396912,
        -0.2810940444469452,
        0.678613543510437
      ],
      "plane_d": -568.2677001953125,
      "bbox_min": [
        -1629.880859375,
        -3609.072998046875,
        970.9550170898438
      ],
      "bbox_max": [
        -1628.585693359375,
        -3607.928955078125,
        972.3447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.9847835898399353,
        0.0
      ],
      "plane_d": -3300.53125,
      "bbox_min": [
        -1631.0,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1510.0,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1631.0,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1622.0,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7781456112861633,
        0.6147946715354919,
        -0.12851794064044952
      ],
      "plane_d": 3567.427734375,
      "bbox_min": [
        -1566.0,
        -3627.8662109375,
        983.1091918945312
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3622.827880859375,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1000.9999389648438,
      "bbox_min": [
        -1566.0,
        -3627.8662109375,
        985.0
      ],
      "bbox_max": [
        -1554.4989013671875,
        -3623.636474609375,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1561.64501953125,
        -3626.926513671875,
        985.0
      ],
      "bbox_max": [
        -1556.2061767578125,
        -3624.22509765625,
        989.2205810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 985.0,
      "bbox_min": [
        -1561.64501953125,
        -3626.926513671875,
        985.0
      ],
      "bbox_max": [
        -1557.35498046875,
        -3624.22509765625,
        985.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6510604023933411,
        -0.10460984706878662,
        0.7517826557159424
      ],
      "plane_d": -2129.9365234375,
      "bbox_min": [
        -1550.6424560546875,
        -3625.07177734375,
        983.1091918945312
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3622.827880859375,
        989.3487548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1550.6424560546875,
        -3625.07177734375,
        983.1091918945312
      ],
      "bbox_max": [
        -1544.0001220703125,
        -3622.827880859375,
        989.3487548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3637.0,
      "bbox_min": [
        -1622.0,
        -3637.764892578125,
        969.321044921875
      ],
      "bbox_max": [
        -1617.66650390625,
        -3635.0,
        975.678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28109776973724365,
        -0.6785942316055298,
        -0.678597092628479
      ],
      "plane_d": -2262.413818359375,
      "bbox_min": [
        -1622.0,
        -3637.0,
        972.9144287109375
      ],
      "bbox_max": [
        -1620.0,
        -3636.414306640625,
        974.9142456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810555100440979,
        -0.6786219477653503,
        0.6785867214202881
      ],
      "plane_d": -3582.307373046875,
      "bbox_min": [
        -1621.4141845703125,
        -3637.0,
        970.4290161132812
      ],
      "bbox_max": [
        -1620.0,
        -3636.414306640625,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785833835601807,
        -0.28107383847236633,
        0.6786177158355713
      ],
      "plane_d": -2781.2451171875,
      "bbox_min": [
        -1622.0,
        -3637.0,
        970.0857543945312
      ],
      "bbox_max": [
        -1621.17138671875,
        -3635.0,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810555100440979,
        -0.6786219477653503,
        0.6785867214202881
      ],
      "plane_d": -3582.307373046875,
      "bbox_min": [
        -1622.0,
        -3637.0,
        970.0857543945312
      ],
      "bbox_max": [
        -1621.17138671875,
        -3636.414306640625,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28109776973724365,
        -0.6785942316055298,
        -0.678597092628479
      ],
      "plane_d": -2262.413818359375,
      "bbox_min": [
        -1622.0,
        -3637.764892578125,
        969.321044921875
      ],
      "bbox_max": [
        -1617.66650390625,
        -3637.0,
        975.678955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7070888876914978,
        -0.707124650478363
      ],
      "plane_d": -1882.8822021484375,
      "bbox_min": [
        -1620.0,
        -3637.411865234375,
        974.0858154296875
      ],
      "bbox_max": [
        -1617.66650390625,
        -3637.0,
        974.4976196289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810555100440979,
        -0.6786219477653503,
        0.6785867214202881
      ],
      "plane_d": -3582.307373046875,
      "bbox_min": [
        -1622.0,
        -3637.764892578125,
        969.321044921875
      ],
      "bbox_max": [
        -1617.66650390625,
        -3637.0,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7070888876914978,
        0.707124650478363
      ],
      "plane_d": -3258.23974609375,
      "bbox_min": [
        -1620.0,
        -3637.411865234375,
        970.5023803710938
      ],
      "bbox_max": [
        -1617.66650390625,
        -3637.0,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3613.0,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -968.5,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        978.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070888876914978,
        0.0,
        0.707124650478363
      ],
      "plane_d": -1833.45556640625,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785833835601807,
        -0.28107383847236633,
        0.6786177158355713
      ],
      "plane_d": -2781.2451171875,
      "bbox_min": [
        -1624.414306640625,
        -3637.973388671875,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3635.0,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 976.5,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        978.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6785756945610046,
        0.6786104440689087,
        -0.2811099886894226
      ],
      "plane_d": 3832.00439453125,
      "bbox_min": [
        -1629.4140625,
        -3613.585693359375,
        976.5001220703125
      ],
      "bbox_max": [
        -1627.4141845703125,
        -3613.0,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785644292831421,
        0.6786410808563232,
        -0.281063437461853
      ],
      "plane_d": 1624.680908203125,
      "bbox_min": [
        -1624.414306640625,
        -3613.585693359375,
        977.0858154296875
      ],
      "bbox_max": [
        -1623.9290771484375,
        -3613.0,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785807609558105,
        0.2810869514942169,
        -0.6786150336265564
      ],
      "plane_d": 576.5006103515625,
      "bbox_min": [
        -1624.414306640625,
        -3615.0,
        976.5
      ],
      "bbox_max": [
        -1623.5859375,
        -3613.0,
        977.3285522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785644292831421,
        0.6786410808563232,
        -0.281063437461853
      ],
      "plane_d": 1624.680908203125,
      "bbox_min": [
        -1624.414306640625,
        -3613.585693359375,
        976.5001220703125
      ],
      "bbox_max": [
        -1623.5859375,
        -3613.0,
        977.3285522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070888876914978,
        0.0,
        -0.707124650478363
      ],
      "plane_d": -458.09814453125,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785796880722046,
        -0.28109174966812134,
        -0.6786140203475952
      ],
      "plane_d": -1461.396484375,
      "bbox_min": [
        -1624.414306640625,
        -3637.973388671875,
        974.0858154296875
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28109776973724365,
        -0.6785942316055298,
        -0.678597092628479
      ],
      "plane_d": -2262.413818359375,
      "bbox_min": [
        -1622.9287109375,
        -3637.9287109375,
        974.9142456054688
      ],
      "bbox_max": [
        -1622.0,
        -3637.0,
        976.2275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070888876914978,
        0.0,
        -0.707124650478363
      ],
      "plane_d": 1842.06201171875,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785795092582703,
        0.28109264373779297,
        -0.6786139011383057
      ],
      "plane_d": 2783.94140625,
      "bbox_min": [
        -1631.0,
        -3615.0,
        974.0858154296875
      ],
      "bbox_max": [
        -1628.585693359375,
        -3613.0,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238788485527039,
        0.38268518447875977,
        -0.0
      ],
      "plane_d": 2897.9072265625,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785838007926941,
        0.28107184171676636,
        0.6786181330680847
      ],
      "plane_d": 1469.58642578125,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785822510719299,
        0.2810794711112976,
        -0.6786165833473206
      ],
      "plane_d": 2789.5224609375,
      "bbox_min": [
        -1631.0,
        -3639.056640625,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826870620250702,
        0.9238780736923218
      ],
      "plane_d": -2278.189697265625,
      "bbox_min": [
        -1631.0,
        -3615.0,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        971.7426147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785792708396912,
        -0.2810940444469452,
        0.678613543510437
      ],
      "plane_d": -568.2677001953125,
      "bbox_min": [
        -1631.0,
        -3615.0,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        971.7426147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785794496536255,
        -0.281093031167984,
        0.6786137819290161
      ],
      "plane_d": -2775.68310546875,
      "bbox_min": [
        -1624.414306640625,
        -3615.0,
        968.5
      ],
      "bbox_max": [
        -1622.0,
        -3613.0,
        971.7426147460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1406.142578125,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785794496536255,
        -0.281093031167984,
        0.6786137819290161
      ],
      "plane_d": -2775.68310546875,
      "bbox_min": [
        -1624.414306640625,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3610.585693359375,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785644292831421,
        0.6786410808563232,
        -0.281063437461853
      ],
      "plane_d": 1624.680908203125,
      "bbox_min": [
        -1624.414306640625,
        -3613.0,
        974.9142456054688
      ],
      "bbox_max": [
        -1622.0,
        -3610.585693359375,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785807609558105,
        0.2810869514942169,
        -0.6786150336265564
      ],
      "plane_d": 576.5006103515625,
      "bbox_min": [
        -1623.5859375,
        -3613.0,
        974.9142456054688
      ],
      "bbox_max": [
        -1622.0,
        -3611.878662109375,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3706.36083984375,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785792708396912,
        -0.2810940444469452,
        0.678613543510437
      ],
      "plane_d": -568.2677001953125,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1628.585693359375,
        -3610.58544921875,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785756945610046,
        0.6786104440689087,
        -0.2811099886894226
      ],
      "plane_d": 3832.00439453125,
      "bbox_min": [
        -1631.0,
        -3613.0,
        974.9142456054688
      ],
      "bbox_max": [
        -1628.585693359375,
        -3610.585693359375,
        978.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785795092582703,
        0.28109264373779297,
        -0.6786139011383057
      ],
      "plane_d": 2783.94140625,
      "bbox_min": [
        -1631.0,
        -3613.0,
        974.9142456054688
      ],
      "bbox_max": [
        -1629.4140625,
        -3611.878662109375,
        976.5001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826870620250702,
        0.9238780736923218
      ],
      "plane_d": -2278.189697265625,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        975.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785792708396912,
        -0.2810940444469452,
        0.678613543510437
      ],
      "plane_d": -568.2677001953125,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        975.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785794496536255,
        -0.281093031167984,
        0.6786137819290161
      ],
      "plane_d": -2775.68310546875,
      "bbox_min": [
        -1631.0,
        -3613.0,
        969.3284301757812
      ],
      "bbox_max": [
        -1622.0,
        -3608.647216796875,
        975.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.678572416305542,
        -0.678619384765625,
        0.2810964286327362
      ],
      "plane_d": -1616.3623046875,
      "bbox_min": [
        -1631.0,
        -3609.635986328125,
        972.3447265625
      ],
      "bbox_max": [
        -1629.880859375,
        -3608.647216796875,
        975.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8462328910827637,
        -0.532813310623169,
        0.0
      ],
      "plane_d": -3218.31787109375,
      "bbox_min": [
        -1629.3197021484375,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1510.0,
        -3624.0,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8695663213729858,
        -0.19248422980308533,
        -0.4547574520111084
      ],
      "plane_d": 1079.763671875,
      "bbox_min": [
        -1518.5003662109375,
        -3629.442626953125,
        1006.363037109375
      ],
      "bbox_max": [
        -1517.7314453125,
        -3628.5,
        1008.5538940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5103150010108948,
        -0.10362716019153595,
        0.8537212014198303
      ],
      "plane_d": -462.158447265625,
      "bbox_min": [
        -1518.5003662109375,
        -3629.442626953125,
        1008.1211547851562
      ],
      "bbox_max": [
        -1517.7314453125,
        -3628.5,
        1008.5538940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4302462041378021,
        -0.078095443546772,
        0.8993271589279175
      ],
      "plane_d": -537.0601806640625,
      "bbox_min": [
        -1518.5003662109375,
        -3628.895751953125,
        1008.383056640625
      ],
      "bbox_max": [
        -1518.1544189453125,
        -3628.5,
        1008.5538940429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5109584331512451,
        0.0907880887389183,
        0.8547976016998291
      ],
      "plane_d": 246.08685302734375,
      "bbox_min": [
        -1524.985107421875,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1516.7227783203125,
        -3655.718017578125,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9137110114097595,
        0.19052287936210632,
        -0.35893362760543823
      ],
      "plane_d": 2446.124267578125,
      "bbox_min": [
        -1524.985107421875,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1516.7227783203125,
        -3655.718017578125,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43055403232574463,
        0.06838241219520569,
        0.8999706506729126
      ],
      "plane_d": -3.548828125,
      "bbox_min": [
        -1524.985107421875,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1516.83056640625,
        -3656.56396484375,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.031940679997205734,
        0.9994897246360779
      ],
      "plane_d": -892.2637329101562,
      "bbox_min": [
        -1524.985107421875,
        -3665.800048828125,
        1009.6653442382812
      ],
      "bbox_max": [
        -1520.426513671875,
        -3659.483154296875,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8733665943145752,
        0.16915975511074066,
        -0.456744909286499
      ],
      "plane_d": 2405.197265625,
      "bbox_min": [
        -1519.1697998046875,
        -3665.800048828125,
        1006.823974609375
      ],
      "bbox_max": [
        -1516.7227783203125,
        -3655.718017578125,
        1008.1559448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462348580360413,
        -0.5328100323677063,
        0.0
      ],
      "plane_d": -605.135498046875,
      "bbox_min": [
        -1629.3197021484375,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1015.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3637.0,
      "bbox_min": [
        -1629.3197021484375,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1574.2222900390625,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3636.0,
      "bbox_min": [
        -1591.0,
        -3637.0,
        969.5
      ],
      "bbox_max": [
        -1574.2222900390625,
        -3636.0,
        975.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3257.28759765625,
      "bbox_min": [
        -1591.0,
        -3637.0,
        969.5
      ],
      "bbox_max": [
        -1574.2222900390625,
        -3636.0,
        975.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1881.9649658203125,
      "bbox_min": [
        -1591.0,
        -3637.0,
        974.5
      ],
      "bbox_max": [
        -1574.2222900390625,
        -3636.0,
        975.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -968.5,
      "bbox_min": [
        -1629.3197021484375,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1574.8519287109375,
        -3637.0,
        977.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3257.28759765625,
      "bbox_min": [
        -1591.0,
        -3645.0,
        967.5
      ],
      "bbox_max": [
        -1575.4815673828125,
        -3638.0,
        968.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1892.5714111328125,
      "bbox_min": [
        -1591.0,
        -3645.0,
        967.5
      ],
      "bbox_max": [
        -1579.2593994140625,
        -3644.0,
        968.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2810555100440979,
        -0.6786219477653503,
        0.6785867214202881
      ],
      "plane_d": -3582.307373046875,
      "bbox_min": [
        -1627.6739501953125,
        -3639.414306640625,
        968.5
      ],
      "bbox_max": [
        -1620.0,
        -3637.411865234375,
        970.5023803710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785833835601807,
        -0.28107383847236633,
        0.6786177158355713
      ],
      "plane_d": -2781.2451171875,
      "bbox_min": [
        -1623.171630859375,
        -3638.121337890625,
        968.5
      ],
      "bbox_max": [
        -1622.9287109375,
        -3637.9287109375,
        968.7724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785838007926941,
        0.28107184171676636,
        0.6786181330680847
      ],
      "plane_d": 1469.58642578125,
      "bbox_min": [
        -1627.6739501953125,
        -3639.414306640625,
        968.5
      ],
      "bbox_max": [
        -1626.75732421875,
        -3638.659423828125,
        969.148193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785833835601807,
        -0.28107383847236633,
        0.6786177158355713
      ],
      "plane_d": -2781.2451171875,
      "bbox_min": [
        -1623.1826171875,
        -3638.0,
        968.5
      ],
      "bbox_max": [
        -1623.1529541015625,
        -3637.96826171875,
        968.5317993164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 976.5,
      "bbox_min": [
        -1629.3197021484375,
        -3647.0,
        968.5
      ],
      "bbox_max": [
        -1574.8519287109375,
        -3637.0,
        977.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1881.9649658203125,
      "bbox_min": [
        -1591.0,
        -3645.0,
        976.5
      ],
      "bbox_max": [
        -1575.4815673828125,
        -3638.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3267.89404296875,
      "bbox_min": [
        -1591.0,
        -3645.0,
        976.5
      ],
      "bbox_max": [
        -1579.2593994140625,
        -3644.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28109776973724365,
        -0.6785942316055298,
        -0.678597092628479
      ],
      "plane_d": -2262.413818359375,
      "bbox_min": [
        -1627.6739501953125,
        -3639.414306640625,
        974.4976196289062
      ],
      "bbox_max": [
        -1620.0,
        -3637.411865234375,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6785796880722046,
        -0.28109174966812134,
        -0.6786140203475952
      ],
      "plane_d": -1461.396484375,
      "bbox_min": [
        -1623.1715087890625,
        -3638.121337890625,
        976.2275390625
      ],
      "bbox_max": [
        -1622.9287109375,
        -3637.9287109375,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785822510719299,
        0.2810794711112976,
        -0.6786165833473206
      ],
      "plane_d": 2789.5224609375,
      "bbox_min": [
        -1627.6739501953125,
        -3639.414306640625,
        975.8518676757812
      ],
      "bbox_max": [
        -1626.75732421875,
        -3638.659423828125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3267.89404296875,
      "bbox_min": [
        -1591.0,
        -3647.0,
        973.0858764648438
      ],
      "bbox_max": [
        -1579.8890380859375,
        -3645.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1892.5714111328125,
      "bbox_min": [
        -1591.0,
        -3647.0,
        968.5
      ],
      "bbox_max": [
        -1579.8890380859375,
        -3645.0,
        971.914306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.0,
      "bbox_min": [
        -1591.0,
        -3647.0,
        971.914306640625
      ],
      "bbox_max": [
        -1581.148193359375,
        -3647.0,
        973.0858764648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269245624542236,
        0.9238758683204651,
        -0.0
      ],
      "plane_d": 3988.413330078125,
      "bbox_min": [
        -1629.3197021484375,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1620.0,
        -3638.76611328125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2810807526111603,
        0.6786053776741028,
        0.6785929203033447
      ],
      "plane_d": 2270.6904296875,
      "bbox_min": [
        -1629.3197021484375,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1620.0,
        -3638.76611328125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28109219670295715,
        0.6785979270935059,
        -0.6785957217216492
      ],
      "plane_d": 3590.5478515625,
      "bbox_min": [
        -1629.3197021484375,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1620.0,
        -3638.76611328125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238788485527039,
        0.38268518447875977,
        -0.0
      ],
      "plane_d": 2897.9072265625,
      "bbox_min": [
        -1629.3197021484375,
        -3642.778076171875,
        968.5
      ],
      "bbox_max": [
        -1626.071044921875,
        -3638.76611328125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785822510719299,
        0.2810794711112976,
        -0.6786165833473206
      ],
      "plane_d": 2789.5224609375,
      "bbox_min": [
        -1629.3197021484375,
        -3642.778076171875,
        968.5
      ],
      "bbox_max": [
        -1626.071044921875,
        -3638.76611328125,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6785838007926941,
        0.28107184171676636,
        0.6786181330680847
      ],
      "plane_d": 1469.58642578125,
      "bbox_min": [
        -1629.3197021484375,
        -3642.778076171875,
        968.5
      ],
      "bbox_max": [
        -1626.071044921875,
        -3638.76611328125,
        970.9141845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8462342619895935,
        0.5328109860420227,
        0.0
      ],
      "plane_d": 3275.855224609375,
      "bbox_min": [
        -1581.148193359375,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1015.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5686390399932861,
        0.8049494028091431,
        -0.1694285124540329
      ],
      "plane_d": 2205.744140625,
      "bbox_min": [
        -1581.148193359375,
        -3654.531005859375,
        956.0
      ],
      "bbox_max": [
        -1570.4405517578125,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7242797613143921,
        -0.6686462759971619,
        -0.168317973613739
      ],
      "plane_d": -1143.673583984375,
      "bbox_min": [
        -1575.550048828125,
        -3654.531005859375,
        956.0
      ],
      "bbox_max": [
        -1570.4405517578125,
        -3649.0810546875,
        963.2122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -963.2122192382812,
      "bbox_min": [
        -1575.550048828125,
        -3654.531005859375,
        963.2122192382812
      ],
      "bbox_max": [
        -1570.4405517578125,
        -3649.0810546875,
        963.2122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.0,
      "bbox_min": [
        -1581.148193359375,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1574.851806640625,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -1892.5714111328125,
      "bbox_min": [
        -1581.148193359375,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1574.851806640625,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3267.89404296875,
      "bbox_min": [
        -1581.148193359375,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1574.851806640625,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3646.0,
      "bbox_min": [
        -1580.5184326171875,
        -3646.0,
        967.5
      ],
      "bbox_max": [
        -1575.4814453125,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 967.5,
      "bbox_min": [
        -1580.5184326171875,
        -3646.0,
        967.5
      ],
      "bbox_max": [
        -1575.4814453125,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -977.5,
      "bbox_min": [
        -1580.5184326171875,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1575.4814453125,
        -3641.999755859375,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -968.5,
      "bbox_min": [
        -1578.9984130859375,
        -3643.585693359375,
        968.5
      ],
      "bbox_max": [
        -1577.0015869140625,
        -3642.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 976.5,
      "bbox_min": [
        -1578.9984130859375,
        -3643.585693359375,
        976.5
      ],
      "bbox_max": [
        -1577.0015869140625,
        -3642.0,
        976.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17377983033657074,
        0.9847844839096069,
        -0.0
      ],
      "plane_d": 3872.626953125,
      "bbox_min": [
        -1578.0,
        -3665.800048828125,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1015.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.2659290134906769,
        0.0,
        -0.963992714881897
      ],
      "plane_d": 1350.732177734375,
      "bbox_min": [
        -1555.796142578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1523.599609375,
        -3657.918212890625,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.038317177444696426,
        0.9992656111717224
      ],
      "plane_d": -848.3582153320312,
      "bbox_min": [
        -1550.97998046875,
        -3665.800048828125,
        982.718505859375
      ],
      "bbox_max": [
        -1523.599609375,
        -3658.935791015625,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.20161986351013184,
        -0.9794638752937317
      ],
      "plane_d": 1700.969970703125,
      "bbox_min": [
        -1550.97998046875,
        -3662.5,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3658.935791015625,
        989.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369971632957458,
        0.2306726723909378,
        -0.7355437874794006
      ],
      "plane_d": 582.16650390625,
      "bbox_min": [
        -1550.97998046875,
        -3662.5,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3658.935791015625,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6506955623626709,
        0.10977879911661148,
        0.7513613700866699
      ],
      "plane_d": -1348.0458984375,
      "bbox_min": [
        -1550.97998046875,
        -3662.5,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3658.935791015625,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6513202786445618,
        0.10076474398374557,
        0.7520827054977417
      ],
      "plane_d": 627.5469360351562,
      "bbox_min": [
        -1539.5595703125,
        -3662.5,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3660.783203125,
        989.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.638286292552948,
        0.22220253944396973,
        -0.7370322942733765
      ],
      "plane_d": 2520.6708984375,
      "bbox_min": [
        -1539.5595703125,
        -3662.5,
        982.718505859375
      ],
      "bbox_max": [
        -1535.5,
        -3660.783203125,
        986.15771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9118090271949768,
        0.2007651925086975,
        -0.3581864833831787
      ],
      "plane_d": -299.3985595703125,
      "bbox_min": [
        -1531.537353515625,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1523.599609375,
        -3662.322509765625,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4304007589817047,
        0.07337993383407593,
        0.8996502161026001
      ],
      "plane_d": -1297.11181640625,
      "bbox_min": [
        -1531.515625,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1523.599609375,
        -3662.333740234375,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2843024730682373,
        -0.9587345719337463
      ],
      "plane_d": 1999.7059326171875,
      "bbox_min": [
        -1531.515625,
        -3665.800048828125,
        998.7225952148438
      ],
      "bbox_max": [
        -1523.599609375,
        -3662.333740234375,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.031940679997205734,
        0.9994897246360779
      ],
      "plane_d": -892.2637329101562,
      "bbox_min": [
        -1531.515625,
        -3665.800048828125,
        1008.095458984375
      ],
      "bbox_max": [
        -1523.599609375,
        -3662.333740234375,
        1009.8671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1531.515625,
        -3665.800048828125,
        1008.095458984375
      ],
      "bbox_max": [
        -1530.52294921875,
        -3662.333740234375,
        1008.301513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.871819794178009,
        0.17903247475624084,
        -0.4559359848499298
      ],
      "plane_d": -219.3062744140625,
      "bbox_min": [
        -1531.537353515625,
        -3665.800048828125,
        1007.4864501953125
      ],
      "bbox_max": [
        -1530.52294921875,
        -3662.322509765625,
        1008.147216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1531.537353515625,
        -3665.800048828125,
        1008.0824584960938
      ],
      "bbox_max": [
        -1530.772705078125,
        -3662.322509765625,
        1008.147216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9275855422019958,
        -0.0,
        0.37361082434654236
      ],
      "plane_d": 1081.478759765625,
      "bbox_min": [
        -1555.796142578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9275855422019958,
        0.0,
        -0.37361082434654236
      ],
      "plane_d": 1804.789306640625,
      "bbox_min": [
        -1555.796142578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3657.918212890625,
        974.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2659290134906769,
        0.0,
        0.9639926552772522
      ],
      "plane_d": -515.5576171875,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3658.23828125,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -1205.2529296875,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1548.5345458984375,
        -3665.7685546875,
        963.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1548.546142578125,
        -3665.800048828125,
        961.99365234375
      ],
      "bbox_max": [
        -1548.5345458984375,
        -3665.7685546875,
        962.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26592525839805603,
        0.0,
        -0.9639936685562134
      ],
      "plane_d": 527.1322631835938,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        961.996826171875
      ],
      "bbox_max": [
        -1541.296142578125,
        -3659.19775390625,
        974.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.26592525839805603,
        0.0,
        0.9639936685562134
      ],
      "plane_d": -1339.159423828125,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        961.996826171875
      ],
      "bbox_max": [
        -1541.296142578125,
        -3659.19775390625,
        974.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": -2061.5400390625,
      "bbox_min": [
        -1543.108642578125,
        -3665.800048828125,
        963.49365234375
      ],
      "bbox_max": [
        -1543.105712890625,
        -3665.7685546875,
        963.5007934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9275854825973511,
        -0.0,
        -0.37361079454421997
      ],
      "plane_d": -1068.0286865234375,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        963.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3660.156982421875,
        974.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9275854825973511,
        0.0,
        0.37361079454421997
      ],
      "plane_d": -1791.3392333984375,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        963.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3660.156982421875,
        974.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 1216.6083984375,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        972.49365234375
      ],
      "bbox_max": [
        -1543.108642578125,
        -3665.7685546875,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 2025.09619140625,
      "bbox_min": [
        -1553.983642578125,
        -3665.800048828125,
        972.49365234375
      ],
      "bbox_max": [
        -1548.546142578125,
        -3665.7685546875,
        974.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378205060958862,
        0.9847841262817383,
        0.0
      ],
      "plane_d": 3335.990478515625,
      "bbox_min": [
        -1578.0,
        -3663.599609375,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1015.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.2843024730682373,
        -0.9587345719337463
      ],
      "plane_d": 1999.7059326171875,
      "bbox_min": [
        -1544.0,
        -3663.599609375,
        963.2540893554688
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1009.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9118090271949768,
        0.2007651925086975,
        -0.3581864833831787
      ],
      "plane_d": -299.3985595703125,
      "bbox_min": [
        -1530.8365478515625,
        -3662.905517578125,
        999.5809326171875
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1009.6653442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1530.772705078125,
        -3662.3779296875,
        1000.5958251953125
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1009.6653442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43055403232574463,
        0.06838241219520569,
        0.8999706506729126
      ],
      "plane_d": -3.548828125,
      "bbox_min": [
        -1521.328369140625,
        -3659.483154296875,
        1000.5958251953125
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1009.6653442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8733665943145752,
        0.16915975511074066,
        -0.456744909286499
      ],
      "plane_d": 2405.197265625,
      "bbox_min": [
        -1521.328369140625,
        -3659.483154296875,
        1000.5958251953125
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1008.6051635742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5109584331512451,
        0.0907880887389183,
        0.8547976016998291
      ],
      "plane_d": 246.08685302734375,
      "bbox_min": [
        -1519.3990478515625,
        -3656.56396484375,
        1008.1559448242188
      ],
      "bbox_max": [
        -1518.6370849609375,
        -3655.53076171875,
        1008.6051635742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9137110114097595,
        0.19052287936210632,
        -0.35893362760543823
      ],
      "plane_d": 2446.124267578125,
      "bbox_min": [
        -1521.328369140625,
        -3659.483154296875,
        1000.5958251953125
      ],
      "bbox_max": [
        -1519.1697998046875,
        -3655.65869140625,
        1006.823974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.871819794178009,
        0.17903247475624084,
        -0.4559359848499298
      ],
      "plane_d": -219.3062744140625,
      "bbox_min": [
        -1530.8365478515625,
        -3662.3779296875,
        1006.9179077148438
      ],
      "bbox_max": [
        -1529.2010498046875,
        -3657.388427734375,
        1008.2196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1530.8365478515625,
        -3662.333740234375,
        1008.1077880859375
      ],
      "bbox_max": [
        -1529.73291015625,
        -3657.482421875,
        1008.2196044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.638286292552948,
        0.22220253944396973,
        -0.7370322942733765
      ],
      "plane_d": 2520.6708984375,
      "bbox_min": [
        -1544.0,
        -3661.452880859375,
        963.2540893554688
      ],
      "bbox_max": [
        -1535.7647705078125,
        -3658.6708984375,
        989.3556518554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6513202786445618,
        0.10076474398374557,
        0.7520827054977417
      ],
      "plane_d": 627.5469360351562,
      "bbox_min": [
        -1543.9991455078125,
        -3661.452880859375,
        983.0718994140625
      ],
      "bbox_max": [
        -1535.7647705078125,
        -3658.6708984375,
        989.3556518554688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.038317177444696426,
        0.9992656111717224
      ],
      "plane_d": -848.3582153320312,
      "bbox_min": [
        -1543.9991455078125,
        -3660.783203125,
        989.2967529296875
      ],
      "bbox_max": [
        -1539.5595703125,
        -3659.246337890625,
        989.3556518554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26594802737236023,
        -0.0,
        -0.963987410068512
      ],
      "plane_d": 527.091064453125,
      "bbox_min": [
        -1544.0,
        -3660.156982421875,
        963.2540893554688
      ],
      "bbox_max": [
        -1543.108642578125,
        -3659.8427734375,
        972.7459106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8631613850593567,
        -0.4983587861061096,
        -0.08118457347154617
      ],
      "plane_d": -388.05712890625,
      "bbox_min": [
        -1578.0,
        -3659.999755859375,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1009.7603149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9557704925537109,
        -0.29411351680755615
      ],
      "plane_d": -3176.8203125,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1553.0,
        -3625.852783203125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.752065122127533,
        -0.5941891074180603,
        -0.2851971387863159
      ],
      "plane_d": -3047.8212890625,
      "bbox_min": [
        -1565.908203125,
        -3631.863525390625,
        985.0
      ],
      "bbox_max": [
        -1553.0,
        -3625.852783203125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7520655393600464,
        -0.5941894054412842,
        -0.2851952910423279
      ],
      "plane_d": -702.1324462890625,
      "bbox_min": [
        -1565.908203125,
        -3631.863525390625,
        985.0
      ],
      "bbox_max": [
        -1553.0,
        -3625.852783203125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7781456112861633,
        0.6147946715354919,
        -0.12851794064044952
      ],
      "plane_d": 3567.427734375,
      "bbox_min": [
        -1565.908203125,
        -3631.863525390625,
        985.0
      ],
      "bbox_max": [
        -1553.0,
        -3625.852783203125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1000.9999389648438,
      "bbox_min": [
        -1565.908203125,
        -3631.863525390625,
        985.0
      ],
      "bbox_max": [
        -1553.0,
        -3625.852783203125,
        1001.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 985.0,
      "bbox_min": [
        -1560.5831298828125,
        -3626.93994140625,
        985.0
      ],
      "bbox_max": [
        -1558.06591796875,
        -3626.482177734375,
        985.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8629466891288757,
        0.4982348680496216,
        -0.0841730609536171
      ],
      "plane_d": 3236.992431640625,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1555.8070068359375,
        -3630.602783203125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9964396357536316,
        -0.08430913090705872
      ],
      "plane_d": 3702.257080078125,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1556.8072509765625,
        -3630.602783203125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8633504509925842,
        -0.49846795201301575,
        -0.07845883071422577
      ],
      "plane_d": -3083.61328125,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1556.8072509765625,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8631430268287659,
        0.498348206281662,
        -0.0814453512430191
      ],
      "plane_d": 542.9013671875,
      "bbox_min": [
        -1563.1873779296875,
        -3638.397216796875,
        956.7099609375
      ],
      "bbox_max": [
        -1556.8072509765625,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9969271421432495,
        -0.0783342719078064
      ],
      "plane_d": -3549.161865234375,
      "bbox_min": [
        -1562.1817626953125,
        -3638.397216796875,
        956.7099609375
      ],
      "bbox_max": [
        -1556.8072509765625,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -980.712158203125,
      "bbox_min": [
        -1562.1817626953125,
        -3637.161865234375,
        980.7122192382812
      ],
      "bbox_max": [
        -1556.8072509765625,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1560.8380126953125,
        -3638.397216796875,
        956.7099609375
      ],
      "bbox_max": [
        -1558.15087890625,
        -3635.3544921875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -980.712158203125,
      "bbox_min": [
        -1560.8380126953125,
        -3638.397216796875,
        980.7122192382812
      ],
      "bbox_max": [
        -1558.15087890625,
        -3637.161865234375,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9605445265769958,
        0.27812641859054565
      ],
      "plane_d": -3758.284912109375,
      "bbox_min": [
        -1559.791259765625,
        -3635.644775390625,
        956.7099609375
      ],
      "bbox_max": [
        -1559.270751953125,
        -3635.3544921875,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7493326663970947,
        0.4326160252094269,
        -0.5013420581817627
      ],
      "plane_d": 892.058837890625,
      "bbox_min": [
        -1563.1873779296875,
        -3634.90380859375,
        956.8013916015625
      ],
      "bbox_max": [
        -1559.791259765625,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -980.712158203125,
      "bbox_min": [
        -1563.1873779296875,
        -3634.834228515625,
        980.7122192382812
      ],
      "bbox_max": [
        -1560.8380126953125,
        -3632.507080078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8219942450523376,
        0.47467273473739624,
        0.3146604895591736
      ],
      "plane_d": 141.68212890625,
      "bbox_min": [
        -1560.1844482421875,
        -3634.90380859375,
        956.8013916015625
      ],
      "bbox_max": [
        -1559.791259765625,
        -3634.453125,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9786690473556519,
        0.12109607458114624,
        -0.1659596860408783
      ],
      "plane_d": 2137.738525390625,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1559.5325927734375,
        -3633.092529296875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 967.5,
      "bbox_min": [
        -1578.0,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1569.050048828125,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3267.89404296875,
      "bbox_min": [
        -1578.0,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1881.9649658203125,
      "bbox_min": [
        -1578.0,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3257.28759765625,
      "bbox_min": [
        -1578.0,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3647.0,
      "bbox_min": [
        -1578.0,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        977.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1571.0,
      "bbox_min": [
        -1578.0,
        -3647.0,
        967.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        977.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -968.5,
      "bbox_min": [
        -1578.0,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        976.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 976.5,
      "bbox_min": [
        -1578.0,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3636.0,
        976.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7070888876914978,
        -0.707124650478363
      ],
      "plane_d": 3266.84619140625,
      "bbox_min": [
        -1577.0015869140625,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        976.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7070888876914978,
        0.707124650478363
      ],
      "plane_d": 1891.4886474609375,
      "bbox_min": [
        -1577.0015869140625,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        976.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7070888876914978,
        -0.707124650478363
      ],
      "plane_d": -1882.8822021484375,
      "bbox_min": [
        -1576.3719482421875,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        976.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7070888876914978,
        0.707124650478363
      ],
      "plane_d": -3258.23974609375,
      "bbox_min": [
        -1576.3719482421875,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        974.0858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3646.0,
      "bbox_min": [
        -1575.4814453125,
        -3646.0,
        970.9141845703125
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        974.0858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3637.0,
      "bbox_min": [
        -1574.8519287109375,
        -3637.0,
        970.9141845703125
      ],
      "bbox_max": [
        -1571.0,
        -3637.0,
        974.0858154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.29030516743659973,
        0.9434918165206909,
        -0.159831240773201
      ],
      "plane_d": 4052.807861328125,
      "bbox_min": [
        -1573.54150390625,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1569.050048828125,
        -3648.468994140625,
        963.2122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5686390399932861,
        0.8049494028091431,
        -0.1694285124540329
      ],
      "plane_d": 2205.744140625,
      "bbox_min": [
        -1573.54150390625,
        -3654.006103515625,
        956.0
      ],
      "bbox_max": [
        -1569.050048828125,
        -3648.468994140625,
        963.2122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -963.2122192382812,
      "bbox_min": [
        -1573.54150390625,
        -3654.006103515625,
        963.2122192382812
      ],
      "bbox_max": [
        -1569.050048828125,
        -3648.468994140625,
        963.2122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7804855108261108,
        -0.4506016671657562,
        -0.4333595931529999
      ],
      "plane_d": -2433.39013671875,
      "bbox_min": [
        -1564.0,
        -3638.397216796875,
        956.0
      ],
      "bbox_max": [
        -1559.5325927734375,
        -3633.092529296875,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -980.712158203125,
      "bbox_min": [
        -1564.0,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1560.124755859375,
        -3633.092529296875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1564.0,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1560.124755859375,
        -3633.092529296875,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284400105476379,
        -0.4783949553966522,
        0.291248083114624
      ],
      "plane_d": -3310.2607421875,
      "bbox_min": [
        -1560.68017578125,
        -3635.850341796875,
        956.0
      ],
      "bbox_max": [
        -1559.5325927734375,
        -3634.530029296875,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7493326663970947,
        0.4326160252094269,
        -0.5013420581817627
      ],
      "plane_d": 892.058837890625,
      "bbox_min": [
        -1562.849365234375,
        -3632.80322265625,
        977.2122192382812
      ],
      "bbox_max": [
        -1558.1510009765625,
        -3630.602783203125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9457221031188965,
        0.32497653365135193
      ],
      "plane_d": 3125.94873046875,
      "bbox_min": [
        -1560.10693359375,
        -3634.453125,
        956.0
      ],
      "bbox_max": [
        -1559.270751953125,
        -3633.86474609375,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7493326663970947,
        0.4326160252094269,
        -0.5013421177864075
      ],
      "plane_d": 3229.2275390625,
      "bbox_min": [
        -1559.777587890625,
        -3634.90380859375,
        956.0
      ],
      "bbox_max": [
        -1555.8070068359375,
        -3630.602783203125,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8226437568664551,
        0.4750477969646454,
        0.312389075756073
      ],
      "plane_d": 2710.08447265625,
      "bbox_min": [
        -1559.270751953125,
        -3634.90380859375,
        956.0
      ],
      "bbox_max": [
        -1558.765869140625,
        -3633.86474609375,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.036495037376880646,
        0.9993337988853455
      ],
      "plane_d": -1120.92919921875,
      "bbox_min": [
        -1559.7181396484375,
        -3659.999755859375,
        956.0
      ],
      "bbox_max": [
        -1517.906494140625,
        -3624.0,
        1009.7603149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6516278982162476,
        -0.09601175785064697,
        0.7524380087852478
      ],
      "plane_d": -89.0885009765625,
      "bbox_min": [
        -1559.7181396484375,
        -3659.999755859375,
        956.0
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3624.0,
        989.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6494667530059814,
        -0.214582622051239,
        -0.7294842600822449
      ],
      "plane_d": 939.4677734375,
      "bbox_min": [
        -1559.7181396484375,
        -3659.999755859375,
        956.0
      ],
      "bbox_max": [
        -1536.4239501953125,
        -3624.0,
        989.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6397563219070435,
        -0.21210886538028717,
        -0.7387297749519348
      ],
      "plane_d": 942.6328125,
      "bbox_min": [
        -1558.8641357421875,
        -3659.26611328125,
        977.2122192382812
      ],
      "bbox_max": [
        -1536.6015625,
        -3624.0,
        989.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.1923827975988388,
        -0.9813199043273926
      ],
      "plane_d": 267.64691162109375,
      "bbox_min": [
        -1558.8641357421875,
        -3659.26611328125,
        977.2122192382812
      ],
      "bbox_max": [
        -1539.7125244140625,
        -3624.0,
        989.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6510604023933411,
        -0.10460984706878662,
        0.7517826557159424
      ],
      "plane_d": -2129.9365234375,
      "bbox_min": [
        -1550.0721435546875,
        -3644.615478515625,
        983.303955078125
      ],
      "bbox_max": [
        -1544.621337890625,
        -3624.486328125,
        989.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6482388973236084,
        -0.22282102704048157,
        -0.7281051278114319
      ],
      "plane_d": -1094.3892822265625,
      "bbox_min": [
        -1550.0721435546875,
        -3644.615478515625,
        983.303955078125
      ],
      "bbox_max": [
        -1544.621337890625,
        -3624.486328125,
        987.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6385786533355713,
        -0.22023369371891022,
        -0.737369954586029
      ],
      "plane_d": -1060.900634765625,
      "bbox_min": [
        -1549.9072265625,
        -3642.5,
        983.303955078125
      ],
      "bbox_max": [
        -1544.621337890625,
        -3624.486328125,
        986.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6465957164764404,
        0.23336903750896454,
        -0.7262595295906067
      ],
      "plane_d": 567.9998168945312,
      "bbox_min": [
        -1545.8505859375,
        -3644.615478515625,
        986.83544921875
      ],
      "bbox_max": [
        -1544.621337890625,
        -3642.5,
        987.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6465957164764404,
        0.23336903750896454,
        -0.7262595295906067
      ],
      "plane_d": 567.9998168945312,
      "bbox_min": [
        -1546.5103759765625,
        -3645.750732421875,
        987.2501220703125
      ],
      "bbox_max": [
        -1545.6429443359375,
        -3642.5,
        987.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6465957164764404,
        0.23336903750896454,
        -0.7262595295906067
      ],
      "plane_d": 567.9998168945312,
      "bbox_min": [
        -1558.8641357421875,
        -3659.26611328125,
        977.2122192382812
      ],
      "bbox_max": [
        -1541.57861328125,
        -3633.10205078125,
        988.3689575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6506955623626709,
        0.10977879911661148,
        0.7513613700866699
      ],
      "plane_d": -1348.0458984375,
      "bbox_min": [
        -1549.8564453125,
        -3659.26611328125,
        985.42724609375
      ],
      "bbox_max": [
        -1541.57861328125,
        -3642.5,
        988.3689575195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.20161986351013184,
        -0.9794638752937317
      ],
      "plane_d": 1700.969970703125,
      "bbox_min": [
        -1545.4725341796875,
        -3649.3408203125,
        985.42724609375
      ],
      "bbox_max": [
        -1541.57861328125,
        -3642.5,
        986.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7804855108261108,
        -0.4506016671657562,
        -0.4333595931529999
      ],
      "plane_d": 0.9442138671875,
      "bbox_min": [
        -1558.8641357421875,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.0,
        -3633.10205078125,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -980.712158203125,
      "bbox_min": [
        -1558.8641357421875,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.0,
        -3633.10205078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.918144941329956,
        -0.396244615316391
      ],
      "plane_d": -2951.97412109375,
      "bbox_min": [
        -1558.8641357421875,
        -3638.397216796875,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.0,
        -3633.10205078125,
        980.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7493295669555664,
        0.4326363205909729,
        -0.5013293027877808
      ],
      "plane_d": 3229.28369140625,
      "bbox_min": [
        -1557.1424560546875,
        -3634.844970703125,
        977.2122192382812
      ],
      "bbox_max": [
        -1555.0,
        -3633.10205078125,
        980.7122192382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.20161986351013184,
        -0.9794638752937317
      ],
      "plane_d": 1700.969970703125,
      "bbox_min": [
        -1545.4874267578125,
        -3649.4599609375,
        985.4027099609375
      ],
      "bbox_max": [
        -1541.57861328125,
        -3642.5,
        986.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.20161986351013184,
        -0.9794638752937317
      ],
      "plane_d": 1700.969970703125,
      "bbox_min": [
        -1559.7181396484375,
        -3659.999755859375,
        956.0
      ],
      "bbox_max": [
        -1538.9649658203125,
        -3634.201416015625,
        987.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6479394435882568,
        0.22478191554546356,
        -0.7277688384056091
      ],
      "plane_d": 2535.8056640625,
      "bbox_min": [
        -1541.57861328125,
        -3647.457275390625,
        986.645751953125
      ],
      "bbox_max": [
        -1540.0718994140625,
        -3642.5,
        987.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9605445265769958,
        0.27812641859054565
      ],
      "plane_d": -3758.284912109375,
      "bbox_min": [
        -1559.7181396484375,
        -3635.850341796875,
        956.0
      ],
      "bbox_max": [
        -1558.9603271484375,
        -3635.3544921875,
        957.7122192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513202786445618,
        0.10076474398374557,
        0.7520827054977417
      ],
      "plane_d": 627.5469360351562,
      "bbox_min": [
        -1541.57861328125,
        -3659.111572265625,
        984.0908813476562
      ],
      "bbox_max": [
        -1536.4681396484375,
        -3642.5,
        988.6546020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6613048315048218,
        0.10500787943601608,
        0.742730975151062
      ],
      "plane_d": 667.6401977539062,
      "bbox_min": [
        -1541.57861328125,
        -3659.111572265625,
        984.0908813476562
      ],
      "bbox_max": [
        -1536.4681396484375,
        -3642.5,
        988.6546020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.638286292552948,
        0.22220253944396973,
        -0.7370322942733765
      ],
      "plane_d": 2520.6708984375,
      "bbox_min": [
        -1540.0718994140625,
        -3659.111572265625,
        984.0908813476562
      ],
      "bbox_max": [
        -1536.65380859375,
        -3647.457275390625,
        986.645751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513202786445618,
        0.10076474398374557,
        0.7520827054977417
      ],
      "plane_d": 627.5469360351562,
      "bbox_min": [
        -1541.57861328125,
        -3659.246337890625,
        988.0521240234375
      ],
      "bbox_max": [
        -1538.330322265625,
        -3642.5,
        989.2967529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5099438428878784,
        -0.11035174131393433,
        0.8531002402305603
      ],
      "plane_d": -2040.90673828125,
      "bbox_min": [
        -1531.00634765625,
        -3657.505859375,
        999.7144775390625
      ],
      "bbox_max": [
        -1517.906494140625,
        -3626.29296875,
        1009.7603149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.430046409368515,
        -0.0837937518954277,
        0.8989096283912659
      ],
      "plane_d": -1868.486328125,
      "bbox_min": [
        -1531.00634765625,
        -3657.287353515625,
        999.7144775390625
      ],
      "bbox_max": [
        -1517.906494140625,
        -3626.29296875,
        1009.7603149414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9062353372573853,
        -0.2280433624982834,
        -0.3559969663619995
      ],
      "plane_d": -1855.4609375,
      "bbox_min": [
        -1531.00634765625,
        -3657.287353515625,
        999.7144775390625
      ],
      "bbox_max": [
        -1517.906494140625,
        -3626.29296875,
        1009.7175903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.32097047567367554,
        -0.9470891952514648
      ],
      "plane_d": -217.3135986328125,
      "bbox_min": [
        -1527.4869384765625,
        -3655.964599609375,
        999.7144775390625
      ],
      "bbox_max": [
        -1517.906494140625,
        -3626.9140625,
        1009.7175903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5103150010108948,
        -0.10362716019153595,
        0.8537212014198303
      ],
      "plane_d": -462.158447265625,
      "bbox_min": [
        -1522.4786376953125,
        -3653.673095703125,
        1000.1109619140625
      ],
      "bbox_max": [
        -1517.906494140625,
        -3628.083984375,
        1009.7175903320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8695663213729858,
        -0.19248422980308533,
        -0.4547574520111084
      ],
      "plane_d": 1079.763671875,
      "bbox_min": [
        -1522.4786376953125,
        -3649.099609375,
        1005.33544921875
      ],
      "bbox_max": [
        -1517.906494140625,
        -3628.895751953125,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8733665943145752,
        0.16915975511074066,
        -0.456744909286499
      ],
      "plane_d": 2405.197265625,
      "bbox_min": [
        -1522.4786376953125,
        -3649.099609375,
        1005.33544921875
      ],
      "bbox_max": [
        -1520.4014892578125,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8733665943145752,
        0.16915975511074066,
        -0.456744909286499
      ],
      "plane_d": 2405.197265625,
      "bbox_min": [
        -1520.95703125,
        -3651.904296875,
        1007.2332153320312
      ],
      "bbox_max": [
        -1519.3612060546875,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2843024730682373,
        -0.9587345719337463
      ],
      "plane_d": 1999.7059326171875,
      "bbox_min": [
        -1525.5213623046875,
        -3655.964599609375,
        1002.0675659179688
      ],
      "bbox_max": [
        -1518.672607421875,
        -3643.5,
        1008.7830810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43055403232574463,
        0.06838241219520569,
        0.8999706506729126
      ],
      "plane_d": -3.548828125,
      "bbox_min": [
        -1520.0863037109375,
        -3655.696044921875,
        1008.6051635742188
      ],
      "bbox_max": [
        -1519.3990478515625,
        -3653.443359375,
        1008.7830810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9137110114097595,
        0.19052287936210632,
        -0.35893362760543823
      ],
      "plane_d": 2446.124267578125,
      "bbox_min": [
        -1522.4786376953125,
        -3655.964599609375,
        1002.0675659179688
      ],
      "bbox_max": [
        -1519.3990478515625,
        -3643.5,
        1006.7208251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2843024730682373,
        -0.9587345719337463
      ],
      "plane_d": 1999.7059326171875,
      "bbox_min": [
        -1528.62744140625,
        -3657.287353515625,
        1001.3363037109375
      ],
      "bbox_max": [
        -1521.132080078125,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9118090271949768,
        0.2007651925086975,
        -0.3581864833831787
      ],
      "plane_d": -299.3985595703125,
      "bbox_min": [
        -1528.62744140625,
        -3657.287353515625,
        1001.3363037109375
      ],
      "bbox_max": [
        -1521.132080078125,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9137110114097595,
        0.19052287936210632,
        -0.35893362760543823
      ],
      "plane_d": 2446.124267578125,
      "bbox_min": [
        -1521.4644775390625,
        -3655.999267578125,
        1001.62890625
      ],
      "bbox_max": [
        -1521.132080078125,
        -3654.52001953125,
        1002.1468505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.871819794178009,
        0.17903247475624084,
        -0.4559359848499298
      ],
      "plane_d": -219.3062744140625,
      "bbox_min": [
        -1528.04052734375,
        -3653.008056640625,
        1005.33544921875
      ],
      "bbox_max": [
        -1525.5213623046875,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4304007589817047,
        0.07337993383407593,
        0.8996502161026001
      ],
      "plane_d": -1297.11181640625,
      "bbox_min": [
        -1529.86572265625,
        -3657.505859375,
        1005.514404296875
      ],
      "bbox_max": [
        -1525.5213623046875,
        -3643.5,
        1009.154541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.871819794178009,
        0.17903247475624084,
        -0.4559359848499298
      ],
      "plane_d": -219.3062744140625,
      "bbox_min": [
        -1529.86572265625,
        -3657.505859375,
        1005.514404296875
      ],
      "bbox_max": [
        -1527.04296875,
        -3643.5,
        1008.2449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.031940679997205734,
        0.9994897246360779
      ],
      "plane_d": -892.2637329101562,
      "bbox_min": [
        -1526.9197998046875,
        -3656.986083984375,
        1008.709228515625
      ],
      "bbox_max": [
        -1519.610595703125,
        -3643.5,
        1009.5855102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43055403232574463,
        0.06838241219520569,
        0.8999706506729126
      ],
      "plane_d": -3.548828125,
      "bbox_min": [
        -1522.4786376953125,
        -3655.999267578125,
        1008.709228515625
      ],
      "bbox_max": [
        -1519.610595703125,
        -3643.5,
        1009.5540161132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 1216.6083984375,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2843024730682373,
        -0.9587345719337463
      ],
      "plane_d": 1999.7059326171875,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.031940679997205734,
        0.9994897246360779
      ],
      "plane_d": -892.2637329101562,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9118090271949768,
        0.2007651925086975,
        -0.3581864833831787
      ],
      "plane_d": -299.3985595703125,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9137110114097595,
        0.19052287936210632,
        -0.35893362760543823
      ],
      "plane_d": 2446.124267578125,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        998.218505859375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4304007589817047,
        0.07337993383407593,
        0.8996502161026001
      ],
      "plane_d": -1297.11181640625,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43055403232574463,
        0.06838241219520569,
        0.8999706506729126
      ],
      "plane_d": -3.548828125,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1009.9215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1008.1469116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5109584331512451,
        0.0907880887389183,
        0.8547976016998291
      ],
      "plane_d": 246.08685302734375,
      "bbox_min": [
        -1516.83056640625,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1008.1469116210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8733665943145752,
        0.16915975511074066,
        -0.456744909286499
      ],
      "plane_d": 2405.197265625,
      "bbox_min": [
        -1516.83056640625,
        -3667.5,
        1007.8763427734375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1008.0953979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5109584331512451,
        0.0907880887389183,
        0.8547976016998291
      ],
      "plane_d": 246.08685302734375,
      "bbox_min": [
        -1516.744384765625,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1516.4000244140625,
        -3665.800048828125,
        1008.0953979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.871819794178009,
        0.17903247475624084,
        -0.4559359848499298
      ],
      "plane_d": -219.3062744140625,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        1007.8763427734375
      ],
      "bbox_max": [
        -1531.4295654296875,
        -3665.800048828125,
        1008.095458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5106731057167053,
        0.09669585525989532,
        0.854320228099823
      ],
      "plane_d": -1288.87255859375,
      "bbox_min": [
        -1531.8800048828125,
        -3667.5,
        1008.070068359375
      ],
      "bbox_max": [
        -1531.515625,
        -3665.800048828125,
        1008.095458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 2025.09619140625,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        973.99365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -1205.2529296875,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        960.3812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9249667525291443,
        0.07508881390094757,
        -0.37255603075027466
      ],
      "plane_d": 2074.9521484375,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        961.8812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": 803.167236328125,
      "bbox_min": [
        -1555.796142578125,
        -3673.800048828125,
        961.8812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": -2061.5400390625,
      "bbox_min": [
        -1543.108642578125,
        -3673.800048828125,
        961.8812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        0.07508881390094757,
        -0.37255603075027466
      ],
      "plane_d": -789.7552490234375,
      "bbox_min": [
        -1543.108642578125,
        -3673.800048828125,
        966.3812255859375
      ],
      "bbox_max": [
        -1541.296142578125,
        -3665.800048828125,
        972.49365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24937207996845245,
        0.3473396897315979,
        -0.9039738178253174
      ],
      "plane_d": 1768.9046630859375,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24937207996845245,
        0.3473396897315979,
        -0.9039738178253174
      ],
      "plane_d": 2541.23291015625,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -1758.0570068359375,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -1205.2529296875,
      "bbox_min": [
        -1553.986328125,
        -3673.8310546875,
        960.375
      ],
      "bbox_max": [
        -1548.53564453125,
        -3673.800048828125,
        961.8877563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1553.986328125,
        -3673.8310546875,
        960.375
      ],
      "bbox_max": [
        -1548.53564453125,
        -3673.800048828125,
        961.8877563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": 803.167236328125,
      "bbox_min": [
        -1553.986328125,
        -3673.8310546875,
        961.875
      ],
      "bbox_max": [
        -1553.983642578125,
        -3673.800048828125,
        961.8877563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24937207996845245,
        -0.3473396897315979,
        0.9039738178253174
      ],
      "plane_d": -2530.38525390625,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        955.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        -0.19072650372982025,
        0.9462968111038208
      ],
      "plane_d": -2013.74072265625,
      "bbox_min": [
        -1548.546142578125,
        -3673.8310546875,
        960.375
      ],
      "bbox_max": [
        -1543.1060791015625,
        -3673.800048828125,
        961.8876342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9249667525291443,
        -0.07508881390094757,
        0.37255603075027466
      ],
      "plane_d": -2061.5400390625,
      "bbox_min": [
        -1543.108642578125,
        -3673.8310546875,
        961.875
      ],
      "bbox_max": [
        -1543.1060791015625,
        -3673.800048828125,
        961.8876342773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9181729555130005,
        0.14209820330142975,
        -0.36981964111328125
      ],
      "plane_d": 2307.919189453125,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        957.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9181729555130005,
        -0.14209820330142975,
        0.36981964111328125
      ],
      "plane_d": 549.0607299804688,
      "bbox_min": [
        -1555.796142578125,
        -3686.5185546875,
        957.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9181729555130005,
        -0.14209820330142975,
        0.36981964111328125
      ],
      "plane_d": -2294.605712890625,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        957.0
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9181729555130005,
        0.14209820330142975,
        -0.36981964111328125
      ],
      "plane_d": -535.7471313476562,
      "bbox_min": [
        -1553.983642578125,
        -3686.5185546875,
        961.5
      ],
      "bbox_max": [
        -1541.296142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 1216.6083984375,
      "bbox_min": [
        -1553.983642578125,
        -3673.8310546875,
        970.875
      ],
      "bbox_max": [
        -1543.108642578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2610473930835724,
        0.19072650372982025,
        -0.9462968111038208
      ],
      "plane_d": 2025.09619140625,
      "bbox_min": [
        -1553.983642578125,
        -3673.8310546875,
        970.875
      ],
      "bbox_max": [
        -1548.546142578125,
        -3673.800048828125,
        972.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40067940950393677,
        0.9162183403968811
      ],
      "plane_d": -2353.93310546875,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        951.8101196289062
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26280197501182556,
        -0.1529032438993454,
        0.952657163143158
      ],
      "plane_d": -1066.983642578125,
      "bbox_min": [
        -1553.983642578125,
        -3697.7685546875,
        951.8101196289062
      ],
      "bbox_max": [
        -1540.7369384765625,
        -3686.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23996202647686005,
        -0.4309960901737213,
        0.8698623776435852
      ],
      "plane_d": -2791.620849609375,
      "bbox_min": [
        -1548.546142578125,
        -3697.7685546875,
        951.8101196289062
      ],
      "bbox_max": [
        -1540.7369384765625,
        -3686.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8457331657409668,
        -0.4107287526130676,
        0.340642511844635
      ],
      "plane_d": -525.898681640625,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457331657409668,
        -0.4107287526130676,
        0.340642511844635
      ],
      "plane_d": -3145.212158203125,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7755640745162964,
        -0.38296639919281006,
        0.5018337965011597
      ],
      "plane_d": -686.853759765625,
      "bbox_min": [
        -1559.296142578125,
        -3697.7685546875,
        952.0801391601562
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25395944714546204,
        0.29663872718811035,
        -0.9206030368804932
      ],
      "plane_d": 2377.515380859375,
      "bbox_min": [
        -1556.026611328125,
        -3697.7685546875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      "bbox_max": [
        -1548.546142578125,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25395944714546204,
        0.29663872718811035,
        -0.9206030368804932
      ],
      "plane_d": 1590.979736328125,
      "bbox_min": [
        -1548.546142578125,
        -3697.7685546875,
        963.875
      ],
      "bbox_max": [
        -1543.108642578125,
        -3686.5185546875,
        967.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622037172317505,
        -0.049794260412454605,
        -0.504108190536499
      ],
      "plane_d": -1027.77880859375,
      "bbox_min": [
        -1543.108642578125,
        -3697.7685546875,
        956.625
      ],
      "bbox_max": [
        -1537.796142578125,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1543.108642578125,
        -3697.7685546875,
        961.5
      ],
      "bbox_max": [
        -1540.6982421875,
        -3686.5185546875,
        966.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.054038431495428085,
        -0.10393351316452026,
        0.9931151270866394
      ],
      "plane_d": -1412.26220703125,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8681620359420776,
        -0.0435086190700531,
        0.4943700432777405
      ],
      "plane_d": -1967.85888671875,
      "bbox_min": [
        -1540.858642578125,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8681620359420776,
        -0.0435086190700531,
        0.4943700432777405
      ],
      "plane_d": -1967.85888671875,
      "bbox_min": [
        -1539.9739990234375,
        -3728.5185546875,
        948.0535888671875
      ],
      "bbox_max": [
        -1539.2103271484375,
        -3716.478515625,
        949.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14027108252048492,
        0.07180550694465637,
        -0.9875059723854065
      ],
      "plane_d": 999.2282104492188,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3348.288818359375,
      "bbox_min": [
        -1548.5999755859375,
        -3717.856689453125,
        957.6713256835938
      ],
      "bbox_max": [
        -1518.9776611328125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3342.95849609375,
      "bbox_min": [
        -1521.0767822265625,
        -3712.97314453125,
        957.6713256835938
      ],
      "bbox_max": [
        -1518.9776611328125,
        -3712.407470703125,
        958.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3717.856689453125,
        961.4942626953125
      ],
      "bbox_max": [
        -1548.54052734375,
        -3717.528564453125,
        961.5820922851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2763727903366089,
        -0.01238174270838499,
        -0.9609708189964294
      ],
      "plane_d": 452.494873046875,
      "bbox_min": [
        -1548.5999755859375,
        -3717.551025390625,
        960.4444580078125
      ],
      "bbox_max": [
        -1540.296142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 1618.83056640625,
      "bbox_min": [
        -1548.546142578125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        963.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1541.065673828125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        962.5009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34520602226257324,
        0.0646713599562645,
        -0.9362961053848267
      ],
      "plane_d": 607.87158203125,
      "bbox_min": [
        -1548.5999755859375,
        -3717.551025390625,
        960.4444580078125
      ],
      "bbox_max": [
        -1540.296142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17288756370544434,
        0.2555210292339325,
        -0.9512196779251099
      ],
      "plane_d": 1596.859130859375,
      "bbox_min": [
        -1548.5999755859375,
        -3717.551025390625,
        960.4444580078125
      ],
      "bbox_max": [
        -1540.296142578125,
        -3697.7685546875,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1548.5999755859375,
        -3697.787841796875,
        963.8597412109375
      ],
      "bbox_max": [
        -1548.546142578125,
        -3697.7685546875,
        963.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3717.551025390625,
        961.5653076171875
      ],
      "bbox_max": [
        -1548.5,
        -3708.402099609375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3417642414569855,
        0.0648205354809761,
        -0.9375476241111755
      ],
      "plane_d": 1673.40478515625,
      "bbox_min": [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      "bbox_max": [
        -1548.5,
        -3708.402099609375,
        964.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        948.4600830078125
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1548.5999755859375,
        -3720.14990234375,
        948.4600830078125
      ],
      "bbox_max": [
        -1539.856201171875,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3342.95849609375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3200073242188
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3348.288818359375,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1521.0767822265625,
        -3712.97314453125,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2057.5009765625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234262466430664,
        0.2431025505065918,
        -0.512708842754364
      ],
      "plane_d": 127.522216796875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8402679562568665,
        0.2549531161785126,
        -0.47848591208457947
      ],
      "plane_d": 113.056640625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2602.8154296875,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8656002879142761,
        -0.042541082948446274,
        0.4989252984523773
      ],
      "plane_d": -1964.642822265625,
      "bbox_min": [
        -1548.5999755859375,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.185302734375,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1548.5999755859375,
        -3718.7685546875,
        961.2447509765625
      ],
      "bbox_max": [
        -1548.5419921875,
        -3717.759765625,
        961.5095825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22476887702941895,
        0.8151643872261047,
        0.5338410139083862
      ],
      "plane_d": 2176.64306640625,
      "bbox_min": [
        -1548.5999755859375,
        -3722.03955078125,
        949.3200073242188
      ],
      "bbox_max": [
        -1516.796142578125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8656002879142761,
        -0.042541082948446274,
        0.4989252984523773
      ],
      "plane_d": -1964.642822265625,
      "bbox_min": [
        -1539.856201171875,
        -3722.03955078125,
        949.3200073242188
      ],
      "bbox_max": [
        -1537.046142578125,
        -3716.478515625,
        954.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23996202647686005,
        -0.4309960901737213,
        0.8698623776435852
      ],
      "plane_d": -2791.620849609375,
      "bbox_min": [
        -1541.7158203125,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1540.2161865234375,
        -3697.7685546875,
        952.0801391601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8622037172317505,
        -0.049794260412454605,
        -0.504108190536499
      ],
      "plane_d": -1027.77880859375,
      "bbox_min": [
        -1540.805908203125,
        -3700.629638671875,
        951.0
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9263224005699158,
        -0.05217086523771286,
        -0.3731020390987396
      ],
      "plane_d": -1261.328369140625,
      "bbox_min": [
        -1540.805908203125,
        -3700.629638671875,
        961.5885620117188
      ],
      "bbox_max": [
        -1540.546142578125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7755640745162964,
        -0.38296639919281006,
        0.5018337965011597
      ],
      "plane_d": -3088.84716796875,
      "bbox_min": [
        -1540.7369384765625,
        -3700.238525390625,
        951.0
      ],
      "bbox_max": [
        -1537.796142578125,
        -3697.7685546875,
        956.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1557.236083984375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8681619763374329,
        -0.043508630245923996,
        0.4943700134754181
      ],
      "plane_d": 720.9188842773438,
      "bbox_min": [
        -1557.236083984375,
        -3728.5185546875,
        946.5
      ],
      "bbox_max": [
        -1556.233642578125,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8681619763374329,
        -0.043508630245923996,
        0.4943700134754181
      ],
      "plane_d": 720.9188842773438,
      "bbox_min": [
        -1557.8819580078125,
        -3728.5185546875,
        948.0535888671875
      ],
      "bbox_max": [
        -1557.1182861328125,
        -3716.478515625,
        949.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14027108252048492,
        0.07180550694465637,
        -0.9875059723854065
      ],
      "plane_d": 1433.66064453125,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3979.525390625,
      "bbox_min": [
        -1578.1146240234375,
        -3717.83935546875,
        957.6712036132812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3915.255859375,
      "bbox_min": [
        -1578.1146240234375,
        -3712.97314453125,
        957.6712036132812
      ],
      "bbox_max": [
        -1576.01513671875,
        -3712.407470703125,
        958.3333129882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2755959928035736,
        -0.010011322796344757,
        -0.9612213969230652
      ],
      "plane_d": 1316.2508544921875,
      "bbox_min": [
        -1556.796142578125,
        -3717.522216796875,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17427998781204224,
        0.2634528875350952,
        -0.9487987160682678
      ],
      "plane_d": 2158.591796875,
      "bbox_min": [
        -1556.546142578125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        963.8651123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.926322340965271,
        -0.05217086896300316,
        -0.3731020390987396
      ],
      "plane_d": 1607.5775146484375,
      "bbox_min": [
        -1556.546142578125,
        -3700.629638671875,
        961.611083984375
      ],
      "bbox_max": [
        -1556.026611328125,
        -3697.7685546875,
        962.5009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3417642414569855,
        0.0648205354809761,
        -0.9375476241111755
      ],
      "plane_d": 1673.40478515625,
      "bbox_min": [
        -1556.796142578125,
        -3717.522216796875,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3700.629638671875,
        963.9703369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1556.796142578125,
        -3717.522216796875,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3708.592529296875,
        963.9571533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10289876908063889,
        0.994691789150238
      ],
      "plane_d": -1326.701904296875,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2280474305152893,
        0.9736499786376953
      ],
      "plane_d": -1771.8388671875,
      "bbox_min": [
        -1557.236083984375,
        -3720.10546875,
        948.4705200195312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.478515625,
        949.3200073242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18478533625602722,
        0.8477975726127625,
        -0.4970851242542267
      ],
      "plane_d": 3915.255859375,
      "bbox_min": [
        -1580.296142578125,
        -3728.5185546875,
        949.3200073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20381586253643036,
        0.8688979148864746,
        -0.4510827362537384
      ],
      "plane_d": 3979.525390625,
      "bbox_min": [
        -1576.01513671875,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3712.97314453125,
        961.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1760730892419815,
        0.3933427333831787,
        -0.9023745656013489
      ],
      "plane_d": 2602.8154296875,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8234262466430664,
        0.2431025505065918,
        -0.512708842754364
      ],
      "plane_d": 2677.749267578125,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8402679562568665,
        0.2549531161785126,
        -0.47848591208457947
      ],
      "plane_d": 2715.44384765625,
      "bbox_min": [
        -1560.046142578125,
        -3728.5185546875,
        949.3544311523438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1724844127893448,
        0.25409120321273804,
        -0.9516757726669312
      ],
      "plane_d": 2126.8046875,
      "bbox_min": [
        -1556.796142578125,
        -3718.751708984375,
        960.4444580078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3716.185302734375,
        961.4883422851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22476887702941895,
        0.8151643872261047,
        0.5338410139083862
      ],
      "plane_d": 2872.773193359375,
      "bbox_min": [
        -1580.296142578125,
        -3722.039794921875,
        949.3200073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22865083813667297,
        0.82159423828125,
        0.522208571434021
      ],
      "plane_d": 2913.837646484375,
      "bbox_min": [
        -1580.296142578125,
        -3718.7685546875,
        951.0
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40067940950393677,
        0.9162183403968811
      ],
      "plane_d": -2353.93310546875,
      "bbox_min": [
        -1559.296142578125,
        -3700.629638671875,
        951.0
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8622037768363953,
        -0.0497942790389061,
        -0.5041082501411438
      ],
      "plane_d": 1642.5458984375,
      "bbox_min": [
        -1559.296142578125,
        -3700.629638671875,
        951.0
      ],
      "bbox_max": [
        -1556.286376953125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.926322340965271,
        -0.05217086896300316,
        -0.3731020390987396
      ],
      "plane_d": 1607.5775146484375,
      "bbox_min": [
        -1556.546142578125,
        -3700.629638671875,
        961.5885620117188
      ],
      "bbox_max": [
        -1556.286376953125,
        -3697.7685546875,
        961.8560180664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011649972759187222,
        -0.09389030933380127,
        0.9955143928527832
      ],
      "plane_d": -1307.3695068359375,
      "bbox_min": [
        -1531.9283447265625,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1510.4072265625,
        -3740.70263671875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044131290167570114,
        0.0,
        0.9990256428718567
      ],
      "plane_d": -1008.2379150390625,
      "bbox_min": [
        -1531.43115234375,
        -3753.7685546875,
        941.5712890625
      ],
      "bbox_max": [
        -1510.4072265625,
        -3743.74072265625,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12376256287097931,
        0.8975092768669128,
        0.4232729375362396
      ],
      "plane_d": 2779.16162109375,
      "bbox_min": [
        -1531.3936767578125,
        -3753.7685546875,
        941.5729370117188
      ],
      "bbox_max": [
        -1510.4072265625,
        -3749.29638671875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7856389880180359,
        0.21981826424598694,
        0.5783175826072693
      ],
      "plane_d": -925.4896850585938,
      "bbox_min": [
        -1538.608642578125,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 1689.9024658203125,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        948.5
      ],
      "bbox_max": [
        -1538.608642578125,
        -3752.5185546875,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "bbox_max": [
        -1548.546142578125,
        -3752.5185546875,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011649972759187222,
        -0.09389030933380127,
        0.9955143928527832
      ],
      "plane_d": -1307.3695068359375,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12069325894117355,
        0.14038754999637604,
        -0.9827128648757935
      ],
      "plane_d": 1275.5908203125,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11516054719686508,
        0.21279339492321014,
        -0.9702870845794678
      ],
      "plane_d": 1543.0672607421875,
      "bbox_min": [
        -1548.5999755859375,
        -3754.908203125,
        950.271728515625
      ],
      "bbox_max": [
        -1534.3707275390625,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 1584.97021484375,
      "bbox_min": [
        -1548.5999755859375,
        -3754.908203125,
        950.271728515625
      ],
      "bbox_max": [
        -1534.3707275390625,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6525701880455017,
        0.47845280170440674,
        -0.5875669121742249
      ],
      "plane_d": 1352.4876708984375,
      "bbox_min": [
        -1548.5999755859375,
        -3754.908203125,
        950.271728515625
      ],
      "bbox_max": [
        -1534.3707275390625,
        -3752.158447265625,
        952.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3752.690185546875,
        952.1936645507812
      ],
      "bbox_max": [
        -1548.546142578125,
        -3752.51708984375,
        952.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.5185546875,
        954.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3728.5185546875,
        957.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.5185546875,
        954.0
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.20458984375,
        954.0750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6777244210243225,
        0.5401923656463623,
        -0.4988805055618286
      ],
      "plane_d": 1461.8388671875,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6525701880455017,
        0.47845280170440674,
        -0.5875669121742249
      ],
      "plane_d": 1352.4876708984375,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7140344381332397,
        0.24048978090286255,
        0.6575101613998413
      ],
      "plane_d": -812.57763671875,
      "bbox_min": [
        -1548.5999755859375,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7856389880180359,
        0.21981826424598694,
        0.5783175826072693
      ],
      "plane_d": -925.4896850585938,
      "bbox_min": [
        -1537.7735595703125,
        -3760.5185546875,
        940.634521484375
      ],
      "bbox_max": [
        -1531.296142578125,
        -3750.979248046875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12376256287097931,
        0.8975092768669128,
        0.4232729375362396
      ],
      "plane_d": 2779.16162109375,
      "bbox_min": [
        -1534.856201171875,
        -3753.7685546875,
        941.4199829101562
      ],
      "bbox_max": [
        -1531.296142578125,
        -3750.979248046875,
        945.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044131290167570114,
        0.0,
        0.9990256428718567
      ],
      "plane_d": -1008.2379150390625,
      "bbox_min": [
        -1534.856201171875,
        -3752.158447265625,
        941.4199829101562
      ],
      "bbox_max": [
        -1531.3936767578125,
        -3750.979248046875,
        941.5729370117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11790303885936737,
        0.14043496549129486,
        -0.9830447435379028
      ],
      "plane_d": 1645.5621337890625,
      "bbox_min": [
        -1548.5999755859375,
        -3746.5185546875,
        952.9970703125
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      "bbox_max": [
        -1548.546142578125,
        -3739.385986328125,
        954.025634765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.010467521846294403,
        -0.09385613352060318,
        0.9955307245254517
      ],
      "plane_d": -1273.01953125,
      "bbox_min": [
        -1589.796142578125,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        939.5
      ],
      "bbox_max": [
        -1558.483642578125,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        940.5975952148438
      ],
      "bbox_max": [
        -1559.2916259765625,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11129294335842133,
        0.9010937213897705,
        0.41909876465797424
      ],
      "plane_d": 3160.400146484375,
      "bbox_min": [
        -1589.796142578125,
        -3760.5185546875,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6592732667922974,
        0.5743206739425659,
        -0.4852983355522156
      ],
      "plane_d": 3647.515625,
      "bbox_min": [
        -1566.296142578125,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        950.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1566.296142578125,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        950.6508178710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7801473140716553,
        0.2481498122215271,
        0.5742750763893127
      ],
      "plane_d": 1609.4873046875,
      "bbox_min": [
        -1562.55615234375,
        -3760.5185546875,
        941.3113403320312
      ],
      "bbox_max": [
        -1559.8170166015625,
        -3752.158447265625,
        944.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08296652138233185,
        0.3366177976131439,
        -0.9379792213439941
      ],
      "plane_d": 2284.832763671875,
      "bbox_min": [
        -1560.529541015625,
        -3760.5185546875,
        948.5
      ],
      "bbox_max": [
        -1554.349853515625,
        -3756.31884765625,
        950.0599365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09354790300130844,
        0.995614767074585
      ],
      "plane_d": -1288.2982177734375,
      "bbox_min": [
        -1566.296142578125,
        -3758.17578125,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.22383302450180054,
        0.9746274948120117
      ],
      "plane_d": -1757.390869140625,
      "bbox_min": [
        -1562.55615234375,
        -3753.242431640625,
        941.1710205078125
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.158447265625,
        941.4199829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.32010748982429504,
        0.9473812580108643
      ],
      "plane_d": -2090.22314453125,
      "bbox_min": [
        -1566.296142578125,
        -3758.17578125,
        942.5399780273438
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11263309419155121,
        0.21111740171909332,
        -0.970949649810791
      ],
      "plane_d": 1890.180908203125,
      "bbox_min": [
        -1566.296142578125,
        -3758.17578125,
        945.875
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1849973052740097,
        0.25857579708099365,
        -0.9481111764907837
      ],
      "plane_d": 2157.923828125,
      "bbox_min": [
        -1563.8194580078125,
        -3758.17578125,
        948.9309692382812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3728.5185546875,
        956.989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08296652138233185,
        0.3366177976131439,
        -0.9379792213439941
      ],
      "plane_d": 2284.832763671875,
      "bbox_min": [
        -1563.8194580078125,
        -3758.17578125,
        948.9309692382812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1554.349853515625,
        -3758.17578125,
        950.0599365234375
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3752.56201171875,
        952.2296752929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11790303885936737,
        0.14043496549129486,
        -0.9830447435379028
      ],
      "plane_d": 1645.5621337890625,
      "bbox_min": [
        -1563.8194580078125,
        -3756.31884765625,
        948.9309692382812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3739.521484375,
        953.9931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1563.066650390625,
        -3754.8642578125,
        950.2855834960938
      ],
      "bbox_max": [
        -1561.2381591796875,
        -3752.158447265625,
        951.1400146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1563.8194580078125,
        -3756.31884765625,
        948.9309692382812
      ],
      "bbox_max": [
        -1560.529541015625,
        -3752.378173828125,
        950.4214477539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6293290853500366,
        0.49560001492500305,
        -0.5986030697822571
      ],
      "plane_d": 3412.287109375,
      "bbox_min": [
        -1566.296142578125,
        -3755.740966796875,
        945.875
      ],
      "bbox_max": [
        -1561.836181640625,
        -3752.702392578125,
        949.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1006.5,
      "bbox_min": [
        -1548.5999755859375,
        -3791.635498046875,
        935.0
      ],
      "bbox_max": [
        -1422.5,
        -3760.5185546875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06866054236888885,
        -0.03870672360062599,
        0.9968889355659485
      ],
      "plane_d": -1184.7757568359375,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.49609375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.49609375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.06879869848489761,
        6.067194408387877e-05,
        0.9976305961608887
      ],
      "plane_d": -1039.0933837890625,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12309727072715759,
        0.06976791471242905,
        0.9899391531944275
      ],
      "plane_d": -851.690673828125,
      "bbox_min": [
        -1548.5999755859375,
        -3783.343994140625,
        935.0
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1548.5999755859375,
        -3782.516357421875,
        935.0
      ],
      "bbox_max": [
        -1548.549072265625,
        -3781.261474609375,
        935.0076904296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.18652649223804474,
        0.8080337643623352,
        0.5588284730911255
      ],
      "plane_d": 2245.948486328125,
      "bbox_min": [
        -1548.5999755859375,
        -3790.76806640625,
        935.7640380859375
      ],
      "bbox_max": [
        -1422.5,
        -3760.5185546875,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7601984739303589,
        0.19578887522220612,
        0.6194876432418823
      ],
      "plane_d": -1006.7376098632812,
      "bbox_min": [
        -1537.785888671875,
        -3783.766357421875,
        935.7640380859375
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.237060546875,
        940.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12309727072715759,
        0.06976791471242905,
        0.9899391531944275
      ],
      "plane_d": -851.690673828125,
      "bbox_min": [
        -1537.785888671875,
        -3783.481689453125,
        935.7640380859375
      ],
      "bbox_max": [
        -1535.498046875,
        -3781.237060546875,
        935.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1548.5999755859375,
        -3790.76806640625,
        935.903564453125
      ],
      "bbox_max": [
        -1422.5,
        -3760.5185546875,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1442.1644287109375,
        -3790.76806640625,
        996.9375
      ],
      "bbox_max": [
        -1437.5,
        -3784.442626953125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11559368669986725,
        0.2340877205133438,
        -0.9653190970420837
      ],
      "plane_d": 1618.04296875,
      "bbox_min": [
        -1548.546142578125,
        -3783.7412109375,
        941.0655517578125
      ],
      "bbox_max": [
        -1532.622314453125,
        -3760.5185546875,
        948.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7845215797424316,
        0.1797778606414795,
        -0.5934693217277527
      ],
      "plane_d": 36.3477783203125,
      "bbox_min": [
        -1535.9979248046875,
        -3783.671875,
        942.2769775390625
      ],
      "bbox_max": [
        -1533.484619140625,
        -3781.237060546875,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7845215797424316,
        0.1797778606414795,
        -0.5934693217277527
      ],
      "plane_d": 36.3477783203125,
      "bbox_min": [
        -1533.527099609375,
        -3783.7412109375,
        941.0655517578125
      ],
      "bbox_max": [
        -1532.622314453125,
        -3782.828857421875,
        942.4762573242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1548.5999755859375,
        -3783.766357421875,
        940.625
      ],
      "bbox_max": [
        -1532.299072265625,
        -3760.5185546875,
        950.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7845215797424316,
        0.1797778606414795,
        -0.5934693217277527
      ],
      "plane_d": 36.3477783203125,
      "bbox_min": [
        -1532.6265869140625,
        -3783.766357421875,
        940.625
      ],
      "bbox_max": [
        -1532.299072265625,
        -3783.5107421875,
        941.1296997070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9965564012527466,
        0.08291661739349365
      ],
      "plane_d": -3835.739501953125,
      "bbox_min": [
        -1548.5999755859375,
        -3791.635498046875,
        1006.5
      ],
      "bbox_max": [
        -1423.42724609375,
        -3764.542724609375,
        1015.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.8887569904327393,
        -0.4521545469760895,
        0.07528110593557358
      ],
      "plane_d": -3068.27587890625,
      "bbox_min": [
        -1451.5,
        -3767.80615234375,
        1006.5
      ],
      "bbox_max": [
        -1449.4796142578125,
        -3764.542724609375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1442.9525146484375,
        -3790.69970703125,
        1006.5
      ],
      "bbox_max": [
        -1435.861572265625,
        -3784.442626953125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1439.25146484375,
        -3784.442626953125,
        1006.5
      ],
      "bbox_max": [
        -1435.861572265625,
        -3784.442626953125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1006.5,
      "bbox_min": [
        -1625.731201171875,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06472378969192505,
        -0.042895738035440445,
        0.9969807863235474
      ],
      "plane_d": -994.1493530273438,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1561.5980224609375,
        -3782.512451171875,
        935.0035400390625
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3780.037109375,
        935.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1550.2620849609375,
        -3782.512451171875,
        935.0075073242188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3781.299560546875,
        935.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13288715481758118,
        0.9392994046211243,
        -0.31631872057914734
      ],
      "plane_d": 4057.22021484375,
      "bbox_min": [
        -1617.4271240234375,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        1002.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7955129742622375,
        0.6059363484382629
      ],
      "plane_d": 2398.28369140625,
      "bbox_min": [
        -1617.4271240234375,
        -3781.5595703125,
        940.625
      ],
      "bbox_max": [
        -1560.986328125,
        -3777.218017578125,
        1002.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7341867685317993,
        0.3785039484500885,
        -0.5636529326438904
      ],
      "plane_d": 3110.26513671875,
      "bbox_min": [
        -1604.1737060546875,
        -3781.5595703125,
        940.625
      ],
      "bbox_max": [
        -1560.986328125,
        -3777.218017578125,
        1002.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8016875982284546,
        0.3298177421092987,
        -0.49851512908935547
      ],
      "plane_d": 2970.04296875,
      "bbox_min": [
        -1561.645751953125,
        -3781.5595703125,
        944.5693969726562
      ],
      "bbox_max": [
        -1560.986328125,
        -3780.037109375,
        945.6199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14578033983707428,
        0.9289018511772156,
        0.3404252529144287
      ],
      "plane_d": 3420.32958984375,
      "bbox_min": [
        -1580.4627685546875,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7348045706748962,
        0.3407658636569977,
        0.5864648222923279
      ],
      "plane_d": 1886.70458984375,
      "bbox_min": [
        -1564.799072265625,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1557.4801025390625,
        -3780.037109375,
        940.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1561.5980224609375,
        -3781.829345703125,
        935.7698364257812
      ],
      "bbox_max": [
        -1557.4801025390625,
        -3780.037109375,
        936.018310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11559368669986725,
        0.2340877205133438,
        -0.9653190970420837
      ],
      "plane_d": 1976.0472412109375,
      "bbox_min": [
        -1561.59619140625,
        -3771.328369140625,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1437956988811493,
        0.26793181896209717,
        -0.9526464939117432
      ],
      "plane_d": 2135.2509765625,
      "bbox_min": [
        -1558.483642578125,
        -3768.47509765625,
        947.7540893554688
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3760.5185546875,
        949.9918823242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11071637272834778,
        0.9938520789146423
      ],
      "plane_d": -1347.8997802734375,
      "bbox_min": [
        -1561.59619140625,
        -3771.328369140625,
        936.1071166992188
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3768.878662109375,
        936.3800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9965564012527466,
        0.08291661739349365
      ],
      "plane_d": -3835.739501953125,
      "bbox_min": [
        -1625.731201171875,
        -3776.648681640625,
        1006.5
      ],
      "bbox_max": [
        -1548.5999755859375,
        -3764.542724609375,
        1015.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7722785472869873,
        -0.6292640566825867,
        -0.08725089579820633
      ],
      "plane_d": -1033.1300048828125,
      "bbox_min": [
        -1625.731201171875,
        -3776.648681640625,
        1006.5
      ],
      "bbox_max": [
        -1616.40869140625,
        -3764.542724609375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9371005892753601,
        -0.34854570031166077,
        0.01893201470375061
      ],
      "plane_d": 183.4063720703125,
      "bbox_min": [
        -1617.6224365234375,
        -3767.80615234375,
        1006.5
      ],
      "bbox_max": [
        -1616.40869140625,
        -3764.542724609375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1006.5,
      "bbox_min": [
        -1578.4940185546875,
        -3829.24462890625,
        935.0
      ],
      "bbox_max": [
        -1422.5,
        -3780.212890625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        -0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": -3093.841796875,
      "bbox_min": [
        -1564.799072265625,
        -3809.557373046875,
        935.0
      ],
      "bbox_max": [
        -1437.5,
        -3781.266357421875,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1445.92724609375,
        -3797.0,
        996.9375
      ],
      "bbox_max": [
        -1441.2779541015625,
        -3790.69970703125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7622888088226318,
        0.19813089072704315,
        0.6161656379699707
      ],
      "plane_d": -997.9542846679688,
      "bbox_min": [
        -1564.799072265625,
        -3796.509521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7601984739303589,
        0.19578887522220612,
        0.6194876432418823
      ],
      "plane_d": -1006.7376098632812,
      "bbox_min": [
        -1564.799072265625,
        -3795.259521484375,
        935.0
      ],
      "bbox_max": [
        -1532.299072265625,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07857740670442581,
        0.10855977982282639,
        0.9909794926643372
      ],
      "plane_d": -394.3914794921875,
      "bbox_min": [
        -1564.799072265625,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14920414984226227,
        -0.0001315796107519418,
        0.9888064861297607
      ],
      "plane_d": -693.981689453125,
      "bbox_min": [
        -1558.49560546875,
        -3791.509521484375,
        935.0
      ],
      "bbox_max": [
        -1548.5501708984375,
        -3782.384521484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7348045706748962,
        0.3407658636569977,
        0.5864648222923279
      ],
      "plane_d": 1886.70458984375,
      "bbox_min": [
        -1564.799072265625,
        -3787.759521484375,
        936.018310546875
      ],
      "bbox_max": [
        -1558.49560546875,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8016875982284546,
        0.3298177421092987,
        -0.49851512908935547
      ],
      "plane_d": 2970.04296875,
      "bbox_min": [
        -1564.799072265625,
        -3787.759521484375,
        940.625
      ],
      "bbox_max": [
        -1558.49560546875,
        -3781.266357421875,
        945.5963134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7341867685317993,
        0.3785039484500885,
        -0.5636529326438904
      ],
      "plane_d": 3110.26513671875,
      "bbox_min": [
        -1564.799072265625,
        -3786.509521484375,
        940.625
      ],
      "bbox_max": [
        -1561.645751953125,
        -3781.266357421875,
        944.5693969726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7752121090888977,
        0.6316543817520142,
        0.007677671033889055
      ],
      "plane_d": 1288.0252685546875,
      "bbox_min": [
        -1448.6239013671875,
        -3829.24462890625,
        1006.5
      ],
      "bbox_max": [
        -1423.42724609375,
        -3790.63916015625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1432.6024169921875,
        -3809.557373046875,
        1006.5
      ],
      "bbox_max": [
        -1423.42724609375,
        -3809.557373046875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        -0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": -3093.841796875,
      "bbox_min": [
        -1446.75146484375,
        -3809.557373046875,
        1006.5
      ],
      "bbox_max": [
        -1424.0,
        -3790.63916015625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7752224206924438,
        -0.6316627860069275,
        -0.005687238648533821
      ],
      "plane_d": -3497.87939453125,
      "bbox_min": [
        -1446.75146484375,
        -3809.557373046875,
        1006.5
      ],
      "bbox_max": [
        -1424.0,
        -3790.63916015625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1439.25146484375,
        -3809.557373046875,
        1006.5
      ],
      "bbox_max": [
        -1424.0,
        -3798.801025390625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8324819207191467,
        0.5529500842094421,
        -0.034930527210235596
      ],
      "plane_d": 950.3607177734375,
      "bbox_min": [
        -1426.301025390625,
        -3801.92724609375,
        1006.5
      ],
      "bbox_max": [
        -1424.0,
        -3798.801025390625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1006.5,
      "bbox_min": [
        -1667.8399658203125,
        -3855.5419921875,
        935.0
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1667.8399658203125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3777.218017578125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7002964615821838,
        0.3830340504646301,
        0.6023868322372437
      ],
      "plane_d": 1966.7952880859375,
      "bbox_min": [
        -1646.4200439453125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1535.30810546875,
        -3777.218017578125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.028995314612984657,
        0.06643924117088318,
        0.9973690509796143
      ],
      "plane_d": -725.2152099609375,
      "bbox_min": [
        -1646.4200439453125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3777.218017578125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06817515194416046,
        0.20299293100833893,
        0.9768040180206299
      ],
      "plane_d": -246.17001342773438,
      "bbox_min": [
        -1586.069091796875,
        -3821.401123046875,
        935.0
      ],
      "bbox_max": [
        -1574.5142822265625,
        -3818.942138671875,
        935.751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7955129742622375,
        0.6059363484382629
      ],
      "plane_d": 2398.28369140625,
      "bbox_min": [
        -1646.4200439453125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3777.218017578125,
        1006.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03280504792928696,
        0.12446453422307968,
        0.9916815757751465
      ],
      "plane_d": -504.6941223144531,
      "bbox_min": [
        -1588.3330078125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3787.759521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06817515194416046,
        0.20299293100833893,
        0.9768040180206299
      ],
      "plane_d": -246.17001342773438,
      "bbox_min": [
        -1583.04052734375,
        -3825.248291015625,
        935.6671142578125
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3818.67724609375,
        936.83740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -935.0,
      "bbox_min": [
        -1588.3330078125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3787.759521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02321176417171955,
        -0.196211040019989,
        0.9802868962287903
      ],
      "plane_d": -1626.1278076171875,
      "bbox_min": [
        -1588.3330078125,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3787.759521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10578218847513199,
        -0.11477456986904144,
        0.9877434372901917
      ],
      "plane_d": -1194.899169921875,
      "bbox_min": [
        -1566.3829345703125,
        -3800.6796875,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3787.759521484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09262727946043015,
        -0.11491353064775467,
        0.9890475273132324
      ],
      "plane_d": -1217.148681640625,
      "bbox_min": [
        -1566.3829345703125,
        -3800.6796875,
        935.0
      ],
      "bbox_max": [
        -1558.49560546875,
        -3787.759521484375,
        936.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044715821743011475,
        0.04851704463362694,
        0.9978209733963013
      ],
      "plane_d": -818.2548217773438,
      "bbox_min": [
        -1558.5078125,
        -3800.6796875,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3791.509521484375,
        935.96533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1331440955400467,
        0.04322949796915054,
        0.9901533722877502
      ],
      "plane_d": -968.0697021484375,
      "bbox_min": [
        -1548.55810546875,
        -3797.843505859375,
        935.0
      ],
      "bbox_max": [
        -1542.16259765625,
        -3791.509521484375,
        935.96533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5424452424049377,
        0.2927165925502777,
        0.7874453663825989
      ],
      "plane_d": -461.12457275390625,
      "bbox_min": [
        -1577.7279052734375,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3793.9228515625,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1331440955400467,
        0.04322949796915054,
        0.9901533722877502
      ],
      "plane_d": -968.0697021484375,
      "bbox_min": [
        -1577.7279052734375,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3793.9228515625,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06817515194416046,
        0.20299293100833893,
        0.9768040180206299
      ],
      "plane_d": -246.17001342773438,
      "bbox_min": [
        -1577.7279052734375,
        -3827.426513671875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3795.259521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5255221724510193,
        0.7500509023666382,
        0.4015595018863678
      ],
      "plane_d": 1666.752197265625,
      "bbox_min": [
        -1574.72021484375,
        -3827.426513671875,
        936.5
      ],
      "bbox_max": [
        -1562.9969482421875,
        -3818.67724609375,
        942.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3657768666744232,
        0.7139313817024231,
        0.5970839858055115
      ],
      "plane_d": 1595.396240234375,
      "bbox_min": [
        -1562.9969482421875,
        -3818.67724609375,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3795.259521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.383934885263443,
        0.7197182178497314,
        0.5784459114074707
      ],
      "plane_d": 1606.790283203125,
      "bbox_min": [
        -1558.5078125,
        -3818.50048828125,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3795.259521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.044715821743011475,
        0.04851704463362694,
        0.9978209733963013
      ],
      "plane_d": -818.2548217773438,
      "bbox_min": [
        -1558.5078125,
        -3810.502685546875,
        935.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3795.259521484375,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7400335073471069,
        0.2647237479686737,
        -0.618281364440918
      ],
      "plane_d": 450.6494140625,
      "bbox_min": [
        -1540.313720703125,
        -3810.502685546875,
        941.0
      ],
      "bbox_max": [
        -1537.7236328125,
        -3803.261962890625,
        943.1204223632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7400335073471069,
        0.2647237479686737,
        -0.618281364440918
      ],
      "plane_d": 450.6494140625,
      "bbox_min": [
        -1539.515869140625,
        -3803.320068359375,
        936.7704467773438
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.259521484375,
        945.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7400335073471069,
        0.2647237479686737,
        0.618281364440918
      ],
      "plane_d": -712.9560546875,
      "bbox_min": [
        -1538.4215087890625,
        -3803.261962890625,
        936.7704467773438
      ],
      "bbox_max": [
        -1535.30810546875,
        -3795.334716796875,
        941.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13499628007411957,
        0.9899726510047913,
        0.04159548878669739
      ],
      "plane_d": 3556.504638671875,
      "bbox_min": [
        -1662.960693359375,
        -3850.810546875,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13511157035827637,
        0.990818202495575,
        0.004906512796878815
      ],
      "plane_d": 4011.02783203125,
      "bbox_min": [
        -1662.960693359375,
        -3850.810546875,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844279170036316,
        -0.37435460090637207,
        0.6256332993507385
      ],
      "plane_d": -972.0638427734375,
      "bbox_min": [
        -1609.7900390625,
        -3850.810546875,
        1006.5
      ],
      "bbox_max": [
        -1533.551025390625,
        -3834.38671875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16493429243564606,
        0.9859719276428223,
        0.025613537058234215
      ],
      "plane_d": 4017.305419921875,
      "bbox_min": [
        -1539.7806396484375,
        -3844.2958984375,
        1006.5
      ],
      "bbox_max": [
        -1533.551025390625,
        -3843.25390625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7731084823608398,
        0.6299402713775635,
        -0.07401607930660248
      ],
      "plane_d": 3738.63037109375,
      "bbox_min": [
        -1662.960693359375,
        -3835.33349609375,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1662.960693359375,
        -3816.10888671875,
        1006.5
      ],
      "bbox_max": [
        -1645.0439453125,
        -3791.9482421875,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7002964615821838,
        0.3830340504646301,
        0.6023868322372437
      ],
      "plane_d": 1966.7952880859375,
      "bbox_min": [
        -1649.7457275390625,
        -3835.33349609375,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7955129742622375,
        0.6059363484382629
      ],
      "plane_d": 2398.28369140625,
      "bbox_min": [
        -1649.7457275390625,
        -3835.33349609375,
        1006.5
      ],
      "bbox_max": [
        -1587.039306640625,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844279170036316,
        -0.37435460090637207,
        0.6256332993507385
      ],
      "plane_d": -972.0638427734375,
      "bbox_min": [
        -1649.7457275390625,
        -3835.33349609375,
        1006.5
      ],
      "bbox_max": [
        -1587.039306640625,
        -3781.407470703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7722785472869873,
        -0.6292640566825867,
        -0.08725089579820633
      ],
      "plane_d": -1033.1300048828125,
      "bbox_min": [
        -1649.7457275390625,
        -3801.92724609375,
        1006.5
      ],
      "bbox_max": [
        -1629.665283203125,
        -3781.407470703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1649.7457275390625,
        -3796.7197265625,
        1006.5
      ],
      "bbox_max": [
        -1640.2099609375,
        -3781.407470703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8267645835876465,
        0.5491524934768677,
        -0.12203191965818405
      ],
      "plane_d": 3568.25634765625,
      "bbox_min": [
        -1644.0,
        -3801.92724609375,
        1006.5
      ],
      "bbox_max": [
        -1640.801025390625,
        -3798.801025390625,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7722785472869873,
        -0.6292640566825867,
        -0.08725089579820633
      ],
      "plane_d": -1033.1300048828125,
      "bbox_min": [
        -1633.9803466796875,
        -3787.881591796875,
        1006.5
      ],
      "bbox_max": [
        -1624.8275146484375,
        -3776.579345703125,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16495898365974426,
        0.9861195683479309,
        0.018887745216488838
      ],
      "plane_d": 3521.101318359375,
      "bbox_min": [
        -1457.7857666015625,
        -3833.96435546875,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3829.22021484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7752121090888977,
        0.6316543817520142,
        0.007677671033889055
      ],
      "plane_d": 1288.0252685546875,
      "bbox_min": [
        -1451.55615234375,
        -3832.922119140625,
        1006.5
      ],
      "bbox_max": [
        -1448.5596923828125,
        -3829.22021484375,
        1015.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9965570569038391,
        -0.08290934562683105
      ],
      "plane_d": 3835.734619140625,
      "bbox_min": [
        -1655.419921875,
        -3864.266357421875,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3707.0,
        1110.625
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.16495898365974426,
        0.9861195683479309,
        0.018887745216488838
      ],
      "plane_d": 3521.101318359375,
      "bbox_min": [
        -1655.419921875,
        -3864.266357421875,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585227727890015,
        -0.5127601623535156,
        -0.003964266274124384
      ],
      "plane_d": -3228.901123046875,
      "bbox_min": [
        -1538.0,
        -3864.266357421875,
        1066.718505859375
      ],
      "bbox_max": [
        -1443.5,
        -3835.49853515625,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457260131835938,
        0.5051171779632568,
        -0.17205862700939178
      ],
      "plane_d": 893.42138671875,
      "bbox_min": [
        -1467.840087890625,
        -3851.0,
        1092.9375
      ],
      "bbox_max": [
        -1443.5,
        -3835.49853515625,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1538.0,
        -3864.266357421875,
        1098.9375
      ],
      "bbox_max": [
        -1506.6107177734375,
        -3848.2197265625,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8419256210327148,
        0.5028473734855652,
        -0.195718452334404
      ],
      "plane_d": 3427.20556640625,
      "bbox_min": [
        -1515.5,
        -3864.266357421875,
        1098.9375
      ],
      "bbox_max": [
        -1506.6107177734375,
        -3848.2197265625,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585206866264343,
        -0.5127589106559753,
        -0.0045297350734472275
      ],
      "plane_d": -681.1605224609375,
      "bbox_min": [
        -1508.6947021484375,
        -3864.266357421875,
        1098.9375
      ],
      "bbox_max": [
        -1506.6107177734375,
        -3860.777099609375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06845475733280182,
        -0.9976541996002197
      ],
      "plane_d": 1327.80126953125,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3837.833251953125,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.012781751342117786,
        0.9999182820320129
      ],
      "plane_d": -1024.11767578125,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3837.833251953125,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527782082557678,
        0.07574823498725891,
        -0.7537524700164795
      ],
      "plane_d": 2060.105224609375,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3837.833251953125,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6542726755142212,
        0.03374145179986954,
        0.7555055618286133
      ],
      "plane_d": 285.54833984375,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3837.833251953125,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6526246666908264,
        0.07877631485462189,
        -0.7535751461982727
      ],
      "plane_d": 137.96136474609375,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1484.6522216796875,
        -3839.463623046875,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6542022228240967,
        0.036791086196899414,
        0.7554242610931396
      ],
      "plane_d": -1640.786865234375,
      "bbox_min": [
        -1488.97998046875,
        -3850.5,
        1070.070068359375
      ],
      "bbox_max": [
        -1484.6568603515625,
        -3839.575439453125,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.13499628007411957,
        0.9899726510047913,
        0.04159548878669739
      ],
      "plane_d": 3556.504638671875,
      "bbox_min": [
        -1655.419921875,
        -3850.5,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13511157035827637,
        0.990818202495575,
        0.004906512796878815
      ],
      "plane_d": 4011.02783203125,
      "bbox_min": [
        -1655.419921875,
        -3850.5,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16493429243564606,
        0.9859719276428223,
        0.025613537058234215
      ],
      "plane_d": 4017.305419921875,
      "bbox_min": [
        -1634.578857421875,
        -3850.5,
        1015.0
      ],
      "bbox_max": [
        -1528.5,
        -3830.396240234375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844279170036316,
        -0.37435460090637207,
        0.6256332993507385
      ],
      "plane_d": -972.0638427734375,
      "bbox_min": [
        -1634.578857421875,
        -3850.5,
        1015.0
      ],
      "bbox_max": [
        -1593.5,
        -3830.396240234375,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1029.0,
      "bbox_min": [
        -1634.578857421875,
        -3831.45458984375,
        1029.0
      ],
      "bbox_max": [
        -1626.8170166015625,
        -3830.396240234375,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06845475733280182,
        -0.9976541996002197
      ],
      "plane_d": 1327.80126953125,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.012781751342117786,
        0.9999182820320129
      ],
      "plane_d": -1024.11767578125,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6526246666908264,
        0.07877631485462189,
        -0.7535751461982727
      ],
      "plane_d": 59.646484375,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6542022228240967,
        0.036791086196899414,
        0.7554242610931396
      ],
      "plane_d": -1719.2911376953125,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6644691824913025,
        0.03827065974473953,
        0.7463350892066956
      ],
      "plane_d": -1720.38720703125,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6628387570381165,
        0.07974305748939514,
        -0.7445037364959717
      ],
      "plane_d": 37.2275390625,
      "bbox_min": [
        -1608.97998046875,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3834.2890625,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527782082557678,
        0.07574823498725891,
        -0.7537524700164795
      ],
      "plane_d": 2138.4384765625,
      "bbox_min": [
        -1597.9189453125,
        -3850.5,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3835.5869140625,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6542726755142212,
        0.03374145179986954,
        0.7555055618286133
      ],
      "plane_d": 364.06103515625,
      "bbox_min": [
        -1597.91796875,
        -3850.5,
        1070.070068359375
      ],
      "bbox_max": [
        -1593.5,
        -3835.6142578125,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8324819207191467,
        0.5529500842094421,
        -0.034930527210235596
      ],
      "plane_d": 950.3607177734375,
      "bbox_min": [
        -1655.419921875,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1435.3814697265625,
        -3809.557373046875,
        1015.0
      ],
      "bbox_max": [
        -1424.25146484375,
        -3809.557373046875,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8267645835876465,
        0.5491524934768677,
        -0.12203191965818405
      ],
      "plane_d": 3568.25634765625,
      "bbox_min": [
        -1655.419921875,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1029.0,
      "bbox_min": [
        -1655.419921875,
        -3831.45458984375,
        1015.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3796.072265625,
        1058.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1655.419921875,
        -3820.7451171875,
        1015.0
      ],
      "bbox_max": [
        -1632.022705078125,
        -3796.072265625,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8647323250770569,
        -0.46597516536712646,
        -0.18736396729946136
      ],
      "plane_d": -173.0313720703125,
      "bbox_min": [
        -1640.757568359375,
        -3820.7451171875,
        1027.0
      ],
      "bbox_max": [
        -1632.022705078125,
        -3807.20947265625,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9647637605667114,
        -0.26311737298965454
      ],
      "plane_d": 3943.8056640625,
      "bbox_min": [
        -1640.757568359375,
        -3807.7548828125,
        1027.0
      ],
      "bbox_max": [
        -1635.5228271484375,
        -3807.20947265625,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9647637605667114,
        -0.26311737298965454
      ],
      "plane_d": 3943.8056640625,
      "bbox_min": [
        -1643.25,
        -3807.7548828125,
        1027.0
      ],
      "bbox_max": [
        -1638.73876953125,
        -3807.20947265625,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9647637605667114,
        -0.26311737298965454
      ],
      "plane_d": 3943.8056640625,
      "bbox_min": [
        -1642.522705078125,
        -3814.7451171875,
        1029.0
      ],
      "bbox_max": [
        -1627.8104248046875,
        -3802.19921875,
        1049.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1048.9998779296875,
      "bbox_min": [
        -1638.75,
        -3814.7451171875,
        1029.0
      ],
      "bbox_max": [
        -1627.8104248046875,
        -3802.292724609375,
        1049.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8029372692108154,
        0.43267589807510376,
        -0.4099797010421753
      ],
      "plane_d": 3382.37890625,
      "bbox_min": [
        -1635.5228271484375,
        -3813.70458984375,
        1029.0
      ],
      "bbox_max": [
        -1631.0057373046875,
        -3807.005859375,
        1031.796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1038.9998779296875,
      "bbox_min": [
        -1629.5,
        -3829.61767578125,
        1038.5059814453125
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3817.814453125,
        1058.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585029244422913,
        -0.462618350982666,
        0.22126200795173645
      ],
      "plane_d": -611.5697021484375,
      "bbox_min": [
        -1619.0,
        -3829.61767578125,
        1038.5059814453125
      ],
      "bbox_max": [
        -1618.938720703125,
        -3829.451171875,
        1039.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43078649044036865,
        -0.22384576499462128,
        0.8742517828941345
      ],
      "plane_d": -2479.538818359375,
      "bbox_min": [
        -1627.5,
        -3828.830078125,
        1055.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3818.404296875,
        1058.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1055.0,
      "bbox_min": [
        -1627.5,
        -3828.830078125,
        1055.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3818.404296875,
        1058.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001361846924,
        0.8320502638816833
      ],
      "plane_d": -3001.66552734375,
      "bbox_min": [
        -1627.5,
        -3828.830078125,
        1055.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3818.404296875,
        1058.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188361525535583,
        0.4254845678806305,
        0.3853183090686798
      ],
      "plane_d": -111.90097045898438,
      "bbox_min": [
        -1627.5,
        -3828.830078125,
        1055.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3818.404296875,
        1058.619384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8188361525535583,
        -0.4254845678806305,
        -0.3853183090686798
      ],
      "plane_d": 104.531494140625,
      "bbox_min": [
        -1625.25,
        -3828.830078125,
        1055.0
      ],
      "bbox_max": [
        -1618.5328369140625,
        -3818.404296875,
        1056.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001361846924,
        -0.8320502638816833
      ],
      "plane_d": 2996.86181640625,
      "bbox_min": [
        -1625.25,
        -3820.169921875,
        1055.0
      ],
      "bbox_max": [
        -1622.779541015625,
        -3818.404296875,
        1056.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7752121090888977,
        0.6316543817520142,
        0.007677671033889055
      ],
      "plane_d": 1288.0252685546875,
      "bbox_min": [
        -1644.6898193359375,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1424.2244873046875,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1432.51806640625,
        -3809.557373046875,
        1015.0
      ],
      "bbox_max": [
        -1431.3690185546875,
        -3809.557373046875,
        1037.1551513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1448.2874755859375,
        -3784.442626953125,
        1015.0
      ],
      "bbox_max": [
        -1424.25146484375,
        -3758.943359375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1440.2041015625,
        -3786.03759765625,
        1015.0
      ],
      "bbox_max": [
        -1435.9239501953125,
        -3784.442626953125,
        1070.3173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1440.2041015625,
        -3786.03759765625,
        1015.0
      ],
      "bbox_max": [
        -1439.25146484375,
        -3784.442626953125,
        1024.710205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6844279170036316,
        -0.37435460090637207,
        0.6256332993507385
      ],
      "plane_d": -972.0638427734375,
      "bbox_min": [
        -1616.0,
        -3833.1474609375,
        1026.124267578125
      ],
      "bbox_max": [
        -1614.2972412109375,
        -3831.0146484375,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8029372692108154,
        0.43267589807510376,
        -0.4099797010421753
      ],
      "plane_d": 3382.37890625,
      "bbox_min": [
        -1635.2513427734375,
        -3813.929443359375,
        1029.7464599609375
      ],
      "bbox_max": [
        -1627.792724609375,
        -3807.005859375,
        1049.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585029244422913,
        -0.462618350982666,
        0.22126200795173645
      ],
      "plane_d": -611.5697021484375,
      "bbox_min": [
        -1618.976318359375,
        -3831.97509765625,
        1029.0
      ],
      "bbox_max": [
        -1616.651611328125,
        -3827.30859375,
        1039.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001361846924,
        0.8320502638816833
      ],
      "plane_d": -3001.66552734375,
      "bbox_min": [
        -1623.778564453125,
        -3826.16943359375,
        1055.0
      ],
      "bbox_max": [
        -1617.751953125,
        -3818.18603515625,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.0,
      "bbox_min": [
        -1623.778564453125,
        -3826.16943359375,
        1055.0
      ],
      "bbox_max": [
        -1617.751953125,
        -3818.18603515625,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188361525535583,
        0.4254845678806305,
        0.3853183090686798
      ],
      "plane_d": -111.90097045898438,
      "bbox_min": [
        -1623.778564453125,
        -3826.16943359375,
        1055.0
      ],
      "bbox_max": [
        -1617.751953125,
        -3818.18603515625,
        1058.75390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8188361525535583,
        -0.4254845678806305,
        -0.3853183090686798
      ],
      "plane_d": 104.531494140625,
      "bbox_min": [
        -1623.778564453125,
        -3826.16943359375,
        1055.0
      ],
      "bbox_max": [
        -1617.751953125,
        -3818.18603515625,
        1057.3983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001361846924,
        -0.8320502638816833
      ],
      "plane_d": 2996.86181640625,
      "bbox_min": [
        -1623.778564453125,
        -3820.169921875,
        1055.0
      ],
      "bbox_max": [
        -1622.10693359375,
        -3818.18603515625,
        1056.3226318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7722785472869873,
        -0.6292640566825867,
        -0.08725089579820633
      ],
      "plane_d": -1033.1300048828125,
      "bbox_min": [
        -1644.6898193359375,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1426.75,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9371005892753601,
        -0.34854570031166077,
        0.01893201470375061
      ],
      "plane_d": 183.4063720703125,
      "bbox_min": [
        -1644.6898193359375,
        -3798.6962890625,
        1015.0
      ],
      "bbox_max": [
        -1604.478759765625,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1644.6898193359375,
        -3798.6962890625,
        1015.0
      ],
      "bbox_max": [
        -1633.980712890625,
        -3787.8818359375,
        1021.5487670898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7955129742622375,
        0.6059363484382629
      ],
      "plane_d": 2398.28369140625,
      "bbox_min": [
        -1640.2099609375,
        -3792.869873046875,
        1015.0
      ],
      "bbox_max": [
        -1633.980712890625,
        -3787.8818359375,
        1021.5487060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.285795122385025,
        -0.1473156064748764,
        -0.9468998312950134
      ],
      "plane_d": 958.275146484375,
      "bbox_min": [
        -1630.25,
        -3796.5625,
        1068.9305419921875
      ],
      "bbox_max": [
        -1604.478759765625,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3169591426849365,
        -0.0631350576877594,
        -0.94633549451828
      ],
      "plane_d": 1324.2353515625,
      "bbox_min": [
        -1615.4000244140625,
        -3758.506103515625,
        1108.9100341796875
      ],
      "bbox_max": [
        -1610.251220703125,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -2039.6798095703125,
      "bbox_min": [
        -1607.1915283203125,
        -3762.379638671875,
        1068.9305419921875
      ],
      "bbox_max": [
        -1604.478759765625,
        -3759.71728515625,
        1073.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -657.8333740234375,
      "bbox_min": [
        -1607.1915283203125,
        -3762.379638671875,
        1070.3270263671875
      ],
      "bbox_max": [
        -1606.572021484375,
        -3759.91455078125,
        1070.7210693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        -0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": -3093.841796875,
      "bbox_min": [
        -1642.28857421875,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1426.75,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1456.8182373046875,
        -3809.557373046875,
        1015.0
      ],
      "bbox_max": [
        -1426.75,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8362694978713989,
        -0.44244563579559326,
        -0.323875367641449
      ],
      "plane_d": -2513.2158203125,
      "bbox_min": [
        -1433.162353515625,
        -3796.5625,
        1110.1031494140625
      ],
      "bbox_max": [
        -1426.75,
        -3784.442626953125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8362694978713989,
        -0.44244563579559326,
        -0.323875367641449
      ],
      "plane_d": -2513.2158203125,
      "bbox_min": [
        -1440.3782958984375,
        -3784.442626953125,
        1109.5035400390625
      ],
      "bbox_max": [
        -1432.960205078125,
        -3770.5146484375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372832536697388,
        -0.5000746846199036,
        -0.2210930436849594
      ],
      "plane_d": -2853.089599609375,
      "bbox_min": [
        -1456.8182373046875,
        -3770.8037109375,
        1082.303466796875
      ],
      "bbox_max": [
        -1440.0968017578125,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9893783330917358,
        -0.1453632116317749
      ],
      "plane_d": -3568.254150390625,
      "bbox_min": [
        -1456.8182373046875,
        -3770.8037109375,
        1084.05224609375
      ],
      "bbox_max": [
        -1440.0968017578125,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8362694978713989,
        -0.44244563579559326,
        -0.323875367641449
      ],
      "plane_d": -2513.2158203125,
      "bbox_min": [
        -1456.8182373046875,
        -3769.7392578125,
        1108.040283203125
      ],
      "bbox_max": [
        -1440.5816650390625,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797518849372864,
        -0.19515667855739594,
        -0.04472288116812706
      ],
      "plane_d": -2101.4150390625,
      "bbox_min": [
        -1447.266845703125,
        -3758.506103515625,
        1108.9100341796875
      ],
      "bbox_max": [
        -1446.884521484375,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8560588955879211,
        0.511288583278656,
        -0.0758100226521492
      ],
      "plane_d": 758.0784912109375,
      "bbox_min": [
        -1456.8182373046875,
        -3757.181884765625,
        1108.040283203125
      ],
      "bbox_max": [
        -1456.362548828125,
        -3756.587158203125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8362694978713989,
        -0.44244563579559326,
        -0.323875367641449
      ],
      "plane_d": -2513.2158203125,
      "bbox_min": [
        -1440.9415283203125,
        -3770.8037109375,
        1109.4627685546875
      ],
      "bbox_max": [
        -1440.0968017578125,
        -3769.568359375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2573006749153137,
        3.118294216619688e-06,
        0.9663314819335938
      ],
      "plane_d": -1458.0789794921875,
      "bbox_min": [
        -1642.28857421875,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1456.008056640625,
        -3757.489990234375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6644691824913025,
        0.03827065974473953,
        0.7463350892066956
      ],
      "plane_d": -1640.65087890625,
      "bbox_min": [
        -1642.28857421875,
        -3840.087890625,
        1015.0
      ],
      "bbox_max": [
        -1456.008056640625,
        -3757.489990234375,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6542022228240967,
        0.036791086196899414,
        0.7554242610931396
      ],
      "plane_d": -1640.786865234375,
      "bbox_min": [
        -1488.0538330078125,
        -3840.087890625,
        1067.475830078125
      ],
      "bbox_max": [
        -1474.567626953125,
        -3759.703369140625,
        1073.2818603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6628387570381165,
        0.07974305748939514,
        -0.7445037364959717
      ],
      "plane_d": 116.7681884765625,
      "bbox_min": [
        -1488.0538330078125,
        -3840.087890625,
        1067.475830078125
      ],
      "bbox_max": [
        -1474.567626953125,
        -3759.703369140625,
        1073.2818603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6526246666908264,
        0.07877631485462189,
        -0.7535751461982727
      ],
      "plane_d": 137.96136474609375,
      "bbox_min": [
        -1487.873046875,
        -3840.0546875,
        1067.475830078125
      ],
      "bbox_max": [
        -1474.567626953125,
        -3759.703369140625,
        1073.2818603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.012781751342117786,
        0.9999182820320129
      ],
      "plane_d": -1024.11767578125,
      "bbox_min": [
        -1484.6568603515625,
        -3839.575439453125,
        1067.475830078125
      ],
      "bbox_max": [
        -1474.567626953125,
        -3759.703369140625,
        1073.2818603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06845475733280182,
        -0.9976541996002197
      ],
      "plane_d": 1327.80126953125,
      "bbox_min": [
        -1484.6522216796875,
        -3839.463623046875,
        1067.475830078125
      ],
      "bbox_max": [
        -1474.567626953125,
        -3759.77880859375,
        1073.2672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6645448207855225,
        0.03517347574234009,
        0.7464200854301453
      ],
      "plane_d": 315.92047119140625,
      "bbox_min": [
        -1479.57861328125,
        -3838.4306640625,
        1067.5540771484375
      ],
      "bbox_max": [
        -1474.567626953125,
        -3768.151611328125,
        1073.2672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542726755142212,
        0.03374145179986954,
        0.7555055618286133
      ],
      "plane_d": 285.54833984375,
      "bbox_min": [
        -1479.57861328125,
        -3838.4306640625,
        1067.5540771484375
      ],
      "bbox_max": [
        -1474.567626953125,
        -3784.79150390625,
        1073.2672119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.662999153137207,
        0.07666803151369095,
        -0.7446839213371277
      ],
      "plane_d": 2069.00341796875,
      "bbox_min": [
        -1479.57861328125,
        -3838.322021484375,
        1067.5540771484375
      ],
      "bbox_max": [
        -1474.567626953125,
        -3784.79150390625,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527782082557678,
        0.07574823498725891,
        -0.7537524700164795
      ],
      "plane_d": 2060.105224609375,
      "bbox_min": [
        -1479.57861328125,
        -3838.322021484375,
        1067.5540771484375
      ],
      "bbox_max": [
        -1474.780029296875,
        -3790.5,
        1070.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1396.4610595703125,
      "bbox_min": [
        -1479.57861328125,
        -3790.5,
        1070.83544921875
      ],
      "bbox_max": [
        -1478.277587890625,
        -3784.79150390625,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1396.4610595703125,
      "bbox_min": [
        -1478.5570068359375,
        -3790.5,
        1071.2271728515625
      ],
      "bbox_max": [
        -1477.60498046875,
        -3781.84033203125,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1396.4610595703125,
      "bbox_min": [
        -1482.621337890625,
        -3790.5,
        1069.1136474609375
      ],
      "bbox_max": [
        -1475.194580078125,
        -3759.77880859375,
        1072.368896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1482.621337890625,
        -3790.5,
        1069.2884521484375
      ],
      "bbox_max": [
        -1475.5335693359375,
        -3759.77880859375,
        1072.368896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.654011607170105,
        -0.043993029743433,
        0.7552041411399841
      ],
      "plane_d": -9.16717529296875,
      "bbox_min": [
        -1477.745361328125,
        -3775.924072265625,
        1070.9346923828125
      ],
      "bbox_max": [
        -1475.5335693359375,
        -3759.77880859375,
        1072.368896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1482.621337890625,
        -3790.5,
        1072.2618408203125
      ],
      "bbox_max": [
        -1477.05859375,
        -3759.703369140625,
        1073.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.654011607170105,
        -0.043993029743433,
        0.7552041411399841
      ],
      "plane_d": -9.16717529296875,
      "bbox_min": [
        -1479.57861328125,
        -3790.5,
        1072.2618408203125
      ],
      "bbox_max": [
        -1477.05859375,
        -3759.703369140625,
        1073.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1482.621337890625,
        -3790.5,
        1069.08447265625
      ],
      "bbox_max": [
        -1476.95654296875,
        -3760.040771484375,
        1070.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1395.667236328125,
      "bbox_min": [
        -1478.748779296875,
        -3773.21533203125,
        1069.08447265625
      ],
      "bbox_max": [
        -1476.95654296875,
        -3760.040771484375,
        1069.2884521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1395.667236328125,
      "bbox_min": [
        -1484.215576171875,
        -3790.5,
        1068.1168212890625
      ],
      "bbox_max": [
        -1476.9906005859375,
        -3760.043212890625,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6542726755142212,
        0.03374145179986954,
        0.7555055618286133
      ],
      "plane_d": 364.06103515625,
      "bbox_min": [
        -1642.28857421875,
        -3836.036865234375,
        1015.0
      ],
      "bbox_max": [
        -1594.580078125,
        -3759.703369140625,
        1073.231201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.012781751342117786,
        0.9999182820320129
      ],
      "plane_d": -1024.11767578125,
      "bbox_min": [
        -1642.28857421875,
        -3836.036865234375,
        1015.0
      ],
      "bbox_max": [
        -1594.580078125,
        -3759.703369140625,
        1073.231201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.662999153137207,
        0.07666803151369095,
        -0.7446839213371277
      ],
      "plane_d": 2148.5634765625,
      "bbox_min": [
        -1642.28857421875,
        -3836.036865234375,
        1015.0
      ],
      "bbox_max": [
        -1594.580078125,
        -3760.05029296875,
        1073.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.06845475733280182,
        -0.9976541996002197
      ],
      "plane_d": 1327.80126953125,
      "bbox_min": [
        -1635.84228515625,
        -3836.001708984375,
        1037.3629150390625
      ],
      "bbox_max": [
        -1594.9688720703125,
        -3760.070068359375,
        1073.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527782082557678,
        0.07574823498725891,
        -0.7537524700164795
      ],
      "plane_d": 2138.4384765625,
      "bbox_min": [
        -1607.5379638671875,
        -3836.001708984375,
        1067.7418212890625
      ],
      "bbox_max": [
        -1594.9688720703125,
        -3768.153076171875,
        1073.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6644691824913025,
        0.03827065974473953,
        0.7463350892066956
      ],
      "plane_d": -1720.38720703125,
      "bbox_min": [
        -1607.5379638671875,
        -3834.722900390625,
        1067.8028564453125
      ],
      "bbox_max": [
        -1602.621337890625,
        -3768.153076171875,
        1073.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6542022228240967,
        0.036791086196899414,
        0.7554242610931396
      ],
      "plane_d": -1719.2911376953125,
      "bbox_min": [
        -1607.5379638671875,
        -3834.722900390625,
        1067.8028564453125
      ],
      "bbox_max": [
        -1602.621337890625,
        -3784.957763671875,
        1073.2198486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6628387570381165,
        0.07974305748939514,
        -0.7445037364959717
      ],
      "plane_d": 37.2275390625,
      "bbox_min": [
        -1607.5379638671875,
        -3834.696044921875,
        1067.8028564453125
      ],
      "bbox_max": [
        -1602.621337890625,
        -3784.957763671875,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6526246666908264,
        0.07877631485462189,
        -0.7535751461982727
      ],
      "plane_d": 59.646484375,
      "bbox_min": [
        -1607.2657470703125,
        -3834.696044921875,
        1067.8028564453125
      ],
      "bbox_max": [
        -1602.621337890625,
        -3790.5,
        1070.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -657.8333740234375,
      "bbox_min": [
        -1603.918212890625,
        -3790.5,
        1070.83544921875
      ],
      "bbox_max": [
        -1602.621337890625,
        -3784.957763671875,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -657.8333740234375,
      "bbox_min": [
        -1604.647705078125,
        -3790.5,
        1071.2158203125
      ],
      "bbox_max": [
        -1603.6429443359375,
        -3781.84033203125,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -627.0723876953125,
      "bbox_min": [
        -1635.84228515625,
        -3825.232421875,
        1037.3629150390625
      ],
      "bbox_max": [
        -1599.57861328125,
        -3760.070068359375,
        1072.368896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -2039.6798095703125,
      "bbox_min": [
        -1606.560546875,
        -3775.923583984375,
        1071.053466796875
      ],
      "bbox_max": [
        -1604.59033203125,
        -3760.57275390625,
        1072.368896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1048.9998779296875,
      "bbox_min": [
        -1635.84228515625,
        -3825.232421875,
        1037.3629150390625
      ],
      "bbox_max": [
        -1613.5,
        -3801.7548828125,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8647323250770569,
        -0.46597516536712646,
        -0.18736396729946136
      ],
      "plane_d": -173.0313720703125,
      "bbox_min": [
        -1628.909423828125,
        -3813.896484375,
        1042.3740234375
      ],
      "bbox_max": [
        -1624.75,
        -3808.25,
        1049.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1059.0,
      "bbox_min": [
        -1623.5966796875,
        -3825.232421875,
        1055.0
      ],
      "bbox_max": [
        -1613.5,
        -3814.169921875,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8188361525535583,
        -0.4254845678806305,
        -0.3853183090686798
      ],
      "plane_d": 104.531494140625,
      "bbox_min": [
        -1623.5966796875,
        -3825.232421875,
        1055.0
      ],
      "bbox_max": [
        -1613.5,
        -3814.169921875,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8188361525535583,
        0.4254845678806305,
        0.3853183090686798
      ],
      "plane_d": -111.90097045898438,
      "bbox_min": [
        -1623.5966796875,
        -3825.232421875,
        1055.0
      ],
      "bbox_max": [
        -1615.75,
        -3814.169921875,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1055.0,
      "bbox_min": [
        -1622.8076171875,
        -3825.232421875,
        1055.0
      ],
      "bbox_max": [
        -1615.75,
        -3818.5,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001361846924,
        0.8320502638816833
      ],
      "plane_d": -3001.66552734375,
      "bbox_min": [
        -1622.8076171875,
        -3825.232421875,
        1057.3983154296875
      ],
      "bbox_max": [
        -1615.75,
        -3818.5,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43078649044036865,
        -0.22384576499462128,
        0.8742517828941345
      ],
      "plane_d": -2479.538818359375,
      "bbox_min": [
        -1622.8076171875,
        -3820.47998046875,
        1058.75390625
      ],
      "bbox_max": [
        -1621.47119140625,
        -3818.5,
        1059.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7002964615821838,
        0.3830340504646301,
        0.6023868322372437
      ],
      "plane_d": 1966.7952880859375,
      "bbox_min": [
        -1642.28857421875,
        -3834.38671875,
        1015.0
      ],
      "bbox_max": [
        -1594.580078125,
        -3760.05029296875,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1029.0,
      "bbox_min": [
        -1642.28857421875,
        -3834.38671875,
        1015.0
      ],
      "bbox_max": [
        -1594.580078125,
        -3787.8818359375,
        1045.2935791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8615180253982544,
        0.464243084192276,
        0.20558424293994904
      ],
      "plane_d": 2952.9814453125,
      "bbox_min": [
        -1642.28857421875,
        -3832.978271484375,
        1017.0
      ],
      "bbox_max": [
        -1610.0400390625,
        -3792.869873046875,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9781474471092224,
        0.20791277289390564
      ],
      "plane_d": 3517.0830078125,
      "bbox_min": [
        -1642.28857421875,
        -3832.978271484375,
        1017.0
      ],
      "bbox_max": [
        -1610.0400390625,
        -3792.869873046875,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585029244422913,
        -0.462618350982666,
        0.22126200795173645
      ],
      "plane_d": -611.5697021484375,
      "bbox_min": [
        -1616.651611328125,
        -3832.978271484375,
        1017.0
      ],
      "bbox_max": [
        -1610.0400390625,
        -3823.17724609375,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.700296938419342,
        0.3830343186855316,
        0.6023860573768616
      ],
      "plane_d": -309.1671142578125,
      "bbox_min": [
        -1642.28857421875,
        -3804.30908203125,
        1019.4600219726562
      ],
      "bbox_max": [
        -1634.0,
        -3792.869873046875,
        1029.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1038.9998779296875,
      "bbox_min": [
        -1626.2486572265625,
        -3829.919921875,
        1029.0
      ],
      "bbox_max": [
        -1613.0181884765625,
        -3816.5048828125,
        1039.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585029244422913,
        -0.462618350982666,
        0.22126200795173645
      ],
      "plane_d": -611.5697021484375,
      "bbox_min": [
        -1617.82177734375,
        -3829.919921875,
        1029.0
      ],
      "bbox_max": [
        -1613.0181884765625,
        -3823.0,
        1039.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1605.22509765625,
        -3790.5,
        1068.1168212890625
      ],
      "bbox_max": [
        -1597.08740234375,
        -3760.05029296875,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1473.843505859375,
      "bbox_min": [
        -1605.22509765625,
        -3790.5,
        1068.1168212890625
      ],
      "bbox_max": [
        -1597.08740234375,
        -3760.05029296875,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1475.857421875,
      "bbox_min": [
        -1605.22509765625,
        -3790.5,
        1068.1168212890625
      ],
      "bbox_max": [
        -1597.9559326171875,
        -3760.05615234375,
        1071.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -627.0723876953125,
      "bbox_min": [
        -1605.22509765625,
        -3771.72607421875,
        1068.1168212890625
      ],
      "bbox_max": [
        -1603.6370849609375,
        -3760.05615234375,
        1069.1552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1605.25830078125,
        -3790.5,
        1072.27197265625
      ],
      "bbox_max": [
        -1599.57861328125,
        -3759.703369140625,
        1073.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -2039.6798095703125,
      "bbox_min": [
        -1605.25830078125,
        -3790.5,
        1072.27197265625
      ],
      "bbox_max": [
        -1602.621337890625,
        -3759.703369140625,
        1073.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1601.785400390625,
        -3836.3037109375,
        1068.85888671875
      ],
      "bbox_max": [
        -1456.008056640625,
        -3757.489990234375,
        1110.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -1961.212646484375,
      "bbox_min": [
        -1599.57861328125,
        -3790.5,
        1068.85888671875
      ],
      "bbox_max": [
        -1482.621337890625,
        -3759.703369140625,
        1073.16796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6641281843185425,
        -0.04989263042807579,
        0.7459520697593689
      ],
      "plane_d": -1973.91748046875,
      "bbox_min": [
        -1487.1915283203125,
        -3790.5,
        1068.85888671875
      ],
      "bbox_max": [
        -1482.621337890625,
        -3759.88916015625,
        1072.654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -548.9273681640625,
      "bbox_min": [
        -1486.845703125,
        -3778.966552734375,
        1068.85888671875
      ],
      "bbox_max": [
        -1484.215576171875,
        -3759.93994140625,
        1070.6435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1473.843505859375,
      "bbox_min": [
        -1597.9559326171875,
        -3778.220458984375,
        1069.0015869140625
      ],
      "bbox_max": [
        -1595.540283203125,
        -3759.93994140625,
        1070.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3394180238246918,
        -0.7401612401008606,
        -0.5804797410964966
      ],
      "plane_d": -2693.0498046875,
      "bbox_min": [
        -1592.896484375,
        -3768.742919921875,
        1076.835693359375
      ],
      "bbox_max": [
        -1536.5213623046875,
        -3757.489990234375,
        1099.7703857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7088859677314758,
        -0.640839695930481,
        -0.2946273684501648
      ],
      "plane_d": -994.7078857421875,
      "bbox_min": [
        -1544.1060791015625,
        -3764.95166015625,
        1084.3175048828125
      ],
      "bbox_max": [
        -1536.5213623046875,
        -3757.489990234375,
        1099.7703857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457260131835938,
        0.5051171779632568,
        -0.17205862700939178
      ],
      "plane_d": 893.42138671875,
      "bbox_min": [
        -1460.8209228515625,
        -3836.3037109375,
        1107.0552978515625
      ],
      "bbox_max": [
        -1459.96875,
        -3835.49853515625,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1201314926147461,
        -0.013168086297810078,
        -0.9926706552505493
      ],
      "plane_d": 803.2310791015625,
      "bbox_min": [
        -1608.97998046875,
        -3764.2763671875,
        1018.2022094726562
      ],
      "bbox_max": [
        -1439.5,
        -3707.0,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.154052734375,
        0.0008227409562096,
        -0.9880622625350952
      ],
      "plane_d": 798.7056274414062,
      "bbox_min": [
        -1608.97998046875,
        -3761.98095703125,
        1042.375
      ],
      "bbox_max": [
        -1439.5,
        -3707.0,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8560588955879211,
        0.511288583278656,
        -0.0758100226521492
      ],
      "plane_d": 758.0784912109375,
      "bbox_min": [
        -1608.97998046875,
        -3761.22021484375,
        1054.9375
      ],
      "bbox_max": [
        -1439.5,
        -3736.442626953125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372832536697388,
        -0.5000746846199036,
        -0.2210930436849594
      ],
      "plane_d": -2853.089599609375,
      "bbox_min": [
        -1456.362548828125,
        -3761.22021484375,
        1054.9375
      ],
      "bbox_max": [
        -1439.7012939453125,
        -3749.0,
        1108.040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2573006749153137,
        3.118294216619688e-06,
        0.9663314819335938
      ],
      "plane_d": -1458.0789794921875,
      "bbox_min": [
        -1608.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3737.34423828125,
        1102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7088859677314758,
        -0.640839695930481,
        -0.2946273684501648
      ],
      "plane_d": -994.7078857421875,
      "bbox_min": [
        -1608.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08791747689247131,
        -0.7838265299797058,
        -0.6147247552871704
      ],
      "plane_d": -2146.033203125,
      "bbox_min": [
        -1608.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1544.1060791015625,
        -3744.5,
        1084.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1608.97998046875,
        -3759.485107421875,
        1066.718505859375
      ],
      "bbox_max": [
        -1544.1060791015625,
        -3744.5,
        1084.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -2039.6798095703125,
      "bbox_min": [
        -1608.97998046875,
        -3759.485107421875,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.654011607170105,
        -0.043993029743433,
        0.7552041411399841
      ],
      "plane_d": 69.314208984375,
      "bbox_min": [
        -1608.97998046875,
        -3758.7939453125,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6641281843185425,
        -0.04989263042807579,
        0.7459520697593689
      ],
      "plane_d": -2053.61279296875,
      "bbox_min": [
        -1608.97998046875,
        -3757.96240234375,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1070.826416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -657.8333740234375,
      "bbox_min": [
        -1608.97998046875,
        -3757.784423828125,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1070.5538330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -627.0723876953125,
      "bbox_min": [
        -1608.97998046875,
        -3757.5458984375,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1070.5006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1605.1099853515625,
        -3756.324951171875,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1070.5006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1473.843505859375,
      "bbox_min": [
        -1597.8450927734375,
        -3756.324951171875,
        1066.718505859375
      ],
      "bbox_max": [
        -1593.5,
        -3744.5,
        1070.5006103515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3394180238246918,
        -0.7401612401008606,
        -0.5804797410964966
      ],
      "plane_d": -2693.0498046875,
      "bbox_min": [
        -1595.7493896484375,
        -3759.398193359375,
        1076.0
      ],
      "bbox_max": [
        -1544.1060791015625,
        -3754.95166015625,
        1084.7596435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20845206081867218,
        -0.8886169195175171,
        -0.4085434377193451
      ],
      "plane_d": -2575.248779296875,
      "bbox_min": [
        -1554.3839111328125,
        -3759.145263671875,
        1076.0
      ],
      "bbox_max": [
        -1544.1060791015625,
        -3754.95166015625,
        1084.3175048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1607.438720703125,
        -3760.123779296875,
        1067.6041259765625
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3754.395263671875,
        1073.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1473.843505859375,
      "bbox_min": [
        -1607.438720703125,
        -3760.123779296875,
        1067.6041259765625
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3754.395263671875,
        1073.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1607.438720703125,
        -3760.123779296875,
        1067.67626953125
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3755.20166015625,
        1073.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -627.0723876953125,
      "bbox_min": [
        -1607.438720703125,
        -3760.123779296875,
        1067.67626953125
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3755.20166015625,
        1073.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.654011607170105,
        -0.043993029743433,
        0.7552041411399841
      ],
      "plane_d": 69.314208984375,
      "bbox_min": [
        -1607.438720703125,
        -3759.93994140625,
        1070.2642822265625
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3756.166748046875,
        1073.18310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -2039.6798095703125,
      "bbox_min": [
        -1607.438720703125,
        -3759.93994140625,
        1070.2642822265625
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3756.166748046875,
        1073.171630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1475.857421875,
      "bbox_min": [
        -1607.438720703125,
        -3759.93994140625,
        1070.2642822265625
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3756.166748046875,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6642568111419678,
        -0.045858561992645264,
        0.7460964918136597
      ],
      "plane_d": 88.40032958984375,
      "bbox_min": [
        -1607.438720703125,
        -3759.93994140625,
        1070.2872314453125
      ],
      "bbox_max": [
        -1594.7999267578125,
        -3756.324951171875,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -657.8333740234375,
      "bbox_min": [
        -1607.438720703125,
        -3759.93994140625,
        1070.2872314453125
      ],
      "bbox_max": [
        -1606.845703125,
        -3757.5458984375,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6641281843185425,
        -0.04989263042807579,
        0.7459520697593689
      ],
      "plane_d": -2053.61279296875,
      "bbox_min": [
        -1607.438720703125,
        -3759.91455078125,
        1070.5538330078125
      ],
      "bbox_max": [
        -1606.8526611328125,
        -3757.784423828125,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.08914245665073395,
        -0.9960188865661621
      ],
      "plane_d": 728.6779174804688,
      "bbox_min": [
        -1488.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.016670895740389824,
        0.9998610615730286
      ],
      "plane_d": -1135.696533203125,
      "bbox_min": [
        -1488.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6512090563774109,
        -0.10252884030342102,
        -0.7519406080245972
      ],
      "plane_d": -548.9273681640625,
      "bbox_min": [
        -1488.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.651468813419342,
        -0.09860385954380035,
        -0.7522405385971069
      ],
      "plane_d": 1395.667236328125,
      "bbox_min": [
        -1488.97998046875,
        -3760.123779296875,
        1066.718505859375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6538919806480408,
        -0.04796561226248741,
        0.75506591796875
      ],
      "plane_d": -1961.212646484375,
      "bbox_min": [
        -1488.97998046875,
        -3759.93994140625,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.654011607170105,
        -0.043993029743433,
        0.7552041411399841
      ],
      "plane_d": -9.16717529296875,
      "bbox_min": [
        -1488.97998046875,
        -3759.93994140625,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1073.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6613656878471375,
        -0.10378153622150421,
        -0.7428492307662964
      ],
      "plane_d": -578.469482421875,
      "bbox_min": [
        -1488.97998046875,
        -3759.93994140625,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6616367697715759,
        -0.09979628771543503,
        -0.7431536912918091
      ],
      "plane_d": 1396.4610595703125,
      "bbox_min": [
        -1488.97998046875,
        -3759.93994140625,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6641281843185425,
        -0.04989263042807579,
        0.7459520697593689
      ],
      "plane_d": -1973.91748046875,
      "bbox_min": [
        -1488.97998046875,
        -3759.91455078125,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6642568111419678,
        -0.045858561992645264,
        0.7460964918136597
      ],
      "plane_d": 8.689453125,
      "bbox_min": [
        -1475.5335693359375,
        -3759.91455078125,
        1070.070068359375
      ],
      "bbox_max": [
        -1473.5,
        -3744.5,
        1070.9346923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1540493667125702,
        0.006635778117924929,
        -0.9880408048629761
      ],
      "plane_d": 1295.9417724609375,
      "bbox_min": [
        -1546.929443359375,
        -3761.98095703125,
        1045.543212890625
      ],
      "bbox_max": [
        -1542.962646484375,
        -3707.0,
        1046.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1540493667125702,
        0.006635778117924929,
        -0.9880408048629761
      ],
      "plane_d": 1295.9417724609375,
      "bbox_min": [
        -1567.25,
        -3761.98095703125,
        1042.375
      ],
      "bbox_max": [
        -1542.962646484375,
        -3707.0,
        1045.79248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737572968006134,
        -0.14351895451545715,
        0.6598397493362427
      ],
      "plane_d": -49.5125732421875,
      "bbox_min": [
        -1586.6759033203125,
        -3764.2763671875,
        1018.2022094726562
      ],
      "bbox_max": [
        -1499.078857421875,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8010060787200928,
        -0.18038897216320038,
        0.5708318948745728
      ],
      "plane_d": 4.069580078125,
      "bbox_min": [
        -1586.6759033203125,
        -3763.286865234375,
        1020.625
      ],
      "bbox_max": [
        -1499.078857421875,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7113898396492004,
        -0.15887613594532013,
        -0.6846042275428772
      ],
      "plane_d": -959.1174926757812,
      "bbox_min": [
        -1586.6759033203125,
        -3763.286865234375,
        1030.0966796875
      ],
      "bbox_max": [
        -1499.078857421875,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8060865998268127,
        -0.1422276794910431,
        -0.5744525790214539
      ],
      "plane_d": -1154.2991943359375,
      "bbox_min": [
        -1520.75,
        -3762.30615234375,
        1031.5
      ],
      "bbox_max": [
        -1510.642822265625,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7169864773750305,
        -0.13166189193725586,
        -0.6845403909683228
      ],
      "plane_d": 1347.286376953125,
      "bbox_min": [
        -1586.6759033203125,
        -3763.286865234375,
        1030.0966796875
      ],
      "bbox_max": [
        -1567.25,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8092585802078247,
        -0.11181507259607315,
        -0.5767130255699158
      ],
      "plane_d": 1454.9632568359375,
      "bbox_min": [
        -1575.240478515625,
        -3762.30615234375,
        1031.5
      ],
      "bbox_max": [
        -1567.25,
        -3707.0,
        1042.375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.025918442755937576,
        -0.5204584002494812,
        0.8534935116767883
      ],
      "plane_d": -2939.17724609375,
      "bbox_min": [
        -1615.4000244140625,
        -3756.72998046875,
        1108.909912109375
      ],
      "bbox_max": [
        -1447.1600341796875,
        -3752.292236328125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8560588955879211,
        0.511288583278656,
        -0.0758100226521492
      ],
      "plane_d": 758.0784912109375,
      "bbox_min": [
        -1455.7398681640625,
        -3755.56396484375,
        1109.3604736328125
      ],
      "bbox_max": [
        -1453.8978271484375,
        -3752.292236328125,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8560588955879211,
        0.511288583278656,
        -0.0758100226521492
      ],
      "plane_d": 758.0784912109375,
      "bbox_min": [
        -1456.4630126953125,
        -3756.72998046875,
        1108.909912109375
      ],
      "bbox_max": [
        -1447.1600341796875,
        -3753.544921875,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797518849372864,
        -0.19515667855739594,
        -0.04472288116812706
      ],
      "plane_d": -2101.4150390625,
      "bbox_min": [
        -1447.804931640625,
        -3756.72998046875,
        1108.9100341796875
      ],
      "bbox_max": [
        -1447.1600341796875,
        -3753.885498046875,
        1110.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1727493554353714,
        -0.9789130091667175,
        -0.10902752727270126
      ],
      "plane_d": -3170.19287109375,
      "bbox_min": [
        -1631.0,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3605.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18118509650230408,
        -0.9778258204460144,
        -0.1050170361995697
      ],
      "plane_d": -3157.298828125,
      "bbox_min": [
        -1631.0,
        -3632.0,
        1015.0
      ],
      "bbox_max": [
        -1543.538818359375,
        -3605.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1015.4999389648438,
      "bbox_min": [
        -1631.0,
        -3613.0,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3605.0,
      "bbox_min": [
        -1631.0,
        -3613.0,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3613.0,
      "bbox_min": [
        -1631.0,
        -3613.0,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1406.142578125,
      "bbox_min": [
        -1631.0,
        -3613.0,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3706.36083984375,
      "bbox_min": [
        -1631.0,
        -3613.0,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70707106590271,
        -0.7071425318717957,
        0.0
      ],
      "plane_d": -1397.722900390625,
      "bbox_min": [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70707106590271,
        -0.7071425318717957,
        -0.0
      ],
      "plane_d": -3697.8251953125,
      "bbox_min": [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3605.0,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1622.0,
      "bbox_min": [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      "bbox_max": [
        -1622.0,
        -3607.4140625,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1631.0,
      "bbox_min": [
        -1631.0,
        -3610.585693359375,
        1015.0
      ],
      "bbox_max": [
        -1631.0,
        -3607.4140625,
        1015.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18118511140346527,
        -0.9778257608413696,
        -0.1050170287489891
      ],
      "plane_d": -3716.798095703125,
      "bbox_min": [
        -1544.0,
        -3628.58544921875,
        1015.0
      ],
      "bbox_max": [
        -1543.538818359375,
        -3624.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18118511140346527,
        -0.9778257608413696,
        -0.1050170287489891
      ],
      "plane_d": -3716.798095703125,
      "bbox_min": [
        -1544.0,
        -3632.0,
        1015.0
      ],
      "bbox_max": [
        -1525.111083984375,
        -3624.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8224902749061584,
        -0.5437551140785217,
        -0.16685354709625244
      ],
      "plane_d": -513.110107421875,
      "bbox_min": [
        -1578.0,
        -3642.0,
        1015.0
      ],
      "bbox_max": [
        -1562.888916015625,
        -3632.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8438162207603455,
        0.5312917232513428,
        -0.07552050054073334
      ],
      "plane_d": 3343.15966796875,
      "bbox_min": [
        -1578.0,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8224902153015137,
        -0.5437551736831665,
        -0.16685353219509125
      ],
      "plane_d": -3052.960205078125,
      "bbox_min": [
        -1569.5,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8331332206726074,
        -0.5245653986930847,
        -0.17527177929878235
      ],
      "plane_d": -2990.59765625,
      "bbox_min": [
        -1525.111083984375,
        -3642.0,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3628.5,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9599553346633911,
        0.26665425300598145,
        -0.08591480553150177
      ],
      "plane_d": -395.7340087890625,
      "bbox_min": [
        -1569.5,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3642.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8340323567390442,
        0.5251314640045166,
        -0.1691950112581253
      ],
      "plane_d": 824.8729248046875,
      "bbox_min": [
        -1518.5,
        -3655.5,
        1015.0
      ],
      "bbox_max": [
        -1510.0,
        -3642.0,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23043940961360931,
        0.9728680849075317,
        -0.020624039694666862
      ],
      "plane_d": 3227.33056640625,
      "bbox_min": [
        -1569.5,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1518.5,
        -3655.5,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378127574920654,
        0.9846614599227905,
        -0.015553208068013191
      ],
      "plane_d": 3887.96630859375,
      "bbox_min": [
        -1569.5,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1518.5,
        -3655.5,
        1056.9000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.1737707555294037,
        0.9847861528396606,
        8.06351727078436e-06
      ],
      "plane_d": 3336.006591796875,
      "bbox_min": [
        -1527.4554443359375,
        -3656.601806640625,
        1015.0
      ],
      "bbox_max": [
        -1518.5,
        -3655.5,
        1056.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.202459916472435,
        0.9785563349723816,
        -0.03791569173336029
      ],
      "plane_d": 3308.9912109375,
      "bbox_min": [
        -1527.4554443359375,
        -3656.586181640625,
        1051.3134765625
      ],
      "bbox_max": [
        -1522.25,
        -3655.5,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.003343928838148713,
        0.9999944567680359
      ],
      "plane_d": -1008.223388671875,
      "bbox_min": [
        -1575.0,
        -3707.0,
        1015.0
      ],
      "bbox_max": [
        -1513.0,
        -3656.23291015625,
        1056.9000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.17376433312892914,
        0.9846646785736084,
        -0.01553752738982439
      ],
      "plane_d": 3887.935302734375,
      "bbox_min": [
        -1565.3463134765625,
        -3660.0,
        1015.0
      ],
      "bbox_max": [
        -1524.7430419921875,
        -3656.23291015625,
        1020.4678344726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17892512679100037,
        0.9838627576828003,
        0.0
      ],
      "plane_d": 3877.1982421875,
      "bbox_min": [
        -1559.9820556640625,
        -3660.0,
        1015.0
      ],
      "bbox_max": [
        -1543.7548828125,
        -3657.093505859375,
        1020.4678344726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17379334568977356,
        0.9847822189331055,
        0.0
      ],
      "plane_d": 3335.9658203125,
      "bbox_min": [
        -1544.0,
        -3660.0,
        1015.0
      ],
      "bbox_max": [
        -1543.7548828125,
        -3659.956787109375,
        1020.4678344726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378532886505127,
        0.9847835898399353,
        -2.2017091396264732e-05
      ],
      "plane_d": 3336.005859375,
      "bbox_min": [
        -1544.0,
        -3660.0,
        1015.0
      ],
      "bbox_max": [
        -1524.7430419921875,
        -3656.601806640625,
        1020.4677124023438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9071251153945923,
        -0.22050511837005615,
        0.35847100615501404
      ],
      "plane_d": -2559.65576171875,
      "bbox_min": [
        -1575.0,
        -3707.0,
        1020.4564208984375
      ],
      "bbox_max": [
        -1513.0,
        -3656.248291015625,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1737707555294037,
        0.9847861528396606,
        8.06351727078436e-06
      ],
      "plane_d": 3336.006591796875,
      "bbox_min": [
        -1529.4134521484375,
        -3657.42578125,
        1020.4564208984375
      ],
      "bbox_max": [
        -1524.7432861328125,
        -3656.601806640625,
        1032.784423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20882874727249146,
        0.0416230745613575,
        -0.9770659804344177
      ],
      "plane_d": 1500.052734375,
      "bbox_min": [
        -1575.0,
        -3707.0,
        1031.5
      ],
      "bbox_max": [
        -1513.0,
        -3656.248291015625,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20260556042194366,
        0.9792602062225342,
        0.0005693599232472479
      ],
      "plane_d": 3896.3134765625,
      "bbox_min": [
        -1562.4635009765625,
        -3660.0,
        1045.5595703125
      ],
      "bbox_max": [
        -1526.78662109375,
        -3656.25927734375,
        1056.9000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17378127574920654,
        0.9846614599227905,
        -0.015553208068013191
      ],
      "plane_d": 3887.96630859375,
      "bbox_min": [
        -1562.4635009765625,
        -3656.698974609375,
        1045.5595703125
      ],
      "bbox_max": [
        -1559.924560546875,
        -3656.25927734375,
        1050.0169677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378883063793182,
        0.9847829341888428,
        0.0
      ],
      "plane_d": 3335.9755859375,
      "bbox_min": [
        -1544.0,
        -3660.0,
        1049.346435546875
      ],
      "bbox_max": [
        -1536.4945068359375,
        -3658.675537109375,
        1056.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17353950440883636,
        0.9847052693367004,
        -0.015477009117603302
      ],
      "plane_d": 3887.66943359375,
      "bbox_min": [
        -1563.6671142578125,
        -3656.698974609375,
        1032.79345703125
      ],
      "bbox_max": [
        -1559.924560546875,
        -3656.248291015625,
        1046.08349609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23763301968574524,
        0.06898656487464905,
        -0.9689021706581116
      ],
      "plane_d": 902.2994384765625,
      "bbox_min": [
        -1547.21142578125,
        -3707.0,
        1045.52392578125
      ],
      "bbox_max": [
        -1525.9190673828125,
        -3656.5830078125,
        1053.1710205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17378883063793182,
        0.9847829341888428,
        0.0
      ],
      "plane_d": 3335.9755859375,
      "bbox_min": [
        -1544.0,
        -3660.0,
        1045.52392578125
      ],
      "bbox_max": [
        -1525.9190673828125,
        -3656.5830078125,
        1053.1710205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.202459916472435,
        0.9785563349723816,
        -0.03791569173336029
      ],
      "plane_d": 3308.9912109375,
      "bbox_min": [
        -1536.4945068359375,
        -3658.675537109375,
        1045.52392578125
      ],
      "bbox_max": [
        -1525.9190673828125,
        -3656.5830078125,
        1053.1710205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22331680357456207,
        0.974510133266449,
        -0.021435463801026344
      ],
      "plane_d": 3245.03271484375,
      "bbox_min": [
        -1530.3275146484375,
        -3657.587158203125,
        1045.52392578125
      ],
      "bbox_max": [
        -1525.9190673828125,
        -3656.586181640625,
        1051.3134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1536729633808136,
        0.070177361369133,
        -0.9856266379356384
      ],
      "plane_d": 1528.384033203125,
      "bbox_min": [
        -1547.21142578125,
        -3707.0,
        1046.0
      ],
      "bbox_max": [
        -1544.0,
        -3660.0,
        1049.346435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9090548753738403,
        -0.1462741643190384,
        -0.39015766978263855
      ],
      "plane_d": -1517.992919921875,
      "bbox_min": [
        -1530.3275146484375,
        -3707.0,
        1032.784423828125
      ],
      "bbox_max": [
        -1520.75,
        -3656.591064453125,
        1046.1649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1536729633808136,
        0.070177361369133,
        -0.9856266379356384
      ],
      "plane_d": 1528.384033203125,
      "bbox_min": [
        -1567.25,
        -3707.0,
        1042.375
      ],
      "bbox_max": [
        -1544.0,
        -3666.491943359375,
        1048.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3249381184577942,
        0.1722082495689392,
        -0.929924488067627
      ],
      "plane_d": 1117.7073974609375,
      "bbox_min": [
        -1569.5,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3249381184577942,
        0.17220817506313324,
        -0.929924488067627
      ],
      "plane_d": 2121.1162109375,
      "bbox_min": [
        -1569.5,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35779446363449097,
        -0.23654092848300934,
        -0.9033446311950684
      ],
      "plane_d": 654.8212890625,
      "bbox_min": [
        -1569.5,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35779449343681335,
        -0.23654094338417053,
        -0.9033446311950684
      ],
      "plane_d": -450.048095703125,
      "bbox_min": [
        -1565.75,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1518.5,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11032269150018692,
        -0.5953929424285889,
        -0.7958242297172546
      ],
      "plane_d": -1148.9384765625,
      "bbox_min": [
        -1565.75,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1522.25,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11032269150018692,
        -0.5953929424285889,
        -0.7958242297172546
      ],
      "plane_d": -1489.6148681640625,
      "bbox_min": [
        -1565.75,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1522.25,
        -3628.5,
        1067.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17527329921722412,
        0.8471543192863464,
        -0.5016061663627625
      ],
      "plane_d": 3901.3544921875,
      "bbox_min": [
        -1565.75,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1522.25,
        -3655.5,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17527329921722412,
        0.8471543192863464,
        -0.5016061663627625
      ],
      "plane_d": 3360.1103515625,
      "bbox_min": [
        -1544.0,
        -3660.0,
        1056.9000244140625
      ],
      "bbox_max": [
        -1522.25,
        -3655.5,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3169591426849365,
        -0.0631350576877594,
        -0.94633549451828
      ],
      "plane_d": 1324.2353515625,
      "bbox_min": [
        -1630.25,
        -3869.375,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3694.5,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2353556901216507,
        0.15632764995098114,
        -0.9592546224594116
      ],
      "plane_d": 2042.568359375,
      "bbox_min": [
        -1630.25,
        -3810.502685546875,
        1110.625
      ],
      "bbox_max": [
        -1547.75,
        -3758.506103515625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2353556901216507,
        0.15632764995098114,
        -0.9592546224594116
      ],
      "plane_d": 2042.568359375,
      "bbox_min": [
        -1620.99072265625,
        -3856.542236328125,
        1110.625
      ],
      "bbox_max": [
        -1533.15771484375,
        -3781.9375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03179214149713516,
        -0.5619184374809265,
        0.8265815377235413
      ],
      "plane_d": -2976.223388671875,
      "bbox_min": [
        -1609.713134765625,
        -3869.375,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3694.5,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15127001702785492,
        -0.2711831033229828,
        0.9505667686462402
      ],
      "plane_d": -2305.340087890625,
      "bbox_min": [
        -1534.6875,
        -3745.5,
        1113.25
      ],
      "bbox_max": [
        -1463.529296875,
        -3694.5,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2841280400753021,
        -0.5093588829040527,
        0.8122958540916443
      ],
      "plane_d": -2377.447265625,
      "bbox_min": [
        -1534.6875,
        -3745.5,
        1113.25
      ],
      "bbox_max": [
        -1495.5,
        -3694.5,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.025918442755937576,
        -0.5204584002494812,
        0.8534935116767883
      ],
      "plane_d": -2939.17724609375,
      "bbox_min": [
        -1604.8125,
        -3869.375,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3712.333740234375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15127001702785492,
        -0.2711831033229828,
        0.9505667686462402
      ],
      "plane_d": -2305.340087890625,
      "bbox_min": [
        -1529.75,
        -3753.544677734375,
        1110.625
      ],
      "bbox_max": [
        -1449.8126220703125,
        -3712.333740234375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8560588955879211,
        0.511288583278656,
        -0.0758100226521492
      ],
      "plane_d": 758.0784912109375,
      "bbox_min": [
        -1454.6458740234375,
        -3753.544677734375,
        1110.625
      ],
      "bbox_max": [
        -1449.8126220703125,
        -3745.03662109375,
        1115.740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1462818682193756,
        0.8744683265686035,
        0.4625006318092346
      ],
      "plane_d": 2627.36962890625,
      "bbox_min": [
        -1604.8125,
        -3869.375,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3716.359375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26408714056015015,
        0.47343143820762634,
        0.8403098583221436
      ],
      "plane_d": 484.6603088378906,
      "bbox_min": [
        -1536.6107177734375,
        -3869.375,
        1110.625
      ],
      "bbox_max": [
        -1445.340087890625,
        -3835.081787109375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585227727890015,
        -0.5127601623535156,
        -0.003964266274124384
      ],
      "plane_d": -3228.901123046875,
      "bbox_min": [
        -1536.6107177734375,
        -3866.031494140625,
        1110.625
      ],
      "bbox_max": [
        -1445.340087890625,
        -3835.081787109375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457260131835938,
        0.5051171779632568,
        -0.17205862700939178
      ],
      "plane_d": 893.42138671875,
      "bbox_min": [
        -1469.384033203125,
        -3848.055908203125,
        1110.625
      ],
      "bbox_max": [
        -1445.340087890625,
        -3835.081787109375,
        1125.4664306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1536.6107177734375,
        -3860.777099609375,
        1110.625
      ],
      "bbox_max": [
        -1513.6004638671875,
        -3847.4033203125,
        1115.1688232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1529.1107177734375,
        -3848.2197265625,
        1110.625
      ],
      "bbox_max": [
        -1513.6004638671875,
        -3847.4033203125,
        1114.9178466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1536.070556640625,
        -3866.7177734375,
        1110.7586669921875
      ],
      "bbox_max": [
        -1507.1015625,
        -3848.04052734375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585206866264343,
        -0.5127589106559753,
        -0.0045297350734472275
      ],
      "plane_d": -681.1605224609375,
      "bbox_min": [
        -1529.0948486328125,
        -3866.7177734375,
        1110.7586669921875
      ],
      "bbox_max": [
        -1507.1015625,
        -3848.04052734375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1529.0948486328125,
        -3848.1943359375,
        1110.7586669921875
      ],
      "bbox_max": [
        -1527.74658203125,
        -3848.04052734375,
        1111.567138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8419256210327148,
        0.5028473734855652,
        -0.195718452334404
      ],
      "plane_d": 3427.20556640625,
      "bbox_min": [
        -1528.0047607421875,
        -3862.627685546875,
        1111.141357421875
      ],
      "bbox_max": [
        -1465.2796630859375,
        -3847.53369140625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585206866264343,
        -0.5127589106559753,
        -0.0045297350734472275
      ],
      "plane_d": -681.1605224609375,
      "bbox_min": [
        -1528.0047607421875,
        -3862.627685546875,
        1111.141357421875
      ],
      "bbox_max": [
        -1503.9212646484375,
        -3847.60986328125,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1528.0047607421875,
        -3848.12158203125,
        1111.141357421875
      ],
      "bbox_max": [
        -1518.26708984375,
        -3847.60986328125,
        1113.832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4831463694572449,
        0.8661409020423889,
        0.12794403731822968
      ],
      "plane_d": 3928.976806640625,
      "bbox_min": [
        -1534.6875,
        -3857.6015625,
        1110.625
      ],
      "bbox_max": [
        -1504.4610595703125,
        -3847.515625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1529.0269775390625,
        -3848.085693359375,
        1111.329345703125
      ],
      "bbox_max": [
        -1528.0048828125,
        -3847.779541015625,
        1112.938720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8419256210327148,
        0.5028473734855652,
        -0.195718452334404
      ],
      "plane_d": 3427.20556640625,
      "bbox_min": [
        -1528.835693359375,
        -3855.570068359375,
        1111.567138671875
      ],
      "bbox_max": [
        -1504.4610595703125,
        -3847.691650390625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1528.835693359375,
        -3848.04052734375,
        1111.567138671875
      ],
      "bbox_max": [
        -1526.674560546875,
        -3847.691650390625,
        1113.4010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7503945231437683,
        0.1494709998369217,
        -0.6438684463500977
      ],
      "plane_d": 211.947021484375,
      "bbox_min": [
        -1529.1265869140625,
        -3852.2392578125,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3716.359375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1131.0,
      "bbox_min": [
        -1453.168701171875,
        -3832.996826171875,
        1116.125
      ],
      "bbox_max": [
        -1428.0,
        -3757.88720703125,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1451.312744140625,
        -3832.996826171875,
        1116.125
      ],
      "bbox_max": [
        -1429.0,
        -3757.88720703125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1441.818359375,
        -3784.442626953125,
        1122.697998046875
      ],
      "bbox_max": [
        -1429.0,
        -3757.88720703125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -1430.3297119140625,
        -3761.226318359375,
        1123.0
      ],
      "bbox_max": [
        -1429.0,
        -3757.88720703125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1451.312744140625,
        -3832.996826171875,
        1125.6549072265625
      ],
      "bbox_max": [
        -1446.9036865234375,
        -3832.107177734375,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1453.168701171875,
        -3832.107177734375,
        1131.0
      ],
      "bbox_max": [
        -1447.459716796875,
        -3831.732666015625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9797518849372864,
        -0.19515667855739594,
        -0.04472288116812706
      ],
      "plane_d": -2101.4150390625,
      "bbox_min": [
        -1529.1265869140625,
        -3852.2392578125,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3716.359375,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -1449.8524169921875,
        -3784.442626953125,
        1110.625
      ],
      "bbox_max": [
        -1429.66455078125,
        -3746.442626953125,
        1129.3746337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9893783330917358,
        -0.1453632116317749
      ],
      "plane_d": -3568.254150390625,
      "bbox_min": [
        -1444.7720947265625,
        -3784.442626953125,
        1110.625
      ],
      "bbox_max": [
        -1433.6451416015625,
        -3769.7392578125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1437.954833984375,
        -3784.442626953125,
        1111.8719482421875
      ],
      "bbox_max": [
        -1433.6451416015625,
        -3784.442626953125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1440.4237060546875,
        -3784.442626953125,
        1123.0
      ],
      "bbox_max": [
        -1434.9541015625,
        -3784.442626953125,
        1129.3746337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8228299617767334,
        0.5465390086174011,
        0.15571096539497375
      ],
      "plane_d": 728.060302734375,
      "bbox_min": [
        -1442.648193359375,
        -3813.100341796875,
        1110.625
      ],
      "bbox_max": [
        -1426.75,
        -3784.442626953125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1435.381591796875,
        -3809.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1433.5242919921875,
        -3809.557373046875,
        1116.3953857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1442.648193359375,
        -3809.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1434.28955078125,
        -3784.442626953125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9893783330917358,
        -0.1453632116317749
      ],
      "plane_d": -3568.254150390625,
      "bbox_min": [
        -1444.8966064453125,
        -3771.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1440.941162109375,
        -3769.7392578125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -1444.8966064453125,
        -3771.557373046875,
        1123.0
      ],
      "bbox_max": [
        -1444.7720947265625,
        -3771.322021484375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1452.3480224609375,
        -3835.35205078125,
        1111.5054931640625
      ],
      "bbox_max": [
        -1445.6005859375,
        -3832.81884765625,
        1126.7242431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": 786.66552734375,
      "bbox_min": [
        -1529.1265869140625,
        -3852.2392578125,
        1110.625
      ],
      "bbox_max": [
        -1436.715576171875,
        -3745.376220703125,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8555697798728943,
        -0.5109964609146118,
        -0.08296433836221695
      ],
      "plane_d": -3093.841796875,
      "bbox_min": [
        -1470.1937255859375,
        -3849.333740234375,
        1110.625
      ],
      "bbox_max": [
        -1436.715576171875,
        -3784.442626953125,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1131.0,
      "bbox_min": [
        -1458.0,
        -3809.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1436.715576171875,
        -3784.442626953125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3784.442626953125,
      "bbox_min": [
        -1450.5,
        -3809.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1436.715576171875,
        -3784.442626953125,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3809.557373046875,
      "bbox_min": [
        -1450.5,
        -3809.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1436.715576171875,
        -3809.557373046875,
        1131.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457260131835938,
        0.5051171779632568,
        -0.17205862700939178
      ],
      "plane_d": 893.42138671875,
      "bbox_min": [
        -1470.1937255859375,
        -3849.333740234375,
        1110.625
      ],
      "bbox_max": [
        -1447.7857666015625,
        -3831.732666015625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585227727890015,
        -0.5127601623535156,
        -0.003964266274124384
      ],
      "plane_d": -3228.901123046875,
      "bbox_min": [
        -1470.1937255859375,
        -3849.333740234375,
        1125.4664306640625
      ],
      "bbox_max": [
        -1467.1812744140625,
        -3844.2900390625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9823895692825317,
        -0.18684378266334534
      ],
      "plane_d": 3987.96435546875,
      "bbox_min": [
        -1529.1265869140625,
        -3852.2392578125,
        1110.625
      ],
      "bbox_max": [
        -1444.64697265625,
        -3745.376220703125,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1529.1265869140625,
        -3852.2392578125,
        1113.4010009765625
      ],
      "bbox_max": [
        -1506.450439453125,
        -3843.91650390625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8419256210327148,
        0.5028473734855652,
        -0.195718452334404
      ],
      "plane_d": 3427.20556640625,
      "bbox_min": [
        -1513.6004638671875,
        -3852.2392578125,
        1114.9178466796875
      ],
      "bbox_max": [
        -1506.450439453125,
        -3843.91650390625,
        1133.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1123.0,
      "bbox_min": [
        -1459.0,
        -3771.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1444.64697265625,
        -3745.376220703125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8372832536697388,
        -0.5000746846199036,
        -0.2210930436849594
      ],
      "plane_d": -2853.089599609375,
      "bbox_min": [
        -1459.0,
        -3771.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1444.64697265625,
        -3745.376220703125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9893783330917358,
        -0.1453632116317749
      ],
      "plane_d": -3568.254150390625,
      "bbox_min": [
        -1451.5,
        -3771.557373046875,
        1110.625
      ],
      "bbox_max": [
        -1444.64697265625,
        -3769.7392578125,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22243961691856384,
        0.0,
        0.9749464392662048
      ],
      "plane_d": -1462.677490234375,
      "bbox_min": [
        -1546.5,
        -3835.8642578125,
        1146.477783203125
      ],
      "bbox_max": [
        -1545.8729248046875,
        -3831.80029296875,
        1147.5645751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1546.5,
        -3832.9169921875,
        1146.477783203125
      ],
      "bbox_max": [
        -1545.8729248046875,
        -3831.80029296875,
        1147.5645751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9801498651504517,
        -0.195235937833786,
        0.03448723629117012
      ],
      "plane_d": -2192.05419921875,
      "bbox_min": [
        -1547.75,
        -3870.125,
        1133.25
      ],
      "bbox_max": [
        -1441.0,
        -3694.5,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.983177900314331,
        -0.1730317920446396,
        -0.058490779250860214
      ],
      "plane_d": -2007.0821533203125,
      "bbox_min": [
        -1547.75,
        -3870.125,
        1133.25
      ],
      "bbox_max": [
        -1441.0,
        -3694.5,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9831008315086365,
        0.17301823198795319,
        0.05981270968914032
      ],
      "plane_d": -833.7944946289062,
      "bbox_min": [
        -1547.75,
        -3870.125,
        1133.25
      ],
      "bbox_max": [
        -1441.0,
        -3694.5,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9801825284957886,
        0.19524244964122772,
        -0.03350423276424408
      ],
      "plane_d": -638.2850341796875,
      "bbox_min": [
        -1457.25634765625,
        -3855.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1441.0,
        -3781.9375,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1457.25634765625,
        -3855.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1441.0,
        -3830.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1453.1728515625,
        -3831.732666015625,
        1133.25
      ],
      "bbox_max": [
        -1447.6937255859375,
        -3830.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1453.5347900390625,
        -3831.732666015625,
        1133.25
      ],
      "bbox_max": [
        -1453.1688232421875,
        -3831.064208984375,
        1137.26611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8340660333633423,
        0.14678925275802612,
        -0.531777024269104
      ],
      "plane_d": 2447.44091796875,
      "bbox_min": [
        -1546.5,
        -3867.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1522.7664794921875,
        -3783.0,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2525845766067505,
        -0.6334431171417236,
        -0.7314034104347229
      ],
      "plane_d": -1207.873291015625,
      "bbox_min": [
        -1546.5,
        -3865.85009765625,
        1133.25
      ],
      "bbox_max": [
        -1525.638671875,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25544682145118713,
        0.6329281330108643,
        -0.7308549880981445
      ],
      "plane_d": 3654.6923828125,
      "bbox_min": [
        -1546.5,
        -3844.5,
        1140.718505859375
      ],
      "bbox_max": [
        -1527.1346435546875,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25148263573646545,
        -0.6435429453849792,
        -0.7229169607162476
      ],
      "plane_d": -1258.115234375,
      "bbox_min": [
        -1546.5,
        -3844.5,
        1144.070068359375
      ],
      "bbox_max": [
        -1527.1346435546875,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25438040494918823,
        0.6431249380111694,
        -0.7222747802734375
      ],
      "plane_d": 3682.2705078125,
      "bbox_min": [
        -1546.5,
        -3844.5,
        1144.070068359375
      ],
      "bbox_max": [
        -1527.5565185546875,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1546.5,
        -3844.5,
        1144.070068359375
      ],
      "bbox_max": [
        -1528.2584228515625,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1459583193063736,
        -0.6476463675498962,
        0.7478305101394653
      ],
      "plane_d": -3571.171630859375,
      "bbox_min": [
        -1546.5,
        -3844.5,
        1144.070068359375
      ],
      "bbox_max": [
        -1529.2587890625,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1546.5,
        -3840.630126953125,
        1144.070068359375
      ],
      "bbox_max": [
        -1529.2587890625,
        -3829.02001953125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22243961691856384,
        0.0,
        0.9749464392662048
      ],
      "plane_d": -1462.677490234375,
      "bbox_min": [
        -1546.5,
        -3840.630126953125,
        1147.4215087890625
      ],
      "bbox_max": [
        -1539.58154296875,
        -3832.9169921875,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1533.9212646484375,
        -3865.85009765625,
        1133.25
      ],
      "bbox_max": [
        -1526.5196533203125,
        -3849.0888671875,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1533.9212646484375,
        -3856.473876953125,
        1133.25
      ],
      "bbox_max": [
        -1529.4696044921875,
        -3849.0888671875,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4704054892063141,
        0.8433001637458801,
        -0.2599300146102905
      ],
      "plane_d": 4261.1015625,
      "bbox_min": [
        -1529.0362548828125,
        -3848.39111328125,
        1140.734130859375
      ],
      "bbox_max": [
        -1528.8355712890625,
        -3848.30029296875,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4704054892063141,
        0.8433001637458801,
        -0.2599300146102905
      ],
      "plane_d": 4261.1015625,
      "bbox_min": [
        -1534.6875,
        -3848.361083984375,
        1133.25
      ],
      "bbox_max": [
        -1528.99853515625,
        -3847.515625,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4704054892063141,
        0.8433001637458801,
        -0.2599300146102905
      ],
      "plane_d": 4261.1015625,
      "bbox_min": [
        -1529.674560546875,
        -3849.438232421875,
        1141.0
      ],
      "bbox_max": [
        -1522.7664794921875,
        -3830.976318359375,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5282365679740906,
        0.836690366268158,
        -0.14462116360664368
      ],
      "plane_d": 4191.33837890625,
      "bbox_min": [
        -1524.5,
        -3849.438232421875,
        1148.3433837890625
      ],
      "bbox_max": [
        -1522.7664794921875,
        -3848.34375,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29815417528152466,
        0.0,
        -0.9545177221298218
      ],
      "plane_d": 1549.9315185546875,
      "bbox_min": [
        -1528.851806640625,
        -3841.873779296875,
        1146.2310791015625
      ],
      "bbox_max": [
        -1524.3736572265625,
        -3830.976318359375,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25544682145118713,
        0.6329281330108643,
        -0.7308549880981445
      ],
      "plane_d": 3654.6923828125,
      "bbox_min": [
        -1528.851806640625,
        -3841.873779296875,
        1146.2310791015625
      ],
      "bbox_max": [
        -1524.3736572265625,
        -3830.976318359375,
        1149.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4765872657299042,
        0.854382336139679,
        0.2071121782064438
      ],
      "plane_d": 2358.479248046875,
      "bbox_min": [
        -1534.6875,
        -3870.125,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3694.5,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1465.27978515625,
        -3856.847412109375,
        1133.25
      ],
      "bbox_max": [
        -1456.15625,
        -3849.306640625,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5166402459144592,
        -0.8183226585388184,
        -0.25185495615005493
      ],
      "plane_d": -1965.242919921875,
      "bbox_min": [
        -1524.5,
        -3717.65625,
        1133.25
      ],
      "bbox_max": [
        -1487.86669921875,
        -3694.5,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5333767533302307,
        -0.8448321223258972,
        -0.04204908385872841
      ],
      "plane_d": -3868.810791015625,
      "bbox_min": [
        -1490.0,
        -3697.221923828125,
        1148.13623046875
      ],
      "bbox_max": [
        -1487.86669921875,
        -3695.875,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5324705243110657,
        0.8433967232704163,
        0.07181397825479507
      ],
      "plane_d": 2388.1552734375,
      "bbox_min": [
        -1534.6875,
        -3870.125,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3696.99853515625,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1464.859619140625,
        -3853.94140625,
        1137.2469482421875
      ],
      "bbox_max": [
        -1455.9127197265625,
        -3847.9228515625,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585227727890015,
        -0.5127601623535156,
        -0.003964266274124384
      ],
      "plane_d": -3228.901123046875,
      "bbox_min": [
        -1464.859619140625,
        -3853.94140625,
        1137.2469482421875
      ],
      "bbox_max": [
        -1464.465087890625,
        -3853.251953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1533.1578369140625,
        -3867.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1506.5999755859375,
        -3848.36083984375,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1533.1578369140625,
        -3867.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1506.5999755859375,
        -3848.36083984375,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8585206866264343,
        -0.5127589106559753,
        -0.0045297350734472275
      ],
      "plane_d": -681.1605224609375,
      "bbox_min": [
        -1510.5,
        -3867.557373046875,
        1133.25
      ],
      "bbox_max": [
        -1506.5999755859375,
        -3861.027587890625,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5333767533302307,
        -0.8448321223258972,
        -0.04204908385872841
      ],
      "plane_d": -3868.810791015625,
      "bbox_min": [
        -1530.0994873046875,
        -3862.62744140625,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3696.99853515625,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1141.0,
      "bbox_min": [
        -1530.0994873046875,
        -3862.62744140625,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3830.442626953125,
        1149.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8585206866264343,
        -0.5127589106559753,
        -0.0045297350734472275
      ],
      "plane_d": -681.1605224609375,
      "bbox_min": [
        -1530.0994873046875,
        -3862.62744140625,
        1133.25
      ],
      "bbox_max": [
        -1503.0,
        -3842.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585206866264343,
        0.5127589106559753,
        0.0045297350734472275
      ],
      "plane_d": 655.4049072265625,
      "bbox_min": [
        -1530.0994873046875,
        -3850.0751953125,
        1133.25
      ],
      "bbox_max": [
        -1525.5,
        -3842.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8457260131835938,
        0.5051171779632568,
        -0.17205862700939178
      ],
      "plane_d": 893.42138671875,
      "bbox_min": [
        -1471.0,
        -3853.49169921875,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3830.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8585227727890015,
        -0.5127601623535156,
        -0.003964266274124384
      ],
      "plane_d": -3228.901123046875,
      "bbox_min": [
        -1471.0,
        -3853.49169921875,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3830.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9864285588264465,
        -0.16419097781181335
      ],
      "plane_d": 3965.7998046875,
      "bbox_min": [
        -1463.5,
        -3831.732666015625,
        1133.25
      ],
      "bbox_max": [
        -1452.8363037109375,
        -3830.442626953125,
        1141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2525845766067505,
        -0.6334431171417236,
        -0.7314034104347229
      ],
      "plane_d": -1207.873291015625,
      "bbox_min": [
        -1526.067138671875,
        -3841.369384765625,
        1147.1009521484375
      ],
      "bbox_max": [
        -1519.9874267578125,
        -3839.620361328125,
        1149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.984754741191864,
        -0.1733092963695526,
        0.014902918599545956
      ],
      "plane_d": 839.8306884765625,
      "bbox_min": [
        -1541.5374755859375,
        -3787.66259765625,
        1149.0
      ],
      "bbox_max": [
        -1524.5,
        -3717.65625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112138152122498,
        -0.3604460656642914,
        0.19941914081573486
      ],
      "plane_d": -193.07568359375,
      "bbox_min": [
        -1541.5374755859375,
        -3787.66259765625,
        1162.36669921875
      ],
      "bbox_max": [
        -1533.5,
        -3767.34375,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17040561139583588,
        -0.2699107825756073,
        -0.9476867318153381
      ],
      "plane_d": -162.56878662109375,
      "bbox_min": [
        -1548.0,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1428.5,
        -3695.875,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09421363472938538,
        -0.33541014790534973,
        -0.9373493194580078
      ],
      "plane_d": -307.05322265625,
      "bbox_min": [
        -1490.0,
        -3787.66259765625,
        1149.0
      ],
      "bbox_max": [
        -1438.4625244140625,
        -3717.65625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9847546815872192,
        -0.1733092963695526,
        0.014902920462191105
      ],
      "plane_d": -2094.73828125,
      "bbox_min": [
        -1455.5,
        -3787.66259765625,
        1149.0
      ],
      "bbox_max": [
        -1438.4625244140625,
        -3717.65625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112138152122498,
        -0.3604460656642914,
        0.19941914081573486
      ],
      "plane_d": -2908.49267578125,
      "bbox_min": [
        -1446.5,
        -3787.66259765625,
        1162.36669921875
      ],
      "bbox_max": [
        -1438.4625244140625,
        -3767.34375,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7262212634086609,
        0.12780939042568207,
        0.6754756569862366
      ],
      "plane_d": -1341.2821044921875,
      "bbox_min": [
        -1548.0,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1428.5,
        -3717.65625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09758298844099045,
        0.0,
        -0.9952273964881897
      ],
      "plane_d": 1298.55712890625,
      "bbox_min": [
        -1440.54248046875,
        -3842.75390625,
        1163.5377197265625
      ],
      "bbox_max": [
        -1428.5,
        -3830.963134765625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04996119812130928,
        -0.6538297533988953,
        -0.7549905180931091
      ],
      "plane_d": -1560.3970947265625,
      "bbox_min": [
        -1440.54248046875,
        -3842.75390625,
        1163.5377197265625
      ],
      "bbox_max": [
        -1428.5,
        -3830.963134765625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112138152122498,
        -0.3604460656642914,
        0.19941914081573486
      ],
      "plane_d": -2908.49267578125,
      "bbox_min": [
        -1445.980224609375,
        -3818.08203125,
        1149.0
      ],
      "bbox_max": [
        -1432.0,
        -3770.5986328125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": -299.47210693359375,
      "bbox_min": [
        -1438.0919189453125,
        -3818.08203125,
        1161.50048828125
      ],
      "bbox_max": [
        -1432.0,
        -3804.0,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.984754741191864,
        -0.1733092963695526,
        0.014902918599545956
      ],
      "plane_d": 839.8306884765625,
      "bbox_min": [
        -1548.0,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1436.7451171875,
        -3717.65625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1548.0,
        -3818.082275390625,
        1161.50048828125
      ],
      "bbox_max": [
        -1541.907958984375,
        -3804.0,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7262212634086609,
        0.12780939042568207,
        0.6754756569862366
      ],
      "plane_d": 822.8572998046875,
      "bbox_min": [
        -1542.4295654296875,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1436.7451171875,
        -3783.0,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1459583193063736,
        -0.6476463675498962,
        0.7478305101394653
      ],
      "plane_d": -3571.171630859375,
      "bbox_min": [
        -1539.58154296875,
        -3842.90966796875,
        1149.0
      ],
      "bbox_max": [
        -1525.6387939453125,
        -3830.69873046875,
        1151.5601806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1539.58154296875,
        -3842.90966796875,
        1149.0
      ],
      "bbox_max": [
        -1525.6387939453125,
        -3830.69873046875,
        1151.3511962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1529.2587890625,
        -3842.90966796875,
        1149.0
      ],
      "bbox_max": [
        -1525.6387939453125,
        -3830.69873046875,
        1149.8380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25148263573646545,
        -0.6435429453849792,
        -0.7229169607162476
      ],
      "plane_d": -1258.115234375,
      "bbox_min": [
        -1529.2587890625,
        -3842.90966796875,
        1149.0
      ],
      "bbox_max": [
        -1525.6387939453125,
        -3830.69873046875,
        1149.5977783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2525845766067505,
        -0.6334431171417236,
        -0.7314034104347229
      ],
      "plane_d": -1207.873291015625,
      "bbox_min": [
        -1529.2587890625,
        -3842.470458984375,
        1149.0
      ],
      "bbox_max": [
        -1525.6387939453125,
        -3830.69873046875,
        1149.3876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25438040494918823,
        0.6431249380111694,
        -0.7222747802734375
      ],
      "plane_d": 3682.2705078125,
      "bbox_min": [
        -1528.2584228515625,
        -3830.97607421875,
        1149.0
      ],
      "bbox_max": [
        -1527.5567626953125,
        -3830.69873046875,
        1149.142822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40388235449790955,
        0.6397218704223633,
        -0.6539378762245178
      ],
      "plane_d": 3828.962890625,
      "bbox_min": [
        -1524.5,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1476.74609375,
        -3848.34375,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40388238430023193,
        0.6397219300270081,
        -0.6539379358291626
      ],
      "plane_d": 2625.393798828125,
      "bbox_min": [
        -1490.0,
        -3870.125,
        1149.0
      ],
      "bbox_max": [
        -1476.74609375,
        -3852.875,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04691097512841225,
        0.6539501547813416,
        -0.7550818920135498
      ],
      "plane_d": 3452.989013671875,
      "bbox_min": [
        -1542.4295654296875,
        -3856.38720703125,
        1154.548095703125
      ],
      "bbox_max": [
        -1436.7451171875,
        -3815.495361328125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16066426038742065,
        0.6563616394996643,
        0.7371405959129333
      ],
      "plane_d": 1422.68115234375,
      "bbox_min": [
        -1540.0792236328125,
        -3844.343994140625,
        1154.82470703125
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3824.02392578125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0475427508354187,
        -0.6641600728034973,
        -0.7460770606994629
      ],
      "plane_d": -1613.978271484375,
      "bbox_min": [
        -1502.4818115234375,
        -3844.343994140625,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1576785445213318,
        -0.6565942764282227,
        0.7375780940055847
      ],
      "plane_d": -3611.0634765625,
      "bbox_min": [
        -1502.4818115234375,
        -3844.234375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16068968176841736,
        0.6461499929428101,
        0.7461026310920715
      ],
      "plane_d": 1373.075927734375,
      "bbox_min": [
        -1502.4818115234375,
        -3842.70068359375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15774986147880554,
        -0.6464370489120483,
        0.7464811205863953
      ],
      "plane_d": -3582.51513671875,
      "bbox_min": [
        -1502.4818115234375,
        -3842.70068359375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17662808299064636,
        0.0,
        0.984277606010437
      ],
      "plane_d": -1405.317138671875,
      "bbox_min": [
        -1502.4818115234375,
        -3842.52099609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22243961691856384,
        0.0,
        0.9749464392662048
      ],
      "plane_d": -1462.677490234375,
      "bbox_min": [
        -1502.4818115234375,
        -3842.52099609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": -299.47210693359375,
      "bbox_min": [
        -1451.9815673828125,
        -3842.52099609375,
        1162.8775634765625
      ],
      "bbox_max": [
        -1442.5023193359375,
        -3830.550048828125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25941982865333557,
        0.9235610961914062,
        -0.28237614035606384
      ],
      "plane_d": 3501.04541015625,
      "bbox_min": [
        -1451.309814453125,
        -3842.201416015625,
        1165.240234375
      ],
      "bbox_max": [
        -1450.282958984375,
        -3841.71875,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1494.2645263671875,
        -3839.443115234375,
        1159.0062255859375
      ],
      "bbox_max": [
        -1488.5,
        -3838.42138671875,
        1160.654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1502.481689453125,
        -3839.450927734375,
        1157.464599609375
      ],
      "bbox_max": [
        -1488.5,
        -3837.882568359375,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1459583193063736,
        -0.6476463675498962,
        0.7478305101394653
      ],
      "plane_d": -3571.171630859375,
      "bbox_min": [
        -1497.8302001953125,
        -3839.450927734375,
        1158.52587890625
      ],
      "bbox_max": [
        -1488.5,
        -3838.42138671875,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25148263573646545,
        -0.6435429453849792,
        -0.7229169607162476
      ],
      "plane_d": -1258.115234375,
      "bbox_min": [
        -1488.5885009765625,
        -3839.450927734375,
        1158.83544921875
      ],
      "bbox_max": [
        -1488.5,
        -3838.42138671875,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1497.2933349609375,
        -3835.378662109375,
        1158.6483154296875
      ],
      "bbox_max": [
        -1488.5,
        -3834.357177734375,
        1160.654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1540.27197265625,
        -3837.039794921875,
        1154.7894287109375
      ],
      "bbox_max": [
        -1488.5,
        -3823.53662109375,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13927562534809113,
        0.6585193872451782,
        0.7395638227462769
      ],
      "plane_d": 1459.9813232421875,
      "bbox_min": [
        -1502.4818115234375,
        -3835.98388671875,
        1157.4644775390625
      ],
      "bbox_max": [
        -1488.5,
        -3834.34912109375,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1497.453125,
        -3835.378662109375,
        1158.61181640625
      ],
      "bbox_max": [
        -1488.5,
        -3834.34912109375,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25438040494918823,
        0.6431249380111694,
        -0.7222747802734375
      ],
      "plane_d": 3682.2705078125,
      "bbox_min": [
        -1488.5865478515625,
        -3835.378662109375,
        1158.83544921875
      ],
      "bbox_max": [
        -1488.5,
        -3834.34912109375,
        1159.7449951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40388238430023193,
        0.6397219300270081,
        -0.6539379358291626
      ],
      "plane_d": 2625.393798828125,
      "bbox_min": [
        -1490.0,
        -3856.38720703125,
        1159.2022705078125
      ],
      "bbox_max": [
        -1477.7608642578125,
        -3851.267578125,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1531.031982421875,
        -3845.614013671875,
        1154.674560546875
      ],
      "bbox_max": [
        -1447.274658203125,
        -3836.999267578125,
        1164.16455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1502.481689453125,
        -3842.060546875,
        1157.464599609375
      ],
      "bbox_max": [
        -1447.274658203125,
        -3837.90673828125,
        1164.16455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1459583193063736,
        -0.6476463675498962,
        0.7478305101394653
      ],
      "plane_d": -3571.171630859375,
      "bbox_min": [
        -1502.481689453125,
        -3842.060546875,
        1157.464599609375
      ],
      "bbox_max": [
        -1447.274658203125,
        -3837.90673828125,
        1164.16455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25148263573646545,
        -0.6435429453849792,
        -0.7229169607162476
      ],
      "plane_d": -1258.115234375,
      "bbox_min": [
        -1502.481689453125,
        -3842.060546875,
        1157.464599609375
      ],
      "bbox_max": [
        -1447.274658203125,
        -3837.90673828125,
        1164.16455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22243961691856384,
        0.0,
        0.9749464392662048
      ],
      "plane_d": -1462.677490234375,
      "bbox_min": [
        -1502.481689453125,
        -3838.953857421875,
        1157.464599609375
      ],
      "bbox_max": [
        -1497.8306884765625,
        -3837.90673828125,
        1158.5257568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": -299.47210693359375,
      "bbox_min": [
        -1448.14404296875,
        -3842.060546875,
        1162.7923583984375
      ],
      "bbox_max": [
        -1447.274658203125,
        -3839.93896484375,
        1164.16455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": -299.47210693359375,
      "bbox_min": [
        -1502.48193359375,
        -3835.95849609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1437.5704345703125,
        -3816.85791015625,
        1165.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13927562534809113,
        0.6585193872451782,
        0.7395638227462769
      ],
      "plane_d": 1459.9813232421875,
      "bbox_min": [
        -1502.48193359375,
        -3835.95849609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1488.5,
        -3833.87109375,
        1159.7215576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1502.48193359375,
        -3835.95849609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1488.5,
        -3833.87109375,
        1159.7215576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25438040494918823,
        0.6431249380111694,
        -0.7222747802734375
      ],
      "plane_d": 3682.2705078125,
      "bbox_min": [
        -1502.48193359375,
        -3835.95849609375,
        1157.4644775390625
      ],
      "bbox_max": [
        -1488.5,
        -3833.87109375,
        1159.7215576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25438040494918823,
        0.6431249380111694,
        -0.7222747802734375
      ],
      "plane_d": 3682.2705078125,
      "bbox_min": [
        -1532.2261962890625,
        -3861.75732421875,
        1149.0
      ],
      "bbox_max": [
        -1437.8172607421875,
        -3815.4951171875,
        1163.804931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25148263573646545,
        -0.6435429453849792,
        -0.7229169607162476
      ],
      "plane_d": -1258.115234375,
      "bbox_min": [
        -1532.2261962890625,
        -3861.75732421875,
        1149.0
      ],
      "bbox_max": [
        -1456.2547607421875,
        -3830.747314453125,
        1161.9970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2525845766067505,
        -0.6334431171417236,
        -0.7314034104347229
      ],
      "plane_d": -1207.873291015625,
      "bbox_min": [
        -1532.2261962890625,
        -3846.584228515625,
        1149.0
      ],
      "bbox_max": [
        -1488.5,
        -3830.747314453125,
        1158.83544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13927562534809113,
        0.6585193872451782,
        0.7395638227462769
      ],
      "plane_d": 1459.9813232421875,
      "bbox_min": [
        -1532.2261962890625,
        -3846.584228515625,
        1149.142822265625
      ],
      "bbox_max": [
        -1493.7813720703125,
        -3830.747314453125,
        1158.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.142422154545784,
        -0.6581339240074158,
        0.7393075823783875
      ],
      "plane_d": -3596.271240234375,
      "bbox_min": [
        -1530.847900390625,
        -3846.584228515625,
        1149.3876953125
      ],
      "bbox_max": [
        -1493.7813720703125,
        -3831.058837890625,
        1158.317626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1429041028022766,
        0.6479148268699646,
        0.7481876611709595
      ],
      "plane_d": 1403.8985595703125,
      "bbox_min": [
        -1530.847900390625,
        -3842.385986328125,
        1149.3876953125
      ],
      "bbox_max": [
        -1498.181640625,
        -3831.058837890625,
        1157.88623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22243961691856384,
        0.0,
        0.9749464392662048
      ],
      "plane_d": -1462.677490234375,
      "bbox_min": [
        -1530.7938232421875,
        -3842.385986328125,
        1149.8380126953125
      ],
      "bbox_max": [
        -1498.1817626953125,
        -3833.629150390625,
        1157.8861083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1459583193063736,
        -0.6476463675498962,
        0.7478305101394653
      ],
      "plane_d": -3571.171630859375,
      "bbox_min": [
        -1528.3603515625,
        -3842.385986328125,
        1149.8380126953125
      ],
      "bbox_max": [
        -1498.1817626953125,
        -3838.953857421875,
        1157.8861083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1530.7938232421875,
        -3838.25,
        1152.8411865234375
      ],
      "bbox_max": [
        -1529.8492431640625,
        -3836.467529296875,
        1153.88427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1530.847900390625,
        -3836.88134765625,
        1153.51953125
      ],
      "bbox_max": [
        -1530.7589111328125,
        -3836.365478515625,
        1153.94873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1530.8150634765625,
        -3846.584228515625,
        1150.6070556640625
      ],
      "bbox_max": [
        -1526.5599365234375,
        -3836.796875,
        1154.9923095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8834781646728516,
        0.34947478771209717,
        0.31198322772979736
      ],
      "plane_d": 2333.29296875,
      "bbox_min": [
        -1532.2261962890625,
        -3837.619140625,
        1153.558349609375
      ],
      "bbox_max": [
        -1530.75244140625,
        -3833.7646484375,
        1154.692626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40388238430023193,
        0.6397219300270081,
        -0.6539379358291626
      ],
      "plane_d": 2625.393798828125,
      "bbox_min": [
        -1484.7591552734375,
        -3861.75732421875,
        1149.0
      ],
      "bbox_max": [
        -1465.84521484375,
        -3849.70263671875,
        1159.888427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25941982865333557,
        0.9235610961914062,
        -0.28237614035606384
      ],
      "plane_d": 3501.04541015625,
      "bbox_min": [
        -1466.3419189453125,
        -3855.188720703125,
        1149.0
      ],
      "bbox_max": [
        -1448.14404296875,
        -3842.060546875,
        1162.7923583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40388238430023193,
        0.6397219300270081,
        -0.6539379358291626
      ],
      "plane_d": 2625.393798828125,
      "bbox_min": [
        -1466.3419189453125,
        -3855.188720703125,
        1149.0
      ],
      "bbox_max": [
        -1455.5,
        -3848.34375,
        1154.0601806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9292333126068115,
        -0.36757397651672363,
        0.037616483867168427
      ],
      "plane_d": -3.6543502807617188,
      "bbox_min": [
        -1565.0,
        -3880.573974609375,
        1165.875
      ],
      "bbox_max": [
        -1422.0,
        -3748.426025390625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9236207604408264,
        -0.3804936707019806,
        0.046360667794942856
      ],
      "plane_d": -71.6837158203125,
      "bbox_min": [
        -1565.0,
        -3831.294921875,
        1165.875
      ],
      "bbox_max": [
        -1535.80029296875,
        -3771.1904296875,
        1212.125
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1209.0,
      "bbox_min": [
        -1565.0,
        -3830.406494140625,
        1185.1083984375
      ],
      "bbox_max": [
        -1535.80029296875,
        -3771.1904296875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1565.0,
        -3830.329345703125,
        1209.0
      ],
      "bbox_max": [
        -1540.041259765625,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3779.426025390625,
      "bbox_min": [
        -1550.25,
        -3779.426025390625,
        1209.0
      ],
      "bbox_max": [
        -1540.041259765625,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11986037343740463,
        -0.01661691628396511,
        -0.9926517009735107
      ],
      "plane_d": 929.6527099609375,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1185.1083984375
      ],
      "bbox_max": [
        -1535.80029296875,
        -3771.1904296875,
        1202.6483154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.11987996846437454,
        0.0166347436606884,
        0.9926490783691406
      ],
      "plane_d": -931.5409545898438,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1187.1480712890625
      ],
      "bbox_max": [
        -1536.044189453125,
        -3771.598388671875,
        1202.6483154296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37255409359931946,
        -0.9278126358985901,
        -0.019166624173521996
      ],
      "plane_d": -4086.9072265625,
      "bbox_min": [
        -1550.404296875,
        -3806.914306640625,
        1187.4571533203125
      ],
      "bbox_max": [
        -1550.283447265625,
        -3806.906494140625,
        1189.4749755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9552854299545288,
        0.29568547010421753
      ],
      "plane_d": -3980.24658203125,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1546.286865234375,
        -3796.048828125,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9443010687828064,
        -0.32908305525779724
      ],
      "plane_d": -3190.69970703125,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1546.286865234375,
        -3796.048828125,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3234235644340515,
        0.9462543725967407
      ],
      "plane_d": -2356.69140625,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1546.6258544921875,
        -3797.40576171875,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2841670513153076,
        -0.9587748050689697
      ],
      "plane_d": 72.675537109375,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1547.1278076171875,
        -3797.561279296875,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3159768283367157,
        0.9487669467926025
      ],
      "plane_d": 71.0660400390625,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1548.285400390625,
        -3801.609375,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3402261734008789,
        -0.9403436779975891
      ],
      "plane_d": 2424.4306640625,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1192.6119384765625
      ],
      "bbox_max": [
        -1549.007568359375,
        -3801.96533203125,
        1202.6483154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9331526160240173,
        0.3594805896282196
      ],
      "plane_d": 3122.766357421875,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1192.6119384765625
      ],
      "bbox_max": [
        -1550.12548828125,
        -3805.90185546875,
        1201.0870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9598159193992615,
        -0.28063055872917175
      ],
      "plane_d": 3990.390380859375,
      "bbox_min": [
        -1565.0,
        -3807.52587890625,
        1196.82763671875
      ],
      "bbox_max": [
        -1550.7069091796875,
        -3806.280517578125,
        1201.0870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1209.0,
      "bbox_min": [
        -1561.0865478515625,
        -3831.294921875,
        1165.875
      ],
      "bbox_max": [
        -1540.0250244140625,
        -3779.426025390625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1561.0865478515625,
        -3831.231689453125,
        1209.0
      ],
      "bbox_max": [
        -1540.0250244140625,
        -3779.426025390625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.5128173828125,
        -3815.135009765625,
        1209.0
      ],
      "bbox_max": [
        -1540.0250244140625,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3779.426025390625,
      "bbox_min": [
        -1540.1165771484375,
        -3779.426025390625,
        1209.0
      ],
      "bbox_max": [
        -1540.0250244140625,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.75,
        -3815.5244140625,
        1210.5
      ],
      "bbox_max": [
        -1554.211181640625,
        -3814.372314453125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1554.75,
        -3815.5244140625,
        1211.1488037109375
      ],
      "bbox_max": [
        -1554.301513671875,
        -3814.75,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.2939453125,
        -3814.7607421875,
        1165.875
      ],
      "bbox_max": [
        -1543.6331787109375,
        -3790.6572265625,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11986037343740463,
        -0.01661691628396511,
        -0.9926517009735107
      ],
      "plane_d": 929.6527099609375,
      "bbox_min": [
        -1550.3851318359375,
        -3807.01025390625,
        1186.4454345703125
      ],
      "bbox_max": [
        -1543.6331787109375,
        -3790.6572265625,
        1189.4873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014337639324367046,
        -0.09165068715810776,
        -0.9956880807876587
      ],
      "plane_d": 855.658935546875,
      "bbox_min": [
        -1550.283447265625,
        -3807.002685546875,
        1187.3099365234375
      ],
      "bbox_max": [
        -1549.3243408203125,
        -3805.154541015625,
        1187.469482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0142056904733181,
        0.09197483956813812,
        0.9956600666046143
      ],
      "plane_d": -856.1967163085938,
      "bbox_min": [
        -1550.3851318359375,
        -3807.01025390625,
        1189.317138671875
      ],
      "bbox_max": [
        -1549.363037109375,
        -3805.047119140625,
        1189.4873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37255409359931946,
        -0.9278126358985901,
        -0.019166624173521996
      ],
      "plane_d": -4086.9072265625,
      "bbox_min": [
        -1550.3851318359375,
        -3807.01025390625,
        1189.4443359375
      ],
      "bbox_max": [
        -1550.1446533203125,
        -3806.914306640625,
        1189.4873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1191.5,
      "bbox_min": [
        -1562.0,
        -3880.573974609375,
        1190.0
      ],
      "bbox_max": [
        -1490.9088134765625,
        -3840.385498046875,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25031331181526184,
        0.928065836429596,
        0.2757481336593628
      ],
      "plane_d": 3626.74951171875,
      "bbox_min": [
        -1562.0,
        -3880.573974609375,
        1190.0
      ],
      "bbox_max": [
        -1490.9088134765625,
        -3840.385498046875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        -0.49065542221069336,
        0.0
      ],
      "plane_d": -594.5977783203125,
      "bbox_min": [
        -1562.0,
        -3880.573974609375,
        1190.0
      ],
      "bbox_max": [
        -1490.9088134765625,
        -3840.844482421875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 525.7608642578125,
      "bbox_min": [
        -1562.0,
        -3845.5,
        1190.0
      ],
      "bbox_max": [
        -1559.3785400390625,
        -3840.844482421875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 525.7608642578125,
      "bbox_min": [
        -1559.596435546875,
        -3847.443359375,
        1190.0
      ],
      "bbox_max": [
        -1536.38525390625,
        -3840.385498046875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1536.7005615234375,
        -3847.443359375,
        1190.0
      ],
      "bbox_max": [
        -1536.38525390625,
        -3846.7353515625,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25031331181526184,
        0.928065836429596,
        0.2757481336593628
      ],
      "plane_d": 3626.74951171875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1191.5
      ],
      "bbox_max": [
        -1491.875,
        -3847.11328125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3848.84033203125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1547.942626953125,
        -3848.84033203125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1552.1025390625,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1552.1025390625,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1552.1025390625,
        -3873.165771484375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1209.0,
      "bbox_min": [
        -1550.6630859375,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1547.942626953125,
        -3848.84033203125,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3849.573974609375,
      "bbox_min": [
        -1550.3670654296875,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1547.942626953125,
        -3849.365966796875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1550.3670654296875,
        -3849.573974609375,
        1210.5
      ],
      "bbox_max": [
        -1549.595703125,
        -3849.365966796875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1503.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1503.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1500.1025390625,
        -3873.165771484375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1551.0811767578125,
        -3852.90625,
        1191.5
      ],
      "bbox_max": [
        -1536.564697265625,
        -3847.11328125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1550.793212890625,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1545.8262939453125,
        -3848.609130859375,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3849.573974609375,
      "bbox_min": [
        -1549.5955810546875,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1545.8262939453125,
        -3849.573974609375,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25031331181526184,
        0.928065836429596,
        0.2757481336593628
      ],
      "plane_d": 3626.74951171875,
      "bbox_min": [
        -1536.51318359375,
        -3853.680419921875,
        1165.875
      ],
      "bbox_max": [
        -1511.7874755859375,
        -3840.65625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1536.51318359375,
        -3847.046142578125,
        1165.875
      ],
      "bbox_max": [
        -1533.5,
        -3840.65625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25229784846305847,
        0.935423731803894,
        0.2476452738046646
      ],
      "plane_d": 2939.42333984375,
      "bbox_min": [
        -1560.5784912109375,
        -3873.165771484375,
        1165.875
      ],
      "bbox_max": [
        -1422.0,
        -3748.426025390625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1196.5,
      "bbox_min": [
        -1491.0072021484375,
        -3873.165771484375,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3837.755615234375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1198.0,
      "bbox_min": [
        -1481.070068359375,
        -3873.165771484375,
        1196.5
      ],
      "bbox_max": [
        -1434.9725341796875,
        -3846.5380859375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3858.573974609375,
      "bbox_min": [
        -1481.070068359375,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1441.75,
        -3858.573974609375,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1444.1025390625,
        -3867.164306640625,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1208.0
      ],
      "bbox_max": [
        -1444.1025390625,
        -3873.165771484375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15774986147880554,
        -0.6464370489120483,
        0.7464811205863953
      ],
      "plane_d": -3582.51513671875,
      "bbox_min": [
        -1491.0072021484375,
        -3859.719970703125,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3837.755615234375,
        1190.7044677734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.04996119812130928,
        -0.6538297533988953,
        -0.7549905180931091
      ],
      "plane_d": -1560.3970947265625,
      "bbox_min": [
        -1442.761962890625,
        -3844.5,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3837.755615234375,
        1171.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17662808299064636,
        0.0,
        0.984277606010437
      ],
      "plane_d": -1405.317138671875,
      "bbox_min": [
        -1439.5968017578125,
        -3840.6298828125,
        1169.43017578125
      ],
      "bbox_max": [
        -1428.5,
        -3837.755615234375,
        1171.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        -0.49065542221069336,
        0.0
      ],
      "plane_d": -594.5977783203125,
      "bbox_min": [
        -1491.0072021484375,
        -3859.719970703125,
        1190.0
      ],
      "bbox_max": [
        -1490.88330078125,
        -3859.500244140625,
        1190.7044677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1204.5,
      "bbox_min": [
        -1522.4468994140625,
        -3768.6982421875,
        1203.0
      ],
      "bbox_max": [
        -1468.3348388671875,
        -3748.426025390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1203.0,
      "bbox_min": [
        -1522.4468994140625,
        -3768.6982421875,
        1203.0
      ],
      "bbox_max": [
        -1468.3348388671875,
        -3748.426025390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 3128.5712890625,
      "bbox_min": [
        -1522.4468994140625,
        -3768.6982421875,
        1203.0
      ],
      "bbox_max": [
        -1468.3348388671875,
        -3748.426025390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 515.38134765625,
      "bbox_min": [
        -1522.4468994140625,
        -3754.103515625,
        1203.0
      ],
      "bbox_max": [
        -1519.25,
        -3748.426025390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2660483419895172,
        -0.9471593499183655,
        -0.1791854053735733
      ],
      "plane_d": -3744.2060546875,
      "bbox_min": [
        -1560.5784912109375,
        -3859.917236328125,
        1165.875
      ],
      "bbox_max": [
        -1422.0,
        -3753.8427734375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1191.5,
      "bbox_min": [
        -1560.5784912109375,
        -3859.917236328125,
        1165.875
      ],
      "bbox_max": [
        -1422.0,
        -3753.8427734375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1190.0,
      "bbox_min": [
        -1559.329345703125,
        -3859.917236328125,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3755.125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3810.426025390625,
      "bbox_min": [
        -1559.329345703125,
        -3859.917236328125,
        1190.0
      ],
      "bbox_max": [
        -1483.0,
        -3769.337158203125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 525.7608642578125,
      "bbox_min": [
        -1559.329345703125,
        -3859.917236328125,
        1190.0
      ],
      "bbox_max": [
        -1483.0,
        -3810.426025390625,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1547.7149658203125,
        -3859.917236328125,
        1190.0
      ],
      "bbox_max": [
        -1483.0,
        -3819.759033203125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        -0.49065542221069336,
        0.0
      ],
      "plane_d": -594.5977783203125,
      "bbox_min": [
        -1547.7149658203125,
        -3859.917236328125,
        1190.0
      ],
      "bbox_max": [
        -1483.0,
        -3819.759033203125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1547.7149658203125,
        -3827.142822265625,
        1190.0
      ],
      "bbox_max": [
        -1544.58447265625,
        -3819.759033203125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1551.553955078125,
        -3820.131103515625,
        1190.0
      ],
      "bbox_max": [
        -1547.50537109375,
        -3810.426025390625,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1551.566650390625,
        -3810.426025390625,
        1190.0
      ],
      "bbox_max": [
        -1525.76416015625,
        -3769.337158203125,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1551.566650390625,
        -3810.426025390625,
        1190.0
      ],
      "bbox_max": [
        -1551.197265625,
        -3810.019775390625,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1525.8870849609375,
        -3852.892333984375,
        1190.0
      ],
      "bbox_max": [
        -1430.337890625,
        -3759.689208984375,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.57080078125,
        -3789.704345703125,
        1190.0
      ],
      "bbox_max": [
        -1438.6343994140625,
        -3772.168701171875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1525.8870849609375,
        -3852.892333984375,
        1190.0
      ],
      "bbox_max": [
        -1430.337890625,
        -3759.689208984375,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1525.8870849609375,
        -3852.892333984375,
        1190.0
      ],
      "bbox_max": [
        -1430.337890625,
        -3759.689208984375,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1525.8870849609375,
        -3769.5556640625,
        1190.0
      ],
      "bbox_max": [
        -1510.4375,
        -3765.421875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1466.38037109375,
        -3852.892333984375,
        1190.0
      ],
      "bbox_max": [
        -1430.337890625,
        -3809.607421875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1437.37158203125,
        -3827.142822265625,
        1190.0
      ],
      "bbox_max": [
        -1430.337890625,
        -3809.607421875,
        1191.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1551.35791015625,
        -3852.891357421875,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3755.125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17662808299064636,
        0.0,
        0.984277606010437
      ],
      "plane_d": -1405.317138671875,
      "bbox_min": [
        -1450.283203125,
        -3841.9296875,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3837.12939453125,
        1171.4215087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15774986147880554,
        -0.6464370489120483,
        0.7464811205863953
      ],
      "plane_d": -3582.51513671875,
      "bbox_min": [
        -1450.283203125,
        -3841.9296875,
        1165.875
      ],
      "bbox_max": [
        -1439.5968017578125,
        -3840.1494140625,
        1169.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14735956490039825,
        0.04173263907432556,
        0.9882021546363831
      ],
      "plane_d": -789.3927001953125,
      "bbox_min": [
        -1551.35791015625,
        -3847.046142578125,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3755.125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09549791365861893,
        0.2457430213689804,
        -0.9646194577217102
      ],
      "plane_d": 1917.10888671875,
      "bbox_min": [
        -1551.35791015625,
        -3846.7353515625,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3755.125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23284251987934113,
        0.17576368153095245,
        -0.9564995765686035
      ],
      "plane_d": 1439.897216796875,
      "bbox_min": [
        -1551.35791015625,
        -3846.7353515625,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3757.375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12145069986581802,
        0.17932634055614471,
        -0.976264238357544
      ],
      "plane_d": 1642.5892333984375,
      "bbox_min": [
        -1551.35791015625,
        -3846.7353515625,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3757.375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25572410225868225,
        -0.9533986449241638,
        -0.16011261940002441
      ],
      "plane_d": -3017.400634765625,
      "bbox_min": [
        -1551.35791015625,
        -3846.7353515625,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3757.375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23266763985157013,
        -0.17577113211154938,
        0.9565407633781433
      ],
      "plane_d": -1442.2081298828125,
      "bbox_min": [
        -1538.1480712890625,
        -3776.882080078125,
        1176.8587646484375
      ],
      "bbox_max": [
        -1481.2139892578125,
        -3757.375,
        1187.49072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2540031969547272,
        -0.9521781206130981,
        -0.1698215901851654
      ],
      "plane_d": -3003.927734375,
      "bbox_min": [
        -1538.1480712890625,
        -3776.882080078125,
        1176.8587646484375
      ],
      "bbox_max": [
        -1490.446533203125,
        -3757.375,
        1187.49072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1538.1480712890625,
        -3776.882080078125,
        1177.7681884765625
      ],
      "bbox_max": [
        -1490.4820556640625,
        -3757.375,
        1187.49072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1536.154296875,
        -3771.874755859375,
        1182.9107666015625
      ],
      "bbox_max": [
        -1517.109130859375,
        -3765.977783203125,
        1187.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11987996846437454,
        0.0166347436606884,
        0.9926490783691406
      ],
      "plane_d": -931.5409545898438,
      "bbox_min": [
        -1536.154296875,
        -3771.874755859375,
        1187.1304931640625
      ],
      "bbox_max": [
        -1535.87255859375,
        -3771.598388671875,
        1187.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11987996846437454,
        0.0166347436606884,
        0.9926490783691406
      ],
      "plane_d": -931.5409545898438,
      "bbox_min": [
        -1538.1480712890625,
        -3776.882080078125,
        1186.8076171875
      ],
      "bbox_max": [
        -1532.710205078125,
        -3771.789306640625,
        1187.49072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25599879026412964,
        -0.947881817817688,
        -0.18969589471817017
      ],
      "plane_d": -3724.524658203125,
      "bbox_min": [
        -1490.566650390625,
        -3762.673583984375,
        1176.8587646484375
      ],
      "bbox_max": [
        -1490.446533203125,
        -3762.292724609375,
        1178.8785400390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.12151883542537689,
        -0.17932486534118652,
        0.9762559533119202
      ],
      "plane_d": -1644.496337890625,
      "bbox_min": [
        -1490.566650390625,
        -3762.673583984375,
        1178.315185546875
      ],
      "bbox_max": [
        -1482.8443603515625,
        -3757.755859375,
        1179.781494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12151883542537689,
        -0.17932486534118652,
        0.9762559533119202
      ],
      "plane_d": -1644.496337890625,
      "bbox_min": [
        -1490.566650390625,
        -3774.15087890625,
        1169.159912109375
      ],
      "bbox_max": [
        -1444.1187744140625,
        -3760.062255859375,
        1178.8785400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.076392762362957,
        0.09464539587497711,
        -0.9925756454467773
      ],
      "plane_d": 1629.0633544921875,
      "bbox_min": [
        -1449.6343994140625,
        -3773.46044921875,
        1170.01025390625
      ],
      "bbox_max": [
        -1444.254638671875,
        -3768.291748046875,
        1170.61474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09559697657823563,
        -0.2458275407552719,
        0.9645880460739136
      ],
      "plane_d": -1919.2694091796875,
      "bbox_min": [
        -1482.8443603515625,
        -3774.15087890625,
        1171.097412109375
      ],
      "bbox_max": [
        -1444.1187744140625,
        -3760.062255859375,
        1178.315185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1446.253662109375,
        -3773.640869140625,
        1171.097412109375
      ],
      "bbox_max": [
        -1444.22265625,
        -3768.622802734375,
        1172.6021728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1446.2408447265625,
        -3773.879150390625,
        1171.14013671875
      ],
      "bbox_max": [
        -1444.174072265625,
        -3768.689208984375,
        1172.6021728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1449.6494140625,
        -3773.68896484375,
        1169.1527099609375
      ],
      "bbox_max": [
        -1444.212890625,
        -3771.953369140625,
        1171.3662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9318848252296448,
        -0.35957205295562744,
        0.04794226586818695
      ],
      "plane_d": 13.91552734375,
      "bbox_min": [
        -1551.35791015625,
        -3816.55810546875,
        1181.1893310546875
      ],
      "bbox_max": [
        -1532.46630859375,
        -3774.901123046875,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014337639324367046,
        -0.09165068715810776,
        -0.9956880807876587
      ],
      "plane_d": 855.658935546875,
      "bbox_min": [
        -1551.35791015625,
        -3816.53369140625,
        1181.1893310546875
      ],
      "bbox_max": [
        -1532.46630859375,
        -3774.901123046875,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0142056904733181,
        0.09197483956813812,
        0.9956600666046143
      ],
      "plane_d": -856.1967163085938,
      "bbox_min": [
        -1551.35791015625,
        -3816.53369140625,
        1184.7679443359375
      ],
      "bbox_max": [
        -1532.46630859375,
        -3774.901123046875,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11986037343740463,
        -0.01661691628396511,
        -0.9926517009735107
      ],
      "plane_d": 929.6527099609375,
      "bbox_min": [
        -1551.322021484375,
        -3816.53369140625,
        1184.7679443359375
      ],
      "bbox_max": [
        -1532.46630859375,
        -3774.901123046875,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1551.322021484375,
        -3816.53369140625,
        1187.469482421875
      ],
      "bbox_max": [
        -1545.6676025390625,
        -3807.002685546875,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37255409359931946,
        -0.9278126358985901,
        -0.019166624173521996
      ],
      "plane_d": -4086.9072265625,
      "bbox_min": [
        -1550.146484375,
        -3808.771728515625,
        1187.469482421875
      ],
      "bbox_max": [
        -1545.6676025390625,
        -3807.002685546875,
        1189.71240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11987996846437454,
        0.0166347436606884,
        0.9926490783691406
      ],
      "plane_d": -931.5409545898438,
      "bbox_min": [
        -1551.35791015625,
        -3812.590576171875,
        1186.8076171875
      ],
      "bbox_max": [
        -1532.710205078125,
        -3775.30908203125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1551.35791015625,
        -3812.590576171875,
        1189.7425537109375
      ],
      "bbox_max": [
        -1550.3409423828125,
        -3809.95556640625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1551.034912109375,
        -3816.1357421875,
        1181.1893310546875
      ],
      "bbox_max": [
        -1547.54736328125,
        -3808.2724609375,
        1188.33203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.052978288382291794,
        -0.02439538948237896,
        0.9982977509498596
      ],
      "plane_d": -1185.232666015625,
      "bbox_min": [
        -1449.6494140625,
        -3812.134765625,
        1165.875
      ],
      "bbox_max": [
        -1431.5377197265625,
        -3771.969970703125,
        1173.6431884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9306172132492065,
        -0.3641214668750763,
        -0.03697614371776581
      ],
      "plane_d": -2679.26171875,
      "bbox_min": [
        -1449.6494140625,
        -3811.341064453125,
        1165.875
      ],
      "bbox_max": [
        -1431.71630859375,
        -3771.969970703125,
        1171.9952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052978236228227615,
        0.02426493912935257,
        -0.9983007907867432
      ],
      "plane_d": 1182.746337890625,
      "bbox_min": [
        -1449.6494140625,
        -3811.341064453125,
        1165.875
      ],
      "bbox_max": [
        -1431.71630859375,
        -3771.969970703125,
        1171.6761474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.076392762362957,
        0.09464539587497711,
        -0.9925756454467773
      ],
      "plane_d": 1629.0633544921875,
      "bbox_min": [
        -1449.6494140625,
        -3811.341064453125,
        1168.25
      ],
      "bbox_max": [
        -1431.71630859375,
        -3771.969970703125,
        1171.6761474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1431.876953125,
        -3805.091064453125,
        1168.2706298828125
      ],
      "bbox_max": [
        -1431.71630859375,
        -3804.556884765625,
        1170.2496337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05283995345234871,
        -0.04213665798306465,
        -0.9977136254310608
      ],
      "plane_d": 929.6295776367188,
      "bbox_min": [
        -1431.876953125,
        -3804.598388671875,
        1168.2706298828125
      ],
      "bbox_max": [
        -1431.8446044921875,
        -3804.556884765625,
        1168.273193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1436.8375244140625,
        -3811.341064453125,
        1168.25
      ],
      "bbox_max": [
        -1431.7457275390625,
        -3804.556884765625,
        1170.2493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1444.2774658203125,
        -3804.556884765625,
        1168.270751953125
      ],
      "bbox_max": [
        -1431.8446044921875,
        -3773.353271484375,
        1170.279541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1432.6947021484375,
        -3804.556884765625,
        1168.270751953125
      ],
      "bbox_max": [
        -1431.8446044921875,
        -3802.503173828125,
        1168.401123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1432.6846923828125,
        -3804.59765625,
        1165.875
      ],
      "bbox_max": [
        -1431.8446044921875,
        -3802.524658203125,
        1168.36474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1432.0,
        -3804.59765625,
        1165.875
      ],
      "bbox_max": [
        -1431.8446044921875,
        -3804.0,
        1168.270751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1434.4901123046875,
        -3810.88134765625,
        1165.875
      ],
      "bbox_max": [
        -1431.8607177734375,
        -3804.0,
        1168.2706298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1434.503662109375,
        -3810.79052734375,
        1165.875
      ],
      "bbox_max": [
        -1434.375,
        -3810.294921875,
        1167.8590087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1433.2686767578125,
        -3805.016845703125,
        1170.2496337890625
      ],
      "bbox_max": [
        -1431.71630859375,
        -3801.26611328125,
        1170.488525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1433.9915771484375,
        -3805.78125,
        1170.2493896484375
      ],
      "bbox_max": [
        -1431.5377197265625,
        -3799.70849609375,
        1173.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1431.775390625,
        -3805.78125,
        1170.2493896484375
      ],
      "bbox_max": [
        -1431.5377197265625,
        -3805.016845703125,
        1173.0147705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.052839647978544235,
        0.04221765697002411,
        0.9977102279663086
      ],
      "plane_d": -931.2799072265625,
      "bbox_min": [
        -1431.775390625,
        -3805.092529296875,
        1170.249755859375
      ],
      "bbox_max": [
        -1431.7161865234375,
        -3805.016845703125,
        1170.2545166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1436.7091064453125,
        -3812.134765625,
        1170.2281494140625
      ],
      "bbox_max": [
        -1431.5850830078125,
        -3805.016845703125,
        1173.6431884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.052839647978544235,
        0.04221765697002411,
        0.9977102279663086
      ],
      "plane_d": -931.2799072265625,
      "bbox_min": [
        -1436.7091064453125,
        -3811.419677734375,
        1170.2529296875
      ],
      "bbox_max": [
        -1431.74560546875,
        -3805.016845703125,
        1170.65234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17662808299064636,
        0.0,
        0.984277606010437
      ],
      "plane_d": -1405.317138671875,
      "bbox_min": [
        -1459.408447265625,
        -3843.542236328125,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3829.02001953125,
        1176.77099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15774986147880554,
        -0.6464370489120483,
        0.7464811205863953
      ],
      "plane_d": -3582.51513671875,
      "bbox_min": [
        -1459.408447265625,
        -3841.718994140625,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3829.02001953125,
        1169.0794677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04691097512841225,
        0.6539501547813416,
        -0.7550818920135498
      ],
      "plane_d": 3452.989013671875,
      "bbox_min": [
        -1446.5,
        -3841.029296875,
        1165.875
      ],
      "bbox_max": [
        -1428.5,
        -3829.02001953125,
        1168.7811279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1446.5,
        -3841.029296875,
        1165.875
      ],
      "bbox_max": [
        -1442.33935546875,
        -3830.248291015625,
        1168.7811279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1446.5,
        -3841.029296875,
        1165.875
      ],
      "bbox_max": [
        -1445.5596923828125,
        -3839.26416015625,
        1168.360107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1446.41015625,
        -3843.542236328125,
        1168.2073974609375
      ],
      "bbox_max": [
        -1443.2137451171875,
        -3833.50048828125,
        1176.77099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15432047843933105,
        -0.021316003054380417,
        -0.9877909421920776
      ],
      "plane_d": 851.4370727539062,
      "bbox_min": [
        -1548.771484375,
        -3846.7353515625,
        1168.535400390625
      ],
      "bbox_max": [
        -1434.201416015625,
        -3804.56494140625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9153919816017151,
        0.3789254128932953,
        0.13591578602790833
      ],
      "plane_d": -32.4227294921875,
      "bbox_min": [
        -1548.771484375,
        -3846.7353515625,
        1168.535400390625
      ],
      "bbox_max": [
        -1434.201416015625,
        -3804.56494140625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15441890060901642,
        0.021571872755885124,
        0.9877700209617615
      ],
      "plane_d": -852.2626953125,
      "bbox_min": [
        -1446.7662353515625,
        -3843.41015625,
        1168.5360107421875
      ],
      "bbox_max": [
        -1434.201416015625,
        -3804.595947265625,
        1176.757568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05283995345234871,
        -0.04213665798306465,
        -0.9977136254310608
      ],
      "plane_d": 929.6295776367188,
      "bbox_min": [
        -1446.7662353515625,
        -3838.040283203125,
        1168.5360107421875
      ],
      "bbox_max": [
        -1434.32763671875,
        -3804.595947265625,
        1172.580810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1444.452392578125,
        -3838.040283203125,
        1171.8563232421875
      ],
      "bbox_max": [
        -1444.046142578125,
        -3837.0234375,
        1172.4461669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1446.0279541015625,
        -3843.41015625,
        1172.3603515625
      ],
      "bbox_max": [
        -1442.7037353515625,
        -3835.0361328125,
        1176.757568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138790965080261,
        0.3783499300479889,
        0.14722895622253418
      ],
      "plane_d": -45.68115234375,
      "bbox_min": [
        -1548.771484375,
        -3846.7353515625,
        1168.535400390625
      ],
      "bbox_max": [
        -1436.7091064453125,
        -3804.56494140625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05283995345234871,
        -0.04213665798306465,
        -0.9977136254310608
      ],
      "plane_d": 929.6295776367188,
      "bbox_min": [
        -1436.8616943359375,
        -3804.68603515625,
        1168.535400390625
      ],
      "bbox_max": [
        -1436.8253173828125,
        -3804.56494140625,
        1168.541748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1548.771484375,
        -3846.7353515625,
        1184.8900146484375
      ],
      "bbox_max": [
        -1535.875,
        -3815.60205078125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1548.771484375,
        -3829.611572265625,
        1185.5926513671875
      ],
      "bbox_max": [
        -1542.5594482421875,
        -3815.60205078125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1548.240478515625,
        -3845.44775390625,
        1172.8260498046875
      ],
      "bbox_max": [
        -1534.3681640625,
        -3814.354248046875,
        1186.1778564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1542.5594482421875,
        -3845.44775390625,
        1172.8260498046875
      ],
      "bbox_max": [
        -1534.3681640625,
        -3829.611572265625,
        1185.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1443.995361328125,
        -3787.0546875,
        1165.875
      ],
      "bbox_max": [
        -1438.7030029296875,
        -3773.9892578125,
        1168.933349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1535.93701171875,
        -3771.419189453125,
        1177.7681884765625
      ],
      "bbox_max": [
        -1490.4820556640625,
        -3757.375,
        1186.2525634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1535.93701171875,
        -3771.419189453125,
        1182.34130859375
      ],
      "bbox_max": [
        -1518.1678466796875,
        -3766.06591796875,
        1186.2525634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1550.3831787109375,
        -3842.40771484375,
        1165.875
      ],
      "bbox_max": [
        -1490.4820556640625,
        -3757.375,
        1185.6011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1538.82763671875,
        -3842.40771484375,
        1165.875
      ],
      "bbox_max": [
        -1490.4820556640625,
        -3757.375,
        1185.6011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11986037343740463,
        -0.01661691628396511,
        -0.9926517009735107
      ],
      "plane_d": 929.6527099609375,
      "bbox_min": [
        -1535.9000244140625,
        -3771.440673828125,
        1185.092529296875
      ],
      "bbox_max": [
        -1535.6448974609375,
        -3771.1904296875,
        1185.1246337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1538.82763671875,
        -3842.40771484375,
        1165.875
      ],
      "bbox_max": [
        -1532.46630859375,
        -3771.36328125,
        1185.6011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11986037343740463,
        -0.01661691628396511,
        -0.9926517009735107
      ],
      "plane_d": 929.6527099609375,
      "bbox_min": [
        -1538.82763671875,
        -3778.793212890625,
        1184.7679443359375
      ],
      "bbox_max": [
        -1532.46630859375,
        -3771.36328125,
        1185.6011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1535.066650390625,
        -3769.9638671875,
        1165.875
      ],
      "bbox_max": [
        -1522.05029296875,
        -3766.3896484375,
        1178.97509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1548.7569580078125,
        -3823.42529296875,
        1165.875
      ],
      "bbox_max": [
        -1439.7718505859375,
        -3767.34375,
        1171.313720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1446.5,
        -3784.3525390625,
        1165.875
      ],
      "bbox_max": [
        -1439.7718505859375,
        -3767.34375,
        1170.61474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1536.3851318359375,
        -3847.046142578125,
        1173.00244140625
      ],
      "bbox_max": [
        -1430.4351806640625,
        -3757.755859375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1438.6343994140625,
        -3810.01953125,
        1173.00244140625
      ],
      "bbox_max": [
        -1430.4351806640625,
        -3789.704345703125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1431.5850830078125,
        -3810.01953125,
        1173.00244140625
      ],
      "bbox_max": [
        -1430.4351806640625,
        -3805.65673828125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1536.3851318359375,
        -3847.046142578125,
        1173.0147705078125
      ],
      "bbox_max": [
        -1430.5982666015625,
        -3757.755859375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1536.3851318359375,
        -3847.046142578125,
        1175.908203125
      ],
      "bbox_max": [
        -1437.3717041015625,
        -3757.755859375,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1536.3851318359375,
        -3772.168701171875,
        1184.087158203125
      ],
      "bbox_max": [
        -1511.7874755859375,
        -3765.534423828125,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1446.080322265625,
        -3847.046142578125,
        1175.908203125
      ],
      "bbox_max": [
        -1437.3717041015625,
        -3827.142822265625,
        1190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1196.5,
      "bbox_min": [
        -1560.5784912109375,
        -3858.573974609375,
        1191.5
      ],
      "bbox_max": [
        -1422.0,
        -3753.8427734375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1204.5,
      "bbox_min": [
        -1560.5784912109375,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1422.0,
        -3753.8427734375,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1203.0,
      "bbox_min": [
        -1553.3760986328125,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1422.0,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        -0.49065542221069336,
        0.0
      ],
      "plane_d": -584.21826171875,
      "bbox_min": [
        -1553.3760986328125,
        -3852.901123046875,
        1203.0
      ],
      "bbox_max": [
        -1429.49462890625,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        -0.49065542221069336,
        -0.0
      ],
      "plane_d": -3197.408203125,
      "bbox_min": [
        -1553.3760986328125,
        -3850.38916015625,
        1203.0
      ],
      "bbox_max": [
        -1460.0,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3818.573974609375,
      "bbox_min": [
        -1539.0,
        -3818.573974609375,
        1203.0
      ],
      "bbox_max": [
        -1460.0,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1539.0,
        -3783.5,
        1203.0
      ],
      "bbox_max": [
        -1460.0,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 515.38134765625,
      "bbox_min": [
        -1533.5599365234375,
        -3773.839111328125,
        1203.0
      ],
      "bbox_max": [
        -1491.505126953125,
        -3753.8427734375,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1500.0875244140625,
        -3764.559326171875,
        1203.0
      ],
      "bbox_max": [
        -1491.505126953125,
        -3762.148681640625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 3128.5712890625,
      "bbox_min": [
        -1539.0,
        -3783.5,
        1203.0
      ],
      "bbox_max": [
        -1460.0,
        -3768.34423828125,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 515.38134765625,
      "bbox_min": [
        -1539.0,
        -3783.5,
        1203.0
      ],
      "bbox_max": [
        -1533.3929443359375,
        -3773.54248046875,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1553.3760986328125,
        -3850.38916015625,
        1203.0
      ],
      "bbox_max": [
        -1538.1368408203125,
        -3813.263671875,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1553.3760986328125,
        -3819.861328125,
        1203.0
      ],
      "bbox_max": [
        -1550.557373046875,
        -3813.263671875,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1453.6527099609375,
        -3852.901123046875,
        1203.0
      ],
      "bbox_max": [
        -1429.49462890625,
        -3774.768798828125,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.0701904296875,
        -3782.0009765625,
        1203.0
      ],
      "bbox_max": [
        -1442.2093505859375,
        -3774.768798828125,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1453.6527099609375,
        -3852.901123046875,
        1203.0
      ],
      "bbox_max": [
        -1429.49462890625,
        -3812.629150390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1453.6527099609375,
        -3852.901123046875,
        1203.0
      ],
      "bbox_max": [
        -1429.49462890625,
        -3812.629150390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1432.4527587890625,
        -3819.861083984375,
        1203.0
      ],
      "bbox_max": [
        -1429.49462890625,
        -3812.629150390625,
        1204.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1198.0,
      "bbox_min": [
        -1553.1673583984375,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1422.0,
        -3760.9189453125,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 568.1190185546875,
      "bbox_min": [
        -1552.4713134765625,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3760.9189453125,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8713537454605103,
        -0.49065542221069336,
        -0.0
      ],
      "plane_d": -3183.9228515625,
      "bbox_min": [
        -1501.0,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3773.46875,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3788.426025390625,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3773.46875,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3788.426025390625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3788.426025390625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3811.1181640625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1429.916259765625,
        -3811.1181640625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3858.573974609375,
      "bbox_min": [
        -1481.25,
        -3858.573974609375,
        1196.5
      ],
      "bbox_max": [
        -1479.59814453125,
        -3858.573974609375,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.320556640625,
        -3788.426025390625,
        1196.5
      ],
      "bbox_max": [
        -1439.3616943359375,
        -3773.46875,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1440.8343505859375,
        -3788.426025390625,
        1196.5
      ],
      "bbox_max": [
        -1439.3616943359375,
        -3784.963623046875,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1552.4713134765625,
        -3848.751220703125,
        1196.5
      ],
      "bbox_max": [
        -1491.2415771484375,
        -3760.9189453125,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1505.9375,
        -3765.046875,
        1196.5
      ],
      "bbox_max": [
        -1491.2415771484375,
        -3760.9189453125,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1552.4713134765625,
        -3848.751220703125,
        1196.5
      ],
      "bbox_max": [
        -1537.3250732421875,
        -3811.6416015625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1552.4713134765625,
        -3823.502197265625,
        1196.5
      ],
      "bbox_max": [
        -1547.5709228515625,
        -3811.6416015625,
        1198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1553.1673583984375,
        -3852.900146484375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3761.20263671875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1504.5875244140625,
        -3764.934326171875,
        1198.0
      ],
      "bbox_max": [
        -1491.3023681640625,
        -3761.20263671875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1553.1673583984375,
        -3852.900146484375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3773.768798828125,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.2628173828125,
        -3784.963623046875,
        1198.0
      ],
      "bbox_max": [
        -1440.8343505859375,
        -3773.768798828125,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1553.1673583984375,
        -3852.900146484375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3811.466796875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1553.1673583984375,
        -3852.900146484375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3811.466796875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1553.1673583984375,
        -3852.900146484375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3811.466796875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1553.1673583984375,
        -3822.662109375,
        1198.0
      ],
      "bbox_max": [
        -1429.5919189453125,
        -3811.466796875,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1553.1673583984375,
        -3822.662109375,
        1198.0
      ],
      "bbox_max": [
        -1548.2601318359375,
        -3812.015869140625,
        1203.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1560.5784912109375,
        -3852.90625,
        1204.5
      ],
      "bbox_max": [
        -1429.0,
        -3762.432373046875,
        1212.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1209.0,
      "bbox_min": [
        -1560.542724609375,
        -3852.9052734375,
        1204.5
      ],
      "bbox_max": [
        -1429.10546875,
        -3762.432373046875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1554.211181640625,
        -3852.9052734375,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3763.28369140625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1494.6875,
        -3764.109375,
        1209.0
      ],
      "bbox_max": [
        -1491.748291015625,
        -3763.28369140625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        0.49065542221069336,
        0.0
      ],
      "plane_d": 3170.79345703125,
      "bbox_min": [
        -1554.211181640625,
        -3852.9052734375,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3775.96875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8713537454605103,
        -0.49065542221069336,
        0.0
      ],
      "plane_d": -572.4166259765625,
      "bbox_min": [
        -1554.211181640625,
        -3851.901123046875,
        1209.0
      ],
      "bbox_max": [
        -1491.0,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1554.211181640625,
        -3851.901123046875,
        1209.0
      ],
      "bbox_max": [
        -1510.75,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3849.573974609375,
      "bbox_min": [
        -1547.3594970703125,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1539.689453125,
        -3849.573974609375,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3779.426025390625,
      "bbox_min": [
        -1554.211181640625,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1510.75,
        -3779.426025390625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3849.573974609375,
      "bbox_min": [
        -1554.211181640625,
        -3849.573974609375,
        1209.0
      ],
      "bbox_max": [
        -1510.75,
        -3814.7607421875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.211181640625,
        -3816.50048828125,
        1209.0
      ],
      "bbox_max": [
        -1553.314208984375,
        -3814.7607421875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1447.7783203125,
        -3852.9052734375,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3775.96875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1444.839111328125,
        -3778.445556640625,
        1209.0
      ],
      "bbox_max": [
        -1443.859375,
        -3775.96875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1447.7783203125,
        -3852.9052734375,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3814.023681640625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1447.7783203125,
        -3852.9052734375,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3814.023681640625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1430.182373046875,
        -3816.50048828125,
        1209.0
      ],
      "bbox_max": [
        -1429.10546875,
        -3814.023681640625,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1554.00244140625,
        -3852.904296875,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3762.432373046875,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1498.737548828125,
        -3764.44677734375,
        1204.5
      ],
      "bbox_max": [
        -1491.56591796875,
        -3762.432373046875,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1554.00244140625,
        -3852.904296875,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3775.06884765625,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.012451171875,
        -3781.112060546875,
        1204.5
      ],
      "bbox_max": [
        -1442.621826171875,
        -3775.06884765625,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1554.00244140625,
        -3852.904296875,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3812.977783203125,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1554.00244140625,
        -3852.904296875,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3812.977783203125,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1554.00244140625,
        -3852.904296875,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3812.977783203125,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1554.00244140625,
        -3819.02099609375,
        1204.5
      ],
      "bbox_max": [
        -1429.2027587890625,
        -3812.977783203125,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.00244140625,
        -3819.02099609375,
        1204.5
      ],
      "bbox_max": [
        -1551.24658203125,
        -3813.637939453125,
        1209.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1554.4310302734375,
        -3852.90625,
        1210.5
      ],
      "bbox_max": [
        -1429.0,
        -3763.567626953125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1493.3375244140625,
        -3763.996826171875,
        1210.5
      ],
      "bbox_max": [
        -1491.80908203125,
        -3763.567626953125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1554.4310302734375,
        -3852.90625,
        1210.5
      ],
      "bbox_max": [
        -1429.0,
        -3776.268798828125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1444.7813720703125,
        -3777.556640625,
        1210.5
      ],
      "bbox_max": [
        -1444.2718505859375,
        -3776.268798828125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1554.4310302734375,
        -3852.90625,
        1210.5
      ],
      "bbox_max": [
        -1429.0,
        -3814.372314453125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1554.4310302734375,
        -3852.90625,
        1210.5
      ],
      "bbox_max": [
        -1429.0,
        -3814.372314453125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1554.301513671875,
        -3815.660400390625,
        1210.5
      ],
      "bbox_max": [
        -1429.0,
        -3814.372314453125,
        1212.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1554.301513671875,
        -3815.660400390625,
        1210.5
      ],
      "bbox_max": [
        -1554.00341796875,
        -3815.135009765625,
        1211.1488037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2570599615573883,
        -0.9530797600746155,
        -0.15987297892570496
      ],
      "plane_d": -3009.98583984375,
      "bbox_min": [
        -1552.2625732421875,
        -3852.895751953125,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3759.972900390625,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26654815673828125,
        -0.9489387273788452,
        -0.1687229424715042
      ],
      "plane_d": -2969.51708984375,
      "bbox_min": [
        -1510.4375,
        -3765.421875,
        1191.5
      ],
      "bbox_max": [
        -1491.038818359375,
        -3759.972900390625,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9242385029792786,
        -0.3807469308376312,
        -0.02854732982814312
      ],
      "plane_d": -2738.58837890625,
      "bbox_min": [
        -1552.2625732421875,
        -3852.895751953125,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3772.46875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9292293787002563,
        -0.3675724267959595,
        -0.03772657737135887
      ],
      "plane_d": -2684.91748046875,
      "bbox_min": [
        -1445.5130615234375,
        -3788.8154296875,
        1191.5
      ],
      "bbox_max": [
        -1439.046875,
        -3772.46875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9161202907562256,
        0.37740254402160645,
        0.13524368405342102
      ],
      "plane_d": -33.3717041015625,
      "bbox_min": [
        -1552.2625732421875,
        -3852.895751953125,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3809.9560546875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.904610276222229,
        0.37266090512275696,
        0.2068912833929062
      ],
      "plane_d": 2577.27294921875,
      "bbox_min": [
        -1552.2625732421875,
        -3852.895751953125,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3809.9560546875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2613757252693176,
        0.9305242300033569,
        0.25652968883514404
      ],
      "plane_d": 2896.662109375,
      "bbox_min": [
        -1552.2625732421875,
        -3852.895751953125,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3809.9560546875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.920160710811615,
        0.363985151052475,
        0.14428803324699402
      ],
      "plane_d": -101.29248046875,
      "bbox_min": [
        -1552.2625732421875,
        -3826.302734375,
        1191.5
      ],
      "bbox_max": [
        -1430.0135498046875,
        -3809.9560546875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.907941997051239,
        0.3591518700122833,
        0.21598899364471436
      ],
      "plane_d": 2519.8916015625,
      "bbox_min": [
        -1552.2625732421875,
        -3826.302734375,
        1191.5
      ],
      "bbox_max": [
        -1545.273681640625,
        -3810.39404296875,
        1196.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1565.0,
        -3961.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3757.125,
        1241.875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1565.0,
        -3961.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1565.0,
        -3961.165771484375,
        1222.0
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3322.59423828125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1546.1025390625,
        -3958.1650390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1549.5675048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1546.1025390625,
        -3961.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1513.1339111328125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1513.1339111328125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1513.1339111328125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1236.0
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1513.1339111328125,
        -3959.375,
        1240.538818359375
      ],
      "bbox_max": [
        -1493.90966796875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1498.995849609375,
        -3957.63818359375,
        1241.2490234375
      ],
      "bbox_max": [
        -1493.90966796875,
        -3955.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1565.0,
        -3955.164306640625,
        1229.115234375
      ],
      "bbox_max": [
        -1439.088623046875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863112136721611,
        0.32000890374183655,
        0.9434747695922852
      ],
      "plane_d": 222.19064331054688,
      "bbox_min": [
        -1563.21875,
        -3934.09375,
        1235.388671875
      ],
      "bbox_max": [
        -1547.6639404296875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1563.21875,
        -3934.09375,
        1236.40478515625
      ],
      "bbox_max": [
        -1558.7713623046875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1565.0,
        -3955.164306640625,
        1229.115234375
      ],
      "bbox_max": [
        -1439.088623046875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09195134043693542,
        0.3409203290939331,
        0.9355844259262085
      ],
      "plane_d": 46.644927978515625,
      "bbox_min": [
        -1453.680419921875,
        -3934.09375,
        1235.388671875
      ],
      "bbox_max": [
        -1442.9595947265625,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1443.341552734375,
        -3934.09375,
        1236.40478515625
      ],
      "bbox_max": [
        -1442.9595947265625,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1565.0,
        -3940.5712890625,
        1233.2723388671875
      ],
      "bbox_max": [
        -1439.088623046875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1443.03125,
        -3934.09375,
        1236.89599609375
      ],
      "bbox_max": [
        -1439.088623046875,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1565.0,
        -3919.165771484375,
        1222.0
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1565.0,
        -3916.1650390625,
        1222.0
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3915.073974609375,
        1236.605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1222.0
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1232.6484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1531.300048828125,
        -3916.1650390625,
        1222.0
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1232.4024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1531.300048828125,
        -3916.1650390625,
        1222.0
      ],
      "bbox_max": [
        -1528.5084228515625,
        -3913.164306640625,
        1232.4024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25721147656440735,
        0.1453804075717926,
        0.9553569555282593
      ],
      "plane_d": -1000.709228515625,
      "bbox_min": [
        -1529.5853271484375,
        -3915.100341796875,
        1231.1463623046875
      ],
      "bbox_max": [
        -1528.5084228515625,
        -3913.164306640625,
        1231.7261962890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25721147656440735,
        -0.1453803926706314,
        -0.9553568363189697
      ],
      "plane_d": 1000.7091064453125,
      "bbox_min": [
        -1529.602783203125,
        -3913.1953125,
        1231.136962890625
      ],
      "bbox_max": [
        -1529.5673828125,
        -3913.164306640625,
        1231.146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1476.1025390625,
        -3916.1650390625,
        1222.0
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1225.1676025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1559.524658203125,
        -3919.165771484375,
        1234.2056884765625
      ],
      "bbox_max": [
        -1556.9833984375,
        -3913.164306640625,
        1236.89599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1565.0,
        -3919.165771484375,
        1224.4813232421875
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09195134043693542,
        0.3409203290939331,
        0.9355844259262085
      ],
      "plane_d": 46.644927978515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1224.4813232421875
      ],
      "bbox_max": [
        -1442.930908203125,
        -3913.164306640625,
        1236.8961181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1224.4813232421875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1232.236083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1224.4813232421875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1231.7490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1224.9217529296875
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1231.7490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3916.1650390625,
        1224.9217529296875
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1230.5025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1443.46630859375,
        -3919.165771484375,
        1234.2056884765625
      ],
      "bbox_max": [
        -1442.930908203125,
        -3913.164306640625,
        1236.8961181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37827789783477783,
        -0.21380925178527832,
        -0.9006616473197937
      ],
      "plane_d": 850.3467407226562,
      "bbox_min": [
        -1565.0,
        -3919.165771484375,
        1229.7431640625
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1529.4930419921875,
        -3919.165771484375,
        1231.234375
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1529.4930419921875,
        -3919.165771484375,
        1231.234375
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1529.4930419921875,
        -3919.165771484375,
        1231.234375
      ],
      "bbox_max": [
        -1526.397216796875,
        -3913.164306640625,
        1233.2786865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25721147656440735,
        -0.1453803926706314,
        -0.9553568363189697
      ],
      "plane_d": 1000.7091064453125,
      "bbox_min": [
        -1529.240966796875,
        -3916.0,
        1231.234375
      ],
      "bbox_max": [
        -1526.397216796875,
        -3913.164306640625,
        1232.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1565.0,
        -3919.165771484375,
        1234.894287109375
      ],
      "bbox_max": [
        -1558.03955078125,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1565.0,
        -3917.256103515625,
        1236.3558349609375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3915.073974609375,
        1240.136962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1565.0,
        -3917.256103515625,
        1236.605224609375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3916.1650390625,
        1240.136962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1565.0,
        -3917.256103515625,
        1239.5384521484375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3915.073974609375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1565.0,
        -3917.256103515625,
        1239.5384521484375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3860553801059723,
        0.07791141420602798,
        0.9191795587539673
      ],
      "plane_d": -1417.220703125,
      "bbox_min": [
        -1528.0,
        -3919.165771484375,
        1229.7431640625
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1230.5025634765625
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1476.1025390625,
        -3919.165771484375,
        1231.4769287109375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3916.1650390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1442.9595947265625,
        -3919.165771484375,
        1234.894287109375
      ],
      "bbox_max": [
        -1437.5035400390625,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1230.8355712890625
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1233.5384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1231.521728515625
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3916.1650390625,
        1233.5384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1528.0,
        -3919.165771484375,
        1232.0
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3915.999755859375,
        1233.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1233.065185546875
      ],
      "bbox_max": [
        -1525.8807373046875,
        -3918.781494140625,
        1233.2801513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1233.125732421875
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3916.1650390625,
        1233.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3873.165771484375,
      "bbox_min": [
        -1565.0,
        -3913.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0863112136721611,
        0.32000890374183655,
        0.9434747695922852
      ],
      "plane_d": 222.19064331054688,
      "bbox_min": [
        -1565.0,
        -3913.164306640625,
        1214.5179443359375
      ],
      "bbox_max": [
        -1426.939453125,
        -3873.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1552.210693359375,
        -3913.164306640625,
        1214.5179443359375
      ],
      "bbox_max": [
        -1490.8555908203125,
        -3873.165771484375,
        1232.781005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1532.4822998046875,
        -3913.164306640625,
        1214.5179443359375
      ],
      "bbox_max": [
        -1490.8555908203125,
        -3873.165771484375,
        1231.557861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25721147656440735,
        -0.1453803926706314,
        -0.9553568363189697
      ],
      "plane_d": 1000.7091064453125,
      "bbox_min": [
        -1532.4822998046875,
        -3913.164306640625,
        1229.0577392578125
      ],
      "bbox_max": [
        -1528.03955078125,
        -3904.594970703125,
        1231.557861328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37827789783477783,
        0.21380923688411713,
        0.9006616473197937
      ],
      "plane_d": -850.3468017578125,
      "bbox_min": [
        -1565.0,
        -3913.164306640625,
        1220.49560546875
      ],
      "bbox_max": [
        -1490.7142333984375,
        -3873.165771484375,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1565.0,
        -3873.165771484375,
        1217.1365966796875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1559.032470703125,
        -3873.165771484375,
        1217.1365966796875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1557.2998046875,
        -3873.165771484375,
        1218.0792236328125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1557.2998046875,
        -3873.165771484375,
        1218.9925537109375
      ],
      "bbox_max": [
        -1548.6373291015625,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1557.2998046875,
        -3873.165771484375,
        1222.4893798828125
      ],
      "bbox_max": [
        -1550.369873046875,
        -3867.164306640625,
        1227.007568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1552.1024169921875,
        -3873.165771484375,
        1221.87646484375
      ],
      "bbox_max": [
        -1548.6373291015625,
        -3870.1650390625,
        1224.1357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1231.1365966796875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1231.1365966796875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3870.0,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1231.1365966796875
      ],
      "bbox_max": [
        -1500.3482666015625,
        -3870.0,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37827789783477783,
        0.21380923688411713,
        0.9006616473197937
      ],
      "plane_d": -850.3468017578125,
      "bbox_min": [
        -1503.6796875,
        -3873.165771484375,
        1232.0
      ],
      "bbox_max": [
        -1500.3482666015625,
        -3870.0,
        1233.4451904296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37827789783477783,
        0.21380923688411713,
        0.9006616473197937
      ],
      "plane_d": -850.3468017578125,
      "bbox_min": [
        -1503.789306640625,
        -3873.165771484375,
        1232.0
      ],
      "bbox_max": [
        -1503.5677490234375,
        -3872.971923828125,
        1232.093017578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1552.102294921875,
        -3873.165771484375,
        1219.5472412109375
      ],
      "bbox_max": [
        -1546.5194091796875,
        -3867.164306640625,
        1223.1021728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1559.032470703125,
        -3873.165771484375,
        1226.394775390625
      ],
      "bbox_max": [
        -1555.5672607421875,
        -3870.164794921875,
        1228.654052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1565.0,
        -3873.165771484375,
        1225.3614501953125
      ],
      "bbox_max": [
        -1555.5675048828125,
        -3867.164306640625,
        1232.5447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863112136721611,
        0.32000890374183655,
        0.9434747695922852
      ],
      "plane_d": 222.19064331054688,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1491.7137451171875,
        -3867.164306640625,
        1219.0023193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1219.0023193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1219.0023193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1555.5675048828125,
        -3867.164306640625,
        1218.0596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1557.300048828125,
        -3870.1650390625,
        1212.125
      ],
      "bbox_max": [
        -1555.5675048828125,
        -3867.164306640625,
        1217.1463623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1215.7523193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1215.435302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1505.300048828125,
        -3870.1650390625,
        1212.125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1214.89306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1500.1025390625,
        -3870.1650390625,
        1212.125
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1214.2591552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1492.7799072265625,
        -3873.165771484375,
        1212.613525390625
      ],
      "bbox_max": [
        -1491.7137451171875,
        -3867.164306640625,
        1214.6678466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09195134043693542,
        0.3409203290939331,
        0.9355844259262085
      ],
      "plane_d": 46.644927978515625,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1491.8426513671875,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1219.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1219.5679931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1212.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1219.2275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1449.300048828125,
        -3870.1650390625,
        1212.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1218.6448974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3870.1650390625,
        1212.125
      ],
      "bbox_max": [
        -1447.5675048828125,
        -3867.164306640625,
        1217.9637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1213.3997802734375
      ],
      "bbox_max": [
        -1425.3543701171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1217.3809814453125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1221.0087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1218.6448974609375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3870.1650390625,
        1221.0087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1213.3997802734375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1217.7611083984375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1217.7611083984375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1219.7998046875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3870.1650390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1213.3997802734375
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1233.00244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1213.7166748046875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1233.00244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1213.7166748046875
      ],
      "bbox_max": [
        -1503.5675048828125,
        -3867.164306640625,
        1232.0596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1214.89306640625
      ],
      "bbox_max": [
        -1503.5675048828125,
        -3870.1650390625,
        1232.0596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1546.6497802734375,
        -3873.165771484375,
        1217.349609375
      ],
      "bbox_max": [
        -1543.279052734375,
        -3867.164306640625,
        1220.49560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863112136721611,
        0.32000890374183655,
        0.9434747695922852
      ],
      "plane_d": 222.19064331054688,
      "bbox_min": [
        -1565.0,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3852.90625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12076537311077118,
        0.28706032037734985,
        0.9502694606781006
      ],
      "plane_d": 137.98910522460938,
      "bbox_min": [
        -1493.4788818359375,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1491.842529296875,
        -3865.625,
        1212.7938232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1492.0596923828125,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1491.842529296875,
        -3865.625,
        1212.64404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09195134043693542,
        0.3409203290939331,
        0.9355844259262085
      ],
      "plane_d": 46.644927978515625,
      "bbox_min": [
        -1565.0,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3852.90625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13217905163764954,
        0.31419071555137634,
        0.9401132464408875
      ],
      "plane_d": -122.18588256835938,
      "bbox_min": [
        -1491.875,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1490.77685546875,
        -3865.625,
        1212.7938232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7728441953659058,
        0.20411746203899384,
        0.6008726358413696
      ],
      "plane_d": -1058.4298095703125,
      "bbox_min": [
        -1565.0,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3852.90625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1565.0,
        -3867.164306640625,
        1212.125
      ],
      "bbox_max": [
        -1539.03125,
        -3852.90625,
        1231.5113525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3870232403278351,
        -0.91995769739151,
        0.06237655133008957
      ],
      "plane_d": -4115.60400390625,
      "bbox_min": [
        -1565.0,
        -3858.25,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3757.125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25656044483184814,
        -0.9512277841567993,
        -0.17129632830619812
      ],
      "plane_d": -3755.42626953125,
      "bbox_min": [
        -1491.875,
        -3785.205810546875,
        1212.125
      ],
      "bbox_max": [
        -1441.1708984375,
        -3763.875,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9243922233581543,
        -0.3808102309703827,
        -0.021967947483062744
      ],
      "plane_d": -2747.0244140625,
      "bbox_min": [
        -1444.71875,
        -3785.205810546875,
        1212.125
      ],
      "bbox_max": [
        -1441.1708984375,
        -3776.59375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2481970340013504,
        -0.9202195405960083,
        0.30264532566070557
      ],
      "plane_d": -3460.15625,
      "bbox_min": [
        -1565.0,
        -3858.25,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3757.125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7420270442962646,
        0.30568352341651917,
        0.5966183543205261
      ],
      "plane_d": -617.426513671875,
      "bbox_min": [
        -1565.0,
        -3858.25,
        1212.125
      ],
      "bbox_max": [
        -1423.0,
        -3776.59375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7655431628227234,
        -0.31537118554115295,
        0.5607892870903015
      ],
      "plane_d": -692.5806884765625,
      "bbox_min": [
        -1565.0,
        -3856.04443359375,
        1212.125
      ],
      "bbox_max": [
        -1429.0,
        -3776.59375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8461481332778931,
        -0.22347791492938995,
        0.4838296175003052
      ],
      "plane_d": -123.425537109375,
      "bbox_min": [
        -1565.0,
        -3856.04443359375,
        1212.125
      ],
      "bbox_max": [
        -1429.0,
        -3782.40625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9243922233581543,
        -0.3808102309703827,
        -0.021967947483062744
      ],
      "plane_d": -2747.0244140625,
      "bbox_min": [
        -1565.0,
        -3856.04443359375,
        1212.125
      ],
      "bbox_max": [
        -1429.0,
        -3782.40625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.526726484298706,
        0.21698889136314392,
        0.821872889995575
      ],
      "plane_d": 650.4736938476562,
      "bbox_min": [
        -1565.0,
        -3856.04443359375,
        1212.125
      ],
      "bbox_max": [
        -1539.03125,
        -3814.75,
        1229.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9400486946105957,
        0.3318715989589691,
        0.07854735851287842
      ],
      "plane_d": -327.3753356933594,
      "bbox_min": [
        -1684.7525634765625,
        -3927.349365234375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3722.95654296875,
        1241.875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.540560245513916,
        0.1427684724330902,
        0.8291029930114746
      ],
      "plane_d": 377.03619384765625,
      "bbox_min": [
        -1583.25,
        -3927.349365234375,
        1222.0
      ],
      "bbox_max": [
        -1565.0,
        -3856.04443359375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1222.0
      ],
      "bbox_max": [
        -1565.0,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1222.0
      ],
      "bbox_max": [
        -1565.0,
        -3913.164306640625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1566.1025390625,
        -3915.073974609375,
        1222.0
      ],
      "bbox_max": [
        -1565.0,
        -3913.164306640625,
        1240.151123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1567.1614990234375,
        -3919.165771484375,
        1240.136962890625
      ],
      "bbox_max": [
        -1565.0,
        -3917.256103515625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1567.1614990234375,
        -3919.165771484375,
        1241.1845703125
      ],
      "bbox_max": [
        -1566.1025390625,
        -3919.165771484375,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1210.5,
      "bbox_min": [
        -1570.0,
        -3823.37939453125,
        1210.5
      ],
      "bbox_max": [
        -1565.0,
        -3805.62060546875,
        1210.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30773651599884033,
        0.8878681659698486,
        0.3420356214046478
      ],
      "plane_d": 3452.8310546875,
      "bbox_min": [
        -1588.7445068359375,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3160887360572815,
        0.8966366648674011,
        0.3100493848323822
      ],
      "plane_d": 3537.570556640625,
      "bbox_min": [
        -1588.7445068359375,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22635890543460846,
        0.3077753186225891,
        0.9241406917572021
      ],
      "plane_d": 423.4731140136719,
      "bbox_min": [
        -1588.7445068359375,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2301313579082489,
        0.2641068398952484,
        0.9366360902786255
      ],
      "plane_d": 248.48226928710938,
      "bbox_min": [
        -1588.7445068359375,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22900830209255219,
        0.9246544241905212,
        -0.30425187945365906
      ],
      "plane_d": 4243.1806640625,
      "bbox_min": [
        -1588.7445068359375,
        -3807.52587890625,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24755331873893738,
        0.9299408793449402,
        -0.27189570665359497
      ],
      "plane_d": 4253.607421875,
      "bbox_min": [
        -1577.869140625,
        -3807.52587890625,
        1196.82763671875
      ],
      "bbox_max": [
        -1565.0,
        -3802.197998046875,
        1203.3331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0561017245054245,
        0.33969032764434814,
        -0.9388626217842102
      ],
      "plane_d": 2332.813232421875,
      "bbox_min": [
        -1577.869140625,
        -3806.280517578125,
        1201.0870361328125
      ],
      "bbox_max": [
        -1565.0,
        -3802.197998046875,
        1203.3331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1588.7445068359375,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771296977996826,
        0.8323646187782288,
        0.28198686242103577
      ],
      "plane_d": 3581.04736328125,
      "bbox_min": [
        -1588.7445068359375,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3721572160720825,
        0.8958039879798889,
        -0.2429696023464203
      ],
      "plane_d": 4285.61279296875,
      "bbox_min": [
        -1588.7445068359375,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.373865008354187,
        0.8682615160942078,
        -0.3261087238788605
      ],
      "plane_d": 4283.62939453125,
      "bbox_min": [
        -1588.7445068359375,
        -3803.35107421875,
        1198.9986572265625
      ],
      "bbox_max": [
        -1577.869140625,
        -3798.11962890625,
        1203.3331298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31192049384117126,
        0.33954817056655884,
        0.8873627781867981
      ],
      "plane_d": 722.8358154296875,
      "bbox_min": [
        -1588.7349853515625,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3122950494289398,
        0.23172438144683838,
        0.9212901592254639
      ],
      "plane_d": 273.44921875,
      "bbox_min": [
        -1588.7349853515625,
        -3801.8193359375,
        1193.25341796875
      ],
      "bbox_max": [
        -1577.7972412109375,
        -3796.764404296875,
        1196.7579345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06707756966352463,
        -0.37331894040107727,
        0.9252748489379883
      ],
      "plane_d": -2416.044677734375,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018677495419979095,
        -0.45775413513183594,
        0.888882577419281
      ],
      "plane_d": -2828.591552734375,
      "bbox_min": [
        -1587.7021484375,
        -3797.80322265625,
        1193.25341796875
      ],
      "bbox_max": [
        -1577.7972412109375,
        -3790.544677734375,
        1196.8095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.056852661073207855,
        -0.3229004144668579,
        0.9447237849235535
      ],
      "plane_d": -2263.9052734375,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1191.182373046875
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.057448748499155045,
        -0.36992257833480835,
        0.9272847175598145
      ],
      "plane_d": -2420.736328125,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1192.619140625
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24425193667411804,
        -0.9171407222747803,
        0.3149505853652954
      ],
      "plane_d": -4240.76220703125,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1192.619140625
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24047423899173737,
        -0.927253007888794,
        0.28700870275497437
      ],
      "plane_d": -4239.7900390625,
      "bbox_min": [
        -1576.1070556640625,
        -3797.40576171875,
        1192.619140625
      ],
      "bbox_max": [
        -1565.0,
        -3793.87646484375,
        1197.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23977775871753693,
        -0.9185296893119812,
        0.3143402338027954
      ],
      "plane_d": -4238.25048828125,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1194.7152099609375
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36401546001434326,
        -0.9085700511932373,
        -0.20492224395275116
      ],
      "plane_d": -3773.85205078125,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1197.0030517578125
      ],
      "bbox_max": [
        -1565.0,
        -3789.407958984375,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3726314604282379,
        -0.8842419385910034,
        -0.2815350890159607
      ],
      "plane_d": -3602.910888671875,
      "bbox_min": [
        -1575.106201171875,
        -3797.561279296875,
        1197.0030517578125
      ],
      "bbox_max": [
        -1565.0,
        -3792.61181640625,
        1203.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36483234167099,
        -0.8792134523391724,
        -0.3064004182815552
      ],
      "plane_d": -3541.737548828125,
      "bbox_min": [
        -1575.106201171875,
        -3797.561279296875,
        1197.0030517578125
      ],
      "bbox_max": [
        -1565.0,
        -3792.61181640625,
        1201.343017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.277534157037735,
        -0.2730037569999695,
        -0.9211100339889526
      ],
      "plane_d": -364.5202941894531,
      "bbox_min": [
        -1587.968994140625,
        -3806.10302734375,
        1201.1512451171875
      ],
      "bbox_max": [
        -1565.0,
        -3790.53564453125,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37397006154060364,
        -0.18344049155712128,
        -0.9091183543205261
      ],
      "plane_d": -190.80389404296875,
      "bbox_min": [
        -1587.2991943359375,
        -3798.159423828125,
        1201.343017578125
      ],
      "bbox_max": [
        -1565.0,
        -3790.53564453125,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2844557464122772,
        -0.2175765484571457,
        -0.9336730241775513
      ],
      "plane_d": -149.77203369140625,
      "bbox_min": [
        -1576.281005859375,
        -3798.159423828125,
        1201.343017578125
      ],
      "bbox_max": [
        -1565.0,
        -3794.031982421875,
        1204.9193115234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.365901917219162,
        -0.28656020760536194,
        -0.8854371905326843
      ],
      "plane_d": -597.8379516601562,
      "bbox_min": [
        -1587.2991943359375,
        -3798.159423828125,
        1203.589111328125
      ],
      "bbox_max": [
        -1575.0718994140625,
        -3790.53564453125,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07363895326852798,
        0.5025526881217957,
        -0.8614047169685364
      ],
      "plane_d": 2830.622802734375,
      "bbox_min": [
        -1587.2991943359375,
        -3798.159423828125,
        1204.9193115234375
      ],
      "bbox_max": [
        -1576.281005859375,
        -3793.852294921875,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05598605424165726,
        0.38399577140808105,
        -0.9216359257698059
      ],
      "plane_d": 2480.724365234375,
      "bbox_min": [
        -1587.968994140625,
        -3802.197998046875,
        1202.6483154296875
      ],
      "bbox_max": [
        -1565.0,
        -3795.45654296875,
        1207.4381103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0908346027135849,
        0.39480429887771606,
        -0.9142640233039856
      ],
      "plane_d": 2457.963134765625,
      "bbox_min": [
        -1587.968994140625,
        -3802.197998046875,
        1203.3331298828125
      ],
      "bbox_max": [
        -1576.281005859375,
        -3795.45654296875,
        1207.4381103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07363895326852798,
        0.5025526881217957,
        -0.8614047169685364
      ],
      "plane_d": 2830.622802734375,
      "bbox_min": [
        -1587.9515380859375,
        -3798.159423828125,
        1204.9193115234375
      ],
      "bbox_max": [
        -1576.281005859375,
        -3795.45654296875,
        1207.4381103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.526726484298706,
        0.21698889136314392,
        0.821872889995575
      ],
      "plane_d": 650.4736938476562,
      "bbox_min": [
        -1583.25,
        -3858.25,
        1222.8245849609375
      ],
      "bbox_max": [
        -1565.0,
        -3830.394775390625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919979929924011,
        -0.9020994901657104,
        0.18042738735675812
      ],
      "plane_d": -2935.265625,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.478759765625,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13704648613929749,
        -0.9696420431137085,
        0.202516108751297
      ],
      "plane_d": -4079.669677734375,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.478759765625,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12090568244457245,
        -0.9647501111030579,
        0.23374983668327332
      ],
      "plane_d": -4072.881103515625,
      "bbox_min": [
        -1612.5445556640625,
        -3729.0966796875,
        1199.5247802734375
      ],
      "bbox_max": [
        -1611.478759765625,
        -3728.857177734375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1611.5523681640625,
        -3729.0966796875,
        1199.5247802734375
      ],
      "bbox_max": [
        -1611.478759765625,
        -3728.99072265625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1194.8253173828125,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.057301636785268784,
        -0.17891520261764526,
        0.9821944832801819
      ],
      "plane_d": -1750.87548828125,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005586736369878054,
        -0.7528338432312012,
        0.6581868529319763
      ],
      "plane_d": -3617.205322265625,
      "bbox_min": [
        -1669.72021484375,
        -3759.6015625,
        1194.825439453125
      ],
      "bbox_max": [
        -1639.1612548828125,
        -3737.085205078125,
        1198.951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01188768818974495,
        -0.19785048067569733,
        0.980160117149353
      ],
      "plane_d": -1894.767333984375,
      "bbox_min": [
        -1667.2191162109375,
        -3745.82958984375,
        1197.14111328125
      ],
      "bbox_max": [
        -1639.1612548828125,
        -3737.085205078125,
        1198.951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525709509849548,
        0.4922329783439636,
        0.17558322846889496
      ],
      "plane_d": 231.3138427734375,
      "bbox_min": [
        -1641.0491943359375,
        -3739.353271484375,
        1197.199951171875
      ],
      "bbox_max": [
        -1640.690673828125,
        -3738.748291015625,
        1197.28662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2991793155670166,
        -0.2640429139137268,
        0.9169368147850037
      ],
      "plane_d": -1588.2822265625,
      "bbox_min": [
        -1667.2191162109375,
        -3745.5380859375,
        1197.273193359375
      ],
      "bbox_max": [
        -1663.98974609375,
        -3737.085205078125,
        1198.951416015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01188768818974495,
        -0.19785048067569733,
        0.980160117149353
      ],
      "plane_d": -1894.767333984375,
      "bbox_min": [
        -1667.250732421875,
        -3747.852783203125,
        1194.825439453125
      ],
      "bbox_max": [
        -1659.9017333984375,
        -3745.263916015625,
        1197.64990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2991793155670166,
        -0.2640429139137268,
        0.9169368147850037
      ],
      "plane_d": -1588.2822265625,
      "bbox_min": [
        -1667.250732421875,
        -3745.6962890625,
        1197.2418212890625
      ],
      "bbox_max": [
        -1666.306640625,
        -3745.263916015625,
        1197.64990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23366641998291016,
        -0.45364871621131897,
        0.8600017428398132
      ],
      "plane_d": -2340.88671875,
      "bbox_min": [
        -1669.72021484375,
        -3759.6015625,
        1194.825439453125
      ],
      "bbox_max": [
        -1639.7864990234375,
        -3745.343994140625,
        1197.63720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01188768818974495,
        -0.19785048067569733,
        0.980160117149353
      ],
      "plane_d": -1894.767333984375,
      "bbox_min": [
        -1669.72021484375,
        -3753.26171875,
        1194.825439453125
      ],
      "bbox_max": [
        -1660.2626953125,
        -3745.343994140625,
        1197.63720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345056116580963,
        0.2806399166584015,
        0.8558306694030762
      ],
      "plane_d": 754.2279663085938,
      "bbox_min": [
        -1669.72021484375,
        -3752.07568359375,
        1195.975341796875
      ],
      "bbox_max": [
        -1668.0985107421875,
        -3751.597900390625,
        1196.64208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6915339827537537,
        0.28290632367134094,
        0.6646389365196228
      ],
      "plane_d": 1419.906494140625,
      "bbox_min": [
        -1669.6697998046875,
        -3759.6015625,
        1194.825439453125
      ],
      "bbox_max": [
        -1639.7864990234375,
        -3747.219482421875,
        1196.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345056116580963,
        0.2806399166584015,
        0.8558306694030762
      ],
      "plane_d": 754.2279663085938,
      "bbox_min": [
        -1669.6697998046875,
        -3753.30908203125,
        1195.975341796875
      ],
      "bbox_max": [
        -1667.77783203125,
        -3751.642333984375,
        1196.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1640.4752197265625,
        -3748.0009765625,
        1194.825439453125
      ],
      "bbox_max": [
        -1639.7864990234375,
        -3747.219482421875,
        1195.72119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2991793155670166,
        -0.2640429139137268,
        0.9169368147850037
      ],
      "plane_d": -1588.2822265625,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005586736369878054,
        -0.7528338432312012,
        0.6581868529319763
      ],
      "plane_d": -3617.205322265625,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.886497437953949,
        -0.4094448685646057,
        0.21558550000190735
      ],
      "plane_d": -3233.6181640625,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1199.0128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8864945769309998,
        -0.4094434976577759,
        0.21560001373291016
      ],
      "plane_d": -346.1357421875,
      "bbox_min": [
        -1631.4000244140625,
        -3737.531005859375,
        1198.199951171875
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1199.0128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820160031318665,
        0.4073750376701355,
        0.2368403524160385
      ],
      "plane_d": 2671.54150390625,
      "bbox_min": [
        -1631.4000244140625,
        -3737.531005859375,
        1198.199951171875
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1199.0128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8820167183876038,
        0.4073753356933594,
        0.23683711886405945
      ],
      "plane_d": -201.3570556640625,
      "bbox_min": [
        -1631.4000244140625,
        -3737.531005859375,
        1198.199951171875
      ],
      "bbox_max": [
        -1627.199951171875,
        -3731.468994140625,
        1199.0128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9566670656204224,
        0.29118406772613525
      ],
      "plane_d": 3220.876708984375,
      "bbox_min": [
        -1630.0,
        -3737.531005859375,
        1198.199951171875
      ],
      "bbox_max": [
        -1627.199951171875,
        -3731.468994140625,
        1199.0128173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9702408909797668,
        0.24214160442352295
      ],
      "plane_d": -3916.439453125,
      "bbox_min": [
        -1630.0,
        -3737.531005859375,
        1198.199951171875
      ],
      "bbox_max": [
        -1627.199951171875,
        -3737.479736328125,
        1198.405029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526269197463989,
        0.49214035272598267,
        0.17557108402252197
      ],
      "plane_d": 3026.4833984375,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500179648399353,
        -0.49077823758125305,
        0.19132709503173828
      ],
      "plane_d": -673.748779296875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8499592542648315,
        -0.4908689260482788,
        0.1913560926914215
      ],
      "plane_d": -3461.065673828125,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        0.19917234778404236
      ],
      "plane_d": -3906.702880859375,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525709509849548,
        0.4922329783439636,
        0.17558322846889496
      ],
      "plane_d": 231.3138427734375,
      "bbox_min": [
        -1642.0,
        -3741.0,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9858459830284119,
        0.16765399277210236
      ],
      "plane_d": 3485.11474609375,
      "bbox_min": [
        -1640.690673828125,
        -3738.89990234375,
        1197.199951171875
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3738.748291015625,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08123259246349335,
        0.00713521521538496,
        0.996669590473175
      ],
      "plane_d": -1299.83251953125,
      "bbox_min": [
        -1660.2626953125,
        -3745.82958984375,
        1197.14111328125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06193792074918747,
        -0.1452135592699051,
        0.9874597191810608
      ],
      "plane_d": -1827.8341064453125,
      "bbox_min": [
        -1639.8760986328125,
        -3745.810546875,
        1197.3359375
      ],
      "bbox_max": [
        -1634.909423828125,
        -3745.205810546875,
        1197.7364501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009403778240084648,
        -0.10570655763149261,
        0.9943529367446899
      ],
      "plane_d": -1601.9522705078125,
      "bbox_min": [
        -1660.2626953125,
        -3745.82958984375,
        1197.14111328125
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8499592542648315,
        -0.4908689260482788,
        0.1913560926914215
      ],
      "plane_d": -3461.065673828125,
      "bbox_min": [
        -1641.8673095703125,
        -3743.169677734375,
        1197.6033935546875
      ],
      "bbox_max": [
        -1638.196044921875,
        -3738.893798828125,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525709509849548,
        0.4922329783439636,
        0.17558322846889496
      ],
      "plane_d": 231.3138427734375,
      "bbox_min": [
        -1641.8673095703125,
        -3743.169677734375,
        1197.6033935546875
      ],
      "bbox_max": [
        -1638.196044921875,
        -3738.893798828125,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9858459830284119,
        0.16765399277210236
      ],
      "plane_d": 3485.11474609375,
      "bbox_min": [
        -1640.656494140625,
        -3743.169677734375,
        1197.6033935546875
      ],
      "bbox_max": [
        -1638.196044921875,
        -3738.893798828125,
        1198.0911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8864945769309998,
        -0.4094434976577759,
        0.21560001373291016
      ],
      "plane_d": -346.1357421875,
      "bbox_min": [
        -1631.2828369140625,
        -3737.490478515625,
        1198.36279296875
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3729.008056640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8820167183876038,
        0.4073753356933594,
        0.23683711886405945
      ],
      "plane_d": -201.3570556640625,
      "bbox_min": [
        -1631.2828369140625,
        -3737.490478515625,
        1198.36279296875
      ],
      "bbox_max": [
        -1625.9376220703125,
        -3731.705078125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820160031318665,
        0.4073750376701355,
        0.2368403524160385
      ],
      "plane_d": 2671.54150390625,
      "bbox_min": [
        -1629.9791259765625,
        -3737.490478515625,
        1198.36279296875
      ],
      "bbox_max": [
        -1625.9376220703125,
        -3731.705078125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9702408909797668,
        0.24214160442352295
      ],
      "plane_d": -3916.439453125,
      "bbox_min": [
        -1629.9791259765625,
        -3737.490478515625,
        1198.36279296875
      ],
      "bbox_max": [
        -1627.2261962890625,
        -3731.705078125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9566670656204224,
        0.29118406772613525
      ],
      "plane_d": 3220.876708984375,
      "bbox_min": [
        -1629.90087890625,
        -3732.016845703125,
        1198.9752197265625
      ],
      "bbox_max": [
        -1627.303955078125,
        -3731.705078125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1611.5523681640625,
        -3729.536376953125,
        1199.5247802734375
      ],
      "bbox_max": [
        -1611.4798583984375,
        -3729.008056640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8499592542648315,
        -0.4908689260482788,
        0.1913560926914215
      ],
      "plane_d": -3461.065673828125,
      "bbox_min": [
        -1641.8642578125,
        -3743.16845703125,
        1197.609375
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525709509849548,
        0.4922329783439636,
        0.17558322846889496
      ],
      "plane_d": 231.3138427734375,
      "bbox_min": [
        -1641.8642578125,
        -3743.16845703125,
        1197.609375
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500179648399353,
        -0.49077823758125305,
        0.19132709503173828
      ],
      "plane_d": -673.748779296875,
      "bbox_min": [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3738.895263671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        0.19917234778404236
      ],
      "plane_d": -3906.702880859375,
      "bbox_min": [
        -1640.6558837890625,
        -3743.16845703125,
        1197.609375
      ],
      "bbox_max": [
        -1636.9486083984375,
        -3738.895263671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9858459830284119,
        0.16765399277210236
      ],
      "plane_d": 3485.11474609375,
      "bbox_min": [
        -1640.60693359375,
        -3739.224365234375,
        1198.064208984375
      ],
      "bbox_max": [
        -1638.196044921875,
        -3738.895263671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3888595402240753,
        -0.9055222272872925,
        0.1697581261396408
      ],
      "plane_d": -2940.35791015625,
      "bbox_min": [
        -1638.6136474609375,
        -3725.8486328125,
        1199.5247802734375
      ],
      "bbox_max": [
        -1637.429443359375,
        -3725.340087890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616606891155243,
        0.19273701310157776,
        0.9121699929237366
      ],
      "plane_d": 234.82391357421875,
      "bbox_min": [
        -1677.8883056640625,
        -3763.067138671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1635.6566162109375,
        -3745.5810546875,
        1200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6183333396911621,
        0.3028362989425659,
        0.725226879119873
      ],
      "plane_d": 1300.352294921875,
      "bbox_min": [
        -1667.77783203125,
        -3760.73974609375,
        1194.825439453125
      ],
      "bbox_max": [
        -1663.5753173828125,
        -3753.30908203125,
        1197.6732177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06193792074918747,
        -0.1452135592699051,
        0.9874597191810608
      ],
      "plane_d": -1827.8341064453125,
      "bbox_min": [
        -1640.261474609375,
        -3747.655029296875,
        1195.614013671875
      ],
      "bbox_max": [
        -1635.6566162109375,
        -3745.5810546875,
        1197.6343994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1640.261474609375,
        -3747.655029296875,
        1195.614013671875
      ],
      "bbox_max": [
        -1638.3426513671875,
        -3745.810546875,
        1197.3359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1194.825439453125,
      "bbox_min": [
        -1670.476318359375,
        -3777.748046875,
        1194.825439453125
      ],
      "bbox_max": [
        -1610.29443359375,
        -3733.63671875,
        1200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.42900165915489197,
        -0.6274410486221313,
        0.6498270630836487
      ],
      "plane_d": -3831.845947265625,
      "bbox_min": [
        -1670.476318359375,
        -3777.748046875,
        1194.825439453125
      ],
      "bbox_max": [
        -1610.29443359375,
        -3733.63671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08123259246349335,
        0.00713521521538496,
        0.996669590473175
      ],
      "plane_d": -1299.83251953125,
      "bbox_min": [
        -1634.909423828125,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1611.8721923828125,
        -3733.63671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9729576706886292,
        0.23098376393318176
      ],
      "plane_d": 3368.60302734375,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3746.40185546875,
        1198.1722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359395265579224,
        0.498689204454422,
        0.22915960848331451
      ],
      "plane_d": 2951.844482421875,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3746.40185546875,
        1198.1722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3746.40185546875,
        1198.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329302072525024,
        0.4968939423561096,
        0.2435646653175354
      ],
      "plane_d": 214.465087890625,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3746.40185546875,
        1198.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1622.800048828125,
        -3749.0,
        1197.9222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1629.0,
        -3751.59814453125,
        1197.0
      ],
      "bbox_max": [
        -1627.408203125,
        -3749.0,
        1197.5594482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9828016757965088,
        0.08632621169090271,
        0.16324426233768463
      ],
      "plane_d": -1457.733154296875,
      "bbox_min": [
        -1612.7301025390625,
        -3742.5048828125,
        1199.5247802734375
      ],
      "bbox_max": [
        -1611.8721923828125,
        -3733.63671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1329224854707718,
        -0.13213592767715454,
        0.9822788238525391
      ],
      "plane_d": -1887.1551513671875,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1610.29443359375,
        -3739.4228515625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1610.29443359375,
        -3739.4228515625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1610.29443359375,
        -3739.4228515625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1628.83642578125,
        -3751.532470703125,
        1197.2767333984375
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3746.639892578125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329302072525024,
        0.4968939423561096,
        0.2435646653175354
      ],
      "plane_d": 214.465087890625,
      "bbox_min": [
        -1628.83642578125,
        -3749.0,
        1197.5594482421875
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3746.639892578125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9729576706886292,
        0.23098376393318176
      ],
      "plane_d": 3368.60302734375,
      "bbox_min": [
        -1627.2987060546875,
        -3749.0,
        1197.9222412109375
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3746.639892578125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359395265579224,
        0.498689204454422,
        0.22915960848331451
      ],
      "plane_d": 2951.844482421875,
      "bbox_min": [
        -1624.74755859375,
        -3749.0,
        1197.9222412109375
      ],
      "bbox_max": [
        -1623.0528564453125,
        -3746.68017578125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6409640312194824,
        -0.7277829051017761,
        0.24392062425613403
      ],
      "plane_d": -4050.021728515625,
      "bbox_min": [
        -1612.7301025390625,
        -3744.578369140625,
        1199.5247802734375
      ],
      "bbox_max": [
        -1610.29443359375,
        -3739.4228515625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9828016757965088,
        0.08632621169090271,
        0.16324426233768463
      ],
      "plane_d": -1457.733154296875,
      "bbox_min": [
        -1612.7301025390625,
        -3742.5048828125,
        1199.5247802734375
      ],
      "bbox_max": [
        -1612.38037109375,
        -3739.4228515625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3252005875110626,
        -0.4211671054363251,
        0.8466775417327881
      ],
      "plane_d": -3123.650146484375,
      "bbox_min": [
        -1670.476318359375,
        -3777.748046875,
        1194.825439453125
      ],
      "bbox_max": [
        -1621.394287109375,
        -3748.0009765625,
        1200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29123783111572266,
        -0.3972978889942169,
        0.8702499270439148
      ],
      "plane_d": -3007.05078125,
      "bbox_min": [
        -1621.7266845703125,
        -3759.345458984375,
        1196.4898681640625
      ],
      "bbox_max": [
        -1621.394287109375,
        -3759.05859375,
        1196.531982421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6286960244178772,
        0.6948664784431458,
        0.3491445779800415
      ],
      "plane_d": 3241.1376953125,
      "bbox_min": [
        -1670.476318359375,
        -3777.748046875,
        1194.825439453125
      ],
      "bbox_max": [
        -1634.1810302734375,
        -3759.6015625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1799265444278717,
        0.4204210638999939,
        0.8893101811408997
      ],
      "plane_d": 815.7205810546875,
      "bbox_min": [
        -1670.476318359375,
        -3771.298095703125,
        1194.825439453125
      ],
      "bbox_max": [
        -1653.5213623046875,
        -3759.6015625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44355252385139465,
        0.6528941988945007,
        0.6139953136444092
      ],
      "plane_d": 2458.887939453125,
      "bbox_min": [
        -1665.842041015625,
        -3771.298095703125,
        1194.825439453125
      ],
      "bbox_max": [
        -1653.5213623046875,
        -3759.6015625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616606891155243,
        0.19273701310157776,
        0.9121699929237366
      ],
      "plane_d": 234.82391357421875,
      "bbox_min": [
        -1670.476318359375,
        -3763.85888671875,
        1197.6895751953125
      ],
      "bbox_max": [
        -1665.87939453125,
        -3760.758544921875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2777150273323059,
        0.8931024670600891,
        0.35389572381973267
      ],
      "plane_d": 3403.28466796875,
      "bbox_min": [
        -1652.3973388671875,
        -3776.222412109375,
        1194.825439453125
      ],
      "bbox_max": [
        -1639.8321533203125,
        -3770.552490234375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1194.825439453125,
      "bbox_min": [
        -1635.2554931640625,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3744.49072265625,
        1200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6409640312194824,
        -0.7277829051017761,
        0.24392062425613403
      ],
      "plane_d": -4050.021728515625,
      "bbox_min": [
        -1635.2554931640625,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3744.49072265625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09997844696044922,
        -0.12448713183403015,
        0.9871712923049927
      ],
      "plane_d": -1811.268310546875,
      "bbox_min": [
        -1623.03564453125,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1588.806396484375,
        -3744.578369140625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29123783111572266,
        -0.3972978889942169,
        0.8702499270439148
      ],
      "plane_d": -3007.05078125,
      "bbox_min": [
        -1623.03564453125,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1594.0347900390625,
        -3759.28857421875,
        1196.9403076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.32098761200904846,
        -0.4236999452114105,
        0.8470214605331421
      ],
      "plane_d": -3126.75048828125,
      "bbox_min": [
        -1623.03564453125,
        -3778.93701171875,
        1194.825439453125
      ],
      "bbox_max": [
        -1594.0347900390625,
        -3759.345458984375,
        1196.9403076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1605.869873046875,
        -3778.93701171875,
        1196.4212646484375
      ],
      "bbox_max": [
        -1594.0347900390625,
        -3770.25830078125,
        1196.9403076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3170998692512512,
        -0.3699498772621155,
        0.8732609748840332
      ],
      "plane_d": -2949.076416015625,
      "bbox_min": [
        -1608.4658203125,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1594.9217529296875,
        -3770.25830078125,
        1196.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1605.869873046875,
        -3781.7763671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1594.9217529296875,
        -3770.25830078125,
        1196.7197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1329224854707718,
        -0.13213592767715454,
        0.9822788238525391
      ],
      "plane_d": -1887.1551513671875,
      "bbox_min": [
        -1611.75732421875,
        -3778.013427734375,
        1196.7197265625
      ],
      "bbox_max": [
        -1588.806396484375,
        -3744.578369140625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1605.869873046875,
        -3778.013427734375,
        1196.7197265625
      ],
      "bbox_max": [
        -1592.9449462890625,
        -3770.25830078125,
        1197.578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20201623439788818,
        -0.05099478363990784,
        0.9780535697937012
      ],
      "plane_d": -1687.13134765625,
      "bbox_min": [
        -1605.869873046875,
        -3776.878662109375,
        1196.7197265625
      ],
      "bbox_max": [
        -1588.806396484375,
        -3759.230712890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1605.869873046875,
        -3776.878662109375,
        1196.7197265625
      ],
      "bbox_max": [
        -1588.806396484375,
        -3770.25830078125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146341681480408,
        -0.3492834270000458,
        0.20358161628246307
      ],
      "plane_d": -3014.728515625,
      "bbox_min": [
        -1593.5579833984375,
        -3764.210693359375,
        1199.866455078125
      ],
      "bbox_max": [
        -1591.51513671875,
        -3759.230712890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6780288815498352,
        -0.7151387333869934,
        0.16986292600631714
      ],
      "plane_d": -3972.685302734375,
      "bbox_min": [
        -1593.5579833984375,
        -3759.44580078125,
        1199.866455078125
      ],
      "bbox_max": [
        -1593.3369140625,
        -3759.230712890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9830623269081116,
        -0.1477513462305069,
        0.1084347739815712
      ],
      "plane_d": -2249.01025390625,
      "bbox_min": [
        -1635.2554931640625,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3772.860107421875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3525896966457367,
        0.3399505913257599,
        0.8718452453613281
      ],
      "plane_d": 811.5929565429688,
      "bbox_min": [
        -1635.2554931640625,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3776.31640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40932556986808777,
        0.8607157468795776,
        0.30268943309783936
      ],
      "plane_d": 3557.586181640625,
      "bbox_min": [
        -1635.2554931640625,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1601.1234130859375,
        -3776.31640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30472713708877563,
        0.354938805103302,
        0.8838325142860413
      ],
      "plane_d": 776.626220703125,
      "bbox_min": [
        -1635.2554931640625,
        -3787.9794921875,
        1194.825439453125
      ],
      "bbox_max": [
        -1615.9910888671875,
        -3776.31640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30048149824142456,
        0.9013935923576355,
        0.3117698132991791
      ],
      "plane_d": 3522.477783203125,
      "bbox_min": [
        -1635.2554931640625,
        -3778.035888671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1634.1810302734375,
        -3776.31640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2026163637638092,
        0.42885521054267883,
        0.8803577423095703
      ],
      "plane_d": 895.6639404296875,
      "bbox_min": [
        -1617.052734375,
        -3787.9794921875,
        1199.062744140625
      ],
      "bbox_max": [
        -1615.9910888671875,
        -3786.45703125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3374372720718384,
        0.8074705600738525,
        0.48386695981025696
      ],
      "plane_d": 3022.5615234375,
      "bbox_min": [
        -1634.1810302734375,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1601.1234130859375,
        -3776.31640625,
        1199.062744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4140835106372833,
        0.769829273223877,
        0.4856930077075958
      ],
      "plane_d": 3001.704345703125,
      "bbox_min": [
        -1615.9910888671875,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1601.1234130859375,
        -3784.38525390625,
        1199.062744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1614.8726806640625,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1601.1234130859375,
        -3784.38525390625,
        1195.223876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1614.8726806640625,
        -3789.3388671875,
        1194.825439453125
      ],
      "bbox_max": [
        -1603.412353515625,
        -3783.412353515625,
        1195.099365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.027988016605377197,
        -0.003239039797335863,
        0.9996030330657959
      ],
      "plane_d": -1162.2196044921875,
      "bbox_min": [
        -1616.8406982421875,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3781.7763671875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020206311717629433,
        0.03197619691491127,
        0.9992844462394714
      ],
      "plane_d": -1040.7611083984375,
      "bbox_min": [
        -1608.4490966796875,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3781.7763671875,
        1195.223876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006197535432875156,
        0.04091614484786987,
        0.9991433620452881
      ],
      "plane_d": -1048.9676513671875,
      "bbox_min": [
        -1608.4490966796875,
        -3792.0322265625,
        1194.825439453125
      ],
      "bbox_max": [
        -1597.6488037109375,
        -3781.7763671875,
        1195.223876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12492716312408447,
        0.4128115177154541,
        0.9022083878517151
      ],
      "plane_d": 686.4901733398438,
      "bbox_min": [
        -1616.8406982421875,
        -3800.1484375,
        1198.2015380859375
      ],
      "bbox_max": [
        -1604.0960693359375,
        -3786.45703125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45620670914649963,
        0.35775572061538696,
        0.8147921562194824
      ],
      "plane_d": 1113.8070068359375,
      "bbox_min": [
        -1616.8406982421875,
        -3799.945556640625,
        1198.2015380859375
      ],
      "bbox_max": [
        -1604.5966796875,
        -3786.45703125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2026163637638092,
        0.42885521054267883,
        0.8803577423095703
      ],
      "plane_d": 895.6639404296875,
      "bbox_min": [
        -1616.8406982421875,
        -3788.431884765625,
        1199.062744140625
      ],
      "bbox_max": [
        -1615.8834228515625,
        -3786.45703125,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3440810739994049,
        0.5472701191902161,
        0.7629570960998535
      ],
      "plane_d": 1714.277587890625,
      "bbox_min": [
        -1604.5966796875,
        -3803.062744140625,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3788.808837890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17675535380840302,
        0.48145797848701477,
        0.8584612011909485
      ],
      "plane_d": 1082.657958984375,
      "bbox_min": [
        -1604.5966796875,
        -3803.062744140625,
        1195.223876953125
      ],
      "bbox_max": [
        -1594.2252197265625,
        -3792.0322265625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12492716312408447,
        0.4128115177154541,
        0.9022083878517151
      ],
      "plane_d": 686.4901733398438,
      "bbox_min": [
        -1604.5966796875,
        -3803.062744140625,
        1198.2015380859375
      ],
      "bbox_max": [
        -1594.2252197265625,
        -3796.06640625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6506555080413818,
        0.7536596059799194,
        0.09297633171081543
      ],
      "plane_d": 1717.1949462890625,
      "bbox_min": [
        -1594.4664306640625,
        -3803.062744140625,
        1199.8636474609375
      ],
      "bbox_max": [
        -1594.2252197265625,
        -3802.837646484375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6506555080413818,
        0.7536596059799194,
        0.09297633171081543
      ],
      "plane_d": 1717.1949462890625,
      "bbox_min": [
        -1594.4090576171875,
        -3803.01318359375,
        1199.8636474609375
      ],
      "bbox_max": [
        -1594.2252197265625,
        -3802.837646484375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923788905143738,
        -0.05445718392729759,
        0.11053726077079773
      ],
      "plane_d": -1912.82958984375,
      "bbox_min": [
        -1594.3414306640625,
        -3802.954833984375,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3788.808837890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6506555080413818,
        0.7536596059799194,
        0.09297633171081543
      ],
      "plane_d": 1717.1949462890625,
      "bbox_min": [
        -1594.3414306640625,
        -3802.954833984375,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3788.808837890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7576195001602173,
        0.319552481174469,
        0.569121241569519
      ],
      "plane_d": -671.2557983398438,
      "bbox_min": [
        -1594.2252197265625,
        -3802.837646484375,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3788.808837890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31192049384117126,
        0.33954817056655884,
        0.8873627781867981
      ],
      "plane_d": 722.8358154296875,
      "bbox_min": [
        -1588.451904296875,
        -3796.095947265625,
        1195.1622314453125
      ],
      "bbox_max": [
        -1587.1092529296875,
        -3792.1982421875,
        1196.3453369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018677495419979095,
        -0.45775413513183594,
        0.888882577419281
      ],
      "plane_d": -2828.591552734375,
      "bbox_min": [
        -1588.175537109375,
        -3793.692626953125,
        1195.1622314453125
      ],
      "bbox_max": [
        -1587.1092529296875,
        -3792.1982421875,
        1195.9442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9587120413780212,
        0.25203296542167664,
        0.13172127306461334
      ],
      "plane_d": -723.4950561523438,
      "bbox_min": [
        -1594.2252197265625,
        -3802.837646484375,
        1194.825439453125
      ],
      "bbox_max": [
        -1585.92041015625,
        -3788.808837890625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22869792580604553,
        -0.9454362988471985,
        0.2320505827665329
      ],
      "plane_d": -4224.16552734375,
      "bbox_min": [
        -1587.3597412109375,
        -3792.503173828125,
        1195.781982421875
      ],
      "bbox_max": [
        -1585.9212646484375,
        -3789.759765625,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018677495419979095,
        -0.45775413513183594,
        0.888882577419281
      ],
      "plane_d": -2828.591552734375,
      "bbox_min": [
        -1587.3597412109375,
        -3792.503173828125,
        1195.781982421875
      ],
      "bbox_max": [
        -1586.4532470703125,
        -3790.380126953125,
        1196.89013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9172722697257996,
        0.3425288796424866,
        0.20318809151649475
      ],
      "plane_d": -400.2686767578125,
      "bbox_min": [
        -1588.175537109375,
        -3793.49609375,
        1194.825439453125
      ],
      "bbox_max": [
        -1586.52001953125,
        -3788.808837890625,
        1196.89013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8927937746047974,
        0.41206541657447815,
        0.1819930225610733
      ],
      "plane_d": -72.2724609375,
      "bbox_min": [
        -1594.2252197265625,
        -3802.837646484375,
        1194.905029296875
      ],
      "bbox_max": [
        -1588.175537109375,
        -3793.49609375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1589.3226318359375,
        -3797.787841796875,
        1195.25341796875
      ],
      "bbox_max": [
        -1588.175537109375,
        -3793.49609375,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31192049384117126,
        0.33954817056655884,
        0.8873627781867981
      ],
      "plane_d": 722.8358154296875,
      "bbox_min": [
        -1589.3226318359375,
        -3796.764404296875,
        1195.25341796875
      ],
      "bbox_max": [
        -1588.175537109375,
        -3793.49609375,
        1196.883056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771296977996826,
        0.8323646187782288,
        0.28198686242103577
      ],
      "plane_d": 3581.04736328125,
      "bbox_min": [
        -1589.3226318359375,
        -3797.073974609375,
        1196.7579345703125
      ],
      "bbox_max": [
        -1588.7349853515625,
        -3796.701171875,
        1197.001708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6888409852981567,
        0.7130476236343384,
        0.13061854243278503
      ],
      "plane_d": 1456.7122802734375,
      "bbox_min": [
        -1594.2252197265625,
        -3802.837646484375,
        1194.905029296875
      ],
      "bbox_max": [
        -1589.0931396484375,
        -3796.701171875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.883378803730011,
        0.44359084963798523,
        0.15122483670711517
      ],
      "plane_d": 99.20947265625,
      "bbox_min": [
        -1590.4600830078125,
        -3798.532470703125,
        1194.905029296875
      ],
      "bbox_max": [
        -1589.0931396484375,
        -3796.701171875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1589.3226318359375,
        -3797.580322265625,
        1196.883056640625
      ],
      "bbox_max": [
        -1589.0931396484375,
        -3796.701171875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8587794303894043,
        0.4916689395904541,
        0.14408192038536072
      ],
      "plane_d": 329.4835205078125,
      "bbox_min": [
        -1590.4600830078125,
        -3798.532470703125,
        1194.905029296875
      ],
      "bbox_max": [
        -1589.4637451171875,
        -3798.044921875,
        1200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023222729563713074,
        0.23063777387142181,
        0.9727625250816345
      ],
      "plane_d": -259.3750305175781,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.852783203125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2777150273323059,
        0.8931024670600891,
        0.35389572381973267
      ],
      "plane_d": 3403.28466796875,
      "bbox_min": [
        -1655.8948974609375,
        -3778.49609375,
        1200.0
      ],
      "bbox_max": [
        -1634.5936279296875,
        -3769.918701171875,
        1201.525146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30048149824142456,
        0.9013935923576355,
        0.3117698132991791
      ],
      "plane_d": 3522.477783203125,
      "bbox_min": [
        -1639.8321533203125,
        -3778.49609375,
        1200.0
      ],
      "bbox_max": [
        -1634.5936279296875,
        -3776.222412109375,
        1201.525146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1799265444278717,
        0.4204210638999939,
        0.8893101811408997
      ],
      "plane_d": 815.7205810546875,
      "bbox_min": [
        -1655.8948974609375,
        -3772.49560546875,
        1200.0
      ],
      "bbox_max": [
        -1652.3973388671875,
        -3769.918701171875,
        1200.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44355252385139465,
        0.6528941988945007,
        0.6139953136444092
      ],
      "plane_d": 2458.887939453125,
      "bbox_min": [
        -1654.9678955078125,
        -3772.49560546875,
        1200.0
      ],
      "bbox_max": [
        -1652.3973388671875,
        -3770.3154296875,
        1200.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6286960244178772,
        0.6948664784431458,
        0.3491445779800415
      ],
      "plane_d": 3241.1376953125,
      "bbox_min": [
        -1653.5213623046875,
        -3772.49560546875,
        1200.0
      ],
      "bbox_max": [
        -1652.3973388671875,
        -3771.298095703125,
        1200.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22411960363388062,
        0.14097826182842255,
        0.964310884475708
      ],
      "plane_d": -255.48825073242188,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.852783203125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20587696135044098,
        0.16527333855628967,
        0.964520275592804
      ],
      "plane_d": -194.23233032226562,
      "bbox_min": [
        -1683.457275390625,
        -3791.842041015625,
        1200.0
      ],
      "bbox_max": [
        -1652.4920654296875,
        -3741.7509765625,
        1209.3228759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1799265444278717,
        0.4204210638999939,
        0.8893101811408997
      ],
      "plane_d": 815.7205810546875,
      "bbox_min": [
        -1683.211669921875,
        -3773.6298828125,
        1200.0
      ],
      "bbox_max": [
        -1652.4920654296875,
        -3744.402587890625,
        1207.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616606891155243,
        0.19273701310157776,
        0.9121699929237366
      ],
      "plane_d": 234.82391357421875,
      "bbox_min": [
        -1683.211669921875,
        -3773.6298828125,
        1200.0
      ],
      "bbox_max": [
        -1670.0543212890625,
        -3744.402587890625,
        1207.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4345056116580963,
        0.2806399166584015,
        0.8558306694030762
      ],
      "plane_d": 754.2279663085938,
      "bbox_min": [
        -1677.9794921875,
        -3749.348388671875,
        1200.0
      ],
      "bbox_max": [
        -1677.7872314453125,
        -3749.1650390625,
        1200.0374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2991793155670166,
        -0.2640429139137268,
        0.9169368147850037
      ],
      "plane_d": -1588.2822265625,
      "bbox_min": [
        -1677.9794921875,
        -3749.19189453125,
        1200.0
      ],
      "bbox_max": [
        -1677.8773193359375,
        -3749.1650390625,
        1200.0374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9184884428977966,
        -0.08188237249851227,
        0.38687777519226074
      ],
      "plane_d": 769.9463500976562,
      "bbox_min": [
        -1683.211669921875,
        -3773.6298828125,
        1200.0
      ],
      "bbox_max": [
        -1672.5625,
        -3744.402587890625,
        1207.28125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519500613212585,
        -0.7402626872062683,
        0.16423194110393524
      ],
      "plane_d": -1878.4925537109375,
      "bbox_min": [
        -1677.9835205078125,
        -3749.179443359375,
        1200.0
      ],
      "bbox_max": [
        -1672.5625,
        -3744.402587890625,
        1201.8526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5726832747459412,
        -0.7640209794044495,
        0.2971629500389099
      ],
      "plane_d": -2260.0966796875,
      "bbox_min": [
        -1677.9835205078125,
        -3749.1650390625,
        1200.0374755859375
      ],
      "bbox_max": [
        -1676.3385009765625,
        -3747.43408203125,
        1201.8526611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2991793155670166,
        -0.2640429139137268,
        0.9169368147850037
      ],
      "plane_d": -1588.2822265625,
      "bbox_min": [
        -1677.9794921875,
        -3749.179443359375,
        1200.0
      ],
      "bbox_max": [
        -1677.4967041015625,
        -3748.748291015625,
        1200.0374755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8991016149520874,
        0.28666257858276367,
        0.3308185935020447
      ],
      "plane_d": 2195.745849609375,
      "bbox_min": [
        -1683.457275390625,
        -3791.842041015625,
        1200.0
      ],
      "bbox_max": [
        -1669.5517578125,
        -3741.7509765625,
        1209.3228759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519500613212585,
        -0.7402626872062683,
        0.16423194110393524
      ],
      "plane_d": -1878.4925537109375,
      "bbox_min": [
        -1677.9857177734375,
        -3748.4619140625,
        1200.0
      ],
      "bbox_max": [
        -1669.5517578125,
        -3741.7509765625,
        1202.8829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5726832747459412,
        -0.7640209794044495,
        0.2971629500389099
      ],
      "plane_d": -2260.0966796875,
      "bbox_min": [
        -1677.9857177734375,
        -3748.4619140625,
        1201.325439453125
      ],
      "bbox_max": [
        -1675.4141845703125,
        -3746.458984375,
        1202.8829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06890147924423218,
        0.2329796850681305,
        0.9700376391410828
      ],
      "plane_d": -399.50335693359375,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.852783203125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009213004261255264,
        0.25568875670433044,
        0.9667152166366577
      ],
      "plane_d": -211.2101287841797,
      "bbox_min": [
        -1652.4920654296875,
        -3803.0693359375,
        1200.52978515625
      ],
      "bbox_max": [
        -1626.7637939453125,
        -3772.49560546875,
        1209.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2777150273323059,
        0.8931024670600891,
        0.35389572381973267
      ],
      "plane_d": 3403.28466796875,
      "bbox_min": [
        -1652.4920654296875,
        -3778.8251953125,
        1200.52978515625
      ],
      "bbox_max": [
        -1634.48876953125,
        -3772.49560546875,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30048149824142456,
        0.9013935923576355,
        0.3117698132991791
      ],
      "plane_d": 3522.477783203125,
      "bbox_min": [
        -1636.68408203125,
        -3778.8251953125,
        1201.3995361328125
      ],
      "bbox_max": [
        -1634.48876953125,
        -3777.755859375,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.046580925583839417,
        0.26604676246643066,
        0.9628340005874634
      ],
      "plane_d": -228.47975158691406,
      "bbox_min": [
        -1641.2308349609375,
        -3803.0693359375,
        1202.37548828125
      ],
      "bbox_max": [
        -1626.7637939453125,
        -3778.8251953125,
        1209.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.031356535851955414,
        0.4992680251598358,
        0.8658799529075623
      ],
      "plane_d": 800.1124877929688,
      "bbox_min": [
        -1641.2308349609375,
        -3803.0693359375,
        1208.170166015625
      ],
      "bbox_max": [
        -1626.7637939453125,
        -3800.976806640625,
        1209.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21379823982715607,
        0.4614641070365906,
        0.8610117435455322
      ],
      "plane_d": 1061.213134765625,
      "bbox_min": [
        -1627.3739013671875,
        -3803.0693359375,
        1209.0030517578125
      ],
      "bbox_max": [
        -1626.7637939453125,
        -3801.543212890625,
        1209.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06758714467287064,
        -0.07208340615034103,
        -0.9951059222221375
      ],
      "plane_d": 1047.00341796875,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.852783203125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10406290739774704,
        -0.03189871460199356,
        -0.9940590262413025
      ],
      "plane_d": 1257.455322265625,
      "bbox_min": [
        -1678.0,
        -3755.70556640625,
        1209.5
      ],
      "bbox_max": [
        -1650.36865234375,
        -3728.852783203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09344251453876495,
        -0.030930355191230774,
        -0.9951441287994385
      ],
      "plane_d": 1244.7073974609375,
      "bbox_min": [
        -1678.0,
        -3754.2666015625,
        1209.5
      ],
      "bbox_max": [
        -1650.36865234375,
        -3728.852783203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5726832747459412,
        -0.7640209794044495,
        0.2971629500389099
      ],
      "plane_d": -2260.0966796875,
      "bbox_min": [
        -1678.0,
        -3745.5,
        1209.5
      ],
      "bbox_max": [
        -1650.36865234375,
        -3728.852783203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919979929924011,
        -0.9020994901657104,
        0.18042738735675812
      ],
      "plane_d": -2935.265625,
      "bbox_min": [
        -1664.5587158203125,
        -3735.169921875,
        1209.667724609375
      ],
      "bbox_max": [
        -1664.0279541015625,
        -3734.955078125,
        1210.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3888595402240753,
        -0.9055222272872925,
        0.1697581261396408
      ],
      "plane_d": -2940.35791015625,
      "bbox_min": [
        -1664.5587158203125,
        -3737.3095703125,
        1209.6851806640625
      ],
      "bbox_max": [
        -1650.36865234375,
        -3728.852783203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07093045115470886,
        -0.06823669373989105,
        -0.9951444864273071
      ],
      "plane_d": 1067.895751953125,
      "bbox_min": [
        -1664.5587158203125,
        -3737.3095703125,
        1209.6851806640625
      ],
      "bbox_max": [
        -1654.1575927734375,
        -3730.46142578125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919979929924011,
        -0.9020994901657104,
        0.18042738735675812
      ],
      "plane_d": -2935.265625,
      "bbox_min": [
        -1664.5587158203125,
        -3735.008544921875,
        1209.6851806640625
      ],
      "bbox_max": [
        -1662.518798828125,
        -3734.288330078125,
        1210.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.968498706817627,
        -0.23149517178535461,
        0.0917619913816452
      ],
      "plane_d": 647.0894775390625,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.98779296875,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5277895927429199,
        0.10864628851413727,
        0.8423978686332703
      ],
      "plane_d": 278.951904296875,
      "bbox_min": [
        -1684.7347412109375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.98779296875,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8991016149520874,
        0.28666257858276367,
        0.3308185935020447
      ],
      "plane_d": 2195.745849609375,
      "bbox_min": [
        -1684.7347412109375,
        -3791.842041015625,
        1202.30322265625
      ],
      "bbox_max": [
        -1676.194091796875,
        -3746.945556640625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4070289433002472,
        0.2415713369846344,
        0.8808920979499817
      ],
      "plane_d": 533.7755126953125,
      "bbox_min": [
        -1680.3271484375,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.98779296875,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3919979929924011,
        -0.9020994901657104,
        0.18042738735675812
      ],
      "plane_d": -2935.265625,
      "bbox_min": [
        -1678.0,
        -3812.849853515625,
        1200.0
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3728.98779296875,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6519500613212585,
        -0.7402626872062683,
        0.16423194110393524
      ],
      "plane_d": -1878.4925537109375,
      "bbox_min": [
        -1675.4141845703125,
        -3746.458984375,
        1200.0
      ],
      "bbox_max": [
        -1664.0411376953125,
        -3735.169921875,
        1209.667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05410146340727806,
        0.5373115539550781,
        0.8416467905044556
      ],
      "plane_d": 1118.922607421875,
      "bbox_min": [
        -1675.0325927734375,
        -3812.849853515625,
        1208.170166015625
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3800.976806640625,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3147137761116028,
        0.5233975052833557,
        0.7918398976325989
      ],
      "plane_d": 516.2265014648438,
      "bbox_min": [
        -1675.0325927734375,
        -3812.849853515625,
        1208.170166015625
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3800.976806640625,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.031356535851955414,
        0.4992680251598358,
        0.8658799529075623
      ],
      "plane_d": 800.1124877929688,
      "bbox_min": [
        -1653.731201171875,
        -3812.849853515625,
        1208.170166015625
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3800.976806640625,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21475182473659515,
        0.3785727620124817,
        0.9003134369850159
      ],
      "plane_d": 699.7657470703125,
      "bbox_min": [
        -1627.75,
        -3805.670166015625,
        1209.498779296875
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3802.41064453125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21379823982715607,
        0.4614641070365906,
        0.8610117435455322
      ],
      "plane_d": 1061.213134765625,
      "bbox_min": [
        -1627.75,
        -3805.183837890625,
        1209.498779296875
      ],
      "bbox_max": [
        -1626.090087890625,
        -3802.41064453125,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1627.75,
        -3805.670166015625,
        1210.833740234375
      ],
      "bbox_max": [
        -1625.9351806640625,
        -3805.043212890625,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02820013090968132,
        0.5067659616470337,
        0.8616223335266113
      ],
      "plane_d": 838.9363403320312,
      "bbox_min": [
        -1642.2025146484375,
        -3805.84228515625,
        1208.170166015625
      ],
      "bbox_max": [
        -1627.75,
        -3800.976806640625,
        1211.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06886692345142365,
        0.5568208694458008,
        0.8277727961540222
      ],
      "plane_d": 1234.6553955078125,
      "bbox_min": [
        -1669.3817138671875,
        -3811.8486328125,
        1209.611083984375
      ],
      "bbox_max": [
        -1663.6644287109375,
        -3809.1875,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12090568244457245,
        -0.9647501111030579,
        0.23374983668327332
      ],
      "plane_d": -4072.881103515625,
      "bbox_min": [
        -1650.4117431640625,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.100830078125,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13704648613929749,
        -0.9696420431137085,
        0.202516108751297
      ],
      "plane_d": -4079.669677734375,
      "bbox_min": [
        -1638.14794921875,
        -3728.857177734375,
        1200.0
      ],
      "bbox_max": [
        -1612.5445556640625,
        -3723.100830078125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3888595402240753,
        -0.9055222272872925,
        0.1697581261396408
      ],
      "plane_d": -2940.35791015625,
      "bbox_min": [
        -1638.14794921875,
        -3725.648681640625,
        1200.0
      ],
      "bbox_max": [
        -1637.017333984375,
        -3723.100830078125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6409640312194824,
        -0.7277829051017761,
        0.24392062425613403
      ],
      "plane_d": -4050.021728515625,
      "bbox_min": [
        -1650.4117431640625,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.119384765625,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1612.643798828125,
        -3742.421630859375,
        1200.0
      ],
      "bbox_max": [
        -1609.7747802734375,
        -3726.5390625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9828016757965088,
        0.08632621169090271,
        0.16324426233768463
      ],
      "plane_d": -1457.733154296875,
      "bbox_min": [
        -1612.643798828125,
        -3742.421630859375,
        1200.0
      ],
      "bbox_max": [
        -1610.578857421875,
        -3729.536376953125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6780288815498352,
        -0.7151387333869934,
        0.16986292600631714
      ],
      "plane_d": -3972.685302734375,
      "bbox_min": [
        -1650.4117431640625,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.119384765625,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3477695882320404,
        0.32250478863716125,
        -0.880367636680603
      ],
      "plane_d": 1738.03955078125,
      "bbox_min": [
        -1650.4117431640625,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.119384765625,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3456922769546509,
        0.4969053566455841,
        -0.7959786057472229
      ],
      "plane_d": 2301.779296875,
      "bbox_min": [
        -1591.3734130859375,
        -3799.46533203125,
        1209.9708251953125
      ],
      "bbox_max": [
        -1588.3397216796875,
        -3796.899658203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160695314407349,
        0.24138912558555603,
        -0.8218293786048889
      ],
      "plane_d": 1091.73388671875,
      "bbox_min": [
        -1589.6260986328125,
        -3799.00341796875,
        1209.9708251953125
      ],
      "bbox_max": [
        -1588.3397216796875,
        -3796.899658203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30472713708877563,
        0.354938805103302,
        0.8838325142860413
      ],
      "plane_d": 776.626220703125,
      "bbox_min": [
        -1650.4117431640625,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.119384765625,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45620670914649963,
        0.35775572061538696,
        0.8147921562194824
      ],
      "plane_d": 1113.8070068359375,
      "bbox_min": [
        -1634.7816162109375,
        -3812.940185546875,
        1200.0
      ],
      "bbox_max": [
        -1602.0355224609375,
        -3777.906005859375,
        1206.024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40932556986808777,
        0.8607157468795776,
        0.30268943309783936
      ],
      "plane_d": 3557.586181640625,
      "bbox_min": [
        -1634.7816162109375,
        -3799.133544921875,
        1200.0
      ],
      "bbox_max": [
        -1606.4169921875,
        -3777.906005859375,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4071606397628784,
        0.40963250398635864,
        0.8163464069366455
      ],
      "plane_d": 1230.17333984375,
      "bbox_min": [
        -1634.7816162109375,
        -3799.133544921875,
        1200.0
      ],
      "bbox_max": [
        -1606.4169921875,
        -3777.906005859375,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30048149824142456,
        0.9013935923576355,
        0.3117698132991791
      ],
      "plane_d": 3522.477783203125,
      "bbox_min": [
        -1634.7816162109375,
        -3778.8251953125,
        1200.0
      ],
      "bbox_max": [
        -1634.3919677734375,
        -3777.906005859375,
        1202.37548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12492716312408447,
        0.4128115177154541,
        0.9022083878517151
      ],
      "plane_d": 686.4901733398438,
      "bbox_min": [
        -1605.336669921875,
        -3812.940185546875,
        1200.0
      ],
      "bbox_max": [
        -1602.0355224609375,
        -3799.945556640625,
        1206.024658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6506555080413818,
        0.7536596059799194,
        0.09297633171081543
      ],
      "plane_d": 1717.1949462890625,
      "bbox_min": [
        -1605.3487548828125,
        -3813.216796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3778.387939453125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12492716312408447,
        0.4128115177154541,
        0.9022083878517151
      ],
      "plane_d": 686.4901733398438,
      "bbox_min": [
        -1605.3487548828125,
        -3813.216796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3778.387939453125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9830623269081116,
        -0.1477513462305069,
        0.1084347739815712
      ],
      "plane_d": -2249.01025390625,
      "bbox_min": [
        -1594.1458740234375,
        -3802.785888671875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3778.387939453125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36401546001434326,
        -0.9085700511932373,
        -0.20492224395275116
      ],
      "plane_d": -3773.85205078125,
      "bbox_min": [
        -1585.6793212890625,
        -3789.472900390625,
        1201.54248046875
      ],
      "bbox_max": [
        -1585.6302490234375,
        -3789.400390625,
        1202.01953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1588.9434814453125,
        -3798.167724609375,
        1200.0
      ],
      "bbox_max": [
        -1588.5440673828125,
        -3797.703857421875,
        1202.8450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3721572160720825,
        0.8958039879798889,
        -0.2429696023464203
      ],
      "plane_d": 4285.61279296875,
      "bbox_min": [
        -1588.9434814453125,
        -3798.167724609375,
        1201.595703125
      ],
      "bbox_max": [
        -1588.5440673828125,
        -3797.895751953125,
        1202.8450927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.373865008354187,
        0.8682615160942078,
        -0.3261087238788605
      ],
      "plane_d": 4283.62939453125,
      "bbox_min": [
        -1588.9434814453125,
        -3798.167724609375,
        1201.595703125
      ],
      "bbox_max": [
        -1588.7138671875,
        -3798.04541015625,
        1201.75927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8587794303894043,
        0.4916689395904541,
        0.14408192038536072
      ],
      "plane_d": 329.4835205078125,
      "bbox_min": [
        -1589.7430419921875,
        -3799.00341796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3788.86767578125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1589.17138671875,
        -3798.062255859375,
        1200.0
      ],
      "bbox_max": [
        -1588.1126708984375,
        -3797.326904296875,
        1205.60302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3721572160720825,
        0.8958039879798889,
        -0.2429696023464203
      ],
      "plane_d": 4285.61279296875,
      "bbox_min": [
        -1589.131591796875,
        -3798.062255859375,
        1201.6485595703125
      ],
      "bbox_max": [
        -1588.1126708984375,
        -3797.326904296875,
        1205.60302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.373865008354187,
        0.8682615160942078,
        -0.3261087238788605
      ],
      "plane_d": 4283.62939453125,
      "bbox_min": [
        -1589.131591796875,
        -3798.062255859375,
        1201.6485595703125
      ],
      "bbox_max": [
        -1588.9107666015625,
        -3797.96240234375,
        1201.730712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5001416802406311,
        0.8423463702201843,
        0.20077568292617798
      ],
      "plane_d": 3752.718994140625,
      "bbox_min": [
        -1589.4637451171875,
        -3799.00341796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3788.86767578125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.883378803730011,
        0.44359084963798523,
        0.15122483670711517
      ],
      "plane_d": 99.20947265625,
      "bbox_min": [
        -1589.4637451171875,
        -3798.044921875,
        1200.0
      ],
      "bbox_max": [
        -1589.131591796875,
        -3797.517578125,
        1201.6986083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467334747314453,
        0.30944401025772095,
        0.08910716325044632
      ],
      "plane_d": -435.731201171875,
      "bbox_min": [
        -1589.131591796875,
        -3799.00341796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3788.86767578125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36401546001434326,
        -0.9085700511932373,
        -0.20492224395275116
      ],
      "plane_d": -3773.85205078125,
      "bbox_min": [
        -1586.006103515625,
        -3790.53564453125,
        1200.0
      ],
      "bbox_max": [
        -1585.6141357421875,
        -3789.3857421875,
        1206.8140869140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22869792580604553,
        -0.9454362988471985,
        0.2320505827665329
      ],
      "plane_d": -4224.16552734375,
      "bbox_min": [
        -1586.006103515625,
        -3789.79296875,
        1200.0
      ],
      "bbox_max": [
        -1585.655029296875,
        -3789.3857421875,
        1201.8740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923788905143738,
        -0.05445718392729759,
        0.11053726077079773
      ],
      "plane_d": -1912.82958984375,
      "bbox_min": [
        -1589.131591796875,
        -3799.00341796875,
        1200.0
      ],
      "bbox_max": [
        -1585.1417236328125,
        -3788.86767578125,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232189059257507,
        0.3602604866027832,
        0.13371340930461884
      ],
      "plane_d": -259.543701171875,
      "bbox_min": [
        -1589.131591796875,
        -3799.00341796875,
        1200.0
      ],
      "bbox_max": [
        -1585.7032470703125,
        -3789.232421875,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3721572160720825,
        0.8958039879798889,
        -0.2429696023464203
      ],
      "plane_d": 4285.61279296875,
      "bbox_min": [
        -1589.131591796875,
        -3797.96240234375,
        1200.0
      ],
      "bbox_max": [
        -1585.7032470703125,
        -3789.232421875,
        1207.6181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07363895326852798,
        0.5025526881217957,
        -0.8614047169685364
      ],
      "plane_d": 2830.622802734375,
      "bbox_min": [
        -1588.0833740234375,
        -3797.13720703125,
        1200.0
      ],
      "bbox_max": [
        -1585.7032470703125,
        -3789.232421875,
        1207.6181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0908346027135849,
        0.39480429887771606,
        -0.9142640233039856
      ],
      "plane_d": 2457.963134765625,
      "bbox_min": [
        -1588.0833740234375,
        -3797.13720703125,
        1206.52197265625
      ],
      "bbox_max": [
        -1587.9515380859375,
        -3797.079833984375,
        1206.55810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9587120413780212,
        0.25203296542167664,
        0.13172127306461334
      ],
      "plane_d": -723.4950561523438,
      "bbox_min": [
        -1586.05908203125,
        -3789.7724609375,
        1200.0
      ],
      "bbox_max": [
        -1585.7032470703125,
        -3789.232421875,
        1201.8740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22869792580604553,
        -0.9454362988471985,
        0.2320505827665329
      ],
      "plane_d": -4224.16552734375,
      "bbox_min": [
        -1586.05908203125,
        -3789.7724609375,
        1200.0
      ],
      "bbox_max": [
        -1585.7032470703125,
        -3789.3857421875,
        1201.8740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9310281872749329,
        0.343376100063324,
        0.12360986322164536
      ],
      "plane_d": -323.866455078125,
      "bbox_min": [
        -1588.3397216796875,
        -3799.00341796875,
        1206.55810546875
      ],
      "bbox_max": [
        -1586.6591796875,
        -3793.852294921875,
        1209.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07363895326852798,
        0.5025526881217957,
        -0.8614047169685364
      ],
      "plane_d": 2830.622802734375,
      "bbox_min": [
        -1588.0833740234375,
        -3797.079833984375,
        1206.55810546875
      ],
      "bbox_max": [
        -1586.6591796875,
        -3793.852294921875,
        1208.3193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4071606397628784,
        0.40963250398635864,
        0.8163464069366455
      ],
      "plane_d": 1230.17333984375,
      "bbox_min": [
        -1622.019287109375,
        -3818.124267578125,
        1200.0
      ],
      "bbox_max": [
        -1604.3623046875,
        -3788.431884765625,
        1210.7515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41764795780181885,
        0.2911357283592224,
        0.8607034087181091
      ],
      "plane_d": 742.4942626953125,
      "bbox_min": [
        -1622.019287109375,
        -3813.216796875,
        1206.1529541015625
      ],
      "bbox_max": [
        -1605.3487548828125,
        -3806.130126953125,
        1210.4683837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21475182473659515,
        0.3785727620124817,
        0.9003134369850159
      ],
      "plane_d": 699.7657470703125,
      "bbox_min": [
        -1622.019287109375,
        -3809.130126953125,
        1208.3992919921875
      ],
      "bbox_max": [
        -1614.9180908203125,
        -3806.130126953125,
        1210.4683837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1622.019287109375,
        -3809.130126953125,
        1209.8992919921875
      ],
      "bbox_max": [
        -1615.9180908203125,
        -3807.022705078125,
        1210.4683837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45913416147232056,
        0.5426976680755615,
        0.7033314108848572
      ],
      "plane_d": 1958.1690673828125,
      "bbox_min": [
        -1616.4854736328125,
        -3813.216796875,
        1206.1529541015625
      ],
      "bbox_max": [
        -1605.3487548828125,
        -3808.81591796875,
        1210.0684814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3961976170539856,
        0.557977557182312,
        -0.7291696667671204
      ],
      "plane_d": 3647.85400390625,
      "bbox_min": [
        -1616.4854736328125,
        -3810.899169921875,
        1209.780517578125
      ],
      "bbox_max": [
        -1613.645263671875,
        -3808.81591796875,
        1210.0684814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1616.4854736328125,
        -3809.130126953125,
        1209.8992919921875
      ],
      "bbox_max": [
        -1615.8408203125,
        -3808.81591796875,
        1210.0684814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45913416147232056,
        0.5426976680755615,
        0.7033314108848572
      ],
      "plane_d": 1958.1690673828125,
      "bbox_min": [
        -1615.38134765625,
        -3817.52685546875,
        1206.1529541015625
      ],
      "bbox_max": [
        -1604.482421875,
        -3809.308837890625,
        1210.1009521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3961976170539856,
        0.557977557182312,
        -0.7291696667671204
      ],
      "plane_d": 3647.85400390625,
      "bbox_min": [
        -1615.38134765625,
        -3816.139892578125,
        1209.4288330078125
      ],
      "bbox_max": [
        -1606.911865234375,
        -3809.308837890625,
        1210.1009521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3961976170539856,
        0.557977557182312,
        -0.7291696667671204
      ],
      "plane_d": 3647.85400390625,
      "bbox_min": [
        -1614.72265625,
        -3818.124267578125,
        1208.9130859375
      ],
      "bbox_max": [
        -1604.3623046875,
        -3809.715576171875,
        1210.7515869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45913416147232056,
        0.5426976680755615,
        0.7033314108848572
      ],
      "plane_d": 1958.1690673828125,
      "bbox_min": [
        -1606.911865234375,
        -3818.124267578125,
        1208.9130859375
      ],
      "bbox_max": [
        -1604.3623046875,
        -3816.139892578125,
        1209.4288330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9830623269081116,
        -0.1477513462305069,
        0.1084347739815712
      ],
      "plane_d": -2249.01025390625,
      "bbox_min": [
        -1650.4117431640625,
        -3815.39892578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3723.119384765625,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146341681480408,
        -0.3492834270000458,
        0.20358161628246307
      ],
      "plane_d": -3014.728515625,
      "bbox_min": [
        -1650.0792236328125,
        -3815.39892578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3725.8486328125,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3961976170539856,
        0.557977557182312,
        -0.7291696667671204
      ],
      "plane_d": 3647.85400390625,
      "bbox_min": [
        -1641.3966064453125,
        -3815.39892578125,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3731.5908203125,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1625.9947509765625,
        -3809.02490234375,
        1210.0218505859375
      ],
      "bbox_max": [
        -1615.2242431640625,
        -3805.4833984375,
        1211.0025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052230801433324814,
        -0.15192356705665588,
        -0.987011194229126
      ],
      "plane_d": 540.7427978515625,
      "bbox_min": [
        -1593.4554443359375,
        -3761.502685546875,
        1210.654296875
      ],
      "bbox_max": [
        -1590.381103515625,
        -3758.997802734375,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20201623439788818,
        -0.05099478363990784,
        0.9780535697937012
      ],
      "plane_d": -1687.13134765625,
      "bbox_min": [
        -1641.3966064453125,
        -3790.30224609375,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21973711252212524,
        -0.3090190291404724,
        0.9253231287002563
      ],
      "plane_d": -2625.30322265625,
      "bbox_min": [
        -1589.5361328125,
        -3772.860107421875,
        1200.0
      ],
      "bbox_max": [
        -1588.3463134765625,
        -3772.050537109375,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20422875881195068,
        -0.3231890797615051,
        0.9240343570709229
      ],
      "plane_d": -2652.574462890625,
      "bbox_min": [
        -1588.806396484375,
        -3772.860107421875,
        1200.0
      ],
      "bbox_max": [
        -1588.3463134765625,
        -3772.17236328125,
        1200.22314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467334747314453,
        0.30944401025772095,
        0.08910716325044632
      ],
      "plane_d": -435.731201171875,
      "bbox_min": [
        -1641.3966064453125,
        -3790.30224609375,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9923788905143738,
        -0.05445718392729759,
        0.11053726077079773
      ],
      "plane_d": -1912.82958984375,
      "bbox_min": [
        -1641.3966064453125,
        -3789.2587890625,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.462723970413208,
        0.026608072221279144,
        -0.8861029744148254
      ],
      "plane_d": 440.28338623046875,
      "bbox_min": [
        -1641.3966064453125,
        -3789.2587890625,
        1200.0
      ],
      "bbox_max": [
        -1584.746826171875,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1641.3966064453125,
        -3752.044677734375,
        1200.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1204.0,
      "bbox_min": [
        -1631.2977294921875,
        -3752.044677734375,
        1200.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8864945769309998,
        -0.4094434976577759,
        0.21560001373291016
      ],
      "plane_d": -346.1357421875,
      "bbox_min": [
        -1630.939453125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1623.6224365234375,
        -3732.016845703125,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820160031318665,
        0.4073750376701355,
        0.2368403524160385
      ],
      "plane_d": 2671.54150390625,
      "bbox_min": [
        -1630.939453125,
        -3737.081787109375,
        1200.0
      ],
      "bbox_max": [
        -1626.2606201171875,
        -3732.016845703125,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8820167183876038,
        0.4073753356933594,
        0.23683711886405945
      ],
      "plane_d": -201.3570556640625,
      "bbox_min": [
        -1630.939453125,
        -3737.081787109375,
        1200.0
      ],
      "bbox_max": [
        -1627.4302978515625,
        -3732.016845703125,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.886497437953949,
        -0.4094448685646057,
        0.21558550000190735
      ],
      "plane_d": -3233.6181640625,
      "bbox_min": [
        -1630.939453125,
        -3737.081787109375,
        1200.0
      ],
      "bbox_max": [
        -1627.4302978515625,
        -3732.016845703125,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9566670656204224,
        0.29118406772613525
      ],
      "plane_d": 3220.876708984375,
      "bbox_min": [
        -1629.769775390625,
        -3737.081787109375,
        1200.0
      ],
      "bbox_max": [
        -1627.4302978515625,
        -3732.016845703125,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9702408909797668,
        0.24214160442352295
      ],
      "plane_d": -3916.439453125,
      "bbox_min": [
        -1629.769775390625,
        -3737.081787109375,
        1200.0
      ],
      "bbox_max": [
        -1627.4302978515625,
        -3736.08349609375,
        1204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9729576706886292,
        0.23098376393318176
      ],
      "plane_d": 3368.60302734375,
      "bbox_min": [
        -1627.11328125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1623.6224365234375,
        -3747.114013671875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359395265579224,
        0.498689204454422,
        0.22915960848331451
      ],
      "plane_d": 2951.844482421875,
      "bbox_min": [
        -1627.11328125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1623.6224365234375,
        -3747.114013671875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8359403014183044,
        -0.4986896812915802,
        0.22915607690811157
      ],
      "plane_d": -787.3236083984375,
      "bbox_min": [
        -1627.11328125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1623.6224365234375,
        -3747.114013671875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1627.11328125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1624.3900146484375,
        -3747.114013671875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329302072525024,
        0.4968939423561096,
        0.2435646653175354
      ],
      "plane_d": 214.465087890625,
      "bbox_min": [
        -1627.11328125,
        -3750.22119140625,
        1200.0
      ],
      "bbox_max": [
        -1624.3900146484375,
        -3747.114013671875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1202.800048828125,
      "bbox_min": [
        -1627.11328125,
        -3750.22119140625,
        1202.800048828125
      ],
      "bbox_max": [
        -1624.3900146484375,
        -3747.77880859375,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9636518955230713,
        -0.2671613097190857
      ],
      "plane_d": 3933.21630859375,
      "bbox_min": [
        -1631.2977294921875,
        -3752.044677734375,
        1204.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8266543745994568,
        0.49317675828933716,
        -0.2709597051143646
      ],
      "plane_d": 829.93701171875,
      "bbox_min": [
        -1629.5634765625,
        -3752.044677734375,
        1204.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3745.838134765625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273950219154358,
        0.4935900568962097,
        -0.26792943477630615
      ],
      "plane_d": 3517.068359375,
      "bbox_min": [
        -1627.712158203125,
        -3752.044677734375,
        1204.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3745.838134765625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9677070379257202,
        -0.2520774304866791
      ],
      "plane_d": -3325.6142578125,
      "bbox_min": [
        -1627.712158203125,
        -3752.044677734375,
        1204.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3748.94140625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829205334186554,
        -0.49467000365257263,
        -0.2602307200431824
      ],
      "plane_d": -194.2471923828125,
      "bbox_min": [
        -1625.1185302734375,
        -3752.044677734375,
        1204.0
      ],
      "bbox_max": [
        -1622.158203125,
        -3748.94140625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8820075988769531,
        0.4074001610279083,
        -0.23682838678359985
      ],
      "plane_d": 369.422607421875,
      "bbox_min": [
        -1631.2977294921875,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1625.90234375,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820191025733948,
        0.4073698818683624,
        -0.23683758080005646
      ],
      "plane_d": 3242.214599609375,
      "bbox_min": [
        -1631.2977294921875,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1625.90234375,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8864840865135193,
        -0.4094678461551666,
        -0.21559666097164154
      ],
      "plane_d": -2714.194091796875,
      "bbox_min": [
        -1631.2977294921875,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1625.90234375,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8864966034889221,
        -0.409437894821167,
        -0.21560229361057281
      ],
      "plane_d": 173.40087890625,
      "bbox_min": [
        -1629.9488525390625,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1625.90234375,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9566670656204224,
        -0.29118406772613525
      ],
      "plane_d": 3922.513916015625,
      "bbox_min": [
        -1629.9488525390625,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1627.2510986328125,
        -3731.5908203125,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9702408909797668,
        -0.24214161932468414
      ],
      "plane_d": -3332.974853515625,
      "bbox_min": [
        -1629.9488525390625,
        -3737.43115234375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1627.2510986328125,
        -3733.234375,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1205.5999755859375,
      "bbox_min": [
        -1629.916015625,
        -3736.08349609375,
        1205.5999755859375
      ],
      "bbox_max": [
        -1627.2840576171875,
        -3733.234375,
        1205.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329330086708069,
        -0.4968956410884857,
        0.24355168640613556
      ],
      "plane_d": -3511.24072265625,
      "bbox_min": [
        -1641.3966064453125,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1624.9072265625,
        -3739.224365234375,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9729576110839844,
        0.23098374903202057
      ],
      "plane_d": -3926.63330078125,
      "bbox_min": [
        -1628.122802734375,
        -3750.885986328125,
        1200.0
      ],
      "bbox_max": [
        -1624.9072265625,
        -3747.248046875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8329302072525024,
        0.4968939423561096,
        0.2435646653175354
      ],
      "plane_d": 214.465087890625,
      "bbox_min": [
        -1628.122802734375,
        -3750.22119140625,
        1200.0
      ],
      "bbox_max": [
        -1626.19384765625,
        -3747.248046875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1202.800048828125,
      "bbox_min": [
        -1627.303955078125,
        -3750.22119140625,
        1202.800048828125
      ],
      "bbox_max": [
        -1626.19384765625,
        -3748.680419921875,
        1202.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1206.7999267578125,
      "bbox_min": [
        -1641.3966064453125,
        -3742.6826171875,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        -0.19917234778404236
      ],
      "plane_d": -3426.37890625,
      "bbox_min": [
        -1641.2672119140625,
        -3742.560791015625,
        1206.7999267578125
      ],
      "bbox_max": [
        -1637.5328369140625,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8500226736068726,
        -0.4907698929309845,
        -0.19132795929908752
      ],
      "plane_d": -2999.35888671875,
      "bbox_min": [
        -1641.2672119140625,
        -3742.560791015625,
        1206.7999267578125
      ],
      "bbox_max": [
        -1637.5328369140625,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500410318374634,
        -0.49073439836502075,
        -0.19133758544921875
      ],
      "plane_d": -212.1297607421875,
      "bbox_min": [
        -1641.2672119140625,
        -3742.560791015625,
        1206.7999267578125
      ],
      "bbox_max": [
        -1637.5328369140625,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525676727294922,
        0.49223923683166504,
        -0.17558152973651886
      ],
      "plane_d": 654.7772216796875,
      "bbox_min": [
        -1641.2672119140625,
        -3740.943603515625,
        1206.7999267578125
      ],
      "bbox_max": [
        -1637.5328369140625,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8525868654251099,
        0.49220412969589233,
        -0.17558714747428894
      ],
      "plane_d": 3450.0830078125,
      "bbox_min": [
        -1640.3336181640625,
        -3740.943603515625,
        1206.7999267578125
      ],
      "bbox_max": [
        -1637.5328369140625,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9858459830284119,
        -0.16765399277210236
      ],
      "plane_d": 3889.42919921875,
      "bbox_min": [
        -1640.3336181640625,
        -3740.040771484375,
        1206.7999267578125
      ],
      "bbox_max": [
        -1638.46630859375,
        -3739.326416015625,
        1211.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        0.19917234778404236
      ],
      "plane_d": -3906.702880859375,
      "bbox_min": [
        -1641.3966064453125,
        -3742.6826171875,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8499592542648315,
        -0.4908689260482788,
        0.1913560926914215
      ],
      "plane_d": -3461.065673828125,
      "bbox_min": [
        -1641.3966064453125,
        -3742.6826171875,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500179648399353,
        -0.49077823758125305,
        0.19132709503173828
      ],
      "plane_d": -673.748779296875,
      "bbox_min": [
        -1641.3966064453125,
        -3742.6826171875,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525709509849548,
        0.4922329783439636,
        0.17558322846889496
      ],
      "plane_d": 231.3138427734375,
      "bbox_min": [
        -1641.3966064453125,
        -3741.70703125,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8526269197463989,
        0.49214035272598267,
        0.17557108402252197
      ],
      "plane_d": 3026.4833984375,
      "bbox_min": [
        -1640.398193359375,
        -3741.70703125,
        1200.0
      ],
      "bbox_max": [
        -1637.4034423828125,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9858459830284119,
        0.16765399277210236
      ],
      "plane_d": 3485.11474609375,
      "bbox_min": [
        -1640.398193359375,
        -3741.70703125,
        1200.0
      ],
      "bbox_max": [
        -1638.4017333984375,
        -3739.224365234375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1204.800048828125,
      "bbox_min": [
        -1640.362060546875,
        -3741.70703125,
        1204.800048828125
      ],
      "bbox_max": [
        -1638.43798828125,
        -3740.040771484375,
        1204.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44481536746025085,
        -0.011552450247108936,
        -0.8955478072166443
      ],
      "plane_d": 1790.3621826171875,
      "bbox_min": [
        -1684.7525634765625,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37680602073669434,
        0.15969131886959076,
        -0.9124231338500977
      ],
      "plane_d": 2346.548828125,
      "bbox_min": [
        -1684.7525634765625,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44968459010124207,
        -0.31487855315208435,
        -0.8358440399169922
      ],
      "plane_d": 578.9735717773438,
      "bbox_min": [
        -1684.7525634765625,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06758714467287064,
        -0.07208340615034103,
        -0.9951059222221375
      ],
      "plane_d": 1047.00341796875,
      "bbox_min": [
        -1684.7525634765625,
        -3782.228759765625,
        1211.0
      ],
      "bbox_max": [
        -1645.3634033203125,
        -3726.616943359375,
        1216.83251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31713974475860596,
        -0.33700087666511536,
        -0.8864834904670715
      ],
      "plane_d": 336.321044921875,
      "bbox_min": [
        -1684.7525634765625,
        -3781.09033203125,
        1211.0
      ],
      "bbox_max": [
        -1645.3634033203125,
        -3726.616943359375,
        1216.83251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09344251453876495,
        -0.030930355191230774,
        -0.9951441287994385
      ],
      "plane_d": 1244.7073974609375,
      "bbox_min": [
        -1666.7996826171875,
        -3755.963134765625,
        1211.0
      ],
      "bbox_max": [
        -1645.3634033203125,
        -3726.616943359375,
        1211.67041015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3888595402240753,
        -0.9055222272872925,
        0.1697581261396408
      ],
      "plane_d": -2940.35791015625,
      "bbox_min": [
        -1654.1575927734375,
        -3730.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1645.3634033203125,
        -3726.616943359375,
        1211.3631591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31442588567733765,
        -0.2121555060148239,
        -0.9252710938453674
      ],
      "plane_d": 849.7811889648438,
      "bbox_min": [
        -1684.7525634765625,
        -3781.09033203125,
        1211.04345703125
      ],
      "bbox_max": [
        -1666.231689453125,
        -3770.9375,
        1216.83251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.968498706817627,
        -0.23149517178535461,
        0.0917619913816452
      ],
      "plane_d": 647.0894775390625,
      "bbox_min": [
        -1684.7525634765625,
        -3773.144287109375,
        1211.0
      ],
      "bbox_max": [
        -1684.7132568359375,
        -3772.991455078125,
        1211.04345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9184884428977966,
        -0.08188237249851227,
        0.38687777519226074
      ],
      "plane_d": 769.9463500976562,
      "bbox_min": [
        -1684.7525634765625,
        -3773.144287109375,
        1211.0
      ],
      "bbox_max": [
        -1684.725830078125,
        -3773.0439453125,
        1211.04345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.968498706817627,
        -0.23149517178535461,
        0.0917619913816452
      ],
      "plane_d": 647.0894775390625,
      "bbox_min": [
        -1684.7525634765625,
        -3773.138671875,
        1211.0
      ],
      "bbox_max": [
        -1684.5625,
        -3772.360595703125,
        1211.04345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44543808698654175,
        -0.30754512548446655,
        -0.8408334851264954
      ],
      "plane_d": 605.6231689453125,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31442588567733765,
        -0.2121555060148239,
        -0.9252710938453674
      ],
      "plane_d": 849.7811889648438,
      "bbox_min": [
        -1673.784423828125,
        -3781.212890625,
        1216.5938720703125
      ],
      "bbox_max": [
        -1666.231689453125,
        -3770.9375,
        1216.83251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12090568244457245,
        -0.9647501111030579,
        0.23374983668327332
      ],
      "plane_d": -4072.881103515625,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13704648613929749,
        -0.9696420431137085,
        0.202516108751297
      ],
      "plane_d": -4079.669677734375,
      "bbox_min": [
        -1637.0606689453125,
        -3723.313720703125,
        1211.0
      ],
      "bbox_max": [
        -1635.510498046875,
        -3722.95654296875,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3888595402240753,
        -0.9055222272872925,
        0.1697581261396408
      ],
      "plane_d": -2940.35791015625,
      "bbox_min": [
        -1637.0606689453125,
        -3723.119384765625,
        1211.0
      ],
      "bbox_max": [
        -1636.99072265625,
        -3722.95654296875,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02832009270787239,
        0.3362668752670288,
        -0.9413408041000366
      ],
      "plane_d": 2473.23583984375,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13025526702404022,
        0.29834482073783875,
        -0.9455283880233765
      ],
      "plane_d": 2502.040771484375,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03328092023730278,
        0.26909157633781433,
        -0.9625393748283386
      ],
      "plane_d": 2250.654052734375,
      "bbox_min": [
        -1674.625732421875,
        -3817.3525390625,
        1212.7427978515625
      ],
      "bbox_max": [
        -1639.54248046875,
        -3779.991943359375,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1604802906513214,
        0.34097832441329956,
        -0.9262720346450806
      ],
      "plane_d": 2690.314453125,
      "bbox_min": [
        -1663.8134765625,
        -3800.2041015625,
        1220.315185546875
      ],
      "bbox_max": [
        -1639.54248046875,
        -3779.991943359375,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3567189872264862,
        -0.20259536802768707,
        -0.9119795560836792
      ],
      "plane_d": 940.12841796875,
      "bbox_min": [
        -1663.8134765625,
        -3788.31884765625,
        1221.6396484375
      ],
      "bbox_max": [
        -1639.54248046875,
        -3779.991943359375,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004490641877055168,
        -0.053320955485105515,
        -0.9985673427581787
      ],
      "plane_d": 1015.8292846679688,
      "bbox_min": [
        -1647.5662841796875,
        -3782.3212890625,
        1226.5369873046875
      ],
      "bbox_max": [
        -1646.680419921875,
        -3779.991943359375,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004490641877055168,
        -0.053320955485105515,
        -0.9985673427581787
      ],
      "plane_d": 1015.8292846679688,
      "bbox_min": [
        -1647.5662841796875,
        -3782.9970703125,
        1226.5474853515625
      ],
      "bbox_max": [
        -1639.54248046875,
        -3780.24462890625,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06886692345142365,
        0.5568208694458008,
        0.8277727961540222
      ],
      "plane_d": 1234.6553955078125,
      "bbox_min": [
        -1674.625732421875,
        -3817.3525390625,
        1212.7427978515625
      ],
      "bbox_max": [
        -1653.6927490234375,
        -3809.49560546875,
        1213.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48632779717445374,
        0.34696274995803833,
        0.8019365072250366
      ],
      "plane_d": 1163.045654296875,
      "bbox_min": [
        -1674.625732421875,
        -3815.182861328125,
        1212.7427978515625
      ],
      "bbox_max": [
        -1670.50634765625,
        -3809.49560546875,
        1213.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27911877632141113,
        -0.8954413533210754,
        -0.34681040048599243
      ],
      "plane_d": -2478.087890625,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3722.95654296875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006964832544326782,
        -0.055574916303157806,
        -0.9984302520751953
      ],
      "plane_d": 991.5025634765625,
      "bbox_min": [
        -1666.51708984375,
        -3755.963134765625,
        1211.0
      ],
      "bbox_max": [
        -1609.6649169921875,
        -3722.95654296875,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9858459830284119,
        -0.16765399277210236
      ],
      "plane_d": 3889.42919921875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1212.614013671875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8525868654251099,
        0.49220412969589233,
        -0.17558714747428894
      ],
      "plane_d": 3450.0830078125,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1212.614013671875
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525676727294922,
        0.49223923683166504,
        -0.17558152973651886
      ],
      "plane_d": 654.7772216796875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1212.6292724609375
      ],
      "bbox_max": [
        -1636.800048828125,
        -3738.748291015625,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500410318374634,
        -0.49073439836502075,
        -0.19133758544921875
      ],
      "plane_d": -212.1297607421875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1212.7130126953125
      ],
      "bbox_max": [
        -1636.800048828125,
        -3740.971923828125,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8500226736068726,
        -0.4907698929309845,
        -0.19132795929908752
      ],
      "plane_d": -2999.35888671875,
      "bbox_min": [
        -1642.0,
        -3743.251708984375,
        1212.7442626953125
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3740.97265625,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        -0.19917234778404236
      ],
      "plane_d": -3426.37890625,
      "bbox_min": [
        -1640.699951171875,
        -3743.251708984375,
        1212.829833984375
      ],
      "bbox_max": [
        -1638.0999755859375,
        -3742.9326171875,
        1214.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09344251453876495,
        -0.030930355191230774,
        -0.9951441287994385
      ],
      "plane_d": 1244.7073974609375,
      "bbox_min": [
        -1666.51708984375,
        -3755.963134765625,
        1211.0
      ],
      "bbox_max": [
        -1609.6649169921875,
        -3722.95654296875,
        1213.1767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8500226736068726,
        -0.4907698929309845,
        -0.19132795929908752
      ],
      "plane_d": -2999.35888671875,
      "bbox_min": [
        -1641.6431884765625,
        -3742.935791015625,
        1212.6085205078125
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.04931640625,
        1212.8458251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500410318374634,
        -0.49073439836502075,
        -0.19133758544921875
      ],
      "plane_d": -212.1297607421875,
      "bbox_min": [
        -1641.6431884765625,
        -3742.9326171875,
        1212.6085205078125
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.04931640625,
        1212.829833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8525868654251099,
        0.49220412969589233,
        -0.17558714747428894
      ],
      "plane_d": 3450.0830078125,
      "bbox_min": [
        -1640.5091552734375,
        -3740.971923828125,
        1212.6085205078125
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.04931640625,
        1212.7130126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9858459830284119,
        -0.16765399277210236
      ],
      "plane_d": 3889.42919921875,
      "bbox_min": [
        -1640.5091552734375,
        -3739.052978515625,
        1212.6085205078125
      ],
      "bbox_max": [
        -1638.2923583984375,
        -3739.04931640625,
        1212.6292724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07093045115470886,
        -0.06823669373989105,
        -0.9951444864273071
      ],
      "plane_d": 1067.895751953125,
      "bbox_min": [
        -1654.794189453125,
        -3748.969482421875,
        1211.0
      ],
      "bbox_max": [
        -1609.6649169921875,
        -3722.95654296875,
        1213.1767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8500226736068726,
        -0.4907698929309845,
        -0.19132795929908752
      ],
      "plane_d": -2999.35888671875,
      "bbox_min": [
        -1641.64111328125,
        -3742.93408203125,
        1212.56298828125
      ],
      "bbox_max": [
        -1639.73388671875,
        -3739.050537109375,
        1212.8370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525676727294922,
        0.49223923683166504,
        -0.17558152973651886
      ],
      "plane_d": 654.7772216796875,
      "bbox_min": [
        -1641.64111328125,
        -3742.93408203125,
        1212.56298828125
      ],
      "bbox_max": [
        -1639.73388671875,
        -3739.050537109375,
        1212.8370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9858459830284119,
        -0.16765399277210236
      ],
      "plane_d": 3889.42919921875,
      "bbox_min": [
        -1640.531494140625,
        -3742.93408203125,
        1212.56298828125
      ],
      "bbox_max": [
        -1639.73388671875,
        -3739.050537109375,
        1212.8370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1646.39697265625,
        -3742.933837890625,
        1211.0
      ],
      "bbox_max": [
        -1609.6649169921875,
        -3722.95654296875,
        1212.836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8820191025733948,
        0.4073698818683624,
        -0.23683758080005646
      ],
      "plane_d": 3242.214599609375,
      "bbox_min": [
        -1631.4000244140625,
        -3737.531005859375,
        1211.0
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1211.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8864840865135193,
        -0.4094678461551666,
        -0.21559666097164154
      ],
      "plane_d": -2714.194091796875,
      "bbox_min": [
        -1631.4000244140625,
        -3737.531005859375,
        1211.0
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1211.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8864966034889221,
        -0.409437894821167,
        -0.21560229361057281
      ],
      "plane_d": 173.40087890625,
      "bbox_min": [
        -1630.0,
        -3737.531005859375,
        1211.0
      ],
      "bbox_max": [
        -1625.800048828125,
        -3731.468994140625,
        1211.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9566670656204224,
        -0.29118406772613525
      ],
      "plane_d": 3922.513916015625,
      "bbox_min": [
        -1630.0,
        -3737.531005859375,
        1211.0
      ],
      "bbox_max": [
        -1627.199951171875,
        -3731.468994140625,
        1211.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9702408909797668,
        -0.24214161932468414
      ],
      "plane_d": -3332.974853515625,
      "bbox_min": [
        -1630.0,
        -3737.531005859375,
        1211.0
      ],
      "bbox_max": [
        -1627.199951171875,
        -3737.43115234375,
        1211.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500410318374634,
        -0.49073439836502075,
        -0.19133758544921875
      ],
      "plane_d": -212.1297607421875,
      "bbox_min": [
        -1641.615234375,
        -3742.933837890625,
        1211.0
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.05126953125,
        1212.836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9799644947052002,
        -0.19917234778404236
      ],
      "plane_d": -3426.37890625,
      "bbox_min": [
        -1641.615234375,
        -3742.933837890625,
        1211.0
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.05126953125,
        1212.836181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8525868654251099,
        0.49220412969589233,
        -0.17558714747428894
      ],
      "plane_d": 3450.0830078125,
      "bbox_min": [
        -1641.615234375,
        -3740.971923828125,
        1211.0
      ],
      "bbox_max": [
        -1637.1636962890625,
        -3739.05126953125,
        1212.7130126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8525676727294922,
        0.49223923683166504,
        -0.17558152973651886
      ],
      "plane_d": 654.7772216796875,
      "bbox_min": [
        -1641.615234375,
        -3740.970458984375,
        1211.0
      ],
      "bbox_max": [
        -1638.29296875,
        -3739.05126953125,
        1212.6170654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9858459830284119,
        -0.16765399277210236
      ],
      "plane_d": 3889.42919921875,
      "bbox_min": [
        -1640.501953125,
        -3739.326416015625,
        1211.0
      ],
      "bbox_max": [
        -1638.29296875,
        -3739.05126953125,
        1212.6170654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05662769451737404,
        -0.17531482875347137,
        -0.982882559299469
      ],
      "plane_d": 440.5255126953125,
      "bbox_min": [
        -1617.3963623046875,
        -3800.237060546875,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3738.48828125,
        1216.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051638130098581314,
        -0.050253286957740784,
        -0.99740070104599
      ],
      "plane_d": 937.429443359375,
      "bbox_min": [
        -1617.3963623046875,
        -3772.035400390625,
        1211.0
      ],
      "bbox_max": [
        -1587.2138671875,
        -3738.48828125,
        1212.896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052230801433324814,
        -0.15192356705665588,
        -0.987011194229126
      ],
      "plane_d": 540.7427978515625,
      "bbox_min": [
        -1617.3963623046875,
        -3772.035400390625,
        1211.62060546875
      ],
      "bbox_max": [
        -1587.2138671875,
        -3738.705810546875,
        1212.896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08396036922931671,
        0.0051246099174022675,
        -0.9964558482170105
      ],
      "plane_d": 1091.36279296875,
      "bbox_min": [
        -1617.3963623046875,
        -3743.73046875,
        1211.62060546875
      ],
      "bbox_max": [
        -1610.4190673828125,
        -3738.705810546875,
        1212.2845458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1610.5186767578125,
        -3740.368896484375,
        1211.62060546875
      ],
      "bbox_max": [
        -1610.4190673828125,
        -3738.705810546875,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9566893577575684,
        -0.2741868793964386,
        0.09781131893396378
      ],
      "plane_d": -2671.304931640625,
      "bbox_min": [
        -1588.250244140625,
        -3772.035400390625,
        1211.97802734375
      ],
      "bbox_max": [
        -1587.2138671875,
        -3768.5888671875,
        1212.45361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1108451709151268,
        -0.05917282775044441,
        -0.9920745491981506
      ],
      "plane_d": 802.2591552734375,
      "bbox_min": [
        -1610.6473388671875,
        -3769.21728515625,
        1211.0
      ],
      "bbox_max": [
        -1588.06787109375,
        -3738.48828125,
        1212.896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.052230801433324814,
        -0.15192356705665588,
        -0.987011194229126
      ],
      "plane_d": 540.7427978515625,
      "bbox_min": [
        -1610.5186767578125,
        -3769.21728515625,
        1211.0
      ],
      "bbox_max": [
        -1588.06787109375,
        -3738.698486328125,
        1212.896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1610.5186767578125,
        -3740.368896484375,
        1211.599609375
      ],
      "bbox_max": [
        -1610.4296875,
        -3738.698486328125,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9566893577575684,
        -0.2741868793964386,
        0.09781131893396378
      ],
      "plane_d": -2671.304931640625,
      "bbox_min": [
        -1590.381103515625,
        -3769.21728515625,
        1211.0
      ],
      "bbox_max": [
        -1588.06787109375,
        -3761.502685546875,
        1212.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6780288815498352,
        -0.7151387333869934,
        0.16986292600631714
      ],
      "plane_d": -3972.685302734375,
      "bbox_min": [
        -1610.6473388671875,
        -3752.8916015625,
        1211.0
      ],
      "bbox_max": [
        -1597.4881591796875,
        -3738.48828125,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9883599877357483,
        0.06032560020685196,
        0.13966137170791626
      ],
      "plane_d": -1535.361083984375,
      "bbox_min": [
        -1610.6409912109375,
        -3740.42138671875,
        1211.0
      ],
      "bbox_max": [
        -1610.4322509765625,
        -3738.48828125,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9828016757965088,
        0.08632621169090271,
        0.16324426233768463
      ],
      "plane_d": -1457.733154296875,
      "bbox_min": [
        -1610.6409912109375,
        -3740.42138671875,
        1211.0
      ],
      "bbox_max": [
        -1610.5186767578125,
        -3739.712890625,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6409640312194824,
        -0.7277829051017761,
        0.24392062425613403
      ],
      "plane_d": -4050.021728515625,
      "bbox_min": [
        -1610.6473388671875,
        -3741.510986328125,
        1211.0
      ],
      "bbox_max": [
        -1609.49169921875,
        -3740.368896484375,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9828016757965088,
        0.08632621169090271,
        0.16324426233768463
      ],
      "plane_d": -1457.733154296875,
      "bbox_min": [
        -1610.6473388671875,
        -3740.4931640625,
        1211.0
      ],
      "bbox_max": [
        -1610.5186767578125,
        -3740.368896484375,
        1211.708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.462723970413208,
        0.026608072221279144,
        -0.8861029744148254
      ],
      "plane_d": 440.28338623046875,
      "bbox_min": [
        -1597.027587890625,
        -3800.237060546875,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3763.001220703125,
        1216.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160695314407349,
        0.24138912558555603,
        -0.8218293786048889
      ],
      "plane_d": 1091.73388671875,
      "bbox_min": [
        -1597.027587890625,
        -3800.237060546875,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3763.001220703125,
        1216.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9831569790840149,
        -0.1535748839378357,
        0.09908170998096466
      ],
      "plane_d": -2259.90234375,
      "bbox_min": [
        -1597.027587890625,
        -3800.237060546875,
        1211.0
      ],
      "bbox_max": [
        -1585.2186279296875,
        -3763.001220703125,
        1216.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3477695882320404,
        0.32250478863716125,
        -0.880367636680603
      ],
      "plane_d": 1738.03955078125,
      "bbox_min": [
        -1592.487548828125,
        -3800.237060546875,
        1211.0
      ],
      "bbox_max": [
        -1591.3734130859375,
        -3799.46533203125,
        1211.3779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051638130098581314,
        -0.050253286957740784,
        -0.99740070104599
      ],
      "plane_d": 937.429443359375,
      "bbox_min": [
        -1635.0692138671875,
        -3770.57861328125,
        1211.0
      ],
      "bbox_max": [
        -1606.1904296875,
        -3741.134521484375,
        1222.8856201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08396036922931671,
        0.0051246099174022675,
        -0.9964558482170105
      ],
      "plane_d": 1091.36279296875,
      "bbox_min": [
        -1629.3287353515625,
        -3751.373779296875,
        1212.17578125
      ],
      "bbox_max": [
        -1616.2645263671875,
        -3741.134521484375,
        1213.2373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006964832544326782,
        -0.055574916303157806,
        -0.9984302520751953
      ],
      "plane_d": 991.5025634765625,
      "bbox_min": [
        -1629.3287353515625,
        -3751.373779296875,
        1212.7227783203125
      ],
      "bbox_max": [
        -1622.708984375,
        -3742.960205078125,
        1213.2373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00599796324968338,
        -0.05531534180045128,
        -0.9984508752822876
      ],
      "plane_d": 994.0765991210938,
      "bbox_min": [
        -1635.0692138671875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3744.83984375,
        1213.2373046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1212.60009765625,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3745.39453125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9636518955230713,
        -0.2671613097190857
      ],
      "plane_d": 3933.21630859375,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3745.39453125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8266543745994568,
        0.49317675828933716,
        -0.2709597051143646
      ],
      "plane_d": 829.93701171875,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3745.39453125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8273950219154358,
        0.4935900568962097,
        -0.26792943477630615
      ],
      "plane_d": 3517.068359375,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3745.39453125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.829205334186554,
        -0.49467000365257263,
        -0.2602307200431824
      ],
      "plane_d": -194.2471923828125,
      "bbox_min": [
        -1630.0799560546875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1621.6480712890625,
        -3748.927978515625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1630.0799560546875,
        -3751.88916015625,
        1211.0
      ],
      "bbox_max": [
        -1628.0830078125,
        -3748.927978515625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20494157075881958,
        -0.5635892152786255,
        -0.8002288937568665
      ],
      "plane_d": -1476.2454833984375,
      "bbox_min": [
        -1620.5,
        -3773.779052734375,
        1222.8856201171875
      ],
      "bbox_max": [
        -1609.124267578125,
        -3770.57861328125,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1616.375,
        -3773.779052734375,
        1222.8856201171875
      ],
      "bbox_max": [
        -1609.124267578125,
        -3770.57861328125,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4294885993003845,
        -0.1312326192855835,
        -0.8934862017631531
      ],
      "plane_d": -93.29193115234375,
      "bbox_min": [
        -1629.699951171875,
        -3781.5283203125,
        1222.8856201171875
      ],
      "bbox_max": [
        -1609.124267578125,
        -3766.1982421875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16228698194026947,
        -0.049587681889534,
        -0.9854968190193176
      ],
      "plane_d": 1285.5439453125,
      "bbox_min": [
        -1629.699951171875,
        -3781.5283203125,
        1225.596923828125
      ],
      "bbox_max": [
        -1614.630126953125,
        -3766.1982421875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1616.078125,
        -3781.5283203125,
        1226.0162353515625
      ],
      "bbox_max": [
        -1614.630126953125,
        -3778.0,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4204432964324951,
        -0.09020400792360306,
        -0.9028237462043762
      ],
      "plane_d": 1458.987548828125,
      "bbox_min": [
        -1683.813232421875,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1592.0889892578125,
        -3746.930419921875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31442588567733765,
        -0.2121555060148239,
        -0.9252710938453674
      ],
      "plane_d": 849.7811889648438,
      "bbox_min": [
        -1673.6153564453125,
        -3788.31884765625,
        1216.679443359375
      ],
      "bbox_max": [
        -1663.8134765625,
        -3770.9375,
        1221.6396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4070289433002472,
        0.2415713369846344,
        0.8808920979499817
      ],
      "plane_d": 533.7755126953125,
      "bbox_min": [
        -1682.331298828125,
        -3797.34228515625,
        1212.100341796875
      ],
      "bbox_max": [
        -1681.4827880859375,
        -3795.91259765625,
        1212.54833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.012174762785434723,
        -0.060378022491931915,
        -0.9981014132499695
      ],
      "plane_d": 976.033203125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1592.0889892578125,
        -3746.930419921875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1342277079820633,
        -0.058762725442647934,
        -0.9892066717147827
      ],
      "plane_d": 1209.8074951171875,
      "bbox_min": [
        -1629.699951171875,
        -3784.216064453125,
        1225.596923828125
      ],
      "bbox_max": [
        -1615.0721435546875,
        -3766.1982421875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16228698194026947,
        -0.049587681889534,
        -0.9854968190193176
      ],
      "plane_d": 1285.5439453125,
      "bbox_min": [
        -1629.699951171875,
        -3778.0,
        1225.596923828125
      ],
      "bbox_max": [
        -1625.0068359375,
        -3766.1982421875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01595359295606613,
        0.043872375041246414,
        -0.9989098310470581
      ],
      "plane_d": 1417.3284912109375,
      "bbox_min": [
        -1629.570068359375,
        -3784.216064453125,
        1226.2554931640625
      ],
      "bbox_max": [
        -1615.0721435546875,
        -3778.0,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02571098506450653,
        0.00785613339394331,
        -0.999638557434082
      ],
      "plane_d": 1297.8431396484375,
      "bbox_min": [
        -1629.570068359375,
        -3784.216064453125,
        1226.2554931640625
      ],
      "bbox_max": [
        -1615.0721435546875,
        -3778.0,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20802104473114014,
        0.572057843208313,
        -0.7933959364891052
      ],
      "plane_d": 2800.906982421875,
      "bbox_min": [
        -1620.5,
        -3784.216064453125,
        1226.2554931640625
      ],
      "bbox_max": [
        -1615.0721435546875,
        -3780.03466796875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1616.375,
        -3782.910400390625,
        1226.2554931640625
      ],
      "bbox_max": [
        -1615.0721435546875,
        -3780.03466796875,
        1226.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3477695882320404,
        0.32250478863716125,
        -0.880367636680603
      ],
      "plane_d": 1738.03955078125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1592.0889892578125,
        -3746.930419921875,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3456922769546509,
        0.4969053566455841,
        -0.7959786057472229
      ],
      "plane_d": 2301.779296875,
      "bbox_min": [
        -1611.0223388671875,
        -3802.456787109375,
        1211.3779296875
      ],
      "bbox_max": [
        -1592.487548828125,
        -3788.6708984375,
        1218.2613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14013676345348358,
        0.1441795527935028,
        -0.97957843542099
      ],
      "plane_d": 1515.2724609375,
      "bbox_min": [
        -1611.0223388671875,
        -3802.456787109375,
        1216.92138671875
      ],
      "bbox_max": [
        -1597.027587890625,
        -3788.6708984375,
        1218.2613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13181768357753754,
        0.18077954649925232,
        -0.9746500253677368
      ],
      "plane_d": 1661.41796875,
      "bbox_min": [
        -1602.6033935546875,
        -3793.91357421875,
        1216.92138671875
      ],
      "bbox_max": [
        -1597.027587890625,
        -3788.6708984375,
        1218.2613525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020709851756691933,
        -0.21241824328899384,
        -0.9769593477249146
      ],
      "plane_d": 363.47784423828125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1599.745361328125,
        -3746.930419921875,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01335526816546917,
        -0.22142572700977325,
        -0.9750857949256897
      ],
      "plane_d": 339.36395263671875,
      "bbox_min": [
        -1645.956787109375,
        -3766.1982421875,
        1222.8856201171875
      ],
      "bbox_max": [
        -1629.699951171875,
        -3754.1982421875,
        1225.786376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4794720411300659,
        0.48429080843925476,
        -0.7318257093429565
      ],
      "plane_d": 1944.152587890625,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1599.745361328125,
        -3746.930419921875,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.023511899635195732,
        0.7411308884620667,
        -0.67094886302948
      ],
      "plane_d": 3665.660400390625,
      "bbox_min": [
        -1646.205078125,
        -3814.93408203125,
        1211.0
      ],
      "bbox_max": [
        -1599.745361328125,
        -3770.57861328125,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018105342984199524,
        0.15083742141723633,
        -0.98839271068573
      ],
      "plane_d": 1747.9168701171875,
      "bbox_min": [
        -1627.4481201171875,
        -3814.93408203125,
        1211.0
      ],
      "bbox_max": [
        -1602.5006103515625,
        -3790.956787109375,
        1219.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3961976170539856,
        0.557977557182312,
        -0.7291696667671204
      ],
      "plane_d": 3647.85400390625,
      "bbox_min": [
        -1627.4481201171875,
        -3814.93408203125,
        1211.0
      ],
      "bbox_max": [
        -1602.5006103515625,
        -3790.956787109375,
        1219.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1620.799560546875,
        -3808.184326171875,
        1211.0
      ],
      "bbox_max": [
        -1611.0223388671875,
        -3802.456787109375,
        1217.666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14013676345348358,
        0.1441795527935028,
        -0.97957843542099
      ],
      "plane_d": 1515.2724609375,
      "bbox_min": [
        -1611.5223388671875,
        -3802.456787109375,
        1217.666015625
      ],
      "bbox_max": [
        -1602.5006103515625,
        -3790.956787109375,
        1219.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13181768357753754,
        0.18077954649925232,
        -0.9746500253677368
      ],
      "plane_d": 1661.41796875,
      "bbox_min": [
        -1611.5223388671875,
        -3792.776123046875,
        1217.886474609375
      ],
      "bbox_max": [
        -1602.5006103515625,
        -3790.956787109375,
        1219.43017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14882946014404297,
        0.48537153005599976,
        -0.861547589302063
      ],
      "plane_d": 2650.86669921875,
      "bbox_min": [
        -1646.205078125,
        -3808.50439453125,
        1211.00048828125
      ],
      "bbox_max": [
        -1617.091064453125,
        -3783.8369140625,
        1226.662353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23003512620925903,
        0.689034640789032,
        -0.6872519254684448
      ],
      "plane_d": 3079.631103515625,
      "bbox_min": [
        -1646.205078125,
        -3808.50439453125,
        1211.00048828125
      ],
      "bbox_max": [
        -1617.091064453125,
        -3797.19580078125,
        1220.315185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17354394495487213,
        0.6893888115882874,
        -0.7032962441444397
      ],
      "plane_d": 3757.334228515625,
      "bbox_min": [
        -1627.75,
        -3807.716064453125,
        1211.00048828125
      ],
      "bbox_max": [
        -1617.091064453125,
        -3797.19580078125,
        1218.769775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17299067974090576,
        0.6905023455619812,
        -0.7023394703865051
      ],
      "plane_d": 3759.51220703125,
      "bbox_min": [
        -1627.75,
        -3807.716064453125,
        1211.00048828125
      ],
      "bbox_max": [
        -1617.091064453125,
        -3803.968505859375,
        1213.7716064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16417481005191803,
        0.6365082859992981,
        -0.7535938620567322
      ],
      "plane_d": 3068.2177734375,
      "bbox_min": [
        -1646.205078125,
        -3808.50439453125,
        1211.0009765625
      ],
      "bbox_max": [
        -1627.4481201171875,
        -3797.19580078125,
        1220.315185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13181768357753754,
        0.18077954649925232,
        -0.9746500253677368
      ],
      "plane_d": 1661.41796875,
      "bbox_min": [
        -1620.2213134765625,
        -3792.62841796875,
        1217.89990234375
      ],
      "bbox_max": [
        -1599.745361328125,
        -3770.57861328125,
        1226.5712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7045546770095825,
        0.19844281673431396,
        -0.6813392043113708
      ],
      "plane_d": 447.7281494140625,
      "bbox_min": [
        -1620.2213134765625,
        -3790.956787109375,
        1219.43017578125
      ],
      "bbox_max": [
        -1609.124267578125,
        -3770.57861328125,
        1226.5712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6881714463233948,
        0.2102745771408081,
        -0.6944095492362976
      ],
      "plane_d": 534.922119140625,
      "bbox_min": [
        -1620.2213134765625,
        -3790.956787109375,
        1219.43017578125
      ],
      "bbox_max": [
        -1611.5223388671875,
        -3779.378173828125,
        1226.5712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20802104473114014,
        0.572057843208313,
        -0.7933959364891052
      ],
      "plane_d": 2800.906982421875,
      "bbox_min": [
        -1620.2213134765625,
        -3790.956787109375,
        1219.43017578125
      ],
      "bbox_max": [
        -1611.5223388671875,
        -3782.910400390625,
        1226.5712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18454092741012573,
        -0.9358578324317932,
        -0.30019137263298035
      ],
      "plane_d": -3447.226806640625,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3746.930419921875,
        1222.8856201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08918102830648422,
        -0.9147180914878845,
        -0.39412862062454224
      ],
      "plane_d": -3097.486328125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3748.969482421875,
        1222.8856201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06886692345142365,
        0.5568208694458008,
        0.8277727961540222
      ],
      "plane_d": 1234.6553955078125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1213.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3144074082374573,
        0.5093142986297607,
        0.801091194152832
      ],
      "plane_d": 451.876220703125,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1213.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3147137761116028,
        0.5233975052833557,
        0.7918398976325989
      ],
      "plane_d": 516.2265014648438,
      "bbox_min": [
        -1648.5311279296875,
        -3809.647705078125,
        1211.0
      ],
      "bbox_max": [
        -1637.416259765625,
        -3805.57763671875,
        1212.54833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02820013090968132,
        0.5067659616470337,
        0.8616223335266113
      ],
      "plane_d": 838.9363403320312,
      "bbox_min": [
        -1642.734130859375,
        -3808.50439453125,
        1211.0
      ],
      "bbox_max": [
        -1637.416259765625,
        -3805.57763671875,
        1212.54833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05410146340727806,
        0.5373115539550781,
        0.8416467905044556
      ],
      "plane_d": 1118.922607421875,
      "bbox_min": [
        -1682.0120849609375,
        -3817.3525390625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1213.872802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4070289433002472,
        0.2415713369846344,
        0.8808920979499817
      ],
      "plane_d": 533.7755126953125,
      "bbox_min": [
        -1682.0120849609375,
        -3803.220703125,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5277895927429199,
        0.10864628851413727,
        0.8423978686332703
      ],
      "plane_d": 278.951904296875,
      "bbox_min": [
        -1682.0120849609375,
        -3795.91259765625,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8284815549850464,
        -0.4942668676376343,
        -0.26328396797180176
      ],
      "plane_d": -2884.203857421875,
      "bbox_min": [
        -1628.3133544921875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.423095703125,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9677070379257202,
        -0.2520774304866791
      ],
      "plane_d": -3325.6142578125,
      "bbox_min": [
        -1628.3133544921875,
        -3752.46142578125,
        1211.0
      ],
      "bbox_max": [
        -1627.26416015625,
        -3751.88916015625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1212.60009765625,
      "bbox_min": [
        -1628.3133544921875,
        -3752.46142578125,
        1212.60009765625
      ],
      "bbox_max": [
        -1627.5595703125,
        -3751.88916015625,
        1212.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        0.2892703115940094,
        0.14169162511825562
      ],
      "plane_d": 2458.374755859375,
      "bbox_min": [
        -1626.0,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1615.0,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": -2447.9609375,
      "bbox_min": [
        -1626.0,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1615.0,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9467028379440308,
        0.2892703115940094,
        0.14169162511825562
      ],
      "plane_d": -609.8890991210938,
      "bbox_min": [
        -1626.0,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1615.0,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9467028379440308,
        -0.2892703115940094,
        -0.14169162511825562
      ],
      "plane_d": 620.3029174804688,
      "bbox_min": [
        -1626.0,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1616.375,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043097376823425,
        0.8536851406097412,
        0.4181557595729828
      ],
      "plane_d": 2214.297607421875,
      "bbox_min": [
        -1624.625,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1616.375,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31043097376823425,
        0.8536851406097412,
        0.4181557595729828
      ],
      "plane_d": 3220.404541015625,
      "bbox_min": [
        -1624.625,
        -3788.8125,
        1226.800048828125
      ],
      "bbox_max": [
        -1616.375,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31043097376823425,
        -0.8536851406097412,
        -0.4181557595729828
      ],
      "plane_d": -2204.053466796875,
      "bbox_min": [
        -1624.625,
        -3778.3125,
        1226.800048828125
      ],
      "bbox_max": [
        -1616.375,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31043097376823425,
        -0.8536851406097412,
        -0.4181557595729828
      ],
      "plane_d": -3210.160400390625,
      "bbox_min": [
        -1620.5,
        -3778.3125,
        1226.800048828125
      ],
      "bbox_max": [
        -1616.375,
        -3772.0,
        1236.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939045250415802,
        0.28693050146102905,
        0.18938039243221283
      ],
      "plane_d": 2378.09912109375,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1614.9498291015625,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9433103799819946,
        -0.2882337272167206,
        0.16458085179328918
      ],
      "plane_d": 239.9637451171875,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1614.9498291015625,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9551894068717957,
        0.29186341166496277,
        0.04928591102361679
      ],
      "plane_d": -499.5145263671875,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1614.9498291015625,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9462943077087402,
        -0.28914546966552734,
        -0.14464446902275085
      ],
      "plane_d": -2443.177490234375,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1614.9498291015625,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8801992535591125,
        -0.4712376892566681,
        -0.05643029883503914
      ],
      "plane_d": -3134.34228515625,
      "bbox_min": [
        -1616.421875,
        -3783.534912109375,
        1236.625
      ],
      "bbox_max": [
        -1614.9498291015625,
        -3780.78515625,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3353404402732849,
        0.9221861362457275,
        0.1926640123128891
      ],
      "plane_d": 2712.318115234375,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33623701333999634,
        0.9246517419815063,
        0.17878443002700806
      ],
      "plane_d": 3827.11474609375,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34157514572143555,
        -0.9393316507339478,
        0.0313434861600399
      ],
      "plane_d": -3032.91748046875,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3417237401008606,
        -0.9397402405738831,
        0.010631038807332516
      ],
      "plane_d": -4116.1328125,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7496141791343689,
        0.6587043404579163,
        0.06470910459756851
      ],
      "plane_d": 3632.5400390625,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302451610565186,
        0.36536556482315063,
        0.03394124284386635
      ],
      "plane_d": -161.843994140625,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1615.826171875,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024573173373937607,
        0.9913090467453003,
        0.1292390078306198
      ],
      "plane_d": 3556.2431640625,
      "bbox_min": [
        -1626.8829345703125,
        -3789.51806640625,
        1236.625
      ],
      "bbox_max": [
        -1619.282958984375,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9730247855186462,
        -0.18034766614437103,
        0.14386644959449768
      ],
      "plane_d": 722.008056640625,
      "bbox_min": [
        -1626.8829345703125,
        -3783.38818359375,
        1236.625
      ],
      "bbox_max": [
        -1619.9271240234375,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0829281285405159,
        -0.9958572387695312,
        -0.03730132058262825
      ],
      "plane_d": -3580.6533203125,
      "bbox_min": [
        -1625.6844482421875,
        -3778.7822265625,
        1236.625
      ],
      "bbox_max": [
        -1619.9271240234375,
        -3776.8125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4981979429721832,
        -0.8667582869529724,
        0.022999893873929977
      ],
      "plane_d": -2493.941162109375,
      "bbox_min": [
        -1625.6844482421875,
        -3778.7822265625,
        1236.625
      ],
      "bbox_max": [
        -1624.455078125,
        -3778.075439453125,
        1241.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1697.6888427734375,
        -3855.753173828125,
        1241.875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1697.6888427734375,
        -3855.753173828125,
        1242.515380859375
      ],
      "bbox_max": [
        -1644.9840087890625,
        -3808.170654296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33741268515586853,
        0.9365807771682739,
        0.09470613300800323
      ],
      "plane_d": 2923.193359375,
      "bbox_min": [
        -1670.34228515625,
        -3855.753173828125,
        1246.5
      ],
      "bbox_max": [
        -1644.9840087890625,
        -3819.56494140625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902018308639526,
        -0.13916033506393433,
        0.011614802293479443
      ],
      "plane_d": 1106.7347412109375,
      "bbox_min": [
        -1670.34228515625,
        -3855.753173828125,
        1246.5
      ],
      "bbox_max": [
        -1646.408935546875,
        -3819.56494140625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3388913869857788,
        0.9406852722167969,
        0.016243943944573402
      ],
      "plane_d": 3041.044921875,
      "bbox_min": [
        -1665.1578369140625,
        -3855.753173828125,
        1331.699951171875
      ],
      "bbox_max": [
        -1646.408935546875,
        -3848.9287109375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1697.6888427734375,
        -3823.38525390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1674.972900390625,
        -3810.76416015625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1697.6888427734375,
        -3821.879150390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1697.310791015625,
        -3821.686767578125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1697.5771484375,
        -3823.38525390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1696.4490966796875,
        -3821.83984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1675.1318359375,
        -3814.2333984375,
        1246.58984375
      ],
      "bbox_max": [
        -1658.724609375,
        -3808.170654296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1675.1318359375,
        -3810.85595703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1669.531494140625,
        -3808.170654296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.864705502986908,
        -0.4905621111392975,
        0.1078575849533081
      ],
      "plane_d": -572.09228515625,
      "bbox_min": [
        -1669.9432373046875,
        -3849.11572265625,
        1241.875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9864533543586731,
        -0.07981184124946594,
        0.14331689476966858
      ],
      "plane_d": 1149.176513671875,
      "bbox_min": [
        -1669.9432373046875,
        -3812.98974609375,
        1246.58984375
      ],
      "bbox_max": [
        -1611.5035400390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1669.9432373046875,
        -3812.98974609375,
        1246.58984375
      ],
      "bbox_max": [
        -1651.2203369140625,
        -3769.202880859375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1669.9432373046875,
        -3808.20361328125,
        1331.699951171875
      ],
      "bbox_max": [
        -1666.420654296875,
        -3806.635498046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1645.653076171875,
        -3733.87255859375,
        1331.699951171875
      ],
      "bbox_max": [
        -1644.5631103515625,
        -3733.549560546875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6477246880531311,
        -0.756960928440094,
        0.08638834208250046
      ],
      "plane_d": -1876.1256103515625,
      "bbox_min": [
        -1667.01904296875,
        -3809.007568359375,
        1246.58984375
      ],
      "bbox_max": [
        -1611.5035400390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1645.07177734375,
        -3733.75439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1643.04541015625,
        -3731.993408203125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1645.07177734375,
        -3733.75439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1644.5631103515625,
        -3733.326904296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1667.01904296875,
        -3809.007568359375,
        1246.58984375
      ],
      "bbox_max": [
        -1611.5035400390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1667.01904296875,
        -3809.007568359375,
        1246.58984375
      ],
      "bbox_max": [
        -1648.2965087890625,
        -3767.5068359375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1667.01904296875,
        -3809.007568359375,
        1246.58984375
      ],
      "bbox_max": [
        -1651.1046142578125,
        -3767.5068359375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1667.01904296875,
        -3806.760498046875,
        1331.699951171875
      ],
      "bbox_max": [
        -1666.420654296875,
        -3806.50732421875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1663.367919921875,
        -3767.720703125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1611.5035400390625,
        -3719.9736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.296495258808136,
        -0.9519112706184387,
        0.07717172801494598
      ],
      "plane_d": -4125.87548828125,
      "bbox_min": [
        -1663.367919921875,
        -3767.720703125,
        1282.656005859375
      ],
      "bbox_max": [
        -1613.2510986328125,
        -3720.6796875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.949376106262207,
        -0.19030731916427612,
        0.24993644654750824
      ],
      "plane_d": 517.9078369140625,
      "bbox_min": [
        -1646.0003662109375,
        -3735.605224609375,
        1331.699951171875
      ],
      "bbox_max": [
        -1644.5631103515625,
        -3733.75439453125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1663.367919921875,
        -3767.720703125,
        1331.699951171875
      ],
      "bbox_max": [
        -1662.90380859375,
        -3763.134033203125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977416396141052,
        -0.018138699233531952,
        0.06467321515083313
      ],
      "plane_d": 1504.76416015625,
      "bbox_min": [
        -1663.214599609375,
        -3765.825439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1662.90380859375,
        -3763.134033203125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4191102683544159,
        -0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": -4095.93798828125,
      "bbox_min": [
        -1659.9410400390625,
        -3849.11572265625,
        1241.875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3722.42529296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39069291949272156,
        -0.9204275608062744,
        0.013124043121933937
      ],
      "plane_d": -2834.691650390625,
      "bbox_min": [
        -1616.8040771484375,
        -3745.53173828125,
        1246.5
      ],
      "bbox_max": [
        -1593.6024169921875,
        -3722.42529296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1616.8040771484375,
        -3741.658935546875,
        1246.5
      ],
      "bbox_max": [
        -1597.5826416015625,
        -3722.42529296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.296495258808136,
        -0.9519112706184387,
        0.07717172801494598
      ],
      "plane_d": -4125.87548828125,
      "bbox_min": [
        -1616.8040771484375,
        -3738.53564453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1600.3179931640625,
        -3722.42529296875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1613.2510986328125,
        -3738.53564453125,
        1251.0999755859375
      ],
      "bbox_max": [
        -1600.3179931640625,
        -3726.04541015625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1613.2510986328125,
        -3732.089599609375,
        1251.0999755859375
      ],
      "bbox_max": [
        -1607.8087158203125,
        -3727.836181640625,
        1282.656005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1600.9962158203125,
        -3740.079345703125,
        1291.6932373046875
      ],
      "bbox_max": [
        -1597.5826416015625,
        -3734.22998046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1599.36474609375,
        -3745.53173828125,
        1301.4146728515625
      ],
      "bbox_max": [
        -1593.6024169921875,
        -3738.833251953125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066479921340942,
        0.6295457482337952,
        0.3229873776435852
      ],
      "plane_d": 837.9146728515625,
      "bbox_min": [
        -1647.8997802734375,
        -3849.11572265625,
        1251.0999755859375
      ],
      "bbox_max": [
        -1608.82666015625,
        -3820.07373046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33741268515586853,
        0.9365807771682739,
        0.09470613300800323
      ],
      "plane_d": 2923.193359375,
      "bbox_min": [
        -1645.1859130859375,
        -3845.44482421875,
        1296.6361083984375
      ],
      "bbox_max": [
        -1628.92041015625,
        -3842.62841796875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33741268515586853,
        0.9365807771682739,
        0.09470613300800323
      ],
      "plane_d": 2923.193359375,
      "bbox_min": [
        -1646.7333984375,
        -3849.11572265625,
        1301.603271484375
      ],
      "bbox_max": [
        -1608.82666015625,
        -3820.07373046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1631.2747802734375,
        -3843.885986328125,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.263427734375,
        -3842.62841796875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7948121428489685,
        0.5870009660720825,
        0.15395909547805786
      ],
      "plane_d": 755.9136962890625,
      "bbox_min": [
        -1628.944580078125,
        -3843.723388671875,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.263427734375,
        -3842.62841796875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7434534430503845,
        0.6623353362083435,
        0.09267634153366089
      ],
      "plane_d": 1210.6651611328125,
      "bbox_min": [
        -1646.7333984375,
        -3849.11572265625,
        1331.699951171875
      ],
      "bbox_max": [
        -1608.82666015625,
        -3820.07373046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7948121428489685,
        0.5870009660720825,
        0.15395909547805786
      ],
      "plane_d": 755.9136962890625,
      "bbox_min": [
        -1628.92041015625,
        -3842.801025390625,
        1331.699951171875
      ],
      "bbox_max": [
        -1626.7802734375,
        -3840.792724609375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3388913869857788,
        0.9406852722167969,
        0.016243943944573402
      ],
      "plane_d": 3041.044921875,
      "bbox_min": [
        -1646.7333984375,
        -3849.11572265625,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.92041015625,
        -3842.62841796875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1632.4429931640625,
        -3843.967529296875,
        1331.699951171875
      ],
      "bbox_max": [
        -1628.92041015625,
        -3842.62841796875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7985454797744751,
        -0.6017830967903137,
        0.01349759753793478
      ],
      "plane_d": -3580.92529296875,
      "bbox_min": [
        -1659.9410400390625,
        -3821.700439453125,
        1241.875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1614.317138671875,
        -3804.9716796875,
        1246.5
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8717682361602783,
        0.3423979878425598,
        0.3504050374031067
      ],
      "plane_d": -550.267578125,
      "bbox_min": [
        -1608.8125,
        -3804.9716796875,
        1268.5235595703125
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7221382260322571,
        0.6595426797866821,
        0.20861408114433289
      ],
      "plane_d": 1079.8951416015625,
      "bbox_min": [
        -1599.1326904296875,
        -3800.916748046875,
        1299.8212890625
      ],
      "bbox_max": [
        -1586.87890625,
        -3796.04296875,
        1331.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9611096382141113,
        0.25461429357528687,
        0.10695737600326538
      ],
      "plane_d": -701.0729370117188,
      "bbox_min": [
        -1597.8125,
        -3804.9716796875,
        1309.2608642578125
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7221382260322571,
        0.6595426797866821,
        0.20861408114433289
      ],
      "plane_d": 1079.8951416015625,
      "bbox_min": [
        -1597.8125,
        -3804.9716796875,
        1309.2608642578125
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320245504379272,
        0.6685720682144165,
        0.13096371293067932
      ],
      "plane_d": 1201.8897705078125,
      "bbox_min": [
        -1594.674072265625,
        -3804.9716796875,
        1331.699951171875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100038409233093,
        -0.41456741094589233,
        0.005178479943424463
      ],
      "plane_d": -3006.795166015625,
      "bbox_min": [
        -1580.3922119140625,
        -3769.1318359375,
        1331.699951171875
      ],
      "bbox_max": [
        -1579.4644775390625,
        -3767.095458984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7221382260322571,
        0.6595426797866821,
        0.20861408114433289
      ],
      "plane_d": 1079.8951416015625,
      "bbox_min": [
        -1659.9410400390625,
        -3821.700439453125,
        1241.875
      ],
      "bbox_max": [
        -1594.30908203125,
        -3776.96142578125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1659.9410400390625,
        -3821.700439453125,
        1241.875
      ],
      "bbox_max": [
        -1594.30908203125,
        -3776.96142578125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1652.632080078125,
        -3795.2421875,
        1284.8017578125
      ],
      "bbox_max": [
        -1651.01953125,
        -3782.736328125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8801992535591125,
        -0.4712376892566681,
        -0.05643029883503914
      ],
      "plane_d": -3134.34228515625,
      "bbox_min": [
        -1620.4119873046875,
        -3790.616455078125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3779.969970703125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9551894068717957,
        0.29186341166496277,
        0.04928591102361679
      ],
      "plane_d": -499.5145263671875,
      "bbox_min": [
        -1615.826171875,
        -3786.40283203125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3783.534912109375,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320245504379272,
        0.6685720682144165,
        0.13096371293067932
      ],
      "plane_d": 1201.8897705078125,
      "bbox_min": [
        -1628.434326171875,
        -3821.700439453125,
        1241.875
      ],
      "bbox_max": [
        -1594.30908203125,
        -3776.96142578125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6985849142074585,
        0.7094742059707642,
        0.09287343174219131
      ],
      "plane_d": 1462.6622314453125,
      "bbox_min": [
        -1609.77099609375,
        -3821.700439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1606.439697265625,
        -3818.253662109375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7434534430503845,
        0.6623353362083435,
        0.09267634153366089
      ],
      "plane_d": 1210.6651611328125,
      "bbox_min": [
        -1609.77099609375,
        -3821.700439453125,
        1331.699951171875
      ],
      "bbox_max": [
        -1608.5616455078125,
        -3820.07373046875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.024573173373937607,
        0.9913090467453003,
        0.1292390078306198
      ],
      "plane_d": 3556.2431640625,
      "bbox_min": [
        -1628.434326171875,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0829281285405159,
        -0.9958572387695312,
        -0.03730132058262825
      ],
      "plane_d": -3580.6533203125,
      "bbox_min": [
        -1628.434326171875,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9730247855186462,
        -0.18034766614437103,
        0.14386644959449768
      ],
      "plane_d": 722.008056640625,
      "bbox_min": [
        -1628.434326171875,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939045250415802,
        0.28693050146102905,
        0.18938039243221283
      ],
      "plane_d": 2378.09912109375,
      "bbox_min": [
        -1628.434326171875,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4981979429721832,
        -0.8667582869529724,
        0.022999893873929977
      ],
      "plane_d": -2493.941162109375,
      "bbox_min": [
        -1627.546142578125,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9433103799819946,
        -0.2882337272167206,
        0.16458085179328918
      ],
      "plane_d": 239.9637451171875,
      "bbox_min": [
        -1627.546142578125,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33623701333999634,
        0.9246517419815063,
        0.17878443002700806
      ],
      "plane_d": 3827.11474609375,
      "bbox_min": [
        -1624.455078125,
        -3790.7578125,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9462943077087402,
        -0.28914546966552734,
        -0.14464446902275085
      ],
      "plane_d": -2443.177490234375,
      "bbox_min": [
        -1624.455078125,
        -3784.80419921875,
        1241.875
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8801992535591125,
        -0.4712376892566681,
        -0.05643029883503914
      ],
      "plane_d": -3134.34228515625,
      "bbox_min": [
        -1618.92041015625,
        -3784.80419921875,
        1242.5655517578125
      ],
      "bbox_max": [
        -1614.8616943359375,
        -3777.22314453125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34157514572143555,
        -0.9393316507339478,
        0.0313434861600399
      ],
      "plane_d": -3032.91748046875,
      "bbox_min": [
        -1624.455078125,
        -3778.075439453125,
        1241.875
      ],
      "bbox_max": [
        -1617.2982177734375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3417237401008606,
        -0.9397402405738831,
        0.010631038807332516
      ],
      "plane_d": -4116.1328125,
      "bbox_min": [
        -1619.9271240234375,
        -3777.91748046875,
        1241.875
      ],
      "bbox_max": [
        -1617.2982177734375,
        -3776.96142578125,
        1251.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9676579833030701,
        -0.25142771005630493,
        -0.020547961816191673
      ],
      "plane_d": 587.4915771484375,
      "bbox_min": [
        -1586.75,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1423.0,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9677536487579346,
        0.25145256519317627,
        -0.014980371110141277
      ],
      "plane_d": -388.656982421875,
      "bbox_min": [
        -1586.75,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1423.0,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9666728377342224,
        0.25530996918678284,
        -0.018981805071234703
      ],
      "plane_d": -366.9527587890625,
      "bbox_min": [
        -1443.03125,
        -3934.09375,
        1241.875
      ],
      "bbox_max": [
        -1423.0,
        -3857.63037109375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9532542824745178,
        -0.24768516421318054,
        -0.1730845719575882
      ],
      "plane_d": -2097.16259765625,
      "bbox_min": [
        -1429.0,
        -3876.5625,
        1241.875
      ],
      "bbox_max": [
        -1423.0,
        -3857.63037109375,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1586.75,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1423.1636962890625,
        -3757.125,
        1301.125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1586.75,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1426.1029052734375,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1577.23974609375,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1443.03125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3961.165771484375,
      "bbox_min": [
        -1560.691162109375,
        -3977.75,
        1241.875
      ],
      "bbox_max": [
        -1455.058837890625,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38111934065818787,
        0.8912402391433716,
        0.24584342539310455
      ],
      "plane_d": 2650.57763671875,
      "bbox_min": [
        -1546.6568603515625,
        -3977.75,
        1247.6492919921875
      ],
      "bbox_max": [
        -1469.0931396484375,
        -3961.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369655579328537,
        0.8786745071411133,
        0.302135169506073
      ],
      "plane_d": 3659.42626953125,
      "bbox_min": [
        -1546.6568603515625,
        -3977.75,
        1247.6492919921875
      ],
      "bbox_max": [
        -1503.587890625,
        -3961.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37553295493125916,
        0.8781765699386597,
        0.29627832770347595
      ],
      "plane_d": 3673.92822265625,
      "bbox_min": [
        -1546.6568603515625,
        -3977.75,
        1278.616943359375
      ],
      "bbox_max": [
        -1507.875,
        -3961.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38111934065818787,
        0.8912402391433716,
        0.24584342539310455
      ],
      "plane_d": 2650.57763671875,
      "bbox_min": [
        -1560.691162109375,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1455.058837890625,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37634217739105225,
        0.8945685625076294,
        0.24106791615486145
      ],
      "plane_d": 2676.86669921875,
      "bbox_min": [
        -1503.125,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1470.02880859375,
        -3955.164306640625,
        1277.917724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.498291015625,
        1262.353271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1499.300048828125,
        -3958.1650390625,
        1241.875
      ],
      "bbox_max": [
        -1498.99560546875,
        -3957.6376953125,
        1243.357421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3271.559814453125,
      "bbox_min": [
        -1499.300048828125,
        -3958.818359375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.447265625,
        1254.161376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1499.300048828125,
        -3958.818359375,
        1241.875
      ],
      "bbox_max": [
        -1498.9228515625,
        -3957.599853515625,
        1246.370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1499.300048828125,
        -3958.1650390625,
        1241.875
      ],
      "bbox_max": [
        -1498.9737548828125,
        -3957.599853515625,
        1243.418212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1560.691162109375,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3322.59423828125,
      "bbox_min": [
        -1551.7701416015625,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1551.2999267578125,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1551.2999267578125,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1542.6373291015625,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37553295493125916,
        0.8781765699386597,
        0.29627832770347595
      ],
      "plane_d": 3673.92822265625,
      "bbox_min": [
        -1551.2999267578125,
        -3961.165771484375,
        1247.73974609375
      ],
      "bbox_max": [
        -1544.369873046875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588711977005005,
        -0.08266758173704147,
        -0.962367832660675
      ],
      "plane_d": 492.33966064453125,
      "bbox_min": [
        -1549.436279296875,
        -3958.300048828125,
        1247.73974609375
      ],
      "bbox_max": [
        -1544.369873046875,
        -3955.164306640625,
        1268.0740966796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1549.436279296875,
        -3958.300048828125,
        1247.73974609375
      ],
      "bbox_max": [
        -1544.369873046875,
        -3955.164306640625,
        1268.0740966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1549.436279296875,
        -3958.300048828125,
        1267.332763671875
      ],
      "bbox_max": [
        -1546.4710693359375,
        -3955.164306640625,
        1268.0740966796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1546.1025390625,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1499.2154541015625,
        -3961.165771484375,
        1248.0313720703125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14528056979179382,
        -0.49755656719207764,
        -0.8551788926124573
      ],
      "plane_d": -1079.2119140625,
      "bbox_min": [
        -1499.2154541015625,
        -3958.0185546875,
        1248.0313720703125
      ],
      "bbox_max": [
        -1494.78466796875,
        -3955.164306640625,
        1295.5570068359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1497.8231201171875,
        -3958.0,
        1293.81201171875
      ],
      "bbox_max": [
        -1494.78466796875,
        -3955.164306640625,
        1295.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3860553801059723,
        -0.07791142165660858,
        -0.9191795587539673
      ],
      "plane_d": 1417.220703125,
      "bbox_min": [
        -1499.2154541015625,
        -3958.0185546875,
        1248.0313720703125
      ],
      "bbox_max": [
        -1494.78466796875,
        -3955.164306640625,
        1254.8665771484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1499.2154541015625,
        -3958.0185546875,
        1248.0313720703125
      ],
      "bbox_max": [
        -1496.0,
        -3955.607177734375,
        1249.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1498.1605224609375,
        -3955.607177734375,
        1293.7171630859375
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3955.164306640625,
        1293.91748046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.369655579328537,
        0.8786745071411133,
        0.302135169506073
      ],
      "plane_d": 3659.42626953125,
      "bbox_min": [
        -1517.9815673828125,
        -3961.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1503.125,
        -3955.164306640625,
        1250.253173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369655579328537,
        0.8786745071411133,
        0.302135169506073
      ],
      "plane_d": 3659.42626953125,
      "bbox_min": [
        -1530.4105224609375,
        -3961.165771484375,
        1247.8060302734375
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3955.164306640625,
        1263.0125732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37553295493125916,
        0.8781765699386597,
        0.29627832770347595
      ],
      "plane_d": 3673.92822265625,
      "bbox_min": [
        -1551.7701416015625,
        -3959.51318359375,
        1298.1153564453125
      ],
      "bbox_max": [
        -1550.5213623046875,
        -3958.164794921875,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37553295493125916,
        0.8781765699386597,
        0.29627832770347595
      ],
      "plane_d": 3673.92822265625,
      "bbox_min": [
        -1560.691162109375,
        -3958.979248046875,
        1287.0257568359375
      ],
      "bbox_max": [
        -1549.5675048828125,
        -3955.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3919.165771484375,
      "bbox_min": [
        -1577.23974609375,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1443.03125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.37634217739105225,
        0.8945685625076294,
        0.24106791615486145
      ],
      "plane_d": 2676.86669921875,
      "bbox_min": [
        -1575.680419921875,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1443.03125,
        -3919.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38111934065818787,
        0.8912402391433716,
        0.24584342539310455
      ],
      "plane_d": 2650.57763671875,
      "bbox_min": [
        -1470.02880859375,
        -3955.164306640625,
        1277.917724609375
      ],
      "bbox_max": [
        -1448.71875,
        -3952.453125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584877490997314,
        0.2490449994802475,
        0.13884463906288147
      ],
      "plane_d": 2305.664794921875,
      "bbox_min": [
        -1575.680419921875,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1479.3568115234375,
        -3919.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.958023190498352,
        0.25302547216415405,
        0.13479509949684143
      ],
      "plane_d": 2325.627197265625,
      "bbox_min": [
        -1569.3245849609375,
        -3934.09375,
        1241.875
      ],
      "bbox_max": [
        -1563.21875,
        -3919.165771484375,
        1257.2489013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37553295493125916,
        0.8781765699386597,
        0.29627832770347595
      ],
      "plane_d": 3673.92822265625,
      "bbox_min": [
        -1567.03125,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1479.3568115234375,
        -3919.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1553.166748046875,
        -3955.164306640625,
        1243.2423095703125
      ],
      "bbox_max": [
        -1518.6234130859375,
        -3943.9736328125,
        1268.2601318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588711977005005,
        -0.08266758173704147,
        -0.962367832660675
      ],
      "plane_d": 492.33966064453125,
      "bbox_min": [
        -1553.166748046875,
        -3955.164306640625,
        1263.0845947265625
      ],
      "bbox_max": [
        -1530.6783447265625,
        -3947.2939453125,
        1268.2601318359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24151511490345,
        0.09163887798786163,
        0.9660604596138
      ],
      "plane_d": -488.377197265625,
      "bbox_min": [
        -1553.166748046875,
        -3955.164306640625,
        1266.3309326171875
      ],
      "bbox_max": [
        -1544.2503662109375,
        -3947.2939453125,
        1268.2601318359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.14528056979179382,
        0.4975566267967224,
        0.8551788926124573
      ],
      "plane_d": 1079.212158203125,
      "bbox_min": [
        -1566.4993896484375,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1479.3568115234375,
        -3919.165771484375,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2588711678981781,
        0.08266759663820267,
        0.9623677730560303
      ],
      "plane_d": -492.3395080566406,
      "bbox_min": [
        -1541.0958251953125,
        -3955.164306640625,
        1263.0125732421875
      ],
      "bbox_max": [
        -1530.41064453125,
        -3951.550537109375,
        1265.5765380859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1566.4993896484375,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1488.7708740234375,
        -3919.165771484375,
        1268.9251708984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.002158845541998744,
        0.37377816438674927,
        0.9275156259536743
      ],
      "plane_d": 317.71728515625,
      "bbox_min": [
        -1541.12939453125,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1488.7708740234375,
        -3919.165771484375,
        1250.6064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3860553801059723,
        0.07791141420602798,
        0.9191795587539673
      ],
      "plane_d": -1417.220703125,
      "bbox_min": [
        -1509.4117431640625,
        -3955.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1488.7708740234375,
        -3919.165771484375,
        1250.6064453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3860553801059723,
        -0.07791142165660858,
        -0.9191795587539673
      ],
      "plane_d": 1417.220703125,
      "bbox_min": [
        -1488.807373046875,
        -3941.13232421875,
        1248.729248046875
      ],
      "bbox_max": [
        -1479.3568115234375,
        -3919.165771484375,
        1252.698486328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1577.23974609375,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1577.23974609375,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1573.0325927734375,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1522.63720703125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1562.6376953125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.958023190498352,
        0.25302547216415405,
        0.13479509949684143
      ],
      "plane_d": 2325.627197265625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1269.1849365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584877490997314,
        0.2490449994802475,
        0.13884463906288147
      ],
      "plane_d": 2305.664794921875,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1257.2489013671875
      ],
      "bbox_max": [
        -1569.3245849609375,
        -3915.40673828125,
        1265.5040283203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1568.0,
        -3919.165771484375,
        1268.108154296875
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1269.1849365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24028833210468292,
        0.13581512868404388,
        -0.9611533284187317
      ],
      "plane_d": 1374.783447265625,
      "bbox_min": [
        -1568.0,
        -3916.0,
        1268.1163330078125
      ],
      "bbox_max": [
        -1564.46533203125,
        -3913.164306640625,
        1269.1849365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1566.1029052734375,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1533.0325927734375,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6227401494979858,
        0.2059522122144699,
        0.7548365592956543
      ],
      "plane_d": 794.8843383789062,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1258.6689453125
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1278.767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1258.6689453125
      ],
      "bbox_max": [
        -1525.8807373046875,
        -3913.164306640625,
        1259.8406982421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24028833210468292,
        0.13581512868404388,
        -0.9611533284187317
      ],
      "plane_d": 1374.783447265625,
      "bbox_min": [
        -1531.204833984375,
        -3916.0,
        1259.0
      ],
      "bbox_max": [
        -1526.397216796875,
        -3913.164306640625,
        1259.80126953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1531.3953857421875,
        -3916.1650390625,
        1259.7926025390625
      ],
      "bbox_max": [
        -1529.5673828125,
        -3913.164306640625,
        1259.848876953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07460525631904602,
        0.23192505538463593,
        -0.9698684215545654
      ],
      "plane_d": 2015.285888671875,
      "bbox_min": [
        -1529.602783203125,
        -3913.1953125,
        1259.7926025390625
      ],
      "bbox_max": [
        -1529.5673828125,
        -3913.164306640625,
        1259.8013916015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6227401494979858,
        0.2059522122144699,
        0.7548365592956543
      ],
      "plane_d": 794.8843383789062,
      "bbox_min": [
        -1566.1029052734375,
        -3919.165771484375,
        1259.692138671875
      ],
      "bbox_max": [
        -1529.5675048828125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24151511490345,
        -0.09163888543844223,
        -0.9660604596138
      ],
      "plane_d": 488.37713623046875,
      "bbox_min": [
        -1566.1029052734375,
        -3919.165771484375,
        1259.692138671875
      ],
      "bbox_max": [
        -1529.5675048828125,
        -3913.164306640625,
        1268.9263916015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24028833210468292,
        0.13581512868404388,
        -0.9611533284187317
      ],
      "plane_d": 1374.783447265625,
      "bbox_min": [
        -1566.1029052734375,
        -3916.0,
        1259.848876953125
      ],
      "bbox_max": [
        -1531.3953857421875,
        -3913.164306640625,
        1268.9263916015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1258.6231689453125
      ],
      "bbox_max": [
        -1522.63720703125,
        -3916.164794921875,
        1277.904296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.14528056979179382,
        -0.49755656719207764,
        -0.8551788926124573
      ],
      "plane_d": -1079.2119140625,
      "bbox_min": [
        -1526.1025390625,
        -3919.165771484375,
        1277.25830078125
      ],
      "bbox_max": [
        -1525.5880126953125,
        -3918.781494140625,
        1277.51953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1483.032470703125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3860553801059723,
        -0.07791142165660858,
        -0.9191795587539673
      ],
      "plane_d": 1417.220703125,
      "bbox_min": [
        -1481.3001708984375,
        -3919.165771484375,
        1251.6279296875
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1284.8291015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1283.2462158203125
      ],
      "bbox_max": [
        -1478.0,
        -3913.164306640625,
        1284.8291015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3860553801059723,
        -0.07791142165660858,
        -0.9191795587539673
      ],
      "plane_d": 1417.220703125,
      "bbox_min": [
        -1483.032470703125,
        -3919.165771484375,
        1251.1546630859375
      ],
      "bbox_max": [
        -1479.567626953125,
        -3916.1650390625,
        1284.79541015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1483.032470703125,
        -3919.165771484375,
        1283.5264892578125
      ],
      "bbox_max": [
        -1479.567626953125,
        -3916.1650390625,
        1284.79541015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15562114119529724,
        -0.1725364774465561,
        -0.972632110118866
      ],
      "plane_d": 803.2149047851562,
      "bbox_min": [
        -1526.1026611328125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1284.240966796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15019574761390686,
        -0.3102256655693054,
        -0.9387232065200806
      ],
      "plane_d": 212.4661407470703,
      "bbox_min": [
        -1524.465087890625,
        -3919.165771484375,
        1276.5655517578125
      ],
      "bbox_max": [
        -1481.2047119140625,
        -3916.0,
        1284.240966796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37827789783477783,
        0.21380923688411713,
        0.9006616473197937
      ],
      "plane_d": -850.3468017578125,
      "bbox_min": [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1251.66845703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3860553801059723,
        -0.07791142165660858,
        -0.9191795587539673
      ],
      "plane_d": 1417.220703125,
      "bbox_min": [
        -1505.126953125,
        -3919.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1481.204833984375,
        -3916.0,
        1251.6539306640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.958023190498352,
        0.25302547216415405,
        0.13479509949684143
      ],
      "plane_d": 2325.627197265625,
      "bbox_min": [
        -1573.0325927734375,
        -3916.1650390625,
        1247.70947265625
      ],
      "bbox_max": [
        -1569.5673828125,
        -3913.164306640625,
        1272.0819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584877490997314,
        0.2490449994802475,
        0.13884463906288147
      ],
      "plane_d": 2305.664794921875,
      "bbox_min": [
        -1573.0325927734375,
        -3916.1650390625,
        1261.120361328125
      ],
      "bbox_max": [
        -1570.8621826171875,
        -3913.164306640625,
        1272.0819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584877490997314,
        0.2490449994802475,
        0.13884463906288147
      ],
      "plane_d": 2305.664794921875,
      "bbox_min": [
        -1577.23974609375,
        -3919.165771484375,
        1258.9263916015625
      ],
      "bbox_max": [
        -1569.567626953125,
        -3913.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3873.165771484375,
      "bbox_min": [
        -1586.75,
        -3913.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1426.1029052734375,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.958023190498352,
        0.25302547216415405,
        0.13479509949684143
      ],
      "plane_d": 2325.627197265625,
      "bbox_min": [
        -1586.75,
        -3913.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1427.952880859375,
        -3873.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9584877490997314,
        0.2490449994802475,
        0.13884463906288147
      ],
      "plane_d": 2305.664794921875,
      "bbox_min": [
        -1586.75,
        -3913.164306640625,
        1263.4296875
      ],
      "bbox_max": [
        -1571.779296875,
        -3876.5625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07460525631904602,
        0.23192505538463593,
        -0.9698684215545654
      ],
      "plane_d": 2015.285888671875,
      "bbox_min": [
        -1567.136962890625,
        -3913.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1427.952880859375,
        -3873.165771484375,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15562114119529724,
        -0.1725364774465561,
        -0.972632110118866
      ],
      "plane_d": 803.2149047851562,
      "bbox_min": [
        -1567.136962890625,
        -3913.164306640625,
        1259.8013916015625
      ],
      "bbox_max": [
        -1427.952880859375,
        -3873.165771484375,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24028833210468292,
        0.13581512868404388,
        -0.9611533284187317
      ],
      "plane_d": 1374.783447265625,
      "bbox_min": [
        -1567.0582275390625,
        -3912.90576171875,
        1267.728271484375
      ],
      "bbox_max": [
        -1427.952880859375,
        -3873.165771484375,
        1301.125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9532542824745178,
        -0.24768516421318054,
        -0.1730845719575882
      ],
      "plane_d": -2097.16259765625,
      "bbox_min": [
        -1429.882568359375,
        -3876.5625,
        1290.49755859375
      ],
      "bbox_max": [
        -1427.952880859375,
        -3873.165771484375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24028833210468292,
        -0.13581514358520508,
        0.9611533284187317
      ],
      "plane_d": -1374.783447265625,
      "bbox_min": [
        -1567.136962890625,
        -3913.164306640625,
        1259.8013916015625
      ],
      "bbox_max": [
        -1529.602783203125,
        -3885.115234375,
        1269.2017822265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37827789783477783,
        0.21380923688411713,
        0.9006616473197937
      ],
      "plane_d": -850.3468017578125,
      "bbox_min": [
        -1502.88525390625,
        -3913.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1479.4794921875,
        -3891.630859375,
        1251.7054443359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1500.3482666015625,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1554.9635009765625,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1500.3482666015625,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1554.9635009765625,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1550.274658203125,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07460525631904602,
        0.23192505538463593,
        -0.9698684215545654
      ],
      "plane_d": 2015.285888671875,
      "bbox_min": [
        -1554.9635009765625,
        -3873.165771484375,
        1271.0970458984375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3870.0,
        1272.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.24028833210468292,
        0.13581512868404388,
        -0.9611533284187317
      ],
      "plane_d": 1374.783447265625,
      "bbox_min": [
        -1554.9635009765625,
        -3873.165771484375,
        1271.1053466796875
      ],
      "bbox_max": [
        -1552.210693359375,
        -3870.0,
        1272.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07460525631904602,
        0.23192505538463593,
        -0.9698684215545654
      ],
      "plane_d": 2015.285888671875,
      "bbox_min": [
        -1550.4652099609375,
        -3870.1650390625,
        1271.6812744140625
      ],
      "bbox_max": [
        -1550.274658203125,
        -3870.0,
        1271.72802734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15562114119529724,
        -0.1725364774465561,
        -0.972632110118866
      ],
      "plane_d": 803.2149047851562,
      "bbox_min": [
        -1505.3001708984375,
        -3873.165771484375,
        1267.4185791015625
      ],
      "bbox_max": [
        -1500.3482666015625,
        -3870.0,
        1272.8258056640625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15562114119529724,
        -0.1725364774465561,
        -0.972632110118866
      ],
      "plane_d": 803.2149047851562,
      "bbox_min": [
        -1503.789306640625,
        -3873.165771484375,
        1272.2584228515625
      ],
      "bbox_max": [
        -1503.5677490234375,
        -3872.971923828125,
        1272.3106689453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1241.875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3870.1650390625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9532542824745178,
        -0.24768516421318054,
        -0.1730845719575882
      ],
      "plane_d": -2097.16259765625,
      "bbox_min": [
        -1431.44189453125,
        -3873.165771484375,
        1271.720458984375
      ],
      "bbox_max": [
        -1426.1029052734375,
        -3867.164306640625,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9529298543930054,
        -0.25168025493621826,
        -0.16906136274337769
      ],
      "plane_d": -2117.111328125,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.1636962890625,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9667154550552368,
        -0.255321204662323,
        -0.016506312415003777
      ],
      "plane_d": 565.9578857421875,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.2099609375,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3750496804714203,
        -0.8770463466644287,
        -0.3002123534679413
      ],
      "plane_d": -3486.09326171875,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.2099609375,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3691811263561249,
        -0.8775467276573181,
        -0.30596888065338135
      ],
      "plane_d": -3472.0029296875,
      "bbox_min": [
        -1503.125,
        -3800.671875,
        1241.875
      ],
      "bbox_max": [
        -1443.03125,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37594887614250183,
        -0.8936337232589722,
        -0.24511492252349854
      ],
      "plane_d": -2487.9931640625,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.2099609375,
        -3757.125,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38070547580718994,
        -0.8902723789215088,
        -0.24995681643486023
      ],
      "plane_d": -2461.830810546875,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.2099609375,
        -3775.375,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9532542824745178,
        -0.24768516421318054,
        -0.1730845719575882
      ],
      "plane_d": -2097.16259765625,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1423.2099609375,
        -3800.671875,
        1301.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.958023190498352,
        0.25302547216415405,
        0.13479509949684143
      ],
      "plane_d": 2325.627197265625,
      "bbox_min": [
        -1584.9537353515625,
        -3867.164306640625,
        1241.875
      ],
      "bbox_max": [
        -1580.8956298828125,
        -3858.25,
        1270.7171630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09477043896913528,
        -0.22161883115768433,
        -0.9705172181129456
      ],
      "plane_d": 283.16796875,
      "bbox_min": [
        -1586.75,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3775.375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01431210059672594,
        -0.31187528371810913,
        -0.9500151872634888
      ],
      "plane_d": 71.48709106445312,
      "bbox_min": [
        -1561.6781005859375,
        -3942.737060546875,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27409252524375916,
        -0.8793426752090454,
        -0.3893965482711792
      ],
      "plane_d": -3322.20068359375,
      "bbox_min": [
        -1561.6781005859375,
        -3907.87060546875,
        1322.127197265625
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1322.127197265625
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1322.127197265625
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1322.179443359375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1323.086181640625
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1503.5675048828125,
        -3873.165771484375,
        1323.1904296875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1503.5675048828125,
        -3873.165771484375,
        1324.097412109375
      ],
      "bbox_max": [
        -1500.1025390625,
        -3873.165771484375,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1322.9708251953125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1323.0230712890625
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1323.9296875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1324.0341796875
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1324.94091796875
      ],
      "bbox_max": [
        -1444.1025390625,
        -3873.165771484375,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1326.4039306640625
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1326.7423095703125
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1326.9200439453125
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1327.5968017578125
      ],
      "bbox_max": [
        -1552.1025390625,
        -3870.1650390625,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1327.7744140625
      ],
      "bbox_max": [
        -1552.1025390625,
        -3873.165771484375,
        1330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2354559451341629,
        -0.821074366569519,
        -0.5199974775314331
      ],
      "plane_d": -2143.179931640625,
      "bbox_min": [
        -1561.6781005859375,
        -3907.87060546875,
        1329.375
      ],
      "bbox_max": [
        -1486.280029296875,
        -3890.375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1733468472957611,
        -0.8141732215881348,
        -0.5541415214538574
      ],
      "plane_d": -2165.860107421875,
      "bbox_min": [
        -1532.3333740234375,
        -3907.87060546875,
        1329.375
      ],
      "bbox_max": [
        -1486.280029296875,
        -3890.375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5578601956367493,
        -0.24393770098686218,
        -0.793275773525238
      ],
      "plane_d": -722.8253173828125,
      "bbox_min": [
        -1487.1475830078125,
        -3907.87060546875,
        1335.1400146484375
      ],
      "bbox_max": [
        -1486.280029296875,
        -3906.009765625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46070587635040283,
        -0.11970574408769608,
        -0.8794434070587158
      ],
      "plane_d": 21.87030029296875,
      "bbox_min": [
        -1534.5703125,
        -3942.737060546875,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5578601956367493,
        -0.24393770098686218,
        -0.793275773525238
      ],
      "plane_d": -722.8253173828125,
      "bbox_min": [
        -1486.3338623046875,
        -3942.737060546875,
        1315.8577880859375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1315.8577880859375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1324.9932861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1315.8577880859375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1324.94091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1315.8577880859375
      ],
      "bbox_max": [
        -1444.1025390625,
        -3867.164306640625,
        1324.94091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1449.300048828125,
        -3870.1650390625,
        1315.8577880859375
      ],
      "bbox_max": [
        -1444.1025390625,
        -3867.164306640625,
        1323.9296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3870.1650390625,
        1316.1961669921875
      ],
      "bbox_max": [
        -1447.5675048828125,
        -3867.164306640625,
        1323.9296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1331.5872802734375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1331.5872802734375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1331.7747802734375
      ],
      "bbox_max": [
        -1476.1025390625,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1333.072509765625
      ],
      "bbox_max": [
        -1476.1025390625,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1333.447021484375
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1334.744873046875
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3916.1650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1334.93212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1334.93212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1334.93212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1334.93212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1334.93212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1476.1025390625,
        -3916.1650390625,
        1330.282958984375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1331.7747802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584287762641907,
        0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": 3070.11376953125,
      "bbox_min": [
        -1534.5703125,
        -3920.25927734375,
        1321.326171875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9912278652191162,
        0.13216371834278107
      ],
      "plane_d": 3699.267333984375,
      "bbox_min": [
        -1534.5703125,
        -3920.25927734375,
        1333.4356689453125
      ],
      "bbox_max": [
        -1521.003662109375,
        -3909.796630859375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584294319152832,
        0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": 446.7625732421875,
      "bbox_min": [
        -1534.5703125,
        -3920.25927734375,
        1334.151611328125
      ],
      "bbox_max": [
        -1521.003662109375,
        -3909.89208984375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1334.369140625
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1334.70751953125
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1334.88525390625
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3916.1650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1526.20947265625,
        -3919.165771484375,
        1335.739501953125
      ],
      "bbox_max": [
        -1526.1025390625,
        -3919.165771484375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1479.5675048828125,
        -3919.165771484375,
        1329.4866943359375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1333.414306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1479.5675048828125,
        -3919.165771484375,
        1329.4866943359375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1333.414306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1476.1025390625,
        -3919.165771484375,
        1329.4866943359375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1331.59912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1476.1025390625,
        -3916.1650390625,
        1329.4866943359375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1330.7823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1321.326171875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1324.1495361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1321.326171875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1324.1495361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1321.326171875
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1324.1495361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1321.326171875
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1324.097412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1505.300048828125,
        -3870.1650390625,
        1321.326171875
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1323.086181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1503.5675048828125,
        -3867.164306640625,
        1321.326171875
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1322.179443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10918858647346497,
        -0.25533539056777954,
        -0.9606673121452332
      ],
      "plane_d": 450.6042175292969,
      "bbox_min": [
        -1586.75,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3775.375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016486825421452522,
        -0.30682066082954407,
        -0.9516245722770691
      ],
      "plane_d": 46.22248840332031,
      "bbox_min": [
        -1577.32568359375,
        -3935.345947265625,
        1301.125
      ],
      "bbox_max": [
        -1528.25,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2354559451341629,
        -0.821074366569519,
        -0.5199974775314331
      ],
      "plane_d": -2143.179931640625,
      "bbox_min": [
        -1570.365234375,
        -3907.885009765625,
        1322.3046875
      ],
      "bbox_max": [
        -1528.25,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1570.0400390625,
        -3906.380126953125,
        1322.3046875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1570.0400390625,
        -3906.380126953125,
        1322.3046875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1322.3046875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1328.11279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1322.3046875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1328.11279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1323.2421875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3870.1650390625,
        1328.11279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1324.23974609375
      ],
      "bbox_max": [
        -1552.1025390625,
        -3873.165771484375,
        1328.11279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001385469367960468,
        -0.9999999403953552,
        0.0004428959218785167
      ],
      "plane_d": -3906.383544921875,
      "bbox_min": [
        -1570.0400390625,
        -3906.380126953125,
        1335.1400146484375
      ],
      "bbox_max": [
        -1568.6912841796875,
        -3906.009521484375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.942906379699707,
        -0.23899878561496735,
        -0.23196375370025635
      ],
      "plane_d": 856.5732421875,
      "bbox_min": [
        -1570.0400390625,
        -3906.380126953125,
        1335.1400146484375
      ],
      "bbox_max": [
        -1569.889892578125,
        -3906.009765625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.942906379699707,
        -0.23899878561496735,
        -0.23196375370025635
      ],
      "plane_d": 856.5732421875,
      "bbox_min": [
        -1570.365234375,
        -3907.885009765625,
        1335.1400146484375
      ],
      "bbox_max": [
        -1569.9837646484375,
        -3906.010009765625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7954450845718384,
        -0.20668141543865204,
        -0.5696927309036255
      ],
      "plane_d": 1202.200439453125,
      "bbox_min": [
        -1577.32568359375,
        -3935.345947265625,
        1301.125
      ],
      "bbox_max": [
        -1531.798583984375,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.942906379699707,
        -0.23899878561496735,
        -0.23196375370025635
      ],
      "plane_d": 856.5732421875,
      "bbox_min": [
        -1577.32568359375,
        -3935.345947265625,
        1335.1400146484375
      ],
      "bbox_max": [
        -1570.0400390625,
        -3906.010009765625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584287762641907,
        -0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": -3434.8828125,
      "bbox_min": [
        -1534.855224609375,
        -3916.93310546875,
        1335.4351806640625
      ],
      "bbox_max": [
        -1534.26806640625,
        -3916.0,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1329.275146484375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3905.650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1329.275146484375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3905.650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5326038002967834,
        -0.21197277307510376,
        -0.8193904757499695
      ],
      "plane_d": -572.1412963867188,
      "bbox_min": [
        -1569.5675048828125,
        -3916.1650390625,
        1329.275146484375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3905.650390625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1569.5675048828125,
        -3916.1650390625,
        1331.798095703125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3913.164306640625,
        1332.032958984375
      ],
      "bbox_max": [
        -1566.1025390625,
        -3913.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3915.179931640625,
        1330.7362060546875
      ],
      "bbox_max": [
        -1564.938720703125,
        -3913.164306640625,
        1334.28515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1566.1025390625,
        -3915.179931640625,
        1331.1300048828125
      ],
      "bbox_max": [
        -1564.938720703125,
        -3913.164306640625,
        1332.0330810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1320.1009521484375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1324.2996826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1320.1009521484375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1324.2996826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1320.1009521484375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1324.23974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1555.5675048828125,
        -3870.1650390625,
        1320.1009521484375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1323.2421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3277.78759765625,
      "bbox_min": [
        -1552.1025390625,
        -3870.1650390625,
        1320.494873046875
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1323.2421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46070587635040283,
        -0.11970574408769608,
        -0.8794434070587158
      ],
      "plane_d": 21.87030029296875,
      "bbox_min": [
        -1586.75,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7959083914756775,
        0.20680180191993713,
        -0.5690016746520996
      ],
      "plane_d": 404.66943359375,
      "bbox_min": [
        -1474.9388427734375,
        -3954.139892578125,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4266683757305145,
        -0.19115078449249268,
        -0.8839770555496216
      ],
      "plane_d": -200.55242919921875,
      "bbox_min": [
        -1474.9388427734375,
        -3954.139892578125,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1307.2581787109375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1317.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1307.2581787109375
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1317.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1307.7574462890625
      ],
      "bbox_max": [
        -1444.1025390625,
        -3867.164306640625,
        1317.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1307.7574462890625
      ],
      "bbox_max": [
        -1444.1025390625,
        -3867.164306640625,
        1317.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1309.572509765625
      ],
      "bbox_max": [
        -1447.5675048828125,
        -3867.164306640625,
        1317.566650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3870.1650390625,
        1309.572509765625
      ],
      "bbox_max": [
        -1447.5675048828125,
        -3867.164306640625,
        1317.050537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7734952569007874,
        0.27196380496025085,
        -0.5724865794181824
      ],
      "plane_d": 699.2237548828125,
      "bbox_min": [
        -1474.9388427734375,
        -3954.139892578125,
        1330.626220703125
      ],
      "bbox_max": [
        -1467.702880859375,
        -3942.9375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7954450845718384,
        -0.20668141543865204,
        -0.5696927309036255
      ],
      "plane_d": 1202.200439453125,
      "bbox_min": [
        -1586.75,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3800.671875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.942906379699707,
        -0.23899878561496735,
        -0.23196375370025635
      ],
      "plane_d": 856.5732421875,
      "bbox_min": [
        -1579.25,
        -3942.9375,
        1335.615478515625
      ],
      "bbox_max": [
        -1577.218994140625,
        -3934.794189453125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169703125953674,
        0.3224101662635803,
        0.23498328030109406
      ],
      "plane_d": 2405.489501953125,
      "bbox_min": [
        -1579.25,
        -3943.022705078125,
        1335.704345703125
      ],
      "bbox_max": [
        -1579.2200927734375,
        -3942.9375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7959083914756775,
        0.20680180191993713,
        -0.5690016746520996
      ],
      "plane_d": 404.66943359375,
      "bbox_min": [
        -1586.75,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1429.0,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23686562478542328,
        0.7495455145835876,
        0.6181230545043945
      ],
      "plane_d": 2529.4638671875,
      "bbox_min": [
        -1567.59375,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1517.5982666015625,
        -3952.453125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1550.521484375,
        -4003.052978515625,
        1301.125
      ],
      "bbox_max": [
        -1517.5982666015625,
        -3959.513427734375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1529.572021484375,
        -4003.052978515625,
        1331.04443359375
      ],
      "bbox_max": [
        -1517.5982666015625,
        -3992.504150390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1529.572021484375,
        -4003.052978515625,
        1331.3504638671875
      ],
      "bbox_max": [
        -1517.5982666015625,
        -3992.504150390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1529.572021484375,
        -4003.052978515625,
        1334.169677734375
      ],
      "bbox_max": [
        -1517.5982666015625,
        -3995.618408203125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1529.572021484375,
        -4000.612060546875,
        1334.7818603515625
      ],
      "bbox_max": [
        -1528.23681640625,
        -3995.618408203125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1550.521484375,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1546.656982421875,
        -3959.513427734375,
        1302.9295654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1527.30517578125,
        -3993.560791015625,
        1334.758056640625
      ],
      "bbox_max": [
        -1526.329345703125,
        -3993.05126953125,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1517.9039306640625,
        -3997.33837890625,
        1335.4068603515625
      ],
      "bbox_max": [
        -1517.125,
        -3995.6181640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2882758378982544,
        0.9122296571731567,
        0.2910911738872528
      ],
      "plane_d": 2815.191650390625,
      "bbox_min": [
        -1579.23388671875,
        -3995.347412109375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1523.7069091796875,
        -3995.347412109375,
        1332.5885009765625
      ],
      "bbox_max": [
        -1516.688720703125,
        -3991.46826171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1519.7418212890625,
        -3995.347412109375,
        1332.5885009765625
      ],
      "bbox_max": [
        -1516.688720703125,
        -3991.46826171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3209020495414734,
        -0.07878925651311874,
        -0.9438295364379883
      ],
      "plane_d": 1416.32861328125,
      "bbox_min": [
        -1579.23388671875,
        -3993.357421875,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.10805919021368027,
        -0.9941444993019104
      ],
      "plane_d": 1723.5008544921875,
      "bbox_min": [
        -1579.23388671875,
        -3993.357421875,
        1301.125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5326038002967834,
        -0.21197277307510376,
        -0.8193904757499695
      ],
      "plane_d": -572.1412963867188,
      "bbox_min": [
        -1579.23388671875,
        -3993.357421875,
        1303.597900390625
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1564.9573974609375,
        -3993.357421875,
        1308.2596435546875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1557.300048828125,
        -3961.165771484375,
        1308.2596435546875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1557.300048828125,
        -3919.165771484375,
        1308.2596435546875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3867.164306640625,
        1335.739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1557.300048828125,
        -3919.165771484375,
        1308.2596435546875
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1335.56201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022235870361,
        -0.44073569774627686,
        -0.4721960127353668
      ],
      "plane_d": 56.2066650390625,
      "bbox_min": [
        -1530.201171875,
        -3919.165771484375,
        1308.2596435546875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1309.82275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 3508.048583984375,
      "bbox_min": [
        -1530.201171875,
        -3919.165771484375,
        1308.2596435546875
      ],
      "bbox_max": [
        -1524.4652099609375,
        -3913.164306640625,
        1309.7099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 1175.0911865234375,
      "bbox_min": [
        -1530.201171875,
        -3914.26171875,
        1308.27978515625
      ],
      "bbox_max": [
        -1529.385498046875,
        -3913.224853515625,
        1308.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022235870361,
        -0.44073569774627686,
        -0.4721960127353668
      ],
      "plane_d": 56.2066650390625,
      "bbox_min": [
        -1524.4652099609375,
        -3916.164794921875,
        1309.514892578125
      ],
      "bbox_max": [
        -1524.2747802734375,
        -3916.0,
        1309.82275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8814928531646729,
        -0.47219738364219666
      ],
      "plane_d": 4067.576904296875,
      "bbox_min": [
        -1529.63720703125,
        -3913.224609375,
        1308.98095703125
      ],
      "bbox_max": [
        -1529.5673828125,
        -3913.164306640625,
        1309.09375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584361672401428,
        0.4956016540527344,
        -0.1321605145931244
      ],
      "plane_d": 3421.1083984375,
      "bbox_min": [
        -1533.69775390625,
        -3913.164306640625,
        1309.09375
      ],
      "bbox_max": [
        -1522.1373291015625,
        -3909.07177734375,
        1334.8077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584294319152832,
        0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": 446.7625732421875,
      "bbox_min": [
        -1533.69775390625,
        -3913.164306640625,
        1309.09375
      ],
      "bbox_max": [
        -1522.1373291015625,
        -3909.07177734375,
        1334.8077392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584287762641907,
        0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": 3070.11376953125,
      "bbox_min": [
        -1532.053466796875,
        -3913.164306640625,
        1309.09375
      ],
      "bbox_max": [
        -1522.1373291015625,
        -3909.07177734375,
        1334.0123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 1175.0911865234375,
      "bbox_min": [
        -1532.053466796875,
        -3913.164306640625,
        1309.09375
      ],
      "bbox_max": [
        -1523.946533203125,
        -3911.07177734375,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 3508.048583984375,
      "bbox_min": [
        -1526.36279296875,
        -3913.164306640625,
        1309.09375
      ],
      "bbox_max": [
        -1523.946533203125,
        -3911.07177734375,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1323.0350341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1312.9820556640625
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1322.6966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -637.5279541015625,
      "bbox_min": [
        -1503.5675048828125,
        -3873.165771484375,
        1313.308349609375
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1322.6966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1503.5675048828125,
        -3870.1650390625,
        1313.308349609375
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1321.84228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3232.7548828125,
      "bbox_min": [
        -1500.1025390625,
        -3870.1650390625,
        1313.408447265625
      ],
      "bbox_max": [
        -1498.3699951171875,
        -3867.164306640625,
        1321.84228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1322.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      "bbox_max": [
        -1550.3699951171875,
        -3867.164306640625,
        1322.090087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1313.304931640625
      ],
      "bbox_max": [
        -1552.1025390625,
        -3867.164306640625,
        1321.6961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1313.304931640625
      ],
      "bbox_max": [
        -1555.5675048828125,
        -3867.164306640625,
        1321.6961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1314.8377685546875
      ],
      "bbox_max": [
        -1555.5675048828125,
        -3870.1650390625,
        1321.6961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584353923797607,
        -0.49560117721557617,
        -0.13216745853424072
      ],
      "plane_d": -460.4339599609375,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3912.298095703125,
        1335.4339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584361672401428,
        0.4956016540527344,
        -0.1321605145931244
      ],
      "plane_d": 3421.1083984375,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      "bbox_max": [
        -1520.0,
        -3912.298095703125,
        1335.4339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584294319152832,
        -0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": -811.518310546875,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      "bbox_max": [
        -1520.0,
        -3912.298095703125,
        1335.4339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584287762641907,
        0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": 3070.11376953125,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      "bbox_max": [
        -1520.0,
        -3912.298095703125,
        1334.5186767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022235870361,
        -0.44073569774627686,
        -0.4721960127353668
      ],
      "plane_d": 56.2066650390625,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1309.8226318359375
      ],
      "bbox_max": [
        -1522.3094482421875,
        -3914.298095703125,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 3508.048583984375,
      "bbox_min": [
        -1524.2747802734375,
        -3916.0,
        1309.82275390625
      ],
      "bbox_max": [
        -1522.3094482421875,
        -3914.298095703125,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1323.8917236328125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1331.1954345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1323.8917236328125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1330.8570556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1479.5675048828125,
        -3919.165771484375,
        1324.2303466796875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1330.8570556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1476.1025390625,
        -3919.165771484375,
        1325.4083251953125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1330.8570556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1476.1025390625,
        -3916.1650390625,
        1325.4083251953125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1330.0028076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9912278652191162,
        -0.13216371834278107
      ],
      "plane_d": -3713.00244140625,
      "bbox_min": [
        -1529.5303955078125,
        -3961.165771484375,
        1309.7098388671875
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3919.165771484375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584353923797607,
        -0.49560117721557617,
        -0.13216745853424072
      ],
      "plane_d": -460.4339599609375,
      "bbox_min": [
        -1529.5303955078125,
        -3922.92822265625,
        1309.7098388671875
      ],
      "bbox_max": [
        -1521.8277587890625,
        -3919.165771484375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9912278652191162,
        0.13216371834278107
      ],
      "plane_d": -4064.029296875,
      "bbox_min": [
        -1529.5303955078125,
        -3922.92822265625,
        1309.7098388671875
      ],
      "bbox_max": [
        -1521.8277587890625,
        -3919.165771484375,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1529.5303955078125,
        -3920.92822265625,
        1309.7098388671875
      ],
      "bbox_max": [
        -1524.1370849609375,
        -3919.165771484375,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022235870361,
        -0.44073569774627686,
        -0.4721960127353668
      ],
      "plane_d": 56.2066650390625,
      "bbox_min": [
        -1526.1722412109375,
        -3920.92822265625,
        1309.7098388671875
      ],
      "bbox_max": [
        -1524.1370849609375,
        -3919.165771484375,
        1313.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1321.27783203125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1321.27783203125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1497.5675048828125,
        -3961.165771484375,
        1321.616455078125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1497.5675048828125,
        -3961.165771484375,
        1322.1173095703125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3271.559814453125,
      "bbox_min": [
        -1494.1025390625,
        -3961.165771484375,
        1322.7945556640625
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1494.1025390625,
        -3961.165771484375,
        1323.29541015625
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3958.1650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584361672401428,
        -0.4956016540527344,
        -0.1321605145931244
      ],
      "plane_d": -3083.82470703125,
      "bbox_min": [
        -1564.9573974609375,
        -3993.357421875,
        1309.830322265625
      ],
      "bbox_max": [
        -1515.381591796875,
        -3912.012451171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9912278652191162,
        -0.13216371834278107
      ],
      "plane_d": -3713.00244140625,
      "bbox_min": [
        -1536.0,
        -3922.92822265625,
        1309.830322265625
      ],
      "bbox_max": [
        -1527.395263671875,
        -3912.012451171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584353923797607,
        0.49560117721557617,
        -0.13216745853424072
      ],
      "plane_d": 797.7357177734375,
      "bbox_min": [
        -1536.0,
        -3922.92822265625,
        1309.830322265625
      ],
      "bbox_max": [
        -1527.395263671875,
        -3912.012451171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9912278652191162,
        0.13216371834278107
      ],
      "plane_d": -4064.029296875,
      "bbox_min": [
        -1536.0,
        -3922.92822265625,
        1309.830322265625
      ],
      "bbox_max": [
        -1527.395263671875,
        -3912.012451171875,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1564.9573974609375,
        -3993.357421875,
        1329.54833984375
      ],
      "bbox_max": [
        -1515.381591796875,
        -3915.179931640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1329.54833984375
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1329.8980712890625
      ],
      "bbox_max": [
        -1546.1025390625,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1331.4508056640625
      ],
      "bbox_max": [
        -1546.1025390625,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1332.150390625
      ],
      "bbox_max": [
        -1549.5675048828125,
        -3955.164306640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3322.59423828125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1333.7030029296875
      ],
      "bbox_max": [
        -1549.5675048828125,
        -3958.1650390625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169703125953674,
        0.3224101662635803,
        0.23498328030109406
      ],
      "plane_d": 2405.489501953125,
      "bbox_min": [
        -1579.23388671875,
        -3976.08935546875,
        1303.597900390625
      ],
      "bbox_max": [
        -1527.4398193359375,
        -3867.195556640625,
        1335.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1571.300048828125,
        -3961.165771484375,
        1305.4261474609375
      ],
      "bbox_max": [
        -1527.4398193359375,
        -3867.195556640625,
        1334.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1571.300048828125,
        -3961.165771484375,
        1305.4261474609375
      ],
      "bbox_max": [
        -1527.4398193359375,
        -3867.195556640625,
        1334.052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1549.5675048828125,
        -3961.165771484375,
        1307.5218505859375
      ],
      "bbox_max": [
        -1527.4398193359375,
        -3918.31591796875,
        1332.150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1546.1025390625,
        -3961.165771484375,
        1308.056884765625
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1331.4508056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1546.1025390625,
        -3958.1650390625,
        1308.056884765625
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1329.8980712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1528.782958984375,
        -3919.165771484375,
        1308.109619140625
      ],
      "bbox_max": [
        -1527.4398193359375,
        -3918.31591796875,
        1309.3277587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1528.6038818359375,
        -3918.855712890625,
        1308.12353515625
      ],
      "bbox_max": [
        -1527.5687255859375,
        -3918.31591796875,
        1309.1312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3943.1611328125,
        1305.4261474609375
      ],
      "bbox_max": [
        -1528.292236328125,
        -3867.195556640625,
        1332.72509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6227401494979858,
        0.2059522122144699,
        0.7548365592956543
      ],
      "plane_d": 794.8843383789062,
      "bbox_min": [
        -1571.300048828125,
        -3943.1611328125,
        1305.4261474609375
      ],
      "bbox_max": [
        -1528.292236328125,
        -3867.195556640625,
        1332.72509765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1307.656005859375
      ],
      "bbox_max": [
        -1565.6702880859375,
        -3913.164306640625,
        1309.51953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1307.982177734375
      ],
      "bbox_max": [
        -1552.2110595703125,
        -3867.195556640625,
        1332.72509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1571.300048828125,
        -3916.1650390625,
        1308.3082275390625
      ],
      "bbox_max": [
        -1566.1025390625,
        -3913.164306640625,
        1331.3369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3916.1650390625,
        1309.51953125
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1331.3369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      "bbox_max": [
        -1552.2110595703125,
        -3867.195556640625,
        1315.187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1312.656005859375
      ],
      "bbox_max": [
        -1552.2110595703125,
        -3867.195556640625,
        1315.187744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1532.3446044921875,
        -3919.40673828125,
        1307.78955078125
      ],
      "bbox_max": [
        -1528.292236328125,
        -3914.261962890625,
        1310.8238525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1531.300048828125,
        -3919.40673828125,
        1307.963623046875
      ],
      "bbox_max": [
        -1528.292236328125,
        -3916.1650390625,
        1310.1876220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1529.5675048828125,
        -3919.165771484375,
        1308.1019287109375
      ],
      "bbox_max": [
        -1528.782958984375,
        -3919.165771484375,
        1309.7095947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1529.9669189453125,
        -3919.40673828125,
        1309.289306640625
      ],
      "bbox_max": [
        -1529.5303955078125,
        -3918.9404296875,
        1310.1597900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1529.5675048828125,
        -3919.165771484375,
        1307.9884033203125
      ],
      "bbox_max": [
        -1528.8326416015625,
        -3919.165771484375,
        1309.2891845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        -0.4407356381416321,
        -0.4721960425376892
      ],
      "plane_d": -2276.75,
      "bbox_min": [
        -1532.3446044921875,
        -3916.893798828125,
        1308.981201171875
      ],
      "bbox_max": [
        -1531.204833984375,
        -3916.0,
        1310.8238525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1531.300048828125,
        -3916.733154296875,
        1307.9202880859375
      ],
      "bbox_max": [
        -1529.7542724609375,
        -3913.487548828125,
        1308.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1531.300048828125,
        -3916.733154296875,
        1307.9202880859375
      ],
      "bbox_max": [
        -1530.9720458984375,
        -3916.1650390625,
        1308.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1529.825439453125,
        -3913.611083984375,
        1308.259765625
      ],
      "bbox_max": [
        -1529.5855712890625,
        -3913.195556640625,
        1308.4901123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6227402091026306,
        -0.2059522122144699,
        -0.7548366189002991
      ],
      "plane_d": -794.8843994140625,
      "bbox_min": [
        -1555.8365478515625,
        -3961.165771484375,
        1303.597900390625
      ],
      "bbox_max": [
        -1528.1337890625,
        -3917.42724609375,
        1308.5430908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1304.0947265625
      ],
      "bbox_max": [
        -1528.1337890625,
        -3917.42724609375,
        1308.5430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1304.478759765625
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1308.5430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1304.478759765625
      ],
      "bbox_max": [
        -1546.1025390625,
        -3955.164306640625,
        1308.493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1304.9273681640625
      ],
      "bbox_max": [
        -1546.1025390625,
        -3958.1650390625,
        1308.493896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3322.59423828125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1306.1163330078125
      ],
      "bbox_max": [
        -1549.5675048828125,
        -3958.1650390625,
        1307.958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1530.27685546875,
        -3919.165771484375,
        1307.6771240234375
      ],
      "bbox_max": [
        -1528.1337890625,
        -3917.42724609375,
        1308.202392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1529.677978515625,
        -3918.32958984375,
        1307.7689208984375
      ],
      "bbox_max": [
        -1528.1337890625,
        -3917.42724609375,
        1308.1490478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        -0.4407356381416321,
        -0.4721960425376892
      ],
      "plane_d": -2276.75,
      "bbox_min": [
        -1529.677978515625,
        -3918.230224609375,
        1307.7689208984375
      ],
      "bbox_max": [
        -1529.2275390625,
        -3917.42724609375,
        1307.963623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1549.5675048828125,
        -3961.165771484375,
        1303.9365234375
      ],
      "bbox_max": [
        -1548.1263427734375,
        -3955.164306640625,
        1306.1163330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1549.5675048828125,
        -3955.164306640625,
        1303.9365234375
      ],
      "bbox_max": [
        -1549.1019287109375,
        -3955.164306640625,
        1304.4788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6227402091026306,
        -0.2059522122144699,
        -0.7548366189002991
      ],
      "plane_d": -794.8843994140625,
      "bbox_min": [
        -1571.300048828125,
        -3954.30419921875,
        1301.125
      ],
      "bbox_max": [
        -1500.3968505859375,
        -3867.164306640625,
        1313.308349609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1568.099365234375,
        -3918.971923828125,
        1301.125
      ],
      "bbox_max": [
        -1500.3968505859375,
        -3867.164306640625,
        1313.308349609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 586.4935302734375,
      "bbox_min": [
        -1568.099365234375,
        -3918.971923828125,
        1301.125
      ],
      "bbox_max": [
        -1526.397216796875,
        -3867.164306640625,
        1313.308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -592.4951171875,
      "bbox_min": [
        -1568.099365234375,
        -3918.971923828125,
        1301.125
      ],
      "bbox_max": [
        -1526.397216796875,
        -3870.1650390625,
        1312.982177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3283.7890625,
      "bbox_min": [
        -1557.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1552.1025390625,
        -3870.1650390625,
        1312.982177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1555.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1552.1025390625,
        -3873.165771484375,
        1312.656005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1568.099365234375,
        -3918.971923828125,
        1306.05029296875
      ],
      "bbox_max": [
        -1526.397216796875,
        -3913.164306640625,
        1308.308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1568.099365234375,
        -3918.4169921875,
        1306.05029296875
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1308.308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1531.300048828125,
        -3918.971923828125,
        1306.891845703125
      ],
      "bbox_max": [
        -1526.397216796875,
        -3913.164306640625,
        1308.308349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        -0.4407356381416321,
        -0.4721960425376892
      ],
      "plane_d": -2276.75,
      "bbox_min": [
        -1530.597900390625,
        -3918.1259765625,
        1307.270263671875
      ],
      "bbox_max": [
        -1529.2017822265625,
        -3916.0,
        1308.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1529.2275390625,
        -3918.1259765625,
        1307.7607421875
      ],
      "bbox_max": [
        -1529.2017822265625,
        -3918.12158203125,
        1307.7689208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3872.9716796875,
        1311.8917236328125
      ],
      "bbox_max": [
        -1503.6795654296875,
        -3870.1650390625,
        1312.9820556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3954.30419921875,
        1301.125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1308.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1308.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1308.3082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1566.1025390625,
        -3919.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1307.7374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1566.1025390625,
        -3916.1650390625,
        1301.125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1306.6610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9169703125953674,
        0.3224101662635803,
        0.23498328030109406
      ],
      "plane_d": 2405.489501953125,
      "bbox_min": [
        -1568.0908203125,
        -3954.30419921875,
        1301.125
      ],
      "bbox_max": [
        -1567.03125,
        -3951.6279296875,
        1304.12744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32122647762298584,
        0.0647851750254631,
        -0.9447838068008423
      ],
      "plane_d": 1980.31005859375,
      "bbox_min": [
        -1552.5811767578125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1326.2479248046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.15221258997917175,
        -0.07178795337677002,
        -0.9857372045516968
      ],
      "plane_d": 1240.803466796875,
      "bbox_min": [
        -1552.5811767578125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3915.99951171875,
        1326.2479248046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1528.1820068359375,
        -3961.165771484375,
        1308.14892578125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3916.0,
        1323.634033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1315.50244140625
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3955.164306640625,
        1322.1173095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1499.300048828125,
        -3958.1650390625,
        1315.50244140625
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3955.164306640625,
        1321.616455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1528.1343994140625,
        -3918.646484375,
        1308.14892578125
      ],
      "bbox_max": [
        -1526.4720458984375,
        -3918.32958984375,
        1308.740478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1524.4652099609375,
        -3916.1650390625,
        1309.201904296875
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3916.000244140625,
        1309.248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1323.86669921875
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3916.000244140625,
        1326.2479248046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3916.1650390625,
        1323.86669921875
      ],
      "bbox_max": [
        -1481.204833984375,
        -3916.000244140625,
        1323.9102783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1544.458740234375,
        -3955.164306640625,
        1304.9273681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1546.1025390625,
        -3957.5986328125,
        1301.125
      ],
      "bbox_max": [
        -1544.6968994140625,
        -3955.164306640625,
        1301.620361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1531.300048828125,
        -3961.165771484375,
        1306.86669921875
      ],
      "bbox_max": [
        -1493.8809814453125,
        -3915.99951171875,
        1316.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1314.86669921875
      ],
      "bbox_max": [
        -1493.8809814453125,
        -3955.607177734375,
        1316.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1314.86669921875
      ],
      "bbox_max": [
        -1493.8809814453125,
        -3955.607177734375,
        1316.52978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1306.86669921875
      ],
      "bbox_max": [
        -1525.8804931640625,
        -3915.99951171875,
        1308.5299072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        -0.4407356381416321,
        -0.4721960425376892
      ],
      "plane_d": -2276.75,
      "bbox_min": [
        -1531.300048828125,
        -3918.463623046875,
        1306.86669921875
      ],
      "bbox_max": [
        -1526.3797607421875,
        -3915.99951171875,
        1308.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022235870361,
        -0.44073569774627686,
        -0.4721960127353668
      ],
      "plane_d": 56.2066650390625,
      "bbox_min": [
        -1526.6055908203125,
        -3918.463623046875,
        1308.30859375
      ],
      "bbox_max": [
        -1526.3797607421875,
        -3918.127197265625,
        1308.4051513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1549.1019287109375,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1536.8848876953125,
        -3953.956787109375,
        1305.9541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -641.692626953125,
      "bbox_min": [
        -1549.1019287109375,
        -3961.165771484375,
        1301.8616943359375
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1305.9541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1549.1019287109375,
        -3955.164306640625,
        1301.8616943359375
      ],
      "bbox_max": [
        -1546.1025390625,
        -3955.164306640625,
        1305.114501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1546.4708251953125,
        -3958.1650390625,
        1301.125
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1303.3134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1546.4708251953125,
        -3955.164306640625,
        1301.6204833984375
      ],
      "bbox_max": [
        -1546.1025390625,
        -3955.164306640625,
        1301.92431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1326.222900390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1326.222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1326.222900390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1326.222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1324.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3916.1650390625,
        1301.125
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1324.2303466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1531.300048828125,
        -3918.4150390625,
        1301.125
      ],
      "bbox_max": [
        -1524.7103271484375,
        -3913.164306640625,
        1309.1185302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 3508.048583984375,
      "bbox_min": [
        -1530.146484375,
        -3918.4150390625,
        1303.800048828125
      ],
      "bbox_max": [
        -1524.7103271484375,
        -3913.60546875,
        1309.1185302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8814927935600281,
        -0.47219735383987427
      ],
      "plane_d": -2836.27490234375,
      "bbox_min": [
        -1530.146484375,
        -3918.4150390625,
        1303.800048828125
      ],
      "bbox_max": [
        -1526.6055908203125,
        -3913.60546875,
        1308.30859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8814928531646729,
        -0.47219738364219666
      ],
      "plane_d": 4067.576904296875,
      "bbox_min": [
        -1530.146484375,
        -3917.97021484375,
        1303.800048828125
      ],
      "bbox_max": [
        -1526.617431640625,
        -3913.60546875,
        1308.270263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        -0.4407356381416321,
        -0.4721960425376892
      ],
      "plane_d": -2276.75,
      "bbox_min": [
        -1530.146484375,
        -3917.97021484375,
        1303.800048828125
      ],
      "bbox_max": [
        -1528.0,
        -3914.04345703125,
        1307.4781494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7634022831916809,
        0.4407356381416321,
        -0.47219598293304443
      ],
      "plane_d": 1175.0911865234375,
      "bbox_min": [
        -1530.146484375,
        -3916.0,
        1303.800048828125
      ],
      "bbox_max": [
        -1528.0,
        -3914.04345703125,
        1307.45263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3271.559814453125,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1317.222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1317.222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1494.1025390625,
        -3955.164306640625,
        1316.839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1494.1025390625,
        -3955.164306640625,
        1316.42822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1540.2315673828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3955.164306640625,
        1315.6614990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1497.5675048828125,
        -3958.1650390625,
        1315.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14528056979179382,
        -0.49755656719207764,
        -0.8551788926124573
      ],
      "plane_d": -1079.2119140625,
      "bbox_min": [
        -1540.2315673828125,
        -3958.236083984375,
        1301.125
      ],
      "bbox_max": [
        -1531.3548583984375,
        -3955.6123046875,
        1302.0830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1313.909423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1500.1025390625,
        -3867.164306640625,
        1313.408447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3238.75634765625,
      "bbox_min": [
        -1505.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1503.5675048828125,
        -3867.164306640625,
        1312.7313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 631.5263671875,
      "bbox_min": [
        -1505.300048828125,
        -3870.1650390625,
        1301.125
      ],
      "bbox_max": [
        -1503.5675048828125,
        -3867.164306640625,
        1312.2303466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3190.25927734375,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1310.888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866016685962677,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.0233154296875,
      "bbox_min": [
        -1449.300048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1310.888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3873.165771484375,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1310.389404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3867.164306640625,
      "bbox_min": [
        -1447.5675048828125,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1309.572509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.02490234375,
      "bbox_min": [
        -1444.1025390625,
        -3873.165771484375,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1308.5743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.866016685962677,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3184.2578125,
      "bbox_min": [
        -1444.1025390625,
        -3870.1650390625,
        1301.125
      ],
      "bbox_max": [
        -1442.3699951171875,
        -3867.164306640625,
        1307.7574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40385907888412476,
        0.914762556552887,
        -0.01035915594547987
      ],
      "plane_d": 2923.58349609375,
      "bbox_min": [
        -1708.5179443359375,
        -3887.300048828125,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3715.59619140625,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9205530881881714,
        -0.2767222225666046,
        -0.2756933867931366
      ],
      "plane_d": -2116.40283203125,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1544.5400390625,
        -3864.799072265625,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48407191038131714,
        0.23269326984882355,
        -0.8435213565826416
      ],
      "plane_d": 1313.933349609375,
      "bbox_min": [
        -1550.9344482421875,
        -3887.300048828125,
        1380.5592041015625
      ],
      "bbox_max": [
        -1544.5400390625,
        -3864.799072265625,
        1382.5819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8490723371505737,
        -0.4162391424179077,
        -0.32530152797698975
      ],
      "plane_d": -2479.751708984375,
      "bbox_min": [
        -1544.5814208984375,
        -3887.300048828125,
        1382.46044921875
      ],
      "bbox_max": [
        -1544.5400390625,
        -3887.25,
        1382.5819091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8721414804458618,
        -0.3573789596557617,
        0.33413997292518616
      ],
      "plane_d": -3198.236328125,
      "bbox_min": [
        -1544.5625,
        -3887.300048828125,
        1382.46044921875
      ],
      "bbox_max": [
        -1544.5400390625,
        -3887.25,
        1382.4739990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6908631324768066,
        0.3320978283882141,
        0.6421985626220703
      ],
      "plane_d": -674.5504150390625,
      "bbox_min": [
        -1550.6846923828125,
        -3865.6220703125,
        1380.5592041015625
      ],
      "bbox_max": [
        -1550.288330078125,
        -3864.799072265625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1550.6846923828125,
        -3865.6220703125,
        1380.5592041015625
      ],
      "bbox_max": [
        -1550.608154296875,
        -3864.943359375,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9298285841941833,
        -0.24718093872070312,
        0.2726173400878906
      ],
      "plane_d": -2773.91748046875,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1544.5452880859375,
        -3864.9814453125,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1552.1619873046875,
        -3887.300048828125,
        1376.1024169921875
      ],
      "bbox_max": [
        -1544.5452880859375,
        -3864.9814453125,
        1382.46875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8721414804458618,
        -0.3573789596557617,
        0.33413997292518616
      ],
      "plane_d": -3198.236328125,
      "bbox_min": [
        -1544.5721435546875,
        -3887.300048828125,
        1382.390380859375
      ],
      "bbox_max": [
        -1544.5452880859375,
        -3887.25,
        1382.46875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1552.1619873046875,
        -3866.78125,
        1376.1024169921875
      ],
      "bbox_max": [
        -1551.5911865234375,
        -3865.431396484375,
        1376.258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9023956656455994,
        -0.25720053911209106,
        -0.3457311689853668
      ],
      "plane_d": -1915.646728515625,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1544.5625,
        -3865.0810546875,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8490723371505737,
        -0.4162391424179077,
        -0.32530152797698975
      ],
      "plane_d": -2479.751708984375,
      "bbox_min": [
        -1546.7265625,
        -3887.300048828125,
        1382.46875
      ],
      "bbox_max": [
        -1544.5625,
        -3887.25,
        1388.1397705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25196951627731323,
        -0.42230406403541565,
        -0.8707300424575806
      ],
      "plane_d": -822.654052734375,
      "bbox_min": [
        -1546.7265625,
        -3887.300048828125,
        1388.1171875
      ],
      "bbox_max": [
        -1546.70947265625,
        -3887.25,
        1388.1397705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9114702343940735,
        -0.21743008494377136,
        0.3492078185081482
      ],
      "plane_d": -2735.796875,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1544.5625,
        -3865.0810546875,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8721414804458618,
        -0.3573789596557617,
        0.33413997292518616
      ],
      "plane_d": -3198.236328125,
      "bbox_min": [
        -1546.7265625,
        -3887.300048828125,
        1376.8087158203125
      ],
      "bbox_max": [
        -1544.5625,
        -3887.25,
        1382.46875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2687537372112274,
        -0.255401074886322,
        0.9287312030792236
      ],
      "plane_d": -2687.1923828125,
      "bbox_min": [
        -1546.7265625,
        -3887.300048828125,
        1376.8087158203125
      ],
      "bbox_max": [
        -1546.70947265625,
        -3887.25,
        1376.8203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27827781438827515,
        -0.04297422617673874,
        0.9595388174057007
      ],
      "plane_d": -1918.583740234375,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1546.7191162109375,
        -3865.0810546875,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26934194564819336,
        -0.2547963857650757,
        0.928726851940155
      ],
      "plane_d": -2685.74560546875,
      "bbox_min": [
        -1553.238037109375,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1546.7191162109375,
        -3865.68408203125,
        1376.8203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1552.6932373046875,
        -3866.78125,
        1376.045166015625
      ],
      "bbox_max": [
        -1551.8245849609375,
        -3865.68408203125,
        1376.258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26988935470581055,
        -0.2472175657749176,
        0.9306144118309021
      ],
      "plane_d": -1821.3358154296875,
      "bbox_min": [
        -1553.238037109375,
        -3887.300048828125,
        1374.9239501953125
      ],
      "bbox_max": [
        -1553.218017578125,
        -3887.25,
        1374.9375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0954543873667717,
        -0.05763554200530052,
        0.99376380443573
      ],
      "plane_d": -1738.6685791015625,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1546.7210693359375,
        -3865.0810546875,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1557.711669921875,
        -3868.8515625,
        1375.5501708984375
      ],
      "bbox_max": [
        -1551.8245849609375,
        -3865.919189453125,
        1376.258544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23484168946743011,
        -0.08580072969198227,
        0.9682394862174988
      ],
      "plane_d": -1298.018798828125,
      "bbox_min": [
        -1557.711669921875,
        -3868.8515625,
        1375.5501708984375
      ],
      "bbox_max": [
        -1557.28955078125,
        -3867.953857421875,
        1375.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2754978537559509,
        -0.1472751498222351,
        -0.9499531984329224
      ],
      "plane_d": 320.03118896484375,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1546.7210693359375,
        -3865.0810546875,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2525472342967987,
        -0.42178013920783997,
        -0.8708164691925049
      ],
      "plane_d": -821.3910522460938,
      "bbox_min": [
        -1553.3258056640625,
        -3887.300048828125,
        1386.3995361328125
      ],
      "bbox_max": [
        -1546.7210693359375,
        -3865.677001953125,
        1390.0240478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25476256012916565,
        0.1850539743900299,
        -0.9491318464279175
      ],
      "plane_d": 1635.9110107421875,
      "bbox_min": [
        -1553.3258056640625,
        -3866.154296875,
        1386.3995361328125
      ],
      "bbox_max": [
        -1552.0811767578125,
        -3865.677001953125,
        1386.7486572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7980432510375977,
        -0.5389218330383301,
        -0.26961150765419006
      ],
      "plane_d": -2948.3935546875,
      "bbox_min": [
        -1552.4556884765625,
        -3866.154296875,
        1386.3995361328125
      ],
      "bbox_max": [
        -1552.0811767578125,
        -3865.677001953125,
        1386.589599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2533508241176605,
        -0.4155217409133911,
        -0.873587429523468
      ],
      "plane_d": -7.441162109375,
      "bbox_min": [
        -1553.2464599609375,
        -3887.300048828125,
        1390.0
      ],
      "bbox_max": [
        -1553.218017578125,
        -3887.25,
        1390.0240478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13550253212451935,
        -0.1595839411020279,
        -0.9778404235839844
      ],
      "plane_d": 528.3904418945312,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1390.0157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476256012916565,
        0.1850539743900299,
        -0.9491318464279175
      ],
      "plane_d": 1635.9110107421875,
      "bbox_min": [
        -1558.396240234375,
        -3868.402099609375,
        1386.3642578125
      ],
      "bbox_max": [
        -1552.0811767578125,
        -3865.6708984375,
        1387.6617431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7980432510375977,
        -0.5389218330383301,
        -0.26961150765419006
      ],
      "plane_d": -2948.3935546875,
      "bbox_min": [
        -1558.396240234375,
        -3868.402099609375,
        1386.3642578125
      ],
      "bbox_max": [
        -1552.0811767578125,
        -3865.6708984375,
        1387.6617431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1558.396240234375,
        -3868.402099609375,
        1387.6256103515625
      ],
      "bbox_max": [
        -1558.28173828125,
        -3868.272705078125,
        1387.6617431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2782386839389801,
        -0.046120766550302505,
        -0.9594039916992188
      ],
      "plane_d": 1586.4541015625,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1390.0157470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2533508241176605,
        -0.4155217409133911,
        -0.873587429523468
      ],
      "plane_d": -7.441162109375,
      "bbox_min": [
        -1559.73583984375,
        -3887.300048828125,
        1387.5406494140625
      ],
      "bbox_max": [
        -1553.21875,
        -3868.305908203125,
        1390.0157470703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1558.5712890625,
        -3868.402099609375,
        1387.5406494140625
      ],
      "bbox_max": [
        -1558.28173828125,
        -3868.305908203125,
        1387.625732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8579274415969849,
        -0.3942665457725525,
        -0.3294152319431305
      ],
      "plane_d": 262.7730712890625,
      "bbox_min": [
        -1559.73583984375,
        -3887.300048828125,
        1388.1123046875
      ],
      "bbox_max": [
        -1559.7109375,
        -3887.25,
        1388.136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44569045305252075,
        -0.05709591880440712,
        -0.8933644890785217
      ],
      "plane_d": 1713.296630859375,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1562.494384765625,
        -3870.1376953125,
        1385.6348876953125
      ],
      "bbox_max": [
        -1558.28173828125,
        -3868.38427734375,
        1387.6256103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26988935470581055,
        -0.2472175657749176,
        0.9306144118309021
      ],
      "plane_d": -1821.3358154296875,
      "bbox_min": [
        -1562.3272705078125,
        -3887.300048828125,
        1374.9296875
      ],
      "bbox_max": [
        -1553.21875,
        -3869.881591796875,
        1376.826904296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1562.3272705078125,
        -3870.18994140625,
        1376.396728515625
      ],
      "bbox_max": [
        -1561.6783447265625,
        -3869.881591796875,
        1376.5472412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07172953337430954,
        0.11237809807062149,
        0.9910731911659241
      ],
      "plane_d": -1041.2471923828125,
      "bbox_min": [
        -1562.078369140625,
        -3870.18994140625,
        1376.396728515625
      ],
      "bbox_max": [
        -1561.6783447265625,
        -3869.881591796875,
        1376.43505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801052570343018,
        -0.33349302411079407,
        0.33793070912361145
      ],
      "plane_d": -388.9307861328125,
      "bbox_min": [
        -1559.732421875,
        -3887.300048828125,
        1376.8115234375
      ],
      "bbox_max": [
        -1559.7109375,
        -3887.25,
        1376.826904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291770458221436,
        0.09949781745672226,
        -0.3559917211532593
      ],
      "plane_d": 2330.1787109375,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1375.572998046875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40307989716529846,
        0.9129976034164429,
        -0.06294482201337814
      ],
      "plane_d": 2990.6015625,
      "bbox_min": [
        -1570.0196533203125,
        -3887.300048828125,
        1378.2723388671875
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.90185546875,
        1388.1171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8579360842704773,
        -0.3948463797569275,
        -0.3286975026130676
      ],
      "plane_d": 259.536376953125,
      "bbox_min": [
        -1561.89599609375,
        -3887.300048828125,
        1382.43701171875
      ],
      "bbox_max": [
        -1559.7109375,
        -3887.25,
        1388.1171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8801056742668152,
        -0.33423930406570435,
        0.33719131350517273
      ],
      "plane_d": -390.8131103515625,
      "bbox_min": [
        -1561.89599609375,
        -3887.300048828125,
        1382.43701171875
      ],
      "bbox_max": [
        -1561.875,
        -3887.25,
        1382.4739990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1570.0196533203125,
        -3873.51025390625,
        1378.2723388671875
      ],
      "bbox_max": [
        -1565.124267578125,
        -3871.40625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.939588725566864,
        0.11981204897165298,
        0.3206525146961212
      ],
      "plane_d": 1489.745361328125,
      "bbox_min": [
        -1565.179443359375,
        -3887.300048828125,
        1375.572998046875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1386.3995361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9283306002616882,
        0.10818085074424744,
        0.35566747188568115
      ],
      "plane_d": 1378.76318359375,
      "bbox_min": [
        -1565.179443359375,
        -3887.300048828125,
        1376.43505859375
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.16650390625,
        1382.7518310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8801056742668152,
        -0.33423930406570435,
        0.33719131350517273
      ],
      "plane_d": -390.8131103515625,
      "bbox_min": [
        -1565.179443359375,
        -3887.300048828125,
        1376.43505859375
      ],
      "bbox_max": [
        -1559.7109375,
        -3870.16650390625,
        1382.46875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.40307989716529846,
        0.9129976034164429,
        -0.06294482201337814
      ],
      "plane_d": 2990.6015625,
      "bbox_min": [
        -1565.179443359375,
        -3871.543701171875,
        1376.43505859375
      ],
      "bbox_max": [
        -1561.7548828125,
        -3870.16650390625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1565.179443359375,
        -3871.543701171875,
        1376.43505859375
      ],
      "bbox_max": [
        -1561.7548828125,
        -3870.16650390625,
        1378.377685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9788185358047485,
        0.07095997035503387,
        -0.19203943014144897
      ],
      "plane_d": 2070.119873046875,
      "bbox_min": [
        -1563.333984375,
        -3887.25,
        1381.199951171875
      ],
      "bbox_max": [
        -1561.875,
        -3870.55859375,
        1382.7518310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48407191038131714,
        0.23269326984882355,
        -0.8435213565826416
      ],
      "plane_d": 1313.933349609375,
      "bbox_min": [
        -1551.121826171875,
        -3865.6220703125,
        1381.199951171875
      ],
      "bbox_max": [
        -1550.6839599609375,
        -3865.0810546875,
        1381.577880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23484168946743011,
        -0.08580072969198227,
        0.9682394862174988
      ],
      "plane_d": -1298.018798828125,
      "bbox_min": [
        -1561.7548828125,
        -3870.18994140625,
        1375.572998046875
      ],
      "bbox_max": [
        -1557.64501953125,
        -3868.10986328125,
        1376.43505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07172953337430954,
        0.11237809807062149,
        0.9910731911659241
      ],
      "plane_d": -1041.2471923828125,
      "bbox_min": [
        -1561.7548828125,
        -3870.18994140625,
        1376.4056396484375
      ],
      "bbox_max": [
        -1561.5091552734375,
        -3869.806884765625,
        1376.43505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1435.0999755859375,
      "bbox_min": [
        -1708.5179443359375,
        -3873.51025390625,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3715.59619140625,
        1437.484619140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8661637902259827,
        0.4913851320743561,
        -0.09110943228006363
      ],
      "plane_d": 3440.12255859375,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661858439445496,
        0.4913976788520813,
        -0.09083105623722076
      ],
      "plane_d": 564.0211181640625,
      "bbox_min": [
        -1672.49560546875,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8662463426589966,
        -0.4914320111274719,
        -0.09006507694721222
      ],
      "plane_d": -325.61572265625,
      "bbox_min": [
        -1666.2618408203125,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1647.560791015625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958792328834534,
        -0.09068919718265533
      ],
      "plane_d": 3933.82470703125,
      "bbox_min": [
        -1666.2618408203125,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3819.198486328125,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9960699081420898,
        -0.08857003599405289
      ],
      "plane_d": -3698.760498046875,
      "bbox_min": [
        -1666.2618408203125,
        -3841.1748046875,
        1435.0999755859375
      ],
      "bbox_max": [
        -1653.7945556640625,
        -3840.962646484375,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664397597312927,
        -0.49154171347618103,
        -0.08757215738296509
      ],
      "plane_d": -311.1588134765625,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664997220039368,
        0.4915757477283478,
        -0.08678330481052399
      ],
      "plane_d": 3370.92724609375,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1620.949462890625,
        -3735.72607421875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8664623498916626,
        -0.49155452847480774,
        -0.0872773602604866
      ],
      "plane_d": -3141.50732421875,
      "bbox_min": [
        -1645.1051025390625,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3746.368896484375,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9962114691734314,
        -0.08696449548006058
      ],
      "plane_d": -3617.77197265625,
      "bbox_min": [
        -1639.066162109375,
        -3757.015625,
        1435.0999755859375
      ],
      "bbox_max": [
        -1626.988525390625,
        -3756.807373046875,
        1437.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9962114691734314,
        -0.08696449548006058
      ],
      "plane_d": -3617.77197265625,
      "bbox_min": [
        -1708.5179443359375,
        -3873.51025390625,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3715.59619140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664397597312927,
        -0.49154171347618103,
        -0.08757215738296509
      ],
      "plane_d": -311.1588134765625,
      "bbox_min": [
        -1673.0755615234375,
        -3756.807373046875,
        1335.75
      ],
      "bbox_max": [
        -1587.3287353515625,
        -3715.59619140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8664997220039368,
        0.4915757477283478,
        -0.08678330481052399
      ],
      "plane_d": 3370.92724609375,
      "bbox_min": [
        -1673.0755615234375,
        -3756.807373046875,
        1335.75
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8664623498916626,
        -0.49155452847480774,
        -0.0872773602604866
      ],
      "plane_d": -3141.50732421875,
      "bbox_min": [
        -1673.0755615234375,
        -3756.807373046875,
        1335.75
      ],
      "bbox_max": [
        -1626.990234375,
        -3722.626220703125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1650.43603515625,
        -3751.55224609375,
        1335.75
      ],
      "bbox_max": [
        -1626.990234375,
        -3722.626220703125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1650.43603515625,
        -3731.975341796875,
        1335.75
      ],
      "bbox_max": [
        -1640.349365234375,
        -3727.0849609375,
        1397.1866455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6477246880531311,
        -0.756960928440094,
        0.08638834208250046
      ],
      "plane_d": -1876.1256103515625,
      "bbox_min": [
        -1643.0291748046875,
        -3731.975341796875,
        1335.75
      ],
      "bbox_max": [
        -1640.349365234375,
        -3728.865234375,
        1342.944580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4656049609184265,
        -0.8380515575408936,
        -0.28439682722091675
      ],
      "plane_d": -1960.2840576171875,
      "bbox_min": [
        -1650.43603515625,
        -3730.100341796875,
        1394.9000244140625
      ],
      "bbox_max": [
        -1646.24560546875,
        -3727.0849609375,
        1397.1866455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1650.2764892578125,
        -3751.55224609375,
        1361.0
      ],
      "bbox_max": [
        -1626.990234375,
        -3722.626220703125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1646.24560546875,
        -3734.566650390625,
        1386.5806884765625
      ],
      "bbox_max": [
        -1628.4610595703125,
        -3722.626220703125,
        1429.3531494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4656049609184265,
        -0.8380515575408936,
        -0.28439682722091675
      ],
      "plane_d": -1960.2840576171875,
      "bbox_min": [
        -1650.2764892578125,
        -3751.55224609375,
        1361.0
      ],
      "bbox_max": [
        -1629.959716796875,
        -3727.0849609375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8790856003761292,
        -0.474399209022522,
        -0.04641010984778404
      ],
      "plane_d": -278.5462646484375,
      "bbox_min": [
        -1648.125,
        -3751.55224609375,
        1361.0
      ],
      "bbox_max": [
        -1629.959716796875,
        -3730.40087890625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1648.125,
        -3751.55224609375,
        1361.0
      ],
      "bbox_max": [
        -1629.959716796875,
        -3730.40087890625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1637.4873046875,
        -3751.386474609375,
        1361.0
      ],
      "bbox_max": [
        -1630.673828125,
        -3741.101806640625,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36749404668807983,
        -0.6063629984855652,
        -0.7051751613616943
      ],
      "plane_d": -1911.773193359375,
      "bbox_min": [
        -1637.4873046875,
        -3750.482177734375,
        1361.0
      ],
      "bbox_max": [
        -1630.673828125,
        -3741.101806640625,
        1366.2608642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132316708564758,
        0.15480175614356995,
        -0.3768877387046814
      ],
      "plane_d": 2582.4140625,
      "bbox_min": [
        -1637.4873046875,
        -3748.274658203125,
        1361.0
      ],
      "bbox_max": [
        -1630.673828125,
        -3741.101806640625,
        1364.9459228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5709734559059143,
        -0.33700570464134216,
        -0.7486096620559692
      ],
      "plane_d": -1175.90087890625,
      "bbox_min": [
        -1637.4873046875,
        -3748.274658203125,
        1363.5
      ],
      "bbox_max": [
        -1635.31201171875,
        -3746.632080078125,
        1364.9459228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9132316708564758,
        0.15480175614356995,
        -0.3768877387046814
      ],
      "plane_d": 2582.4140625,
      "bbox_min": [
        -1631.531982421875,
        -3743.590087890625,
        1361.0
      ],
      "bbox_max": [
        -1631.1722412109375,
        -3743.050048828125,
        1362.064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321675419807434,
        -0.5764033794403076,
        -0.36289089918136597
      ],
      "plane_d": -430.4671630859375,
      "bbox_min": [
        -1648.125,
        -3751.55224609375,
        1373.0
      ],
      "bbox_max": [
        -1633.2000732421875,
        -3739.365234375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1638.8819580078125,
        -3751.55224609375,
        1373.0
      ],
      "bbox_max": [
        -1633.2000732421875,
        -3745.8173828125,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847064733505249,
        -0.5281789302825928,
        0.059230607002973557
      ],
      "plane_d": -657.9163818359375,
      "bbox_min": [
        -1673.0755615234375,
        -3754.354736328125,
        1335.75
      ],
      "bbox_max": [
        -1646.0003662109375,
        -3735.599609375,
        1407.0020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7880221605300903,
        -0.5122191309928894,
        -0.3415447771549225
      ],
      "plane_d": -127.6697998046875,
      "bbox_min": [
        -1673.0755615234375,
        -3754.354736328125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1661.5712890625,
        -3735.599609375,
        1407.0020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4829953908920288,
        -0.8693528771400452,
        0.10460001975297928
      ],
      "plane_d": -2590.9296875,
      "bbox_min": [
        -1668.5169677734375,
        -3756.807373046875,
        1335.75
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3729.4130859375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1645.150390625,
        -3733.326904296875,
        1335.75
      ],
      "bbox_max": [
        -1643.0244140625,
        -3731.426025390625,
        1353.76318359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7211121916770935,
        -0.6304303407669067,
        -0.28732365369796753
      ],
      "plane_d": -760.0289306640625,
      "bbox_min": [
        -1662.5538330078125,
        -3756.741455078125,
        1422.8326416015625
      ],
      "bbox_max": [
        -1655.9932861328125,
        -3753.8232421875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1659.6474609375,
        -3756.741455078125,
        1431.855224609375
      ],
      "bbox_max": [
        -1655.9932861328125,
        -3753.8232421875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4656049609184265,
        -0.8380515575408936,
        -0.28439682722091675
      ],
      "plane_d": -1960.2840576171875,
      "bbox_min": [
        -1661.5712890625,
        -3756.807373046875,
        1364.9202880859375
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3729.4130859375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5709734559059143,
        -0.33700570464134216,
        -0.7486096620559692
      ],
      "plane_d": -1175.90087890625,
      "bbox_min": [
        -1658.2171630859375,
        -3756.807373046875,
        1364.9202880859375
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1658.2171630859375,
        -3756.807373046875,
        1364.9459228515625
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3746.22802734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451468348503113,
        -0.5320992469787598,
        -0.050962261855602264
      ],
      "plane_d": -543.6800537109375,
      "bbox_min": [
        -1635.79541015625,
        -3751.38232421875,
        1366.2606201171875
      ],
      "bbox_max": [
        -1635.5985107421875,
        -3750.48193359375,
        1372.9522705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1658.2171630859375,
        -3756.807373046875,
        1434.345458984375
      ],
      "bbox_max": [
        -1655.9932861328125,
        -3753.8232421875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5037271976470947,
        -0.8287147879600525,
        -0.24390731751918793
      ],
      "plane_d": -3564.69921875,
      "bbox_min": [
        -1640.5208740234375,
        -3742.275634765625,
        1335.75
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1628.9127197265625,
        -3734.973388671875,
        1361.890625
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1414.3336181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.296495258808136,
        -0.9519112706184387,
        0.07717172801494598
      ],
      "plane_d": -4125.87548828125,
      "bbox_min": [
        -1628.9127197265625,
        -3721.100341796875,
        1361.890625
      ],
      "bbox_max": [
        -1612.8072509765625,
        -3715.59619140625,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2220492660999298,
        -0.9227495789527893,
        -0.31500354409217834
      ],
      "plane_d": -2634.219970703125,
      "bbox_min": [
        -1640.5208740234375,
        -3742.275634765625,
        1335.75
      ],
      "bbox_max": [
        -1614.253662109375,
        -3715.59619140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20496656000614166,
        -0.929183304309845,
        -0.3075826168060303
      ],
      "plane_d": -2696.672607421875,
      "bbox_min": [
        -1628.4610595703125,
        -3736.14453125,
        1429.3531494140625
      ],
      "bbox_max": [
        -1625.4945068359375,
        -3734.566650390625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311894059181213,
        -0.7694128751754761,
        0.09799864888191223
      ],
      "plane_d": -1965.272705078125,
      "bbox_min": [
        -1640.5208740234375,
        -3742.275634765625,
        1335.75
      ],
      "bbox_max": [
        -1614.253662109375,
        -3715.59619140625,
        1386.5806884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6477246880531311,
        -0.756960928440094,
        0.08638834208250046
      ],
      "plane_d": -1876.1256103515625,
      "bbox_min": [
        -1640.5208740234375,
        -3729.833251953125,
        1335.75
      ],
      "bbox_max": [
        -1628.463134765625,
        -3715.59619140625,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1628.9984130859375,
        -3720.031005859375,
        1335.75
      ],
      "bbox_max": [
        -1628.463134765625,
        -3715.59619140625,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10582078248262405,
        -0.9877265095710754,
        0.11488477140665054
      ],
      "plane_d": -4000.156005859375,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1335.75
      ],
      "bbox_max": [
        -1614.253662109375,
        -3715.59619140625,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.296495258808136,
        -0.9519112706184387,
        0.07717172801494598
      ],
      "plane_d": -4125.87548828125,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1335.75
      ],
      "bbox_max": [
        -1614.253662109375,
        -3715.59619140625,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.0,
      "bbox_min": [
        -1636.4681396484375,
        -3742.275634765625,
        1363.5902099609375
      ],
      "bbox_max": [
        -1627.5999755859375,
        -3728.79052734375,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8790856003761292,
        -0.474399209022522,
        -0.04641010984778404
      ],
      "plane_d": -278.5462646484375,
      "bbox_min": [
        -1630.673828125,
        -3742.275634765625,
        1363.5902099609375
      ],
      "bbox_max": [
        -1627.5999755859375,
        -3737.5,
        1373.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8297655582427979,
        -0.4930509030818939,
        -0.2615146338939667
      ],
      "plane_d": -2807.57421875,
      "bbox_min": [
        -1632.0400390625,
        -3756.807373046875,
        1335.75
      ],
      "bbox_max": [
        -1587.3287353515625,
        -3720.612548828125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8190222978591919,
        -0.513898491859436,
        -0.25516799092292786
      ],
      "plane_d": -2877.44873046875,
      "bbox_min": [
        -1610.6807861328125,
        -3756.807373046875,
        1373.9412841796875
      ],
      "bbox_max": [
        -1587.4544677734375,
        -3744.819091796875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2793818712234497,
        -0.8969679474830627,
        -0.3426285684108734
      ],
      "plane_d": -3317.271484375,
      "bbox_min": [
        -1632.0400390625,
        -3751.427001953125,
        1335.75
      ],
      "bbox_max": [
        -1587.3287353515625,
        -3720.612548828125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5037271976470947,
        -0.8287147879600525,
        -0.24390731751918793
      ],
      "plane_d": -3564.69921875,
      "bbox_min": [
        -1617.841064453125,
        -3744.819091796875,
        1414.3336181640625
      ],
      "bbox_max": [
        -1610.6807861328125,
        -3734.973388671875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1632.0400390625,
        -3751.427001953125,
        1335.75
      ],
      "bbox_max": [
        -1587.3287353515625,
        -3720.612548828125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.296495258808136,
        -0.9519112706184387,
        0.07717172801494598
      ],
      "plane_d": -4125.87548828125,
      "bbox_min": [
        -1632.0400390625,
        -3748.460693359375,
        1335.75
      ],
      "bbox_max": [
        -1601.1094970703125,
        -3720.612548828125,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4191102683544159,
        -0.9077640771865845,
        0.0176377072930336
      ],
      "plane_d": -4095.93798828125,
      "bbox_min": [
        -1632.0400390625,
        -3748.460693359375,
        1335.75
      ],
      "bbox_max": [
        -1601.1094970703125,
        -3735.135498046875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.944113552570343,
        -0.32914844155311584,
        0.017635561525821686
      ],
      "plane_d": 258.2093505859375,
      "bbox_min": [
        -1612.0628662109375,
        -3742.864501953125,
        1335.75
      ],
      "bbox_max": [
        -1601.1094970703125,
        -3735.135498046875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1373.5,
      "bbox_min": [
        -1612.0628662109375,
        -3742.864501953125,
        1373.5
      ],
      "bbox_max": [
        -1601.9371337890625,
        -3735.135498046875,
        1373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.864705502986908,
        -0.4905621111392975,
        0.1078575849533081
      ],
      "plane_d": -572.09228515625,
      "bbox_min": [
        -1632.0400390625,
        -3748.460693359375,
        1335.75
      ],
      "bbox_max": [
        -1630.3421630859375,
        -3746.288818359375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8662463426589966,
        -0.4914320111274719,
        -0.09006507694721222
      ],
      "plane_d": -325.61572265625,
      "bbox_min": [
        -1708.5179443359375,
        -3873.51025390625,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3748.134765625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9960699081420898,
        -0.08857003599405289
      ],
      "plane_d": -3698.760498046875,
      "bbox_min": [
        -1708.5179443359375,
        -3854.443115234375,
        1335.75
      ],
      "bbox_max": [
        -1631.38916015625,
        -3748.134765625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661858439445496,
        0.4913976788520813,
        -0.09083105623722076
      ],
      "plane_d": 564.0211181640625,
      "bbox_min": [
        -1708.5179443359375,
        -3837.37109375,
        1335.75
      ],
      "bbox_max": [
        -1631.38916015625,
        -3748.134765625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661637902259827,
        0.4913851320743561,
        -0.09110943228006363
      ],
      "plane_d": 3440.12255859375,
      "bbox_min": [
        -1672.06396484375,
        -3837.37109375,
        1335.75
      ],
      "bbox_max": [
        -1641.3128662109375,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958792328834534,
        -0.09068919718265533
      ],
      "plane_d": 3933.82470703125,
      "bbox_min": [
        -1672.06396484375,
        -3837.37109375,
        1335.75
      ],
      "bbox_max": [
        -1650.5738525390625,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1672.06396484375,
        -3837.37109375,
        1379.0
      ],
      "bbox_max": [
        -1650.5738525390625,
        -3819.960693359375,
        1429.1142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1660.445068359375,
        -3837.37109375,
        1394.5888671875
      ],
      "bbox_max": [
        -1655.6619873046875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3837.21484375,
        1394.7890625
      ],
      "bbox_max": [
        -1655.6619873046875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1672.06396484375,
        -3837.362060546875,
        1394.568359375
      ],
      "bbox_max": [
        -1655.5018310546875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1672.06396484375,
        -3837.362060546875,
        1394.568359375
      ],
      "bbox_max": [
        -1671.2332763671875,
        -3836.5166015625,
        1395.0447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3836.400390625,
        1395.0128173828125
      ],
      "bbox_max": [
        -1655.1014404296875,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1666.414794921875,
        -3835.728515625,
        1379.0
      ],
      "bbox_max": [
        -1652.8970947265625,
        -3820.20654296875,
        1426.4166259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1659.769287109375,
        -3835.728515625,
        1395.1973876953125
      ],
      "bbox_max": [
        -1654.4971923828125,
        -3834.57275390625,
        1396.0308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1382.5,
      "bbox_min": [
        -1663.87841796875,
        -3830.064697265625,
        1379.0
      ],
      "bbox_max": [
        -1656.1591796875,
        -3824.20556640625,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8496588468551636,
        -0.4987213611602783,
        -0.17133881151676178
      ],
      "plane_d": -263.67529296875,
      "bbox_min": [
        -1663.669677734375,
        -3830.064697265625,
        1379.0
      ],
      "bbox_max": [
        -1656.1591796875,
        -3824.315673828125,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1663.669677734375,
        -3827.840087890625,
        1379.0
      ],
      "bbox_max": [
        -1656.375244140625,
        -3824.315673828125,
        1381.291259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1661.1710205078125,
        -3827.840087890625,
        1379.0
      ],
      "bbox_max": [
        -1656.375244140625,
        -3824.318603515625,
        1381.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1661.1710205078125,
        -3826.939208984375,
        1379.0
      ],
      "bbox_max": [
        -1658.8289794921875,
        -3824.39990234375,
        1380.366455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1665.2738037109375,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1654.242431640625,
        -3811.935302734375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1663.272216796875,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1656.803955078125,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1663.272216796875,
        -3824.39990234375,
        1380.366455078125
      ],
      "bbox_max": [
        -1656.803955078125,
        -3821.5498046875,
        1381.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1658.8289794921875,
        -3824.39990234375,
        1380.366455078125
      ],
      "bbox_max": [
        -1656.803955078125,
        -3821.65283203125,
        1381.8448486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1661.048095703125,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1659.0400390625,
        -3827.779052734375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1657.7388916015625,
        -3820.20654296875,
        1426.4166259765625
      ],
      "bbox_max": [
        -1654.242431640625,
        -3818.8876953125,
        1431.0322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1659.6275634765625,
        -3830.291748046875,
        1335.75
      ],
      "bbox_max": [
        -1651.9266357421875,
        -3815.164794921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1659.6275634765625,
        -3830.291748046875,
        1335.75
      ],
      "bbox_max": [
        -1651.9266357421875,
        -3815.164794921875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1382.5,
      "bbox_min": [
        -1659.6275634765625,
        -3830.291748046875,
        1335.75
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3592352867126465,
        0.382885217666626,
        -0.8510868549346924
      ],
      "plane_d": 3235.028076171875,
      "bbox_min": [
        -1659.6275634765625,
        -3830.291748046875,
        1335.75
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8496588468551636,
        -0.4987213611602783,
        -0.17133881151676178
      ],
      "plane_d": -263.67529296875,
      "bbox_min": [
        -1658.8763427734375,
        -3825.224853515625,
        1381.0843505859375
      ],
      "bbox_max": [
        -1655.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1658.8763427734375,
        -3821.65283203125,
        1381.8448486328125
      ],
      "bbox_max": [
        -1658.0,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1659.6275634765625,
        -3830.291748046875,
        1335.75
      ],
      "bbox_max": [
        -1657.80517578125,
        -3827.779052734375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1659.6275634765625,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1658.8380126953125,
        -3827.779052734375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977416396141052,
        -0.018138699233531952,
        0.06467321515083313
      ],
      "plane_d": 1504.76416015625,
      "bbox_min": [
        -1708.5179443359375,
        -3837.358642578125,
        1335.75
      ],
      "bbox_max": [
        -1631.38916015625,
        -3748.134765625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.996465802192688,
        -0.08062192797660828,
        0.023578589782118797
      ],
      "plane_d": 1322.2332763671875,
      "bbox_min": [
        -1708.5179443359375,
        -3837.358642578125,
        1335.75
      ],
      "bbox_max": [
        -1663.214599609375,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37160712480545044,
        -0.925055980682373,
        0.07860997319221497
      ],
      "plane_d": -3009.404296875,
      "bbox_min": [
        -1708.5179443359375,
        -3837.358642578125,
        1335.75
      ],
      "bbox_max": [
        -1666.506103515625,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44221529364585876,
        -0.8961166739463806,
        0.03769296780228615
      ],
      "plane_d": -2724.46826171875,
      "bbox_min": [
        -1708.5179443359375,
        -3820.774169921875,
        1335.75
      ],
      "bbox_max": [
        -1666.506103515625,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5174413919448853,
        0.042831193655729294,
        0.8546460866928101
      ],
      "plane_d": -163.09271240234375,
      "bbox_min": [
        -1708.5179443359375,
        -3810.99609375,
        1394.9000244140625
      ],
      "bbox_max": [
        -1667.7584228515625,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.543486475944519,
        -0.794340193271637,
        -0.2713780403137207
      ],
      "plane_d": -1710.2587890625,
      "bbox_min": [
        -1708.5179443359375,
        -3800.73583984375,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3760.60009765625,
        1408.791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5521392226219177,
        -0.7932242155075073,
        -0.25678348541259766
      ],
      "plane_d": -1711.816162109375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1397.7073974609375
      ],
      "bbox_max": [
        -1680.453857421875,
        -3760.60009765625,
        1408.791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8742781281471252,
        0.4108649492263794,
        0.258510947227478
      ],
      "plane_d": 2673.95068359375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3760.60009765625,
        1408.791015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5898225903511047,
        -0.7913569808006287,
        -0.16082163155078888
      ],
      "plane_d": -1775.6019287109375,
      "bbox_min": [
        -1705.0323486328125,
        -3800.73583984375,
        1402.945068359375
      ],
      "bbox_max": [
        -1692.160888671875,
        -3790.072998046875,
        1408.7164306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9808455109596252,
        0.11954662203788757,
        0.153787299990654
      ],
      "plane_d": 1902.333251953125,
      "bbox_min": [
        -1702.01416015625,
        -3790.89306640625,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3760.60009765625,
        1408.791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9291348457336426,
        0.06194232776761055,
        0.36451566219329834
      ],
      "plane_d": 1300.832275390625,
      "bbox_min": [
        -1702.01416015625,
        -3790.89306640625,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3760.60009765625,
        1408.791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8549758195877075,
        0.5185649394989014,
        -0.010333336889743805
      ],
      "plane_d": 3426.65283203125,
      "bbox_min": [
        -1700.01416015625,
        -3790.89306640625,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3770.754150390625,
        1408.791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5898225903511047,
        -0.7913569808006287,
        -0.16082163155078888
      ],
      "plane_d": -1775.6019287109375,
      "bbox_min": [
        -1692.5484619140625,
        -3790.89306640625,
        1402.945068359375
      ],
      "bbox_max": [
        -1691.9532470703125,
        -3790.072998046875,
        1405.559326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22611574828624725,
        -0.2783043384552002,
        0.9334978461265564
      ],
      "plane_d": -1978.2275390625,
      "bbox_min": [
        -1699.6336669921875,
        -3788.66943359375,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3770.754150390625,
        1405.224365234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35810279846191406,
        -0.03704282268881798,
        0.9329470992088318
      ],
      "plane_d": -842.2459106445312,
      "bbox_min": [
        -1685.2486572265625,
        -3783.66552734375,
        1397.722412109375
      ],
      "bbox_max": [
        -1680.485107421875,
        -3771.52392578125,
        1400.2330322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1685.2486572265625,
        -3783.362548828125,
        1399.427490234375
      ],
      "bbox_max": [
        -1684.0240478515625,
        -3771.52392578125,
        1400.2330322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17676745355129242,
        -0.21756620705127716,
        0.9599053263664246
      ],
      "plane_d": -1868.552490234375,
      "bbox_min": [
        -1691.7803955078125,
        -3788.66943359375,
        1399.2032470703125
      ],
      "bbox_max": [
        -1684.63916015625,
        -3780.165283203125,
        1400.5316162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35810279846191406,
        -0.03704282268881798,
        0.9329470992088318
      ],
      "plane_d": -842.2459106445312,
      "bbox_min": [
        -1685.2486572265625,
        -3783.78955078125,
        1399.2032470703125
      ],
      "bbox_max": [
        -1684.6956787109375,
        -3783.362548828125,
        1399.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1685.2486572265625,
        -3783.367919921875,
        1399.427490234375
      ],
      "bbox_max": [
        -1684.63916015625,
        -3780.165283203125,
        1400.5316162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17676745355129242,
        -0.21756620705127716,
        0.9599053263664246
      ],
      "plane_d": -1868.552490234375,
      "bbox_min": [
        -1691.7803955078125,
        -3788.66943359375,
        1397.7073974609375
      ],
      "bbox_max": [
        -1680.453857421875,
        -3780.255126953125,
        1399.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35810279846191406,
        -0.03704282268881798,
        0.9329470992088318
      ],
      "plane_d": -842.2459106445312,
      "bbox_min": [
        -1684.848876953125,
        -3783.834228515625,
        1397.7073974609375
      ],
      "bbox_max": [
        -1680.453857421875,
        -3780.255126953125,
        1399.257080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11556665599346161,
        -0.3644982576370239,
        0.9240050911903381
      ],
      "plane_d": -2478.528076171875,
      "bbox_min": [
        -1708.5179443359375,
        -3800.73583984375,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3780.332275390625,
        1408.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17676745355129242,
        -0.21756620705127716,
        0.9599053263664246
      ],
      "plane_d": -1868.552490234375,
      "bbox_min": [
        -1708.5179443359375,
        -3799.530517578125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1674.6270751953125,
        -3780.332275390625,
        1399.427490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6062149405479431,
        -0.7577535510063171,
        -0.24148109555244446
      ],
      "plane_d": -1506.3494873046875,
      "bbox_min": [
        -1708.5179443359375,
        -3799.530517578125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1702.3944091796875,
        -3794.384765625,
        1397.9945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6062149405479431,
        -0.7577535510063171,
        -0.24148109555244446
      ],
      "plane_d": -1506.3494873046875,
      "bbox_min": [
        -1707.9254150390625,
        -3800.73583984375,
        1397.1622314453125
      ],
      "bbox_max": [
        -1703.0078125,
        -3795.861572265625,
        1408.20703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1698.8807373046875,
        -3810.99609375,
        1394.9000244140625
      ],
      "bbox_max": [
        -1667.7584228515625,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8549758195877075,
        0.5185649394989014,
        -0.010333336889743805
      ],
      "plane_d": 3426.65283203125,
      "bbox_min": [
        -1698.8807373046875,
        -3810.99609375,
        1403.9876708984375
      ],
      "bbox_max": [
        -1679.1861572265625,
        -3770.299072265625,
        1428.4156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1697.409912109375,
        -3810.99609375,
        1405.1727294921875
      ],
      "bbox_max": [
        -1681.4110107421875,
        -3790.370849609375,
        1428.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1697.409912109375,
        -3807.337890625,
        1405.1727294921875
      ],
      "bbox_max": [
        -1681.4110107421875,
        -3790.370849609375,
        1428.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5898225903511047,
        -0.7913569808006287,
        -0.16082163155078888
      ],
      "plane_d": -1775.6019287109375,
      "bbox_min": [
        -1697.409912109375,
        -3795.158203125,
        1405.1727294921875
      ],
      "bbox_max": [
        -1691.586669921875,
        -3790.370849609375,
        1409.1055908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1693.662109375,
        -3807.293701171875,
        1403.9876708984375
      ],
      "bbox_max": [
        -1679.1861572265625,
        -3770.299072265625,
        1428.4156494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22611576318740845,
        -0.2783043384552002,
        0.9334979057312012
      ],
      "plane_d": -1978.227783203125,
      "bbox_min": [
        -1693.662109375,
        -3771.359130859375,
        1404.886474609375
      ],
      "bbox_max": [
        -1692.6441650390625,
        -3770.299072265625,
        1405.224365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7211121916770935,
        -0.6304303407669067,
        -0.28732365369796753
      ],
      "plane_d": -760.0289306640625,
      "bbox_min": [
        -1684.8671875,
        -3806.37939453125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1667.7584228515625,
        -3753.29833984375,
        1434.0556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7880221605300903,
        -0.5122191309928894,
        -0.3415447771549225
      ],
      "plane_d": -127.6697998046875,
      "bbox_min": [
        -1677.4923095703125,
        -3760.09326171875,
        1394.9000244140625
      ],
      "bbox_max": [
        -1667.7584228515625,
        -3753.29833984375,
        1412.57421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1680.2659912109375,
        -3806.37939453125,
        1423.3345947265625
      ],
      "bbox_max": [
        -1669.5841064453125,
        -3792.74560546875,
        1429.4134521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6806304454803467,
        -0.1954345554113388,
        -0.7060790657997131
      ],
      "plane_d": 1401.94384765625,
      "bbox_min": [
        -1672.25927734375,
        -3798.766357421875,
        1423.3345947265625
      ],
      "bbox_max": [
        -1669.5841064453125,
        -3792.74560546875,
        1427.4149169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1684.8671875,
        -3783.384033203125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1668.8682861328125,
        -3760.09326171875,
        1433.8359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8100697994232178,
        -0.5467621684074402,
        -0.21174998581409454
      ],
      "plane_d": -401.6207275390625,
      "bbox_min": [
        -1684.8671875,
        -3783.384033203125,
        1394.9000244140625
      ],
      "bbox_max": [
        -1677.4923095703125,
        -3760.09326171875,
        1412.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749769568443298,
        -0.0545491948723793,
        -0.21550977230072021
      ],
      "plane_d": 1737.7413330078125,
      "bbox_min": [
        -1684.8671875,
        -3783.384033203125,
        1399.427490234375
      ],
      "bbox_max": [
        -1681.119384765625,
        -3771.52392578125,
        1412.788818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405639171600342,
        -0.09729369729757309,
        -0.3253823220729828
      ],
      "plane_d": 1672.335693359375,
      "bbox_min": [
        -1684.8671875,
        -3783.384033203125,
        1399.427490234375
      ],
      "bbox_max": [
        -1683.6907958984375,
        -3771.52392578125,
        1403.9371337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9902018308639526,
        -0.13916033506393433,
        0.011614802293479443
      ],
      "plane_d": 1106.7347412109375,
      "bbox_min": [
        -1703.2109375,
        -3837.358642578125,
        1335.75
      ],
      "bbox_max": [
        -1669.489501953125,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42730265855789185,
        0.7768415808677673,
        -0.4625251591205597
      ],
      "plane_d": 4345.2626953125,
      "bbox_min": [
        -1703.2109375,
        -3837.353515625,
        1383.227783203125
      ],
      "bbox_max": [
        -1670.9088134765625,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527439951896667,
        0.69832843542099,
        -0.293705016374588
      ],
      "plane_d": 4188.28125,
      "bbox_min": [
        -1703.2109375,
        -3837.353515625,
        1383.227783203125
      ],
      "bbox_max": [
        -1670.9088134765625,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6851163506507874,
        0.7231000661849976,
        -0.08798906207084656
      ],
      "plane_d": 4051.06494140625,
      "bbox_min": [
        -1703.2109375,
        -3837.2021484375,
        1394.0797119140625
      ],
      "bbox_max": [
        -1683.9769287109375,
        -3818.878662109375,
        1406.4208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5693304538726807,
        0.7272651195526123,
        -0.3833383619785309
      ],
      "plane_d": 2366.328369140625,
      "bbox_min": [
        -1689.34228515625,
        -3837.353515625,
        1393.7108154296875
      ],
      "bbox_max": [
        -1670.9088134765625,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3401351273059845,
        0.8780872821807861,
        -0.3365573287010193
      ],
      "plane_d": 3262.26123046875,
      "bbox_min": [
        -1683.9769287109375,
        -3837.353515625,
        1393.8631591796875
      ],
      "bbox_max": [
        -1670.9088134765625,
        -3812.534912109375,
        1428.345458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1683.9769287109375,
        -3837.353515625,
        1393.8631591796875
      ],
      "bbox_max": [
        -1672.458984375,
        -3827.89208984375,
        1399.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5122923851013184,
        0.8093295097351074,
        -0.2873016893863678
      ],
      "plane_d": 4368.77099609375,
      "bbox_min": [
        -1683.9769287109375,
        -3837.310546875,
        1393.8631591796875
      ],
      "bbox_max": [
        -1683.834716796875,
        -3837.2021484375,
        1394.0797119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1675.744873046875,
        -3830.831787109375,
        1397.989013671875
      ],
      "bbox_max": [
        -1671.9005126953125,
        -3826.251220703125,
        1405.259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1675.744873046875,
        -3830.831787109375,
        1397.989013671875
      ],
      "bbox_max": [
        -1672.2596435546875,
        -3827.89208984375,
        1399.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1682.716064453125,
        -3823.24462890625,
        1418.6871337890625
      ],
      "bbox_max": [
        -1672.7684326171875,
        -3812.534912109375,
        1428.345458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1689.34228515625,
        -3837.2958984375,
        1393.7108154296875
      ],
      "bbox_max": [
        -1675.5382080078125,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1684.05712890625,
        -3837.2958984375,
        1393.7108154296875
      ],
      "bbox_max": [
        -1679.6114501953125,
        -3806.83154296875,
        1428.96630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5122923851013184,
        0.8093295097351074,
        -0.2873016893863678
      ],
      "plane_d": 4368.77099609375,
      "bbox_min": [
        -1684.05712890625,
        -3837.2958984375,
        1393.7108154296875
      ],
      "bbox_max": [
        -1683.9503173828125,
        -3837.2021484375,
        1394.0797119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1673.3348388671875,
        -3837.358642578125,
        1394.510009765625
      ],
      "bbox_max": [
        -1669.489501953125,
        -3817.908203125,
        1420.6773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1673.3348388671875,
        -3837.358642578125,
        1394.510009765625
      ],
      "bbox_max": [
        -1669.9124755859375,
        -3829.349609375,
        1398.7559814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1673.3348388671875,
        -3837.358642578125,
        1394.510009765625
      ],
      "bbox_max": [
        -1671.6361083984375,
        -3833.918212890625,
        1396.3919677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1671.9005126953125,
        -3826.251220703125,
        1405.259765625
      ],
      "bbox_max": [
        -1669.489501953125,
        -3817.908203125,
        1420.6773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1679.6114501953125,
        -3819.530517578125,
        1417.298095703125
      ],
      "bbox_max": [
        -1669.4849853515625,
        -3807.658203125,
        1432.8856201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3401351273059845,
        0.8780872821807861,
        -0.3365573287010193
      ],
      "plane_d": 3262.26123046875,
      "bbox_min": [
        -1672.7684326171875,
        -3819.530517578125,
        1417.298095703125
      ],
      "bbox_max": [
        -1669.4849853515625,
        -3813.95556640625,
        1430.29150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1670.2042236328125,
        -3819.530517578125,
        1417.298095703125
      ],
      "bbox_max": [
        -1669.4849853515625,
        -3817.7041015625,
        1419.8992919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1670.136474609375,
        -3833.59375,
        1396.5552978515625
      ],
      "bbox_max": [
        -1668.5098876953125,
        -3819.430419921875,
        1417.4501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1670.136474609375,
        -3833.59375,
        1396.5552978515625
      ],
      "bbox_max": [
        -1668.718505859375,
        -3830.3310546875,
        1398.243896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1669.7501220703125,
        -3825.33349609375,
        1408.472412109375
      ],
      "bbox_max": [
        -1669.07080078125,
        -3819.430419921875,
        1417.4501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.949376106262207,
        -0.19030731916427612,
        0.24993644654750824
      ],
      "plane_d": 517.9078369140625,
      "bbox_min": [
        -1668.7396240234375,
        -3762.63525390625,
        1369.64306640625
      ],
      "bbox_max": [
        -1658.02783203125,
        -3751.093505859375,
        1421.944580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7211121916770935,
        -0.6304303407669067,
        -0.28732365369796753
      ],
      "plane_d": -760.0289306640625,
      "bbox_min": [
        -1668.7396240234375,
        -3762.407470703125,
        1409.0157470703125
      ],
      "bbox_max": [
        -1664.1239013671875,
        -3754.530517578125,
        1421.944580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7880221605300903,
        -0.5122191309928894,
        -0.3415447771549225
      ],
      "plane_d": -127.6697998046875,
      "bbox_min": [
        -1668.0400390625,
        -3757.336669921875,
        1409.0157470703125
      ],
      "bbox_max": [
        -1664.1239013671875,
        -3754.530517578125,
        1418.71728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9912394285202026,
        -0.13088169693946838,
        0.017735162749886513
      ],
      "plane_d": 1117.77490234375,
      "bbox_min": [
        -1670.2999267578125,
        -3830.20361328125,
        1335.75
      ],
      "bbox_max": [
        -1631.38916015625,
        -3748.134765625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9006834626197815,
        -0.4341058135032654,
        0.017928484827280045
      ],
      "plane_d": -182.85888671875,
      "bbox_min": [
        -1670.2999267578125,
        -3830.20361328125,
        1335.75
      ],
      "bbox_max": [
        -1647.5968017578125,
        -3751.535888671875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6632358431816101,
        0.7461646795272827,
        0.05793612077832222
      ],
      "plane_d": 3837.1572265625,
      "bbox_min": [
        -1670.2999267578125,
        -3825.88818359375,
        1335.75
      ],
      "bbox_max": [
        -1647.5968017578125,
        -3751.535888671875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43397170305252075,
        0.7468518614768982,
        -0.5038660168647766
      ],
      "plane_d": 4291.2626953125,
      "bbox_min": [
        -1670.2999267578125,
        -3825.88818359375,
        1375.93994140625
      ],
      "bbox_max": [
        -1651.5545654296875,
        -3769.662353515625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3401351273059845,
        0.8780872821807861,
        -0.3365573287010193
      ],
      "plane_d": 3262.26123046875,
      "bbox_min": [
        -1670.2999267578125,
        -3817.7041015625,
        1419.8992919921875
      ],
      "bbox_max": [
        -1665.0389404296875,
        -3808.731201171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40995875000953674,
        0.4438454210758209,
        -0.7968281507492065
      ],
      "plane_d": 3517.2236328125,
      "bbox_min": [
        -1670.2999267578125,
        -3813.95556640625,
        1430.29150390625
      ],
      "bbox_max": [
        -1665.0389404296875,
        -3808.731201171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1670.2999267578125,
        -3810.1064453125,
        1432.62841796875
      ],
      "bbox_max": [
        -1665.0389404296875,
        -3808.731201171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7467292547225952,
        0.2761877775192261,
        -0.6050750017166138
      ],
      "plane_d": 3157.458984375,
      "bbox_min": [
        -1670.2742919921875,
        -3825.88818359375,
        1375.93994140625
      ],
      "bbox_max": [
        -1651.5545654296875,
        -3769.662353515625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6806304454803467,
        -0.1954345554113388,
        -0.7060790657997131
      ],
      "plane_d": 1401.94384765625,
      "bbox_min": [
        -1670.2742919921875,
        -3810.1064453125,
        1426.1861572265625
      ],
      "bbox_max": [
        -1661.2216796875,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2789035141468048,
        -0.45655572414398193,
        -0.8448488116264343
      ],
      "plane_d": -62.698150634765625,
      "bbox_min": [
        -1670.2742919921875,
        -3810.1064453125,
        1427.4149169921875
      ],
      "bbox_max": [
        -1665.0389404296875,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6988072991371155,
        0.3117196261882782,
        -0.6438160538673401
      ],
      "plane_d": 3267.225830078125,
      "bbox_min": [
        -1669.7750244140625,
        -3779.218994140625,
        1432.62109375
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1669.7750244140625,
        -3776.171875,
        1434.0223388671875
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.6083984375,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1375.93994140625,
      "bbox_min": [
        -1669.770751953125,
        -3825.88818359375,
        1375.93994140625
      ],
      "bbox_max": [
        -1651.5545654296875,
        -3769.662353515625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1669.770751953125,
        -3825.88818359375,
        1407.8333740234375
      ],
      "bbox_max": [
        -1667.0150146484375,
        -3769.662353515625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26822924613952637,
        0.8638705611228943,
        -0.42635753750801086
      ],
      "plane_d": 4352.9814453125,
      "bbox_min": [
        -1669.770751953125,
        -3825.88818359375,
        1407.8333740234375
      ],
      "bbox_max": [
        -1668.5052490234375,
        -3775.42626953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8553448915481567,
        -0.1754799485206604,
        -0.4874339997768402
      ],
      "plane_d": 1464.598388671875,
      "bbox_min": [
        -1669.770751953125,
        -3776.058837890625,
        1433.8359375
      ],
      "bbox_max": [
        -1669.064208984375,
        -3775.42626953125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7553277611732483,
        -0.45319077372550964,
        -0.47339022159576416
      ],
      "plane_d": 228.98193359375,
      "bbox_min": [
        -1669.3280029296875,
        -3772.193115234375,
        1374.711181640625
      ],
      "bbox_max": [
        -1647.5968017578125,
        -3751.535888671875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1647.8345947265625,
        -3751.873779296875,
        1374.9000244140625
      ],
      "bbox_max": [
        -1647.602294921875,
        -3751.55224609375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1382.5,
      "bbox_min": [
        -1665.0,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1660.46142578125,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3592281639575958,
        0.3828776180744171,
        -0.8510933518409729
      ],
      "plane_d": 2042.3585205078125,
      "bbox_min": [
        -1665.0,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1660.46142578125,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.47387903928756714,
        -0.8805899620056152
      ],
      "plane_d": 3027.83984375,
      "bbox_min": [
        -1662.0,
        -3821.5498046875,
        1381.9002685546875
      ],
      "bbox_max": [
        -1661.1976318359375,
        -3820.435302734375,
        1382.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9957917928695679,
        0.09164515882730484
      ],
      "plane_d": 3689.255859375,
      "bbox_min": [
        -1661.2489013671875,
        -3828.122802734375,
        1335.75
      ],
      "bbox_max": [
        -1660.46142578125,
        -3827.779052734375,
        1339.484619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36749404668807983,
        -0.6063629984855652,
        -0.7051751613616943
      ],
      "plane_d": -1911.773193359375,
      "bbox_min": [
        -1647.644775390625,
        -3757.98291015625,
        1335.75
      ],
      "bbox_max": [
        -1631.38916015625,
        -3748.134765625,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1374.9000244140625,
      "bbox_min": [
        -1647.644775390625,
        -3757.98291015625,
        1366.66552734375
      ],
      "bbox_max": [
        -1635.7513427734375,
        -3750.83349609375,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5709734559059143,
        -0.33700570464134216,
        -0.7486096620559692
      ],
      "plane_d": -1175.90087890625,
      "bbox_min": [
        -1647.644775390625,
        -3753.98291015625,
        1369.900634765625
      ],
      "bbox_max": [
        -1641.5374755859375,
        -3751.115966796875,
        1374.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124725103378296,
        0.8080757856369019,
        -0.2904915511608124
      ],
      "plane_d": 4368.66455078125,
      "bbox_min": [
        -1686.881591796875,
        -3854.443115234375,
        1374.34912109375
      ],
      "bbox_max": [
        -1665.1240234375,
        -3840.106689453125,
        1386.5465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1689.8741455078125,
        -3851.680419921875,
        1366.6529541015625
      ],
      "bbox_max": [
        -1656.084228515625,
        -3834.87646484375,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1689.8741455078125,
        -3851.15869140625,
        1366.6529541015625
      ],
      "bbox_max": [
        -1656.084228515625,
        -3834.87646484375,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1663.232666015625,
        -3848.85986328125,
        1388.640625
      ],
      "bbox_max": [
        -1656.084228515625,
        -3837.360595703125,
        1394.7066650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067728877067566,
        0.5889610052108765,
        0.047356072813272476
      ],
      "plane_d": 3557.21826171875,
      "bbox_min": [
        -1689.8741455078125,
        -3840.106689453125,
        1366.6529541015625
      ],
      "bbox_max": [
        -1684.05712890625,
        -3834.87646484375,
        1393.7108154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6527439951896667,
        0.69832843542099,
        -0.293705016374588
      ],
      "plane_d": 4188.28125,
      "bbox_min": [
        -1689.7711181640625,
        -3840.106689453125,
        1380.71826171875
      ],
      "bbox_max": [
        -1684.05712890625,
        -3836.350341796875,
        1393.7108154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8190222978591919,
        -0.513898491859436,
        -0.25516799092292786
      ],
      "plane_d": -2877.44873046875,
      "bbox_min": [
        -1667.885986328125,
        -3873.51025390625,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3751.3125,
        1435.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4371967911720276,
        -0.8732787370681763,
        -0.2150418758392334
      ],
      "plane_d": -3674.721435546875,
      "bbox_min": [
        -1601.3858642578125,
        -3773.55615234375,
        1373.4637451171875
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3751.5205078125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1601.3858642578125,
        -3773.55615234375,
        1373.4637451171875
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3751.5205078125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1587.2730712890625,
        -3771.714111328125,
        1373.4637451171875
      ],
      "bbox_max": [
        -1570.4444580078125,
        -3751.5205078125,
        1401.457275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1375.0999755859375,
      "bbox_min": [
        -1667.885986328125,
        -3873.51025390625,
        1335.75
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3751.3125,
        1435.0999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.06719516217708588,
        0.9632619619369507,
        0.2600216567516327
      ],
      "plane_d": 3245.7314453125,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3751.3125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3388913869857788,
        0.9406852722167969,
        0.016243943944573402
      ],
      "plane_d": 3041.044921875,
      "bbox_min": [
        -1665.245361328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1632.4429931640625,
        -3843.967529296875,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7948121428489685,
        0.5870009660720825,
        0.15395909547805786
      ],
      "plane_d": 755.9136962890625,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3751.3125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6985849142074585,
        0.7094742059707642,
        0.09287343174219131
      ],
      "plane_d": 1462.6622314453125,
      "bbox_min": [
        -1626.7802734375,
        -3840.792724609375,
        1335.75
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3780.625244140625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7434534430503845,
        0.6623353362083435,
        0.09267634153366089
      ],
      "plane_d": 1210.6651611328125,
      "bbox_min": [
        -1626.7802734375,
        -3840.792724609375,
        1335.75
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3803.326416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4040.78076171875,
      "bbox_min": [
        -1573.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3803.326416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -963.1756591796875,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3803.326416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3548.5302734375,
      "bbox_min": [
        -1573.7880859375,
        -3807.86572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1570.1778564453125,
        -3803.326416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -969.6336669921875,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3814.826416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3553.34326171875,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3814.826416015625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4051.794921875,
      "bbox_min": [
        -1570.134033203125,
        -3819.36572265625,
        1369.247802734375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3817.6083984375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7320245504379272,
        0.6685720682144165,
        0.13096371293067932
      ],
      "plane_d": 1201.8897705078125,
      "bbox_min": [
        -1606.439697265625,
        -3818.253662109375,
        1335.75
      ],
      "bbox_max": [
        -1580.92333984375,
        -3780.625244140625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9611096382141113,
        0.25461429357528687,
        0.10695737600326538
      ],
      "plane_d": -701.0729370117188,
      "bbox_min": [
        -1586.5400390625,
        -3800.569091796875,
        1335.75
      ],
      "bbox_max": [
        -1580.92333984375,
        -3780.625244140625,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783594012260437,
        0.19699105620384216,
        0.0633055791258812
      ],
      "plane_d": -887.359130859375,
      "bbox_min": [
        -1583.2481689453125,
        -3800.569091796875,
        1351.6605224609375
      ],
      "bbox_max": [
        -1580.92333984375,
        -3783.39404296875,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9100038409233093,
        -0.41456741094589233,
        0.005178479943424463
      ],
      "plane_d": -3006.795166015625,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1577.630126953125,
        -3751.3125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1587.2730712890625,
        -3772.6669921875,
        1373.4637451171875
      ],
      "bbox_max": [
        -1577.630126953125,
        -3751.5205078125,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9821799397468567,
        0.18706625699996948,
        0.018136272206902504
      ],
      "plane_d": -900.9671630859375,
      "bbox_min": [
        -1612.697265625,
        -3785.392578125,
        1335.75
      ],
      "bbox_max": [
        -1579.98876953125,
        -3751.3125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9611096382141113,
        0.25461429357528687,
        0.10695737600326538
      ],
      "plane_d": -701.0729370117188,
      "bbox_min": [
        -1612.07568359375,
        -3785.392578125,
        1335.75
      ],
      "bbox_max": [
        -1579.98876953125,
        -3751.3125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8579734563827515,
        -0.5098121762275696,
        0.06303274631500244
      ],
      "plane_d": -3360.98193359375,
      "bbox_min": [
        -1587.4927978515625,
        -3751.5205078125,
        1372.1544189453125
      ],
      "bbox_max": [
        -1587.2730712890625,
        -3751.3125,
        1373.4637451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1629.17919921875,
        -3829.599609375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660876154899597,
        0.49134039878845215,
        0.09206963330507278
      ],
      "plane_d": 3194.45947265625,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1335.75
      ],
      "bbox_max": [
        -1657.414794921875,
        -3829.599609375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124725103378296,
        0.8080757856369019,
        -0.2904915511608124
      ],
      "plane_d": 4368.66455078125,
      "bbox_min": [
        -1667.885986328125,
        -3856.43603515625,
        1373.4637451171875
      ],
      "bbox_max": [
        -1665.10302734375,
        -3854.281005859375,
        1375.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.68327796459198,
        0.48658624291419983,
        -0.544394314289093
      ],
      "plane_d": 1517.5426025390625,
      "bbox_min": [
        -1636.3670654296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3772.21826171875,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1392.0999755859375,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3772.21826171875,
        1435.0999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3803.38818359375,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1566.14013671875,
        -3807.86572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1563.3250732421875,
        -3803.38818359375,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2762.74365234375,
      "bbox_min": [
        -1572.7880859375,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3814.88818359375,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1570.134033203125,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1562.3250732421875,
        -3814.88818359375,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1570.134033203125,
        -3819.36572265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1564.978759765625,
        -3819.073486328125,
        1393.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47025132179260254,
        -0.10104064643383026,
        -0.8767293095588684
      ],
      "plane_d": 96.09918212890625,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.3896484375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1570.9749755859375,
        -3819.073486328125,
        1387.48095703125
      ],
      "bbox_max": [
        -1562.65283203125,
        -3803.328369140625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1570.9749755859375,
        -3807.573486328125,
        1388.645263671875
      ],
      "bbox_max": [
        -1566.14013671875,
        -3806.51611328125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1570.744873046875,
        -3819.073486328125,
        1388.1480712890625
      ],
      "bbox_max": [
        -1562.65283203125,
        -3814.837158203125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1570.744873046875,
        -3819.073486328125,
        1389.392822265625
      ],
      "bbox_max": [
        -1565.14013671875,
        -3817.778076171875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2762.74365234375,
      "bbox_min": [
        -1570.744873046875,
        -3819.073486328125,
        1391.798828125
      ],
      "bbox_max": [
        -1569.9248046875,
        -3817.778076171875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1567.0799560546875,
        -3806.57666015625,
        1386.826416015625
      ],
      "bbox_max": [
        -1565.2379150390625,
        -3803.31982421875,
        1388.84326171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1572.462646484375,
        -3818.981201171875,
        1387.794189453125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3805.72314453125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1572.462646484375,
        -3818.981201171875,
        1387.794189453125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3805.72314453125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1565.6800537109375,
        -3818.244873046875,
        1387.794189453125
      ],
      "bbox_max": [
        -1564.0089111328125,
        -3814.83251953125,
        1389.392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8234690427780151,
        -0.48947080969810486,
        -0.28690972924232483
      ],
      "plane_d": -2762.74365234375,
      "bbox_min": [
        -1577.745849609375,
        -3818.74951171875,
        1387.293701171875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3796.682861328125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1577.745849609375,
        -3818.74951171875,
        1387.293701171875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3796.682861328125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3233.507568359375,
      "bbox_min": [
        -1577.745849609375,
        -3818.095458984375,
        1387.293701171875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3796.682861328125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43648433685302734,
        -0.46496182680130005,
        -0.7702544331550598
      ],
      "plane_d": -1381.702880859375,
      "bbox_min": [
        -1577.745849609375,
        -3806.40234375,
        1387.293701171875
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3796.682861328125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1566.8492431640625,
        -3806.40234375,
        1387.293701171875
      ],
      "bbox_max": [
        -1566.0643310546875,
        -3804.6083984375,
        1388.2728271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1565.6893310546875,
        -3818.095458984375,
        1387.671875
      ],
      "bbox_max": [
        -1564.13037109375,
        -3814.8310546875,
        1388.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1566.0643310546875,
        -3804.6083984375,
        1386.4254150390625
      ],
      "bbox_max": [
        -1565.4625244140625,
        -3803.314697265625,
        1387.293701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1571.2906494140625,
        -3789.5859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1566.068359375,
        -3782.3896484375,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1571.2906494140625,
        -3789.5859375,
        1378.6053466796875
      ],
      "bbox_max": [
        -1566.07080078125,
        -3782.3896484375,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321924567222595,
        -0.15732266008853912,
        0.6626793146133423
      ],
      "plane_d": -2651.123779296875,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.51513671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8603194952011108,
        -0.13034118711948395,
        0.49280983209609985
      ],
      "plane_d": -2512.115234375,
      "bbox_min": [
        -1553.8087158203125,
        -3850.2529296875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3818.267578125,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17870178818702698,
        0.505961000919342,
        -0.8438419699668884
      ],
      "plane_d": 3411.8828125,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.51513671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07172953337430954,
        0.11237809807062149,
        0.9910731911659241
      ],
      "plane_d": -1041.2471923828125,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.51513671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23484168946743011,
        -0.08580072969198227,
        0.9682394862174988
      ],
      "plane_d": -1298.018798828125,
      "bbox_min": [
        -1561.5091552734375,
        -3869.806884765625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.6326904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1479032188653946,
        0.09458452463150024,
        0.9844685792922974
      ],
      "plane_d": -1218.66552734375,
      "bbox_min": [
        -1557.28955078125,
        -3867.953857421875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.6326904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1551.5911865234375,
        -3865.431396484375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1376.6326904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48407191038131714,
        0.23269326984882355,
        -0.8435213565826416
      ],
      "plane_d": 1313.933349609375,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.51513671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7980432510375977,
        -0.5389218330383301,
        -0.26961150765419006
      ],
      "plane_d": -2948.3935546875,
      "bbox_min": [
        -1563.3109130859375,
        -3869.614013671875,
        1381.577880859375
      ],
      "bbox_max": [
        -1551.121826171875,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25476256012916565,
        0.1850539743900299,
        -0.9491318464279175
      ],
      "plane_d": 1635.9110107421875,
      "bbox_min": [
        -1563.3109130859375,
        -3869.614013671875,
        1386.2039794921875
      ],
      "bbox_max": [
        -1552.4556884765625,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1563.3109130859375,
        -3869.614013671875,
        1386.2039794921875
      ],
      "bbox_max": [
        -1558.322265625,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3782.51513671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20497587323188782,
        0.7754420638084412,
        -0.5972223281860352
      ],
      "plane_d": 4150.05712890625,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.709228515625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7973082661628723,
        0.5862280130386353,
        0.14365337789058685
      ],
      "plane_d": 3360.955078125,
      "bbox_min": [
        -1629.5155029296875,
        -3873.51025390625,
        1378.1693115234375
      ],
      "bbox_max": [
        -1569.65966796875,
        -3852.690185546875,
        1389.716552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20014050602912903,
        0.645072340965271,
        0.7374451160430908
      ],
      "plane_d": 1794.3597412109375,
      "bbox_min": [
        -1629.075439453125,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1569.65966796875,
        -3852.690185546875,
        1389.716552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26621708273887634,
        0.15397192537784576,
        -0.951536238193512
      ],
      "plane_d": 2347.12158203125,
      "bbox_min": [
        -1629.075439453125,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1569.65966796875,
        -3852.690185546875,
        1389.716552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1570.126220703125,
        -3873.51025390625,
        1380.982177734375
      ],
      "bbox_max": [
        -1569.65966796875,
        -3873.2294921875,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14916349947452545,
        0.6815324425697327,
        0.7164244055747986
      ],
      "plane_d": 1884.0177001953125,
      "bbox_min": [
        -1628.288818359375,
        -3873.353759765625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3788.709228515625,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17272649705410004,
        0.6420222520828247,
        0.746975839138031
      ],
      "plane_d": 1726.3408203125,
      "bbox_min": [
        -1626.646240234375,
        -3873.353759765625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1562.078369140625,
        -3859.00390625,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7973082661628723,
        0.5862280130386353,
        0.14365337789058685
      ],
      "plane_d": 3360.955078125,
      "bbox_min": [
        -1626.646240234375,
        -3860.91455078125,
        1377.7252197265625
      ],
      "bbox_max": [
        -1624.914306640625,
        -3859.00390625,
        1380.015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20014050602912903,
        0.645072340965271,
        0.7374451160430908
      ],
      "plane_d": 1794.3597412109375,
      "bbox_min": [
        -1579.16015625,
        -3873.2294921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1570.126220703125,
        -3865.60595703125,
        1381.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37581175565719604,
        0.30167463421821594,
        -0.8762179613113403
      ],
      "plane_d": 1794.4366455078125,
      "bbox_min": [
        -1628.288818359375,
        -3872.783447265625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3803.248046875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28390222787857056,
        0.33947694301605225,
        -0.8967469334602356
      ],
      "plane_d": 2999.981689453125,
      "bbox_min": [
        -1563.3109130859375,
        -3870.1376953125,
        1385.6348876953125
      ],
      "bbox_max": [
        -1561.3228759765625,
        -3852.376953125,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6908631324768066,
        0.3320978283882141,
        0.6421985626220703
      ],
      "plane_d": -674.5504150390625,
      "bbox_min": [
        -1626.7030029296875,
        -3872.783447265625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1543.3992919921875,
        -3803.248046875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9668928384780884,
        0.17989327013492584,
        0.1809876561164856
      ],
      "plane_d": -1053.926025390625,
      "bbox_min": [
        -1551.4945068359375,
        -3865.38330078125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1548.96630859375,
        -3850.2529296875,
        1380.9305419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04376031830906868,
        0.7580565214157104,
        -0.6507191061973572
      ],
      "plane_d": 3903.817626953125,
      "bbox_min": [
        -1626.7030029296875,
        -3872.783447265625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1562.494384765625,
        -3803.248046875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9562231302261353,
        -0.29263854026794434
      ],
      "plane_d": -3244.504150390625,
      "bbox_min": [
        -1571.83154296875,
        -3818.730712890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.17236328125,
        -3803.248046875,
        1390.980224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -177.9371337890625,
      "bbox_min": [
        -1571.83154296875,
        -3818.07861328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1564.17236328125,
        -3803.248046875,
        1389.8531494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9577512145042419,
        0.28759777545928955
      ],
      "plane_d": -4040.78076171875,
      "bbox_min": [
        -1571.83154296875,
        -3806.885986328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.2955322265625,
        -3803.248046875,
        1389.8531494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -963.1756591796875,
      "bbox_min": [
        -1571.83154296875,
        -3806.1083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.2955322265625,
        -3803.248046875,
        1384.487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3548.5302734375,
      "bbox_min": [
        -1571.83154296875,
        -3806.1083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.1707763671875,
        -3803.248046875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1567.970947265625,
        -3804.25732421875,
        1381.264404296875
      ],
      "bbox_max": [
        -1566.26513671875,
        -3803.248046875,
        1384.487548828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8230227828025818,
        -0.48913806676864624,
        -0.2887515425682068
      ],
      "plane_d": -171.489013671875,
      "bbox_min": [
        -1567.970947265625,
        -3806.2890625,
        1381.264404296875
      ],
      "bbox_max": [
        -1565.60009765625,
        -3803.28955078125,
        1387.903076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -969.6336669921875,
      "bbox_min": [
        -1566.970947265625,
        -3815.75732421875,
        1378.09814453125
      ],
      "bbox_max": [
        -1565.3050537109375,
        -3814.748046875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.824732780456543,
        -0.4902220070362091,
        0.2819540798664093
      ],
      "plane_d": -3553.34326171875,
      "bbox_min": [
        -1626.7030029296875,
        -3859.04052734375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.435791015625,
        -3814.748046875,
        1381.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8243029713630676,
        -0.4898988902568817,
        0.28376710414886475
      ],
      "plane_d": -969.6336669921875,
      "bbox_min": [
        -1566.420166015625,
        -3817.6083984375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1565.435791015625,
        -3816.7451171875,
        1377.9420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.702180027961731,
        0.5420933961868286,
        -0.4616036117076874
      ],
      "plane_d": 1582.606689453125,
      "bbox_min": [
        -1626.77978515625,
        -3836.5947265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1586.23974609375,
        -3788.709228515625,
        1408.6197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2064199149608612,
        0.8485844731330872,
        -0.48712968826293945
      ],
      "plane_d": 3598.04443359375,
      "bbox_min": [
        -1626.77978515625,
        -3836.5947265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1622.4228515625,
        -3827.154296875,
        1408.6197509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1625.92919921875,
        -3836.5947265625,
        1392.0999755859375
      ],
      "bbox_max": [
        -1622.4228515625,
        -3835.57763671875,
        1392.1646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009981022449210286,
        0.9665272831916809,
        -0.25656211376190186
      ],
      "plane_d": 4062.731201171875,
      "bbox_min": [
        -1625.9490966796875,
        -3836.3583984375,
        1392.0999755859375
      ],
      "bbox_max": [
        -1622.4228515625,
        -3834.8466796875,
        1394.86767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1625.78564453125,
        -3836.3583984375,
        1392.0999755859375
      ],
      "bbox_max": [
        -1622.4228515625,
        -3835.501220703125,
        1392.399169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1636.3670654296875,
        -3859.96630859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3776.952880859375,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09103017300367355,
        0.3138766884803772,
        -0.9450899362564087
      ],
      "plane_d": 2371.86865234375,
      "bbox_min": [
        -1636.3670654296875,
        -3854.740234375,
        1385.192138671875
      ],
      "bbox_max": [
        -1622.4228515625,
        -3835.57763671875,
        1392.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02514362707734108,
        0.45447838306427,
        -0.8904027342796326
      ],
      "plane_d": 3027.492919921875,
      "bbox_min": [
        -1636.3670654296875,
        -3854.740234375,
        1385.192138671875
      ],
      "bbox_max": [
        -1631.0516357421875,
        -3851.773193359375,
        1387.94677734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1636.366943359375,
        -3854.740234375,
        1385.192138671875
      ],
      "bbox_max": [
        -1631.0516357421875,
        -3854.26953125,
        1386.63818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7973082661628723,
        0.5862280130386353,
        0.14365337789058685
      ],
      "plane_d": 3360.955078125,
      "bbox_min": [
        -1636.0306396484375,
        -3859.96630859375,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3776.952880859375,
        1387.2027587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1636.0306396484375,
        -3854.890625,
        1375.0999755859375
      ],
      "bbox_max": [
        -1629.17919921875,
        -3854.36181640625,
        1386.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1636.0306396484375,
        -3854.890625,
        1384.73046875
      ],
      "bbox_max": [
        -1631.0516357421875,
        -3854.6337890625,
        1386.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1631.0516357421875,
        -3856.526611328125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1569.11962890625,
        -3776.952880859375,
        1387.2027587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18132080137729645,
        0.5047606825828552,
        -0.8440020680427551
      ],
      "plane_d": 3411.70654296875,
      "bbox_min": [
        -1631.0516357421875,
        -3856.526611328125,
        1385.80029296875
      ],
      "bbox_max": [
        -1629.075439453125,
        -3854.339599609375,
        1387.2027587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1598.079833984375,
        -3775.89892578125,
        1427.2364501953125
      ],
      "bbox_max": [
        -1591.0390625,
        -3768.994140625,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2182459682226181,
        0.9206604361534119,
        -0.32365575432777405
      ],
      "plane_d": 3624.37939453125,
      "bbox_min": [
        -1654.4971923828125,
        -3835.501220703125,
        1392.399169921875
      ],
      "bbox_max": [
        -1593.689697265625,
        -3759.6328125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2064199149608612,
        0.8485844731330872,
        -0.48712968826293945
      ],
      "plane_d": 3598.04443359375,
      "bbox_min": [
        -1644.084228515625,
        -3835.501220703125,
        1392.399169921875
      ],
      "bbox_max": [
        -1625.26513671875,
        -3827.154296875,
        1409.101806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0009981022449210286,
        0.9665272831916809,
        -0.25656211376190186
      ],
      "plane_d": 4062.731201171875,
      "bbox_min": [
        -1654.4971923828125,
        -3835.14501953125,
        1393.7921142578125
      ],
      "bbox_max": [
        -1593.689697265625,
        -3759.6328125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7415204644203186,
        -0.2118629515171051,
        -0.636601448059082
      ],
      "plane_d": -1070.4005126953125,
      "bbox_min": [
        -1601.3858642578125,
        -3771.20361328125,
        1429.2508544921875
      ],
      "bbox_max": [
        -1593.689697265625,
        -3759.6328125,
        1435.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.058050818741321564,
        0.9982133507728577,
        0.014152820222079754
      ],
      "plane_d": 3733.4384765625,
      "bbox_min": [
        -1667.7159423828125,
        -3856.211669921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.142333984375,
        -3757.077392578125,
        1394.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0015104603953659534,
        0.45972731709480286,
        -0.8880589008331299
      ],
      "plane_d": 3000.108642578125,
      "bbox_min": [
        -1664.9873046875,
        -3852.36962890625,
        1386.8251953125
      ],
      "bbox_max": [
        -1663.232666015625,
        -3848.85986328125,
        1388.640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.04228266701102257,
        0.47568580508232117,
        -0.8785985112190247
      ],
      "plane_d": 3121.341796875,
      "bbox_min": [
        -1664.9873046875,
        -3852.36962890625,
        1386.8251953125
      ],
      "bbox_max": [
        -1664.08349609375,
        -3851.15869140625,
        1387.4530029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06334260106086731,
        0.9532076716423035,
        -0.29560601711273193
      ],
      "plane_d": 4187.4697265625,
      "bbox_min": [
        -1667.7159423828125,
        -3856.211669921875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.142333984375,
        -3757.077392578125,
        1387.15478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8711618781089783,
        -0.37250569462776184,
        0.3198692798614502
      ],
      "plane_d": -3219.5634765625,
      "bbox_min": [
        -1667.7159423828125,
        -3855.93798828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.142333984375,
        -3757.077392578125,
        1387.15478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7768447399139404,
        -0.5998343229293823,
        -0.19160105288028717
      ],
      "plane_d": -3225.078125,
      "bbox_min": [
        -1577.630126953125,
        -3777.18408203125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.142333984375,
        -3772.6669921875,
        1376.9832763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1577.630126953125,
        -3777.162841796875,
        1375.0999755859375
      ],
      "bbox_max": [
        -1574.7020263671875,
        -3772.6669921875,
        1376.9832763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4164329767227173,
        -0.5464820265769958,
        -0.7265954613685608
      ],
      "plane_d": -1719.530517578125,
      "bbox_min": [
        -1667.7159423828125,
        -3855.93798828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1575.016357421875,
        -3772.6669921875,
        1387.15478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5124725103378296,
        0.8080757856369019,
        -0.2904915511608124
      ],
      "plane_d": 4368.66455078125,
      "bbox_min": [
        -1667.7159423828125,
        -3855.93798828125,
        1375.0999755859375
      ],
      "bbox_max": [
        -1664.08349609375,
        -3851.680419921875,
        1387.15478515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25277045369148254,
        -0.4160633385181427,
        -0.8734978437423706
      ],
      "plane_d": -10.57598876953125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1393.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25196951627731323,
        -0.42230406403541565,
        -0.8707300424575806
      ],
      "plane_d": -822.654052734375,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1393.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.26930010318756104,
        -0.24784131348133087,
        0.9306192398071289
      ],
      "plane_d": -1824.6865234375,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2687537372112274,
        -0.255401074886322,
        0.9287312030792236
      ],
      "plane_d": -2687.1923828125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1373.25
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8721579313278198,
        -0.356646329164505,
        0.33487921953201294
      ],
      "plane_d": -3196.431640625,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1375.71875
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8801052570343018,
        -0.33349302411079407,
        0.33793070912361145
      ],
      "plane_d": -388.9307861328125,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1375.71875
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8490763902664185,
        -0.4156712293624878,
        -0.3260166645050049
      ],
      "plane_d": -2476.5576171875,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1382.4739990234375
      ],
      "bbox_max": [
        -1541.75,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8579274415969849,
        -0.3942665457725525,
        -0.3294152319431305
      ],
      "plane_d": 262.7730712890625,
      "bbox_min": [
        -1564.5,
        -3893.5,
        1382.4739990234375
      ],
      "bbox_max": [
        -1559.7265625,
        -3887.300048828125,
        1390.53125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3906.0,
      "bbox_min": [
        -1591.0,
        -4003.042236328125,
        1335.75
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3893.5,
        1428.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.27409252524375916,
        -0.8793426752090454,
        -0.3893965482711792
      ],
      "plane_d": -3322.20068359375,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1335.75
      ],
      "bbox_max": [
        -1487.178955078125,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4108384847640991,
        0.9117081165313721
      ],
      "plane_d": -2853.853515625,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1501.965087890625,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1501.965087890625,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1501.965087890625,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3900.506103515625,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1498.98291015625,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3901.922607421875,
        1359.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1493.83544921875,
        -3906.0,
        1351.37255859375
      ],
      "bbox_max": [
        -1490.0869140625,
        -3901.968994140625,
        1358.785888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1493.427001953125,
        -3906.0,
        1354.7989501953125
      ],
      "bbox_max": [
        -1490.0869140625,
        -3903.362548828125,
        1358.785888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7356816530227661,
        -0.6199018359184265,
        0.27293649315834045
      ],
      "plane_d": -3925.33056640625,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1370.099365234375
      ],
      "bbox_max": [
        -1531.4375,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7475398778915405,
        -0.6035469174385071,
        -0.27733591198921204
      ],
      "plane_d": -3118.83935546875,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1370.099365234375
      ],
      "bbox_max": [
        -1531.4375,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2527981102466583,
        -0.47287169098854065,
        -0.8440885543823242
      ],
      "plane_d": -1057.8648681640625,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1370.099365234375
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7292430400848389,
        -0.6243412494659424,
        0.28000470995903015
      ],
      "plane_d": -3942.46484375,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1370.099365234375
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7413931488990784,
        -0.607699990272522,
        -0.2846699357032776
      ],
      "plane_d": -3115.388671875,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1373.2047119140625
      ],
      "bbox_max": [
        -1536.0546875,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24435769021511078,
        -0.47669079899787903,
        -0.8444259166717529
      ],
      "plane_d": -1059.228271484375,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1373.2047119140625
      ],
      "bbox_max": [
        -1544.59375,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25911954045295715,
        -0.36200475692749023,
        -0.8954383134841919
      ],
      "plane_d": 240.3250732421875,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1373.2047119140625
      ],
      "bbox_max": [
        -1549.90625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.266791433095932,
        -0.36779916286468506,
        -0.8908120393753052
      ],
      "plane_d": 223.23550415039062,
      "bbox_min": [
        -1563.7578125,
        -3906.0,
        1393.0
      ],
      "bbox_max": [
        -1549.90625,
        -3893.5,
        1399.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9025225639343262,
        -0.2708120048046112,
        -0.33483418822288513
      ],
      "plane_d": 820.6207275390625,
      "bbox_min": [
        -1567.10107421875,
        -3906.0,
        1373.2047119140625
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1394.9765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9007346630096436,
        -0.26279979944229126,
        -0.34585168957710266
      ],
      "plane_d": 864.344482421875,
      "bbox_min": [
        -1567.10107421875,
        -3902.834716796875,
        1382.684814453125
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1390.53125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925831317901611,
        -0.2929800748825073,
        0.3427217900753021
      ],
      "plane_d": -218.2987060546875,
      "bbox_min": [
        -1567.10107421875,
        -3901.890625,
        1382.684814453125
      ],
      "bbox_max": [
        -1564.4510498046875,
        -3893.5,
        1383.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925831317901611,
        -0.2929800748825073,
        0.3427217900753021
      ],
      "plane_d": -218.2987060546875,
      "bbox_min": [
        -1567.0810546875,
        -3901.87841796875,
        1373.2047119140625
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1382.9974365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.894402265548706,
        -0.2998984456062317,
        0.3318215608596802
      ],
      "plane_d": -227.3988037109375,
      "bbox_min": [
        -1565.709716796875,
        -3901.041259765625,
        1373.2047119140625
      ],
      "bbox_max": [
        -1561.65625,
        -3893.5,
        1379.8287353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2354559451341629,
        -0.821074366569519,
        -0.5199974775314331
      ],
      "plane_d": -2143.179931640625,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1335.75
      ],
      "bbox_max": [
        -1516.125,
        -3894.0986328125,
        1390.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4108384847640991,
        0.9117081165313721
      ],
      "plane_d": -2853.853515625,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1366.5819091796875
      ],
      "bbox_max": [
        -1536.03515625,
        -3898.70556640625,
        1390.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1366.5819091796875
      ],
      "bbox_max": [
        -1562.0701904296875,
        -3898.70556640625,
        1372.8731689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16739465296268463,
        0.023890966549515724,
        -0.985600471496582
      ],
      "plane_d": 1177.7626953125,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1366.5819091796875
      ],
      "bbox_max": [
        -1567.9063720703125,
        -3900.921630859375,
        1369.022705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48215293884277344,
        -0.6684456467628479,
        -0.5663117170333862
      ],
      "plane_d": -2597.18505859375,
      "bbox_min": [
        -1579.436767578125,
        -3906.0,
        1368.419921875
      ],
      "bbox_max": [
        -1578.7286376953125,
        -3905.64404296875,
        1369.022705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1578.05224609375,
        -3906.0,
        1370.0858154296875
      ],
      "bbox_max": [
        -1536.03515625,
        -3899.0791015625,
        1390.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.894402265548706,
        -0.2998984456062317,
        0.3318215608596802
      ],
      "plane_d": -227.3988037109375,
      "bbox_min": [
        -1578.05224609375,
        -3906.0,
        1370.0859375
      ],
      "bbox_max": [
        -1563.7257080078125,
        -3905.808837890625,
        1375.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27310365438461304,
        -0.6975887417793274,
        0.6624080538749695
      ],
      "plane_d": -4066.563720703125,
      "bbox_min": [
        -1578.05224609375,
        -3906.0,
        1374.998291015625
      ],
      "bbox_max": [
        -1577.87744140625,
        -3905.93359375,
        1375.0919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.894402265548706,
        -0.2998984456062317,
        0.3318215608596802
      ],
      "plane_d": -227.3988037109375,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1370.0859375
      ],
      "bbox_max": [
        -1536.03515625,
        -3899.0791015625,
        1390.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8925831317901611,
        -0.2929800748825073,
        0.3427217900753021
      ],
      "plane_d": -218.2987060546875,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1379.8287353515625
      ],
      "bbox_max": [
        -1565.709716796875,
        -3901.041259765625,
        1382.76708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9007346630096436,
        -0.26279979944229126,
        -0.34585168957710266
      ],
      "plane_d": 864.344482421875,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1382.53125
      ],
      "bbox_max": [
        -1567.091552734375,
        -3901.890625,
        1382.76708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9025225639343262,
        -0.2708120048046112,
        -0.33483418822288513
      ],
      "plane_d": 820.6207275390625,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1370.0859375
      ],
      "bbox_max": [
        -1536.03515625,
        -3901.91162109375,
        1390.7552490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9007346630096436,
        -0.26279979944229126,
        -0.34585168957710266
      ],
      "plane_d": 864.344482421875,
      "bbox_min": [
        -1568.375,
        -3906.0,
        1382.53125
      ],
      "bbox_max": [
        -1566.673583984375,
        -3901.91162109375,
        1384.55712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7356816530227661,
        -0.6199018359184265,
        0.27293649315834045
      ],
      "plane_d": -3925.33056640625,
      "bbox_min": [
        -1536.0750732421875,
        -3906.0,
        1370.0859375
      ],
      "bbox_max": [
        -1536.03515625,
        -3905.97021484375,
        1370.138671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1733468472957611,
        -0.8141732215881348,
        -0.5541415214538574
      ],
      "plane_d": -2165.860107421875,
      "bbox_min": [
        -1540.5,
        -3906.0,
        1335.75
      ],
      "bbox_max": [
        -1516.125,
        -3894.0986328125,
        1356.125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16739505529403687,
        -0.02388993836939335,
        0.985600471496582
      ],
      "plane_d": -1184.455322265625,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.0,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.0,
        -3906.0,
        1375.0704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16739465296268463,
        0.023890966549515724,
        -0.985600471496582
      ],
      "plane_d": 1177.7626953125,
      "bbox_min": [
        -1591.0,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.1658935546875,
        -3906.0,
        1375.0704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1579.9139404296875,
        -3954.0,
        1349.7503662109375
      ],
      "bbox_max": [
        -1475.40087890625,
        -3906.0,
        1375.0704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48215293884277344,
        -0.6684456467628479,
        -0.5663117170333862
      ],
      "plane_d": -2597.18505859375,
      "bbox_min": [
        -1579.9139404296875,
        -3954.0,
        1352.8477783203125
      ],
      "bbox_max": [
        -1493.041259765625,
        -3906.0,
        1375.0704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27310365438461304,
        -0.6975887417793274,
        0.6624080538749695
      ],
      "plane_d": -4066.563720703125,
      "bbox_min": [
        -1579.9139404296875,
        -3954.0,
        1357.0921630859375
      ],
      "bbox_max": [
        -1493.041259765625,
        -3906.0,
        1375.0704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1571.6949462890625,
        -3916.7529296875,
        1366.1263427734375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3906.0,
        1373.9365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1569.9329833984375,
        -3916.7529296875,
        1366.1263427734375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1372.3809814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1569.9329833984375,
        -3916.7529296875,
        1368.193359375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1370.952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1571.1605224609375,
        -3918.878662109375,
        1369.1761474609375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1373.689208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.1605224609375,
        -3918.878662109375,
        1369.1761474609375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1373.689208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1569.5675048828125,
        -3918.878662109375,
        1369.1761474609375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1373.4853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3913.164306640625,
        1370.952392578125
      ],
      "bbox_max": [
        -1566.1025390625,
        -3913.164306640625,
        1373.4853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1578.2216796875,
        -3954.0,
        1365.7347412109375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3911.289794921875,
        1373.9339599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9456968307495117,
        -0.3026995062828064,
        -0.11845056712627411
      ],
      "plane_d": 458.1868896484375,
      "bbox_min": [
        -1578.2216796875,
        -3954.0,
        1366.697265625
      ],
      "bbox_max": [
        -1569.66845703125,
        -3913.339111328125,
        1373.9287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3917.88134765625,
        1366.701904296875
      ],
      "bbox_max": [
        -1569.66845703125,
        -3913.339111328125,
        1370.173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3917.88134765625,
        1366.701904296875
      ],
      "bbox_max": [
        -1570.3092041015625,
        -3916.1650390625,
        1370.173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1578.2216796875,
        -3954.0,
        1367.0511474609375
      ],
      "bbox_max": [
        -1577.5205078125,
        -3952.03857421875,
        1373.9287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1365.7347412109375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1373.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1365.7347412109375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1373.70703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3916.1650390625,
        1365.7347412109375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1369.076904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1566.1025390625,
        -3916.1650390625,
        1365.7347412109375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1368.193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1476.2586669921875,
        -3954.0,
        1349.7503662109375
      ],
      "bbox_max": [
        -1475.40087890625,
        -3952.216064453125,
        1352.5863037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1591.0,
        -3951.532958984375,
        1336.5
      ],
      "bbox_max": [
        -1564.875,
        -3906.0,
        1366.911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1591.0,
        -3951.532958984375,
        1336.5
      ],
      "bbox_max": [
        -1564.875,
        -3906.0,
        1366.911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3916.0,
      "bbox_min": [
        -1591.0,
        -3916.0,
        1336.5
      ],
      "bbox_max": [
        -1571.6226806640625,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1572.6378173828125,
        -3934.3896484375,
        1340.481201171875
      ],
      "bbox_max": [
        -1564.875,
        -3906.0,
        1366.911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1340.481201171875
      ],
      "bbox_max": [
        -1566.8341064453125,
        -3913.164306640625,
        1366.911865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1344.432373046875
      ],
      "bbox_max": [
        -1566.8341064453125,
        -3913.164306640625,
        1366.4886474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1352.306884765625
      ],
      "bbox_max": [
        -1568.47509765625,
        -3919.165771484375,
        1364.103271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1569.66845703125,
        -3913.339111328125,
        1366.4886474609375
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1366.7032470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1576.957275390625,
        -3937.046142578125,
        1336.5
      ],
      "bbox_max": [
        -1567.663330078125,
        -3913.164306640625,
        1352.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3916.0,
      "bbox_min": [
        -1571.2047119140625,
        -3916.0,
        1336.5
      ],
      "bbox_max": [
        -1570.220703125,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3916.0,
      "bbox_min": [
        -1572.2376708984375,
        -3916.0,
        1336.5
      ],
      "bbox_max": [
        -1571.2047119140625,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1571.300048828125,
        -3918.71923828125,
        1339.0
      ],
      "bbox_max": [
        -1567.663330078125,
        -3913.164306640625,
        1352.17236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3918.71923828125,
        1339.0
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1349.1077880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3916.1650390625,
        1339.0
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1344.432373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3916.9599609375,
        1335.75
      ],
      "bbox_max": [
        -1567.3360595703125,
        -3906.0,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3916.9599609375,
        1335.75
      ],
      "bbox_max": [
        -1570.8411865234375,
        -3916.1650390625,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001385469367960468,
        -0.9999999403953552,
        0.0004428959218785167
      ],
      "plane_d": -3906.383544921875,
      "bbox_min": [
        -1569.889892578125,
        -3906.009765625,
        1335.75
      ],
      "bbox_max": [
        -1567.3360595703125,
        -3906.0,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2354559451341629,
        -0.821074366569519,
        -0.5199974775314331
      ],
      "plane_d": -2143.179931640625,
      "bbox_min": [
        -1568.6912841796875,
        -3906.009521484375,
        1335.75
      ],
      "bbox_max": [
        -1567.35302734375,
        -3906.0,
        1336.354736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1581.7359619140625,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.1658935546875,
        -3906.0,
        1367.2178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1581.59423828125,
        -3954.0,
        1339.0
      ],
      "bbox_max": [
        -1575.584716796875,
        -3943.877685546875,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0001385469367960468,
        -0.9999999403953552,
        0.0004428959218785167
      ],
      "plane_d": -3906.383544921875,
      "bbox_min": [
        -1579.2257080078125,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.1658935546875,
        -3906.0,
        1366.2481689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2354559451341629,
        -0.821074366569519,
        -0.5199974775314331
      ],
      "plane_d": -2143.179931640625,
      "bbox_min": [
        -1567.354248046875,
        -3906.009033203125,
        1336.3409423828125
      ],
      "bbox_max": [
        -1540.5,
        -3906.0,
        1348.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1579.2257080078125,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.1658935546875,
        -3910.105224609375,
        1366.2481689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1579.2257080078125,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1549.31005859375,
        -3913.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9191451072692871,
        0.39391934871673584,
        -0.0
      ],
      "plane_d": 2980.49609375,
      "bbox_min": [
        -1570.8411865234375,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1549.31005859375,
        -3913.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8094816207885742,
        0.587145209312439,
        -0.0
      ],
      "plane_d": 3568.52783203125,
      "bbox_min": [
        -1570.8411865234375,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1549.31005859375,
        -3913.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1570.8411865234375,
        -3954.0,
        1336.5
      ],
      "bbox_max": [
        -1549.31005859375,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1570.8411865234375,
        -3919.165771484375,
        1336.5
      ],
      "bbox_max": [
        -1565.92578125,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3916.0,
      "bbox_min": [
        -1570.8411865234375,
        -3919.165771484375,
        1336.5
      ],
      "bbox_max": [
        -1565.92578125,
        -3916.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1570.8411865234375,
        -3919.165771484375,
        1336.5
      ],
      "bbox_max": [
        -1565.92578125,
        -3916.9599609375,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1566.1025390625,
        -3919.165771484375,
        1336.5
      ],
      "bbox_max": [
        -1565.92578125,
        -3918.859619140625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.6995849609375,
        -3918.859619140625,
        1336.5
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1569.6995849609375,
        -3913.393310546875,
        1336.5
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1336.97021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1570.901611328125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1566.1025390625,
        -3913.164306640625,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1570.901611328125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1569.910400390625,
        -3913.75830078125,
        1335.75
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1336.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1570.6397705078125,
        -3919.165771484375,
        1339.0
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1366.2481689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1570.6397705078125,
        -3919.165771484375,
        1339.0
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3917.308837890625,
        1352.306884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1516.036376953125,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1473.212646484375,
        -3928.5166015625,
        1352.667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1513.0540771484375,
        -3954.0,
        1341.1697998046875
      ],
      "bbox_max": [
        -1473.212646484375,
        -3930.644287109375,
        1352.667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1513.0540771484375,
        -3954.0,
        1344.59619140625
      ],
      "bbox_max": [
        -1499.1424560546875,
        -3932.1484375,
        1352.667236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1507.4981689453125,
        -3954.0,
        1344.59619140625
      ],
      "bbox_max": [
        -1499.1424560546875,
        -3934.276123046875,
        1352.05517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1476.0333251953125,
        -3954.0,
        1341.170166015625
      ],
      "bbox_max": [
        -1473.212646484375,
        -3947.66552734375,
        1349.8145751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1475.3304443359375,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.1658935546875,
        -3943.4091796875,
        1342.5164794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1534.8067626953125,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1521.1932373046875,
        -3910.105224609375,
        1356.8564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1533.10107421875,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1521.1932373046875,
        -3910.105224609375,
        1356.8564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1533.10107421875,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1521.1932373046875,
        -3910.105224609375,
        1354.7896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1533.10107421875,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1522.73388671875,
        -3910.105224609375,
        1354.7896728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584287762641907,
        0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": 3070.11376953125,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1522.73388671875,
        -3910.105224609375,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1523.2919921875,
        -3913.164306640625,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423888206482,
        -0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -1258.0462646484375,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1345.6937255859375
      ],
      "bbox_max": [
        -1524.3697509765625,
        -3913.164306640625,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423292160034,
        0.4226883351802826,
        0.5341368913650513
      ],
      "plane_d": 2052.448974609375,
      "bbox_min": [
        -1531.300048828125,
        -3918.9404296875,
        1345.95458984375
      ],
      "bbox_max": [
        -1524.4649658203125,
        -3913.164306640625,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321423888206482,
        -0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -3495.473388671875,
      "bbox_min": [
        -1531.300048828125,
        -3918.9404296875,
        1346.1461181640625
      ],
      "bbox_max": [
        -1526.36279296875,
        -3913.164306640625,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8453970551490784,
        0.5341383814811707
      ],
      "plane_d": 2589.060546875,
      "bbox_min": [
        -1531.204833984375,
        -3916.0,
        1346.3118896484375
      ],
      "bbox_max": [
        -1526.36279296875,
        -3913.164306640625,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321423888206482,
        0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -184.978271484375,
      "bbox_min": [
        -1531.204833984375,
        -3916.0,
        1346.4071044921875
      ],
      "bbox_max": [
        -1528.0,
        -3913.224609375,
        1350.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423292160034,
        0.4226883351802826,
        0.5341368913650513
      ],
      "plane_d": 2052.448974609375,
      "bbox_min": [
        -1526.1025390625,
        -3916.164794921875,
        1343.0
      ],
      "bbox_max": [
        -1523.2919921875,
        -3913.164306640625,
        1345.9552001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8453970551490784,
        0.5341383814811707
      ],
      "plane_d": 2589.060546875,
      "bbox_min": [
        -1529.5675048828125,
        -3913.164306640625,
        1343.0
      ],
      "bbox_max": [
        -1523.946533203125,
        -3911.07177734375,
        1346.31201171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423292160034,
        0.4226883351802826,
        0.5341368913650513
      ],
      "plane_d": 2052.448974609375,
      "bbox_min": [
        -1526.36279296875,
        -3913.164306640625,
        1343.0
      ],
      "bbox_max": [
        -1523.946533203125,
        -3911.07177734375,
        1346.3118896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584294319152832,
        0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": 446.7625732421875,
      "bbox_min": [
        -1533.10107421875,
        -3916.1650390625,
        1335.75
      ],
      "bbox_max": [
        -1527.80126953125,
        -3910.105224609375,
        1346.407470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8453970551490784,
        0.5341383814811707
      ],
      "plane_d": 2589.060546875,
      "bbox_min": [
        -1531.395263671875,
        -3916.1650390625,
        1343.0
      ],
      "bbox_max": [
        -1528.3592529296875,
        -3911.07177734375,
        1346.407470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584294319152832,
        -0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": -811.518310546875,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1521.1932373046875,
        -3913.33154296875,
        1345.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584287762641907,
        0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": 3070.11376953125,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1521.1932373046875,
        -3913.33154296875,
        1345.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423888206482,
        -0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -1258.0462646484375,
      "bbox_min": [
        -1526.1024169921875,
        -3919.165771484375,
        1343.0
      ],
      "bbox_max": [
        -1522.3094482421875,
        -3914.298095703125,
        1345.69384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423292160034,
        0.4226883351802826,
        0.5341368913650513
      ],
      "plane_d": 2052.448974609375,
      "bbox_min": [
        -1524.274658203125,
        -3916.0,
        1343.0
      ],
      "bbox_max": [
        -1522.3094482421875,
        -3914.298095703125,
        1345.6937255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9912278652191162,
        0.13216371834278107
      ],
      "plane_d": -4064.029296875,
      "bbox_min": [
        -1529.5675048828125,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1523.02099609375,
        -3919.165771484375,
        1345.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8584294319152832,
        -0.4956130385398865,
        0.13216151297092438
      ],
      "plane_d": -811.518310546875,
      "bbox_min": [
        -1529.5675048828125,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1523.02099609375,
        -3919.165771484375,
        1345.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8453971147537231,
        0.5341383814811707
      ],
      "plane_d": -4032.08935546875,
      "bbox_min": [
        -1529.5675048828125,
        -3920.92822265625,
        1343.0
      ],
      "bbox_max": [
        -1524.1370849609375,
        -3919.165771484375,
        1345.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7321423888206482,
        -0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -1258.0462646484375,
      "bbox_min": [
        -1526.1722412109375,
        -3920.92822265625,
        1343.0
      ],
      "bbox_max": [
        -1524.1370849609375,
        -3919.165771484375,
        1345.7894287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8584287762641907,
        -0.4956126809120178,
        0.13216644525527954
      ],
      "plane_d": -3434.8828125,
      "bbox_min": [
        -1534.8067626953125,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1527.991943359375,
        -3913.045654296875,
        1346.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9912278652191162,
        0.13216371834278107
      ],
      "plane_d": -4064.029296875,
      "bbox_min": [
        -1534.8067626953125,
        -3921.894775390625,
        1335.75
      ],
      "bbox_max": [
        -1527.991943359375,
        -3913.045654296875,
        1346.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7321423888206482,
        0.4226883351802826,
        0.534136950969696
      ],
      "plane_d": -184.978271484375,
      "bbox_min": [
        -1533.6905517578125,
        -3920.92822265625,
        1343.0
      ],
      "bbox_max": [
        -1528.550048828125,
        -3914.01220703125,
        1346.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8453971147537231,
        0.5341383814811707
      ],
      "plane_d": -4032.08935546875,
      "bbox_min": [
        -1530.8453369140625,
        -3920.92822265625,
        1343.0
      ],
      "bbox_max": [
        -1528.550048828125,
        -3918.9404296875,
        1346.1461181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6822958588600159,
        -0.6594514846801758,
        -0.3155883252620697
      ],
      "plane_d": -3182.2861328125,
      "bbox_min": [
        -1531.300048828125,
        -3954.0,
        1335.75
      ],
      "bbox_max": [
        -1471.0,
        -3906.0,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5578601956367493,
        -0.24393770098686218,
        -0.793275773525238
      ],
      "plane_d": -722.8253173828125,
      "bbox_min": [
        -1516.125,
        -3942.9375,
        1335.75
      ],
      "bbox_max": [
        -1471.0,
        -3906.0,
        1364.101318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1358.4212646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1479.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1358.19970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1479.5675048828125,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1358.0543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1476.1025390625,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1357.611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1476.1025390625,
        -3919.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3916.1650390625,
        1357.4658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995131611824036,
        -0.529276967048645,
        0.2839800715446472
      ],
      "plane_d": -3664.630126953125,
      "bbox_min": [
        -1516.125,
        -3924.158203125,
        1348.2276611328125
      ],
      "bbox_max": [
        -1490.853271484375,
        -3906.0,
        1364.101318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1504.889404296875,
        -3924.158203125,
        1348.2276611328125
      ],
      "bbox_max": [
        -1490.853271484375,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1504.889404296875,
        -3924.158203125,
        1348.2276611328125
      ],
      "bbox_max": [
        -1490.853271484375,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1504.889404296875,
        -3923.43017578125,
        1348.2276611328125
      ],
      "bbox_max": [
        -1493.427001953125,
        -3906.0,
        1358.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1504.889404296875,
        -3920.795166015625,
        1348.2276611328125
      ],
      "bbox_max": [
        -1493.83544921875,
        -3906.0,
        1358.2252197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1504.889404296875,
        -3916.446533203125,
        1349.3193359375
      ],
      "bbox_max": [
        -1499.391357421875,
        -3906.0,
        1354.7989501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1503.3631591796875,
        -3920.01806640625,
        1348.392822265625
      ],
      "bbox_max": [
        -1499.0001220703125,
        -3915.659912109375,
        1350.36279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1531.300048828125,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3913.164306640625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1346.8226318359375
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1348.8897705078125
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3913.164306640625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1348.8897705078125
      ],
      "bbox_max": [
        -1524.3699951171875,
        -3916.1650390625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1353.906494140625
      ],
      "bbox_max": [
        -1526.1025390625,
        -3916.1650390625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1354.7896728515625
      ],
      "bbox_max": [
        -1529.5675048828125,
        -3916.1650390625,
        1366.913330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1508.5657958984375,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3915.975830078125,
        1355.3900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1508.5657958984375,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3915.975830078125,
        1355.3900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1508.5657958984375,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3915.975830078125,
        1354.5205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1505.7716064453125,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3916.70361328125,
        1354.5205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1501.9366455078125,
        -3935.0283203125,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3920.795166015625,
        1354.5205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1501.0599365234375,
        -3934.276123046875,
        1346.1341552734375
      ],
      "bbox_max": [
        -1496.1763916015625,
        -3920.795166015625,
        1350.939208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3234.970947265625,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3240.97265625,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -681.3131103515625,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1357.244384765625
      ],
      "bbox_max": [
        -1474.3699951171875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1481.300048828125,
        -3919.165771484375,
        1357.4658203125
      ],
      "bbox_max": [
        -1476.1025390625,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1481.300048828125,
        -3916.1650390625,
        1357.611328125
      ],
      "bbox_max": [
        -1476.1025390625,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 675.3116455078125,
      "bbox_min": [
        -1481.300048828125,
        -3916.1650390625,
        1358.19970703125
      ],
      "bbox_max": [
        -1479.5675048828125,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8242894411087036,
        -0.48849767446517944,
        -0.28621160984039307
      ],
      "plane_d": -2756.56494140625,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.8016357421875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8242518901824951,
        -0.48466089367866516,
        -0.29276707768440247
      ],
      "plane_d": -2732.33154296875,
      "bbox_min": [
        -1516.125,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.8016357421875,
        -3906.0,
        1401.875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995131611824036,
        -0.529276967048645,
        0.2839800715446472
      ],
      "plane_d": -3664.630126953125,
      "bbox_min": [
        -1508.09228515625,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.8016357421875,
        -3906.0,
        1379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1478.0,
        -3954.0,
        1356.5230712890625
      ],
      "bbox_max": [
        -1474.8016357421875,
        -3948.9453125,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -638.0123291015625,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1356.5279541015625
      ],
      "bbox_max": [
        -1474.8492431640625,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3278.271728515625,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1365.7362060546875
      ],
      "bbox_max": [
        -1518.5008544921875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3284.2734375,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1365.957763671875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1537.1693115234375,
        -3922.16650390625,
        1365.957763671875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1537.1693115234375,
        -3919.165771484375,
        1366.1033935546875
      ],
      "bbox_max": [
        -1524.369873046875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 632.0107421875,
      "bbox_min": [
        -1533.03271484375,
        -3919.165771484375,
        1366.6917724609375
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1531.300048828125,
        -3919.165771484375,
        1407.4454345703125
      ],
      "bbox_max": [
        -1524.369873046875,
        -3913.164306640625,
        1410.5811767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1533.03271484375,
        -3916.1650390625,
        1408.5294189453125
      ],
      "bbox_max": [
        -1529.5673828125,
        -3913.164306640625,
        1410.0972900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1537.1693115234375,
        -3913.164306640625,
        1406.2900390625
      ],
      "bbox_max": [
        -1526.1024169921875,
        -3906.0,
        1409.6134033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1529.5675048828125,
        -3922.16650390625,
        1409.4971923828125
      ],
      "bbox_max": [
        -1526.1024169921875,
        -3919.165771484375,
        1411.0650634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9404411315917969,
        -0.06316715478897095,
        -0.3340364396572113
      ],
      "plane_d": 1693.21923828125,
      "bbox_min": [
        -1578.0,
        -3954.0,
        1374.0
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3906.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1385.7081298828125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1385.7081298828125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1390.018798828125
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3913.164306640625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1566.1025390625,
        -3919.165771484375,
        1401.0615234375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3916.1650390625,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1578.0,
        -3954.0,
        1374.0
      ],
      "bbox_max": [
        -1566.8260498046875,
        -3906.0,
        1397.7369384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1385.4720458984375
      ],
      "bbox_max": [
        -1568.470947265625,
        -3913.164306640625,
        1394.2406005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3919.165771484375,
      "bbox_min": [
        -1569.5675048828125,
        -3919.165771484375,
        1391.08251953125
      ],
      "bbox_max": [
        -1568.470947265625,
        -3919.165771484375,
        1394.2406005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005312979221344,
        -0.16630962491035461,
        -0.9391602873802185
      ],
      "plane_d": 1137.109619140625,
      "bbox_min": [
        -1565.5,
        -3954.0,
        1403.4130859375
      ],
      "bbox_max": [
        -1533.5013427734375,
        -3906.0,
        1416.338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3312.91259765625,
      "bbox_min": [
        -1565.0218505859375,
        -3917.294189453125,
        1403.4130859375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3915.085693359375,
        1405.430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1565.0218505859375,
        -3917.294189453125,
        1403.786865234375
      ],
      "bbox_max": [
        -1564.3699951171875,
        -3916.1650390625,
        1405.430908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1540.5,
        -3932.258544921875,
        1409.5
      ],
      "bbox_max": [
        -1533.5013427734375,
        -3906.0,
        1416.338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9340946078300476,
        -0.13186217844486237,
        0.3317822515964508
      ],
      "plane_d": 496.74951171875,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1372.5299072265625
      ],
      "bbox_max": [
        -1527.8349609375,
        -3906.0,
        1416.19287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1578.0023193359375,
        -3954.0,
        1373.9268798828125
      ],
      "bbox_max": [
        -1577.9949951171875,
        -3953.9794921875,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -603.3717041015625,
      "bbox_min": [
        -1571.300048828125,
        -3931.98046875,
        1372.5299072265625
      ],
      "bbox_max": [
        -1527.8349609375,
        -3906.0,
        1416.19287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3913.164306640625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1372.89697265625
      ],
      "bbox_max": [
        -1566.1025390625,
        -3913.164306640625,
        1399.8206787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3318.9140625,
      "bbox_min": [
        -1571.300048828125,
        -3919.165771484375,
        1373.3399658203125
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1391.08251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 597.3701171875,
      "bbox_min": [
        -1571.300048828125,
        -3916.1650390625,
        1373.4853515625
      ],
      "bbox_max": [
        -1569.5675048828125,
        -3913.164306640625,
        1389.841552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1540.5,
        -3931.98046875,
        1408.4580078125
      ],
      "bbox_max": [
        -1527.8349609375,
        -3906.0,
        1416.19287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995131611824036,
        -0.529276967048645,
        0.2839800715446472
      ],
      "plane_d": -3664.630126953125,
      "bbox_min": [
        -1546.21484375,
        -3954.0,
        1356.5279541015625
      ],
      "bbox_max": [
        -1474.8492431640625,
        -3906.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9406219124794006,
        0.33072617650032043,
        -0.07648875564336777
      ],
      "plane_d": 22.547607421875,
      "bbox_min": [
        -1478.0,
        -3954.0,
        1356.5279541015625
      ],
      "bbox_max": [
        -1474.8492431640625,
        -3949.07958984375,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2838270366191864,
        -0.3101935088634491,
        -0.9073159098625183
      ],
      "plane_d": -369.9895935058594,
      "bbox_min": [
        -1546.21484375,
        -3954.0,
        1401.875
      ],
      "bbox_max": [
        -1516.125,
        -3906.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005312979221344,
        -0.16630962491035461,
        -0.9391602873802185
      ],
      "plane_d": 1137.109619140625,
      "bbox_min": [
        -1546.21484375,
        -3954.0,
        1416.1712646484375
      ],
      "bbox_max": [
        -1528.0,
        -3932.258544921875,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3277.5615234375,
      "bbox_min": [
        -1580.941162109375,
        -4003.042236328125,
        1335.75
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 680.723876953125,
      "bbox_min": [
        -1501.704833984375,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -686.7254638671875,
      "bbox_min": [
        -1499.300048828125,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1499.300048828125,
        -3964.16650390625,
        1335.75
      ],
      "bbox_max": [
        -1489.9652099609375,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3271.559814453125,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1489.9652099609375,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1499.300048828125,
        -3961.165771484375,
        1354.40087890625
      ],
      "bbox_max": [
        -1492.3699951171875,
        -3955.164306640625,
        1411.6551513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48215293884277344,
        -0.6684456467628479,
        -0.5663117170333862
      ],
      "plane_d": -2597.18505859375,
      "bbox_min": [
        -1496.81982421875,
        -3957.44775390625,
        1354.40087890625
      ],
      "bbox_max": [
        -1492.7840576171875,
        -3955.164306640625,
        1357.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1497.5675048828125,
        -3955.164306640625,
        1356.7144775390625
      ],
      "bbox_max": [
        -1494.1024169921875,
        -3954.0,
        1412.0465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1491.77734375,
        -3957.138671875,
        1408.4598388671875
      ],
      "bbox_max": [
        -1489.9652099609375,
        -3954.0,
        1410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1497.567626953125,
        -3964.16650390625,
        1406.4111328125
      ],
      "bbox_max": [
        -1494.1025390625,
        -3961.165771484375,
        1408.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1480.08349609375,
        -3973.450927734375,
        1347.04443359375
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3954.433837890625,
        1356.983642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730949819087982,
        0.6975775361061096,
        -0.6624233722686768
      ],
      "plane_d": 4058.18115234375,
      "bbox_min": [
        -1480.08349609375,
        -3973.450927734375,
        1347.04443359375
      ],
      "bbox_max": [
        -1459.5479736328125,
        -3954.433837890625,
        1356.983642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27310365438461304,
        -0.6975887417793274,
        0.6624080538749695
      ],
      "plane_d": -4066.563720703125,
      "bbox_min": [
        -1480.08349609375,
        -3973.450927734375,
        1347.04443359375
      ],
      "bbox_max": [
        -1461.4674072265625,
        -3957.316162109375,
        1356.983642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16739465296268463,
        0.023890966549515724,
        -0.985600471496582
      ],
      "plane_d": 1177.7626953125,
      "bbox_min": [
        -1480.08349609375,
        -3973.450927734375,
        1347.04443359375
      ],
      "bbox_max": [
        -1461.4674072265625,
        -3957.316162109375,
        1353.642333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48215293884277344,
        -0.6684456467628479,
        -0.5663117170333862
      ],
      "plane_d": -2597.18505859375,
      "bbox_min": [
        -1480.08349609375,
        -3973.450927734375,
        1347.3504638671875
      ],
      "bbox_max": [
        -1463.9432373046875,
        -3962.416259765625,
        1353.642333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9277945756912231,
        0.35961028933525085,
        -0.09938639402389526
      ],
      "plane_d": 187.175537109375,
      "bbox_min": [
        -1495.8350830078125,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1408.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1495.8350830078125,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1408.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.849248468875885,
        0.329166054725647,
        -0.41282767057418823
      ],
      "plane_d": 613.5584716796875,
      "bbox_min": [
        -1492.6265869140625,
        -3978.5654296875,
        1374.0
      ],
      "bbox_max": [
        -1478.0,
        -3954.0,
        1391.5518798828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48215293884277344,
        -0.6684456467628479,
        -0.5663117170333862
      ],
      "plane_d": -2597.18505859375,
      "bbox_min": [
        -1495.8350830078125,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1408.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27310365438461304,
        -0.6975887417793274,
        0.6624080538749695
      ],
      "plane_d": -4066.563720703125,
      "bbox_min": [
        -1495.8350830078125,
        -3965.383056640625,
        1349.9339599609375
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1408.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16739465296268463,
        0.023890966549515724,
        -0.985600471496582
      ],
      "plane_d": 1177.7626953125,
      "bbox_min": [
        -1490.93212890625,
        -3962.416259765625,
        1349.9339599609375
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1359.0726318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48214980959892273,
        0.6684367656707764,
        0.5663248896598816
      ],
      "plane_d": 2588.773681640625,
      "bbox_min": [
        -1482.218994140625,
        -3956.651123046875,
        1353.2752685546875
      ],
      "bbox_max": [
        -1476.46728515625,
        -3954.0,
        1357.6602783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1495.8350830078125,
        -3965.383056640625,
        1405.5526123046875
      ],
      "bbox_max": [
        -1491.77734375,
        -3957.138671875,
        1408.773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3005174696445465,
        0.9509676098823547,
        0.07314186543226242
      ],
      "plane_d": 3242.37646484375,
      "bbox_min": [
        -1485.6651611328125,
        -3982.1611328125,
        1335.75
      ],
      "bbox_max": [
        -1484.53125,
        -3981.421875,
        1341.60693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1501.704833984375,
        -3958.1650390625,
        1355.4044189453125
      ],
      "bbox_max": [
        -1496.895263671875,
        -3954.0,
        1413.5855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660166263580322,
        0.5000151991844177,
        -0.0
      ],
      "plane_d": 3316.5927734375,
      "bbox_min": [
        -1580.941162109375,
        -3987.458740234375,
        1335.75
      ],
      "bbox_max": [
        -1541.965087890625,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        -0.5000151991844177,
        0.0
      ],
      "plane_d": -3322.59423828125,
      "bbox_min": [
        -1580.941162109375,
        -3987.458740234375,
        1335.75
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3961.165771484375,
      "bbox_min": [
        -1553.704833984375,
        -3964.166259765625,
        1335.75
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660166263580322,
        0.5000151991844177,
        0.0
      ],
      "plane_d": 635.6910400390625,
      "bbox_min": [
        -1553.704833984375,
        -3961.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3955.164306640625,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1335.75
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3954.0,
        1428.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1551.300048828125,
        -3961.165771484375,
        1336.5
      ],
      "bbox_max": [
        -1544.3699951171875,
        -3955.164306640625,
        1415.6005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1551.300048828125,
        -3960.206298828125,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1551.300048828125,
        -3960.206298828125,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7208330631256104,
        -0.6931086778640747,
        0.0
      ],
      "plane_d": -1627.474609375,
      "bbox_min": [
        -1550.1214599609375,
        -3960.206298828125,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1548.9287109375,
        -3958.0,
        1336.5
      ],
      "bbox_max": [
        -1548.0,
        -3955.164306640625,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1549.5675048828125,
        -3955.164306640625,
        1336.5
      ],
      "bbox_max": [
        -1546.1025390625,
        -3954.0,
        1415.9920654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1549.5673828125,
        -3955.164306640625,
        1336.5
      ],
      "bbox_max": [
        -1548.9287109375,
        -3954.45849609375,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1549.5673828125,
        -3955.164306640625,
        1336.5
      ],
      "bbox_max": [
        -1548.9287109375,
        -3954.45849609375,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1553.704833984375,
        -3958.1650390625,
        1336.5
      ],
      "bbox_max": [
        -1549.159912109375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1553.704833984375,
        -3958.1650390625,
        1336.5
      ],
      "bbox_max": [
        -1549.159912109375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9503291845321655,
        0.3112466335296631,
        0.0
      ],
      "plane_d": 2703.02392578125,
      "bbox_min": [
        -1549.31005859375,
        -3954.45849609375,
        1336.5
      ],
      "bbox_max": [
        -1549.159912109375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1549.5673828125,
        -3964.166259765625,
        1410.3568115234375
      ],
      "bbox_max": [
        -1546.1025390625,
        -3961.165771484375,
        1412.4742431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1580.941162109375,
        -3984.0,
        1336.5
      ],
      "bbox_max": [
        -1567.12158203125,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1580.941162109375,
        -3984.0,
        1336.5
      ],
      "bbox_max": [
        -1567.12158203125,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7208330631256104,
        -0.6931086778640747,
        0.0
      ],
      "plane_d": -1627.474609375,
      "bbox_min": [
        -1573.0,
        -3984.0,
        1336.5
      ],
      "bbox_max": [
        -1567.12158203125,
        -3977.886474609375,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.941392719745636,
        0.33099716901779175,
        0.06496511399745941
      ],
      "plane_d": 2705.0185546875,
      "bbox_min": [
        -1578.0,
        -3987.458740234375,
        1335.75
      ],
      "bbox_max": [
        -1547.8349609375,
        -3954.0,
        1413.7744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1576.3798828125,
        -3977.966552734375,
        1336.5
      ],
      "bbox_max": [
        -1567.0426025390625,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7208330631256104,
        -0.6931086778640747,
        0.0
      ],
      "plane_d": -1627.474609375,
      "bbox_min": [
        -1567.198486328125,
        -3977.966552734375,
        1336.5
      ],
      "bbox_max": [
        -1567.0426025390625,
        -3977.80419921875,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.84065842628479,
        0.4561693072319031,
        -0.2918952703475952
      ],
      "plane_d": 3531.31640625,
      "bbox_min": [
        -1578.0,
        -3987.458740234375,
        1335.75
      ],
      "bbox_max": [
        -1547.8349609375,
        -3954.0,
        1413.7744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8492484092712402,
        0.3291660249233246,
        -0.4128277003765106
      ],
      "plane_d": 3208.86181640625,
      "bbox_min": [
        -1578.0,
        -3987.458740234375,
        1361.8050537109375
      ],
      "bbox_max": [
        -1555.77783203125,
        -3954.0,
        1400.6666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25569289922714233,
        0.8919519186019897,
        -0.3728846311569214
      ],
      "plane_d": 4468.17431640625,
      "bbox_min": [
        -1565.5697021484375,
        -3987.458740234375,
        1361.8050537109375
      ],
      "bbox_max": [
        -1555.77783203125,
        -3977.888916015625,
        1400.6666259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27361223101615906,
        0.9544612765312195,
        0.11891253292560577
      ],
      "plane_d": 4069.675537109375,
      "bbox_min": [
        -1565.5697021484375,
        -3987.458740234375,
        1361.8050537109375
      ],
      "bbox_max": [
        -1561.0931396484375,
        -3984.710693359375,
        1374.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1565.71875,
        -3984.0634765625,
        1335.75
      ],
      "bbox_max": [
        -1559.02001953125,
        -3981.421875,
        1342.23583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1338.9998779296875,
      "bbox_min": [
        -1575.5848388671875,
        -3977.988525390625,
        1336.5
      ],
      "bbox_max": [
        -1547.8349609375,
        -3954.0,
        1413.7744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1336.4998779296875,
      "bbox_min": [
        -1575.4122314453125,
        -3977.935791015625,
        1336.5
      ],
      "bbox_max": [
        -1550.1214599609375,
        -3954.0,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7208330631256104,
        -0.6931086778640747,
        0.0
      ],
      "plane_d": -1627.474609375,
      "bbox_min": [
        -1567.1688232421875,
        -3977.935791015625,
        1336.5
      ],
      "bbox_max": [
        -1550.1214599609375,
        -3960.206298828125,
        1339.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1565.5,
        -3977.988525390625,
        1400.402587890625
      ],
      "bbox_max": [
        -1547.8349609375,
        -3954.0,
        1413.7744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25569289922714233,
        0.8919519186019897,
        -0.3728846311569214
      ],
      "plane_d": 4468.17431640625,
      "bbox_min": [
        -1555.8154296875,
        -3977.988525390625,
        1400.402587890625
      ],
      "bbox_max": [
        -1555.7608642578125,
        -3977.888916015625,
        1400.67236328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1546.7747802734375,
        -3958.1650390625,
        1414.591796875
      ],
      "bbox_max": [
        -1541.965087890625,
        -3954.0,
        1417.5311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1528.77685546875,
        -4003.042236328125,
        1335.75
      ],
      "bbox_max": [
        -1515.966796875,
        -3991.667236328125,
        1339.807373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518153190612793,
        -0.34042564034461975,
        0.5646982789039612
      ],
      "plane_d": -973.9085693359375,
      "bbox_min": [
        -1528.77685546875,
        -4003.042236328125,
        1335.75
      ],
      "bbox_max": [
        -1515.966796875,
        -3991.667236328125,
        1339.807373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1528.77685546875,
        -4001.58984375,
        1335.75
      ],
      "bbox_max": [
        -1515.966796875,
        -3991.667236328125,
        1339.4420166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1528.23681640625,
        -3995.618408203125,
        1335.75
      ],
      "bbox_max": [
        -1527.989013671875,
        -3995.071044921875,
        1335.8592529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.843358278274536e-06,
        -0.20790989696979523,
        0.9781480431556702
      ],
      "plane_d": -2140.65185546875,
      "bbox_min": [
        -1521.6080322265625,
        -3993.437744140625,
        1335.75
      ],
      "bbox_max": [
        -1515.8885498046875,
        -3991.400146484375,
        1339.8250732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1516.71630859375,
        -3991.83984375,
        1335.75
      ],
      "bbox_max": [
        -1515.8885498046875,
        -3991.400146484375,
        1336.6466064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3000791668891907,
        0.9495805501937866,
        0.09082546830177307
      ],
      "plane_d": 4129.2001953125,
      "bbox_min": [
        -1561.2833251953125,
        -3997.0,
        1335.75
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27361223101615906,
        0.9544612765312195,
        0.11891253292560577
      ],
      "plane_d": 4069.675537109375,
      "bbox_min": [
        -1561.2833251953125,
        -3997.0,
        1335.75
      ],
      "bbox_max": [
        -1525.3619384765625,
        -3984.0634765625,
        1375.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1528.086181640625,
        -3995.1044921875,
        1335.75
      ],
      "bbox_max": [
        -1525.3619384765625,
        -3993.50537109375,
        1338.9111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1528.086181640625,
        -3995.1044921875,
        1335.75
      ],
      "bbox_max": [
        -1527.30517578125,
        -3993.50537109375,
        1336.1990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25569289922714233,
        0.8919519186019897,
        -0.3728846311569214
      ],
      "plane_d": 4468.17431640625,
      "bbox_min": [
        -1561.2833251953125,
        -3997.0,
        1374.0
      ],
      "bbox_max": [
        -1528.0,
        -3986.784912109375,
        1375.878662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.358928382396698,
        0.8943427801132202,
        -0.26706069707870483
      ],
      "plane_d": 4490.072265625,
      "bbox_min": [
        -1560.894287109375,
        -3997.0,
        1335.75
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25569289922714233,
        0.8919519186019897,
        -0.3728846311569214
      ],
      "plane_d": 4468.17431640625,
      "bbox_min": [
        -1560.894287109375,
        -3997.0,
        1374.0
      ],
      "bbox_max": [
        -1528.0,
        -3977.898681640625,
        1400.6529541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25569286942481995,
        0.891951858997345,
        -0.372884601354599
      ],
      "plane_d": 3686.7763671875,
      "bbox_min": [
        -1555.7608642578125,
        -3997.0,
        1335.75
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3589284121990204,
        0.894342839717865,
        -0.2670607268810272
      ],
      "plane_d": 3393.18701171875,
      "bbox_min": [
        -1533.9056396484375,
        -3997.0,
        1374.0
      ],
      "bbox_max": [
        -1500.22216796875,
        -3977.888916015625,
        1411.894775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3871349096298218,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 1908.636474609375,
      "bbox_min": [
        -1533.9056396484375,
        -3986.25,
        1400.6666259765625
      ],
      "bbox_max": [
        -1500.22216796875,
        -3977.888916015625,
        1411.894775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38713499903678894,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 3091.720703125,
      "bbox_min": [
        -1533.9056396484375,
        -3986.25,
        1408.0157470703125
      ],
      "bbox_max": [
        -1528.0,
        -3981.157958984375,
        1411.894775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518106698989868,
        0.08130911737680435,
        0.6543467044830322
      ],
      "plane_d": -1698.108154296875,
      "bbox_min": [
        -1555.7608642578125,
        -3994.477294921875,
        1335.75
      ],
      "bbox_max": [
        -1485.4451904296875,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7518141269683838,
        0.340425580739975,
        -0.5646998286247253
      ],
      "plane_d": 965.5584716796875,
      "bbox_min": [
        -1527.617431640625,
        -3993.56103515625,
        1335.75
      ],
      "bbox_max": [
        -1504.924560546875,
        -3954.0,
        1344.59619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7518207430839539,
        -0.0813145861029625,
        -0.6543344855308533
      ],
      "plane_d": 1689.7313232421875,
      "bbox_min": [
        -1520.9375,
        -3991.584228515625,
        1335.75
      ],
      "bbox_max": [
        -1504.924560546875,
        -3954.0,
        1344.59619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        6.843358278274536e-06,
        0.20790989696979523,
        -0.9781480431556702
      ],
      "plane_d": 2133.94873046875,
      "bbox_min": [
        -1520.9375,
        -3979.498291015625,
        1335.75
      ],
      "bbox_max": [
        -1507.90673828125,
        -3954.0,
        1341.1697998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9277945756912231,
        0.35961028933525085,
        -0.09938639402389526
      ],
      "plane_d": 187.175537109375,
      "bbox_min": [
        -1491.4862060546875,
        -3986.25,
        1342.0260009765625
      ],
      "bbox_max": [
        -1485.473388671875,
        -3976.25341796875,
        1378.5897216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2730191946029663,
        0.4444501996040344,
        -0.8531849980354309
      ],
      "plane_d": 2553.411865234375,
      "bbox_min": [
        -1528.0,
        -3977.888916015625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1494.5736083984375,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1500.22216796875,
        -3977.888916015625,
        1400.6666259765625
      ],
      "bbox_max": [
        -1494.5736083984375,
        -3965.383056640625,
        1405.5526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38713499903678894,
        0.32154056429862976,
        -0.8641401529312134
      ],
      "plane_d": 3091.720703125,
      "bbox_min": [
        -1555.7608642578125,
        -3985.40185546875,
        1376.7049560546875
      ],
      "bbox_max": [
        -1488.8564453125,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2730192244052887,
        0.44445016980171204,
        -0.8531849980354309
      ],
      "plane_d": 3387.75830078125,
      "bbox_min": [
        -1555.7384033203125,
        -3977.85498046875,
        1400.6968994140625
      ],
      "bbox_max": [
        -1528.0,
        -3954.0,
        1422.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.849248468875885,
        0.329166054725647,
        -0.41282767057418823
      ],
      "plane_d": 613.5584716796875,
      "bbox_min": [
        -1500.22216796875,
        -3985.40185546875,
        1376.7049560546875
      ],
      "bbox_max": [
        -1488.8564453125,
        -3966.3515625,
        1402.428955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8406584858894348,
        0.45616933703422546,
        -0.2918953001499176
      ],
      "plane_d": 962.2645263671875,
      "bbox_min": [
        -1500.22216796875,
        -3977.888916015625,
        1391.5518798828125
      ],
      "bbox_max": [
        -1492.6265869140625,
        -3966.3515625,
        1402.428955078125
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02d",
      "entity_class": "CGameArea",
      "piece_name": "mt02d",
      "offset": 54,
      "centroid": [
        -1551.1278381347656,
        -3777.541748046875,
        1173.1500091552734
      ],
      "bbox_min": [
        -1567.888427734375,
        -3880.6669921875,
        958.2000122070312
      ],
      "bbox_max": [
        -1539.5228271484375,
        -3679.300048828125,
        1392.0
      ],
      "dimensions_source": {
        "span_x": 28.3656005859375,
        "span_y": 201.366943359375,
        "height_z": 433.79998779296875,
        "door_width": 201.366943359375,
        "door_depth": 28.3656005859375,
        "leaf_depth": 28.3656005859375,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -1555.800048828125,
          -3679.300048828125,
          958.2000122070312
        ],
        [
          -1541.300048828125,
          -3679.300048828125,
          958.2000122070312
        ],
        [
          -1541.300048828125,
          -3679.300048828125,
          970.4000244140625
        ],
        [
          -1555.800048828125,
          -3679.300048828125,
          970.4000244140625
        ],
        [
          -1567.888427734375,
          -3880.6669921875,
          1372.0
        ],
        [
          -1567.888427734375,
          -3880.6669921875,
          1392.0
        ],
        [
          -1539.5228271484375,
          -3870.89990234375,
          1392.0
        ],
        [
          -1539.5228271484375,
          -3870.89990234375,
          1372.0
        ]
      ],
      "plane_distance": 3679.3
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 10099,
      "centroid": [
        -1572.800048828125,
        -3641.5,
        972.5
      ],
      "bbox_min": [
        -1572.800048828125,
        -3646.0,
        968.5
      ],
      "bbox_max": [
        -1572.800048828125,
        -3637.0,
        976.5
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 9.0,
        "height_z": 8.0,
        "door_width": 9.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "z"
      },
      "vertices": [
        [
          -1572.800048828125,
          -3639.414306640625,
          968.5
        ],
        [
          -1572.800048828125,
          -3643.585693359375,
          968.5
        ],
        [
          -1572.800048828125,
          -3646.0,
          970.9141845703125
        ],
        [
          -1572.800048828125,
          -3646.0,
          974.0858154296875
        ],
        [
          -1572.800048828125,
          -3643.585693359375,
          976.5
        ],
        [
          -1572.800048828125,
          -3639.414306640625,
          976.5
        ],
        [
          -1572.800048828125,
          -3637.0,
          974.0858154296875
        ],
        [
          -1572.800048828125,
          -3637.0,
          970.9141845703125
        ]
      ],
      "authentic_texture": "chkcrate-s_h"
    }
  ],
  "tutorial_messages": []
}